export const dataGeoJson = [{
    "nosamw": "0904753",
    "nama": "ABDUL MANAF SALEH",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": null,
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4829557,
    "lng": 121.9377908,
    "color": "#28a745"
}, {
    "nosamw": "0900813",
    "nama": "Abdul Rasit Panto",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 168500,
    "total_denda": 10000,
    "total_jumlah": 178500,
    "lat": 0.482826,
    "lng": 121.9377882,
    "color": "#ffc107"
}, {
    "nosamw": "0902977",
    "nama": "Acu Antu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55400,
    "total_denda": 5000,
    "total_jumlah": 60400,
    "lat": 0.4848796,
    "lng": 121.9372473,
    "color": "#ffc107"
}, {
    "nosamw": "0903503",
    "nama": "Acu Noho",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4845901,
    "lng": 121.9366792,
    "color": "#28a745"
}, {
    "nosamw": "0905176",
    "nama": "ADE HAKIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": null,
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 5000,
    "total_jumlah": 79500,
    "lat": 0.4873657,
    "lng": 121.9353519,
    "color": "#ffc107"
}, {
    "nosamw": "0900219",
    "nama": "Aldi Rahim",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.489299,
    "lng": 121.9343192,
    "color": "#ffc107"
}, {
    "nosamw": "0901181",
    "nama": "Amina Dunggio",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.485147,
    "lng": 121.9357664,
    "color": "#28a745"
}, {
    "nosamw": "0901001",
    "nama": "AMNA MBUINGA 2",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4852391,
    "lng": 121.9366366,
    "color": "#28a745"
}, {
    "nosamw": "0902672",
    "nama": "Anini Mato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4857103,
    "lng": 121.9363081,
    "color": "#28a745"
}, {
    "nosamw": "0904837",
    "nama": "ANSI NOHO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": null,
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4844752,
    "lng": 121.9373341,
    "color": "#28a745"
}, {
    "nosamw": "0904836",
    "nama": "APULO NOHO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4847837,
    "lng": 121.9376045,
    "color": "#28a745"
}, {
    "nosamw": "0902085",
    "nama": "Ardiansyah Abdullah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4831908,
    "lng": 121.9376778,
    "color": "#28a745"
}, {
    "nosamw": "0904502",
    "nama": "ARIEF BOEKOESOE",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4857356,
    "lng": 121.9362764,
    "color": "#28a745"
}, {
    "nosamw": "0904829",
    "nama": "ASMIN DAY",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": null,
    "total_bulan": 3,
    "total_tagihan": 216600,
    "total_denda": 15000,
    "total_jumlah": 231600,
    "lat": 0.4846938,
    "lng": 121.9364308,
    "color": "#fd7e14"
}, {
    "nosamw": "0901182",
    "nama": "Asna Mardain",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4915046,
    "lng": 121.9337609,
    "color": "#28a745"
}, {
    "nosamw": "0903614",
    "nama": "Darlin Kune",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4877503,
    "lng": 121.9350765,
    "color": "#28a745"
}, {
    "nosamw": "0902394",
    "nama": "DARWIN DJAFAR",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4816559,
    "lng": 121.9334971,
    "color": "#28a745"
}, {
    "nosamw": "0902404",
    "nama": "David Sahe",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082290977117",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4804581,
    "lng": 121.9349341,
    "color": "#28a745"
}, {
    "nosamw": "0906343",
    "nama": "DIAN NENTO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081523741799",
    "total_bulan": 1,
    "total_tagihan": 297500,
    "total_denda": 5000,
    "total_jumlah": 302500,
    "lat": 0.4791157,
    "lng": 121.9342911,
    "color": "#ffc107"
}, {
    "nosamw": "0903489",
    "nama": "Dui Djafar",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 136600,
    "total_denda": 5000,
    "total_jumlah": 141600,
    "lat": 0.4855066,
    "lng": 121.9351956,
    "color": "#ffc107"
}, {
    "nosamw": "0904825",
    "nama": "FATMAWATI PASISINGI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4845699,
    "lng": 121.9378209,
    "color": "#28a745"
}, {
    "nosamw": "0900155",
    "nama": "Felis Abdullah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4896954,
    "lng": 121.9341371,
    "color": "#28a745"
}, {
    "nosamw": "0901935",
    "nama": "Felis Abdullah II",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 366000,
    "total_denda": 25000,
    "total_jumlah": 391000,
    "lat": 0.489349,
    "lng": 121.9340505,
    "color": "#fd7e14"
}, {
    "nosamw": "0900221",
    "nama": "Foni Bawu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.4871956,
    "lng": 121.9357289,
    "color": "#ffc107"
}, {
    "nosamw": "0900025",
    "nama": "Gani Pasisingi",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4824594,
    "lng": 121.9356859,
    "color": "#28a745"
}, {
    "nosamw": "0906184",
    "nama": "H18 RAHMAWATI AMU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 5000,
    "total_jumlah": 86000,
    "lat": 0.4838742,
    "lng": 121.9374116,
    "color": "#ffc107"
}, {
    "nosamw": "0906660",
    "nama": "H19 ANI KASIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 222200,
    "total_denda": 15000,
    "total_jumlah": 237200,
    "lat": 0.4848569,
    "lng": 121.9374568,
    "color": "#fd7e14"
}, {
    "nosamw": "0901920",
    "nama": "Hamzah Laya",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.4832275,
    "lng": 121.937665,
    "color": "#fd7e14"
}, {
    "nosamw": "0900790",
    "nama": "Idris Kamato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.4832022,
    "lng": 121.9376773,
    "color": "#ffc107"
}, {
    "nosamw": "0905505",
    "nama": "ISA AHMAD",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 5000,
    "total_jumlah": 86000,
    "lat": 0.4824576,
    "lng": 121.9373764,
    "color": "#ffc107"
}, {
    "nosamw": "0900026",
    "nama": "Ishak Dunggio",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4825202,
    "lng": 121.9357291,
    "color": "#28a745"
}, {
    "nosamw": "0902877",
    "nama": "Ismail Katili",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 47000,
    "total_denda": 5000,
    "total_jumlah": 52000,
    "lat": 0.4850364,
    "lng": 121.9367809,
    "color": "#ffc107"
}, {
    "nosamw": "0903247",
    "nama": "Ismail Muke",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4855815,
    "lng": 121.9356187,
    "color": "#28a745"
}, {
    "nosamw": "0907325",
    "nama": "Jerie Tambun",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": null,
    "total_bulan": 6,
    "total_tagihan": 335000,
    "total_denda": 30000,
    "total_jumlah": 365000,
    "lat": 0.4908011,
    "lng": 121.933602,
    "color": "#fd7e14"
}, {
    "nosamw": "0900203",
    "nama": "Jhoni Bawu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 855000,
    "total_denda": 5000,
    "total_jumlah": 860000,
    "lat": 0.4873603,
    "lng": 121.9352644,
    "color": "#ffc107"
}, {
    "nosamw": "0900416",
    "nama": "Jumria Inaku",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4907073,
    "lng": 121.9335969,
    "color": "#28a745"
}, {
    "nosamw": "0907496",
    "nama": "KEVIN ELDAD RORING",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082187787896",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4771541,
    "lng": 121.9350869,
    "color": "#28a745"
}, {
    "nosamw": "0905506",
    "nama": "KIMA SABURI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4824163,
    "lng": 121.9392204,
    "color": "#ffc107"
}, {
    "nosamw": "0903158",
    "nama": "KUSNO BANGGA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4873117,
    "lng": 121.933435,
    "color": "#28a745"
}, {
    "nosamw": "0905501",
    "nama": "MANTIK NOHO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4825563,
    "lng": 121.9390726,
    "color": "#28a745"
}, {
    "nosamw": "0902597",
    "nama": "Marlina Karim",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132000,
    "total_denda": 20000,
    "total_jumlah": 152000,
    "lat": 0.4848261,
    "lng": 121.9375912,
    "color": "#fd7e14"
}, {
    "nosamw": "0900715",
    "nama": "Mesjid B.Tengah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 24000,
    "total_denda": 30000,
    "total_jumlah": 54000,
    "lat": 0.4892372,
    "lng": 121.9338638,
    "color": "#fd7e14"
}, {
    "nosamw": "0901906",
    "nama": "Moh. Abd. Kadri M.",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 622000,
    "total_denda": 40000,
    "total_jumlah": 662000,
    "lat": 0.4782796,
    "lng": 121.9330111,
    "color": "#dc3545"
}, {
    "nosamw": "0902637",
    "nama": "Moh. Toolingo",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4850727,
    "lng": 121.9359136,
    "color": "#28a745"
}, {
    "nosamw": "0900031",
    "nama": "Mohamad Kadir",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4852138,
    "lng": 121.9356697,
    "color": "#28a745"
}, {
    "nosamw": "0902498",
    "nama": "Mushola B. Tengah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4000,
    "total_denda": 5000,
    "total_jumlah": 9000,
    "lat": 0.4839796,
    "lng": 121.9358319,
    "color": "#ffc107"
}, {
    "nosamw": "0900936",
    "nama": "Nani Gani",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.487044,
    "lng": 121.9351009,
    "color": "#28a745"
}, {
    "nosamw": "0902864",
    "nama": "Neno Katili",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4813824,
    "lng": 121.9354287,
    "color": "#28a745"
}, {
    "nosamw": "0907460",
    "nama": "NISTAIN KUNE",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085242549363",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4914509,
    "lng": 121.9333884,
    "color": "#28a745"
}, {
    "nosamw": "0905017",
    "nama": "NITA IBRAHIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 780300,
    "total_denda": 65000,
    "total_jumlah": 845300,
    "lat": 0.4873318,
    "lng": 121.933423,
    "color": "#dc3545"
}, {
    "nosamw": "0900154",
    "nama": "Nony Bawu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4857645,
    "lng": 121.9356671,
    "color": "#28a745"
}, {
    "nosamw": "0904440",
    "nama": "Novsin Hontong",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4831356,
    "lng": 121.9372335,
    "color": "#28a745"
}, {
    "nosamw": "0901821",
    "nama": "Nuraeni S.Si,Apt",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 5000,
    "total_jumlah": 140000,
    "lat": 0.4909493,
    "lng": 121.9334625,
    "color": "#ffc107"
}, {
    "nosamw": "0901543",
    "nama": "Olha Tialo,ss",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4828539,
    "lng": 121.9358335,
    "color": "#28a745"
}, {
    "nosamw": "0902594",
    "nama": "Otin Nihe",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4838005,
    "lng": 121.9374098,
    "color": "#ffc107"
}, {
    "nosamw": "0904661",
    "nama": "RAHMIYATI MOKOAGOW",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4873377,
    "lng": 121.9333192,
    "color": "#28a745"
}, {
    "nosamw": "0903496",
    "nama": "Ratna DJ. Sangkulu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4846591,
    "lng": 121.9364583,
    "color": "#28a745"
}, {
    "nosamw": "0900287",
    "nama": "RD Hasrat Abadi 2",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4837068,
    "lng": 121.9357353,
    "color": "#28a745"
}, {
    "nosamw": "0901529",
    "nama": "Riko M. Bagu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4857927,
    "lng": 121.9363015,
    "color": "#28a745"
}, {
    "nosamw": "0900036",
    "nama": "Riman Pakaya",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4846512,
    "lng": 121.937682,
    "color": "#28a745"
}, {
    "nosamw": "0903495",
    "nama": "Rini Noho",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100200,
    "total_denda": 5000,
    "total_jumlah": 105200,
    "lat": 0.4846208,
    "lng": 121.9365826,
    "color": "#ffc107"
}, {
    "nosamw": "0904841",
    "nama": "RITA NAPU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4845897,
    "lng": 121.9367024,
    "color": "#28a745"
}, {
    "nosamw": "0903317",
    "nama": "Robin Mahmud",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4849446,
    "lng": 121.9372236,
    "color": "#fd7e14"
}, {
    "nosamw": "0904833",
    "nama": "RONI ADAM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 383400,
    "total_denda": 25000,
    "total_jumlah": 408400,
    "lat": 0.4846751,
    "lng": 121.9373083,
    "color": "#fd7e14"
}, {
    "nosamw": "0900210",
    "nama": "Roni Bawu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 311000,
    "total_denda": 10000,
    "total_jumlah": 321000,
    "lat": 0.4867954,
    "lng": 121.9351199,
    "color": "#ffc107"
}, {
    "nosamw": "0901467",
    "nama": "Roy Haras",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4829055,
    "lng": 121.9358667,
    "color": "#28a745"
}, {
    "nosamw": "0900836",
    "nama": "Rustin Majiji",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.4868456,
    "lng": 121.9351396,
    "color": "#ffc107"
}, {
    "nosamw": "0900708",
    "nama": "Salma Mardain",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.4914119,
    "lng": 121.9332963,
    "color": "#ffc107"
}, {
    "nosamw": "0902695",
    "nama": "Samin Sangkulo",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4849232,
    "lng": 121.9372202,
    "color": "#ffc107"
}, {
    "nosamw": "0903262",
    "nama": "Sarjon Tantu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.490923,
    "lng": 121.9328032,
    "color": "#ffc107"
}, {
    "nosamw": "0904265",
    "nama": "SASARINA NOVIANTI OLII",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4759312,
    "lng": 121.9373267,
    "color": "#ffc107"
}, {
    "nosamw": "0906166",
    "nama": "SATLAK PAMSIMAS 1",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 522000,
    "total_denda": 5000,
    "total_jumlah": 527000,
    "lat": 0.488664,
    "lng": 121.9342169,
    "color": "#ffc107"
}, {
    "nosamw": "0906167",
    "nama": "SATLAK PAMSIMAS 2",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 820000,
    "total_denda": 10000,
    "total_jumlah": 830000,
    "lat": 0.4848395,
    "lng": 121.937565,
    "color": "#ffc107"
}, {
    "nosamw": "0901184",
    "nama": "SDN 07 BUNTULIA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.4841598,
    "lng": 121.9360145,
    "color": "#ffc107"
}, {
    "nosamw": "0907482",
    "nama": "SRI YULAN OS PANEO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085145916169",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4856838,
    "lng": 121.9362083,
    "color": "#28a745"
}, {
    "nosamw": "0904840",
    "nama": "SUDIRO UMAR",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4845936,
    "lng": 121.9366733,
    "color": "#28a745"
}, {
    "nosamw": "0900118",
    "nama": "Sudirto Gaib",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4861417,
    "lng": 121.9358569,
    "color": "#ffc107"
}, {
    "nosamw": "0903233",
    "nama": "Sutriono Koesri",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 10000,
    "total_jumlah": 250000,
    "lat": 0.4901972,
    "lng": 121.9337092,
    "color": "#ffc107"
}, {
    "nosamw": "0904422",
    "nama": "Tetri Ismail",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4827523,
    "lng": 121.937249,
    "color": "#28a745"
}, {
    "nosamw": "0904830",
    "nama": "TILA ANTU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4844324,
    "lng": 121.9365086,
    "color": "#28a745"
}, {
    "nosamw": "0900571",
    "nama": "Udin Montoli",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61000,
    "total_denda": 5000,
    "total_jumlah": 66000,
    "lat": 0.4913107,
    "lng": 121.9335173,
    "color": "#ffc107"
}, {
    "nosamw": "0904465",
    "nama": "Verawati Mbuinga III",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4882464,
    "lng": 121.9348834,
    "color": "#28a745"
}, {
    "nosamw": "0905230",
    "nama": "WAHID MANDRAVI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4774981,
    "lng": 121.9347334,
    "color": "#28a745"
}, {
    "nosamw": "0905279",
    "nama": "WENDY A. KELA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4810669,
    "lng": 121.935292,
    "color": "#28a745"
}, {
    "nosamw": "0905481",
    "nama": "WILLY RORING",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "NB",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4814099,
    "lng": 121.9354746,
    "color": "#28a745"
}, {
    "nosamw": "0902860",
    "nama": "Yanti Biki",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 38600,
    "total_denda": 5000,
    "total_jumlah": 43600,
    "lat": 0.4846501,
    "lng": 121.9357468,
    "color": "#ffc107"
}, {
    "nosamw": "0902674",
    "nama": "Yasin Gobel",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 377800,
    "total_denda": 25000,
    "total_jumlah": 402800,
    "lat": 0.4846376,
    "lng": 121.9357492,
    "color": "#fd7e14"
}, {
    "nosamw": "0901180",
    "nama": "Yeni Toraja",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4889946,
    "lng": 121.9340617,
    "color": "#28a745"
}, {
    "nosamw": "0906668",
    "nama": "YENNY MARIANA OLII",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4778542,
    "lng": 121.9349156,
    "color": "#28a745"
}, {
    "nosamw": "0903241",
    "nama": "Yolanda Ibrahim",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4828244,
    "lng": 121.9358864,
    "color": "#28a745"
}, {
    "nosamw": "0904838",
    "nama": "YONI HUJULI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4845086,
    "lng": 121.937057,
    "color": "#28a745"
}, {
    "nosamw": "0902474",
    "nama": "Yulan Langago SE",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 825000,
    "total_denda": 20000,
    "total_jumlah": 845000,
    "lat": 0.4887649,
    "lng": 121.9341356,
    "color": "#fd7e14"
}, {
    "nosamw": "0905548",
    "nama": "YUNDA JUMAATI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5120749,
    "lng": 121.9561047,
    "color": "#28a745"
}, {
    "nosamw": "0906347",
    "nama": "ZETH TUTUD",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA TENGAH",
    "desa": "BUNTULIA TENGAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4828396,
    "lng": 121.937794,
    "color": "#28a745"
}, {
    "nosamw": "0903528",
    "nama": " POSKESDES BUNTULIA UTARA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "PP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 384600,
    "total_denda": 10000,
    "total_jumlah": 394600,
    "lat": 0.4958385,
    "lng": 121.935818,
    "color": "#ffc107"
}, {
    "nosamw": "0900003",
    "nama": "Abd Wahid Hiola",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4921445,
    "lng": 121.9331994,
    "color": "#28a745"
}, {
    "nosamw": "0900435",
    "nama": "Abd. Karim Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 941500,
    "total_denda": 30000,
    "total_jumlah": 971500,
    "lat": 0.4944441,
    "lng": 121.9339154,
    "color": "#fd7e14"
}, {
    "nosamw": "0903506",
    "nama": "Abd. Lakarim Lapamaroe",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4979947,
    "lng": 121.9338964,
    "color": "#28a745"
}, {
    "nosamw": "0903430",
    "nama": "ABDUL MAJID BELENETI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.4971045,
    "lng": 121.9356593,
    "color": "#ffc107"
}, {
    "nosamw": "0904882",
    "nama": "Abdul Muis Ladiku",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4971492,
    "lng": 121.9344769,
    "color": "#28a745"
}, {
    "nosamw": "0902364",
    "nama": "Agus Kadji",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.497205,
    "lng": 121.9337498,
    "color": "#28a745"
}, {
    "nosamw": "0902710",
    "nama": "Agustina Harun",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4995745,
    "lng": 121.935093,
    "color": "#28a745"
}, {
    "nosamw": "0904235",
    "nama": "Ajen Abdullah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.5006138,
    "lng": 121.9346,
    "color": "#ffc107"
}, {
    "nosamw": "0901922",
    "nama": "Ali Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4949734,
    "lng": 121.9336952,
    "color": "#28a745"
}, {
    "nosamw": "0904437",
    "nama": "Aminuddin",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.497585,
    "lng": 121.9350772,
    "color": "#28a745"
}, {
    "nosamw": "0901597",
    "nama": "Amna Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4948552,
    "lng": 121.933478,
    "color": "#28a745"
}, {
    "nosamw": "0905046",
    "nama": "ANCE DUNGGIO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4958,
    "lng": 121.9343399,
    "color": "#28a745"
}, {
    "nosamw": "0903246",
    "nama": "ANDI CAROL GAU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4926268,
    "lng": 121.9333816,
    "color": "#ffc107"
}, {
    "nosamw": "0903956",
    "nama": "Ardan Thaib",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 282500,
    "total_denda": 20000,
    "total_jumlah": 302500,
    "lat": 0.5005837,
    "lng": 121.9345956,
    "color": "#fd7e14"
}, {
    "nosamw": "0903448",
    "nama": "Aripin Bangga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4993429,
    "lng": 121.9348869,
    "color": "#28a745"
}, {
    "nosamw": "0905521",
    "nama": "ASIA ALI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "0823951200",
    "total_bulan": 7,
    "total_tagihan": 474000,
    "total_denda": 35000,
    "total_jumlah": 509000,
    "lat": 0.4997658,
    "lng": 121.9343465,
    "color": "#dc3545"
}, {
    "nosamw": "0905067",
    "nama": "AYIB ABDULLAH",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 495000,
    "total_denda": 30000,
    "total_jumlah": 525000,
    "lat": 0.4956185,
    "lng": 121.9361782,
    "color": "#fd7e14"
}, {
    "nosamw": "0904281",
    "nama": "AYU ABDULLAH",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.5005983,
    "lng": 121.934601,
    "color": "#ffc107"
}, {
    "nosamw": "0903491",
    "nama": "Azan Maa",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 447500,
    "total_denda": 5000,
    "total_jumlah": 452500,
    "lat": 0.4979478,
    "lng": 121.9353161,
    "color": "#ffc107"
}, {
    "nosamw": "0900554",
    "nama": "B.T. Neneng Oka",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 597500,
    "total_denda": 15000,
    "total_jumlah": 612500,
    "lat": 0.4940421,
    "lng": 121.9320832,
    "color": "#fd7e14"
}, {
    "nosamw": "0903408",
    "nama": "DEDRIYAN DJIBU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 643500,
    "total_denda": 35000,
    "total_jumlah": 678500,
    "lat": 0.5002295,
    "lng": 121.9347194,
    "color": "#dc3545"
}, {
    "nosamw": "0900840",
    "nama": "Deni Saleh",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 377000,
    "total_denda": 10000,
    "total_jumlah": 387000,
    "lat": 0.4962494,
    "lng": 121.9339002,
    "color": "#ffc107"
}, {
    "nosamw": "0901574",
    "nama": "Elvi Anwar",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4949499,
    "lng": 121.9337432,
    "color": "#28a745"
}, {
    "nosamw": "0902406",
    "nama": "EMUS ISHAK",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4971118,
    "lng": 121.9368744,
    "color": "#28a745"
}, {
    "nosamw": "0901563",
    "nama": "Eni Saleh",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4972832,
    "lng": 121.9336773,
    "color": "#28a745"
}, {
    "nosamw": "0903024",
    "nama": "Erna Anwar",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 574000,
    "total_denda": 15000,
    "total_jumlah": 589000,
    "lat": 0.4973661,
    "lng": 121.9344798,
    "color": "#fd7e14"
}, {
    "nosamw": "0903268",
    "nama": "Fardiyanto Mardain",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4913743,
    "lng": 121.9334149,
    "color": "#ffc107"
}, {
    "nosamw": "0903237",
    "nama": "Febriyanto Husin",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4993584,
    "lng": 121.9340675,
    "color": "#28a745"
}, {
    "nosamw": "0904242",
    "nama": "H. Yusuf Adam\/Panti Asuha",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 64000,
    "total_denda": 10000,
    "total_jumlah": 74000,
    "lat": 0.4972834,
    "lng": 121.9374204,
    "color": "#ffc107"
}, {
    "nosamw": "0906189",
    "nama": "H18 ADRIAN NENTO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4978656,
    "lng": 121.9353102,
    "color": "#28a745"
}, {
    "nosamw": "0906191",
    "nama": "H18 ALEX SURENTU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4954432,
    "lng": 121.9355687,
    "color": "#28a745"
}, {
    "nosamw": "0906217",
    "nama": "H18 ALFIAN J. IBRAHIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4950995,
    "lng": 121.9357394,
    "color": "#28a745"
}, {
    "nosamw": "0906209",
    "nama": "H18 IDRUS YAKIN",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 332400,
    "total_denda": 30000,
    "total_jumlah": 362400,
    "lat": 0.4951874,
    "lng": 121.9355846,
    "color": "#fd7e14"
}, {
    "nosamw": "0906192",
    "nama": "H18 ISMAIL KASIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 94000,
    "total_denda": 10000,
    "total_jumlah": 104000,
    "lat": 0.4955292,
    "lng": 121.93556,
    "color": "#ffc107"
}, {
    "nosamw": "0906186",
    "nama": "H18 MUHDAR MOMONTO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 326400,
    "total_denda": 10000,
    "total_jumlah": 336400,
    "lat": 0.4956946,
    "lng": 121.9356391,
    "color": "#ffc107"
}, {
    "nosamw": "0906213",
    "nama": "H18 NONCE DALANGGO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 85600,
    "total_denda": 10000,
    "total_jumlah": 95600,
    "lat": 0.4955356,
    "lng": 121.935879,
    "color": "#ffc107"
}, {
    "nosamw": "0906187",
    "nama": "H18 ONI DUNGGIO",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 165000,
    "total_denda": 25000,
    "total_jumlah": 190000,
    "lat": 0.4957543,
    "lng": 121.9357143,
    "color": "#fd7e14"
}, {
    "nosamw": "0906219",
    "nama": "H18 PAHRUDIN AKUDE",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4955544,
    "lng": 121.9358428,
    "color": "#ffc107"
}, {
    "nosamw": "0906220",
    "nama": "H18 STARMIN YASIN",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4955209,
    "lng": 121.9358268,
    "color": "#28a745"
}, {
    "nosamw": "0906221",
    "nama": "H18 SUDIRMAN MUSA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 98500,
    "total_denda": 10000,
    "total_jumlah": 108500,
    "lat": 0.4955419,
    "lng": 121.9357944,
    "color": "#ffc107"
}, {
    "nosamw": "0906214",
    "nama": "H18 SUGENG MBUINGA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 402400,
    "total_denda": 30000,
    "total_jumlah": 432400,
    "lat": 0.4958273,
    "lng": 121.9358365,
    "color": "#fd7e14"
}, {
    "nosamw": "0906188",
    "nama": "H18 SUUD MUSA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 129800,
    "total_denda": 15000,
    "total_jumlah": 144800,
    "lat": 0.4957274,
    "lng": 121.9356055,
    "color": "#fd7e14"
}, {
    "nosamw": "0906216",
    "nama": "H18 UCA BANI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 274200,
    "total_denda": 25000,
    "total_jumlah": 299200,
    "lat": 0.4955998,
    "lng": 121.9358879,
    "color": "#fd7e14"
}, {
    "nosamw": "0906211",
    "nama": "H18 YAKOB BUNTA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4952625,
    "lng": 121.9354985,
    "color": "#28a745"
}, {
    "nosamw": "0906195",
    "nama": "H18 YUNUS YUSUF",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 105800,
    "total_denda": 5000,
    "total_jumlah": 110800,
    "lat": 0.4957555,
    "lng": 121.9358872,
    "color": "#ffc107"
}, {
    "nosamw": "0906672",
    "nama": "H19 ABDUL RAHMAN HULUNGGI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1041000,
    "total_denda": 20000,
    "total_jumlah": 1061000,
    "lat": 0.4932389,
    "lng": 121.9335057,
    "color": "#fd7e14"
}, {
    "nosamw": "0906670",
    "nama": "H19 AMNA ISMAIL",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4930486,
    "lng": 121.9339239,
    "color": "#28a745"
}, {
    "nosamw": "0906686",
    "nama": "H19 CILI GIASI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4951969,
    "lng": 121.9362019,
    "color": "#28a745"
}, {
    "nosamw": "0906704",
    "nama": "H19 HARDIYANTI IBRAHIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 210000,
    "total_denda": 30000,
    "total_jumlah": 240000,
    "lat": 0.4955087,
    "lng": 121.936237,
    "color": "#fd7e14"
}, {
    "nosamw": "0906680",
    "nama": "H19 LUKMAN ISMAIL",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 71600,
    "total_denda": 10000,
    "total_jumlah": 81600,
    "lat": 0.4953057,
    "lng": 121.9362102,
    "color": "#ffc107"
}, {
    "nosamw": "0906688",
    "nama": "H19 MALIK MAHJAN",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61000,
    "total_denda": 5000,
    "total_jumlah": 66000,
    "lat": 0.4954713,
    "lng": 121.9362401,
    "color": "#ffc107"
}, {
    "nosamw": "0906656",
    "nama": "H19 MARNI R. KUNAI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4952127,
    "lng": 121.9362004,
    "color": "#28a745"
}, {
    "nosamw": "0906655",
    "nama": "H19 MONIRA TORAJA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4948952,
    "lng": 121.9363022,
    "color": "#28a745"
}, {
    "nosamw": "0906678",
    "nama": "H19 RISNAWATI LADJULU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4976883,
    "lng": 121.9349596,
    "color": "#28a745"
}, {
    "nosamw": "0906681",
    "nama": "H19 SALMAN PAPUTUNGAN",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.4953467,
    "lng": 121.9362319,
    "color": "#ffc107"
}, {
    "nosamw": "0906700",
    "nama": "H19 SUDARMON SAFARI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 259600,
    "total_denda": 25000,
    "total_jumlah": 284600,
    "lat": 0.4956806,
    "lng": 121.9362864,
    "color": "#fd7e14"
}, {
    "nosamw": "0906710",
    "nama": "H19 SUWARDI HUSAI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4951637,
    "lng": 121.9361981,
    "color": "#28a745"
}, {
    "nosamw": "0906682",
    "nama": "H19 TAMBRIN ABDULLAH",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 141600,
    "total_denda": 10000,
    "total_jumlah": 151600,
    "lat": 0.4953078,
    "lng": 121.9362239,
    "color": "#ffc107"
}, {
    "nosamw": "0906708",
    "nama": "H19 TONI HANAPI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 245200,
    "total_denda": 10000,
    "total_jumlah": 255200,
    "lat": 0.4951365,
    "lng": 121.9361727,
    "color": "#ffc107"
}, {
    "nosamw": "0906687",
    "nama": "H19 ZAKIR BOUTY",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 157200,
    "total_denda": 20000,
    "total_jumlah": 177200,
    "lat": 0.4952673,
    "lng": 121.9362137,
    "color": "#fd7e14"
}, {
    "nosamw": "0904236",
    "nama": "Hamzah Ibrahim \/ Rapi",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4939522,
    "lng": 121.9328116,
    "color": "#28a745"
}, {
    "nosamw": "0904171",
    "nama": "Hamzah Kalaha",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4938707,
    "lng": 121.9330328,
    "color": "#ffc107"
}, {
    "nosamw": "0903504",
    "nama": "Harpin Djaini",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5001777,
    "lng": 121.9345778,
    "color": "#28a745"
}, {
    "nosamw": "0906208",
    "nama": "Hasan Antu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 69400,
    "total_denda": 5000,
    "total_jumlah": 74400,
    "lat": 0.49558,
    "lng": 121.9358652,
    "color": "#ffc107"
}, {
    "nosamw": "0901738",
    "nama": "Hasan Botutihe",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4933801,
    "lng": 121.9335091,
    "color": "#28a745"
}, {
    "nosamw": "0902516",
    "nama": "Hervina Tulen",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4943085,
    "lng": 121.9334169,
    "color": "#ffc107"
}, {
    "nosamw": "0903151",
    "nama": "Hi. Yusuf Adam",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 3960000,
    "total_denda": 45000,
    "total_jumlah": 4005000,
    "lat": 0.4967203,
    "lng": 121.9337574,
    "color": "#dc3545"
}, {
    "nosamw": "0903321",
    "nama": "HIRWAN INAKU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4954754,
    "lng": 121.9353813,
    "color": "#28a745"
}, {
    "nosamw": "0902643",
    "nama": "Husain Goi",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 73000,
    "total_denda": 5000,
    "total_jumlah": 78000,
    "lat": 0.4931728,
    "lng": 121.9333617,
    "color": "#ffc107"
}, {
    "nosamw": "0900332",
    "nama": "Idris Bouty",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 207500,
    "total_denda": 5000,
    "total_jumlah": 212500,
    "lat": 0.4935413,
    "lng": 121.933672,
    "color": "#ffc107"
}, {
    "nosamw": "0902341",
    "nama": "Imelda Mantali",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4828241,
    "lng": 121.9372217,
    "color": "#fd7e14"
}, {
    "nosamw": "0903011",
    "nama": "Ino Bouty",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.4923605,
    "lng": 121.9334981,
    "color": "#fd7e14"
}, {
    "nosamw": "0903415",
    "nama": "INO KADJI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1309500,
    "total_denda": 70000,
    "total_jumlah": 1379500,
    "lat": 0.4972719,
    "lng": 121.9372849,
    "color": "#dc3545"
}, {
    "nosamw": "0904877",
    "nama": "ISMAIL IBRAHIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46326,
    "lng": 121.951486,
    "color": "#28a745"
}, {
    "nosamw": "0905072",
    "nama": "ISMAIL MUSA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46507,
    "lng": 121.945534,
    "color": "#28a745"
}, {
    "nosamw": "0901596",
    "nama": "Isna Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4949347,
    "lng": 121.9337385,
    "color": "#28a745"
}, {
    "nosamw": "0903953",
    "nama": "Isnawaty Hanapi",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2762200,
    "total_denda": 70000,
    "total_jumlah": 2832200,
    "lat": 0.5005905,
    "lng": 121.9345872,
    "color": "#dc3545"
}, {
    "nosamw": "0900300",
    "nama": "Jardin Saleh",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 337500,
    "total_denda": 10000,
    "total_jumlah": 347500,
    "lat": 0.4962272,
    "lng": 121.9338817,
    "color": "#ffc107"
}, {
    "nosamw": "0905512",
    "nama": "JARDIN SALEH \/ BPD",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 590000,
    "total_denda": 20000,
    "total_jumlah": 610000,
    "lat": 0.5005949,
    "lng": 121.9345715,
    "color": "#ffc107"
}, {
    "nosamw": "0905068",
    "nama": "KISMAN D. LUMA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111000,
    "total_denda": 5000,
    "total_jumlah": 116000,
    "lat": 0.4954803,
    "lng": 121.9358366,
    "color": "#ffc107"
}, {
    "nosamw": "0904279",
    "nama": "Ktr Cab Dinas Pendidikan",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 330000,
    "total_denda": 60000,
    "total_jumlah": 390000,
    "lat": 0.4985887,
    "lng": 121.9353864,
    "color": "#fd7e14"
}, {
    "nosamw": "0901740",
    "nama": "Ktr. Desa B. Utara",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 605000,
    "total_denda": 20000,
    "total_jumlah": 625000,
    "lat": 0.4979103,
    "lng": 121.9340898,
    "color": "#ffc107"
}, {
    "nosamw": "0904501",
    "nama": "Lapas 2",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5006127,
    "lng": 121.9346918,
    "color": "#28a745"
}, {
    "nosamw": "0905056",
    "nama": "LENI MARDAIN",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477713,
    "lng": 121.950022,
    "color": "#28a745"
}, {
    "nosamw": "0901088",
    "nama": "Lili Oka",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1055500,
    "total_denda": 10000,
    "total_jumlah": 1065500,
    "lat": 0.4938418,
    "lng": 121.9336311,
    "color": "#ffc107"
}, {
    "nosamw": "0903774",
    "nama": "Malik AbdulLah",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1899000,
    "total_denda": 80000,
    "total_jumlah": 1979000,
    "lat": 0.493813,
    "lng": 121.9329951,
    "color": "#dc3545"
}, {
    "nosamw": "0904081",
    "nama": "MARYAM MONOARFA . SE",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4933256,
    "lng": 121.9339951,
    "color": "#28a745"
}, {
    "nosamw": "0900932",
    "nama": "Maryam Usura",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 500000,
    "total_denda": 45000,
    "total_jumlah": 545000,
    "lat": 0.495229,
    "lng": 121.9336264,
    "color": "#dc3545"
}, {
    "nosamw": "0901571",
    "nama": "Masyamin Aliwu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 320200,
    "total_denda": 15000,
    "total_jumlah": 335200,
    "lat": 0.4942994,
    "lng": 121.9334011,
    "color": "#fd7e14"
}, {
    "nosamw": "0902945",
    "nama": "Mesjid Al-Ikhlas",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458828,
    "lng": 121.936022,
    "color": "#28a745"
}, {
    "nosamw": "0902499",
    "nama": "Mesjid Nur Hayat",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 270500,
    "total_denda": 5000,
    "total_jumlah": 275500,
    "lat": 0.4958331,
    "lng": 121.9337149,
    "color": "#ffc107"
}, {
    "nosamw": "0906139",
    "nama": "MEYKE MALIU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005954,
    "lng": 121.9345754,
    "color": "#28a745"
}, {
    "nosamw": "0904535",
    "nama": "Nandar Dunggio",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4997603,
    "lng": 121.9343803,
    "color": "#28a745"
}, {
    "nosamw": "0905526",
    "nama": "Nur Kadji",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1487500,
    "total_denda": 10,
    "total_jumlah": 1487510,
    "lat": 0.4976043,
    "lng": 121.9378798,
    "color": "#fd7e14"
}, {
    "nosamw": "0905061",
    "nama": "NURLAILA KADJI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4958067,
    "lng": 121.9343301,
    "color": "#ffc107"
}, {
    "nosamw": "0902343",
    "nama": "Oku Kadir\/ Gilang",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4995491,
    "lng": 121.9346506,
    "color": "#28a745"
}, {
    "nosamw": "0905513",
    "nama": "ONA SAMANI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4964103,
    "lng": 121.9336729,
    "color": "#28a745"
}, {
    "nosamw": "0901098",
    "nama": "Rabia Oka",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4934925,
    "lng": 121.9336595,
    "color": "#28a745"
}, {
    "nosamw": "0904192",
    "nama": "Ramdan Moobongu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4919241,
    "lng": 121.9333077,
    "color": "#28a745"
}, {
    "nosamw": "0904550",
    "nama": "RD No.01 Lapas Pohuwato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5005979,
    "lng": 121.9345788,
    "color": "#ffc107"
}, {
    "nosamw": "0904551",
    "nama": "RD No.02 Lapas Pohuwato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 647500,
    "total_denda": 35000,
    "total_jumlah": 682500,
    "lat": 0.5006027,
    "lng": 121.9345953,
    "color": "#dc3545"
}, {
    "nosamw": "0904552",
    "nama": "RD No.03 Lapas Pohuwato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1821500,
    "total_denda": 75000,
    "total_jumlah": 1896500,
    "lat": 0.5006365,
    "lng": 121.9347016,
    "color": "#dc3545"
}, {
    "nosamw": "0902381",
    "nama": "RD. Camat Buntulia",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4987252,
    "lng": 121.9352072,
    "color": "#28a745"
}, {
    "nosamw": "0904746",
    "nama": "REDI ANWAR",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 58200,
    "total_denda": 5000,
    "total_jumlah": 63200,
    "lat": 0.497339,
    "lng": 121.934613,
    "color": "#ffc107"
}, {
    "nosamw": "0905518",
    "nama": "RISTON HULOPI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4951532,
    "lng": 121.9325531,
    "color": "#28a745"
}, {
    "nosamw": "0902758",
    "nama": "Rita Kadir",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4995474,
    "lng": 121.9346425,
    "color": "#28a745"
}, {
    "nosamw": "0906149",
    "nama": "RIYANA HULOPI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005808,
    "lng": 121.9346255,
    "color": "#28a745"
}, {
    "nosamw": "0903949",
    "nama": "ROLIYA HANAPI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5010279,
    "lng": 121.9346894,
    "color": "#28a745"
}, {
    "nosamw": "0904234",
    "nama": "Rosita Mohamad",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 133000,
    "total_denda": 5000,
    "total_jumlah": 138000,
    "lat": 0.4932403,
    "lng": 121.933492,
    "color": "#ffc107"
}, {
    "nosamw": "0901881",
    "nama": "Rowaty Monoarfa",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4964769,
    "lng": 121.9337106,
    "color": "#28a745"
}, {
    "nosamw": "0904878",
    "nama": "RUDIN IBRAHIM",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4992117,
    "lng": 121.9348942,
    "color": "#28a745"
}, {
    "nosamw": "0900289",
    "nama": "Rudin Yalini",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4958287,
    "lng": 121.9335846,
    "color": "#28a745"
}, {
    "nosamw": "0904499",
    "nama": "Rumah Titipan. Lapas Pohuwato",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5006012,
    "lng": 121.9345788,
    "color": "#28a745"
}, {
    "nosamw": "0900958",
    "nama": "Rusni Sakue",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 234000,
    "total_denda": 10000,
    "total_jumlah": 244000,
    "lat": 0.4952355,
    "lng": 121.9340481,
    "color": "#ffc107"
}, {
    "nosamw": "0900204",
    "nama": "Rusni Tino",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4890778,
    "lng": 121.9342916,
    "color": "#28a745"
}, {
    "nosamw": "0900021",
    "nama": "Rustam Saleh",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 256000,
    "total_denda": 15000,
    "total_jumlah": 271000,
    "lat": 0.4954772,
    "lng": 121.9336136,
    "color": "#fd7e14"
}, {
    "nosamw": "0904508",
    "nama": "SIU ABADA",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005961,
    "lng": 121.93461,
    "color": "#28a745"
}, {
    "nosamw": "0906112",
    "nama": "SRI ENDANG GOBEL",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005829,
    "lng": 121.9346028,
    "color": "#28a745"
}, {
    "nosamw": "0900184",
    "nama": "Suldani Giasi",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4969525,
    "lng": 121.9338819,
    "color": "#ffc107"
}, {
    "nosamw": "0901123",
    "nama": "SUNGKONO DJ. SALEH",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4978506,
    "lng": 121.934038,
    "color": "#28a745"
}, {
    "nosamw": "0901083",
    "nama": "Surapati Ntekuku",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.4929336,
    "lng": 121.9334836,
    "color": "#ffc107"
}, {
    "nosamw": "0900359",
    "nama": "Suwardi Arsyad",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 5000,
    "total_jumlah": 99000,
    "lat": 0.4977745,
    "lng": 121.9339996,
    "color": "#ffc107"
}, {
    "nosamw": "0903412",
    "nama": "Suwitno Balu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5010279,
    "lng": 121.9346894,
    "color": "#28a745"
}, {
    "nosamw": "0902286",
    "nama": "Syafrudin Rivai",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4972102,
    "lng": 121.9343577,
    "color": "#28a745"
}, {
    "nosamw": "0902112",
    "nama": "Syarif Djafar",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 986000,
    "total_denda": 20000,
    "total_jumlah": 1006000,
    "lat": 0.4926049,
    "lng": 121.9335109,
    "color": "#fd7e14"
}, {
    "nosamw": "0903308",
    "nama": "Toni Dj. Mopangga",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4976435,
    "lng": 121.9350264,
    "color": "#28a745"
}, {
    "nosamw": "0900839",
    "nama": "TUE MOINTI",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.495828,
    "lng": 121.9336388,
    "color": "#ffc107"
}, {
    "nosamw": "0903826",
    "nama": "USAID Harun Abas",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.4939416,
    "lng": 121.933021,
    "color": "#ffc107"
}, {
    "nosamw": "0903869",
    "nama": "USAID Sano Yasin",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66600,
    "total_denda": 5000,
    "total_jumlah": 71600,
    "lat": 0.4931823,
    "lng": 121.9332898,
    "color": "#ffc107"
}, {
    "nosamw": "0903848",
    "nama": "USAID Stela Usman",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4932012,
    "lng": 121.9335189,
    "color": "#fd7e14"
}, {
    "nosamw": "0903845",
    "nama": "USAID Yusuf Kadir",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 790000,
    "total_denda": 25000,
    "total_jumlah": 815000,
    "lat": 0.493841,
    "lng": 121.9316724,
    "color": "#fd7e14"
}, {
    "nosamw": "0901553",
    "nama": "Voni Nurdin Tamu",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1151000,
    "total_denda": 25000,
    "total_jumlah": 1176000,
    "lat": 0.4966656,
    "lng": 121.9336143,
    "color": "#fd7e14"
}, {
    "nosamw": "0905044",
    "nama": "WARNI LADIKU",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4956341,
    "lng": 121.935807,
    "color": "#ffc107"
}, {
    "nosamw": "0900198",
    "nama": "Wendy A. Kela 2",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4812044,
    "lng": 121.9352687,
    "color": "#28a745"
}, {
    "nosamw": "0903209",
    "nama": "Wilson Baku",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 10000,
    "total_jumlah": 152500,
    "lat": 0.4995176,
    "lng": 121.9354005,
    "color": "#ffc107"
}, {
    "nosamw": "0903235",
    "nama": "Yonis Nay",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4978647,
    "lng": 121.933142,
    "color": "#28a745"
}, {
    "nosamw": "0903770",
    "nama": "Yusuf Ismail",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4983222,
    "lng": 121.9335003,
    "color": "#28a745"
}, {
    "nosamw": "0903163",
    "nama": "Yusufriyadi Hamda\/Gilingan Mopio",
    "kecamatan": "KEC BUNTULIA DESA BUNTULIA UTARA",
    "desa": "BUNTULIA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 8921500,
    "total_denda": 150000,
    "total_jumlah": 9071500,
    "lat": 0.4968103,
    "lng": 121.9371704,
    "color": "#dc3545"
}, {
    "nosamw": "0904532",
    "nama": "Abubakar Batiti",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 146000,
    "total_denda": 5000,
    "total_jumlah": 151000,
    "lat": 0.5328705,
    "lng": 121.9649365,
    "color": "#ffc107"
}, {
    "nosamw": "0905272",
    "nama": "ADLAN MOHA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 74750,
    "total_denda": 10000,
    "total_jumlah": 84750,
    "lat": 0.5313935,
    "lng": 121.966952,
    "color": "#ffc107"
}, {
    "nosamw": "0905422",
    "nama": "ALEX SAMSUDIN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1062300,
    "total_denda": 5000,
    "total_jumlah": 1067300,
    "lat": 0.5314007,
    "lng": 121.9669535,
    "color": "#ffc107"
}, {
    "nosamw": "0904384",
    "nama": "Amir iLahude",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.5331764,
    "lng": 121.9630595,
    "color": "#ffc107"
}, {
    "nosamw": "0903049",
    "nama": "Anton Idrus",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.5326627,
    "lng": 121.9670973,
    "color": "#ffc107"
}, {
    "nosamw": "0905467",
    "nama": "ANTON YASIN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5336845,
    "lng": 121.9601267,
    "color": "#28a745"
}, {
    "nosamw": "0904525",
    "nama": "Aripin Huruji",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 393000,
    "total_denda": 10000,
    "total_jumlah": 403000,
    "lat": 0.5346019,
    "lng": 121.9694243,
    "color": "#fd7e14"
}, {
    "nosamw": "0905533",
    "nama": "ARMAN LANTOWA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 578500,
    "total_denda": 35000,
    "total_jumlah": 613500,
    "lat": 0.5325757,
    "lng": 121.9661875,
    "color": "#dc3545"
}, {
    "nosamw": "0904883",
    "nama": "ASEP IDRUS",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 52600,
    "total_denda": 0,
    "total_jumlah": 52600,
    "lat": 0.5331804,
    "lng": 121.9671139,
    "color": "#ffc107"
}, {
    "nosamw": "0906160",
    "nama": "ASLAN DILEMBA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 248600,
    "total_denda": 5000,
    "total_jumlah": 253600,
    "lat": 0.5322445,
    "lng": 121.9659037,
    "color": "#ffc107"
}, {
    "nosamw": "0903139",
    "nama": "Cili Giasi",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 567800,
    "total_denda": 10000,
    "total_jumlah": 577800,
    "lat": 0.5332209,
    "lng": 121.9637828,
    "color": "#fd7e14"
}, {
    "nosamw": "0904628",
    "nama": "Cimu Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 208000,
    "total_denda": 10000,
    "total_jumlah": 218000,
    "lat": 0.5332097,
    "lng": 121.9630687,
    "color": "#fd7e14"
}, {
    "nosamw": "0903558",
    "nama": "Cindra Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.5332425,
    "lng": 121.9632065,
    "color": "#ffc107"
}, {
    "nosamw": "0901379",
    "nama": "Dian Dumako",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 702500,
    "total_denda": 15000,
    "total_jumlah": 717500,
    "lat": 0.5325642,
    "lng": 121.9661942,
    "color": "#fd7e14"
}, {
    "nosamw": "0904450",
    "nama": "Dini IsmaiL",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 340800,
    "total_denda": 25000,
    "total_jumlah": 365800,
    "lat": 0.5331678,
    "lng": 121.9621539,
    "color": "#fd7e14"
}, {
    "nosamw": "0903055",
    "nama": "Dino Tuna",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 772000,
    "total_denda": 15000,
    "total_jumlah": 787000,
    "lat": 0.532439,
    "lng": 121.9663983,
    "color": "#fd7e14"
}, {
    "nosamw": "0906135",
    "nama": "DJONI HARUN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 405000,
    "total_denda": 25000,
    "total_jumlah": 430000,
    "lat": 0.5324229,
    "lng": 121.9661393,
    "color": "#fd7e14"
}, {
    "nosamw": "0905433",
    "nama": "EJA MBUINGA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 229000,
    "total_denda": 25000,
    "total_jumlah": 254000,
    "lat": 0.5334782,
    "lng": 121.9609544,
    "color": "#fd7e14"
}, {
    "nosamw": "0904890",
    "nama": "ELI SALEH",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5334932,
    "lng": 121.9589172,
    "color": "#ffc107"
}, {
    "nosamw": "0904389",
    "nama": "Esman Tino",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 209800,
    "total_denda": 20000,
    "total_jumlah": 229800,
    "lat": 0.5314024,
    "lng": 121.9669531,
    "color": "#fd7e14"
}, {
    "nosamw": "0905448",
    "nama": "Fatmawati Ashala",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 332750,
    "total_denda": 10000,
    "total_jumlah": 342750,
    "lat": 0.5335964,
    "lng": 121.9605013,
    "color": "#fd7e14"
}, {
    "nosamw": "0906684",
    "nama": "H19 ROBI DILEMBA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.5332076,
    "lng": 121.9630513,
    "color": "#ffc107"
}, {
    "nosamw": "0904651",
    "nama": "Hamza Jama",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 522500,
    "total_denda": 30000,
    "total_jumlah": 552500,
    "lat": 0.533302,
    "lng": 121.9614028,
    "color": "#dc3545"
}, {
    "nosamw": "0903587",
    "nama": "Hapsal Atune",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 293750,
    "total_denda": 25000,
    "total_jumlah": 318750,
    "lat": 0.5320081,
    "lng": 121.9666099,
    "color": "#fd7e14"
}, {
    "nosamw": "0903058",
    "nama": "Haris Harun",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.533274,
    "lng": 121.9637327,
    "color": "#ffc107"
}, {
    "nosamw": "0904529",
    "nama": "Hariyanto Yunus",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005905,
    "lng": 121.9345872,
    "color": "#28a745"
}, {
    "nosamw": "0903052",
    "nama": "Harun Dilemba",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.5324708,
    "lng": 121.9664612,
    "color": "#ffc107"
}, {
    "nosamw": "0904454",
    "nama": "Harun Monoarfa",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.533257,
    "lng": 121.9688167,
    "color": "#ffc107"
}, {
    "nosamw": "0907518",
    "nama": "HARUN MONOARFA 2",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085368383559",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.5339222,
    "lng": 121.9692765,
    "color": "#ffc107"
}, {
    "nosamw": "0904511",
    "nama": "HOLMIS ILUNFIA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 572000,
    "total_denda": 5000,
    "total_jumlah": 577000,
    "lat": 0.5319541,
    "lng": 121.9668846,
    "color": "#ffc107"
}, {
    "nosamw": "0904381",
    "nama": "Husain Idrus",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 464500,
    "total_denda": 15000,
    "total_jumlah": 479500,
    "lat": 0.5314666,
    "lng": 121.9668485,
    "color": "#fd7e14"
}, {
    "nosamw": "0903140",
    "nama": "HUSIN KAILI\/BABEN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 198500,
    "total_denda": 5000,
    "total_jumlah": 203500,
    "lat": 0.5335911,
    "lng": 121.9591583,
    "color": "#ffc107"
}, {
    "nosamw": "0904634",
    "nama": "Inggo Husa",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.5334317,
    "lng": 121.9590971,
    "color": "#ffc107"
}, {
    "nosamw": "0903588",
    "nama": "Ismail Dilemba",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.455477,
    "lng": 121.938348,
    "color": "#ffc107"
}, {
    "nosamw": "0905444",
    "nama": "ISMAIL GOI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 268600,
    "total_denda": 25000,
    "total_jumlah": 293600,
    "lat": 0.467541,
    "lng": 121.94873,
    "color": "#fd7e14"
}, {
    "nosamw": "0903232",
    "nama": "ITON USULU",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 2269500,
    "total_denda": 45000,
    "total_jumlah": 2314500,
    "lat": 0.5323971,
    "lng": 121.9660509,
    "color": "#dc3545"
}, {
    "nosamw": "0904637",
    "nama": "Kahar Husain",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 687300,
    "total_denda": 25000,
    "total_jumlah": 712300,
    "lat": 0.5318875,
    "lng": 121.966514,
    "color": "#fd7e14"
}, {
    "nosamw": "0904699",
    "nama": "Karim Ulintiya",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.5375481,
    "lng": 121.970456,
    "color": "#ffc107"
}, {
    "nosamw": "0904382",
    "nama": "Kasmad Idrus",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 345000,
    "total_denda": 0,
    "total_jumlah": 345000,
    "lat": 0.5317566,
    "lng": 121.9666801,
    "color": "#ffc107"
}, {
    "nosamw": "0904386",
    "nama": "Kisman Pade",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 159000,
    "total_denda": 5000,
    "total_jumlah": 164000,
    "lat": 0.5319703,
    "lng": 121.966577,
    "color": "#ffc107"
}, {
    "nosamw": "0903582",
    "nama": "Mano H. Giasi",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 292500,
    "total_denda": 0,
    "total_jumlah": 292500,
    "lat": 0.5328832,
    "lng": 121.9648708,
    "color": "#ffc107"
}, {
    "nosamw": "0905035",
    "nama": "MESJID AL-RAHMAN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 281600,
    "total_denda": 45000,
    "total_jumlah": 326600,
    "lat": 0.5334364,
    "lng": 121.9584057,
    "color": "#dc3545"
}, {
    "nosamw": "0904650",
    "nama": "Min Kaji",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 58200,
    "total_denda": 0,
    "total_jumlah": 58200,
    "lat": 0.5332085,
    "lng": 121.9629859,
    "color": "#ffc107"
}, {
    "nosamw": "0906327",
    "nama": "MINDRIYA BATITI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.5330345,
    "lng": 121.9631181,
    "color": "#ffc107"
}, {
    "nosamw": "0903056",
    "nama": "Mohamad Harun",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 187500,
    "total_denda": 0,
    "total_jumlah": 187500,
    "lat": 0.5330068,
    "lng": 121.9670612,
    "color": "#ffc107"
}, {
    "nosamw": "0904638",
    "nama": "Mus Bauko",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.531988,
    "lng": 121.9666486,
    "color": "#ffc107"
}, {
    "nosamw": "0904526",
    "nama": "Ningsi Saliko",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5336533,
    "lng": 121.9594836,
    "color": "#28a745"
}, {
    "nosamw": "0904639",
    "nama": "NON DILEMBA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 236000,
    "total_denda": 0,
    "total_jumlah": 236000,
    "lat": 0.5319576,
    "lng": 121.9666092,
    "color": "#ffc107"
}, {
    "nosamw": "0904391",
    "nama": "Olwin Husain",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 492600,
    "total_denda": 20000,
    "total_jumlah": 512600,
    "lat": 0.5317829,
    "lng": 121.966668,
    "color": "#fd7e14"
}, {
    "nosamw": "0903050",
    "nama": "Ony Lahay",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.5326177,
    "lng": 121.9665736,
    "color": "#ffc107"
}, {
    "nosamw": "0905437",
    "nama": "PERDI MOHAMAD",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 272500,
    "total_denda": 0,
    "total_jumlah": 272500,
    "lat": 0.5328424,
    "lng": 121.9648389,
    "color": "#ffc107"
}, {
    "nosamw": "0907383",
    "nama": "PT. GSM 2",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "IB",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5005506,
    "lng": 121.9345804,
    "color": "#28a745"
}, {
    "nosamw": "0904500",
    "nama": "PT. Pani Resorser Indones",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "IB",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5380312,
    "lng": 121.9703613,
    "color": "#ffc107"
}, {
    "nosamw": "0904824",
    "nama": "RAHMAN LAMBAYU",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 484200,
    "total_denda": 25000,
    "total_jumlah": 509200,
    "lat": 0.5219125,
    "lng": 121.9568735,
    "color": "#fd7e14"
}, {
    "nosamw": "0904885",
    "nama": "RAHMAN MODUYO",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 124200,
    "total_denda": 10000,
    "total_jumlah": 134200,
    "lat": 0.5313991,
    "lng": 121.9669462,
    "color": "#fd7e14"
}, {
    "nosamw": "0905527",
    "nama": "RAMAN UMURI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.478238,
    "lng": 121.952963,
    "color": "#28a745"
}, {
    "nosamw": "0907298",
    "nama": "RIATUN HASAN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 386000,
    "total_denda": 10000,
    "total_jumlah": 396000,
    "lat": 0.5327573,
    "lng": 121.9668702,
    "color": "#fd7e14"
}, {
    "nosamw": "0907480",
    "nama": "RINTO MUCHSIN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085213723359",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.5331813,
    "lng": 121.9638632,
    "color": "#fd7e14"
}, {
    "nosamw": "0903088",
    "nama": "Rita Konio",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 245000,
    "total_denda": 15000,
    "total_jumlah": 260000,
    "lat": 0.5332977,
    "lng": 121.9627146,
    "color": "#fd7e14"
}, {
    "nosamw": "0905416",
    "nama": "ROBINSON BABUTA",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 190000,
    "total_denda": 0,
    "total_jumlah": 190000,
    "lat": 0.5336091,
    "lng": 121.9594851,
    "color": "#ffc107"
}, {
    "nosamw": "0904143",
    "nama": "Robinson Babuta",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5329614,
    "lng": 121.9671796,
    "color": "#28a745"
}, {
    "nosamw": "0904455",
    "nama": "Roni Idrus",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1162100,
    "total_denda": 45000,
    "total_jumlah": 1207100,
    "lat": 0.5313985,
    "lng": 121.9669497,
    "color": "#dc3545"
}, {
    "nosamw": "0905528",
    "nama": "ROSTIN IDRUS",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 10000,
    "total_jumlah": 250000,
    "lat": 0.5314186,
    "lng": 121.9669078,
    "color": "#ffc107"
}, {
    "nosamw": "0904627",
    "nama": "Rostin Ilohapa",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 253600,
    "total_denda": 5000,
    "total_jumlah": 258600,
    "lat": 0.5339393,
    "lng": 121.9691884,
    "color": "#ffc107"
}, {
    "nosamw": "0904451",
    "nama": "RULIS PILAMANGU",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5314009,
    "lng": 121.9669515,
    "color": "#ffc107"
}, {
    "nosamw": "0905083",
    "nama": "SALMA GIASI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1950400,
    "total_denda": 75000,
    "total_jumlah": 2025400,
    "lat": 0.5218758,
    "lng": 121.956948,
    "color": "#dc3545"
}, {
    "nosamw": "0903623",
    "nama": "Sartin Dauko",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.533147,
    "lng": 121.9637205,
    "color": "#ffc107"
}, {
    "nosamw": "0903996",
    "nama": "Soni Inundia",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.5331465,
    "lng": 121.9636886,
    "color": "#ffc107"
}, {
    "nosamw": "0906185",
    "nama": "SUDIRMAN HUSAIN",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 57500,
    "total_denda": 0,
    "total_jumlah": 57500,
    "lat": 0.5320271,
    "lng": 121.9665369,
    "color": "#ffc107"
}, {
    "nosamw": "0904632",
    "nama": "SUWARDI K. BADU",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 760500,
    "total_denda": 30000,
    "total_jumlah": 790500,
    "lat": 0.5325491,
    "lng": 121.9665067,
    "color": "#dc3545"
}, {
    "nosamw": "0904629",
    "nama": "Tamrin Tino",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 5000,
    "total_jumlah": 147500,
    "lat": 0.5325534,
    "lng": 121.966531,
    "color": "#ffc107"
}, {
    "nosamw": "0903087",
    "nama": "Udin Karim",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 92500,
    "total_denda": 0,
    "total_jumlah": 92500,
    "lat": 0.5330571,
    "lng": 121.964719,
    "color": "#ffc107"
}, {
    "nosamw": "0904003",
    "nama": "USAID DANDI KAILI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 199000,
    "total_denda": 10000,
    "total_jumlah": 209000,
    "lat": 0.5337375,
    "lng": 121.9594019,
    "color": "#fd7e14"
}, {
    "nosamw": "0904113",
    "nama": "USAID Hadija Abdullah",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5329244,
    "lng": 121.9650477,
    "color": "#28a745"
}, {
    "nosamw": "0904039",
    "nama": "USAID Herlina Tino",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165000,
    "total_denda": 0,
    "total_jumlah": 165000,
    "lat": 0.5333159,
    "lng": 121.9576604,
    "color": "#ffc107"
}, {
    "nosamw": "0903973",
    "nama": "USAID Honji Paana",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.5334798,
    "lng": 121.958498,
    "color": "#ffc107"
}, {
    "nosamw": "0903982",
    "nama": "USAID Ismail Pakaya",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 2237500,
    "total_denda": 55000,
    "total_jumlah": 2292500,
    "lat": 0.5334872,
    "lng": 121.9610216,
    "color": "#dc3545"
}, {
    "nosamw": "0904002",
    "nama": "USAID Kede Lihawa",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 330000,
    "total_denda": 0,
    "total_jumlah": 330000,
    "lat": 0.533389,
    "lng": 121.9621136,
    "color": "#ffc107"
}, {
    "nosamw": "0904042",
    "nama": "USAID Masi Baku",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.5332689,
    "lng": 121.9621177,
    "color": "#ffc107"
}, {
    "nosamw": "0903972",
    "nama": "USAID Mohamad Husain",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.5335509,
    "lng": 121.9591352,
    "color": "#ffc107"
}, {
    "nosamw": "0903997",
    "nama": "USAID Muhamad Gusasi",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 202750,
    "total_denda": 10000,
    "total_jumlah": 212750,
    "lat": 0.5332536,
    "lng": 121.962527,
    "color": "#fd7e14"
}, {
    "nosamw": "0903988",
    "nama": "USAID Murtin Tino",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 223000,
    "total_denda": 0,
    "total_jumlah": 223000,
    "lat": 0.5344949,
    "lng": 121.9693901,
    "color": "#ffc107"
}, {
    "nosamw": "0904032",
    "nama": "USAID Neni Huruji",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 935000,
    "total_denda": 5000,
    "total_jumlah": 940000,
    "lat": 0.533167,
    "lng": 121.9621513,
    "color": "#ffc107"
}, {
    "nosamw": "0904029",
    "nama": "USAID Salima Akuba",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 336200,
    "total_denda": 5000,
    "total_jumlah": 341200,
    "lat": 0.533613,
    "lng": 121.9599105,
    "color": "#ffc107"
}, {
    "nosamw": "0904044",
    "nama": "USAID Susanti Potutu",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107500,
    "total_denda": 0,
    "total_jumlah": 107500,
    "lat": 0.5329172,
    "lng": 121.9651766,
    "color": "#ffc107"
}, {
    "nosamw": "0904045",
    "nama": "USAID Umar Karim",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5333426,
    "lng": 121.9586964,
    "color": "#ffc107"
}, {
    "nosamw": "0904036",
    "nama": "USAID Umiyati Jailani",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.5334846,
    "lng": 121.9589011,
    "color": "#ffc107"
}, {
    "nosamw": "0903993",
    "nama": "USAID Usman Suleman",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 40000,
    "total_jumlah": 485000,
    "lat": 0.5337002,
    "lng": 121.9594683,
    "color": "#dc3545"
}, {
    "nosamw": "0902915",
    "nama": "Usman Abdjul",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 986500,
    "total_denda": 15000,
    "total_jumlah": 1001500,
    "lat": 0.5327022,
    "lng": 121.9671367,
    "color": "#fd7e14"
}, {
    "nosamw": "0904636",
    "nama": "Usman Samarang",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 598000,
    "total_denda": 25000,
    "total_jumlah": 623000,
    "lat": 0.5327482,
    "lng": 121.96683,
    "color": "#fd7e14"
}, {
    "nosamw": "0904631",
    "nama": "Yunus Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 75500,
    "total_denda": 0,
    "total_jumlah": 75500,
    "lat": 0.5331166,
    "lng": 121.9629564,
    "color": "#ffc107"
}, {
    "nosamw": "0905466",
    "nama": "YUSUF ALI",
    "kecamatan": "KEC BUNTULIA DESA HULAWA",
    "desa": "HULAWA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 561250,
    "total_denda": 70000,
    "total_jumlah": 631250,
    "lat": 0.460731,
    "lng": 121.936923,
    "color": "#dc3545"
}, {
    "nosamw": "0902908",
    "nama": "ABD WAHAB TULUKI",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 38600,
    "total_denda": 0,
    "total_jumlah": 38600,
    "lat": 0.5179569,
    "lng": 121.9496179,
    "color": "#ffc107"
}, {
    "nosamw": "0902962",
    "nama": "Abdul Rahman Maruf",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 99600,
    "total_denda": 10000,
    "total_jumlah": 109600,
    "lat": 0.5176841,
    "lng": 121.9494489,
    "color": "#ffc107"
}, {
    "nosamw": "0902938",
    "nama": "Ahmad Kala",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 639500,
    "total_denda": 50000,
    "total_jumlah": 689500,
    "lat": 0.5168706,
    "lng": 121.9494055,
    "color": "#dc3545"
}, {
    "nosamw": "0903759",
    "nama": "Bahtin Pakaya",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5194676,
    "lng": 121.9509077,
    "color": "#28a745"
}, {
    "nosamw": "0904479",
    "nama": "Bandiklat 2",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 2072500,
    "total_denda": 20000,
    "total_jumlah": 2092500,
    "lat": 0.5198297,
    "lng": 121.9426075,
    "color": "#fd7e14"
}, {
    "nosamw": "0901986",
    "nama": "BKPPD\/ Gedung Bandiklat",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 2555000,
    "total_denda": 20000,
    "total_jumlah": 2575000,
    "lat": 0.5199867,
    "lng": 121.9424433,
    "color": "#fd7e14"
}, {
    "nosamw": "0901772",
    "nama": "Deni Ambo",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 162500,
    "total_denda": 0,
    "total_jumlah": 162500,
    "lat": 0.5107967,
    "lng": 121.949095,
    "color": "#ffc107"
}, {
    "nosamw": "0902958",
    "nama": "Djafar Kadir",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5169286,
    "lng": 121.9491298,
    "color": "#28a745"
}, {
    "nosamw": "0901107",
    "nama": "Djainudin Umuri",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66000,
    "total_denda": 0,
    "total_jumlah": 66000,
    "lat": 0.5142857,
    "lng": 121.9488,
    "color": "#ffc107"
}, {
    "nosamw": "0901693",
    "nama": "Fikriyan Pakaya",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 368000,
    "total_denda": 20000,
    "total_jumlah": 388000,
    "lat": 0.519569,
    "lng": 121.9508089,
    "color": "#fd7e14"
}, {
    "nosamw": "0906698",
    "nama": "H19 ALWIN MANGGA",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.5194619,
    "lng": 121.95089,
    "color": "#ffc107"
}, {
    "nosamw": "0906697",
    "nama": "H19 APIPA SUPU",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 374700,
    "total_denda": 5000,
    "total_jumlah": 379700,
    "lat": 0.5167249,
    "lng": 121.9477678,
    "color": "#ffc107"
}, {
    "nosamw": "0906689",
    "nama": "H19 YUSUF RAIS",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.520352,
    "lng": 121.9520886,
    "color": "#ffc107"
}, {
    "nosamw": "0901328",
    "nama": "Halim Saleh",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5123038,
    "lng": 121.9469452,
    "color": "#28a745"
}, {
    "nosamw": "0901471",
    "nama": "Hani Tobamba",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.5136196,
    "lng": 121.9483913,
    "color": "#ffc107"
}, {
    "nosamw": "0902934",
    "nama": "Husa Maaruf",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5175256,
    "lng": 121.9493235,
    "color": "#28a745"
}, {
    "nosamw": "0902055",
    "nama": "Ibrahim Nota",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 307500,
    "total_denda": 20000,
    "total_jumlah": 327500,
    "lat": 0.519825,
    "lng": 121.951895,
    "color": "#fd7e14"
}, {
    "nosamw": "0901811",
    "nama": "Idris Hunta",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 82000,
    "total_denda": 0,
    "total_jumlah": 82000,
    "lat": 0.5151663,
    "lng": 121.9490228,
    "color": "#ffc107"
}, {
    "nosamw": "0902824",
    "nama": "Idris Nento",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 197500,
    "total_denda": 5000,
    "total_jumlah": 202500,
    "lat": 0.465426,
    "lng": 121.937734,
    "color": "#ffc107"
}, {
    "nosamw": "0901487",
    "nama": "Inton Pambi",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 58200,
    "total_denda": 0,
    "total_jumlah": 58200,
    "lat": 0.51874,
    "lng": 121.9513117,
    "color": "#ffc107"
}, {
    "nosamw": "0902917",
    "nama": "Ismail Tuluki",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5178894,
    "lng": 121.9496911,
    "color": "#28a745"
}, {
    "nosamw": "0902935",
    "nama": "Jadi Suku",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.517252,
    "lng": 121.9491983,
    "color": "#28a745"
}, {
    "nosamw": "0902918",
    "nama": "Kader Bone Putra",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5182496,
    "lng": 121.9497904,
    "color": "#28a745"
}, {
    "nosamw": "0905277",
    "nama": "KANTOR BP3K BUNTULIA",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.519725,
    "lng": 121.9447941,
    "color": "#ffc107"
}, {
    "nosamw": "0901806",
    "nama": "Karim Dama",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5134583,
    "lng": 121.950615,
    "color": "#ffc107"
}, {
    "nosamw": "0902913",
    "nama": "Kona Ingo",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 302600,
    "total_denda": 10000,
    "total_jumlah": 312600,
    "lat": 0.5190727,
    "lng": 121.9505311,
    "color": "#fd7e14"
}, {
    "nosamw": "0903429",
    "nama": "Kona Matiti",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5112564,
    "lng": 121.9558015,
    "color": "#28a745"
}, {
    "nosamw": "0903032",
    "nama": "Lajuardi Aridi",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5124646,
    "lng": 121.9468967,
    "color": "#28a745"
}, {
    "nosamw": "0901497",
    "nama": "MESJID AL-AZIM",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.515777,
    "lng": 121.9489473,
    "color": "#ffc107"
}, {
    "nosamw": "0902907",
    "nama": "Monira Maaruf",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5154567,
    "lng": 121.949335,
    "color": "#28a745"
}, {
    "nosamw": "0902940",
    "nama": "Mus Rais",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49250,
    "total_denda": 5000,
    "total_jumlah": 54250,
    "lat": 0.517587,
    "lng": 121.9494019,
    "color": "#ffc107"
}, {
    "nosamw": "0901350",
    "nama": "Nani Tane",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.5143624,
    "lng": 121.9490048,
    "color": "#fd7e14"
}, {
    "nosamw": "0907563",
    "nama": "NUKHRAWI",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085215114323",
    "total_bulan": 2,
    "total_tagihan": 248500,
    "total_denda": 5000,
    "total_jumlah": 253500,
    "lat": 0.5134634,
    "lng": 121.9479296,
    "color": "#ffc107"
}, {
    "nosamw": "0901155",
    "nama": "Nune Jumaati",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.515365,
    "lng": 121.9487583,
    "color": "#ffc107"
}, {
    "nosamw": "0902911",
    "nama": "Padlun Dama",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 246000,
    "total_denda": 15000,
    "total_jumlah": 261000,
    "lat": 0.51874,
    "lng": 121.9513117,
    "color": "#fd7e14"
}, {
    "nosamw": "0907555",
    "nama": "PETRICK PONTOH",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082234343383",
    "total_bulan": 2,
    "total_tagihan": 1287500,
    "total_denda": 5000,
    "total_jumlah": 1292500,
    "lat": 0.5196804,
    "lng": 121.9447886,
    "color": "#ffc107"
}, {
    "nosamw": "0901265",
    "nama": "REGINA PUTRI LATIF",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 843300,
    "total_denda": 15000,
    "total_jumlah": 858300,
    "lat": 0.5149829,
    "lng": 121.9489501,
    "color": "#fd7e14"
}, {
    "nosamw": "0901359",
    "nama": "Rison Tahuwa",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.5179967,
    "lng": 121.9496217,
    "color": "#ffc107"
}, {
    "nosamw": "0901808",
    "nama": "Rukia Ngau",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5154383,
    "lng": 121.9492914,
    "color": "#28a745"
}, {
    "nosamw": "0901695",
    "nama": "Runi Paana",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.5160717,
    "lng": 121.948985,
    "color": "#ffc107"
}, {
    "nosamw": "0901253",
    "nama": "Sabrun Jafar",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.51609,
    "lng": 121.9492566,
    "color": "#ffc107"
}, {
    "nosamw": "0903302",
    "nama": "SALEH ARABA'A",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 374000,
    "total_denda": 10000,
    "total_jumlah": 384000,
    "lat": 0.5178651,
    "lng": 121.945736,
    "color": "#fd7e14"
}, {
    "nosamw": "0901794",
    "nama": "Saleh Rasid",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.517771,
    "lng": 121.9496218,
    "color": "#ffc107"
}, {
    "nosamw": "0901224",
    "nama": "SDN. Inpres Karya Indah",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 3297250,
    "total_denda": 55000,
    "total_jumlah": 3352250,
    "lat": 0.5157995,
    "lng": 121.9490279,
    "color": "#dc3545"
}, {
    "nosamw": "0902959",
    "nama": "Suaiba Nento",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5171411,
    "lng": 121.9491961,
    "color": "#28a745"
}, {
    "nosamw": "0902916",
    "nama": "Suarni Mustapa",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 150000,
    "total_denda": 10000,
    "total_jumlah": 160000,
    "lat": 0.5176001,
    "lng": 121.9493547,
    "color": "#ffc107"
}, {
    "nosamw": "0902932",
    "nama": "Tahir Saleh",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 259500,
    "total_denda": 10000,
    "total_jumlah": 269500,
    "lat": 0.518623,
    "lng": 121.9503225,
    "color": "#ffc107"
}, {
    "nosamw": "0902466",
    "nama": "Tommy Adam",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 168400,
    "total_denda": 15000,
    "total_jumlah": 183400,
    "lat": 0.5200434,
    "lng": 121.9515433,
    "color": "#fd7e14"
}, {
    "nosamw": "0904288",
    "nama": "Tuu Bokingo",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 202600,
    "total_denda": 10000,
    "total_jumlah": 212600,
    "lat": 0.5198189,
    "lng": 121.9516781,
    "color": "#fd7e14"
}, {
    "nosamw": "0901769",
    "nama": "Usman Bagi",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 57500,
    "total_denda": 0,
    "total_jumlah": 57500,
    "lat": 0.5168815,
    "lng": 121.9494367,
    "color": "#ffc107"
}, {
    "nosamw": "0902933",
    "nama": "Uten Djumaati",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5178332,
    "lng": 121.9494851,
    "color": "#28a745"
}, {
    "nosamw": "0902956",
    "nama": "Yona Heda",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5202728,
    "lng": 121.9521088,
    "color": "#28a745"
}, {
    "nosamw": "0901804",
    "nama": "Yusuf Pambi",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120500,
    "total_denda": 0,
    "total_jumlah": 120500,
    "lat": 0.5186187,
    "lng": 121.9501761,
    "color": "#ffc107"
}, {
    "nosamw": "0901936",
    "nama": "Zamin Hunowu",
    "kecamatan": "KEC BUNTULIA DESA KARYA INDAH",
    "desa": "KARYA INDAH",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 309000,
    "total_denda": 5000,
    "total_jumlah": 314000,
    "lat": 0.52053,
    "lng": 121.94987,
    "color": "#ffc107"
}, {
    "nosamw": "0903208",
    "nama": "DAVID SAHE 2",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4791196,
    "lng": 121.9335984,
    "color": "#28a745"
}, {
    "nosamw": "0902865",
    "nama": "Dewi Ismail",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 750000,
    "total_denda": 20000,
    "total_jumlah": 770000,
    "lat": 0.4814632,
    "lng": 121.9354457,
    "color": "#fd7e14"
}, {
    "nosamw": "0904410",
    "nama": "Dolli Ginoga",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4811046,
    "lng": 121.9361883,
    "color": "#ffc107"
}, {
    "nosamw": "0906210",
    "nama": "H18 MOHAMMAD RIZALDY MOHUNE",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4783042,
    "lng": 121.9325322,
    "color": "#ffc107"
}, {
    "nosamw": "0904366",
    "nama": "Idrus Due",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4788834,
    "lng": 121.9308834,
    "color": "#28a745"
}, {
    "nosamw": "0902204",
    "nama": "Komala Bempa",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.481138,
    "lng": 121.9340501,
    "color": "#28a745"
}, {
    "nosamw": "0902789",
    "nama": "Nita Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4765166,
    "lng": 121.9368805,
    "color": "#fd7e14"
}, {
    "nosamw": "0902961",
    "nama": "Nurhayati Nento",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 884000,
    "total_denda": 35000,
    "total_jumlah": 919000,
    "lat": 0.4799978,
    "lng": 121.9341828,
    "color": "#dc3545"
}, {
    "nosamw": "0906168",
    "nama": "PAMSIMAS SIPATANA 1",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 522000,
    "total_denda": 5000,
    "total_jumlah": 527000,
    "lat": 0.4773584,
    "lng": 121.9347947,
    "color": "#ffc107"
}, {
    "nosamw": "0905426",
    "nama": "Riyanto Ismail",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4817431,
    "lng": 121.9326768,
    "color": "#fd7e14"
}, {
    "nosamw": "0902616",
    "nama": "Serli Katili",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4777195,
    "lng": 121.9341029,
    "color": "#28a745"
}, {
    "nosamw": "0903510",
    "nama": "SISKA DUKALANG",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2410000,
    "total_denda": 25000,
    "total_jumlah": 2435000,
    "lat": 0.4817013,
    "lng": 121.9333184,
    "color": "#fd7e14"
}, {
    "nosamw": "0904264",
    "nama": "Welly Motto 3",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4785045,
    "lng": 121.933345,
    "color": "#28a745"
}, {
    "nosamw": "0903331",
    "nama": "Zaenab A. Nento",
    "kecamatan": "KEC BUNTULIA DESA SIPATANA",
    "desa": "SIPATANA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4777533,
    "lng": 121.934052,
    "color": "#28a745"
}, {
    "nosamw": "0905263",
    "nama": "ADI SABUGE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5112427,
    "lng": 121.9557757,
    "color": "#28a745"
}, {
    "nosamw": "0904296",
    "nama": "Alvi Djakatara",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5042097,
    "lng": 121.9389472,
    "color": "#ffc107"
}, {
    "nosamw": "0905270",
    "nama": "ASWIN JUMAATI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5029814,
    "lng": 121.9495295,
    "color": "#28a745"
}, {
    "nosamw": "0904647",
    "nama": "BAYU DJAPAR",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 134500,
    "total_denda": 0,
    "total_jumlah": 134500,
    "lat": 0.5061381,
    "lng": 121.9402443,
    "color": "#ffc107"
}, {
    "nosamw": "0905537",
    "nama": "DANDI DIANGE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.504465,
    "lng": 121.9387507,
    "color": "#ffc107"
}, {
    "nosamw": "0905262",
    "nama": "DAUD SULEMAN",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5020941,
    "lng": 121.949056,
    "color": "#28a745"
}, {
    "nosamw": "0901800",
    "nama": "DJAMALUDIN BALU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5061608,
    "lng": 121.940182,
    "color": "#ffc107"
}, {
    "nosamw": "0903500",
    "nama": "Erni Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081342967724",
    "total_bulan": 2,
    "total_tagihan": 337500,
    "total_denda": 10000,
    "total_jumlah": 347500,
    "lat": 0.5028603,
    "lng": 121.9370942,
    "color": "#ffc107"
}, {
    "nosamw": "0904664",
    "nama": "Fadlun Karim",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 225000,
    "total_denda": 0,
    "total_jumlah": 225000,
    "lat": 0.5059612,
    "lng": 121.9399563,
    "color": "#ffc107"
}, {
    "nosamw": "0903154",
    "nama": "Fatriani Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.509143,
    "lng": 121.9431995,
    "color": "#ffc107"
}, {
    "nosamw": "0903136",
    "nama": "Fauziah Abdullah",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 399000,
    "total_denda": 15000,
    "total_jumlah": 414000,
    "lat": 0.5018604,
    "lng": 121.9364793,
    "color": "#fd7e14"
}, {
    "nosamw": "0905236",
    "nama": "HADISA KOBI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4998002,
    "lng": 121.9464867,
    "color": "#28a745"
}, {
    "nosamw": "0905232",
    "nama": "HALID DAMA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 275400,
    "total_denda": 15000,
    "total_jumlah": 290400,
    "lat": 0.5008236,
    "lng": 121.9480766,
    "color": "#fd7e14"
}, {
    "nosamw": "0905086",
    "nama": "HAMRAN URI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 397500,
    "total_denda": 0,
    "total_jumlah": 397500,
    "lat": 0.506244,
    "lng": 121.9395529,
    "color": "#ffc107"
}, {
    "nosamw": "0905265",
    "nama": "HARTONO HASAN",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44200,
    "total_denda": 5000,
    "total_jumlah": 49200,
    "lat": 0.5153483,
    "lng": 121.9564635,
    "color": "#ffc107"
}, {
    "nosamw": "0903155",
    "nama": "Harun Wantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5041287,
    "lng": 121.9389988,
    "color": "#ffc107"
}, {
    "nosamw": "0905249",
    "nama": "HERLINA MUNGGEA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5026644,
    "lng": 121.9490993,
    "color": "#28a745"
}, {
    "nosamw": "0902737",
    "nama": "Husin Potutu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 759500,
    "total_denda": 15000,
    "total_jumlah": 774500,
    "lat": 0.5065635,
    "lng": 121.9406158,
    "color": "#fd7e14"
}, {
    "nosamw": "0903411",
    "nama": "Husin Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 787500,
    "total_denda": 20000,
    "total_jumlah": 807500,
    "lat": 0.5027909,
    "lng": 121.93725,
    "color": "#fd7e14"
}, {
    "nosamw": "0905246",
    "nama": "IDA RIPO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5019757,
    "lng": 121.9489522,
    "color": "#28a745"
}, {
    "nosamw": "0902895",
    "nama": "Imran Moigo",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.520649,
    "lng": 121.9531848,
    "color": "#ffc107"
}, {
    "nosamw": "0905534",
    "nama": "IMRAN POLUMUDUYO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.5009106,
    "lng": 121.9349371,
    "color": "#ffc107"
}, {
    "nosamw": "0901833",
    "nama": "INTAN TANE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5151324,
    "lng": 121.9490726,
    "color": "#ffc107"
}, {
    "nosamw": "0901371",
    "nama": "Irmawati Bouti",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 225000,
    "total_denda": 0,
    "total_jumlah": 225000,
    "lat": 0.5029665,
    "lng": 121.9375497,
    "color": "#ffc107"
}, {
    "nosamw": "0905256",
    "nama": "ISMAIL BAWU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 862000,
    "total_denda": 115000,
    "total_jumlah": 977000,
    "lat": 0.503873,
    "lng": 121.9495512,
    "color": "#dc3545"
}, {
    "nosamw": "0905242",
    "nama": "JUNI KOBI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 75000,
    "total_denda": 5000,
    "total_jumlah": 80000,
    "lat": 0.4987969,
    "lng": 121.9460529,
    "color": "#ffc107"
}, {
    "nosamw": "0903825",
    "nama": "Jusuf Djafar",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 146000,
    "total_denda": 5000,
    "total_jumlah": 151000,
    "lat": 0.5167106,
    "lng": 121.9490735,
    "color": "#ffc107"
}, {
    "nosamw": "0905247",
    "nama": "KARTIN TANTU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5026839,
    "lng": 121.9492634,
    "color": "#28a745"
}, {
    "nosamw": "0904392",
    "nama": "Krislinus Roka",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 397000,
    "total_denda": 5000,
    "total_jumlah": 402000,
    "lat": 0.5065612,
    "lng": 121.940602,
    "color": "#ffc107"
}, {
    "nosamw": "0905081",
    "nama": "LAKSMIN ABAS",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5025523,
    "lng": 121.9492722,
    "color": "#28a745"
}, {
    "nosamw": "0901803",
    "nama": "Lili Kosambi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4873438,
    "lng": 121.935348,
    "color": "#28a745"
}, {
    "nosamw": "0905084",
    "nama": "Lin Malae",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 219400,
    "total_denda": 15000,
    "total_jumlah": 234400,
    "lat": 0.469965,
    "lng": 121.943224,
    "color": "#fd7e14"
}, {
    "nosamw": "0905543",
    "nama": "LIN MUNGGEA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 165000,
    "total_denda": 25000,
    "total_jumlah": 190000,
    "lat": 0.5040883,
    "lng": 121.9491688,
    "color": "#fd7e14"
}, {
    "nosamw": "0905234",
    "nama": "LINGSI BUMULO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5016319,
    "lng": 121.9485905,
    "color": "#28a745"
}, {
    "nosamw": "0905254",
    "nama": "MARDAN DIANGE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 486400,
    "total_denda": 30000,
    "total_jumlah": 516400,
    "lat": 0.5046041,
    "lng": 121.9486057,
    "color": "#fd7e14"
}, {
    "nosamw": "0902747",
    "nama": "Marlina Hasan",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 250500,
    "total_denda": 10000,
    "total_jumlah": 260500,
    "lat": 0.506546,
    "lng": 121.9404836,
    "color": "#ffc107"
}, {
    "nosamw": "0901828",
    "nama": "Marlina Pikoli",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 610000,
    "total_denda": 10000,
    "total_jumlah": 620000,
    "lat": 0.5052415,
    "lng": 121.9393816,
    "color": "#fd7e14"
}, {
    "nosamw": "0902530",
    "nama": "Mesjid Al- Ishaq",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 9000,
    "total_denda": 5000,
    "total_jumlah": 14000,
    "lat": 0.5055432,
    "lng": 121.9395632,
    "color": "#ffc107"
}, {
    "nosamw": "0906197",
    "nama": "MESJID AL-IQRA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5012905,
    "lng": 121.9341792,
    "color": "#28a745"
}, {
    "nosamw": "0904221",
    "nama": "Mimon Pauweni",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.506606,
    "lng": 121.9405111,
    "color": "#ffc107"
}, {
    "nosamw": "0901564",
    "nama": "Misra Udin Lasiki",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1816000,
    "total_denda": 60000,
    "total_jumlah": 1876000,
    "lat": 0.5018014,
    "lng": 121.9364619,
    "color": "#dc3545"
}, {
    "nosamw": "0903741",
    "nama": "Moh. Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 10000,
    "total_jumlah": 165500,
    "lat": 0.5010924,
    "lng": 121.934649,
    "color": "#ffc107"
}, {
    "nosamw": "0907513",
    "nama": "MOHAMAD ARIF SUSANTO, S.M",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085213723359",
    "total_bulan": 1,
    "total_tagihan": 442500,
    "total_denda": 0,
    "total_jumlah": 442500,
    "lat": 0.5026693,
    "lng": 121.9377798,
    "color": "#ffc107"
}, {
    "nosamw": "0903565",
    "nama": "Naiko Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165500,
    "total_denda": 5000,
    "total_jumlah": 170500,
    "lat": 0.5072524,
    "lng": 121.9411196,
    "color": "#ffc107"
}, {
    "nosamw": "0901768",
    "nama": "Najli Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39500,
    "total_denda": 0,
    "total_jumlah": 39500,
    "lat": 0.5022103,
    "lng": 121.936503,
    "color": "#ffc107"
}, {
    "nosamw": "0901801",
    "nama": "NURJANAH BALU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5080423,
    "lng": 121.9423276,
    "color": "#ffc107"
}, {
    "nosamw": "0905252",
    "nama": "RAHMAN MURJAI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5029738,
    "lng": 121.9495342,
    "color": "#28a745"
}, {
    "nosamw": "0902739",
    "nama": "Ratna Potutu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.505825,
    "lng": 121.9401037,
    "color": "#ffc107"
}, {
    "nosamw": "0907494",
    "nama": "RD MEDIS PKM BUNTULIA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081242942441",
    "total_bulan": 2,
    "total_tagihan": 260500,
    "total_denda": 5000,
    "total_jumlah": 265500,
    "lat": 0.5069371,
    "lng": 121.9421218,
    "color": "#ffc107"
}, {
    "nosamw": "0907495",
    "nama": "RD PARAMEDIS PKM BUNTULIA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081242942441",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5069224,
    "lng": 121.9421663,
    "color": "#ffc107"
}, {
    "nosamw": "0903419",
    "nama": "RICHMOND KAABA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.502317,
    "lng": 121.9369318,
    "color": "#28a745"
}, {
    "nosamw": "0905223",
    "nama": "RINTO SUKOLI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 129800,
    "total_denda": 15000,
    "total_jumlah": 144800,
    "lat": 0.5034117,
    "lng": 121.9497988,
    "color": "#fd7e14"
}, {
    "nosamw": "0905544",
    "nama": "Riska Djumaati",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5026448,
    "lng": 121.9493124,
    "color": "#28a745"
}, {
    "nosamw": "0902777",
    "nama": "Rizal Abada",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5089489,
    "lng": 121.9431479,
    "color": "#ffc107"
}, {
    "nosamw": "0903119",
    "nama": "Rolly Kasim",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 173400,
    "total_denda": 25000,
    "total_jumlah": 198400,
    "lat": 0.507975,
    "lng": 121.9417407,
    "color": "#fd7e14"
}, {
    "nosamw": "0904712",
    "nama": "Roman Pikoli",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5041697,
    "lng": 121.9390509,
    "color": "#ffc107"
}, {
    "nosamw": "0903899",
    "nama": "Ruspiyanti Harun",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1385000,
    "total_denda": 5000,
    "total_jumlah": 1390000,
    "lat": 0.5070724,
    "lng": 121.9408897,
    "color": "#fd7e14"
}, {
    "nosamw": "0902773",
    "nama": "Rustam Pasa",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 133200,
    "total_denda": 10000,
    "total_jumlah": 143200,
    "lat": 0.5088851,
    "lng": 121.9431836,
    "color": "#ffc107"
}, {
    "nosamw": "0905540",
    "nama": "Salmiyati Radjak,S.Pd",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.5061155,
    "lng": 121.9399867,
    "color": "#ffc107"
}, {
    "nosamw": "0905225",
    "nama": "SARTIN KARIM",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 190200,
    "total_denda": 25000,
    "total_jumlah": 215200,
    "lat": 0.5001961,
    "lng": 121.9476664,
    "color": "#fd7e14"
}, {
    "nosamw": "0903295",
    "nama": "SELVI TUNA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 272500,
    "total_denda": 10000,
    "total_jumlah": 282500,
    "lat": 0.5041111,
    "lng": 121.9386311,
    "color": "#ffc107"
}, {
    "nosamw": "0902774",
    "nama": "SRI DEWI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5067891,
    "lng": 121.9408662,
    "color": "#28a745"
}, {
    "nosamw": "0902746",
    "nama": "Suartin Husain",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.5063777,
    "lng": 121.9402195,
    "color": "#ffc107"
}, {
    "nosamw": "0905545",
    "nama": "SUDIN KARIM",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 135400,
    "total_denda": 15000,
    "total_jumlah": 150400,
    "lat": 0.5032988,
    "lng": 121.9496017,
    "color": "#fd7e14"
}, {
    "nosamw": "0904813",
    "nama": "SUPRATMAN TANTU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.5008967,
    "lng": 121.9349059,
    "color": "#ffc107"
}, {
    "nosamw": "0905536",
    "nama": "TISNI YUSUF",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.5060803,
    "lng": 121.9412008,
    "color": "#ffc107"
}, {
    "nosamw": "0903853",
    "nama": "USAID Daryanto Tantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5078154,
    "lng": 121.9425848,
    "color": "#28a745"
}, {
    "nosamw": "0903849",
    "nama": "USAID Iwan Bangga",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5028957,
    "lng": 121.9374503,
    "color": "#28a745"
}, {
    "nosamw": "0903819",
    "nama": "USAID Karim Djengo",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 105200,
    "total_denda": 10000,
    "total_jumlah": 115200,
    "lat": 0.5054614,
    "lng": 121.9396181,
    "color": "#ffc107"
}, {
    "nosamw": "0903855",
    "nama": "USAID Lin Tahir",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5078071,
    "lng": 121.9425794,
    "color": "#28a745"
}, {
    "nosamw": "0903890",
    "nama": "USAID Nani Tantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 133000,
    "total_denda": 5000,
    "total_jumlah": 138000,
    "lat": 0.5079071,
    "lng": 121.9419905,
    "color": "#ffc107"
}, {
    "nosamw": "0903829",
    "nama": "USAID Pahrun Mahmud",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5080507,
    "lng": 121.942219,
    "color": "#28a745"
}, {
    "nosamw": "0903817",
    "nama": "USAID Ulya Jumaati",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5040859,
    "lng": 121.9387845,
    "color": "#28a745"
}, {
    "nosamw": "0904088",
    "nama": "USAID Weni Tantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 645500,
    "total_denda": 20000,
    "total_jumlah": 665500,
    "lat": 0.5038469,
    "lng": 121.9396837,
    "color": "#fd7e14"
}, {
    "nosamw": "0903138",
    "nama": "Usman Tatu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.501842,
    "lng": 121.9364075,
    "color": "#28a745"
}, {
    "nosamw": "0905253",
    "nama": "WILSON TANE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 524250,
    "total_denda": 45000,
    "total_jumlah": 569250,
    "lat": 0.5032577,
    "lng": 121.9496115,
    "color": "#dc3545"
}, {
    "nosamw": "0902752",
    "nama": "YAHYA TANE",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5087036,
    "lng": 121.9433894,
    "color": "#28a745"
}, {
    "nosamw": "0905250",
    "nama": "YANTO JUMAATI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5027859,
    "lng": 121.9493101,
    "color": "#28a745"
}, {
    "nosamw": "0905243",
    "nama": "YASIN KIRAMAN",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.5007055,
    "lng": 121.9480118,
    "color": "#ffc107"
}, {
    "nosamw": "0903121",
    "nama": "Yopi Ladiku",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 207500,
    "total_denda": 5000,
    "total_jumlah": 212500,
    "lat": 0.460457,
    "lng": 121.942615,
    "color": "#ffc107"
}, {
    "nosamw": "0904819",
    "nama": "YULIUS TALOKAN",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 246500,
    "total_denda": 5000,
    "total_jumlah": 251500,
    "lat": 0.5063565,
    "lng": 121.9402963,
    "color": "#ffc107"
}, {
    "nosamw": "0905532",
    "nama": "YUNUS HASAN",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 2614500,
    "total_denda": 135000,
    "total_jumlah": 2749500,
    "lat": 0.46078,
    "lng": 121.943225,
    "color": "#dc3545"
}, {
    "nosamw": "0903695",
    "nama": "Yusri Abd. Rahman",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5022727,
    "lng": 121.9366687,
    "color": "#28a745"
}, {
    "nosamw": "0903117",
    "nama": "Yusuf Banggoi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5040311,
    "lng": 121.9384318,
    "color": "#28a745"
}, {
    "nosamw": "0904821",
    "nama": "YUYUN MUSTAFA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 462300,
    "total_denda": 10000,
    "total_jumlah": 472300,
    "lat": 0.504194,
    "lng": 121.9389044,
    "color": "#fd7e14"
}, {
    "nosamw": "0904298",
    "nama": "Zulkifli Tantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU",
    "desa": "TALUDUYUNU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5070724,
    "lng": 121.9409114,
    "color": "#28a745"
}, {
    "nosamw": "0904844",
    "nama": "AGUS TOBAMBA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165000,
    "total_denda": 0,
    "total_jumlah": 165000,
    "lat": 0.5126162,
    "lng": 121.9477172,
    "color": "#ffc107"
}, {
    "nosamw": "0905267",
    "nama": "ANDA JUMAATI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5120743,
    "lng": 121.9561275,
    "color": "#28a745"
}, {
    "nosamw": "0903493",
    "nama": "AULA KB",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 410000,
    "total_denda": 50000,
    "total_jumlah": 460000,
    "lat": 0.5096497,
    "lng": 121.9485458,
    "color": "#fd7e14"
}, {
    "nosamw": "0905264",
    "nama": "DAUD NOHO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 91800,
    "total_denda": 5000,
    "total_jumlah": 96800,
    "lat": 0.5153526,
    "lng": 121.9564623,
    "color": "#ffc107"
}, {
    "nosamw": "0902791",
    "nama": "Detris Hamid",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5128215,
    "lng": 121.9476482,
    "color": "#28a745"
}, {
    "nosamw": "0901737",
    "nama": "Gamar Hasan Saleh",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.512328,
    "lng": 121.9467089,
    "color": "#ffc107"
}, {
    "nosamw": "0904645",
    "nama": "Hasan Goi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.512516,
    "lng": 121.9472354,
    "color": "#ffc107"
}, {
    "nosamw": "0905095",
    "nama": "Irmawati Lomba",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5327433,
    "lng": 121.9671883,
    "color": "#ffc107"
}, {
    "nosamw": "0905268",
    "nama": "JUMA MA'RUP",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 15000,
    "total_jumlah": 120000,
    "lat": 0.5111027,
    "lng": 121.9555946,
    "color": "#fd7e14"
}, {
    "nosamw": "0907434",
    "nama": "LAJUARDI ARIDI 3",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356968170",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5139156,
    "lng": 121.9484435,
    "color": "#ffc107"
}, {
    "nosamw": "0901805",
    "nama": "MESJID DARUSSALAM \/ ABUBAKAR PAANA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4000,
    "total_denda": 5000,
    "total_jumlah": 9000,
    "lat": 0.5135523,
    "lng": 121.9479413,
    "color": "#ffc107"
}, {
    "nosamw": "0903015",
    "nama": "Min Umuri",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.5130731,
    "lng": 121.9477022,
    "color": "#ffc107"
}, {
    "nosamw": "0904222",
    "nama": "Noningsi Aridi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.5124323,
    "lng": 121.9468208,
    "color": "#ffc107"
}, {
    "nosamw": "0902829",
    "nama": "Oga Halidu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 402500,
    "total_denda": 5000,
    "total_jumlah": 407500,
    "lat": 0.5128128,
    "lng": 121.9476455,
    "color": "#ffc107"
}, {
    "nosamw": "0904037",
    "nama": "Oin Mbuinga",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.51393,
    "lng": 121.9484514,
    "color": "#ffc107"
}, {
    "nosamw": "0905553",
    "nama": "OYAN KOBI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.510048,
    "lng": 121.9482476,
    "color": "#ffc107"
}, {
    "nosamw": "0904478",
    "nama": "Puskesmas Buntulia",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "PP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.5100358,
    "lng": 121.9485631,
    "color": "#ffc107"
}, {
    "nosamw": "0904716",
    "nama": "RD. Dokter Puskesmas Taluduyunu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5099253,
    "lng": 121.9486259,
    "color": "#ffc107"
}, {
    "nosamw": "0905549",
    "nama": "SALMA AKINO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5116046,
    "lng": 121.9495166,
    "color": "#ffc107"
}, {
    "nosamw": "0905546",
    "nama": "SALMA BABUNGA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 324000,
    "total_denda": 5000,
    "total_jumlah": 329000,
    "lat": 0.5121818,
    "lng": 121.9465133,
    "color": "#ffc107"
}, {
    "nosamw": "0905547",
    "nama": "SISKA HALIDU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 505500,
    "total_denda": 25000,
    "total_jumlah": 530500,
    "lat": 0.5141558,
    "lng": 121.947598,
    "color": "#fd7e14"
}, {
    "nosamw": "0904845",
    "nama": "SULEMAN SAHI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.5121269,
    "lng": 121.9470562,
    "color": "#ffc107"
}, {
    "nosamw": "0901810",
    "nama": "Sutriyanto Daud",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5126292,
    "lng": 121.947614,
    "color": "#28a745"
}, {
    "nosamw": "0904024",
    "nama": "USAID Ajis Pantili",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 231200,
    "total_denda": 10000,
    "total_jumlah": 241200,
    "lat": 0.5145292,
    "lng": 121.9474157,
    "color": "#ffc107"
}, {
    "nosamw": "0903873",
    "nama": "USAID ALDI HALIDU",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.512506,
    "lng": 121.9475627,
    "color": "#28a745"
}, {
    "nosamw": "0903860",
    "nama": "USAID Cucun Sumiyati",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5123107,
    "lng": 121.9469593,
    "color": "#28a745"
}, {
    "nosamw": "0903977",
    "nama": "USAID Dawis Karim",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 149000,
    "total_denda": 10000,
    "total_jumlah": 159000,
    "lat": 0.5138803,
    "lng": 121.9476319,
    "color": "#ffc107"
}, {
    "nosamw": "0903974",
    "nama": "USAID Endris Tantu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87250,
    "total_denda": 5000,
    "total_jumlah": 92250,
    "lat": 0.5141283,
    "lng": 121.9476162,
    "color": "#ffc107"
}, {
    "nosamw": "0903911",
    "nama": "USAID HADIJA MANO",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 246000,
    "total_denda": 20000,
    "total_jumlah": 266000,
    "lat": 0.5134096,
    "lng": 121.9479413,
    "color": "#fd7e14"
}, {
    "nosamw": "0903978",
    "nama": "USAID Husain Tino",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 380500,
    "total_denda": 10000,
    "total_jumlah": 390500,
    "lat": 0.5138722,
    "lng": 121.9476275,
    "color": "#ffc107"
}, {
    "nosamw": "0904083",
    "nama": "USAID Idris Dama",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5140035,
    "lng": 121.9474532,
    "color": "#ffc107"
}, {
    "nosamw": "0904008",
    "nama": "USAID Karim Kala",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 192000,
    "total_denda": 10000,
    "total_jumlah": 202000,
    "lat": 0.5149597,
    "lng": 121.9473803,
    "color": "#ffc107"
}, {
    "nosamw": "0903979",
    "nama": "USAID Muklis Badu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5140626,
    "lng": 121.9474559,
    "color": "#28a745"
}, {
    "nosamw": "0903844",
    "nama": "USAID Owin Dama",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5128758,
    "lng": 121.9480895,
    "color": "#28a745"
}, {
    "nosamw": "0904084",
    "nama": "USAID Pauzia Tobamba",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 679000,
    "total_denda": 40000,
    "total_jumlah": 719000,
    "lat": 0.5140628,
    "lng": 121.9475343,
    "color": "#dc3545"
}, {
    "nosamw": "0903909",
    "nama": "USAID Rostin Hunowu",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.513495,
    "lng": 121.9479047,
    "color": "#ffc107"
}, {
    "nosamw": "0904025",
    "nama": "USAID Sain Baruadi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5142355,
    "lng": 121.9474028,
    "color": "#28a745"
}, {
    "nosamw": "0904080",
    "nama": "USAID Samin Kaili",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1166000,
    "total_denda": 40000,
    "total_jumlah": 1206000,
    "lat": 0.5137829,
    "lng": 121.9476594,
    "color": "#dc3545"
}, {
    "nosamw": "0904004",
    "nama": "USAID Sudin Ripo",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49800,
    "total_denda": 5000,
    "total_jumlah": 54800,
    "lat": 0.5102083,
    "lng": 121.9489578,
    "color": "#ffc107"
}, {
    "nosamw": "0904019",
    "nama": "USAID Tamrin Pakaya",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 102000,
    "total_denda": 5000,
    "total_jumlah": 107000,
    "lat": 0.5115332,
    "lng": 121.9495125,
    "color": "#ffc107"
}, {
    "nosamw": "0903891",
    "nama": "USAID Ulin Umar",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 845000,
    "total_denda": 5000,
    "total_jumlah": 850000,
    "lat": 0.5126097,
    "lng": 121.9472154,
    "color": "#fd7e14"
}, {
    "nosamw": "0904023",
    "nama": "USAID Yolan Abjul",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5137321,
    "lng": 121.9474367,
    "color": "#ffc107"
}, {
    "nosamw": "0903160",
    "nama": "Yati Baangi",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 10000,
    "total_jumlah": 146000,
    "lat": 0.5133311,
    "lng": 121.9494158,
    "color": "#ffc107"
}, {
    "nosamw": "0907444",
    "nama": "YULIN KUMAI",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081241368881",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.5105067,
    "lng": 121.9493375,
    "color": "#fd7e14"
}, {
    "nosamw": "0905013",
    "nama": "YUSNA PASA",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5112488,
    "lng": 121.955742,
    "color": "#28a745"
}, {
    "nosamw": "0900322",
    "nama": "Yusni Umar",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5125783,
    "lng": 121.9471564,
    "color": "#ffc107"
}, {
    "nosamw": "0906847",
    "nama": "Yusuf yunus",
    "kecamatan": "KEC BUNTULIA DESA TALUDUYUNU UTARA",
    "desa": "TALUDUYUNU UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.5337668,
    "lng": 121.9572544,
    "color": "#ffc107"
}, {
    "nosamw": "0800397",
    "nama": "Abd. Rahman Hamzah",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 736200,
    "total_denda": 85000,
    "total_jumlah": 821200,
    "lat": 0.525191,
    "lng": 122.1026904,
    "color": "#dc3545"
}, {
    "nosamw": "0800424",
    "nama": "Ahaya Tinelo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1019000,
    "total_denda": 155000,
    "total_jumlah": 1174000,
    "lat": 0.5245166,
    "lng": 122.1038268,
    "color": "#dc3545"
}, {
    "nosamw": "0800202",
    "nama": "AIS HUMADILO",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 233250,
    "total_denda": 25000,
    "total_jumlah": 258250,
    "lat": 0.5243763,
    "lng": 122.1035268,
    "color": "#fd7e14"
}, {
    "nosamw": "0800207",
    "nama": "AISYA MONOARFA",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 327750,
    "total_denda": 30000,
    "total_jumlah": 357750,
    "lat": 0.5310946,
    "lng": 122.0951384,
    "color": "#dc3545"
}, {
    "nosamw": "0800172",
    "nama": "Alan Arsad \/ Paud Dahlia",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1655650,
    "total_denda": 95000,
    "total_jumlah": 1750650,
    "lat": 0.531411,
    "lng": 122.0955132,
    "color": "#dc3545"
}, {
    "nosamw": "0800435",
    "nama": "ALAN HIYANGO",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1769100,
    "total_denda": 115000,
    "total_jumlah": 1884100,
    "lat": 0.5255679,
    "lng": 122.1029366,
    "color": "#dc3545"
}, {
    "nosamw": "0800418",
    "nama": "Alwin Rauf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 405800,
    "total_denda": 40000,
    "total_jumlah": 445800,
    "lat": 0.5252206,
    "lng": 122.1026938,
    "color": "#dc3545"
}, {
    "nosamw": "0800388",
    "nama": "Andi Mambu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 699800,
    "total_denda": 55000,
    "total_jumlah": 754800,
    "lat": 0.5253271,
    "lng": 122.1023276,
    "color": "#dc3545"
}, {
    "nosamw": "0800179",
    "nama": "Asmin Manuwei",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 629000,
    "total_denda": 95000,
    "total_jumlah": 724000,
    "lat": 0.5312542,
    "lng": 122.0954701,
    "color": "#dc3545"
}, {
    "nosamw": "0800227",
    "nama": "BASRI",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 502500,
    "total_denda": 20000,
    "total_jumlah": 522500,
    "lat": 0.5287009,
    "lng": 122.0937336,
    "color": "#fd7e14"
}, {
    "nosamw": "0800027",
    "nama": "David Ibrahim",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 278500,
    "total_denda": 25000,
    "total_jumlah": 303500,
    "lat": 0.5256476,
    "lng": 122.1024479,
    "color": "#fd7e14"
}, {
    "nosamw": "0800353",
    "nama": "Deliyanti Dolongseda",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 365000,
    "total_denda": 35000,
    "total_jumlah": 400000,
    "lat": 0.5301819,
    "lng": 122.0945398,
    "color": "#dc3545"
}, {
    "nosamw": "0800189",
    "nama": "Ekmon Ruitan",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 256000,
    "total_denda": 35000,
    "total_jumlah": 291000,
    "lat": 0.5356179,
    "lng": 122.0984193,
    "color": "#dc3545"
}, {
    "nosamw": "0800190",
    "nama": "Ekohadihayulu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1717500,
    "total_denda": 90000,
    "total_jumlah": 1807500,
    "lat": 0.5308059,
    "lng": 122.0952039,
    "color": "#dc3545"
}, {
    "nosamw": "0801025",
    "nama": "FELIX STEVEN PULUHULAWA",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 3,
    "total_tagihan": 308450,
    "total_denda": 10000,
    "total_jumlah": 318450,
    "lat": 0.5343976,
    "lng": 122.0915012,
    "color": "#fd7e14"
}, {
    "nosamw": "0800196",
    "nama": "Ferdinan Mohamad",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 416500,
    "total_denda": 35000,
    "total_jumlah": 451500,
    "lat": 0.5318175,
    "lng": 122.0957267,
    "color": "#dc3545"
}, {
    "nosamw": "0800197",
    "nama": "Feri Imon ",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 804600,
    "total_denda": 110000,
    "total_jumlah": 914600,
    "lat": 0.5284515,
    "lng": 122.0932881,
    "color": "#dc3545"
}, {
    "nosamw": "0801023",
    "nama": "FERI IMON",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5284165,
    "lng": 122.0932523,
    "color": "#ffc107"
}, {
    "nosamw": "0800678",
    "nama": "H16 Riko Suma",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 575400,
    "total_denda": 15000,
    "total_jumlah": 590400,
    "lat": 0.5330802,
    "lng": 122.0961159,
    "color": "#fd7e14"
}, {
    "nosamw": "0800825",
    "nama": "H18 JENAB ARIF",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 300750,
    "total_denda": 20000,
    "total_jumlah": 320750,
    "lat": 0.5448684,
    "lng": 122.091192,
    "color": "#fd7e14"
}, {
    "nosamw": "0800900",
    "nama": "H18 LISNA SUKU 2",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 563000,
    "total_denda": 75000,
    "total_jumlah": 638000,
    "lat": 0.5278187,
    "lng": 122.0946011,
    "color": "#dc3545"
}, {
    "nosamw": "0800868",
    "nama": "H18 Ruflin Arif",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1123000,
    "total_denda": 125000,
    "total_jumlah": 1248000,
    "lat": 0.5357765,
    "lng": 122.0972523,
    "color": "#dc3545"
}, {
    "nosamw": "0800874",
    "nama": "H18 SALAMI DETU",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 285250,
    "total_denda": 10000,
    "total_jumlah": 295250,
    "lat": 0.5300128,
    "lng": 122.0945437,
    "color": "#fd7e14"
}, {
    "nosamw": "0800898",
    "nama": "H18 TIWI DAUD",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 493200,
    "total_denda": 35000,
    "total_jumlah": 528200,
    "lat": 0.5283243,
    "lng": 122.0941718,
    "color": "#dc3545"
}, {
    "nosamw": "0800975",
    "nama": "H19 AYUN YUNUS",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1348000,
    "total_denda": 90000,
    "total_jumlah": 1438000,
    "lat": 0.5252457,
    "lng": 122.1030292,
    "color": "#dc3545"
}, {
    "nosamw": "0800944",
    "nama": "H19 DANCE ALBAKIR",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1189000,
    "total_denda": 115000,
    "total_jumlah": 1304000,
    "lat": 0.5363501,
    "lng": 122.0978382,
    "color": "#dc3545"
}, {
    "nosamw": "0800946",
    "nama": "H19 HAJAR MOKOTIKA",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1727350,
    "total_denda": 85000,
    "total_jumlah": 1812350,
    "lat": 0.5244226,
    "lng": 122.1040272,
    "color": "#dc3545"
}, {
    "nosamw": "0800943",
    "nama": "H19 HUSIN SANTE",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 294500,
    "total_denda": 35000,
    "total_jumlah": 329500,
    "lat": 0.5254995,
    "lng": 122.1030162,
    "color": "#dc3545"
}, {
    "nosamw": "0800739",
    "nama": "H19 Kisman Bagu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 798750,
    "total_denda": 60000,
    "total_jumlah": 858750,
    "lat": 0.5252017,
    "lng": 122.1030593,
    "color": "#dc3545"
}, {
    "nosamw": "0800961",
    "nama": "H19 PATMA HAMSA",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1281600,
    "total_denda": 95000,
    "total_jumlah": 1376600,
    "lat": 0.5282161,
    "lng": 122.0939174,
    "color": "#dc3545"
}, {
    "nosamw": "0800972",
    "nama": "H19 RABIA YUNUS",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 448600,
    "total_denda": 55000,
    "total_jumlah": 503600,
    "lat": 0.5259738,
    "lng": 122.1026364,
    "color": "#dc3545"
}, {
    "nosamw": "0800959",
    "nama": "H19 RANTI SUKO",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 3490400,
    "total_denda": 100000,
    "total_jumlah": 3590400,
    "lat": 0.5279078,
    "lng": 122.0939116,
    "color": "#dc3545"
}, {
    "nosamw": "0800969",
    "nama": "H19 SONI RAUF",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1446600,
    "total_denda": 50000,
    "total_jumlah": 1496600,
    "lat": 0.5307488,
    "lng": 122.0950922,
    "color": "#dc3545"
}, {
    "nosamw": "0800973",
    "nama": "H19 TUM AKE",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1205600,
    "total_denda": 110000,
    "total_jumlah": 1315600,
    "lat": 0.5255427,
    "lng": 122.1029859,
    "color": "#dc3545"
}, {
    "nosamw": "0800964",
    "nama": "H19 USMAN DJAFAR",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1503600,
    "total_denda": 65000,
    "total_jumlah": 1568600,
    "lat": 0.5330824,
    "lng": 122.0959017,
    "color": "#dc3545"
}, {
    "nosamw": "0800940",
    "nama": "H19 WATI KUMAY",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 2059200,
    "total_denda": 40000,
    "total_jumlah": 2099200,
    "lat": 0.5308438,
    "lng": 122.0957805,
    "color": "#dc3545"
}, {
    "nosamw": "0800499",
    "nama": "Hadija Rajak",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 274500,
    "total_denda": 5000,
    "total_jumlah": 279500,
    "lat": 0.5253099,
    "lng": 122.1029247,
    "color": "#ffc107"
}, {
    "nosamw": "0800200",
    "nama": "Hajara S. Detu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.5290624,
    "lng": 122.0925549,
    "color": "#ffc107"
}, {
    "nosamw": "0800447",
    "nama": "Hamdan Rahim",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1296400,
    "total_denda": 125000,
    "total_jumlah": 1421400,
    "lat": 0.524549,
    "lng": 122.1040949,
    "color": "#dc3545"
}, {
    "nosamw": "0800206",
    "nama": "Hasana Hasim",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5258442,
    "lng": 122.1019062,
    "color": "#ffc107"
}, {
    "nosamw": "0800600",
    "nama": "Heri Djafar",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5261556,
    "lng": 122.1019526,
    "color": "#ffc107"
}, {
    "nosamw": "0800448",
    "nama": "HERMAN YASIN",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 159000,
    "total_denda": 15000,
    "total_jumlah": 174000,
    "lat": 0.5246429,
    "lng": 122.1042203,
    "color": "#fd7e14"
}, {
    "nosamw": "0800519",
    "nama": "Herson Amaiya",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2548800,
    "total_denda": 120000,
    "total_jumlah": 2668800,
    "lat": 0.5260282,
    "lng": 122.1018967,
    "color": "#dc3545"
}, {
    "nosamw": "0800222",
    "nama": "HINO HAMID",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 96600,
    "total_denda": 10000,
    "total_jumlah": 106600,
    "lat": 0.5311871,
    "lng": 122.0953875,
    "color": "#fd7e14"
}, {
    "nosamw": "0800809",
    "nama": "Husain Haji",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1359650,
    "total_denda": 55000,
    "total_jumlah": 1414650,
    "lat": 0.5443186,
    "lng": 122.0910027,
    "color": "#dc3545"
}, {
    "nosamw": "0800525",
    "nama": "Ibrahim Rajak",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 566400,
    "total_denda": 35000,
    "total_jumlah": 601400,
    "lat": 0.5258914,
    "lng": 122.1021443,
    "color": "#dc3545"
}, {
    "nosamw": "0800210",
    "nama": "Idram Abas",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 105600,
    "total_denda": 5000,
    "total_jumlah": 110600,
    "lat": 0.5314561,
    "lng": 122.0954825,
    "color": "#ffc107"
}, {
    "nosamw": "0800503",
    "nama": "Idris Usman",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 911000,
    "total_denda": 95000,
    "total_jumlah": 1006000,
    "lat": 0.456869,
    "lng": 121.936811,
    "color": "#dc3545"
}, {
    "nosamw": "0800211",
    "nama": "Idrus Djakaria",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 993650,
    "total_denda": 65000,
    "total_jumlah": 1058650,
    "lat": 0.5241164,
    "lng": 122.103635,
    "color": "#dc3545"
}, {
    "nosamw": "0800213",
    "nama": "Indah Rauf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 138400,
    "total_denda": 15000,
    "total_jumlah": 153400,
    "lat": 0.5317539,
    "lng": 122.0957953,
    "color": "#fd7e14"
}, {
    "nosamw": "0800454",
    "nama": "Indra Rahman",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1040400,
    "total_denda": 75000,
    "total_jumlah": 1115400,
    "lat": 0.5242724,
    "lng": 122.1039785,
    "color": "#dc3545"
}, {
    "nosamw": "0800436",
    "nama": "Ismail Rajak",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 500000,
    "total_denda": 70000,
    "total_jumlah": 570000,
    "lat": 0.5239827,
    "lng": 122.1035474,
    "color": "#dc3545"
}, {
    "nosamw": "0800216",
    "nama": "Isna Due",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 719500,
    "total_denda": 55000,
    "total_jumlah": 774500,
    "lat": 0.5311319,
    "lng": 122.0953252,
    "color": "#dc3545"
}, {
    "nosamw": "0800450",
    "nama": "Jama Salehe",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1533700,
    "total_denda": 130000,
    "total_jumlah": 1663700,
    "lat": 0.5258384,
    "lng": 122.1020744,
    "color": "#dc3545"
}, {
    "nosamw": "0800218",
    "nama": "Japar Husain",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 578900,
    "total_denda": 25000,
    "total_jumlah": 603900,
    "lat": 0.5320665,
    "lng": 122.095948,
    "color": "#fd7e14"
}, {
    "nosamw": "0800415",
    "nama": "Jefri Mambu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1446600,
    "total_denda": 55000,
    "total_jumlah": 1501600,
    "lat": 0.5241297,
    "lng": 122.1039161,
    "color": "#dc3545"
}, {
    "nosamw": "0800183",
    "nama": "Jelita Rauf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 902250,
    "total_denda": 40000,
    "total_jumlah": 942250,
    "lat": 0.5251655,
    "lng": 122.1030474,
    "color": "#dc3545"
}, {
    "nosamw": "0800219",
    "nama": "Jubaida Nagaring",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.5285428,
    "lng": 122.0939677,
    "color": "#fd7e14"
}, {
    "nosamw": "0800220",
    "nama": "Jubair Hulopi",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1005600,
    "total_denda": 75000,
    "total_jumlah": 1080600,
    "lat": 0.5345672,
    "lng": 122.0973863,
    "color": "#dc3545"
}, {
    "nosamw": "0800428",
    "nama": "Kani Humadilo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1348400,
    "total_denda": 90000,
    "total_jumlah": 1438400,
    "lat": 0.5248013,
    "lng": 122.1034481,
    "color": "#dc3545"
}, {
    "nosamw": "0800451",
    "nama": "Karim Buloto",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 2272100,
    "total_denda": 130000,
    "total_jumlah": 2402100,
    "lat": 0.5257854,
    "lng": 122.1021431,
    "color": "#dc3545"
}, {
    "nosamw": "0800221",
    "nama": "Karim Detu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 192000,
    "total_denda": 25000,
    "total_jumlah": 217000,
    "lat": 0.5317012,
    "lng": 122.0957643,
    "color": "#fd7e14"
}, {
    "nosamw": "0800430",
    "nama": "Karim Ma'ruf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2137000,
    "total_denda": 110000,
    "total_jumlah": 2247000,
    "lat": 0.5247123,
    "lng": 122.1034898,
    "color": "#dc3545"
}, {
    "nosamw": "0800408",
    "nama": "Kasim Laiya",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 225000,
    "total_denda": 30000,
    "total_jumlah": 255000,
    "lat": 0.525248,
    "lng": 122.1022342,
    "color": "#dc3545"
}, {
    "nosamw": "0800224",
    "nama": "Lihawa Monoarfa",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1719200,
    "total_denda": 130000,
    "total_jumlah": 1849200,
    "lat": 0.5275457,
    "lng": 122.0956848,
    "color": "#dc3545"
}, {
    "nosamw": "0800178",
    "nama": "LUTAN SUKO",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 272500,
    "total_denda": 0,
    "total_jumlah": 272500,
    "lat": 0.5257235,
    "lng": 122.103008,
    "color": "#ffc107"
}, {
    "nosamw": "0800417",
    "nama": "Man Hasan",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 203500,
    "total_denda": 20000,
    "total_jumlah": 223500,
    "lat": 0.5253085,
    "lng": 122.10292,
    "color": "#fd7e14"
}, {
    "nosamw": "0800509",
    "nama": "Marten Yusuf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 178000,
    "total_denda": 15000,
    "total_jumlah": 193000,
    "lat": 0.447392,
    "lng": 121.937898,
    "color": "#fd7e14"
}, {
    "nosamw": "0800589",
    "nama": "Megawati Mangga",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 142250,
    "total_denda": 10000,
    "total_jumlah": 152250,
    "lat": 0.5287806,
    "lng": 122.0942575,
    "color": "#fd7e14"
}, {
    "nosamw": "0800181",
    "nama": "MIGEL MAMBU",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 515000,
    "total_denda": 20000,
    "total_jumlah": 535000,
    "lat": 0.5253131,
    "lng": 122.1027505,
    "color": "#fd7e14"
}, {
    "nosamw": "0800514",
    "nama": "Mimin Hamzah",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 101800,
    "total_denda": 10000,
    "total_jumlah": 111800,
    "lat": 0.5242885,
    "lng": 122.1033784,
    "color": "#fd7e14"
}, {
    "nosamw": "0800407",
    "nama": "Mohamad Pipi",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1152100,
    "total_denda": 105000,
    "total_jumlah": 1257100,
    "lat": 0.5252915,
    "lng": 122.102293,
    "color": "#dc3545"
}, {
    "nosamw": "0800228",
    "nama": "Moody Wolter Kapondo, S.TH",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 128700,
    "total_denda": 40000,
    "total_jumlah": 168700,
    "lat": 0.535155,
    "lng": 122.0989769,
    "color": "#dc3545"
}, {
    "nosamw": "0800601",
    "nama": "Murtiyati Motota",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 103250,
    "total_denda": 5000,
    "total_jumlah": 108250,
    "lat": 0.525665,
    "lng": 122.1029062,
    "color": "#ffc107"
}, {
    "nosamw": "0800375",
    "nama": "Najamudin Arsad",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1053350,
    "total_denda": 60000,
    "total_jumlah": 1113350,
    "lat": 0.524089,
    "lng": 122.1036931,
    "color": "#dc3545"
}, {
    "nosamw": "0800398",
    "nama": "Nasir Yusuf",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 85600,
    "total_denda": 5000,
    "total_jumlah": 90600,
    "lat": 0.5252263,
    "lng": 122.1026764,
    "color": "#ffc107"
}, {
    "nosamw": "0800527",
    "nama": "Neni Tenilo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 2544600,
    "total_denda": 130000,
    "total_jumlah": 2674600,
    "lat": 0.5285021,
    "lng": 122.0964508,
    "color": "#dc3545"
}, {
    "nosamw": "0800231",
    "nama": "Ningsi Napu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 1013800,
    "total_denda": 145000,
    "total_jumlah": 1158800,
    "lat": 0.5275324,
    "lng": 122.0956375,
    "color": "#dc3545"
}, {
    "nosamw": "0800233",
    "nama": "NITA DETU",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 561500,
    "total_denda": 65000,
    "total_jumlah": 626500,
    "lat": 0.5243406,
    "lng": 122.1043298,
    "color": "#dc3545"
}, {
    "nosamw": "0800452",
    "nama": "Nitan Anuke",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 141000,
    "total_denda": 10000,
    "total_jumlah": 151000,
    "lat": 0.5244083,
    "lng": 122.1035707,
    "color": "#fd7e14"
}, {
    "nosamw": "0800421",
    "nama": "Noldi Najiru",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 433700,
    "total_denda": 45000,
    "total_jumlah": 478700,
    "lat": 0.5244335,
    "lng": 122.1037192,
    "color": "#dc3545"
}, {
    "nosamw": "0800504",
    "nama": "Nune Tenilo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5259679,
    "lng": 122.1018462,
    "color": "#ffc107"
}, {
    "nosamw": "0800434",
    "nama": "Nunu Matantu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1881900,
    "total_denda": 140000,
    "total_jumlah": 2021900,
    "lat": 0.5243742,
    "lng": 122.1035189,
    "color": "#dc3545"
}, {
    "nosamw": "0800528",
    "nama": "OTMAN RAHIM",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 997200,
    "total_denda": 125000,
    "total_jumlah": 1122200,
    "lat": 0.5278246,
    "lng": 122.0946491,
    "color": "#dc3545"
}, {
    "nosamw": "0800237",
    "nama": "Radjak Gogou",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5358034,
    "lng": 122.0996037,
    "color": "#fd7e14"
}, {
    "nosamw": "0800443",
    "nama": "RAHMAN BUBANTO",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 889300,
    "total_denda": 15000,
    "total_jumlah": 904300,
    "lat": 0.5257748,
    "lng": 122.1022108,
    "color": "#fd7e14"
}, {
    "nosamw": "0800404",
    "nama": "Rahman Buloto",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 368600,
    "total_denda": 45000,
    "total_jumlah": 413600,
    "lat": 0.5258986,
    "lng": 122.1027408,
    "color": "#dc3545"
}, {
    "nosamw": "0800256",
    "nama": "Rahman Motota",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 646200,
    "total_denda": 25000,
    "total_jumlah": 671200,
    "lat": 0.5289162,
    "lng": 122.0923961,
    "color": "#fd7e14"
}, {
    "nosamw": "0800201",
    "nama": "RATNI AKE",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 184000,
    "total_denda": 20000,
    "total_jumlah": 204000,
    "lat": 0.5256817,
    "lng": 122.1029835,
    "color": "#fd7e14"
}, {
    "nosamw": "0800294",
    "nama": "Reti Saud",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 500700,
    "total_denda": 30000,
    "total_jumlah": 530700,
    "lat": 0.5287188,
    "lng": 122.093874,
    "color": "#dc3545"
}, {
    "nosamw": "0800513",
    "nama": "RIAN MANGGA",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1342000,
    "total_denda": 35000,
    "total_jumlah": 1377000,
    "lat": 0.5244698,
    "lng": 122.1039086,
    "color": "#dc3545"
}, {
    "nosamw": "0800502",
    "nama": "Rionis Yasidu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 413200,
    "total_denda": 35000,
    "total_jumlah": 448200,
    "lat": 0.5260263,
    "lng": 122.1018928,
    "color": "#dc3545"
}, {
    "nosamw": "0800420",
    "nama": "Rudi Pakaya",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 523150,
    "total_denda": 45000,
    "total_jumlah": 568150,
    "lat": 0.5255182,
    "lng": 122.1026666,
    "color": "#dc3545"
}, {
    "nosamw": "0800437",
    "nama": "Rudin Husain",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 329800,
    "total_denda": 40000,
    "total_jumlah": 369800,
    "lat": 0.5237294,
    "lng": 122.1035279,
    "color": "#dc3545"
}, {
    "nosamw": "0800457",
    "nama": "Saldi Husain",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 115000,
    "total_denda": 5000,
    "total_jumlah": 120000,
    "lat": 0.5246829,
    "lng": 122.1036284,
    "color": "#ffc107"
}, {
    "nosamw": "0800372",
    "nama": "Santo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 584700,
    "total_denda": 55000,
    "total_jumlah": 639700,
    "lat": 0.523856,
    "lng": 122.1035004,
    "color": "#dc3545"
}, {
    "nosamw": "0800255",
    "nama": "Saripa Salehe",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1846950,
    "total_denda": 110000,
    "total_jumlah": 1956950,
    "lat": 0.5243622,
    "lng": 122.1033379,
    "color": "#dc3545"
}, {
    "nosamw": "0800524",
    "nama": "Sarton Djalimu",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 846400,
    "total_denda": 65000,
    "total_jumlah": 911400,
    "lat": 0.5258001,
    "lng": 122.1025913,
    "color": "#dc3545"
}, {
    "nosamw": "0800442",
    "nama": "Sarvin Antula",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 926000,
    "total_denda": 65000,
    "total_jumlah": 991000,
    "lat": 0.5262562,
    "lng": 122.1019589,
    "color": "#dc3545"
}, {
    "nosamw": "0800030",
    "nama": "SDN 03 Dengilo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 20000,
    "total_jumlah": 160000,
    "lat": 0.5287949,
    "lng": 122.0936652,
    "color": "#fd7e14"
}, {
    "nosamw": "0800426",
    "nama": "Siron Kadir",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 604800,
    "total_denda": 85000,
    "total_jumlah": 689800,
    "lat": 0.5239597,
    "lng": 122.1035546,
    "color": "#dc3545"
}, {
    "nosamw": "0800416",
    "nama": "Soni Wambi",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1421900,
    "total_denda": 95000,
    "total_jumlah": 1516900,
    "lat": 0.5243844,
    "lng": 122.103538,
    "color": "#dc3545"
}, {
    "nosamw": "0801027",
    "nama": "SRI ANAI",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 2,
    "total_tagihan": 287800,
    "total_denda": 5000,
    "total_jumlah": 292800,
    "lat": 0.5251739,
    "lng": 122.103037,
    "color": "#ffc107"
}, {
    "nosamw": "0800395",
    "nama": "Suleman Pahude",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 349800,
    "total_denda": 30000,
    "total_jumlah": 379800,
    "lat": 0.5255411,
    "lng": 122.1024545,
    "color": "#dc3545"
}, {
    "nosamw": "0800390",
    "nama": "Udin bau",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 218800,
    "total_denda": 15000,
    "total_jumlah": 233800,
    "lat": 0.525233,
    "lng": 122.1026749,
    "color": "#fd7e14"
}, {
    "nosamw": "0800373",
    "nama": "Umar Tolana",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 725800,
    "total_denda": 65000,
    "total_jumlah": 790800,
    "lat": 0.5241951,
    "lng": 122.1038899,
    "color": "#dc3545"
}, {
    "nosamw": "0800423",
    "nama": "Usman Jauhari",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 803350,
    "total_denda": 40000,
    "total_jumlah": 843350,
    "lat": 0.524608,
    "lng": 122.1036448,
    "color": "#dc3545"
}, {
    "nosamw": "0800593",
    "nama": "Usman Tahir",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1470000,
    "total_denda": 95000,
    "total_jumlah": 1565000,
    "lat": 0.527922,
    "lng": 122.0939344,
    "color": "#dc3545"
}, {
    "nosamw": "0800177",
    "nama": "WAHAB MELANGI",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 487400,
    "total_denda": 30000,
    "total_jumlah": 517400,
    "lat": 0.5311941,
    "lng": 122.0954343,
    "color": "#dc3545"
}, {
    "nosamw": "0800378",
    "nama": "Weli Albakir",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 945100,
    "total_denda": 90000,
    "total_jumlah": 1035100,
    "lat": 0.5244494,
    "lng": 122.1040197,
    "color": "#dc3545"
}, {
    "nosamw": "0800396",
    "nama": "Yakob Ibrahim",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 244600,
    "total_denda": 30000,
    "total_jumlah": 274600,
    "lat": 0.5256319,
    "lng": 122.1025555,
    "color": "#dc3545"
}, {
    "nosamw": "0800374",
    "nama": "Yakop Basiru",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 384600,
    "total_denda": 25000,
    "total_jumlah": 409600,
    "lat": 0.5241702,
    "lng": 122.1039047,
    "color": "#fd7e14"
}, {
    "nosamw": "0800406",
    "nama": "Yunus Hiyango",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 248200,
    "total_denda": 30000,
    "total_jumlah": 278200,
    "lat": 0.5256405,
    "lng": 122.1024419,
    "color": "#dc3545"
}, {
    "nosamw": "0800268",
    "nama": "Yusni Melangi",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 137000,
    "total_denda": 5000,
    "total_jumlah": 142000,
    "lat": 0.530908,
    "lng": 122.0957006,
    "color": "#ffc107"
}, {
    "nosamw": "0800409",
    "nama": "Yusuf Humadilo",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1513000,
    "total_denda": 85000,
    "total_jumlah": 1598000,
    "lat": 0.5244258,
    "lng": 122.1041523,
    "color": "#dc3545"
}, {
    "nosamw": "0800522",
    "nama": "Yusuf Mahmud",
    "kecamatan": "KEC DENGILO DESA HUTA MOPUTI",
    "desa": "HUTA MOPUTI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 730200,
    "total_denda": 85000,
    "total_jumlah": 815200,
    "lat": 0.5243139,
    "lng": 122.1043034,
    "color": "#dc3545"
}, {
    "nosamw": "0800325",
    "nama": "Daniel Kairala",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 3327200,
    "total_denda": 120000,
    "total_jumlah": 3447200,
    "lat": 0.5369526,
    "lng": 122.10996,
    "color": "#dc3545"
}, {
    "nosamw": "0800099",
    "nama": "Doortensi Ruitan",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5386088,
    "lng": 122.1095585,
    "color": "#28a745"
}, {
    "nosamw": "0800037",
    "nama": "Dortea Dame",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1022400,
    "total_denda": 85000,
    "total_jumlah": 1107400,
    "lat": 0.5379665,
    "lng": 122.1085915,
    "color": "#dc3545"
}, {
    "nosamw": "0800495",
    "nama": "Eldat Galomat",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082292523710",
    "total_bulan": 18,
    "total_tagihan": 1246000,
    "total_denda": 90000,
    "total_jumlah": 1336000,
    "lat": 0.5380488,
    "lng": 122.1095144,
    "color": "#dc3545"
}, {
    "nosamw": "0800310",
    "nama": "Fence Mamuko",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 366950,
    "total_denda": 30000,
    "total_jumlah": 396950,
    "lat": 0.537403,
    "lng": 122.1058963,
    "color": "#fd7e14"
}, {
    "nosamw": "0800315",
    "nama": "Gat Karame",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 782800,
    "total_denda": 95000,
    "total_jumlah": 877800,
    "lat": 0.5374571,
    "lng": 122.1087115,
    "color": "#dc3545"
}, {
    "nosamw": "0800308",
    "nama": "H.U VII",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2402350,
    "total_denda": 80000,
    "total_jumlah": 2482350,
    "lat": 0.5431777,
    "lng": 122.1130831,
    "color": "#dc3545"
}, {
    "nosamw": "0800983",
    "nama": "H19 HENOK MAMUKO",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1275400,
    "total_denda": 120000,
    "total_jumlah": 1395400,
    "lat": 0.5404263,
    "lng": 122.1107489,
    "color": "#dc3545"
}, {
    "nosamw": "0800921",
    "nama": "H19 Maskarena Galomat",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 930000,
    "total_denda": 105000,
    "total_jumlah": 1035000,
    "lat": 0.5387274,
    "lng": 122.1096456,
    "color": "#dc3545"
}, {
    "nosamw": "0800490",
    "nama": "Hasan Thaib",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 158400,
    "total_denda": 10000,
    "total_jumlah": 168400,
    "lat": 0.540311,
    "lng": 122.1104121,
    "color": "#ffc107"
}, {
    "nosamw": "0800491",
    "nama": "HASNA LATIF",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1401800,
    "total_denda": 120000,
    "total_jumlah": 1521800,
    "lat": 0.537718,
    "lng": 122.1081385,
    "color": "#dc3545"
}, {
    "nosamw": "0800546",
    "nama": "Hutman Sahibomang",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 846400,
    "total_denda": 125000,
    "total_jumlah": 971400,
    "lat": 0.5371909,
    "lng": 122.1094647,
    "color": "#dc3545"
}, {
    "nosamw": "0800591",
    "nama": "Jhonhen Dame",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 2174450,
    "total_denda": 150000,
    "total_jumlah": 2324450,
    "lat": 0.5374116,
    "lng": 122.1057107,
    "color": "#dc3545"
}, {
    "nosamw": "0800480",
    "nama": "Katrina Kadai",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1857800,
    "total_denda": 105000,
    "total_jumlah": 1962800,
    "lat": 0.5447484,
    "lng": 122.1123495,
    "color": "#dc3545"
}, {
    "nosamw": "0800341",
    "nama": "Lipus Kairalang",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1552600,
    "total_denda": 120000,
    "total_jumlah": 1672600,
    "lat": 0.5428976,
    "lng": 122.1130381,
    "color": "#dc3545"
}, {
    "nosamw": "0800345",
    "nama": "Naplon Sada",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 658800,
    "total_denda": 60000,
    "total_jumlah": 718800,
    "lat": 0.543626,
    "lng": 122.1128757,
    "color": "#dc3545"
}, {
    "nosamw": "0800319",
    "nama": "Obet Kalesing",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1823400,
    "total_denda": 130000,
    "total_jumlah": 1953400,
    "lat": 0.5378537,
    "lng": 122.1097287,
    "color": "#dc3545"
}, {
    "nosamw": "0800485",
    "nama": "Piter Bawole",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1504600,
    "total_denda": 75000,
    "total_jumlah": 1579600,
    "lat": 0.5432282,
    "lng": 122.1127806,
    "color": "#dc3545"
}, {
    "nosamw": "0800547",
    "nama": "Royke Takahegesang",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5384558,
    "lng": 122.1096707,
    "color": "#28a745"
}, {
    "nosamw": "0800487",
    "nama": "Winter Galomat",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5373844,
    "lng": 122.1063233,
    "color": "#28a745"
}, {
    "nosamw": "0800344",
    "nama": "Zebedeus Kairala",
    "kecamatan": "KEC DENGILO DESA KARAGETAN",
    "desa": "KARAGETAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 610600,
    "total_denda": 85000,
    "total_jumlah": 695600,
    "lat": 0.5435677,
    "lng": 122.1130091,
    "color": "#dc3545"
}, {
    "nosamw": "0800105",
    "nama": "Abd Rahman Salehe",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 719500,
    "total_denda": 50000,
    "total_jumlah": 769500,
    "lat": 0.5503695,
    "lng": 122.0936871,
    "color": "#dc3545"
}, {
    "nosamw": "0800562",
    "nama": "Ajis Kadir",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5497589,
    "lng": 122.0914838,
    "color": "#28a745"
}, {
    "nosamw": "0800011",
    "nama": "Amna Ali",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1324950,
    "total_denda": 40000,
    "total_jumlah": 1364950,
    "lat": 0.5484418,
    "lng": 122.0920231,
    "color": "#dc3545"
}, {
    "nosamw": "0800989",
    "nama": "ANTON LAHAY",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1239100,
    "total_denda": 65000,
    "total_jumlah": 1304100,
    "lat": 0.5566465,
    "lng": 122.1097404,
    "color": "#dc3545"
}, {
    "nosamw": "0800110",
    "nama": "Dedi Abdullah",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5481983,
    "lng": 122.0925444,
    "color": "#ffc107"
}, {
    "nosamw": "0800111",
    "nama": "Elis Ibrahim",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1325100,
    "total_denda": 55000,
    "total_jumlah": 1380100,
    "lat": 0.5480608,
    "lng": 122.0925073,
    "color": "#dc3545"
}, {
    "nosamw": "0800703",
    "nama": "H16 CANDRA LATIF",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1922300,
    "total_denda": 55000,
    "total_jumlah": 1977300,
    "lat": 0.5021955,
    "lng": 122.0714615,
    "color": "#dc3545"
}, {
    "nosamw": "0800707",
    "nama": "H16 IBRAHIM MULANE",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 2265550,
    "total_denda": 120000,
    "total_jumlah": 2385550,
    "lat": 0.5572737,
    "lng": 122.0945377,
    "color": "#dc3545"
}, {
    "nosamw": "0800705",
    "nama": "H16 Ibrahim Pou",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 72200,
    "total_denda": 5000,
    "total_jumlah": 77200,
    "lat": 0.5649392,
    "lng": 122.0941972,
    "color": "#ffc107"
}, {
    "nosamw": "0800687",
    "nama": "H16 IDRAK MULANE",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 828000,
    "total_denda": 20000,
    "total_jumlah": 848000,
    "lat": 0.5501199,
    "lng": 122.0923149,
    "color": "#fd7e14"
}, {
    "nosamw": "0800701",
    "nama": "H16 Idrak Rauf",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 93000,
    "total_denda": 15000,
    "total_jumlah": 108000,
    "lat": 0.55788,
    "lng": 122.0944872,
    "color": "#fd7e14"
}, {
    "nosamw": "0800694",
    "nama": "H16 KASIM SAMANUA",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 668850,
    "total_denda": 25000,
    "total_jumlah": 693850,
    "lat": 0.5502201,
    "lng": 122.0931905,
    "color": "#fd7e14"
}, {
    "nosamw": "0800699",
    "nama": "H16 Njoke Hasan",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 383500,
    "total_denda": 50000,
    "total_jumlah": 433500,
    "lat": 0.5575577,
    "lng": 122.0944181,
    "color": "#dc3545"
}, {
    "nosamw": "0800684",
    "nama": "H16 Ridwan Ngoli",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5501365,
    "lng": 122.0933736,
    "color": "#28a745"
}, {
    "nosamw": "0800700",
    "nama": "H16 SALIMIN",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1579600,
    "total_denda": 125000,
    "total_jumlah": 1704600,
    "lat": 0.5576158,
    "lng": 122.094522,
    "color": "#dc3545"
}, {
    "nosamw": "0800685",
    "nama": "H16 Sarifudin Idrus",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 779200,
    "total_denda": 90000,
    "total_jumlah": 869200,
    "lat": 0.5570783,
    "lng": 122.0948618,
    "color": "#dc3545"
}, {
    "nosamw": "0800730",
    "nama": "H16 Usri Dai",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 93400,
    "total_denda": 15000,
    "total_jumlah": 108400,
    "lat": 0.5575358,
    "lng": 122.0948481,
    "color": "#fd7e14"
}, {
    "nosamw": "0800704",
    "nama": "H16 Yunus Ombili",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 188200,
    "total_denda": 25000,
    "total_jumlah": 213200,
    "lat": 0.5645135,
    "lng": 122.0940854,
    "color": "#fd7e14"
}, {
    "nosamw": "0800779",
    "nama": "H18 AISA UMAR",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 162000,
    "total_denda": 15000,
    "total_jumlah": 177000,
    "lat": 0.5475696,
    "lng": 122.0926564,
    "color": "#fd7e14"
}, {
    "nosamw": "0800816",
    "nama": "H18 MIDUN LATIF 2",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 509700,
    "total_denda": 20000,
    "total_jumlah": 529700,
    "lat": 0.5496634,
    "lng": 122.0951621,
    "color": "#fd7e14"
}, {
    "nosamw": "0800849",
    "nama": "H18 Niya Maudi",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5532692,
    "lng": 122.0950751,
    "color": "#28a745"
}, {
    "nosamw": "0800888",
    "nama": "H18 SUMARDI MANGGA",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2697850,
    "total_denda": 75000,
    "total_jumlah": 2772850,
    "lat": 0.5563852,
    "lng": 122.0957966,
    "color": "#dc3545"
}, {
    "nosamw": "0800774",
    "nama": "H19 ABDUL RAHMAN SUMA",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 2821850,
    "total_denda": 135000,
    "total_jumlah": 2956850,
    "lat": 0.5502217,
    "lng": 122.0924433,
    "color": "#dc3545"
}, {
    "nosamw": "0800606",
    "nama": "H19 Asni Baturapa",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 369350,
    "total_denda": 15000,
    "total_jumlah": 384350,
    "lat": 0.5497464,
    "lng": 122.0936447,
    "color": "#fd7e14"
}, {
    "nosamw": "0800771",
    "nama": "H19 Femi Lolonto",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 416250,
    "total_denda": 35000,
    "total_jumlah": 451250,
    "lat": 0.5474851,
    "lng": 122.0923702,
    "color": "#dc3545"
}, {
    "nosamw": "0800749",
    "nama": "H19 Husain Palaki",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 474000,
    "total_denda": 35000,
    "total_jumlah": 509000,
    "lat": 0.5577118,
    "lng": 122.0942834,
    "color": "#dc3545"
}, {
    "nosamw": "0800767",
    "nama": "H19 Ismail Ali",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 609200,
    "total_denda": 85000,
    "total_jumlah": 694200,
    "lat": 0.5522285,
    "lng": 122.0942777,
    "color": "#dc3545"
}, {
    "nosamw": "0800759",
    "nama": "H19 Mansur Lolonto",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 769200,
    "total_denda": 95000,
    "total_jumlah": 864200,
    "lat": 0.5553296,
    "lng": 122.0956347,
    "color": "#dc3545"
}, {
    "nosamw": "0800743",
    "nama": "H19 Mus Tarawe",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 426200,
    "total_denda": 60000,
    "total_jumlah": 486200,
    "lat": 0.5527234,
    "lng": 122.0947773,
    "color": "#dc3545"
}, {
    "nosamw": "0800608",
    "nama": "H19 Risan Djuma",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 365000,
    "total_denda": 20000,
    "total_jumlah": 385000,
    "lat": 0.5576547,
    "lng": 122.0952078,
    "color": "#fd7e14"
}, {
    "nosamw": "0800877",
    "nama": "H19 SAPRIN RAHMAN",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 493400,
    "total_denda": 35000,
    "total_jumlah": 528400,
    "lat": 0.5501758,
    "lng": 122.0919579,
    "color": "#dc3545"
}, {
    "nosamw": "0800755",
    "nama": "H19 srawati Sore",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1505850,
    "total_denda": 55000,
    "total_jumlah": 1560850,
    "lat": 0.5581404,
    "lng": 122.0944504,
    "color": "#dc3545"
}, {
    "nosamw": "0800758",
    "nama": "Hadija Majadi",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 590000,
    "total_denda": 40000,
    "total_jumlah": 630000,
    "lat": 0.5477932,
    "lng": 122.0923247,
    "color": "#dc3545"
}, {
    "nosamw": "0800691",
    "nama": "Ibrahim Palaki",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 434750,
    "total_denda": 30000,
    "total_jumlah": 464750,
    "lat": 0.5482432,
    "lng": 122.0925537,
    "color": "#fd7e14"
}, {
    "nosamw": "0801015",
    "nama": "INDRAWATY YUSUF",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 4,
    "total_tagihan": 419800,
    "total_denda": 20000,
    "total_jumlah": 439800,
    "lat": 0.464316,
    "lng": 121.951727,
    "color": "#fd7e14"
}, {
    "nosamw": "0800118",
    "nama": "Lisna Kiraman",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 927450,
    "total_denda": 40000,
    "total_jumlah": 967450,
    "lat": 0.5482394,
    "lng": 122.0925597,
    "color": "#dc3545"
}, {
    "nosamw": "0800104",
    "nama": "MELINDA TUNA",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.552502,
    "lng": 122.0947529,
    "color": "#ffc107"
}, {
    "nosamw": "0800120",
    "nama": "Mohamad Latif",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 840600,
    "total_denda": 60000,
    "total_jumlah": 900600,
    "lat": 0.5477438,
    "lng": 122.0923993,
    "color": "#dc3545"
}, {
    "nosamw": "0800560",
    "nama": "Saipul Abas",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1432500,
    "total_denda": 105000,
    "total_jumlah": 1537500,
    "lat": 0.5531245,
    "lng": 122.0960989,
    "color": "#dc3545"
}, {
    "nosamw": "0800122",
    "nama": "Saleh Lolonto II",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.550342,
    "lng": 122.0931805,
    "color": "#ffc107"
}, {
    "nosamw": "0800103",
    "nama": "Sane Latif",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 27000,
    "total_denda": 5000,
    "total_jumlah": 32000,
    "lat": 0.5499648,
    "lng": 122.0918294,
    "color": "#ffc107"
}, {
    "nosamw": "0800123",
    "nama": "Saumi Latif",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 9425000,
    "total_denda": 50000,
    "total_jumlah": 9475000,
    "lat": 0.5474842,
    "lng": 122.092368,
    "color": "#dc3545"
}, {
    "nosamw": "0800008",
    "nama": "SDN 05 Dengilo",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1113700,
    "total_denda": 25000,
    "total_jumlah": 1138700,
    "lat": 0.5496588,
    "lng": 122.0919118,
    "color": "#fd7e14"
}, {
    "nosamw": "0800127",
    "nama": "Yusuf Baturapa",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 650000,
    "total_denda": 5000,
    "total_jumlah": 655000,
    "lat": 0.5506419,
    "lng": 122.0933126,
    "color": "#ffc107"
}, {
    "nosamw": "0801011",
    "nama": "YUSUF LOLONTO",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 2442300,
    "total_denda": 130000,
    "total_jumlah": 2572300,
    "lat": 0.5501918,
    "lng": 122.0925556,
    "color": "#dc3545"
}, {
    "nosamw": "0800126",
    "nama": "Yusuf palaki",
    "kecamatan": "KEC DENGILO DESA KARYA BARU",
    "desa": "KARYA BARU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1052200,
    "total_denda": 30000,
    "total_jumlah": 1082200,
    "lat": 0.5479379,
    "lng": 122.0925594,
    "color": "#fd7e14"
}, {
    "nosamw": "0800995",
    "nama": "ACONG IBRAHIM",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 501400,
    "total_denda": 35000,
    "total_jumlah": 536400,
    "lat": 0.5629864,
    "lng": 122.1154168,
    "color": "#dc3545"
}, {
    "nosamw": "0800274",
    "nama": "Arifin Taha",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 715400,
    "total_denda": 95000,
    "total_jumlah": 810400,
    "lat": 0.552138,
    "lng": 122.1106205,
    "color": "#dc3545"
}, {
    "nosamw": "0800544",
    "nama": "Asma Rauf",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1085300,
    "total_denda": 25000,
    "total_jumlah": 1110300,
    "lat": 0.5486359,
    "lng": 122.1044484,
    "color": "#fd7e14"
}, {
    "nosamw": "0800994",
    "nama": "BADRUDIN TAMPILANG",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 72800,
    "total_denda": 5000,
    "total_jumlah": 77800,
    "lat": 0.5629363,
    "lng": 122.1153082,
    "color": "#ffc107"
}, {
    "nosamw": "0800004",
    "nama": "DEWI HASAN",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1444300,
    "total_denda": 105000,
    "total_jumlah": 1549300,
    "lat": 0.5514477,
    "lng": 122.1140563,
    "color": "#dc3545"
}, {
    "nosamw": "0801014",
    "nama": "DIKU IBRAHIM",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 545700,
    "total_denda": 45000,
    "total_jumlah": 590700,
    "lat": 0.5628379,
    "lng": 122.1154361,
    "color": "#dc3545"
}, {
    "nosamw": "0800284",
    "nama": "Emi Tawaluyan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 2747250,
    "total_denda": 100000,
    "total_jumlah": 2847250,
    "lat": 0.5381132,
    "lng": 122.1040383,
    "color": "#dc3545"
}, {
    "nosamw": "0800273",
    "nama": "FADLUN MAIRE",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 375000,
    "total_denda": 35000,
    "total_jumlah": 410000,
    "lat": 0.5627333,
    "lng": 122.1143971,
    "color": "#dc3545"
}, {
    "nosamw": "0800640",
    "nama": "H16 Agustin Albakir",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 141600,
    "total_denda": 10000,
    "total_jumlah": 151600,
    "lat": 0.545036,
    "lng": 122.1120675,
    "color": "#ffc107"
}, {
    "nosamw": "0800646",
    "nama": "H16 Amrin Kue",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 337400,
    "total_denda": 35000,
    "total_jumlah": 372400,
    "lat": 0.5478524,
    "lng": 122.1154627,
    "color": "#dc3545"
}, {
    "nosamw": "0800676",
    "nama": "H16 Deno Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 190650,
    "total_denda": 20000,
    "total_jumlah": 210650,
    "lat": 0.5507424,
    "lng": 122.1057492,
    "color": "#fd7e14"
}, {
    "nosamw": "0800675",
    "nama": "H16 Erlin Masiri",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 159000,
    "total_denda": 25000,
    "total_jumlah": 184000,
    "lat": 0.55075,
    "lng": 122.1057009,
    "color": "#fd7e14"
}, {
    "nosamw": "0800633",
    "nama": "H16 Fatma Kiraman",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 566400,
    "total_denda": 75000,
    "total_jumlah": 641400,
    "lat": 0.5456239,
    "lng": 122.1119703,
    "color": "#dc3545"
}, {
    "nosamw": "0800653",
    "nama": "H16 Husain Mooduto",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 148800,
    "total_denda": 20000,
    "total_jumlah": 168800,
    "lat": 0.5502097,
    "lng": 122.1155304,
    "color": "#fd7e14"
}, {
    "nosamw": "0800631",
    "nama": "H16 Husin Taha",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2293000,
    "total_denda": 95000,
    "total_jumlah": 2388000,
    "lat": 0.5459549,
    "lng": 122.1120252,
    "color": "#dc3545"
}, {
    "nosamw": "0800647",
    "nama": "H16 Idris Kue",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 347800,
    "total_denda": 25000,
    "total_jumlah": 372800,
    "lat": 0.5480784,
    "lng": 122.1146518,
    "color": "#fd7e14"
}, {
    "nosamw": "0800636",
    "nama": "H16 Idrus Yasin",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5498125,
    "lng": 122.1158527,
    "color": "#28a745"
}, {
    "nosamw": "0800635",
    "nama": "H16 Ismail Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1282500,
    "total_denda": 35000,
    "total_jumlah": 1317500,
    "lat": 0.5463383,
    "lng": 122.1128585,
    "color": "#dc3545"
}, {
    "nosamw": "0800638",
    "nama": "H16 Kasmad Melangi",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.5491968,
    "lng": 122.1154296,
    "color": "#ffc107"
}, {
    "nosamw": "0800645",
    "nama": "H16 Nurlan Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 172000,
    "total_denda": 20000,
    "total_jumlah": 192000,
    "lat": 0.5487701,
    "lng": 122.114768,
    "color": "#fd7e14"
}, {
    "nosamw": "0800637",
    "nama": "H16 Salim Husain",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 91200,
    "total_denda": 10000,
    "total_jumlah": 101200,
    "lat": 0.5463968,
    "lng": 122.1128048,
    "color": "#ffc107"
}, {
    "nosamw": "0800648",
    "nama": "H16 Salma Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 93000,
    "total_denda": 15000,
    "total_jumlah": 108000,
    "lat": 0.5482551,
    "lng": 122.1144329,
    "color": "#fd7e14"
}, {
    "nosamw": "0800727",
    "nama": "H16 Tuna L. Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 637300,
    "total_denda": 45000,
    "total_jumlah": 682300,
    "lat": 0.5437914,
    "lng": 122.08925,
    "color": "#dc3545"
}, {
    "nosamw": "0800634",
    "nama": "H16 Udin Saleha",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 165600,
    "total_denda": 20000,
    "total_jumlah": 185600,
    "lat": 0.5470999,
    "lng": 122.1135991,
    "color": "#fd7e14"
}, {
    "nosamw": "0800782",
    "nama": "H18 AMIN KARNAIN",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1263200,
    "total_denda": 100000,
    "total_jumlah": 1363200,
    "lat": 0.5513496,
    "lng": 122.1145585,
    "color": "#dc3545"
}, {
    "nosamw": "0800830",
    "nama": "H18 KARIM ABAS",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1110000,
    "total_denda": 55000,
    "total_jumlah": 1165000,
    "lat": 0.5563521,
    "lng": 122.1093495,
    "color": "#dc3545"
}, {
    "nosamw": "0800865",
    "nama": "H18 Rian Samarang",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1581750,
    "total_denda": 115000,
    "total_jumlah": 1696750,
    "lat": 0.5454161,
    "lng": 122.0912921,
    "color": "#dc3545"
}, {
    "nosamw": "0800609",
    "nama": "H19 Abdullah Kue",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2018300,
    "total_denda": 80000,
    "total_jumlah": 2098300,
    "lat": 0.5466771,
    "lng": 122.1131343,
    "color": "#dc3545"
}, {
    "nosamw": "0800974",
    "nama": "H19 ALIMIN RAUF",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.5501662,
    "lng": 122.1049168,
    "color": "#fd7e14"
}, {
    "nosamw": "0800979",
    "nama": "H19 AMIN MANTALI",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 567200,
    "total_denda": 70000,
    "total_jumlah": 637200,
    "lat": 0.5450741,
    "lng": 122.0913954,
    "color": "#dc3545"
}, {
    "nosamw": "0800615",
    "nama": "H19 FATMA POLIMENGO",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 2568750,
    "total_denda": 55000,
    "total_jumlah": 2623750,
    "lat": 0.5628282,
    "lng": 122.1156585,
    "color": "#dc3545"
}, {
    "nosamw": "0800621",
    "nama": "H19 FIAT NUSA",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220750,
    "total_denda": 20000,
    "total_jumlah": 240750,
    "lat": 0.5396934,
    "lng": 122.1015654,
    "color": "#fd7e14"
}, {
    "nosamw": "0800624",
    "nama": "H19 Halid Hasan",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 54000,
    "total_denda": 10000,
    "total_jumlah": 64000,
    "lat": 0.5464967,
    "lng": 122.1129378,
    "color": "#ffc107"
}, {
    "nosamw": "0800043",
    "nama": "H19 Hasan Salehe",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 62000,
    "total_denda": 10000,
    "total_jumlah": 72000,
    "lat": 0.545366,
    "lng": 122.1118118,
    "color": "#ffc107"
}, {
    "nosamw": "0800611",
    "nama": "H19 Marni Ibura",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 7958200,
    "total_denda": 110000,
    "total_jumlah": 8068200,
    "lat": 0.5591551,
    "lng": 122.1042429,
    "color": "#dc3545"
}, {
    "nosamw": "0800843",
    "nama": "H19 MARTIN USMAN",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 108400,
    "total_denda": 10000,
    "total_jumlah": 118400,
    "lat": 0.546232,
    "lng": 122.1124762,
    "color": "#ffc107"
}, {
    "nosamw": "0800880",
    "nama": "H19 SARIPA YUSUF",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1182900,
    "total_denda": 125000,
    "total_jumlah": 1307900,
    "lat": 0.551133,
    "lng": 122.1146857,
    "color": "#dc3545"
}, {
    "nosamw": "0800881",
    "nama": "H19 SARTIN KUE",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 650200,
    "total_denda": 35000,
    "total_jumlah": 685200,
    "lat": 0.5491885,
    "lng": 122.1154348,
    "color": "#dc3545"
}, {
    "nosamw": "0800737",
    "nama": "H19 Selmi Abas",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 467000,
    "total_denda": 35000,
    "total_jumlah": 502000,
    "lat": 0.5463991,
    "lng": 122.1129382,
    "color": "#dc3545"
}, {
    "nosamw": "0800903",
    "nama": "H19 YAHYA KUMAJI",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 745800,
    "total_denda": 80000,
    "total_jumlah": 825800,
    "lat": 0.5513496,
    "lng": 122.1145585,
    "color": "#dc3545"
}, {
    "nosamw": "0800986",
    "nama": "HADIJA ISHAK",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 854000,
    "total_denda": 130000,
    "total_jumlah": 984000,
    "lat": 0.5591553,
    "lng": 122.1042428,
    "color": "#dc3545"
}, {
    "nosamw": "0800098",
    "nama": "Hayati Salehe",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 937500,
    "total_denda": 25000,
    "total_jumlah": 962500,
    "lat": 0.5450468,
    "lng": 122.112063,
    "color": "#fd7e14"
}, {
    "nosamw": "0800277",
    "nama": "Ibrahim Hamzah",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 894200,
    "total_denda": 125000,
    "total_jumlah": 1019200,
    "lat": 0.5502487,
    "lng": 122.1048845,
    "color": "#dc3545"
}, {
    "nosamw": "0801002",
    "nama": "JAIMA MAGALAENG",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 2261500,
    "total_denda": 135000,
    "total_jumlah": 2396500,
    "lat": 0.5619856,
    "lng": 122.1139917,
    "color": "#dc3545"
}, {
    "nosamw": "0801008",
    "nama": "Karim Harun",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1787000,
    "total_denda": 60000,
    "total_jumlah": 1847000,
    "lat": 0.5564384,
    "lng": 122.1095158,
    "color": "#dc3545"
}, {
    "nosamw": "0800280",
    "nama": "Karman Masigi",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1156000,
    "total_denda": 130000,
    "total_jumlah": 1286000,
    "lat": 0.5501928,
    "lng": 122.1049017,
    "color": "#dc3545"
}, {
    "nosamw": "0800997",
    "nama": "MUKLIS MAWALI",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1220400,
    "total_denda": 130000,
    "total_jumlah": 1350400,
    "lat": 0.5620238,
    "lng": 122.113982,
    "color": "#dc3545"
}, {
    "nosamw": "0800072",
    "nama": "Muntriwan Mohamad",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 266600,
    "total_denda": 25000,
    "total_jumlah": 291600,
    "lat": 0.5459874,
    "lng": 122.1120513,
    "color": "#fd7e14"
}, {
    "nosamw": "0800041",
    "nama": "Noldi Kiraman",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 246200,
    "total_denda": 25000,
    "total_jumlah": 271200,
    "lat": 0.5452751,
    "lng": 122.1117906,
    "color": "#fd7e14"
}, {
    "nosamw": "0800285",
    "nama": "Poni Masigi",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 968600,
    "total_denda": 110000,
    "total_jumlah": 1078600,
    "lat": 0.5528329,
    "lng": 122.1072912,
    "color": "#dc3545"
}, {
    "nosamw": "0800552",
    "nama": "Pulu Abdullah",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "082292523710",
    "total_bulan": 20,
    "total_tagihan": 740600,
    "total_denda": 100000,
    "total_jumlah": 840600,
    "lat": 0.4873672,
    "lng": 121.9352265,
    "color": "#dc3545"
}, {
    "nosamw": "0800993",
    "nama": "RAMADAN PIDO",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 4962900,
    "total_denda": 90000,
    "total_jumlah": 5052900,
    "lat": 0.5623768,
    "lng": 122.1141687,
    "color": "#dc3545"
}, {
    "nosamw": "0800998",
    "nama": "RONAL MILE",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 118500,
    "total_denda": 0,
    "total_jumlah": 118500,
    "lat": 0.551779,
    "lng": 122.110825,
    "color": "#ffc107"
}, {
    "nosamw": "0800042",
    "nama": "RUSNI LOLONTO",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 263000,
    "total_denda": 10000,
    "total_jumlah": 273000,
    "lat": 0.5564963,
    "lng": 122.1097177,
    "color": "#fd7e14"
}, {
    "nosamw": "0800386",
    "nama": "SAHADA NUSI",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.5330528,
    "lng": 122.0915534,
    "color": "#ffc107"
}, {
    "nosamw": "0800991",
    "nama": "SAHRUN MAIRE",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 2314100,
    "total_denda": 100000,
    "total_jumlah": 2414100,
    "lat": 0.5606959,
    "lng": 122.1134272,
    "color": "#dc3545"
}, {
    "nosamw": "0800100",
    "nama": "Saiful Hulinggi",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 405450,
    "total_denda": 15000,
    "total_jumlah": 420450,
    "lat": 0.5465835,
    "lng": 122.1129049,
    "color": "#fd7e14"
}, {
    "nosamw": "0801007",
    "nama": "SAPRUDIN MAIRE",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1581500,
    "total_denda": 30000,
    "total_jumlah": 1611500,
    "lat": 0.5628867,
    "lng": 122.1142848,
    "color": "#dc3545"
}, {
    "nosamw": "0800992",
    "nama": "Ulin Pakaya",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 178000,
    "total_denda": 30000,
    "total_jumlah": 208000,
    "lat": 0.449581,
    "lng": 121.941978,
    "color": "#fd7e14"
}, {
    "nosamw": "0800456",
    "nama": "Umar Salehe",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 263500,
    "total_denda": 20000,
    "total_jumlah": 283500,
    "lat": 0.5458979,
    "lng": 122.1120251,
    "color": "#fd7e14"
}, {
    "nosamw": "0800060",
    "nama": "Wisman Salehe",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85500,
    "total_denda": 0,
    "total_jumlah": 85500,
    "lat": 0.544964,
    "lng": 122.1121369,
    "color": "#ffc107"
}, {
    "nosamw": "0800205",
    "nama": "Yosias Yance Huru",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 12427000,
    "total_denda": 35000,
    "total_jumlah": 12462000,
    "lat": 0.545982,
    "lng": 122.1120382,
    "color": "#dc3545"
}, {
    "nosamw": "0801010",
    "nama": "YUSUP D IBRAHIM",
    "kecamatan": "KEC DENGILO DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 539500,
    "total_denda": 35000,
    "total_jumlah": 574500,
    "lat": 0.562899,
    "lng": 122.1154889,
    "color": "#dc3545"
}, {
    "nosamw": "0800006",
    "nama": " IWIN SUUDI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 587200,
    "total_denda": 85000,
    "total_jumlah": 672200,
    "lat": 0.5451404,
    "lng": 122.0912252,
    "color": "#dc3545"
}, {
    "nosamw": "0800095",
    "nama": " Rustam Mona",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 478000,
    "total_denda": 30000,
    "total_jumlah": 508000,
    "lat": 0.5341905,
    "lng": 122.0916232,
    "color": "#fd7e14"
}, {
    "nosamw": "0800132",
    "nama": "Alpian Detu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 252000,
    "total_denda": 40000,
    "total_jumlah": 292000,
    "lat": 0.5403233,
    "lng": 122.0892017,
    "color": "#dc3545"
}, {
    "nosamw": "0800096",
    "nama": "Aman Tuliabu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 204200,
    "total_denda": 25000,
    "total_jumlah": 229200,
    "lat": 0.545306,
    "lng": 122.0911264,
    "color": "#fd7e14"
}, {
    "nosamw": "0800014",
    "nama": "Asna Adam",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5459707,
    "lng": 122.0905159,
    "color": "#28a745"
}, {
    "nosamw": "0800025",
    "nama": "Asna Due",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 363600,
    "total_denda": 30000,
    "total_jumlah": 393600,
    "lat": 0.539572,
    "lng": 122.0889379,
    "color": "#fd7e14"
}, {
    "nosamw": "0800013",
    "nama": "ASNITA NUSI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 598000,
    "total_denda": 40000,
    "total_jumlah": 638000,
    "lat": 0.5394922,
    "lng": 122.0891735,
    "color": "#dc3545"
}, {
    "nosamw": "0800134",
    "nama": "Ayini Padunggala",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 882000,
    "total_denda": 90000,
    "total_jumlah": 972000,
    "lat": 0.5384201,
    "lng": 122.0899993,
    "color": "#dc3545"
}, {
    "nosamw": "0800146",
    "nama": "AYINI PADUNGGALA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 2562500,
    "total_denda": 5000,
    "total_jumlah": 2567500,
    "lat": 0.5399867,
    "lng": 122.0893257,
    "color": "#ffc107"
}, {
    "nosamw": "0800141",
    "nama": "BP3K Dengilo",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 485000,
    "total_denda": 20000,
    "total_jumlah": 505000,
    "lat": 0.5373067,
    "lng": 122.0909497,
    "color": "#ffc107"
}, {
    "nosamw": "0800135",
    "nama": "Cidra Saud",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082292523710",
    "total_bulan": 11,
    "total_tagihan": 1085350,
    "total_denda": 55000,
    "total_jumlah": 1140350,
    "lat": 0.5295777,
    "lng": 122.091289,
    "color": "#dc3545"
}, {
    "nosamw": "0800088",
    "nama": "Danial Husain",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1032400,
    "total_denda": 115000,
    "total_jumlah": 1147400,
    "lat": 0.5337785,
    "lng": 122.0915639,
    "color": "#dc3545"
}, {
    "nosamw": "0800592",
    "nama": "Ewin Mamu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5292327,
    "lng": 122.0914786,
    "color": "#ffc107"
}, {
    "nosamw": "0800153",
    "nama": "EWIN MAMU 2",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1476200,
    "total_denda": 130000,
    "total_jumlah": 1606200,
    "lat": 0.538575,
    "lng": 122.0903771,
    "color": "#dc3545"
}, {
    "nosamw": "0800056",
    "nama": "Fikal Mulane",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 445000,
    "total_denda": 25000,
    "total_jumlah": 470000,
    "lat": 0.5440104,
    "lng": 122.0891878,
    "color": "#fd7e14"
}, {
    "nosamw": "0800667",
    "nama": "H16 Amsir Angguti",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 420750,
    "total_denda": 35000,
    "total_jumlah": 455750,
    "lat": 0.5387325,
    "lng": 122.0890618,
    "color": "#dc3545"
}, {
    "nosamw": "0800716",
    "nama": "H16 ARIYANTO ABDULLAH",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1284800,
    "total_denda": 40000,
    "total_jumlah": 1324800,
    "lat": 0.5432284,
    "lng": 122.0890472,
    "color": "#dc3545"
}, {
    "nosamw": "0800661",
    "nama": "H16 Danial A. Muda",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 448000,
    "total_denda": 5000,
    "total_jumlah": 453000,
    "lat": 0.5271598,
    "lng": 122.0904332,
    "color": "#ffc107"
}, {
    "nosamw": "0800712",
    "nama": "H16 Herman Husain",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 539100,
    "total_denda": 55000,
    "total_jumlah": 594100,
    "lat": 0.53055,
    "lng": 122.0914489,
    "color": "#dc3545"
}, {
    "nosamw": "0800628",
    "nama": "H16 Imran Abas",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102000,
    "total_denda": 0,
    "total_jumlah": 102000,
    "lat": 0.5219371,
    "lng": 122.085319,
    "color": "#ffc107"
}, {
    "nosamw": "0800662",
    "nama": "H16 Ishak Datau",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1203250,
    "total_denda": 85000,
    "total_jumlah": 1288250,
    "lat": 0.540714,
    "lng": 122.0891403,
    "color": "#dc3545"
}, {
    "nosamw": "0800665",
    "nama": "H16 Jumu Detu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 628200,
    "total_denda": 15000,
    "total_jumlah": 643200,
    "lat": 0.5297167,
    "lng": 122.0911416,
    "color": "#fd7e14"
}, {
    "nosamw": "0800652",
    "nama": "H16 Kamarudin Igrisa",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 255200,
    "total_denda": 15000,
    "total_jumlah": 270200,
    "lat": 0.5204622,
    "lng": 122.0825312,
    "color": "#fd7e14"
}, {
    "nosamw": "0800643",
    "nama": "H16 Maryam Makmur",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5209039,
    "lng": 122.0836066,
    "color": "#fd7e14"
}, {
    "nosamw": "0800663",
    "nama": "H16 MURTI MURSALI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082292523710",
    "total_bulan": 10,
    "total_tagihan": 7692350,
    "total_denda": 50000,
    "total_jumlah": 7742350,
    "lat": 0.4873672,
    "lng": 121.9352265,
    "color": "#dc3545"
}, {
    "nosamw": "0800666",
    "nama": "H16 Nicon Biki",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 219300,
    "total_denda": 25000,
    "total_jumlah": 244300,
    "lat": 0.5300286,
    "lng": 122.0912109,
    "color": "#fd7e14"
}, {
    "nosamw": "0800719",
    "nama": "H16 Pance Hasan",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 594400,
    "total_denda": 75000,
    "total_jumlah": 669400,
    "lat": 0.5408907,
    "lng": 122.0889654,
    "color": "#dc3545"
}, {
    "nosamw": "0800629",
    "nama": "H16 Ramli Taliki",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5392516,
    "lng": 122.0891366,
    "color": "#28a745"
}, {
    "nosamw": "0800726",
    "nama": "H16 Saman L.  Hasan",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 268700,
    "total_denda": 5000,
    "total_jumlah": 273700,
    "lat": 0.5465337,
    "lng": 122.0876889,
    "color": "#ffc107"
}, {
    "nosamw": "0800715",
    "nama": "H16 Sin Hamid",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 336750,
    "total_denda": 20000,
    "total_jumlah": 356750,
    "lat": 0.5257978,
    "lng": 122.0893551,
    "color": "#fd7e14"
}, {
    "nosamw": "0800660",
    "nama": "H16 Usman Pakaya",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132400,
    "total_denda": 15000,
    "total_jumlah": 147400,
    "lat": 0.527277,
    "lng": 122.0905823,
    "color": "#fd7e14"
}, {
    "nosamw": "0800627",
    "nama": "H16 YANTI PAKAYA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1733200,
    "total_denda": 35000,
    "total_jumlah": 1768200,
    "lat": 0.5420983,
    "lng": 122.0888013,
    "color": "#dc3545"
}, {
    "nosamw": "0800713",
    "nama": "H16 Yunus Poliyama",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 600600,
    "total_denda": 25000,
    "total_jumlah": 625600,
    "lat": 0.5263389,
    "lng": 122.0892938,
    "color": "#fd7e14"
}, {
    "nosamw": "0800650",
    "nama": "H16 Yusdin Libunelo",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 314100,
    "total_denda": 20000,
    "total_jumlah": 334100,
    "lat": 0.5210942,
    "lng": 122.0849322,
    "color": "#fd7e14"
}, {
    "nosamw": "0800777",
    "nama": "H18 AHMAD PAKAYA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 321600,
    "total_denda": 20000,
    "total_jumlah": 341600,
    "lat": 0.523488,
    "lng": 122.0877566,
    "color": "#fd7e14"
}, {
    "nosamw": "0800933",
    "nama": "H18 ALIN POLIYAMA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5189142,
    "lng": 122.0802003,
    "color": "#fd7e14"
}, {
    "nosamw": "0800917",
    "nama": "H18 APRIUS GOMIS",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 481200,
    "total_denda": 50000,
    "total_jumlah": 531200,
    "lat": 0.5442675,
    "lng": 122.091032,
    "color": "#dc3545"
}, {
    "nosamw": "0800785",
    "nama": "H18 Arman Palaki",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 582150,
    "total_denda": 40000,
    "total_jumlah": 622150,
    "lat": 0.5445649,
    "lng": 122.0909164,
    "color": "#dc3545"
}, {
    "nosamw": "0800791",
    "nama": "H18 DANI MOHAMAD",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1370050,
    "total_denda": 30000,
    "total_jumlah": 1400050,
    "lat": 0.5404284,
    "lng": 122.0896875,
    "color": "#fd7e14"
}, {
    "nosamw": "0800792",
    "nama": "H18 DANIAL ADAM",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 15000,
    "total_jumlah": 120000,
    "lat": 0.544388,
    "lng": 122.0905556,
    "color": "#fd7e14"
}, {
    "nosamw": "0800793",
    "nama": "H18 DANIAL ARIF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 616400,
    "total_denda": 85000,
    "total_jumlah": 701400,
    "lat": 0.5445381,
    "lng": 122.0911309,
    "color": "#dc3545"
}, {
    "nosamw": "0800794",
    "nama": "H18 DINA BAWOLE",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 547000,
    "total_denda": 55000,
    "total_jumlah": 602000,
    "lat": 0.5444126,
    "lng": 122.0910584,
    "color": "#dc3545"
}, {
    "nosamw": "0800798",
    "nama": "H18 FATMA HASAN",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5460676,
    "lng": 122.0909711,
    "color": "#28a745"
}, {
    "nosamw": "0800804",
    "nama": "H18 FITRI BATURAPA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1002000,
    "total_denda": 80000,
    "total_jumlah": 1082000,
    "lat": 0.5448581,
    "lng": 122.0912411,
    "color": "#dc3545"
}, {
    "nosamw": "0800801",
    "nama": "H18 GIHAM BAKU",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 20000,
    "total_jumlah": 195000,
    "lat": 0.5213389,
    "lng": 122.0837947,
    "color": "#fd7e14"
}, {
    "nosamw": "0800803",
    "nama": "H18 HADIJA ALBAKIR",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 419400,
    "total_denda": 25000,
    "total_jumlah": 444400,
    "lat": 0.522836,
    "lng": 122.0867454,
    "color": "#fd7e14"
}, {
    "nosamw": "0800852",
    "nama": "H18 HADIJA MAJADI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1442500,
    "total_denda": 25000,
    "total_jumlah": 1467500,
    "lat": 0.5391345,
    "lng": 122.0895138,
    "color": "#fd7e14"
}, {
    "nosamw": "0800808",
    "nama": "H18 HENDRIK THALIB",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5412158,
    "lng": 122.0890709,
    "color": "#28a745"
}, {
    "nosamw": "0800814",
    "nama": "H18 IDRUS RADJAK",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 38,
    "total_tagihan": 1566600,
    "total_denda": 185000,
    "total_jumlah": 1751600,
    "lat": 0.5245816,
    "lng": 122.1040809,
    "color": "#dc3545"
}, {
    "nosamw": "0800819",
    "nama": "H18 ISHAK POLIYAMA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 192000,
    "total_denda": 25000,
    "total_jumlah": 217000,
    "lat": 0.5186877,
    "lng": 122.0801592,
    "color": "#fd7e14"
}, {
    "nosamw": "0800822",
    "nama": "H18 IWAN AKE",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 439100,
    "total_denda": 40000,
    "total_jumlah": 479100,
    "lat": 0.5183475,
    "lng": 122.0803483,
    "color": "#dc3545"
}, {
    "nosamw": "0800824",
    "nama": "H18 JEFRI IBRAHIM",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 191000,
    "total_denda": 15000,
    "total_jumlah": 206000,
    "lat": 0.5458692,
    "lng": 122.0900213,
    "color": "#fd7e14"
}, {
    "nosamw": "0800828",
    "nama": "H18 JULHAM YUSUF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 82800,
    "total_denda": 10000,
    "total_jumlah": 92800,
    "lat": 0.5460473,
    "lng": 122.0906333,
    "color": "#ffc107"
}, {
    "nosamw": "0800831",
    "nama": "H18 KARIM LATIF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 670600,
    "total_denda": 35000,
    "total_jumlah": 705600,
    "lat": 0.5443973,
    "lng": 122.0906912,
    "color": "#dc3545"
}, {
    "nosamw": "0800832",
    "nama": "H18 KARIM MAKO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 211600,
    "total_denda": 20000,
    "total_jumlah": 231600,
    "lat": 0.5460771,
    "lng": 122.0907105,
    "color": "#fd7e14"
}, {
    "nosamw": "0800919",
    "nama": "H18 KASMAT LAHILOTE",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 375000,
    "total_denda": 20000,
    "total_jumlah": 395000,
    "lat": 0.5435562,
    "lng": 122.0893692,
    "color": "#fd7e14"
}, {
    "nosamw": "0800837",
    "nama": "H18 LENDRA MOPUTI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 162000,
    "total_denda": 10000,
    "total_jumlah": 172000,
    "lat": 0.5257051,
    "lng": 122.0892823,
    "color": "#fd7e14"
}, {
    "nosamw": "0800840",
    "nama": "H18 LISNAWATI BANGI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 300600,
    "total_denda": 15000,
    "total_jumlah": 315600,
    "lat": 0.5460633,
    "lng": 122.0897057,
    "color": "#fd7e14"
}, {
    "nosamw": "0800842",
    "nama": "H18 MANTIK ABAS",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1725500,
    "total_denda": 65000,
    "total_jumlah": 1790500,
    "lat": 0.5208319,
    "lng": 122.0833962,
    "color": "#dc3545"
}, {
    "nosamw": "0800847",
    "nama": "H18 MARLINA POLIAMA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 71500,
    "total_denda": 0,
    "total_jumlah": 71500,
    "lat": 0.5264698,
    "lng": 122.0891527,
    "color": "#ffc107"
}, {
    "nosamw": "0800873",
    "nama": "H18 MARSANDA DAKO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.5329682,
    "lng": 122.0914766,
    "color": "#fd7e14"
}, {
    "nosamw": "0800848",
    "nama": "H18 MASRIN K. HULU",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 151000,
    "total_denda": 20000,
    "total_jumlah": 171000,
    "lat": 0.5207999,
    "lng": 122.0847144,
    "color": "#fd7e14"
}, {
    "nosamw": "0800899",
    "nama": "H18 MERLU EMENGO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2604650,
    "total_denda": 100000,
    "total_jumlah": 2704650,
    "lat": 0.5453781,
    "lng": 122.0914291,
    "color": "#dc3545"
}, {
    "nosamw": "0800845",
    "nama": "H18 NOVITA MAWALI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1452550,
    "total_denda": 60000,
    "total_jumlah": 1512550,
    "lat": 0.5412641,
    "lng": 122.0890531,
    "color": "#dc3545"
}, {
    "nosamw": "0800913",
    "nama": "H18 Rahman Badi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 250200,
    "total_denda": 35000,
    "total_jumlah": 285200,
    "lat": 0.5442704,
    "lng": 122.0910002,
    "color": "#dc3545"
}, {
    "nosamw": "0800841",
    "nama": "H18 RAHMAN MULANE",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 263500,
    "total_denda": 20000,
    "total_jumlah": 283500,
    "lat": 0.5435793,
    "lng": 122.0894291,
    "color": "#fd7e14"
}, {
    "nosamw": "0800860",
    "nama": "H18 RAHMAN YUSUF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2440000,
    "total_denda": 25000,
    "total_jumlah": 2465000,
    "lat": 0.5419657,
    "lng": 122.0889692,
    "color": "#fd7e14"
}, {
    "nosamw": "0800861",
    "nama": "H18 RANTI NUSI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44000,
    "total_denda": 0,
    "total_jumlah": 44000,
    "lat": 0.5465344,
    "lng": 122.0876563,
    "color": "#ffc107"
}, {
    "nosamw": "0800862",
    "nama": "H18 RATNI DUNGGIO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 502000,
    "total_denda": 25000,
    "total_jumlah": 527000,
    "lat": 0.5356606,
    "lng": 122.090968,
    "color": "#fd7e14"
}, {
    "nosamw": "0800867",
    "nama": "H18 RITA HAMZAH",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 144800,
    "total_denda": 20000,
    "total_jumlah": 164800,
    "lat": 0.5245416,
    "lng": 122.0884248,
    "color": "#fd7e14"
}, {
    "nosamw": "0800906",
    "nama": "H18 SRI YANTI HASAN",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1057800,
    "total_denda": 45000,
    "total_jumlah": 1102800,
    "lat": 0.5396808,
    "lng": 122.0891086,
    "color": "#dc3545"
}, {
    "nosamw": "0800787",
    "nama": "H18 SUNDARI LAHAMBU",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 213300,
    "total_denda": 5000,
    "total_jumlah": 218300,
    "lat": 0.5286125,
    "lng": 122.0916402,
    "color": "#ffc107"
}, {
    "nosamw": "0800904",
    "nama": "H18 YAKOP HASAN",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 717100,
    "total_denda": 25000,
    "total_jumlah": 742100,
    "lat": 0.5260279,
    "lng": 122.089608,
    "color": "#fd7e14"
}, {
    "nosamw": "0800093",
    "nama": "H19 Agustin Padunggala",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 27000,
    "total_denda": 5000,
    "total_jumlah": 32000,
    "lat": 0.5392922,
    "lng": 122.0892543,
    "color": "#ffc107"
}, {
    "nosamw": "0800773",
    "nama": "H19 Anwar N Jaona",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 983000,
    "total_denda": 150000,
    "total_jumlah": 1133000,
    "lat": 0.5453128,
    "lng": 122.0911182,
    "color": "#dc3545"
}, {
    "nosamw": "0800735",
    "nama": "H19 ASMA YUNUS",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1263900,
    "total_denda": 85000,
    "total_jumlah": 1348900,
    "lat": 0.5450486,
    "lng": 122.091178,
    "color": "#dc3545"
}, {
    "nosamw": "0800981",
    "nama": "H19 ESTEVANUS KALESING",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 2036000,
    "total_denda": 165000,
    "total_jumlah": 2201000,
    "lat": 0.5454057,
    "lng": 122.0914018,
    "color": "#dc3545"
}, {
    "nosamw": "0800075",
    "nama": "H19 Fitriyadi Rahman",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.5285044,
    "lng": 122.0914146,
    "color": "#fd7e14"
}, {
    "nosamw": "0800038",
    "nama": "H19 HASRIYANTI POLIYAMA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 126500,
    "total_denda": 5000,
    "total_jumlah": 131500,
    "lat": 0.536563,
    "lng": 122.0917689,
    "color": "#ffc107"
}, {
    "nosamw": "0800952",
    "nama": "H19 ISMAIL KUMAY",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1290400,
    "total_denda": 125000,
    "total_jumlah": 1415400,
    "lat": 0.5451115,
    "lng": 122.0912304,
    "color": "#dc3545"
}, {
    "nosamw": "0800764",
    "nama": "H19 JAMALIA ABAS",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 554400,
    "total_denda": 65000,
    "total_jumlah": 619400,
    "lat": 0.5456248,
    "lng": 122.0912949,
    "color": "#dc3545"
}, {
    "nosamw": "0800765",
    "nama": "H19 Jamila Buloto",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 165000,
    "total_denda": 25000,
    "total_jumlah": 190000,
    "lat": 0.5451935,
    "lng": 122.0910141,
    "color": "#fd7e14"
}, {
    "nosamw": "0800744",
    "nama": "H19 Kasmad Detu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 1255800,
    "total_denda": 155000,
    "total_jumlah": 1410800,
    "lat": 0.5448751,
    "lng": 122.0909575,
    "color": "#dc3545"
}, {
    "nosamw": "0800047",
    "nama": "H19 Lindrawati Rahim",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 320000,
    "total_denda": 45000,
    "total_jumlah": 365000,
    "lat": 0.5396991,
    "lng": 122.0889587,
    "color": "#dc3545"
}, {
    "nosamw": "0800063",
    "nama": "H19 Maryam Paramata",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 539400,
    "total_denda": 30000,
    "total_jumlah": 569400,
    "lat": 0.5435377,
    "lng": 122.0892304,
    "color": "#fd7e14"
}, {
    "nosamw": "0800934",
    "nama": "H19 NUNE TINELO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 203200,
    "total_denda": 20000,
    "total_jumlah": 223200,
    "lat": 0.5445269,
    "lng": 122.091127,
    "color": "#fd7e14"
}, {
    "nosamw": "0800935",
    "nama": "H19 RAJIN LATIF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 127000,
    "total_denda": 15000,
    "total_jumlah": 142000,
    "lat": 0.5443396,
    "lng": 122.090676,
    "color": "#fd7e14"
}, {
    "nosamw": "0800733",
    "nama": "H19 Ratna Abdullah",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 990600,
    "total_denda": 70000,
    "total_jumlah": 1060600,
    "lat": 0.5453908,
    "lng": 122.0911333,
    "color": "#dc3545"
}, {
    "nosamw": "0800731",
    "nama": "H19 Ratna Une",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 508800,
    "total_denda": 20000,
    "total_jumlah": 528800,
    "lat": 0.5438349,
    "lng": 122.0894072,
    "color": "#fd7e14"
}, {
    "nosamw": "0800734",
    "nama": "H19 Salju Biki",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 494000,
    "total_denda": 75000,
    "total_jumlah": 569000,
    "lat": 0.5451705,
    "lng": 122.0910193,
    "color": "#dc3545"
}, {
    "nosamw": "0800081",
    "nama": "H19 Sarlota Mambu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 849200,
    "total_denda": 35000,
    "total_jumlah": 884200,
    "lat": 0.531326,
    "lng": 122.0916623,
    "color": "#dc3545"
}, {
    "nosamw": "0800012",
    "nama": "H19 SASMITA JALIMU",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 141800,
    "total_denda": 15000,
    "total_jumlah": 156800,
    "lat": 0.53744,
    "lng": 122.0910862,
    "color": "#fd7e14"
}, {
    "nosamw": "0800732",
    "nama": "H19 Sasmita Saleh",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 206000,
    "total_denda": 30000,
    "total_jumlah": 236000,
    "lat": 0.5448797,
    "lng": 122.0910468,
    "color": "#fd7e14"
}, {
    "nosamw": "0800036",
    "nama": "H19 SELPI DANGO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 2437000,
    "total_denda": 35000,
    "total_jumlah": 2472000,
    "lat": 0.5189165,
    "lng": 122.0801403,
    "color": "#dc3545"
}, {
    "nosamw": "0800741",
    "nama": "H19 Suleman Maudi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 526600,
    "total_denda": 35000,
    "total_jumlah": 561600,
    "lat": 0.5393513,
    "lng": 122.0888756,
    "color": "#dc3545"
}, {
    "nosamw": "0800071",
    "nama": "H19 Uyun Laiya",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 527400,
    "total_denda": 50000,
    "total_jumlah": 577400,
    "lat": 0.5434841,
    "lng": 122.0886439,
    "color": "#dc3545"
}, {
    "nosamw": "0800752",
    "nama": "H19 Yunus Amiri",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 387400,
    "total_denda": 35000,
    "total_jumlah": 422400,
    "lat": 0.5448613,
    "lng": 122.0910021,
    "color": "#dc3545"
}, {
    "nosamw": "0800954",
    "nama": "H19 YUSUF AGANA",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 146200,
    "total_denda": 25000,
    "total_jumlah": 171200,
    "lat": 0.544867,
    "lng": 122.0909702,
    "color": "#fd7e14"
}, {
    "nosamw": "0800070",
    "nama": "HADIJA YUSUF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 79600,
    "total_denda": 10000,
    "total_jumlah": 89600,
    "lat": 0.5458581,
    "lng": 122.0901598,
    "color": "#ffc107"
}, {
    "nosamw": "0800142",
    "nama": "Hajara Salehe",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 4508400,
    "total_denda": 135000,
    "total_jumlah": 4643400,
    "lat": 0.5021715,
    "lng": 122.0714209,
    "color": "#dc3545"
}, {
    "nosamw": "0800438",
    "nama": "Hariyanto Kumay",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 240200,
    "total_denda": 20000,
    "total_jumlah": 260200,
    "lat": 0.5451596,
    "lng": 122.0910141,
    "color": "#fd7e14"
}, {
    "nosamw": "0801028",
    "nama": "HASNA MAKO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 15000,
    "total_jumlah": 120000,
    "lat": 0.5401665,
    "lng": 122.0893767,
    "color": "#fd7e14"
}, {
    "nosamw": "0800021",
    "nama": "Herman Puluhulawa",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2848500,
    "total_denda": 70000,
    "total_jumlah": 2918500,
    "lat": 0.5213968,
    "lng": 122.0837994,
    "color": "#dc3545"
}, {
    "nosamw": "0800296",
    "nama": "Idrus Kango ",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1424800,
    "total_denda": 75000,
    "total_jumlah": 1499800,
    "lat": 0.5396237,
    "lng": 122.0890142,
    "color": "#dc3545"
}, {
    "nosamw": "0800039",
    "nama": "Imran Harun",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 174850,
    "total_denda": 15000,
    "total_jumlah": 189850,
    "lat": 0.5209634,
    "lng": 122.0838433,
    "color": "#fd7e14"
}, {
    "nosamw": "0800566",
    "nama": "Ismail Lahilote",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5430989,
    "lng": 122.0892084,
    "color": "#ffc107"
}, {
    "nosamw": "0800387",
    "nama": "Ismail Mamu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 951800,
    "total_denda": 55000,
    "total_jumlah": 1006800,
    "lat": 0.5187474,
    "lng": 122.0800829,
    "color": "#dc3545"
}, {
    "nosamw": "0800586",
    "nama": "ISNA ANGGUTI",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 563600,
    "total_denda": 40000,
    "total_jumlah": 603600,
    "lat": 0.5427175,
    "lng": 122.088963,
    "color": "#dc3545"
}, {
    "nosamw": "0800278",
    "nama": "Iwan Dolongseda",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 502500,
    "total_denda": 25000,
    "total_jumlah": 527500,
    "lat": 0.5223259,
    "lng": 122.0850027,
    "color": "#fd7e14"
}, {
    "nosamw": "0800078",
    "nama": "Iyam Albakir",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 682500,
    "total_denda": 10000,
    "total_jumlah": 692500,
    "lat": 0.529093,
    "lng": 122.092099,
    "color": "#ffc107"
}, {
    "nosamw": "0800169",
    "nama": "Kadir Yunus",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 311500,
    "total_denda": 20000,
    "total_jumlah": 331500,
    "lat": 0.540876,
    "lng": 122.0891464,
    "color": "#fd7e14"
}, {
    "nosamw": "0800064",
    "nama": "Karim Madu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 75000,
    "total_denda": 5000,
    "total_jumlah": 80000,
    "lat": 0.5442212,
    "lng": 122.0923249,
    "color": "#ffc107"
}, {
    "nosamw": "0800076",
    "nama": "KARTIN KANGO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 614000,
    "total_denda": 55000,
    "total_jumlah": 669000,
    "lat": 0.5398665,
    "lng": 122.0891936,
    "color": "#dc3545"
}, {
    "nosamw": "0800298",
    "nama": "Ktr Camat Dengilo",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 3335000,
    "total_denda": 65000,
    "total_jumlah": 3400000,
    "lat": 0.5364261,
    "lng": 122.0909886,
    "color": "#fd7e14"
}, {
    "nosamw": "0800871",
    "nama": "KUA Dengilo",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 205000,
    "total_denda": 20000,
    "total_jumlah": 225000,
    "lat": 0.532614,
    "lng": 122.0917013,
    "color": "#ffc107"
}, {
    "nosamw": "0800576",
    "nama": "Latipa Adam",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 281600,
    "total_denda": 20000,
    "total_jumlah": 301600,
    "lat": 0.5463294,
    "lng": 122.0910271,
    "color": "#fd7e14"
}, {
    "nosamw": "0800217",
    "nama": "Mansur Ismail",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2397200,
    "total_denda": 25000,
    "total_jumlah": 2422200,
    "lat": 0.5392188,
    "lng": 122.0890951,
    "color": "#fd7e14"
}, {
    "nosamw": "0800152",
    "nama": "Martin Padunggala",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 610200,
    "total_denda": 90000,
    "total_jumlah": 700200,
    "lat": 0.5021715,
    "lng": 122.0714209,
    "color": "#dc3545"
}, {
    "nosamw": "0800023",
    "nama": "Maryam Basir",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.539685,
    "lng": 122.0888974,
    "color": "#fd7e14"
}, {
    "nosamw": "0800180",
    "nama": "MARYAM KADIR",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 138250,
    "total_denda": 10000,
    "total_jumlah": 148250,
    "lat": 0.451493,
    "lng": 121.937886,
    "color": "#fd7e14"
}, {
    "nosamw": "0800572",
    "nama": "MASPA DJAPAR",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 240600,
    "total_denda": 25000,
    "total_jumlah": 265600,
    "lat": 0.546072,
    "lng": 122.089725,
    "color": "#fd7e14"
}, {
    "nosamw": "0800069",
    "nama": "Max Basiru",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 145200,
    "total_denda": 20000,
    "total_jumlah": 165200,
    "lat": 0.5236249,
    "lng": 122.0878225,
    "color": "#fd7e14"
}, {
    "nosamw": "0800079",
    "nama": "Mazhar Busura",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 845500,
    "total_denda": 15000,
    "total_jumlah": 860500,
    "lat": 0.5346174,
    "lng": 122.0915096,
    "color": "#fd7e14"
}, {
    "nosamw": "0800003",
    "nama": "Melky Buli ide",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 20000,
    "total_jumlah": 160000,
    "lat": 0.5301106,
    "lng": 122.0912454,
    "color": "#fd7e14"
}, {
    "nosamw": "0800507",
    "nama": "Mey Ake",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 320600,
    "total_denda": 30000,
    "total_jumlah": 350600,
    "lat": 0.5218228,
    "lng": 122.085141,
    "color": "#dc3545"
}, {
    "nosamw": "0800155",
    "nama": "Murtin Maudi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 250000,
    "total_denda": 35000,
    "total_jumlah": 285000,
    "lat": 0.5403536,
    "lng": 122.0891463,
    "color": "#dc3545"
}, {
    "nosamw": "0800156",
    "nama": "Nani Nusi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 630400,
    "total_denda": 65000,
    "total_jumlah": 695400,
    "lat": 0.5302771,
    "lng": 122.0912728,
    "color": "#dc3545"
}, {
    "nosamw": "0800080",
    "nama": "Nasir Dunggio",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 470000,
    "total_denda": 45000,
    "total_jumlah": 515000,
    "lat": 0.5346706,
    "lng": 122.0915865,
    "color": "#dc3545"
}, {
    "nosamw": "0800264",
    "nama": "Nintu Panti Mohamad",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1384500,
    "total_denda": 100000,
    "total_jumlah": 1484500,
    "lat": 0.5318976,
    "lng": 122.091918,
    "color": "#dc3545"
}, {
    "nosamw": "0800091",
    "nama": "Nisa Mohamad",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 319000,
    "total_denda": 30000,
    "total_jumlah": 349000,
    "lat": 0.5358358,
    "lng": 122.0907929,
    "color": "#fd7e14"
}, {
    "nosamw": "0800582",
    "nama": "Noki Sahmalia",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 703850,
    "total_denda": 25000,
    "total_jumlah": 728850,
    "lat": 0.5459898,
    "lng": 122.0899956,
    "color": "#fd7e14"
}, {
    "nosamw": "0800588",
    "nama": "Norma Halada",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 558000,
    "total_denda": 85000,
    "total_jumlah": 643000,
    "lat": 0.5292852,
    "lng": 122.0914407,
    "color": "#dc3545"
}, {
    "nosamw": "0800157",
    "nama": "Oku Buloto",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1632000,
    "total_denda": 135000,
    "total_jumlah": 1767000,
    "lat": 0.529401,
    "lng": 122.0911799,
    "color": "#dc3545"
}, {
    "nosamw": "0800168",
    "nama": "Onu Abas",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 20000,
    "total_jumlah": 160000,
    "lat": 0.5423548,
    "lng": 122.0890209,
    "color": "#fd7e14"
}, {
    "nosamw": "0800833",
    "nama": "Puskesmas Dengilo II",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "PP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1512500,
    "total_denda": 10000,
    "total_jumlah": 1522500,
    "lat": 0.5365417,
    "lng": 122.0910524,
    "color": "#fd7e14"
}, {
    "nosamw": "0800018",
    "nama": "Rahman Abdullah",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 95600,
    "total_denda": 10000,
    "total_jumlah": 105600,
    "lat": 0.5460891,
    "lng": 122.0907127,
    "color": "#ffc107"
}, {
    "nosamw": "0800033",
    "nama": "RD Puskes",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1275500,
    "total_denda": 20000,
    "total_jumlah": 1295500,
    "lat": 0.5358568,
    "lng": 122.0908999,
    "color": "#fd7e14"
}, {
    "nosamw": "0800092",
    "nama": "RD. Puskes 2",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 282500,
    "total_denda": 10000,
    "total_jumlah": 292500,
    "lat": 0.5364506,
    "lng": 122.0910403,
    "color": "#fd7e14"
}, {
    "nosamw": "0801022",
    "nama": "RINTO KANGO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 6,
    "total_tagihan": 2812800,
    "total_denda": 30000,
    "total_jumlah": 2842800,
    "lat": 0.5407926,
    "lng": 122.0892391,
    "color": "#fd7e14"
}, {
    "nosamw": "0801026",
    "nama": "RISAL ADAM",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259931919",
    "total_bulan": 5,
    "total_tagihan": 1283200,
    "total_denda": 20000,
    "total_jumlah": 1303200,
    "lat": 0.5388643,
    "lng": 122.0903157,
    "color": "#fd7e14"
}, {
    "nosamw": "0800048",
    "nama": "Rivon Rauf",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.5221264,
    "lng": 122.0856388,
    "color": "#ffc107"
}, {
    "nosamw": "0801009",
    "nama": "Ronaldo Y. Putirulang\/ Komunal",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2272000,
    "total_denda": 125000,
    "total_jumlah": 2397000,
    "lat": 0.5450476,
    "lng": 122.0913513,
    "color": "#dc3545"
}, {
    "nosamw": "0800161",
    "nama": "Salimi Nusi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 285000,
    "total_denda": 45000,
    "total_jumlah": 330000,
    "lat": 0.5300396,
    "lng": 122.0912008,
    "color": "#dc3545"
}, {
    "nosamw": "0800017",
    "nama": "SALMA HAMID",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 3095000,
    "total_denda": 25000,
    "total_jumlah": 3120000,
    "lat": 0.5399594,
    "lng": 122.0893176,
    "color": "#fd7e14"
}, {
    "nosamw": "0800151",
    "nama": "SALMA LATIF",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3109200,
    "total_denda": 40000,
    "total_jumlah": 3149200,
    "lat": 0.529339,
    "lng": 122.0913493,
    "color": "#dc3545"
}, {
    "nosamw": "0800567",
    "nama": "Sarco Detu",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 423100,
    "total_denda": 15000,
    "total_jumlah": 438100,
    "lat": 0.5388509,
    "lng": 122.0904914,
    "color": "#fd7e14"
}, {
    "nosamw": "0800618",
    "nama": "Saripa Une",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 732200,
    "total_denda": 70000,
    "total_jumlah": 802200,
    "lat": 0.5457396,
    "lng": 122.091651,
    "color": "#dc3545"
}, {
    "nosamw": "0800162",
    "nama": "Sarmada Palilati",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5402453,
    "lng": 122.0894023,
    "color": "#ffc107"
}, {
    "nosamw": "0800163",
    "nama": "Sarman Albakir",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 480500,
    "total_denda": 45000,
    "total_jumlah": 525500,
    "lat": 0.5290782,
    "lng": 122.0920491,
    "color": "#dc3545"
}, {
    "nosamw": "0800164",
    "nama": "Selmi Saud",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 865000,
    "total_denda": 10000,
    "total_jumlah": 875000,
    "lat": 0.5300397,
    "lng": 122.0912281,
    "color": "#ffc107"
}, {
    "nosamw": "0800229",
    "nama": "SMK Dengilo",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1440600,
    "total_denda": 10000,
    "total_jumlah": 1450600,
    "lat": 0.5226162,
    "lng": 122.0847701,
    "color": "#ffc107"
}, {
    "nosamw": "0800594",
    "nama": "Sofyan Latif",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 956600,
    "total_denda": 120000,
    "total_jumlah": 1076600,
    "lat": 0.5448942,
    "lng": 122.0910383,
    "color": "#dc3545"
}, {
    "nosamw": "0800252",
    "nama": "Sofyan Nusi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.5422713,
    "lng": 122.0888,
    "color": "#fd7e14"
}, {
    "nosamw": "0800568",
    "nama": "Umar Nusi",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 153600,
    "total_denda": 10000,
    "total_jumlah": 163600,
    "lat": 0.5422055,
    "lng": 122.0889163,
    "color": "#ffc107"
}, {
    "nosamw": "0800553",
    "nama": "Usman Abas",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 209200,
    "total_denda": 25000,
    "total_jumlah": 234200,
    "lat": 0.5224098,
    "lng": 122.086492,
    "color": "#fd7e14"
}, {
    "nosamw": "0800565",
    "nama": "Wahab Lahilote",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085880298139",
    "total_bulan": 7,
    "total_tagihan": 991200,
    "total_denda": 35000,
    "total_jumlah": 1026200,
    "lat": 0.5431651,
    "lng": 122.0892367,
    "color": "#dc3545"
}, {
    "nosamw": "0800166",
    "nama": "Wasri Saud",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 207950,
    "total_denda": 25000,
    "total_jumlah": 232950,
    "lat": 0.5290972,
    "lng": 122.0916712,
    "color": "#fd7e14"
}, {
    "nosamw": "0800090",
    "nama": "Wisno Mangga",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 323000,
    "total_denda": 50000,
    "total_jumlah": 373000,
    "lat": 0.5359021,
    "lng": 122.0909648,
    "color": "#dc3545"
}, {
    "nosamw": "0800441",
    "nama": "Yakob Djuma",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 917000,
    "total_denda": 120000,
    "total_jumlah": 1037000,
    "lat": 0.5454117,
    "lng": 122.0913616,
    "color": "#dc3545"
}, {
    "nosamw": "0800746",
    "nama": "YAYASAN MDK DENGILO",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1374400,
    "total_denda": 75000,
    "total_jumlah": 1449400,
    "lat": 0.5365523,
    "lng": 122.0911472,
    "color": "#dc3545"
}, {
    "nosamw": "0800167",
    "nama": "Yusuf Mako",
    "kecamatan": "KEC DENGILO DESA POPAYA",
    "desa": "POPAYA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5389393,
    "lng": 122.0895544,
    "color": "#28a745"
}, {
    "nosamw": "1004424",
    "nama": " Mesjid Bulili Pohuwato \/ Parni Tangahu 3",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4000,
    "total_denda": 5000,
    "total_jumlah": 9000,
    "lat": 0.4485791,
    "lng": 121.9328862,
    "color": "#ffc107"
}, {
    "nosamw": "1007389",
    "nama": "ABD. RAHMAN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 481500,
    "total_denda": 25000,
    "total_jumlah": 506500,
    "lat": 0.453234,
    "lng": 121.9274811,
    "color": "#fd7e14"
}, {
    "nosamw": "1004300",
    "nama": "Abdurahman Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1004500,
    "total_denda": 30000,
    "total_jumlah": 1034500,
    "lat": 0.4673447,
    "lng": 121.9313395,
    "color": "#fd7e14"
}, {
    "nosamw": "1002700",
    "nama": "AGUS",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 162000,
    "total_denda": 5000,
    "total_jumlah": 167000,
    "lat": 0.462755,
    "lng": 121.9308947,
    "color": "#ffc107"
}, {
    "nosamw": "1000563",
    "nama": "AGUSTIAN MOHI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 428800,
    "total_denda": 55000,
    "total_jumlah": 483800,
    "lat": 0.4699896,
    "lng": 121.9316162,
    "color": "#dc3545"
}, {
    "nosamw": "1002785",
    "nama": "Agustin Baruadi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 601000,
    "total_denda": 50000,
    "total_jumlah": 651000,
    "lat": 0.4472815,
    "lng": 121.9325838,
    "color": "#dc3545"
}, {
    "nosamw": "1001934",
    "nama": "AHMAD ISLAKHULKHOIR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 228500,
    "total_denda": 0,
    "total_jumlah": 228500,
    "lat": 0.4629239,
    "lng": 121.9308881,
    "color": "#ffc107"
}, {
    "nosamw": "1002627",
    "nama": "Ako Lahay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55400,
    "total_denda": 0,
    "total_jumlah": 55400,
    "lat": 0.4526792,
    "lng": 121.9253595,
    "color": "#ffc107"
}, {
    "nosamw": "1003499",
    "nama": "Alexander Giasi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 15000,
    "total_jumlah": 310000,
    "lat": 0.4448906,
    "lng": 121.9363584,
    "color": "#fd7e14"
}, {
    "nosamw": "1005554",
    "nama": "ALFIKAWATI KARNOTO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 425000,
    "total_denda": 60000,
    "total_jumlah": 485000,
    "lat": 0.4457562,
    "lng": 121.9360603,
    "color": "#dc3545"
}, {
    "nosamw": "1000705",
    "nama": "ALIATIN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4675288,
    "lng": 121.9308143,
    "color": "#ffc107"
}, {
    "nosamw": "1002608",
    "nama": "Alimin Paulu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 15000,
    "total_jumlah": 310000,
    "lat": 0.4456082,
    "lng": 121.9356168,
    "color": "#fd7e14"
}, {
    "nosamw": "1000692",
    "nama": "Amina Bahua",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4633827,
    "lng": 121.9295706,
    "color": "#dc3545"
}, {
    "nosamw": "1000990",
    "nama": "Amran Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4459899,
    "lng": 121.9349282,
    "color": "#28a745"
}, {
    "nosamw": "1000124",
    "nama": "Andi Arifai",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4482738,
    "lng": 121.9321631,
    "color": "#28a745"
}, {
    "nosamw": "1005582",
    "nama": "ANDI LAHAY",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2332600,
    "total_denda": 70000,
    "total_jumlah": 2402600,
    "lat": 0.4631634,
    "lng": 121.9299057,
    "color": "#dc3545"
}, {
    "nosamw": "1005010",
    "nama": "ANDRI ANTUKAI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39500,
    "total_denda": 0,
    "total_jumlah": 39500,
    "lat": 0.4535288,
    "lng": 121.9275125,
    "color": "#ffc107"
}, {
    "nosamw": "1006734",
    "nama": "Andris Malanua",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4639938,
    "lng": 121.9296188,
    "color": "#dc3545"
}, {
    "nosamw": "1004672",
    "nama": "Angki Lihawa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 96200,
    "total_denda": 10000,
    "total_jumlah": 106200,
    "lat": 0.4636619,
    "lng": 121.9299218,
    "color": "#fd7e14"
}, {
    "nosamw": "1002703",
    "nama": "Ani Halidu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1475800,
    "total_denda": 45000,
    "total_jumlah": 1520800,
    "lat": 0.4643278,
    "lng": 121.9299283,
    "color": "#dc3545"
}, {
    "nosamw": "1004903",
    "nama": "ANO BAHUWA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1142950,
    "total_denda": 75000,
    "total_jumlah": 1217950,
    "lat": 0.4474215,
    "lng": 121.9330404,
    "color": "#dc3545"
}, {
    "nosamw": "1001887",
    "nama": "Ano Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 381000,
    "total_denda": 40000,
    "total_jumlah": 421000,
    "lat": 0.4479484,
    "lng": 121.9324812,
    "color": "#dc3545"
}, {
    "nosamw": "1004377",
    "nama": "Anton Antulangi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 143200,
    "total_denda": 15000,
    "total_jumlah": 158200,
    "lat": 0.461306,
    "lng": 121.9303565,
    "color": "#fd7e14"
}, {
    "nosamw": "1004931",
    "nama": "ANWAR RAHMAN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 900000,
    "total_denda": 30000,
    "total_jumlah": 930000,
    "lat": 0.4630529,
    "lng": 121.9309522,
    "color": "#dc3545"
}, {
    "nosamw": "1004927",
    "nama": "ARDIN TULIABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 412000,
    "total_denda": 15000,
    "total_jumlah": 427000,
    "lat": 0.4471693,
    "lng": 121.9322996,
    "color": "#fd7e14"
}, {
    "nosamw": "1002636",
    "nama": "Arif Mohi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35800,
    "total_denda": 5000,
    "total_jumlah": 40800,
    "lat": 0.4445918,
    "lng": 121.936141,
    "color": "#ffc107"
}, {
    "nosamw": "1001174",
    "nama": "AS.AD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 195000,
    "total_denda": 0,
    "total_jumlah": 195000,
    "lat": 0.4613268,
    "lng": 121.9303514,
    "color": "#ffc107"
}, {
    "nosamw": "1002047",
    "nama": "Asia Maiji",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 178500,
    "total_denda": 5000,
    "total_jumlah": 183500,
    "lat": 0.445325,
    "lng": 121.9364896,
    "color": "#ffc107"
}, {
    "nosamw": "1005579",
    "nama": "ASMA BABUNGA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4630725,
    "lng": 121.9307459,
    "color": "#28a745"
}, {
    "nosamw": "1004982",
    "nama": "ATMAN SALUNI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1357150,
    "total_denda": 65000,
    "total_jumlah": 1422150,
    "lat": 0.4467857,
    "lng": 121.9366034,
    "color": "#dc3545"
}, {
    "nosamw": "1002715",
    "nama": "Aton Bahuwa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 405800,
    "total_denda": 25000,
    "total_jumlah": 430800,
    "lat": 0.4645801,
    "lng": 121.929485,
    "color": "#fd7e14"
}, {
    "nosamw": "1000695",
    "nama": "Azis Babunga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1244500,
    "total_denda": 100000,
    "total_jumlah": 1344500,
    "lat": 0.4624146,
    "lng": 121.9292491,
    "color": "#dc3545"
}, {
    "nosamw": "1003478",
    "nama": "Azis Babunga 2",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 277500,
    "total_denda": 0,
    "total_jumlah": 277500,
    "lat": 0.4624994,
    "lng": 121.9292359,
    "color": "#ffc107"
}, {
    "nosamw": "1004902",
    "nama": "BAMBANG K.",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 99500,
    "total_denda": 0,
    "total_jumlah": 99500,
    "lat": 0.4632603,
    "lng": 121.9315586,
    "color": "#ffc107"
}, {
    "nosamw": "1003477",
    "nama": "BAMBANG TRI WAHONO 4",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 120000,
    "total_denda": 10000,
    "total_jumlah": 130000,
    "lat": 0.4479194,
    "lng": 121.933216,
    "color": "#fd7e14"
}, {
    "nosamw": "1002662",
    "nama": "Bona Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 25000,
    "total_jumlah": 200000,
    "lat": 0.4455021,
    "lng": 121.9348591,
    "color": "#fd7e14"
}, {
    "nosamw": "1002327",
    "nama": "Buka Suma",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4467827,
    "lng": 121.9335047,
    "color": "#28a745"
}, {
    "nosamw": "1000997",
    "nama": "DANO KADIR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4468137,
    "lng": 121.9333478,
    "color": "#28a745"
}, {
    "nosamw": "1001175",
    "nama": "Darna Polumulo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.4612558,
    "lng": 121.9303592,
    "color": "#ffc107"
}, {
    "nosamw": "1005557",
    "nama": "DEWI IDJI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 229800,
    "total_denda": 5000,
    "total_jumlah": 234800,
    "lat": 0.4615154,
    "lng": 121.9326267,
    "color": "#ffc107"
}, {
    "nosamw": "1002579",
    "nama": "Dirman Hamid",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 226500,
    "total_denda": 20000,
    "total_jumlah": 246500,
    "lat": 0.4479414,
    "lng": 121.9325721,
    "color": "#fd7e14"
}, {
    "nosamw": "1002801",
    "nama": "Djabi Suma",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 234400,
    "total_denda": 25000,
    "total_jumlah": 259400,
    "lat": 0.460727,
    "lng": 121.9275623,
    "color": "#fd7e14"
}, {
    "nosamw": "1002529",
    "nama": "DJAFAR LAMUSI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 605000,
    "total_denda": 45000,
    "total_jumlah": 650000,
    "lat": 0.4631247,
    "lng": 121.9312436,
    "color": "#dc3545"
}, {
    "nosamw": "1002702",
    "nama": "Djafar Mopangga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 95800,
    "total_denda": 15000,
    "total_jumlah": 110800,
    "lat": 0.4642074,
    "lng": 121.9296383,
    "color": "#fd7e14"
}, {
    "nosamw": "1002942",
    "nama": "Djamaludin Pantatu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 251350,
    "total_denda": 10000,
    "total_jumlah": 261350,
    "lat": 0.4458521,
    "lng": 121.9366757,
    "color": "#ffc107"
}, {
    "nosamw": "1007464",
    "nama": "DJIBRAN BULONGGODU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085213723359",
    "total_bulan": 3,
    "total_tagihan": 301500,
    "total_denda": 10000,
    "total_jumlah": 311500,
    "lat": 0.4468599,
    "lng": 121.9334743,
    "color": "#fd7e14"
}, {
    "nosamw": "1001314",
    "nama": "Dolly Marjun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4450037,
    "lng": 121.9367105,
    "color": "#28a745"
}, {
    "nosamw": "1001634",
    "nama": "Dona Moobu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1523000,
    "total_denda": 125000,
    "total_jumlah": 1648000,
    "lat": 0.4452409,
    "lng": 121.9361056,
    "color": "#dc3545"
}, {
    "nosamw": "1004900",
    "nama": "EDI SUWARJO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 65000,
    "total_denda": 5000,
    "total_jumlah": 70000,
    "lat": 0.4631459,
    "lng": 121.9302089,
    "color": "#ffc107"
}, {
    "nosamw": "1004925",
    "nama": "ELAN TULIABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466191,
    "lng": 121.9337133,
    "color": "#28a745"
}, {
    "nosamw": "1004905",
    "nama": "EMAN ARSYAD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4474266,
    "lng": 121.932281,
    "color": "#dc3545"
}, {
    "nosamw": "1000960",
    "nama": "Eman Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.445478,
    "lng": 121.936171,
    "color": "#ffc107"
}, {
    "nosamw": "1003459",
    "nama": "Endi Tuliabu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 119200,
    "total_denda": 10000,
    "total_jumlah": 129200,
    "lat": 0.4460346,
    "lng": 121.9345553,
    "color": "#ffc107"
}, {
    "nosamw": "1002699",
    "nama": "Eno Halidu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.4644148,
    "lng": 121.9300559,
    "color": "#ffc107"
}, {
    "nosamw": "1003025",
    "nama": "Etris Abay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4459621,
    "lng": 121.9349747,
    "color": "#28a745"
}, {
    "nosamw": "1005563",
    "nama": "FAHMI ARSYAD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 175000,
    "total_denda": 5000,
    "total_jumlah": 180000,
    "lat": 0.4681214,
    "lng": 121.9284889,
    "color": "#ffc107"
}, {
    "nosamw": "1002693",
    "nama": "Fatma Dukalang",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 914600,
    "total_denda": 120000,
    "total_jumlah": 1034600,
    "lat": 0.4653425,
    "lng": 121.9304372,
    "color": "#dc3545"
}, {
    "nosamw": "1002075",
    "nama": "Fatmawaty Daud",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 90000,
    "total_denda": 5000,
    "total_jumlah": 95000,
    "lat": 0.4653913,
    "lng": 121.9323844,
    "color": "#ffc107"
}, {
    "nosamw": "1005351",
    "nama": "FATMAWATY LOPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4463267,
    "lng": 121.9360986,
    "color": "#ffc107"
}, {
    "nosamw": "1003824",
    "nama": "Fatria Samad",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.445999,
    "lng": 121.9358714,
    "color": "#ffc107"
}, {
    "nosamw": "1001086",
    "nama": "Fauzi Hunowu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 230000,
    "total_denda": 5000,
    "total_jumlah": 235000,
    "lat": 0.4652332,
    "lng": 121.9306763,
    "color": "#ffc107"
}, {
    "nosamw": "1003040",
    "nama": "Fentiwati Usman II",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466595,
    "lng": 121.9342491,
    "color": "#28a745"
}, {
    "nosamw": "1005019",
    "nama": "FERDIYANTO LIMONU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 10000,
    "total_denda": 0,
    "total_jumlah": 10000,
    "lat": 0.4676004,
    "lng": 121.9277796,
    "color": "#ffc107"
}, {
    "nosamw": "1002086",
    "nama": "Fikal Musa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 175000,
    "total_denda": 5000,
    "total_jumlah": 180000,
    "lat": 0.4652881,
    "lng": 121.9324776,
    "color": "#ffc107"
}, {
    "nosamw": "1005583",
    "nama": "FIKRAM LAHAY",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 126400,
    "total_denda": 15000,
    "total_jumlah": 141400,
    "lat": 0.4524288,
    "lng": 121.9252458,
    "color": "#fd7e14"
}, {
    "nosamw": "1005558",
    "nama": "FITRI BOTUTIHE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 655000,
    "total_denda": 30000,
    "total_jumlah": 685000,
    "lat": 0.4475439,
    "lng": 121.9326341,
    "color": "#fd7e14"
}, {
    "nosamw": "1002044",
    "nama": "Fitri Gani",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.4457933,
    "lng": 121.9360575,
    "color": "#ffc107"
}, {
    "nosamw": "1002687",
    "nama": "FITRI HANAPI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 550000,
    "total_denda": 20000,
    "total_jumlah": 570000,
    "lat": 0.4532176,
    "lng": 121.9274801,
    "color": "#fd7e14"
}, {
    "nosamw": "1002701",
    "nama": "Fred Nagaring",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49250,
    "total_denda": 5000,
    "total_jumlah": 54250,
    "lat": 0.4645884,
    "lng": 121.9298904,
    "color": "#ffc107"
}, {
    "nosamw": "1002943",
    "nama": "Gafar Aune",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1545600,
    "total_denda": 130000,
    "total_jumlah": 1675600,
    "lat": 0.4631776,
    "lng": 121.9298924,
    "color": "#dc3545"
}, {
    "nosamw": "1000962",
    "nama": "Golo Maleo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4447432,
    "lng": 121.9366941,
    "color": "#28a745"
}, {
    "nosamw": "1004911",
    "nama": "GUNTUR SUNATI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 334000,
    "total_denda": 15000,
    "total_jumlah": 349000,
    "lat": 0.4454821,
    "lng": 121.9361586,
    "color": "#fd7e14"
}, {
    "nosamw": "1006589",
    "nama": "H18 LIKMAN BOTUTIHE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4636217,
    "lng": 121.9293618,
    "color": "#28a745"
}, {
    "nosamw": "1006797",
    "nama": "H19 ALIM MOPANGGA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 107250,
    "total_denda": 5000,
    "total_jumlah": 112250,
    "lat": 0.4531805,
    "lng": 121.9274801,
    "color": "#ffc107"
}, {
    "nosamw": "1006755",
    "nama": "H19 AZAN BIKI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4474943,
    "lng": 121.9329928,
    "color": "#ffc107"
}, {
    "nosamw": "1006775",
    "nama": "H19 EPI HIMARI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4445372,
    "lng": 121.9360964,
    "color": "#28a745"
}, {
    "nosamw": "1006798",
    "nama": "H19 IDFAR PATILIMA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1074500,
    "total_denda": 95000,
    "total_jumlah": 1169500,
    "lat": 0.4612018,
    "lng": 121.930268,
    "color": "#dc3545"
}, {
    "nosamw": "1006774",
    "nama": "H19 ISKANDAR SALUNI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 878600,
    "total_denda": 70000,
    "total_jumlah": 948600,
    "lat": 0.4466802,
    "lng": 121.9366109,
    "color": "#dc3545"
}, {
    "nosamw": "1006770",
    "nama": "H19 IYON AYULA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 171800,
    "total_denda": 10000,
    "total_jumlah": 181800,
    "lat": 0.4467494,
    "lng": 121.9366042,
    "color": "#fd7e14"
}, {
    "nosamw": "1006759",
    "nama": "H19 KARMILA TULIABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.4467753,
    "lng": 121.9335296,
    "color": "#ffc107"
}, {
    "nosamw": "1006769",
    "nama": "H19 LELI HADUDU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 457000,
    "total_denda": 15000,
    "total_jumlah": 472000,
    "lat": 0.4531133,
    "lng": 121.9274903,
    "color": "#fd7e14"
}, {
    "nosamw": "1006776",
    "nama": "H19 LELI TANI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 185200,
    "total_denda": 20000,
    "total_jumlah": 205200,
    "lat": 0.4460834,
    "lng": 121.9340697,
    "color": "#fd7e14"
}, {
    "nosamw": "1006773",
    "nama": "H19 LIA IDJI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 424500,
    "total_denda": 25000,
    "total_jumlah": 449500,
    "lat": 0.4446873,
    "lng": 121.9361802,
    "color": "#fd7e14"
}, {
    "nosamw": "1006781",
    "nama": "H19 MISNA LATIF",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 851000,
    "total_denda": 45000,
    "total_jumlah": 896000,
    "lat": 0.4456002,
    "lng": 121.9356908,
    "color": "#dc3545"
}, {
    "nosamw": "1006777",
    "nama": "H19 RAHMAN ADAM",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132000,
    "total_denda": 20000,
    "total_jumlah": 152000,
    "lat": 0.4455744,
    "lng": 121.9351938,
    "color": "#fd7e14"
}, {
    "nosamw": "1006779",
    "nama": "H19 RASID ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 71000,
    "total_denda": 10000,
    "total_jumlah": 81000,
    "lat": 0.4467189,
    "lng": 121.9366187,
    "color": "#fd7e14"
}, {
    "nosamw": "1006778",
    "nama": "H19 RUSMIN DARISE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 156600,
    "total_denda": 20000,
    "total_jumlah": 176600,
    "lat": 0.4470992,
    "lng": 121.9327057,
    "color": "#fd7e14"
}, {
    "nosamw": "1006796",
    "nama": "H19 SUMARDI POLUMUDUYO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 112000,
    "total_denda": 5000,
    "total_jumlah": 117000,
    "lat": 0.4677184,
    "lng": 121.9294698,
    "color": "#ffc107"
}, {
    "nosamw": "1006786",
    "nama": "H19 SUNANDAR NOHO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 160000,
    "total_denda": 10000,
    "total_jumlah": 170000,
    "lat": 0.4532294,
    "lng": 121.9274724,
    "color": "#fd7e14"
}, {
    "nosamw": "1006753",
    "nama": "H19 SUTRISNO HARUNA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.447613,
    "lng": 121.9326205,
    "color": "#ffc107"
}, {
    "nosamw": "1006758",
    "nama": "H19 YAHYA MOUKO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 289500,
    "total_denda": 5000,
    "total_jumlah": 294500,
    "lat": 0.4634392,
    "lng": 121.9294306,
    "color": "#ffc107"
}, {
    "nosamw": "1006784",
    "nama": "H19 YUNUS SUKOLI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4653911,
    "lng": 121.9323998,
    "color": "#ffc107"
}, {
    "nosamw": "1005559",
    "nama": "HABI LOPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4481919,
    "lng": 121.9332452,
    "color": "#ffc107"
}, {
    "nosamw": "1007473",
    "nama": "HADI SANTOSO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "087788107034",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.4479528,
    "lng": 121.9324991,
    "color": "#ffc107"
}, {
    "nosamw": "1004983",
    "nama": "HADIJA MUSA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 228500,
    "total_denda": 15000,
    "total_jumlah": 243500,
    "lat": 0.4447519,
    "lng": 121.9360514,
    "color": "#fd7e14"
}, {
    "nosamw": "1002680",
    "nama": "Hadris Bahuwa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 41400,
    "total_denda": 0,
    "total_jumlah": 41400,
    "lat": 0.4669908,
    "lng": 121.9328365,
    "color": "#ffc107"
}, {
    "nosamw": "1000072",
    "nama": "Hamsa Bahuwa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 462000,
    "total_denda": 65000,
    "total_jumlah": 527000,
    "lat": 0.4462428,
    "lng": 121.9348323,
    "color": "#dc3545"
}, {
    "nosamw": "1000606",
    "nama": "Hamsir Bagu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.4632647,
    "lng": 121.9294417,
    "color": "#ffc107"
}, {
    "nosamw": "1002154",
    "nama": "Hapi Moigo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 233500,
    "total_denda": 10000,
    "total_jumlah": 243500,
    "lat": 0.4461822,
    "lng": 121.9356717,
    "color": "#ffc107"
}, {
    "nosamw": "1001087",
    "nama": "HARTATI PAPEO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 275000,
    "total_denda": 5000,
    "total_jumlah": 280000,
    "lat": 0.4457715,
    "lng": 121.9360561,
    "color": "#ffc107"
}, {
    "nosamw": "1002823",
    "nama": "Harun Karim",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 47000,
    "total_denda": 0,
    "total_jumlah": 47000,
    "lat": 0.4614491,
    "lng": 121.9308882,
    "color": "#ffc107"
}, {
    "nosamw": "1002878",
    "nama": "Hasan Bula",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 349500,
    "total_denda": 25000,
    "total_jumlah": 374500,
    "lat": 0.4532222,
    "lng": 121.9274786,
    "color": "#fd7e14"
}, {
    "nosamw": "1003044",
    "nama": "Hasanudin Arbie",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4541813,
    "lng": 121.9263193,
    "color": "#ffc107"
}, {
    "nosamw": "1004921",
    "nama": "HASI KADILI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 736750,
    "total_denda": 30000,
    "total_jumlah": 766750,
    "lat": 0.4461295,
    "lng": 121.9356523,
    "color": "#fd7e14"
}, {
    "nosamw": "1003666",
    "nama": "Hasna Puyi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2461000,
    "total_denda": 95000,
    "total_jumlah": 2556000,
    "lat": 0.4679077,
    "lng": 121.9262218,
    "color": "#dc3545"
}, {
    "nosamw": "1001193",
    "nama": "Hasna Walangadi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 360000,
    "total_denda": 30000,
    "total_jumlah": 390000,
    "lat": 0.4613204,
    "lng": 121.9303139,
    "color": "#dc3545"
}, {
    "nosamw": "1001638",
    "nama": "Hendrik Melangi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4448109,
    "lng": 121.9365054,
    "color": "#28a745"
}, {
    "nosamw": "1002159",
    "nama": "Herlina Une",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1059000,
    "total_denda": 45000,
    "total_jumlah": 1104000,
    "lat": 0.4486409,
    "lng": 121.932821,
    "color": "#dc3545"
}, {
    "nosamw": "1002635",
    "nama": "Herman Taib",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 179600,
    "total_denda": 20000,
    "total_jumlah": 199600,
    "lat": 0.4449248,
    "lng": 121.936082,
    "color": "#fd7e14"
}, {
    "nosamw": "1000693",
    "nama": "Hesti Baginda.II",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 3861000,
    "total_denda": 85000,
    "total_jumlah": 3946000,
    "lat": 0.4590493,
    "lng": 121.9281262,
    "color": "#dc3545"
}, {
    "nosamw": "1001159",
    "nama": "Husain Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66500,
    "total_denda": 0,
    "total_jumlah": 66500,
    "lat": 0.4615844,
    "lng": 121.9292831,
    "color": "#ffc107"
}, {
    "nosamw": "1000045",
    "nama": "Husain Lasantu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1110000,
    "total_denda": 100000,
    "total_jumlah": 1210000,
    "lat": 0.4674547,
    "lng": 121.9320598,
    "color": "#dc3545"
}, {
    "nosamw": "1007470",
    "nama": "IBRAHIM HUSIN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "081526022281",
    "total_bulan": 3,
    "total_tagihan": 87000,
    "total_denda": 10000,
    "total_jumlah": 97000,
    "lat": 0.4534281,
    "lng": 121.9274909,
    "color": "#fd7e14"
}, {
    "nosamw": "1000994",
    "nama": "Ibrahim Mapiyone",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4458248,
    "lng": 121.9351751,
    "color": "#28a745"
}, {
    "nosamw": "1005378",
    "nama": "Idris Lasimpala",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466899,
    "lng": 121.9354953,
    "color": "#28a745"
}, {
    "nosamw": "1000215",
    "nama": "Ikbal Hunow",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1430000,
    "total_denda": 35000,
    "total_jumlah": 1465000,
    "lat": 0.4676058,
    "lng": 121.9304524,
    "color": "#dc3545"
}, {
    "nosamw": "1002092",
    "nama": "Iko Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.4453542,
    "lng": 121.9369874,
    "color": "#ffc107"
}, {
    "nosamw": "1004744",
    "nama": "IMRAN IBRAHIM",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 62000,
    "total_denda": 0,
    "total_jumlah": 62000,
    "lat": 0.4613459,
    "lng": 121.9305408,
    "color": "#ffc107"
}, {
    "nosamw": "1002610",
    "nama": "INANG YANJO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4450815,
    "lng": 121.9354666,
    "color": "#ffc107"
}, {
    "nosamw": "1007362",
    "nama": "INJI SUMA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085298831785",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4518298,
    "lng": 121.9301183,
    "color": "#ffc107"
}, {
    "nosamw": "1002583",
    "nama": "Insan Abay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 233500,
    "total_denda": 10000,
    "total_jumlah": 243500,
    "lat": 0.4460109,
    "lng": 121.934577,
    "color": "#ffc107"
}, {
    "nosamw": "1002492",
    "nama": "Ira Pakaya",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.4676421,
    "lng": 121.9309158,
    "color": "#ffc107"
}, {
    "nosamw": "1001691",
    "nama": "Irfan Ismail 2",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1146000,
    "total_denda": 30000,
    "total_jumlah": 1176000,
    "lat": 0.4584176,
    "lng": 121.9279546,
    "color": "#dc3545"
}, {
    "nosamw": "1002858",
    "nama": "Irwan Mopangga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 260500,
    "total_denda": 25000,
    "total_jumlah": 285500,
    "lat": 0.4645319,
    "lng": 121.928657,
    "color": "#fd7e14"
}, {
    "nosamw": "1002730",
    "nama": "IWAN ABAY",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1199000,
    "total_denda": 100000,
    "total_jumlah": 1299000,
    "lat": 0.4476897,
    "lng": 121.9324222,
    "color": "#dc3545"
}, {
    "nosamw": "1002187",
    "nama": "Iwan Babunga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1393500,
    "total_denda": 20000,
    "total_jumlah": 1413500,
    "lat": 0.4629208,
    "lng": 121.9308373,
    "color": "#fd7e14"
}, {
    "nosamw": "1001077",
    "nama": "Iwan Dango",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 548000,
    "total_denda": 30000,
    "total_jumlah": 578000,
    "lat": 0.464351,
    "lng": 121.9299293,
    "color": "#fd7e14"
}, {
    "nosamw": "1001318",
    "nama": "Iyan Marjun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4453979,
    "lng": 121.9370948,
    "color": "#28a745"
}, {
    "nosamw": "1000881",
    "nama": "Jafrin Bagu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 437500,
    "total_denda": 10000,
    "total_jumlah": 447500,
    "lat": 0.4643654,
    "lng": 121.9299951,
    "color": "#ffc107"
}, {
    "nosamw": "1002968",
    "nama": "Jasni Bague",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4454943,
    "lng": 121.9379761,
    "color": "#ffc107"
}, {
    "nosamw": "1004608",
    "nama": "Jefri Hanafi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4489966,
    "lng": 121.9317788,
    "color": "#28a745"
}, {
    "nosamw": "1002461",
    "nama": "Juhuria Kokalo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4460129,
    "lng": 121.9348588,
    "color": "#28a745"
}, {
    "nosamw": "1007570",
    "nama": "JUSRIN LANGGAIBA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085242990885",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4467506,
    "lng": 121.9335192,
    "color": "#28a745"
}, {
    "nosamw": "1005561",
    "nama": "KADIR ABJUL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 593000,
    "total_denda": 50000,
    "total_jumlah": 643000,
    "lat": 0.447717,
    "lng": 121.9322688,
    "color": "#dc3545"
}, {
    "nosamw": "1003315",
    "nama": "KAMA BASIRU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 414450,
    "total_denda": 15000,
    "total_jumlah": 429450,
    "lat": 0.4643417,
    "lng": 121.9296583,
    "color": "#fd7e14"
}, {
    "nosamw": "1002037",
    "nama": "Kardia Lahay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 74400,
    "total_denda": 5000,
    "total_jumlah": 79400,
    "lat": 0.4524925,
    "lng": 121.9258225,
    "color": "#ffc107"
}, {
    "nosamw": "1002879",
    "nama": "Karsum Ishak",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 102400,
    "total_denda": 5000,
    "total_jumlah": 107400,
    "lat": 0.4645197,
    "lng": 121.9287882,
    "color": "#ffc107"
}, {
    "nosamw": "1001774",
    "nama": "Kartin Luawo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1124500,
    "total_denda": 100000,
    "total_jumlah": 1224500,
    "lat": 0.4632227,
    "lng": 121.9298513,
    "color": "#dc3545"
}, {
    "nosamw": "1005079",
    "nama": "KASIM BAHUA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 186000,
    "total_denda": 5000,
    "total_jumlah": 191000,
    "lat": 0.4646724,
    "lng": 121.9295273,
    "color": "#ffc107"
}, {
    "nosamw": "1002905",
    "nama": "Kasma Mopangga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 253000,
    "total_denda": 10000,
    "total_jumlah": 263000,
    "lat": 0.4646668,
    "lng": 121.929512,
    "color": "#ffc107"
}, {
    "nosamw": "1003658",
    "nama": "Kasman Sahi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1716000,
    "total_denda": 95000,
    "total_jumlah": 1811000,
    "lat": 0.4679268,
    "lng": 121.9278652,
    "color": "#dc3545"
}, {
    "nosamw": "1001776",
    "nama": "Kisman Basiru",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44000,
    "total_denda": 0,
    "total_jumlah": 44000,
    "lat": 0.4614563,
    "lng": 121.9307483,
    "color": "#ffc107"
}, {
    "nosamw": "1002822",
    "nama": "Kisman Bulonggodu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4614677,
    "lng": 121.9307407,
    "color": "#ffc107"
}, {
    "nosamw": "1002842",
    "nama": "Koha Habu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110800,
    "total_denda": 10000,
    "total_jumlah": 120800,
    "lat": 0.4447368,
    "lng": 121.936155,
    "color": "#ffc107"
}, {
    "nosamw": "1002950",
    "nama": "Krispandi Huko",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 668000,
    "total_denda": 25000,
    "total_jumlah": 693000,
    "lat": 0.453609,
    "lng": 121.927508,
    "color": "#fd7e14"
}, {
    "nosamw": "1004933",
    "nama": "KUSNAN MOHAMAD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 257500,
    "total_denda": 10000,
    "total_jumlah": 267500,
    "lat": 0.4603868,
    "lng": 121.928339,
    "color": "#fd7e14"
}, {
    "nosamw": "1000572",
    "nama": "Lasi Olii",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4636286,
    "lng": 121.9293661,
    "color": "#28a745"
}, {
    "nosamw": "1004986",
    "nama": "LENI MARJUN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111000,
    "total_denda": 5000,
    "total_jumlah": 116000,
    "lat": 0.4446647,
    "lng": 121.9358508,
    "color": "#ffc107"
}, {
    "nosamw": "1000791",
    "nama": "Lince Tantu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 713500,
    "total_denda": 30000,
    "total_jumlah": 743500,
    "lat": 0.4672742,
    "lng": 121.9312701,
    "color": "#fd7e14"
}, {
    "nosamw": "1004910",
    "nama": "LINDA PAULU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 119800,
    "total_denda": 5000,
    "total_jumlah": 124800,
    "lat": 0.4462907,
    "lng": 121.9340449,
    "color": "#ffc107"
}, {
    "nosamw": "1005565",
    "nama": "LINSE PALWENI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 910000,
    "total_denda": 135000,
    "total_jumlah": 1045000,
    "lat": 0.4449447,
    "lng": 121.9359842,
    "color": "#dc3545"
}, {
    "nosamw": "1002903",
    "nama": "Lis Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 300000,
    "total_denda": 0,
    "total_jumlah": 300000,
    "lat": 0.4595224,
    "lng": 121.9283659,
    "color": "#ffc107"
}, {
    "nosamw": "1002095",
    "nama": "Lisna Lahay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4632415,
    "lng": 121.9295434,
    "color": "#ffc107"
}, {
    "nosamw": "1001367",
    "nama": "Lotto Tangalayu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.4678342,
    "lng": 121.9291443,
    "color": "#ffc107"
}, {
    "nosamw": "1001000",
    "nama": "Ludin Pakaya",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4455335,
    "lng": 121.9359561,
    "color": "#28a745"
}, {
    "nosamw": "1004750",
    "nama": "LUKMAN ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4452194,
    "lng": 121.936206,
    "color": "#28a745"
}, {
    "nosamw": "1004674",
    "nama": "Lukman Olii",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4631441,
    "lng": 121.9313069,
    "color": "#ffc107"
}, {
    "nosamw": "1002581",
    "nama": "Lun N. Yanjo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 32000,
    "total_denda": 5000,
    "total_jumlah": 37000,
    "lat": 0.4462518,
    "lng": 121.9348381,
    "color": "#ffc107"
}, {
    "nosamw": "1002170",
    "nama": "Madi Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 482000,
    "total_denda": 20000,
    "total_jumlah": 502000,
    "lat": 0.4616648,
    "lng": 121.930706,
    "color": "#fd7e14"
}, {
    "nosamw": "1005584",
    "nama": "MANSUR LAHAY",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 14000,
    "total_denda": 0,
    "total_jumlah": 14000,
    "lat": 0.4525665,
    "lng": 121.9252536,
    "color": "#ffc107"
}, {
    "nosamw": "1005106",
    "nama": "MARDIA HALIDU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 250000,
    "total_denda": 35000,
    "total_jumlah": 285000,
    "lat": 0.464476,
    "lng": 121.9297658,
    "color": "#dc3545"
}, {
    "nosamw": "1003441",
    "nama": "Marhan Monoarfa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 5000,
    "total_jumlah": 85000,
    "lat": 0.4665442,
    "lng": 121.933131,
    "color": "#ffc107"
}, {
    "nosamw": "1005567",
    "nama": "MARIA SAMADE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4648332,
    "lng": 121.9332071,
    "color": "#ffc107"
}, {
    "nosamw": "1004676",
    "nama": "Marta Banto",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4444422,
    "lng": 121.9360663,
    "color": "#28a745"
}, {
    "nosamw": "1005111",
    "nama": "MARYAM ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 24600,
    "total_denda": 0,
    "total_jumlah": 24600,
    "lat": 0.4616462,
    "lng": 121.9307188,
    "color": "#ffc107"
}, {
    "nosamw": "1002383",
    "nama": "Mas Hasan",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4678595,
    "lng": 121.9262047,
    "color": "#ffc107"
}, {
    "nosamw": "1002705",
    "nama": "Mawin Dahiba",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.4653878,
    "lng": 121.9323999,
    "color": "#ffc107"
}, {
    "nosamw": "1002885",
    "nama": "Mba Sriwahyuni",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4631619,
    "lng": 121.9302158,
    "color": "#ffc107"
}, {
    "nosamw": "1002641",
    "nama": "Mei Hasan",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1528500,
    "total_denda": 120000,
    "total_jumlah": 1648500,
    "lat": 0.4599829,
    "lng": 121.9284274,
    "color": "#dc3545"
}, {
    "nosamw": "1000868",
    "nama": "Mesjid \/ Rustam Bagu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 32000,
    "total_denda": 35000,
    "total_jumlah": 67000,
    "lat": 0.4674089,
    "lng": 121.9313563,
    "color": "#dc3545"
}, {
    "nosamw": "1005482",
    "nama": "MESJID BULILI TANJUNG",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 95400,
    "total_denda": 70000,
    "total_jumlah": 165400,
    "lat": 0.4458865,
    "lng": 121.9360723,
    "color": "#dc3545"
}, {
    "nosamw": "1003316",
    "nama": "Mesjid Nurul Ikhsan",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 133200,
    "total_denda": 20000,
    "total_jumlah": 153200,
    "lat": 0.4618825,
    "lng": 121.9289276,
    "color": "#fd7e14"
}, {
    "nosamw": "1004162",
    "nama": "Meylan Hunowu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 90000,
    "total_denda": 5000,
    "total_jumlah": 95000,
    "lat": 0.4532146,
    "lng": 121.9274788,
    "color": "#ffc107"
}, {
    "nosamw": "1007392",
    "nama": "MEYLAN IBRAHIM",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 57500,
    "total_denda": 0,
    "total_jumlah": 57500,
    "lat": 0.4531473,
    "lng": 121.9274886,
    "color": "#ffc107"
}, {
    "nosamw": "1001611",
    "nama": "MIFTAHULJANA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 111500,
    "total_denda": 10000,
    "total_jumlah": 121500,
    "lat": 0.4533248,
    "lng": 121.927457,
    "color": "#fd7e14"
}, {
    "nosamw": "1002644",
    "nama": "Minarti Maidji",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4449027,
    "lng": 121.9358493,
    "color": "#28a745"
}, {
    "nosamw": "1001117",
    "nama": "Mis Mopangga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4634054,
    "lng": 121.9294317,
    "color": "#28a745"
}, {
    "nosamw": "1003484",
    "nama": "MIsran Abdullah",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.4617003,
    "lng": 121.9288377,
    "color": "#ffc107"
}, {
    "nosamw": "1002273",
    "nama": "Misran Mopangga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 265500,
    "total_denda": 20000,
    "total_jumlah": 285500,
    "lat": 0.4644939,
    "lng": 121.9291141,
    "color": "#fd7e14"
}, {
    "nosamw": "1005098",
    "nama": "MOH. SAHRIR LIHU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4481533,
    "lng": 121.9332491,
    "color": "#28a745"
}, {
    "nosamw": "1006353",
    "nama": "MOHAMAD FAIZIN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.466903,
    "lng": 121.9278774,
    "color": "#ffc107"
}, {
    "nosamw": "1003458",
    "nama": "Mudin Ali",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 85600,
    "total_denda": 10000,
    "total_jumlah": 95600,
    "lat": 0.4453674,
    "lng": 121.9347048,
    "color": "#ffc107"
}, {
    "nosamw": "1004920",
    "nama": "MUHAJIR ALHASNI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 50000,
    "total_jumlah": 605000,
    "lat": 0.444948,
    "lng": 121.9355628,
    "color": "#dc3545"
}, {
    "nosamw": "1005122",
    "nama": "MUHAMAD WIYANI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4646607,
    "lng": 121.9295096,
    "color": "#28a745"
}, {
    "nosamw": "1005628",
    "nama": "Mujrimin Husain",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 135000,
    "total_denda": 10000,
    "total_jumlah": 145000,
    "lat": 0.4590661,
    "lng": 121.928142,
    "color": "#fd7e14"
}, {
    "nosamw": "1002429",
    "nama": "Murtaji",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 230000,
    "total_denda": 5000,
    "total_jumlah": 235000,
    "lat": 0.4644166,
    "lng": 121.9301224,
    "color": "#ffc107"
}, {
    "nosamw": "1004926",
    "nama": "MURTIN TAMBE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4466576,
    "lng": 121.9366283,
    "color": "#ffc107"
}, {
    "nosamw": "1001902",
    "nama": "Murtin Tetu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 71000,
    "total_denda": 10000,
    "total_jumlah": 81000,
    "lat": 0.454331,
    "lng": 121.9263463,
    "color": "#fd7e14"
}, {
    "nosamw": "1002694",
    "nama": "Nani Maksun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 636500,
    "total_denda": 40000,
    "total_jumlah": 676500,
    "lat": 0.4642618,
    "lng": 121.9293237,
    "color": "#dc3545"
}, {
    "nosamw": "1007546",
    "nama": "NAWAF HUNOWU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085212607113",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4652226,
    "lng": 121.9303831,
    "color": "#28a745"
}, {
    "nosamw": "1005568",
    "nama": "NELI DALANGGO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 401000,
    "total_denda": 60000,
    "total_jumlah": 461000,
    "lat": 0.4447116,
    "lng": 121.9359602,
    "color": "#dc3545"
}, {
    "nosamw": "1002972",
    "nama": "NENA UMAR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 10000,
    "total_jumlah": 165500,
    "lat": 0.4486248,
    "lng": 121.9324827,
    "color": "#ffc107"
}, {
    "nosamw": "1005577",
    "nama": "NETI MURNIATI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4631506,
    "lng": 121.9312875,
    "color": "#ffc107"
}, {
    "nosamw": "1002094",
    "nama": "Niko Suma",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132000,
    "total_denda": 20000,
    "total_jumlah": 152000,
    "lat": 0.4449198,
    "lng": 121.9362799,
    "color": "#fd7e14"
}, {
    "nosamw": "1001633",
    "nama": "Nina Tangahu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4454378,
    "lng": 121.9360376,
    "color": "#28a745"
}, {
    "nosamw": "1002580",
    "nama": "Nona Bahuwa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 349500,
    "total_denda": 30000,
    "total_jumlah": 379500,
    "lat": 0.447692,
    "lng": 121.9322633,
    "color": "#fd7e14"
}, {
    "nosamw": "1007528",
    "nama": "NOOR USMAN ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082296598983",
    "total_bulan": 2,
    "total_tagihan": 105000,
    "total_denda": 5000,
    "total_jumlah": 110000,
    "lat": 0.4532282,
    "lng": 121.9274821,
    "color": "#ffc107"
}, {
    "nosamw": "1002513",
    "nama": "Norma Lasantu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.4471348,
    "lng": 121.9333721,
    "color": "#fd7e14"
}, {
    "nosamw": "1000977",
    "nama": "NORMA TAKI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 277000,
    "total_denda": 25000,
    "total_jumlah": 302000,
    "lat": 0.4461254,
    "lng": 121.9355142,
    "color": "#fd7e14"
}, {
    "nosamw": "1006501",
    "nama": "NOVANTI ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 201000,
    "total_denda": 5000,
    "total_jumlah": 206000,
    "lat": 0.4532187,
    "lng": 121.9274804,
    "color": "#ffc107"
}, {
    "nosamw": "1001011",
    "nama": "Nune Bahua",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4449736,
    "lng": 121.9359221,
    "color": "#fd7e14"
}, {
    "nosamw": "1002582",
    "nama": "NURAIN LAMAPA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082216967091",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4461459,
    "lng": 121.934355,
    "color": "#28a745"
}, {
    "nosamw": "1001473",
    "nama": "Nurdin Maa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1520500,
    "total_denda": 105000,
    "total_jumlah": 1625500,
    "lat": 0.4447679,
    "lng": 121.9365187,
    "color": "#dc3545"
}, {
    "nosamw": "1004625",
    "nama": "Nurhayati Sianu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 587200,
    "total_denda": 30000,
    "total_jumlah": 617200,
    "lat": 0.447481,
    "lng": 121.9389499,
    "color": "#fd7e14"
}, {
    "nosamw": "1005566",
    "nama": "OJE MOPUTI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 200800,
    "total_denda": 30000,
    "total_jumlah": 230800,
    "lat": 0.446792,
    "lng": 121.9334254,
    "color": "#fd7e14"
}, {
    "nosamw": "1000478",
    "nama": "Oku Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 495000,
    "total_denda": 70000,
    "total_jumlah": 565000,
    "lat": 0.4678155,
    "lng": 121.930615,
    "color": "#dc3545"
}, {
    "nosamw": "1005570",
    "nama": "OKU OLII",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 581200,
    "total_denda": 35000,
    "total_jumlah": 616200,
    "lat": 0.4627532,
    "lng": 121.9331344,
    "color": "#dc3545"
}, {
    "nosamw": "1003110",
    "nama": "Oni Atiya",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.467738,
    "lng": 121.9306918,
    "color": "#ffc107"
}, {
    "nosamw": "1003573",
    "nama": "Oskar Babunga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44000,
    "total_denda": 0,
    "total_jumlah": 44000,
    "lat": 0.4616586,
    "lng": 121.929462,
    "color": "#ffc107"
}, {
    "nosamw": "1002871",
    "nama": "Oyan Suaiba",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 5000,
    "total_jumlah": 66500,
    "lat": 0.4657289,
    "lng": 121.9312872,
    "color": "#ffc107"
}, {
    "nosamw": "1005555",
    "nama": "OYIS BASO LASAMPE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 243250,
    "total_denda": 10000,
    "total_jumlah": 253250,
    "lat": 0.4481304,
    "lng": 121.9332683,
    "color": "#ffc107"
}, {
    "nosamw": "1002605",
    "nama": "Paris Lahay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 601400,
    "total_denda": 90000,
    "total_jumlah": 691400,
    "lat": 0.4453604,
    "lng": 121.9360946,
    "color": "#dc3545"
}, {
    "nosamw": "1001572",
    "nama": "Parman Kasim",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 5000,
    "total_jumlah": 73000,
    "lat": 0.460099,
    "lng": 121.940253,
    "color": "#ffc107"
}, {
    "nosamw": "1005114",
    "nama": "PELISKA TANTU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111400,
    "total_denda": 5000,
    "total_jumlah": 116400,
    "lat": 0.46525,
    "lng": 121.9307743,
    "color": "#ffc107"
}, {
    "nosamw": "1002869",
    "nama": "Priyadi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 239500,
    "total_denda": 15000,
    "total_jumlah": 254500,
    "lat": 0.467052,
    "lng": 121.9280985,
    "color": "#fd7e14"
}, {
    "nosamw": "1003456",
    "nama": "Pulu idji",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4445569,
    "lng": 121.9368665,
    "color": "#28a745"
}, {
    "nosamw": "1001228",
    "nama": "Purwanto",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4644921,
    "lng": 121.9297605,
    "color": "#28a745"
}, {
    "nosamw": "1002126",
    "nama": "Rahma Amana",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4476605,
    "lng": 121.9326084,
    "color": "#fd7e14"
}, {
    "nosamw": "1000786",
    "nama": "Raman Arsyad",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4625645,
    "lng": 121.929219,
    "color": "#ffc107"
}, {
    "nosamw": "1002873",
    "nama": "Ratna Djaane",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 5000,
    "total_jumlah": 79500,
    "lat": 0.4653503,
    "lng": 121.931144,
    "color": "#ffc107"
}, {
    "nosamw": "1002970",
    "nama": "Ratna Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 610500,
    "total_denda": 45000,
    "total_jumlah": 655500,
    "lat": 0.4477587,
    "lng": 121.9325609,
    "color": "#dc3545"
}, {
    "nosamw": "1007387",
    "nama": "RATNA TANTU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.4531554,
    "lng": 121.9274707,
    "color": "#ffc107"
}, {
    "nosamw": "1001606",
    "nama": "Rawin Katili",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465762,
    "lng": 121.9312734,
    "color": "#28a745"
}, {
    "nosamw": "1007403",
    "nama": "RENALDI R KASIM",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356223321",
    "total_bulan": 2,
    "total_tagihan": 310000,
    "total_denda": 5000,
    "total_jumlah": 315000,
    "lat": 0.4470002,
    "lng": 121.9354258,
    "color": "#ffc107"
}, {
    "nosamw": "1003393",
    "nama": "Rion Ibrahim",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 185000,
    "total_denda": 15000,
    "total_jumlah": 200000,
    "lat": 0.4626862,
    "lng": 121.9309413,
    "color": "#fd7e14"
}, {
    "nosamw": "1005573",
    "nama": "RISMAN HANAPI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4646053,
    "lng": 121.9299038,
    "color": "#28a745"
}, {
    "nosamw": "1000699",
    "nama": "Rita Babunga",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 106500,
    "total_denda": 0,
    "total_jumlah": 106500,
    "lat": 0.4607871,
    "lng": 121.9275788,
    "color": "#ffc107"
}, {
    "nosamw": "1004255",
    "nama": "Riwan Akuna",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4532217,
    "lng": 121.9274712,
    "color": "#ffc107"
}, {
    "nosamw": "1002757",
    "nama": "Rizal Hunowu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 665500,
    "total_denda": 30000,
    "total_jumlah": 695500,
    "lat": 0.462106,
    "lng": 121.929048,
    "color": "#dc3545"
}, {
    "nosamw": "1005311",
    "nama": "RN ABDULAH SAMAU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4460805,
    "lng": 121.9367245,
    "color": "#28a745"
}, {
    "nosamw": "1005335",
    "nama": "RN ADRIAN TARABA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4464577,
    "lng": 121.9363687,
    "color": "#ffc107"
}, {
    "nosamw": "1005344",
    "nama": "RN AMRAN ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4462274,
    "lng": 121.9363685,
    "color": "#28a745"
}, {
    "nosamw": "1005327",
    "nama": "RN AN MALEO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4464982,
    "lng": 121.9366354,
    "color": "#28a745"
}, {
    "nosamw": "1005315",
    "nama": "RN ANIS KATILI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446513,
    "lng": 121.9366208,
    "color": "#28a745"
}, {
    "nosamw": "1005341",
    "nama": "RN APRIYANTO DJAILANI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 5000,
    "total_jumlah": 79500,
    "lat": 0.446516,
    "lng": 121.9362655,
    "color": "#ffc107"
}, {
    "nosamw": "1005356",
    "nama": "RN ARDIN PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 397000,
    "total_denda": 25000,
    "total_jumlah": 422000,
    "lat": 0.4465139,
    "lng": 121.9358789,
    "color": "#fd7e14"
}, {
    "nosamw": "1005400",
    "nama": "RN ARMAN TULIYABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 149000,
    "total_denda": 5000,
    "total_jumlah": 154000,
    "lat": 0.4469586,
    "lng": 121.9350129,
    "color": "#ffc107"
}, {
    "nosamw": "1005407",
    "nama": "RN ASMIN PIKOLI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 631000,
    "total_denda": 40000,
    "total_jumlah": 671000,
    "lat": 0.447004,
    "lng": 121.9353543,
    "color": "#dc3545"
}, {
    "nosamw": "1005321",
    "nama": "RN ASNI LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 10000,
    "total_jumlah": 152500,
    "lat": 0.4460564,
    "lng": 121.9367545,
    "color": "#ffc107"
}, {
    "nosamw": "1005330",
    "nama": "RN ASPAN LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4459364,
    "lng": 121.9364755,
    "color": "#28a745"
}, {
    "nosamw": "1005380",
    "nama": "RN ASRIN  TULIYABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.446686,
    "lng": 121.9352367,
    "color": "#fd7e14"
}, {
    "nosamw": "1005405",
    "nama": "RN ASRIN PILOMALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 282000,
    "total_denda": 15000,
    "total_jumlah": 297000,
    "lat": 0.4470286,
    "lng": 121.9354074,
    "color": "#fd7e14"
}, {
    "nosamw": "1005377",
    "nama": "RN ASWIN HABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 594000,
    "total_denda": 5000,
    "total_jumlah": 599000,
    "lat": 0.4466796,
    "lng": 121.935521,
    "color": "#fd7e14"
}, {
    "nosamw": "1005328",
    "nama": "RN ATEN PAULU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 133000,
    "total_denda": 5000,
    "total_jumlah": 138000,
    "lat": 0.4465956,
    "lng": 121.936584,
    "color": "#ffc107"
}, {
    "nosamw": "1005354",
    "nama": "RN BUANG LASAMPE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 413000,
    "total_denda": 25000,
    "total_jumlah": 438000,
    "lat": 0.4465706,
    "lng": 121.9362092,
    "color": "#fd7e14"
}, {
    "nosamw": "1005375",
    "nama": "RN CICI MBUINGA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446534,
    "lng": 121.9358667,
    "color": "#28a745"
}, {
    "nosamw": "1005410",
    "nama": "RN CINDRA AMUNE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 953000,
    "total_denda": 5000,
    "total_jumlah": 958000,
    "lat": 0.4469467,
    "lng": 121.9349999,
    "color": "#dc3545"
}, {
    "nosamw": "1005340",
    "nama": "RN DAVID ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1985500,
    "total_denda": 80000,
    "total_jumlah": 2065500,
    "lat": 0.4465449,
    "lng": 121.9360737,
    "color": "#dc3545"
}, {
    "nosamw": "1005347",
    "nama": "RN ERWIN GOI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 454000,
    "total_denda": 20000,
    "total_jumlah": 474000,
    "lat": 0.4459225,
    "lng": 121.9364938,
    "color": "#fd7e14"
}, {
    "nosamw": "1005370",
    "nama": "RN FADILA ALHASNI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 220500,
    "total_denda": 10000,
    "total_jumlah": 230500,
    "lat": 0.446446,
    "lng": 121.9352683,
    "color": "#ffc107"
}, {
    "nosamw": "1005391",
    "nama": "RN FAHNI BARUADI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4466834,
    "lng": 121.9346747,
    "color": "#ffc107"
}, {
    "nosamw": "1005392",
    "nama": "RN FATMA BAHUWA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.4466811,
    "lng": 121.9348734,
    "color": "#ffc107"
}, {
    "nosamw": "1005332",
    "nama": "RN GRASELA MONTOLI\/ RANDO TALIB",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 10000,
    "total_jumlah": 152500,
    "lat": 0.4461908,
    "lng": 121.936375,
    "color": "#ffc107"
}, {
    "nosamw": "1005331",
    "nama": "RN GUSTI KADIR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4460604,
    "lng": 121.9364076,
    "color": "#fd7e14"
}, {
    "nosamw": "1005399",
    "nama": "RN HAMID LAGINTA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 442500,
    "total_denda": 25000,
    "total_jumlah": 467500,
    "lat": 0.4469617,
    "lng": 121.9351138,
    "color": "#fd7e14"
}, {
    "nosamw": "1005352",
    "nama": "RN HANAPI THALIB",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 720000,
    "total_denda": 65000,
    "total_jumlah": 785000,
    "lat": 0.4463349,
    "lng": 121.9360929,
    "color": "#dc3545"
}, {
    "nosamw": "1005368",
    "nama": "RN HASAN ABAY",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 184500,
    "total_denda": 15000,
    "total_jumlah": 199500,
    "lat": 0.446451,
    "lng": 121.9353084,
    "color": "#fd7e14"
}, {
    "nosamw": "1005343",
    "nama": "RN HERMAN ABDJUL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 692000,
    "total_denda": 40000,
    "total_jumlah": 732000,
    "lat": 0.4463105,
    "lng": 121.9363449,
    "color": "#dc3545"
}, {
    "nosamw": "1005312",
    "nama": "RN HUSIN LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 4002000,
    "total_denda": 110000,
    "total_jumlah": 4112000,
    "lat": 0.4873734,
    "lng": 121.9353432,
    "color": "#dc3545"
}, {
    "nosamw": "1005409",
    "nama": "RN IDRUS LAPATA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 269000,
    "total_denda": 10000,
    "total_jumlah": 279000,
    "lat": 0.4469708,
    "lng": 121.9350572,
    "color": "#fd7e14"
}, {
    "nosamw": "1005329",
    "nama": "RN ISNANTO RADJAK",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4459716,
    "lng": 121.9362473,
    "color": "#ffc107"
}, {
    "nosamw": "1005386",
    "nama": "RN ISRA KATILI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4466691,
    "lng": 121.9355283,
    "color": "#ffc107"
}, {
    "nosamw": "1005373",
    "nama": "RN JEFRI PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 661500,
    "total_denda": 30000,
    "total_jumlah": 691500,
    "lat": 0.4464269,
    "lng": 121.9349785,
    "color": "#fd7e14"
}, {
    "nosamw": "1005385",
    "nama": "RN KAHAR BARUADI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1589500,
    "total_denda": 70000,
    "total_jumlah": 1659500,
    "lat": 0.4466764,
    "lng": 121.9355335,
    "color": "#dc3545"
}, {
    "nosamw": "1005369",
    "nama": "RN KARTIN MAPIONE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 194500,
    "total_denda": 10000,
    "total_jumlah": 204500,
    "lat": 0.446442,
    "lng": 121.9352847,
    "color": "#ffc107"
}, {
    "nosamw": "1005396",
    "nama": "RN KISMAN ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 572000,
    "total_denda": 20000,
    "total_jumlah": 592000,
    "lat": 0.4470172,
    "lng": 121.9354183,
    "color": "#fd7e14"
}, {
    "nosamw": "1005320",
    "nama": "RN KOLO PANTATU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 856500,
    "total_denda": 65000,
    "total_jumlah": 921500,
    "lat": 0.4466934,
    "lng": 121.9366503,
    "color": "#dc3545"
}, {
    "nosamw": "1005374",
    "nama": "RN LI'I HANAPI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 282000,
    "total_denda": 15000,
    "total_jumlah": 297000,
    "lat": 0.4464245,
    "lng": 121.9349712,
    "color": "#fd7e14"
}, {
    "nosamw": "1005319",
    "nama": "RN LUKMAN IGIRISA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 5000,
    "total_jumlah": 66500,
    "lat": 0.4467391,
    "lng": 121.9366014,
    "color": "#ffc107"
}, {
    "nosamw": "1005367",
    "nama": "RN LUTEN MARJUN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.446469,
    "lng": 121.9355618,
    "color": "#ffc107"
}, {
    "nosamw": "1005359",
    "nama": "RN MARYON HANGGU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1088500,
    "total_denda": 40000,
    "total_jumlah": 1128500,
    "lat": 0.4459584,
    "lng": 121.9356678,
    "color": "#dc3545"
}, {
    "nosamw": "1005366",
    "nama": "RN MAYANG SARI BARUADI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 256000,
    "total_denda": 15000,
    "total_jumlah": 271000,
    "lat": 0.4464619,
    "lng": 121.9356115,
    "color": "#fd7e14"
}, {
    "nosamw": "1005348",
    "nama": "RN MEIKO PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 349500,
    "total_denda": 30000,
    "total_jumlah": 379500,
    "lat": 0.4459732,
    "lng": 121.9362388,
    "color": "#fd7e14"
}, {
    "nosamw": "1005338",
    "nama": "RN MENTARI BARUADI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 513500,
    "total_denda": 35000,
    "total_jumlah": 548500,
    "lat": 0.4466049,
    "lng": 121.936326,
    "color": "#dc3545"
}, {
    "nosamw": "1005398",
    "nama": "RN MISRA MOOPONU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4470139,
    "lng": 121.9352572,
    "color": "#ffc107"
}, {
    "nosamw": "1005353",
    "nama": "RN MOHAMAD MADU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4463662,
    "lng": 121.93603,
    "color": "#dc3545"
}, {
    "nosamw": "1005317",
    "nama": "RN MOMI IGIRISA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 548000,
    "total_denda": 25000,
    "total_jumlah": 573000,
    "lat": 0.4464417,
    "lng": 121.9366663,
    "color": "#fd7e14"
}, {
    "nosamw": "1005389",
    "nama": "RN NANI TULIYABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 126500,
    "total_denda": 5000,
    "total_jumlah": 131500,
    "lat": 0.4466823,
    "lng": 121.9352243,
    "color": "#ffc107"
}, {
    "nosamw": "1005358",
    "nama": "RN NARSEN TULEN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 271000,
    "total_denda": 20000,
    "total_jumlah": 291000,
    "lat": 0.4467752,
    "lng": 121.935687,
    "color": "#fd7e14"
}, {
    "nosamw": "1005362",
    "nama": "RN NOCI S. HALID",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 292000,
    "total_denda": 10000,
    "total_jumlah": 302000,
    "lat": 0.4464579,
    "lng": 121.9356089,
    "color": "#ffc107"
}, {
    "nosamw": "1005403",
    "nama": "RN NORMA LASANTU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4470163,
    "lng": 121.9354706,
    "color": "#28a745"
}, {
    "nosamw": "1005381",
    "nama": "RN NURDIN TULIYABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 434000,
    "total_denda": 30000,
    "total_jumlah": 464000,
    "lat": 0.4466529,
    "lng": 121.9353387,
    "color": "#fd7e14"
}, {
    "nosamw": "1005360",
    "nama": "RN OLWAN MAHMUD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1097000,
    "total_denda": 65000,
    "total_jumlah": 1162000,
    "lat": 0.4468113,
    "lng": 121.9356581,
    "color": "#dc3545"
}, {
    "nosamw": "1005334",
    "nama": "RN PIAN PATUE LAWANI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4462878,
    "lng": 121.9363613,
    "color": "#28a745"
}, {
    "nosamw": "1005364",
    "nama": "RN PILDA ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1133500,
    "total_denda": 50000,
    "total_jumlah": 1183500,
    "lat": 0.4464382,
    "lng": 121.9355083,
    "color": "#dc3545"
}, {
    "nosamw": "1005383",
    "nama": "RN RAHMAT PULUHULAWA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 535000,
    "total_denda": 25000,
    "total_jumlah": 560000,
    "lat": 0.44671,
    "lng": 121.934663,
    "color": "#fd7e14"
}, {
    "nosamw": "1005339",
    "nama": "RN RAMAN SULEMAN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4465434,
    "lng": 121.9362155,
    "color": "#dc3545"
}, {
    "nosamw": "1005402",
    "nama": "RN RIPAL UMAR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 311000,
    "total_denda": 20000,
    "total_jumlah": 331000,
    "lat": 0.4470025,
    "lng": 121.9355237,
    "color": "#fd7e14"
}, {
    "nosamw": "1005322",
    "nama": "RN RISI ALINTI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 583000,
    "total_denda": 30000,
    "total_jumlah": 613000,
    "lat": 0.4461181,
    "lng": 121.9367449,
    "color": "#fd7e14"
}, {
    "nosamw": "1005395",
    "nama": "RN SAIPUL MASIAGA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1266000,
    "total_denda": 75000,
    "total_jumlah": 1341000,
    "lat": 0.4470145,
    "lng": 121.9354199,
    "color": "#dc3545"
}, {
    "nosamw": "1005318",
    "nama": "RN SARIF SAID",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 301000,
    "total_denda": 25000,
    "total_jumlah": 326000,
    "lat": 0.4465758,
    "lng": 121.9366109,
    "color": "#fd7e14"
}, {
    "nosamw": "1005346",
    "nama": "RN SATRA BORMAN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 210500,
    "total_denda": 15000,
    "total_jumlah": 225500,
    "lat": 0.4460201,
    "lng": 121.9364218,
    "color": "#fd7e14"
}, {
    "nosamw": "1005404",
    "nama": "RN SAYIN LAKUMA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 360000,
    "total_denda": 15000,
    "total_jumlah": 375000,
    "lat": 0.4470275,
    "lng": 121.935403,
    "color": "#fd7e14"
}, {
    "nosamw": "1005379",
    "nama": "RN SISAN TULIYABU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4466845,
    "lng": 121.9353776,
    "color": "#ffc107"
}, {
    "nosamw": "1005387",
    "nama": "RN SRI YANTI MARJUN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 230000,
    "total_denda": 15000,
    "total_jumlah": 245000,
    "lat": 0.4466888,
    "lng": 121.9355018,
    "color": "#fd7e14"
}, {
    "nosamw": "1005376",
    "nama": "RN SUMAWA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1128000,
    "total_denda": 90000,
    "total_jumlah": 1218000,
    "lat": 0.4466652,
    "lng": 121.9355391,
    "color": "#dc3545"
}, {
    "nosamw": "1005355",
    "nama": "RN UMAR BUMULO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4464705,
    "lng": 121.9359218,
    "color": "#28a745"
}, {
    "nosamw": "1005326",
    "nama": "RN UTUN MUSA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 720500,
    "total_denda": 20000,
    "total_jumlah": 740500,
    "lat": 0.4464412,
    "lng": 121.9366709,
    "color": "#dc3545"
}, {
    "nosamw": "1005345",
    "nama": "RN WAHAB MUSLIM",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 481000,
    "total_denda": 35000,
    "total_jumlah": 516000,
    "lat": 0.44604,
    "lng": 121.9364302,
    "color": "#dc3545"
}, {
    "nosamw": "1005363",
    "nama": "RN WILAN TAMBE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4464697,
    "lng": 121.9355351,
    "color": "#fd7e14"
}, {
    "nosamw": "1005342",
    "nama": "RN YAHYA LOI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4464826,
    "lng": 121.9362706,
    "color": "#ffc107"
}, {
    "nosamw": "1005388",
    "nama": "RN YAHYA MELANGI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 301500,
    "total_denda": 15000,
    "total_jumlah": 316500,
    "lat": 0.4466851,
    "lng": 121.9354071,
    "color": "#fd7e14"
}, {
    "nosamw": "1005397",
    "nama": "RN YANTI MOOPONU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 10000,
    "total_jumlah": 250000,
    "lat": 0.4470294,
    "lng": 121.9354004,
    "color": "#ffc107"
}, {
    "nosamw": "1005408",
    "nama": "RN YASIN LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 90000,
    "total_denda": 5000,
    "total_jumlah": 95000,
    "lat": 0.447001,
    "lng": 121.935257,
    "color": "#ffc107"
}, {
    "nosamw": "1005401",
    "nama": "RN YASIN NAKI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 25000,
    "total_jumlah": 300000,
    "lat": 0.4469664,
    "lng": 121.9350695,
    "color": "#fd7e14"
}, {
    "nosamw": "1005314",
    "nama": "RN YORDAN LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 353500,
    "total_denda": 15000,
    "total_jumlah": 368500,
    "lat": 0.4461732,
    "lng": 121.9367256,
    "color": "#fd7e14"
}, {
    "nosamw": "1005336",
    "nama": "RN YUNAN LAPUO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 311500,
    "total_denda": 10000,
    "total_jumlah": 321500,
    "lat": 0.4465259,
    "lng": 121.9362755,
    "color": "#ffc107"
}, {
    "nosamw": "1005371",
    "nama": "RN YUSPIN ALINTI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4464648,
    "lng": 121.9351632,
    "color": "#28a745"
}, {
    "nosamw": "1005361",
    "nama": "RN YUSRI NUSI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4464628,
    "lng": 121.9356119,
    "color": "#ffc107"
}, {
    "nosamw": "1005333",
    "nama": "RN YUSUF MAA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4462642,
    "lng": 121.9363547,
    "color": "#28a745"
}, {
    "nosamw": "1005323",
    "nama": "RN YUSUF WALUDAMBA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4461292,
    "lng": 121.9367398,
    "color": "#28a745"
}, {
    "nosamw": "1005390",
    "nama": "RN ZUBAIDA PIDO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4466808,
    "lng": 121.9352487,
    "color": "#ffc107"
}, {
    "nosamw": "1005372",
    "nama": "RN. RAMAN TARABA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 334000,
    "total_denda": 15000,
    "total_jumlah": 349000,
    "lat": 0.446428,
    "lng": 121.9350299,
    "color": "#fd7e14"
}, {
    "nosamw": "1007361",
    "nama": "RONAL ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 193750,
    "total_denda": 15000,
    "total_jumlah": 208750,
    "lat": 0.4532179,
    "lng": 121.9274788,
    "color": "#fd7e14"
}, {
    "nosamw": "1005096",
    "nama": "Rosita Hunowu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 376000,
    "total_denda": 20000,
    "total_jumlah": 396000,
    "lat": 0.4477722,
    "lng": 121.9324677,
    "color": "#fd7e14"
}, {
    "nosamw": "1002102",
    "nama": "ROSTIN MOHAMAD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 415000,
    "total_denda": 15000,
    "total_jumlah": 430000,
    "lat": 0.4626434,
    "lng": 121.929284,
    "color": "#fd7e14"
}, {
    "nosamw": "1003613",
    "nama": "Roy Abdjul",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 802500,
    "total_denda": 25000,
    "total_jumlah": 827500,
    "lat": 0.4644212,
    "lng": 121.9299429,
    "color": "#fd7e14"
}, {
    "nosamw": "1002652",
    "nama": "Rukmin Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4675776,
    "lng": 121.9303184,
    "color": "#28a745"
}, {
    "nosamw": "1001244",
    "nama": "RUSMAN ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 482800,
    "total_denda": 35000,
    "total_jumlah": 517800,
    "lat": 0.4455174,
    "lng": 121.9360306,
    "color": "#dc3545"
}, {
    "nosamw": "1002317",
    "nama": "Saipan Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 62000,
    "total_denda": 0,
    "total_jumlah": 62000,
    "lat": 0.4595889,
    "lng": 121.9284528,
    "color": "#ffc107"
}, {
    "nosamw": "1002706",
    "nama": "Saipul Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 236800,
    "total_denda": 5000,
    "total_jumlah": 241800,
    "lat": 0.4654,
    "lng": 121.9323718,
    "color": "#ffc107"
}, {
    "nosamw": "1001607",
    "nama": "Saman Musa",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4656445,
    "lng": 121.9312528,
    "color": "#28a745"
}, {
    "nosamw": "1002807",
    "nama": "SAMIN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 74750,
    "total_denda": 10000,
    "total_jumlah": 84750,
    "lat": 0.4646112,
    "lng": 121.9285278,
    "color": "#ffc107"
}, {
    "nosamw": "1002624",
    "nama": "Samon Rahim",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1045000,
    "total_denda": 130000,
    "total_jumlah": 1175000,
    "lat": 0.445968,
    "lng": 121.9350112,
    "color": "#dc3545"
}, {
    "nosamw": "1002409",
    "nama": "Samonu Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1257000,
    "total_denda": 50000,
    "total_jumlah": 1307000,
    "lat": 0.4475826,
    "lng": 121.9323682,
    "color": "#dc3545"
}, {
    "nosamw": "1000373",
    "nama": "Samsudin Baruadi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 139500,
    "total_denda": 5000,
    "total_jumlah": 144500,
    "lat": 0.4464605,
    "lng": 121.9356104,
    "color": "#ffc107"
}, {
    "nosamw": "1000720",
    "nama": "Samu Mointi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1160000,
    "total_denda": 105000,
    "total_jumlah": 1265000,
    "lat": 0.460763,
    "lng": 121.9285269,
    "color": "#dc3545"
}, {
    "nosamw": "1004912",
    "nama": "SANTI B. ALI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35800,
    "total_denda": 5000,
    "total_jumlah": 40800,
    "lat": 0.4451365,
    "lng": 121.9363102,
    "color": "#ffc107"
}, {
    "nosamw": "1002376",
    "nama": "Santi Djafar",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1253500,
    "total_denda": 55000,
    "total_jumlah": 1308500,
    "lat": 0.4471157,
    "lng": 121.9333713,
    "color": "#dc3545"
}, {
    "nosamw": "1003497",
    "nama": "SARAATI PEMANGGI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1248400,
    "total_denda": 45000,
    "total_jumlah": 1293400,
    "lat": 0.4459886,
    "lng": 121.9349168,
    "color": "#dc3545"
}, {
    "nosamw": "1002453",
    "nama": "Sardin Tuliabu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2350600,
    "total_denda": 100000,
    "total_jumlah": 2450600,
    "lat": 0.4467898,
    "lng": 121.933417,
    "color": "#dc3545"
}, {
    "nosamw": "1001894",
    "nama": "Sarifa Y. Abjul",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 730600,
    "total_denda": 25000,
    "total_jumlah": 755600,
    "lat": 0.4488761,
    "lng": 121.9321949,
    "color": "#fd7e14"
}, {
    "nosamw": "1007491",
    "nama": "SARIONO 2",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085340227500",
    "total_bulan": 3,
    "total_tagihan": 147000,
    "total_denda": 10000,
    "total_jumlah": 157000,
    "lat": 0.4604935,
    "lng": 121.9283131,
    "color": "#fd7e14"
}, {
    "nosamw": "1002093",
    "nama": "Saripudin Lopuo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 429250,
    "total_denda": 45000,
    "total_jumlah": 474250,
    "lat": 0.4450897,
    "lng": 121.9362759,
    "color": "#dc3545"
}, {
    "nosamw": "1003312",
    "nama": "Sariyono",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 25000,
    "total_jumlah": 300000,
    "lat": 0.4645662,
    "lng": 121.9298987,
    "color": "#fd7e14"
}, {
    "nosamw": "1001486",
    "nama": "Sarton Paulu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4455702,
    "lng": 121.9357066,
    "color": "#fd7e14"
}, {
    "nosamw": "1002321",
    "nama": "SD. Inp. Bulili",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 480200,
    "total_denda": 10000,
    "total_jumlah": 490200,
    "lat": 0.4617462,
    "lng": 121.9294497,
    "color": "#fd7e14"
}, {
    "nosamw": "1004485",
    "nama": "SDN 09 Duhiadaa ( Kelas Jauh )",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 512000,
    "total_denda": 10000,
    "total_jumlah": 522000,
    "lat": 0.4479239,
    "lng": 121.9332565,
    "color": "#ffc107"
}, {
    "nosamw": "1002532",
    "nama": "Selfi Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 217000,
    "total_denda": 10000,
    "total_jumlah": 227000,
    "lat": 0.4616321,
    "lng": 121.9287921,
    "color": "#fd7e14"
}, {
    "nosamw": "1003455",
    "nama": "Sia Taraba",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 629750,
    "total_denda": 75000,
    "total_jumlah": 704750,
    "lat": 0.4458453,
    "lng": 121.9366505,
    "color": "#dc3545"
}, {
    "nosamw": "1000758",
    "nama": "SITI MUBAYYINAH",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 53000,
    "total_denda": 0,
    "total_jumlah": 53000,
    "lat": 0.4629302,
    "lng": 121.930879,
    "color": "#ffc107"
}, {
    "nosamw": "1002904",
    "nama": "Sitria Ahmad",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 30000,
    "total_denda": 0,
    "total_jumlah": 30000,
    "lat": 0.4588031,
    "lng": 121.9280043,
    "color": "#ffc107"
}, {
    "nosamw": "1002283",
    "nama": "Soke Malia",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 658600,
    "total_denda": 55000,
    "total_jumlah": 713600,
    "lat": 0.4672273,
    "lng": 121.9278995,
    "color": "#dc3545"
}, {
    "nosamw": "1002201",
    "nama": "Soni Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.458447,
    "lng": 121.9279549,
    "color": "#ffc107"
}, {
    "nosamw": "1002697",
    "nama": "Sri Wahyuni",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.46292,
    "lng": 121.9308668,
    "color": "#ffc107"
}, {
    "nosamw": "1001736",
    "nama": "Suardi Dadusolang",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4642213,
    "lng": 121.9295612,
    "color": "#ffc107"
}, {
    "nosamw": "1005112",
    "nama": "SUGITO",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.4676883,
    "lng": 121.9308298,
    "color": "#ffc107"
}, {
    "nosamw": "1004471",
    "nama": "Sulastri Suparman",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1247000,
    "total_denda": 55000,
    "total_jumlah": 1302000,
    "lat": 0.4631539,
    "lng": 121.9300978,
    "color": "#dc3545"
}, {
    "nosamw": "1002043",
    "nama": "Suleman Lopuo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4452317,
    "lng": 121.9363888,
    "color": "#28a745"
}, {
    "nosamw": "1002212",
    "nama": "Suliswanto",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 324000,
    "total_denda": 15000,
    "total_jumlah": 339000,
    "lat": 0.462714,
    "lng": 121.9309305,
    "color": "#fd7e14"
}, {
    "nosamw": "1005575",
    "nama": "SUNA MOPUTI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 568500,
    "total_denda": 15000,
    "total_jumlah": 583500,
    "lat": 0.4475398,
    "lng": 121.9333519,
    "color": "#fd7e14"
}, {
    "nosamw": "1002666",
    "nama": "Suni Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5000,
    "total_denda": 0,
    "total_jumlah": 5000,
    "lat": 0.4599736,
    "lng": 121.9284912,
    "color": "#ffc107"
}, {
    "nosamw": "1007506",
    "nama": "SUPRIYADI SUPARMAN",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082259292404",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.461452,
    "lng": 121.9308604,
    "color": "#ffc107"
}, {
    "nosamw": "1002799",
    "nama": "Syarifudin Kadir",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 620500,
    "total_denda": 40000,
    "total_jumlah": 660500,
    "lat": 0.4475409,
    "lng": 121.9320685,
    "color": "#dc3545"
}, {
    "nosamw": "1002450",
    "nama": "Tago Arsyad",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 422500,
    "total_denda": 35000,
    "total_jumlah": 457500,
    "lat": 0.4475134,
    "lng": 121.9331616,
    "color": "#dc3545"
}, {
    "nosamw": "1004908",
    "nama": "TAHIR LAKUMA",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 387750,
    "total_denda": 35000,
    "total_jumlah": 422750,
    "lat": 0.4488461,
    "lng": 121.9322327,
    "color": "#dc3545"
}, {
    "nosamw": "1002813",
    "nama": "Tahir Saluni",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 451600,
    "total_denda": 35000,
    "total_jumlah": 486600,
    "lat": 0.4461179,
    "lng": 121.9367466,
    "color": "#dc3545"
}, {
    "nosamw": "1003660",
    "nama": "TANTI ARMAS",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1026500,
    "total_denda": 45000,
    "total_jumlah": 1071500,
    "lat": 0.4447234,
    "lng": 121.9359599,
    "color": "#dc3545"
}, {
    "nosamw": "1007568",
    "nama": "TOMY ILAHUDE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082396735684",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 5000,
    "total_jumlah": 99000,
    "lat": 0.4486299,
    "lng": 121.9324536,
    "color": "#ffc107"
}, {
    "nosamw": "1005576",
    "nama": "TUNU MOLE",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4653526,
    "lng": 121.9311726,
    "color": "#28a745"
}, {
    "nosamw": "1001414",
    "nama": "Tuu Olii",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1022000,
    "total_denda": 135000,
    "total_jumlah": 1157000,
    "lat": 0.4653042,
    "lng": 121.9309057,
    "color": "#dc3545"
}, {
    "nosamw": "1001157",
    "nama": "Udin Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 795500,
    "total_denda": 50000,
    "total_jumlah": 845500,
    "lat": 0.446481,
    "lng": 121.939891,
    "color": "#dc3545"
}, {
    "nosamw": "1001604",
    "nama": "Udin Khairun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.4681692,
    "lng": 121.9313277,
    "color": "#fd7e14"
}, {
    "nosamw": "1001889",
    "nama": "Ulin Tangahu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4490808,
    "lng": 121.9311401,
    "color": "#ffc107"
}, {
    "nosamw": "1004990",
    "nama": "Wani Alinti",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.4446418,
    "lng": 121.9360542,
    "color": "#ffc107"
}, {
    "nosamw": "1002880",
    "nama": "Wani Halida",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 239500,
    "total_denda": 20000,
    "total_jumlah": 259500,
    "lat": 0.4643059,
    "lng": 121.9292335,
    "color": "#fd7e14"
}, {
    "nosamw": "1006929",
    "nama": "WARNI KADIR",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 10000,
    "total_denda": 0,
    "total_jumlah": 10000,
    "lat": 0.4635187,
    "lng": 121.9295791,
    "color": "#ffc107"
}, {
    "nosamw": "1005382",
    "nama": "WILAN TAMBE 2",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466929,
    "lng": 121.9347036,
    "color": "#28a745"
}, {
    "nosamw": "1004909",
    "nama": "WIWIN PAULU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.446206,
    "lng": 121.9343583,
    "color": "#ffc107"
}, {
    "nosamw": "1001603",
    "nama": "Yamin Botutihe",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 226500,
    "total_denda": 20000,
    "total_jumlah": 246500,
    "lat": 0.4656136,
    "lng": 121.9311418,
    "color": "#fd7e14"
}, {
    "nosamw": "1001955",
    "nama": "Yamin Polumulo",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132000,
    "total_denda": 20000,
    "total_jumlah": 152000,
    "lat": 0.4632701,
    "lng": 121.9314783,
    "color": "#fd7e14"
}, {
    "nosamw": "1000770",
    "nama": "Yanto Ashari",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4626563,
    "lng": 121.9293188,
    "color": "#ffc107"
}, {
    "nosamw": "1002172",
    "nama": "Yasin Lamusi",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 4625500,
    "total_denda": 100000,
    "total_jumlah": 4725500,
    "lat": 0.4673864,
    "lng": 121.9312493,
    "color": "#dc3545"
}, {
    "nosamw": "1005105",
    "nama": "YASIN MOOBU",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1548500,
    "total_denda": 115000,
    "total_jumlah": 1663500,
    "lat": 0.4646832,
    "lng": 121.9295301,
    "color": "#dc3545"
}, {
    "nosamw": "1001315",
    "nama": "Yeni Marjun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445065,
    "lng": 121.9363451,
    "color": "#28a745"
}, {
    "nosamw": "1002665",
    "nama": "Yulis Ismail",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 450000,
    "total_denda": 40000,
    "total_jumlah": 490000,
    "lat": 0.4598666,
    "lng": 121.9283482,
    "color": "#dc3545"
}, {
    "nosamw": "1005109",
    "nama": "YUNUS ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4614908,
    "lng": 121.9307602,
    "color": "#28a745"
}, {
    "nosamw": "1000403",
    "nama": "YUSRI  MOKODOMPIT",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 363500,
    "total_denda": 5000,
    "total_jumlah": 368500,
    "lat": 0.4607019,
    "lng": 121.9284883,
    "color": "#ffc107"
}, {
    "nosamw": "1004922",
    "nama": "YUSRI TUKILI",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 3809500,
    "total_denda": 75000,
    "total_jumlah": 3884500,
    "lat": 0.446152,
    "lng": 121.9355493,
    "color": "#dc3545"
}, {
    "nosamw": "1005581",
    "nama": "YUSRIN MOHAMAD",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4646485,
    "lng": 121.9288671,
    "color": "#28a745"
}, {
    "nosamw": "1000988",
    "nama": "Yusuf Abay",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4461337,
    "lng": 121.9350653,
    "color": "#28a745"
}, {
    "nosamw": "1001602",
    "nama": "Yusuf Marjun",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 260000,
    "total_denda": 20000,
    "total_jumlah": 280000,
    "lat": 0.4658301,
    "lng": 121.9310347,
    "color": "#fd7e14"
}, {
    "nosamw": "1001085",
    "nama": "Zarina Hunowu",
    "kecamatan": "KEC DUHIADAA DESA BULILI",
    "desa": "BULILI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4676992,
    "lng": 121.9314095,
    "color": "#ffc107"
}, {
    "nosamw": "1004233",
    "nama": "Agus Katili",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449025,
    "lng": 121.943754,
    "color": "#28a745"
}, {
    "nosamw": "1003445",
    "nama": "Alvian Tomaili",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 525500,
    "total_denda": 20000,
    "total_jumlah": 545500,
    "lat": 0.4866057,
    "lng": 121.9139836,
    "color": "#fd7e14"
}, {
    "nosamw": "1004706",
    "nama": "Amran Aminu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.4741378,
    "lng": 121.9166468,
    "color": "#fd7e14"
}, {
    "nosamw": "1000704",
    "nama": "Anis Abdullah",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4865063,
    "lng": 121.9139386,
    "color": "#ffc107"
}, {
    "nosamw": "1003749",
    "nama": "Eman Puyo",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 71600,
    "total_denda": 10000,
    "total_jumlah": 81600,
    "lat": 0.4849647,
    "lng": 121.9116517,
    "color": "#ffc107"
}, {
    "nosamw": "1004172",
    "nama": "Erwin Noho",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.4730351,
    "lng": 121.9159581,
    "color": "#ffc107"
}, {
    "nosamw": "1007294",
    "nama": "FAJRI HASAN 4",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1871500,
    "total_denda": 125000,
    "total_jumlah": 1996500,
    "lat": 0.47847,
    "lng": 121.9195984,
    "color": "#dc3545"
}, {
    "nosamw": "1006274",
    "nama": "H18 DARNA MUSTAFA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1369200,
    "total_denda": 135000,
    "total_jumlah": 1504200,
    "lat": 0.4815034,
    "lng": 121.9236702,
    "color": "#dc3545"
}, {
    "nosamw": "1006281",
    "nama": "H18 IDRIS TUPATA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2664000,
    "total_denda": 125000,
    "total_jumlah": 2789000,
    "lat": 0.4815259,
    "lng": 121.9237326,
    "color": "#dc3545"
}, {
    "nosamw": "1006273",
    "nama": "H18 INTON SABU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1092000,
    "total_denda": 135000,
    "total_jumlah": 1227000,
    "lat": 0.4817261,
    "lng": 121.923437,
    "color": "#dc3545"
}, {
    "nosamw": "1006314",
    "nama": "H18 MAMAT MADU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.4814822,
    "lng": 121.9236865,
    "color": "#fd7e14"
}, {
    "nosamw": "1006259",
    "nama": "H18 NANI SABU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1426000,
    "total_denda": 105000,
    "total_jumlah": 1531000,
    "lat": 0.4813356,
    "lng": 121.9240402,
    "color": "#dc3545"
}, {
    "nosamw": "1006267",
    "nama": "H18 NORMA YUSUP",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 935800,
    "total_denda": 130000,
    "total_jumlah": 1065800,
    "lat": 0.4813481,
    "lng": 121.9240483,
    "color": "#dc3545"
}, {
    "nosamw": "1006271",
    "nama": "H18 RIDWAN AHMAD",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 265200,
    "total_denda": 30000,
    "total_jumlah": 295200,
    "lat": 0.4681093,
    "lng": 121.9301805,
    "color": "#fd7e14"
}, {
    "nosamw": "1006272",
    "nama": "H18 TIN SANE",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1432400,
    "total_denda": 125000,
    "total_jumlah": 1557400,
    "lat": 0.4813261,
    "lng": 121.9239907,
    "color": "#dc3545"
}, {
    "nosamw": "1006315",
    "nama": "H18 WAHAB HAMZAH",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 751800,
    "total_denda": 105000,
    "total_jumlah": 856800,
    "lat": 0.481494,
    "lng": 121.9236639,
    "color": "#dc3545"
}, {
    "nosamw": "1006743",
    "nama": "H19 AMINA TAIB \/ DARMIN MOHA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1588150,
    "total_denda": 110000,
    "total_jumlah": 1698150,
    "lat": 0.4817523,
    "lng": 121.9234298,
    "color": "#dc3545"
}, {
    "nosamw": "1006766",
    "nama": "H19 DJAFAR PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4761628,
    "lng": 121.9175564,
    "color": "#28a745"
}, {
    "nosamw": "1006737",
    "nama": "H19 IDRIS EBA \/ AMIN DJAFAR",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1037500,
    "total_denda": 85000,
    "total_jumlah": 1122500,
    "lat": 0.4848088,
    "lng": 121.9122513,
    "color": "#dc3545"
}, {
    "nosamw": "1006761",
    "nama": "H19 JAINAB PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 109750,
    "total_denda": 15000,
    "total_jumlah": 124750,
    "lat": 0.4760821,
    "lng": 121.9177412,
    "color": "#fd7e14"
}, {
    "nosamw": "1006767",
    "nama": "H19 SARNI MOHAMAD",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4761295,
    "lng": 121.9175867,
    "color": "#28a745"
}, {
    "nosamw": "1006794",
    "nama": "H19 WANO YASIN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 318000,
    "total_denda": 15000,
    "total_jumlah": 333000,
    "lat": 0.4731799,
    "lng": 121.9161328,
    "color": "#fd7e14"
}, {
    "nosamw": "1007336",
    "nama": "HARIS HUNOWU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.467971,
    "lng": 121.958516,
    "color": "#ffc107"
}, {
    "nosamw": "1007371",
    "nama": "Irwanzah Otoluwa",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2491500,
    "total_denda": 110000,
    "total_jumlah": 2601500,
    "lat": 0.4783411,
    "lng": 121.91951,
    "color": "#dc3545"
}, {
    "nosamw": "1001421",
    "nama": "KARTIN PAKAYA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4785012,
    "lng": 121.9188708,
    "color": "#ffc107"
}, {
    "nosamw": "1004614",
    "nama": "Lukman Katili",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 5000,
    "total_jumlah": 79500,
    "lat": 0.4750538,
    "lng": 121.9172387,
    "color": "#ffc107"
}, {
    "nosamw": "1004206",
    "nama": "Lulu Hado",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1080500,
    "total_denda": 45000,
    "total_jumlah": 1125500,
    "lat": 0.4812291,
    "lng": 121.916088,
    "color": "#dc3545"
}, {
    "nosamw": "1005115",
    "nama": "MALDFRID FRANGKY F . NGAJOW",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1781000,
    "total_denda": 25000,
    "total_jumlah": 1806000,
    "lat": 0.4786085,
    "lng": 121.9190062,
    "color": "#fd7e14"
}, {
    "nosamw": "1003676",
    "nama": "Mohamad Bobihoe",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.4760517,
    "lng": 121.9177204,
    "color": "#ffc107"
}, {
    "nosamw": "1003273",
    "nama": "Mohamad Dango",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4852973,
    "lng": 121.9204652,
    "color": "#ffc107"
}, {
    "nosamw": "1003748",
    "nama": "Muhtar Kiu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 587500,
    "total_denda": 50000,
    "total_jumlah": 637500,
    "lat": 0.4820821,
    "lng": 121.9160264,
    "color": "#dc3545"
}, {
    "nosamw": "1005486",
    "nama": "NETTY NURHAYATI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 40000,
    "total_jumlah": 485000,
    "lat": 0.4787799,
    "lng": 121.9191087,
    "color": "#dc3545"
}, {
    "nosamw": "1003354",
    "nama": "Nisfa S. Monoarfa",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4786972,
    "lng": 121.9189609,
    "color": "#28a745"
}, {
    "nosamw": "1004610",
    "nama": "Raman Pakaya",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 39,
    "total_tagihan": 1299350,
    "total_denda": 195000,
    "total_jumlah": 1494350,
    "lat": 0.487366,
    "lng": 121.9353279,
    "color": "#dc3545"
}, {
    "nosamw": "1004556",
    "nama": "Rusman Pakaya",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4787926,
    "lng": 121.9191378,
    "color": "#ffc107"
}, {
    "nosamw": "1005283",
    "nama": "SALEH PANIGORO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4869382,
    "lng": 121.9142451,
    "color": "#28a745"
}, {
    "nosamw": "1004200",
    "nama": "Sudirman M. Biki",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4754441,
    "lng": 121.9219286,
    "color": "#ffc107"
}, {
    "nosamw": "1005823",
    "nama": "SURYANTO SURYA NINGGRAT",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4783623,
    "lng": 121.919679,
    "color": "#28a745"
}, {
    "nosamw": "1004176",
    "nama": "UMAR KOLONGO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4730185,
    "lng": 121.9159743,
    "color": "#28a745"
}, {
    "nosamw": "1001127",
    "nama": "VEMY DANGKUA,S.Si",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA BARAT",
    "desa": "BUNTULIA BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4781443,
    "lng": 121.9190002,
    "color": "#ffc107"
}, {
    "nosamw": "1004204",
    "nama": "Adrian Ali",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4772972,
    "lng": 121.934698,
    "color": "#28a745"
}, {
    "nosamw": "1003443",
    "nama": "ARIFIN BALU 2",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4723369,
    "lng": 121.9338469,
    "color": "#28a745"
}, {
    "nosamw": "1001948",
    "nama": "Drg. Herlina",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4770842,
    "lng": 121.9350654,
    "color": "#28a745"
}, {
    "nosamw": "1006238",
    "nama": "H18 RUSTAM SADO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4738926,
    "lng": 121.9267957,
    "color": "#28a745"
}, {
    "nosamw": "1006372",
    "nama": "H18 TAHIR HIPI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4752892,
    "lng": 121.9321711,
    "color": "#28a745"
}, {
    "nosamw": "1006256",
    "nama": "H18 TAUFIK UMAR",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4721905,
    "lng": 121.9334535,
    "color": "#28a745"
}, {
    "nosamw": "1003861",
    "nama": "Hesti Baginda",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1590500,
    "total_denda": 70000,
    "total_jumlah": 1660500,
    "lat": 0.4773089,
    "lng": 121.9346701,
    "color": "#dc3545"
}, {
    "nosamw": "1001076",
    "nama": "JEN PASISINGI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4779075,
    "lng": 121.9333692,
    "color": "#28a745"
}, {
    "nosamw": "1004515",
    "nama": "Mahyudin R.Sako",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4740377,
    "lng": 121.9269804,
    "color": "#28a745"
}, {
    "nosamw": "1001530",
    "nama": "Melinda Suleman",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4752797,
    "lng": 121.9321476,
    "color": "#28a745"
}, {
    "nosamw": "1003772",
    "nama": "Mursid",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 380500,
    "total_denda": 30000,
    "total_jumlah": 410500,
    "lat": 0.4765024,
    "lng": 121.9318961,
    "color": "#fd7e14"
}, {
    "nosamw": "1002673",
    "nama": "TRY YADI WONGGOW",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA JAYA",
    "desa": "BUNTULIA JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4769449,
    "lng": 121.9356329,
    "color": "#ffc107"
}, {
    "nosamw": "1000673",
    "nama": "Abdul Mbuinga",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4698207,
    "lng": 121.9312038,
    "color": "#28a745"
}, {
    "nosamw": "1001202",
    "nama": "Abdullah Husa",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4715552,
    "lng": 121.9313731,
    "color": "#28a745"
}, {
    "nosamw": "1002696",
    "nama": "Abdullah Syah",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4684377,
    "lng": 121.9335353,
    "color": "#28a745"
}, {
    "nosamw": "1001824",
    "nama": "Advont Nento",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4679953,
    "lng": 121.9338478,
    "color": "#28a745"
}, {
    "nosamw": "1005613",
    "nama": "AGUS DJONGGE",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66600,
    "total_denda": 5000,
    "total_jumlah": 71600,
    "lat": 0.4679033,
    "lng": 121.930139,
    "color": "#ffc107"
}, {
    "nosamw": "1000797",
    "nama": "Ahmad Fadli",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4680766,
    "lng": 121.9307139,
    "color": "#28a745"
}, {
    "nosamw": "1001706",
    "nama": "ALI MASRUHIN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477759,
    "lng": 121.9339549,
    "color": "#28a745"
}, {
    "nosamw": "1005614",
    "nama": "ANITA IGIRISA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 55000,
    "total_jumlah": 665000,
    "lat": 0.46803,
    "lng": 121.9295047,
    "color": "#dc3545"
}, {
    "nosamw": "1002642",
    "nama": "Asia Mahmud",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 2785000,
    "total_denda": 170000,
    "total_jumlah": 2955000,
    "lat": 0.4680075,
    "lng": 121.9312427,
    "color": "#dc3545"
}, {
    "nosamw": "1000497",
    "nama": "Ati Labaco",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4873715,
    "lng": 121.9353635,
    "color": "#28a745"
}, {
    "nosamw": "1000967",
    "nama": "Basyar Saiful M",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 222500,
    "total_denda": 5000,
    "total_jumlah": 227500,
    "lat": 0.4729344,
    "lng": 121.9306902,
    "color": "#ffc107"
}, {
    "nosamw": "1001031",
    "nama": "Darwin Situngkir",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4750642,
    "lng": 121.9321719,
    "color": "#28a745"
}, {
    "nosamw": "1000431",
    "nama": "Dince Kadir",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 282000,
    "total_denda": 15000,
    "total_jumlah": 297000,
    "lat": 0.4679425,
    "lng": 121.9290793,
    "color": "#fd7e14"
}, {
    "nosamw": "1000051",
    "nama": "Dr. Farid Dunggio",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4753111,
    "lng": 121.9321777,
    "color": "#28a745"
}, {
    "nosamw": "1000425",
    "nama": "Ece Roring . I",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4719948,
    "lng": 121.9312415,
    "color": "#28a745"
}, {
    "nosamw": "1003330",
    "nama": "Ece Roring. 2",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4712946,
    "lng": 121.9313446,
    "color": "#28a745"
}, {
    "nosamw": "1005618",
    "nama": "ERNI AMANA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4683558,
    "lng": 121.928469,
    "color": "#28a745"
}, {
    "nosamw": "1004322",
    "nama": "Erni Ismail",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 935200,
    "total_denda": 135000,
    "total_jumlah": 1070200,
    "lat": 0.470035,
    "lng": 121.9316022,
    "color": "#dc3545"
}, {
    "nosamw": "1005139",
    "nama": "FATMA HULUKATI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1173200,
    "total_denda": 135000,
    "total_jumlah": 1308200,
    "lat": 0.4708375,
    "lng": 121.9304878,
    "color": "#dc3545"
}, {
    "nosamw": "1005619",
    "nama": "FATMA HUSAIN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 2302500,
    "total_denda": 155000,
    "total_jumlah": 2457500,
    "lat": 0.461675,
    "lng": 121.938411,
    "color": "#dc3545"
}, {
    "nosamw": "1002987",
    "nama": "Fatma Kasim",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4679077,
    "lng": 121.9290444,
    "color": "#28a745"
}, {
    "nosamw": "1002691",
    "nama": "H. HERMAN DAMIS",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.455221,
    "lng": 121.938074,
    "color": "#28a745"
}, {
    "nosamw": "1006246",
    "nama": "H18 AZWAR ARAFAT THANWIR",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2460000,
    "total_denda": 70000,
    "total_jumlah": 2530000,
    "lat": 0.4721907,
    "lng": 121.9342058,
    "color": "#dc3545"
}, {
    "nosamw": "1006247",
    "nama": "H18 FAHRY DJAFAR",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4728329,
    "lng": 121.9334759,
    "color": "#28a745"
}, {
    "nosamw": "1006244",
    "nama": "H18 IDRIS UMAR",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4696833,
    "lng": 121.9295844,
    "color": "#28a745"
}, {
    "nosamw": "1006254",
    "nama": "H18 MUNTIHANA LATIF",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4722126,
    "lng": 121.9341734,
    "color": "#28a745"
}, {
    "nosamw": "1006241",
    "nama": "H18 PURWO SETIAWAN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1409800,
    "total_denda": 60000,
    "total_jumlah": 1469800,
    "lat": 0.467977,
    "lng": 121.9312117,
    "color": "#dc3545"
}, {
    "nosamw": "1006245",
    "nama": "H18 YANTI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4680919,
    "lng": 121.930711,
    "color": "#28a745"
}, {
    "nosamw": "1006801",
    "nama": "H19 DWI YANA FITRI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4678144,
    "lng": 121.9305821,
    "color": "#ffc107"
}, {
    "nosamw": "1006757",
    "nama": "H19 SUSANTI RASYID",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 834000,
    "total_denda": 50000,
    "total_jumlah": 884000,
    "lat": 0.468121,
    "lng": 121.9298173,
    "color": "#dc3545"
}, {
    "nosamw": "1006768",
    "nama": "H19 SUWARTIN MULANE",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66600,
    "total_denda": 5000,
    "total_jumlah": 71600,
    "lat": 0.4701437,
    "lng": 121.9318575,
    "color": "#ffc107"
}, {
    "nosamw": "1005140",
    "nama": "HANI WALAHE",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.4701209,
    "lng": 121.9317359,
    "color": "#fd7e14"
}, {
    "nosamw": "1000753",
    "nama": "Hartati Baginda",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4695038,
    "lng": 121.9311,
    "color": "#28a745"
}, {
    "nosamw": "1000612",
    "nama": "Haryono Wahab",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.469185,
    "lng": 121.9311224,
    "color": "#ffc107"
}, {
    "nosamw": "1002527",
    "nama": "HASLINA MAKASENDA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 5000,
    "total_jumlah": 99000,
    "lat": 0.4681865,
    "lng": 121.9284345,
    "color": "#ffc107"
}, {
    "nosamw": "1005135",
    "nama": "HENDRA POIYO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4704296,
    "lng": 121.9307474,
    "color": "#28a745"
}, {
    "nosamw": "1000625",
    "nama": "Heriyanto Baginda",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 258000,
    "total_denda": 20000,
    "total_jumlah": 278000,
    "lat": 0.4694192,
    "lng": 121.9311666,
    "color": "#fd7e14"
}, {
    "nosamw": "1000044",
    "nama": "Husin Rahim",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.468652,
    "lng": 121.9312841,
    "color": "#ffc107"
}, {
    "nosamw": "1000712",
    "nama": "Indrawaty Djama",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4781025,
    "lng": 121.932821,
    "color": "#28a745"
}, {
    "nosamw": "1007442",
    "nama": "INDRAYANA KURNIAWAN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082189045073",
    "total_bulan": 6,
    "total_tagihan": 388500,
    "total_denda": 30000,
    "total_jumlah": 418500,
    "lat": 0.4617429,
    "lng": 121.9306229,
    "color": "#fd7e14"
}, {
    "nosamw": "1000022",
    "nama": "Iswan Paudi",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 529500,
    "total_denda": 40000,
    "total_jumlah": 569500,
    "lat": 0.4712497,
    "lng": 121.9313723,
    "color": "#dc3545"
}, {
    "nosamw": "1001118",
    "nama": "Jari Polimengo",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4678949,
    "lng": 121.9301417,
    "color": "#28a745"
}, {
    "nosamw": "1000717",
    "nama": "Kadir Mahful",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 103000,
    "total_denda": 5000,
    "total_jumlah": 108000,
    "lat": 0.4688697,
    "lng": 121.9311214,
    "color": "#ffc107"
}, {
    "nosamw": "1000436",
    "nama": "Kadir Thalib",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 452500,
    "total_denda": 10000,
    "total_jumlah": 462500,
    "lat": 0.4679038,
    "lng": 121.9299728,
    "color": "#ffc107"
}, {
    "nosamw": "1005149",
    "nama": "LILI HASAN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1316800,
    "total_denda": 105000,
    "total_jumlah": 1421800,
    "lat": 0.4695522,
    "lng": 121.9285408,
    "color": "#dc3545"
}, {
    "nosamw": "1005627",
    "nama": "LISNA IBRAHIM",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 216000,
    "total_denda": 40000,
    "total_jumlah": 256000,
    "lat": 0.473757,
    "lng": 121.945052,
    "color": "#dc3545"
}, {
    "nosamw": "1000341",
    "nama": "Maimuna Mahmud",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4679925,
    "lng": 121.9312477,
    "color": "#28a745"
}, {
    "nosamw": "1002765",
    "nama": "Marsono Pou",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.4778791,
    "lng": 121.933535,
    "color": "#dc3545"
}, {
    "nosamw": "1000498",
    "nama": "Mat Dai",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4677244,
    "lng": 121.9307494,
    "color": "#28a745"
}, {
    "nosamw": "1000506",
    "nama": "Mesjid Fastabiqul-Khairat",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4000,
    "total_denda": 5000,
    "total_jumlah": 9000,
    "lat": 0.4700867,
    "lng": 121.9312525,
    "color": "#ffc107"
}, {
    "nosamw": "1002511",
    "nama": "Moh. Mooduto",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4778545,
    "lng": 121.9349186,
    "color": "#28a745"
}, {
    "nosamw": "1000162",
    "nama": "Moha Idrus",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.469174,
    "lng": 121.931181,
    "color": "#ffc107"
}, {
    "nosamw": "1005629",
    "nama": "MOHAMAD ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4691617,
    "lng": 121.9303648,
    "color": "#28a745"
}, {
    "nosamw": "1001849",
    "nama": "Mushola Ar-Ridho \/ Mursyi",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 48000,
    "total_denda": 55000,
    "total_jumlah": 103000,
    "lat": 0.4678463,
    "lng": 121.9305721,
    "color": "#dc3545"
}, {
    "nosamw": "1005642",
    "nama": "MUSTAKIM",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 5000,
    "total_jumlah": 66500,
    "lat": 0.464129,
    "lng": 121.94972,
    "color": "#ffc107"
}, {
    "nosamw": "1004743",
    "nama": "NURDIN ADJU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2424000,
    "total_denda": 110000,
    "total_jumlah": 2534000,
    "lat": 0.4681943,
    "lng": 121.9284701,
    "color": "#dc3545"
}, {
    "nosamw": "1000059",
    "nama": "Nurdin Olii",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4755838,
    "lng": 121.9321127,
    "color": "#28a745"
}, {
    "nosamw": "1000611",
    "nama": "Oki. Himran",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4677579,
    "lng": 121.9311551,
    "color": "#28a745"
}, {
    "nosamw": "1006348",
    "nama": "PARMAN KASIM 3",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.4682665,
    "lng": 121.9283678,
    "color": "#ffc107"
}, {
    "nosamw": "1004490",
    "nama": "PT.BFI Finance Indonesia,",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472371,
    "lng": 121.9315107,
    "color": "#28a745"
}, {
    "nosamw": "1003664",
    "nama": "Purmaya Tangahu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4720839,
    "lng": 121.9314635,
    "color": "#28a745"
}, {
    "nosamw": "1001390",
    "nama": "Rahman Dunggio",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 214000,
    "total_denda": 10000,
    "total_jumlah": 224000,
    "lat": 0.4680312,
    "lng": 121.9282192,
    "color": "#ffc107"
}, {
    "nosamw": "1001045",
    "nama": "Ramijan",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4680223,
    "lng": 121.9289328,
    "color": "#ffc107"
}, {
    "nosamw": "1002417",
    "nama": "Rezal Nusi",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4724522,
    "lng": 121.9313729,
    "color": "#28a745"
}, {
    "nosamw": "1000437",
    "nama": "Ridwan Anwar",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4678421,
    "lng": 121.9300151,
    "color": "#fd7e14"
}, {
    "nosamw": "1005152",
    "nama": "RIKO DJINGO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4691469,
    "lng": 121.92864,
    "color": "#28a745"
}, {
    "nosamw": "1002648",
    "nama": "Rusni Harun",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 319600,
    "total_denda": 20000,
    "total_jumlah": 339600,
    "lat": 0.4681168,
    "lng": 121.9298482,
    "color": "#fd7e14"
}, {
    "nosamw": "1005137",
    "nama": "RUSTAM ABD. KAI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55400,
    "total_denda": 5000,
    "total_jumlah": 60400,
    "lat": 0.4707478,
    "lng": 121.9305657,
    "color": "#ffc107"
}, {
    "nosamw": "1005146",
    "nama": "RUSUNA GANI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 294400,
    "total_denda": 20000,
    "total_jumlah": 314400,
    "lat": 0.4701704,
    "lng": 121.9316342,
    "color": "#fd7e14"
}, {
    "nosamw": "1000019",
    "nama": "Sahrun Tangahu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "BN",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 615000,
    "total_denda": 80000,
    "total_jumlah": 695000,
    "lat": 0.4718275,
    "lng": 121.931495,
    "color": "#fd7e14"
}, {
    "nosamw": "1002143",
    "nama": "Saiba Dalanggo",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4674426,
    "lng": 121.9321854,
    "color": "#28a745"
}, {
    "nosamw": "1005145",
    "nama": "SAMSIA HASAN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 599000,
    "total_denda": 90000,
    "total_jumlah": 689000,
    "lat": 0.4701098,
    "lng": 121.931728,
    "color": "#dc3545"
}, {
    "nosamw": "1002135",
    "nama": "Saoda Tantu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 399000,
    "total_denda": 10000,
    "total_jumlah": 409000,
    "lat": 0.4732331,
    "lng": 121.9297067,
    "color": "#fd7e14"
}, {
    "nosamw": "1000752",
    "nama": "Sarina Syuaib",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.4692314,
    "lng": 121.9311564,
    "color": "#ffc107"
}, {
    "nosamw": "1001104",
    "nama": "Saripa Bakir",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 702000,
    "total_denda": 95000,
    "total_jumlah": 797000,
    "lat": 0.4678739,
    "lng": 121.9301491,
    "color": "#dc3545"
}, {
    "nosamw": "1001649",
    "nama": "SARLIN MOPUTI",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1925500,
    "total_denda": 35000,
    "total_jumlah": 1960500,
    "lat": 0.4680107,
    "lng": 121.9281663,
    "color": "#dc3545"
}, {
    "nosamw": "1000762",
    "nama": "Sarman",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4691263,
    "lng": 121.9312332,
    "color": "#28a745"
}, {
    "nosamw": "1000452",
    "nama": "SD. B. Selatan",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 20000,
    "total_jumlah": 160000,
    "lat": 0.4755718,
    "lng": 121.9320287,
    "color": "#fd7e14"
}, {
    "nosamw": "1001261",
    "nama": "Selly Robert",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4687177,
    "lng": 121.931111,
    "color": "#28a745"
}, {
    "nosamw": "1002235",
    "nama": "Selvi Wongkuginta",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.4727822,
    "lng": 121.9315064,
    "color": "#ffc107"
}, {
    "nosamw": "1002205",
    "nama": "Stevani Kumawijaya",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4675646,
    "lng": 121.9320513,
    "color": "#28a745"
}, {
    "nosamw": "1002645",
    "nama": "Suhardi Harun",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1097600,
    "total_denda": 135000,
    "total_jumlah": 1232600,
    "lat": 0.4679524,
    "lng": 121.9290348,
    "color": "#dc3545"
}, {
    "nosamw": "1001029",
    "nama": "Sulkifli Detu",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4730426,
    "lng": 121.9294896,
    "color": "#28a745"
}, {
    "nosamw": "1000773",
    "nama": "Sumi Katili",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 993000,
    "total_denda": 65000,
    "total_jumlah": 1058000,
    "lat": 0.4680088,
    "lng": 121.9282045,
    "color": "#dc3545"
}, {
    "nosamw": "1000755",
    "nama": "Sun Katili",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.4680139,
    "lng": 121.9289976,
    "color": "#ffc107"
}, {
    "nosamw": "1002690",
    "nama": "SUPRIYATIN",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4679133,
    "lng": 121.9262071,
    "color": "#28a745"
}, {
    "nosamw": "1000788",
    "nama": "Supriyono",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4680221,
    "lng": 121.9264647,
    "color": "#28a745"
}, {
    "nosamw": "1001966",
    "nama": "SURIANTI BOBIHU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 632000,
    "total_denda": 95000,
    "total_jumlah": 727000,
    "lat": 0.4731995,
    "lng": 121.929773,
    "color": "#dc3545"
}, {
    "nosamw": "1005497",
    "nama": "SUYONO",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4680797,
    "lng": 121.930727,
    "color": "#28a745"
}, {
    "nosamw": "1005637",
    "nama": "TANIS HUNOWU",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 63800,
    "total_denda": 5000,
    "total_jumlah": 68800,
    "lat": 0.4681443,
    "lng": 121.9298352,
    "color": "#ffc107"
}, {
    "nosamw": "1002332",
    "nama": "Thomas Suandi",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4676423,
    "lng": 121.9319595,
    "color": "#28a745"
}, {
    "nosamw": "1001092",
    "nama": "Tuntun Amana",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 4834000,
    "total_denda": 95000,
    "total_jumlah": 4929000,
    "lat": 0.4678954,
    "lng": 121.9266953,
    "color": "#dc3545"
}, {
    "nosamw": "1000067",
    "nama": "Welly Motto",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4782176,
    "lng": 121.9329832,
    "color": "#28a745"
}, {
    "nosamw": "1002734",
    "nama": "Win Mahmud",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87250,
    "total_denda": 5000,
    "total_jumlah": 92250,
    "lat": 0.467937,
    "lng": 121.9318288,
    "color": "#ffc107"
}, {
    "nosamw": "1000461",
    "nama": "Yahya Konio",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 966000,
    "total_denda": 85000,
    "total_jumlah": 1051000,
    "lat": 0.4673585,
    "lng": 121.9331799,
    "color": "#dc3545"
}, {
    "nosamw": "1005638",
    "nama": "YANTI HAMSA",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 957850,
    "total_denda": 35000,
    "total_jumlah": 992850,
    "lat": 0.4696677,
    "lng": 121.9298191,
    "color": "#dc3545"
}, {
    "nosamw": "1002651",
    "nama": "Yeli Ahmad",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4680436,
    "lng": 121.9294569,
    "color": "#28a745"
}, {
    "nosamw": "1000623",
    "nama": "zufri kidam",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "08114199929",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4676884,
    "lng": 121.9317639,
    "color": "#28a745"
}, {
    "nosamw": "1000561",
    "nama": "Zulkifli Liputo",
    "kecamatan": "KEC DUHIADAA DESA BUNTULIA SELATAN",
    "desa": "BUNTULIA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 676850,
    "total_denda": 80000,
    "total_jumlah": 756850,
    "lat": 0.4680013,
    "lng": 121.9279139,
    "color": "#dc3545"
}, {
    "nosamw": "1003877",
    "nama": "ABDUL KHAMID",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4874655,
    "lng": 121.9148487,
    "color": "#28a745"
}, {
    "nosamw": "1003612",
    "nama": "ABDUL MUQIIT KIAYI",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 513000,
    "total_denda": 45000,
    "total_jumlah": 558000,
    "lat": 0.4872865,
    "lng": 121.9145812,
    "color": "#dc3545"
}, {
    "nosamw": "1003343",
    "nama": "Ali Lukum",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 432000,
    "total_denda": 35000,
    "total_jumlah": 467000,
    "lat": 0.4870475,
    "lng": 121.9142896,
    "color": "#dc3545"
}, {
    "nosamw": "1003224",
    "nama": "DETY GUSWATI",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 45,
    "total_tagihan": 6386500,
    "total_denda": 225000,
    "total_jumlah": 6611500,
    "lat": 0.478216,
    "lng": 121.9191628,
    "color": "#dc3545"
}, {
    "nosamw": "1003347",
    "nama": "Hamjati Palilati",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1012000,
    "total_denda": 145000,
    "total_jumlah": 1157000,
    "lat": 0.4821323,
    "lng": 121.916029,
    "color": "#dc3545"
}, {
    "nosamw": "1003705",
    "nama": "Haridja Kaani",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 531000,
    "total_denda": 50000,
    "total_jumlah": 581000,
    "lat": 0.4827599,
    "lng": 121.9174901,
    "color": "#dc3545"
}, {
    "nosamw": "1004108",
    "nama": "I NYOMAN ADIARTA",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4836486,
    "lng": 121.917945,
    "color": "#28a745"
}, {
    "nosamw": "1001177",
    "nama": "Lestari I Ishak",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4871293,
    "lng": 121.9143244,
    "color": "#28a745"
}, {
    "nosamw": "1004607",
    "nama": "MARYAM ULOLI",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 54000,
    "total_denda": 5000,
    "total_jumlah": 59000,
    "lat": 0.4879182,
    "lng": 121.9149504,
    "color": "#ffc107"
}, {
    "nosamw": "1001932",
    "nama": "Mesjid Ar-Rayani\/Ibrahim",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4874425,
    "lng": 121.9219046,
    "color": "#28a745"
}, {
    "nosamw": "1001979",
    "nama": "Najib Polumulo",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2261200,
    "total_denda": 125000,
    "total_jumlah": 2386200,
    "lat": 0.501263,
    "lng": 121.893061,
    "color": "#dc3545"
}, {
    "nosamw": "1007423",
    "nama": "NURLELA DJUA (PERUM DUHIADAA)",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085316537218",
    "total_bulan": 23,
    "total_tagihan": 1270000,
    "total_denda": 115000,
    "total_jumlah": 1385000,
    "lat": 0.4783585,
    "lng": 121.9196882,
    "color": "#dc3545"
}, {
    "nosamw": "1004210",
    "nama": "Puskesmas Duhiadaa",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "PP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 327500,
    "total_denda": 5000,
    "total_jumlah": 332500,
    "lat": 0.481046,
    "lng": 121.9207252,
    "color": "#ffc107"
}, {
    "nosamw": "1006745",
    "nama": "ROSNA ISMAIL",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 616200,
    "total_denda": 95000,
    "total_jumlah": 711200,
    "lat": 0.4818248,
    "lng": 121.9234376,
    "color": "#dc3545"
}, {
    "nosamw": "1003906",
    "nama": "SAIFUL ASROL",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4869064,
    "lng": 121.9141917,
    "color": "#28a745"
}, {
    "nosamw": "1004579",
    "nama": "SRI WINDA MONOARFA",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1520500,
    "total_denda": 100000,
    "total_jumlah": 1620500,
    "lat": 0.4784677,
    "lng": 121.9196244,
    "color": "#dc3545"
}, {
    "nosamw": "1003900",
    "nama": "USAID Bahrun Lukum",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1735750,
    "total_denda": 55000,
    "total_jumlah": 1790750,
    "lat": 0.4852131,
    "lng": 121.9121117,
    "color": "#dc3545"
}, {
    "nosamw": "1004150",
    "nama": "USAID Darna Nawayi",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.485227,
    "lng": 121.9135907,
    "color": "#ffc107"
}, {
    "nosamw": "1003907",
    "nama": "USAID Jon Abdullah",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4860085,
    "lng": 121.9134764,
    "color": "#28a745"
}, {
    "nosamw": "1003903",
    "nama": "USAID Kahar Nggon",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 213200,
    "total_denda": 20000,
    "total_jumlah": 233200,
    "lat": 0.4870746,
    "lng": 121.9142963,
    "color": "#fd7e14"
}, {
    "nosamw": "1003897",
    "nama": "USAID Kuna Hunowu",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4857005,
    "lng": 121.9135367,
    "color": "#28a745"
}, {
    "nosamw": "1004151",
    "nama": "USAID Sugito Nawayi",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 808250,
    "total_denda": 110000,
    "total_jumlah": 918250,
    "lat": 0.4852,
    "lng": 121.9135874,
    "color": "#dc3545"
}, {
    "nosamw": "1003879",
    "nama": "USAID Yohan Yasin",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4874621,
    "lng": 121.9147433,
    "color": "#28a745"
}, {
    "nosamw": "1004367",
    "nama": "Yusuf Tani",
    "kecamatan": "KEC DUHIADAA DESA DUHIADAA",
    "desa": "DUHIADAA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4790553,
    "lng": 121.930073,
    "color": "#fd7e14"
}, {
    "nosamw": "1003221",
    "nama": "Asu Saleh",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1212000,
    "total_denda": 105000,
    "total_jumlah": 1317000,
    "lat": 0.5018355,
    "lng": 121.8931052,
    "color": "#dc3545"
}, {
    "nosamw": "1002442",
    "nama": "Daton Hunowu",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1310200,
    "total_denda": 90000,
    "total_jumlah": 1400200,
    "lat": 0.5005459,
    "lng": 121.8977333,
    "color": "#dc3545"
}, {
    "nosamw": "1005662",
    "nama": "ESMI MUSA",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 882600,
    "total_denda": 130000,
    "total_jumlah": 1012600,
    "lat": 0.5018464,
    "lng": 121.8930359,
    "color": "#dc3545"
}, {
    "nosamw": "1005635",
    "nama": "Ester Katili",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4999825,
    "lng": 121.8927796,
    "color": "#ffc107"
}, {
    "nosamw": "1006293",
    "nama": "H18 TENO MATITI",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 169500,
    "total_denda": 15000,
    "total_jumlah": 184500,
    "lat": 0.5003795,
    "lng": 121.8977524,
    "color": "#fd7e14"
}, {
    "nosamw": "1002354",
    "nama": "Halim Musa",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 333500,
    "total_denda": 25000,
    "total_jumlah": 358500,
    "lat": 0.4994793,
    "lng": 121.8928389,
    "color": "#fd7e14"
}, {
    "nosamw": "1003520",
    "nama": "Hamzah Husain",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 2722200,
    "total_denda": 130000,
    "total_jumlah": 2852200,
    "lat": 0.5007143,
    "lng": 121.8951221,
    "color": "#dc3545"
}, {
    "nosamw": "1003219",
    "nama": "Ipa Kini",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4996192,
    "lng": 121.8928208,
    "color": "#ffc107"
}, {
    "nosamw": "1005706",
    "nama": "NORMA ABJUL",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2253500,
    "total_denda": 115000,
    "total_jumlah": 2368500,
    "lat": 0.499473,
    "lng": 121.8927997,
    "color": "#dc3545"
}, {
    "nosamw": "1003630",
    "nama": "Ramin Igirisa",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 5646500,
    "total_denda": 125000,
    "total_jumlah": 5771500,
    "lat": 0.5007751,
    "lng": 121.8934485,
    "color": "#dc3545"
}, {
    "nosamw": "1003888",
    "nama": "USAID Azis Datau",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1431800,
    "total_denda": 80000,
    "total_jumlah": 1511800,
    "lat": 0.5005716,
    "lng": 121.8975289,
    "color": "#dc3545"
}, {
    "nosamw": "1003831",
    "nama": "USAID Halim Walangadi",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 1312200,
    "total_denda": 140000,
    "total_jumlah": 1452200,
    "lat": 0.5005223,
    "lng": 121.8974035,
    "color": "#dc3545"
}, {
    "nosamw": "1003834",
    "nama": "USAID Risna Hamid",
    "kecamatan": "KEC DUHIADAA DESA MEKAR JAYA",
    "desa": "MEKAR JAYA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 863000,
    "total_denda": 130000,
    "total_jumlah": 993000,
    "lat": 0.5010238,
    "lng": 121.8945119,
    "color": "#dc3545"
}, {
    "nosamw": "1003182",
    "nama": "Kumi Muhamad",
    "kecamatan": "KEC DUHIADAA DESA MOOTILANGO",
    "desa": "MOOTILANGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1645200,
    "total_denda": 120000,
    "total_jumlah": 1765200,
    "lat": 0.5001647,
    "lng": 121.8993833,
    "color": "#dc3545"
}, {
    "nosamw": "1004722",
    "nama": "Non Umar",
    "kecamatan": "KEC DUHIADAA DESA MOOTILANGO",
    "desa": "MOOTILANGO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449958,
    "lng": 121.938742,
    "color": "#28a745"
}, {
    "nosamw": "1005779",
    "nama": "SULEMAN ANWAR",
    "kecamatan": "KEC DUHIADAA DESA MOOTILANGO",
    "desa": "MOOTILANGO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.453177,
    "lng": 121.938658,
    "color": "#28a745"
}, {
    "nosamw": "1004085",
    "nama": "USAID Majid Datau",
    "kecamatan": "KEC DUHIADAA DESA MOOTILANGO",
    "desa": "MOOTILANGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1561500,
    "total_denda": 135000,
    "total_jumlah": 1696500,
    "lat": 0.5003736,
    "lng": 121.8977393,
    "color": "#dc3545"
}, {
    "nosamw": "1006345",
    "nama": "H18 DARNI ADIKO",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1500500,
    "total_denda": 70000,
    "total_jumlah": 1570500,
    "lat": 0.500312,
    "lng": 121.8991324,
    "color": "#dc3545"
}, {
    "nosamw": "1003285",
    "nama": "Habi Bumulo",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 3556600,
    "total_denda": 130000,
    "total_jumlah": 3686600,
    "lat": 0.5002928,
    "lng": 121.8991602,
    "color": "#dc3545"
}, {
    "nosamw": "1003191",
    "nama": "Ibrahim Tani",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 3946200,
    "total_denda": 130000,
    "total_jumlah": 4076200,
    "lat": 0.5005622,
    "lng": 121.8981247,
    "color": "#dc3545"
}, {
    "nosamw": "1002454",
    "nama": "Sartin Tani",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 926000,
    "total_denda": 95000,
    "total_jumlah": 1021000,
    "lat": 0.5005765,
    "lng": 121.8980797,
    "color": "#dc3545"
}, {
    "nosamw": "1003305",
    "nama": "Yamin Polumulo",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1601800,
    "total_denda": 160000,
    "total_jumlah": 1761800,
    "lat": 0.5005623,
    "lng": 121.8981579,
    "color": "#dc3545"
}, {
    "nosamw": "1005870",
    "nama": "YUYUN BUMULO",
    "kecamatan": "KEC DUHIADAA DESA PADENGO",
    "desa": "PADENGO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 219400,
    "total_denda": 15000,
    "total_jumlah": 234400,
    "lat": 0.5002098,
    "lng": 121.8991743,
    "color": "#fd7e14"
}, {
    "nosamw": "0200494",
    "nama": "AHMAD ALAMRI",
    "kecamatan": "KEC LEMITO DESA BABALONGE",
    "desa": "BABALONGE",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.5499153,
    "lng": 121.5720439,
    "color": "#fd7e14"
}, {
    "nosamw": "0201597",
    "nama": "Nikson Mukusibu",
    "kecamatan": "KEC LEMITO DESA BABALONGE",
    "desa": "BABALONGE",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 815000,
    "total_denda": 115000,
    "total_jumlah": 930000,
    "lat": 0.5683822,
    "lng": 121.5689794,
    "color": "#dc3545"
}, {
    "nosamw": "0200482",
    "nama": "Abas Tololiu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107500,
    "total_denda": 0,
    "total_jumlah": 107500,
    "lat": 0.5689789,
    "lng": 121.5691282,
    "color": "#ffc107"
}, {
    "nosamw": "0201009",
    "nama": "ABDUL KARIM YUNUS",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5627637,
    "lng": 121.5638305,
    "color": "#ffc107"
}, {
    "nosamw": "0200192",
    "nama": "Abdullah Biki",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 391300,
    "total_denda": 10000,
    "total_jumlah": 401300,
    "lat": 0.5603596,
    "lng": 121.5696211,
    "color": "#fd7e14"
}, {
    "nosamw": "0201783",
    "nama": "AGUS HURUDJI",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 7,
    "total_tagihan": 245000,
    "total_denda": 30000,
    "total_jumlah": 275000,
    "lat": 0.5439954,
    "lng": 121.5792103,
    "color": "#dc3545"
}, {
    "nosamw": "0201116",
    "nama": "Agustin Dulanimo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085217746434",
    "total_bulan": 5,
    "total_tagihan": 520600,
    "total_denda": 20000,
    "total_jumlah": 540600,
    "lat": 0.5691003,
    "lng": 121.5691658,
    "color": "#fd7e14"
}, {
    "nosamw": "0200885",
    "nama": "Alsa Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.562845,
    "lng": 121.5687833,
    "color": "#ffc107"
}, {
    "nosamw": "0200722",
    "nama": "Anas Labuga",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 180000,
    "total_denda": 20000,
    "total_jumlah": 200000,
    "lat": 0.5509741,
    "lng": 121.5701297,
    "color": "#fd7e14"
}, {
    "nosamw": "0200572",
    "nama": "Anis Haniu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5627302,
    "lng": 121.5650337,
    "color": "#ffc107"
}, {
    "nosamw": "0201742",
    "nama": "ASRA TAIB",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5605117,
    "lng": 121.5693165,
    "color": "#ffc107"
}, {
    "nosamw": "0200759",
    "nama": "Bahrun Olii",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 265500,
    "total_denda": 5000,
    "total_jumlah": 270500,
    "lat": 0.5619569,
    "lng": 121.5690741,
    "color": "#ffc107"
}, {
    "nosamw": "0200375",
    "nama": "Ben Masengge",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1355050,
    "total_denda": 85000,
    "total_jumlah": 1440050,
    "lat": 0.5683704,
    "lng": 121.5689583,
    "color": "#dc3545"
}, {
    "nosamw": "0201118",
    "nama": "Cana Tambe",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 144250,
    "total_denda": 5000,
    "total_jumlah": 149250,
    "lat": 0.5694351,
    "lng": 121.5693173,
    "color": "#ffc107"
}, {
    "nosamw": "0200272",
    "nama": "Darson Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 265250,
    "total_denda": 20000,
    "total_jumlah": 285250,
    "lat": 0.558385,
    "lng": 121.57019,
    "color": "#fd7e14"
}, {
    "nosamw": "0200512",
    "nama": "Fatma Poduengo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 877000,
    "total_denda": 125000,
    "total_jumlah": 1002000,
    "lat": 0.5670641,
    "lng": 121.5681731,
    "color": "#dc3545"
}, {
    "nosamw": "0200877",
    "nama": "Gowani Maliki",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5680612,
    "lng": 121.5686888,
    "color": "#fd7e14"
}, {
    "nosamw": "0201363",
    "nama": "H16 Abdul Rahman Ibrahim",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 400000,
    "total_denda": 50000,
    "total_jumlah": 450000,
    "lat": 0.5509703,
    "lng": 121.5708068,
    "color": "#dc3545"
}, {
    "nosamw": "0201247",
    "nama": "H16 AHMAD BUMULO",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.56269,
    "lng": 121.5648898,
    "color": "#ffc107"
}, {
    "nosamw": "0201305",
    "nama": "H16 Ani Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 872200,
    "total_denda": 95000,
    "total_jumlah": 967200,
    "lat": 0.5697154,
    "lng": 121.5695819,
    "color": "#dc3545"
}, {
    "nosamw": "0201222",
    "nama": "H16 Anwar Haniu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5684961,
    "lng": 121.5689709,
    "color": "#ffc107"
}, {
    "nosamw": "0201219",
    "nama": "H16 Imran Botutihe",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 115000,
    "total_denda": 5000,
    "total_jumlah": 120000,
    "lat": 0.55686,
    "lng": 121.5708872,
    "color": "#ffc107"
}, {
    "nosamw": "0201228",
    "nama": "H16 Ino Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 157800,
    "total_denda": 10000,
    "total_jumlah": 167800,
    "lat": 0.5681921,
    "lng": 121.5689465,
    "color": "#fd7e14"
}, {
    "nosamw": "0201227",
    "nama": "H16 Irmawati Hatama",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5673927,
    "lng": 121.5684446,
    "color": "#fd7e14"
}, {
    "nosamw": "0201213",
    "nama": "H16 Jauria Ahmad",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 93750,
    "total_denda": 5000,
    "total_jumlah": 98750,
    "lat": 0.5685546,
    "lng": 121.5690215,
    "color": "#ffc107"
}, {
    "nosamw": "0201214",
    "nama": "H16 Kartin Haniu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5678576,
    "lng": 121.5687854,
    "color": "#ffc107"
}, {
    "nosamw": "0201323",
    "nama": "H16 MANSUR PAKUDE",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.5543384,
    "lng": 121.571339,
    "color": "#ffc107"
}, {
    "nosamw": "0201303",
    "nama": "H16 Maryam Pasain",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5674139,
    "lng": 121.5684981,
    "color": "#ffc107"
}, {
    "nosamw": "0201215",
    "nama": "H16 Odi Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 120750,
    "total_denda": 5000,
    "total_jumlah": 125750,
    "lat": 0.5678728,
    "lng": 121.5686554,
    "color": "#ffc107"
}, {
    "nosamw": "0201216",
    "nama": "H16 Oki Taib",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 222200,
    "total_denda": 10000,
    "total_jumlah": 232200,
    "lat": 0.5660719,
    "lng": 121.5676801,
    "color": "#fd7e14"
}, {
    "nosamw": "0201217",
    "nama": "H16 Onis Hananu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "082192024351",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5678353,
    "lng": 121.5687423,
    "color": "#ffc107"
}, {
    "nosamw": "0201304",
    "nama": "H16 Roslan Datau",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 620000,
    "total_denda": 20000,
    "total_jumlah": 640000,
    "lat": 0.5674729,
    "lng": 121.5685449,
    "color": "#fd7e14"
}, {
    "nosamw": "0201309",
    "nama": "H16 Sindun Yasin",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 52600,
    "total_denda": 0,
    "total_jumlah": 52600,
    "lat": 0.5674842,
    "lng": 121.5685539,
    "color": "#ffc107"
}, {
    "nosamw": "0201308",
    "nama": "H16 Umar Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 423500,
    "total_denda": 40000,
    "total_jumlah": 463500,
    "lat": 0.5669625,
    "lng": 121.5681706,
    "color": "#dc3545"
}, {
    "nosamw": "0201307",
    "nama": "H16 Usman Datau",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5696991,
    "lng": 121.5695219,
    "color": "#fd7e14"
}, {
    "nosamw": "0201200",
    "nama": "H16 Yusuf Doholio",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5628707,
    "lng": 121.5654488,
    "color": "#ffc107"
}, {
    "nosamw": "0201429",
    "nama": "H18 DAENG AMBO",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5669782,
    "lng": 121.5672715,
    "color": "#ffc107"
}, {
    "nosamw": "0201425",
    "nama": "H18 FATMA PARANGI",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5644206,
    "lng": 121.567277,
    "color": "#ffc107"
}, {
    "nosamw": "0201426",
    "nama": "H18 ROSMITAWATI HANIU",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082316137221",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.5656317,
    "lng": 121.567459,
    "color": "#ffc107"
}, {
    "nosamw": "0201702",
    "nama": "H19 HATIJA HANIU",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.568249,
    "lng": 121.5701447,
    "color": "#ffc107"
}, {
    "nosamw": "0201763",
    "nama": "H19 HUSAI PASAI",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5669866,
    "lng": 121.5676131,
    "color": "#fd7e14"
}, {
    "nosamw": "0201734",
    "nama": "H19 MANDU IBRAHIM",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 179000,
    "total_denda": 20000,
    "total_jumlah": 199000,
    "lat": 0.5670519,
    "lng": 121.5682193,
    "color": "#fd7e14"
}, {
    "nosamw": "0201759",
    "nama": "H19 NINO WALUDAMBA",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 748000,
    "total_denda": 55000,
    "total_jumlah": 803000,
    "lat": 0.5670469,
    "lng": 121.5675425,
    "color": "#dc3545"
}, {
    "nosamw": "0201758",
    "nama": "H19 NUNU LATIF",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.566782,
    "lng": 121.5671587,
    "color": "#ffc107"
}, {
    "nosamw": "0201760",
    "nama": "H19 Rosna Biga",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5670643,
    "lng": 121.5675597,
    "color": "#ffc107"
}, {
    "nosamw": "0201730",
    "nama": "H19 SAIPUL PASAIN",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 84250,
    "total_denda": 5000,
    "total_jumlah": 89250,
    "lat": 0.5673468,
    "lng": 121.5684113,
    "color": "#ffc107"
}, {
    "nosamw": "0201765",
    "nama": "H19 SAMSU YUSUF",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5628833,
    "lng": 121.5661533,
    "color": "#ffc107"
}, {
    "nosamw": "0201761",
    "nama": "H19 WAROKAH HADJU",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "083839239145",
    "total_bulan": 3,
    "total_tagihan": 419450,
    "total_denda": 10000,
    "total_jumlah": 429450,
    "lat": 0.5668524,
    "lng": 121.5671649,
    "color": "#fd7e14"
}, {
    "nosamw": "0200869",
    "nama": "Hadijah Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 5000,
    "total_jumlah": 85000,
    "lat": 0.566195,
    "lng": 121.5677354,
    "color": "#ffc107"
}, {
    "nosamw": "0200677",
    "nama": "Hafid Alhadad",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5545546,
    "lng": 121.5713559,
    "color": "#ffc107"
}, {
    "nosamw": "0200688",
    "nama": "Hasan Maleo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66500,
    "total_denda": 0,
    "total_jumlah": 66500,
    "lat": 0.569216,
    "lng": 121.5691861,
    "color": "#ffc107"
}, {
    "nosamw": "0200676",
    "nama": "Hj. Djuwita Mohungo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5580217,
    "lng": 121.5705083,
    "color": "#ffc107"
}, {
    "nosamw": "0201120",
    "nama": "Ibrahim Yusup",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 632400,
    "total_denda": 35000,
    "total_jumlah": 667400,
    "lat": 0.5651948,
    "lng": 121.567493,
    "color": "#dc3545"
}, {
    "nosamw": "0200723",
    "nama": "Ida Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 140500,
    "total_denda": 0,
    "total_jumlah": 140500,
    "lat": 0.5666933,
    "lng": 121.5679973,
    "color": "#ffc107"
}, {
    "nosamw": "0200687",
    "nama": "Ilyas Umar",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5681372,
    "lng": 121.5689276,
    "color": "#ffc107"
}, {
    "nosamw": "0200377",
    "nama": "ISE BIKI",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 164000,
    "total_denda": 5000,
    "total_jumlah": 169000,
    "lat": 0.5603856,
    "lng": 121.569545,
    "color": "#ffc107"
}, {
    "nosamw": "0200865",
    "nama": "Jauria Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5678201,
    "lng": 121.5687868,
    "color": "#ffc107"
}, {
    "nosamw": "0201176",
    "nama": "Leni Moha",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 972000,
    "total_denda": 140000,
    "total_jumlah": 1112000,
    "lat": 0.5670523,
    "lng": 121.5681875,
    "color": "#dc3545"
}, {
    "nosamw": "0200443",
    "nama": "Mansur Lakadjo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5631733,
    "lng": 121.5487917,
    "color": "#ffc107"
}, {
    "nosamw": "0200878",
    "nama": "Marni Latif",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082187180210",
    "total_bulan": 11,
    "total_tagihan": 579750,
    "total_denda": 50000,
    "total_jumlah": 629750,
    "lat": 0.5695506,
    "lng": 121.5694739,
    "color": "#dc3545"
}, {
    "nosamw": "0200269",
    "nama": "Maryam Moha",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 618700,
    "total_denda": 35000,
    "total_jumlah": 653700,
    "lat": 0.5627229,
    "lng": 121.5645752,
    "color": "#dc3545"
}, {
    "nosamw": "0200280",
    "nama": "Maryam Pakude",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5541819,
    "lng": 121.5714059,
    "color": "#fd7e14"
}, {
    "nosamw": "0200678",
    "nama": "MARZUKI HULOPI",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 667600,
    "total_denda": 55000,
    "total_jumlah": 722600,
    "lat": 0.5508419,
    "lng": 121.5712759,
    "color": "#dc3545"
}, {
    "nosamw": "0201766",
    "nama": "MELIYANTI DAMA",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5639314,
    "lng": 121.5676016,
    "color": "#28a745"
}, {
    "nosamw": "0200122",
    "nama": "MERTA TOOY",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 548900,
    "total_denda": 10000,
    "total_jumlah": 558900,
    "lat": 0.5632757,
    "lng": 121.5681884,
    "color": "#fd7e14"
}, {
    "nosamw": "0200560",
    "nama": "Mesjid Al-Mukminin",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 112500,
    "total_denda": 5000,
    "total_jumlah": 117500,
    "lat": 0.5677581,
    "lng": 121.5686591,
    "color": "#ffc107"
}, {
    "nosamw": "0200974",
    "nama": "Momi Paue",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5657254,
    "lng": 121.5674426,
    "color": "#ffc107"
}, {
    "nosamw": "0200518",
    "nama": "Nawab Amana",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 55000,
    "total_jumlah": 720000,
    "lat": 0.5660032,
    "lng": 121.5675199,
    "color": "#dc3545"
}, {
    "nosamw": "0200230",
    "nama": "Ningsi Hunowu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5438833,
    "lng": 121.5729,
    "color": "#ffc107"
}, {
    "nosamw": "0201119",
    "nama": "Nirmala Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 121250,
    "total_denda": 5000,
    "total_jumlah": 126250,
    "lat": 0.569485,
    "lng": 121.5693535,
    "color": "#ffc107"
}, {
    "nosamw": "0200041",
    "nama": "NUR GUSU",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5583026,
    "lng": 121.5703862,
    "color": "#ffc107"
}, {
    "nosamw": "0200872",
    "nama": "Nurhayati Haniu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081355123901",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5654667,
    "lng": 121.5674867,
    "color": "#ffc107"
}, {
    "nosamw": "0200126",
    "nama": "Rahmad M",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5623585,
    "lng": 121.5691615,
    "color": "#ffc107"
}, {
    "nosamw": "0200357",
    "nama": "Raya Pakaya",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 249400,
    "total_denda": 5000,
    "total_jumlah": 254400,
    "lat": 0.5627505,
    "lng": 121.5655327,
    "color": "#ffc107"
}, {
    "nosamw": "0200887",
    "nama": "Roslin Umar",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5628218,
    "lng": 121.5646865,
    "color": "#ffc107"
}, {
    "nosamw": "0201611",
    "nama": "RUSDIN PAKUDE",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5542743,
    "lng": 121.5714,
    "color": "#ffc107"
}, {
    "nosamw": "0200249",
    "nama": "Saiful Pakaya",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.466635,
    "lng": 121.949521,
    "color": "#ffc107"
}, {
    "nosamw": "0201770",
    "nama": "SARTIN NIHE",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 6,
    "total_tagihan": 224250,
    "total_denda": 30000,
    "total_jumlah": 254250,
    "lat": 0.5690716,
    "lng": 121.569155,
    "color": "#fd7e14"
}, {
    "nosamw": "0200868",
    "nama": "Sukrin Tololiu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 377900,
    "total_denda": 5000,
    "total_jumlah": 382900,
    "lat": 0.5638506,
    "lng": 121.5672315,
    "color": "#ffc107"
}, {
    "nosamw": "0201428",
    "nama": "Sumardan Moyo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 213250,
    "total_denda": 10000,
    "total_jumlah": 223250,
    "lat": 0.5537168,
    "lng": 121.5715903,
    "color": "#fd7e14"
}, {
    "nosamw": "0201131",
    "nama": "Suud Tangahu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5585718,
    "lng": 121.5702325,
    "color": "#ffc107"
}, {
    "nosamw": "0201122",
    "nama": "Taufik Guamo",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5690624,
    "lng": 121.5691195,
    "color": "#fd7e14"
}, {
    "nosamw": "0200213",
    "nama": "TK. Handayani",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5556866,
    "lng": 121.571129,
    "color": "#ffc107"
}, {
    "nosamw": "0201173",
    "nama": "Umar Hunowu",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 629800,
    "total_denda": 20000,
    "total_jumlah": 649800,
    "lat": 0.5662143,
    "lng": 121.5676983,
    "color": "#fd7e14"
}, {
    "nosamw": "0200892",
    "nama": "Umar Tooy",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.562949,
    "lng": 121.5684142,
    "color": "#fd7e14"
}, {
    "nosamw": "0200358",
    "nama": "Umar Van Gobel",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5553564,
    "lng": 121.5712457,
    "color": "#fd7e14"
}, {
    "nosamw": "0200977",
    "nama": "USAID Djamila Monoarfa",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5559885,
    "lng": 121.5710769,
    "color": "#ffc107"
}, {
    "nosamw": "0200992",
    "nama": "USAID Ibrahim Kadir",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 148500,
    "total_denda": 5000,
    "total_jumlah": 153500,
    "lat": 0.5539665,
    "lng": 121.5715301,
    "color": "#ffc107"
}, {
    "nosamw": "0200981",
    "nama": "USAID Ishak Kadir",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 420000,
    "total_denda": 55000,
    "total_jumlah": 475000,
    "lat": 0.5539467,
    "lng": 121.5715671,
    "color": "#dc3545"
}, {
    "nosamw": "0201777",
    "nama": "WIWIN ADAM, S.Pd.I",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 2,
    "total_tagihan": 287100,
    "total_denda": 5000,
    "total_jumlah": 292100,
    "lat": 0.562727,
    "lng": 121.5637454,
    "color": "#ffc107"
}, {
    "nosamw": "0200870",
    "nama": "Yusrin Kaune",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1513100,
    "total_denda": 80000,
    "total_jumlah": 1593100,
    "lat": 0.5646657,
    "lng": 121.5673087,
    "color": "#dc3545"
}, {
    "nosamw": "0200391",
    "nama": "ZEIN LATIF",
    "kecamatan": "KEC LEMITO DESA KENARI",
    "desa": "KENARI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 245000,
    "total_denda": 30000,
    "total_jumlah": 275000,
    "lat": 0.5692856,
    "lng": 121.5691853,
    "color": "#dc3545"
}, {
    "nosamw": "0200102",
    "nama": "A. Doholio",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": null,
    "total_bulan": 5,
    "total_tagihan": 185000,
    "total_denda": 20000,
    "total_jumlah": 205000,
    "lat": 0.5458813,
    "lng": 121.5726698,
    "color": "#fd7e14"
}, {
    "nosamw": "0200147",
    "nama": "A. H. Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 193600,
    "total_denda": 15000,
    "total_jumlah": 208600,
    "lat": 0.5415808,
    "lng": 121.5732398,
    "color": "#fd7e14"
}, {
    "nosamw": "0200171",
    "nama": "A. Lanapa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5366035,
    "lng": 121.5732985,
    "color": "#28a745"
}, {
    "nosamw": "0200110",
    "nama": "A. Poduengo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 188500,
    "total_denda": 5000,
    "total_jumlah": 193500,
    "lat": 0.5468575,
    "lng": 121.5707449,
    "color": "#ffc107"
}, {
    "nosamw": "0200086",
    "nama": "A. W. Bula",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 310400,
    "total_denda": 10000,
    "total_jumlah": 320400,
    "lat": 0.53595,
    "lng": 121.5723983,
    "color": "#ffc107"
}, {
    "nosamw": "0200475",
    "nama": "ABD MANAF LONTANG",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2117100,
    "total_denda": 105000,
    "total_jumlah": 2222100,
    "lat": 0.540146,
    "lng": 121.5714798,
    "color": "#dc3545"
}, {
    "nosamw": "0200231",
    "nama": "Abd Rahman Daiponta",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 319750,
    "total_denda": 20000,
    "total_jumlah": 339750,
    "lat": 0.5392551,
    "lng": 121.570592,
    "color": "#fd7e14"
}, {
    "nosamw": "0200673",
    "nama": "Abd. Karim Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5405187,
    "lng": 121.5717201,
    "color": "#ffc107"
}, {
    "nosamw": "0200467",
    "nama": "Abd. Rahman Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466704,
    "lng": 121.949675,
    "color": "#28a745"
}, {
    "nosamw": "0201159",
    "nama": "Abdan Mohungo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.5588842,
    "lng": 121.5701452,
    "color": "#fd7e14"
}, {
    "nosamw": "0200404",
    "nama": "Abdul Rahman Abjul",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 440400,
    "total_denda": 15000,
    "total_jumlah": 455400,
    "lat": 0.5381694,
    "lng": 121.573339,
    "color": "#fd7e14"
}, {
    "nosamw": "0200797",
    "nama": "Abdulatif Sedi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5374548,
    "lng": 121.5737365,
    "color": "#28a745"
}, {
    "nosamw": "0200036",
    "nama": "Abubakar Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 712500,
    "total_denda": 70000,
    "total_jumlah": 782500,
    "lat": 0.5404398,
    "lng": 121.5732834,
    "color": "#dc3545"
}, {
    "nosamw": "0200822",
    "nama": "ADITYA DAIPONTE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.5334941,
    "lng": 121.5712106,
    "color": "#fd7e14"
}, {
    "nosamw": "0200006",
    "nama": "Afandi Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5381605,
    "lng": 121.5732914,
    "color": "#28a745"
}, {
    "nosamw": "0200662",
    "nama": "Agustin Hermonis",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 269000,
    "total_denda": 35000,
    "total_jumlah": 304000,
    "lat": 0.5397167,
    "lng": 121.5703246,
    "color": "#dc3545"
}, {
    "nosamw": "0200361",
    "nama": "Ahmad Dama",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 175900,
    "total_denda": 5000,
    "total_jumlah": 180900,
    "lat": 0.5447304,
    "lng": 121.5709411,
    "color": "#ffc107"
}, {
    "nosamw": "0200003",
    "nama": "Ahmad Harun",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5367131,
    "lng": 121.5730051,
    "color": "#28a745"
}, {
    "nosamw": "0200062",
    "nama": "Ajijah Aljufri",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 267000,
    "total_denda": 0,
    "total_jumlah": 267000,
    "lat": 0.5420743,
    "lng": 121.5731738,
    "color": "#ffc107"
}, {
    "nosamw": "0200785",
    "nama": "Alex Pangulu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5371093,
    "lng": 121.573674,
    "color": "#ffc107"
}, {
    "nosamw": "0200297",
    "nama": "Alwin Balide",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5335316,
    "lng": 121.5712567,
    "color": "#ffc107"
}, {
    "nosamw": "0200150",
    "nama": "Amir Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5405376,
    "lng": 121.5732881,
    "color": "#28a745"
}, {
    "nosamw": "0200779",
    "nama": "Amirudin Tahir",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5401325,
    "lng": 121.5687811,
    "color": "#ffc107"
}, {
    "nosamw": "0200323",
    "nama": "Amiruding Lion",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102000,
    "total_denda": 0,
    "total_jumlah": 102000,
    "lat": 0.5397932,
    "lng": 121.5701012,
    "color": "#ffc107"
}, {
    "nosamw": "0200832",
    "nama": "Amran Onte",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5328778,
    "lng": 121.5707507,
    "color": "#ffc107"
}, {
    "nosamw": "0200844",
    "nama": "Amran Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5332888,
    "lng": 121.5708271,
    "color": "#ffc107"
}, {
    "nosamw": "0200076",
    "nama": "Anis Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 219250,
    "total_denda": 15000,
    "total_jumlah": 234250,
    "lat": 0.5409487,
    "lng": 121.5713483,
    "color": "#fd7e14"
}, {
    "nosamw": "0200352",
    "nama": "Anis Sialo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1444600,
    "total_denda": 50000,
    "total_jumlah": 1494600,
    "lat": 0.53408,
    "lng": 121.571677,
    "color": "#dc3545"
}, {
    "nosamw": "0201654",
    "nama": "ANTI GAFAR",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2845650,
    "total_denda": 70000,
    "total_jumlah": 2915650,
    "lat": 0.5513983,
    "lng": 121.572125,
    "color": "#dc3545"
}, {
    "nosamw": "0201125",
    "nama": "Anton Abdulwahab",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5391354,
    "lng": 121.5701881,
    "color": "#28a745"
}, {
    "nosamw": "0200348",
    "nama": "Apu Andang",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5338295,
    "lng": 121.5715462,
    "color": "#ffc107"
}, {
    "nosamw": "0200400",
    "nama": "Arfan Hasan",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5408974,
    "lng": 121.5728276,
    "color": "#ffc107"
}, {
    "nosamw": "0200809",
    "nama": "ARIFIN DAIPONTA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 145000,
    "total_denda": 15000,
    "total_jumlah": 160000,
    "lat": 0.5360937,
    "lng": 121.5710758,
    "color": "#fd7e14"
}, {
    "nosamw": "0200637",
    "nama": "Arifin Onte",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 409700,
    "total_denda": 25000,
    "total_jumlah": 434700,
    "lat": 0.5357247,
    "lng": 121.5714961,
    "color": "#fd7e14"
}, {
    "nosamw": "0200205",
    "nama": "ARIPIN HAMU",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.5402033,
    "lng": 121.5714817,
    "color": "#ffc107"
}, {
    "nosamw": "0200415",
    "nama": "Arman Sarullah",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 923600,
    "total_denda": 35000,
    "total_jumlah": 958600,
    "lat": 0.5342521,
    "lng": 121.5718048,
    "color": "#dc3545"
}, {
    "nosamw": "0200309",
    "nama": "ARPAN BAKARI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 561000,
    "total_denda": 35000,
    "total_jumlah": 596000,
    "lat": 0.5447917,
    "lng": 121.5695767,
    "color": "#dc3545"
}, {
    "nosamw": "0200718",
    "nama": "Arpan Rahim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5396481,
    "lng": 121.5715061,
    "color": "#fd7e14"
}, {
    "nosamw": "0200484",
    "nama": "Aslam Hamu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 327500,
    "total_denda": 10000,
    "total_jumlah": 337500,
    "lat": 0.5396124,
    "lng": 121.5715334,
    "color": "#fd7e14"
}, {
    "nosamw": "0200202",
    "nama": "Asna Kadir",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 468600,
    "total_denda": 15000,
    "total_jumlah": 483600,
    "lat": 0.5408833,
    "lng": 121.571405,
    "color": "#fd7e14"
}, {
    "nosamw": "0201801",
    "nama": "ASNI OPI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5337435,
    "lng": 121.5715145,
    "color": "#fd7e14"
}, {
    "nosamw": "0200831",
    "nama": "ASRI OPI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5330705,
    "lng": 121.5707625,
    "color": "#ffc107"
}, {
    "nosamw": "0200426",
    "nama": "Asri Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 173600,
    "total_denda": 15000,
    "total_jumlah": 188600,
    "lat": 0.5339808,
    "lng": 121.5717194,
    "color": "#fd7e14"
}, {
    "nosamw": "0200016",
    "nama": "Aswin Daud",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5370643,
    "lng": 121.5732751,
    "color": "#28a745"
}, {
    "nosamw": "0200615",
    "nama": "Awin Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 490750,
    "total_denda": 55000,
    "total_jumlah": 545750,
    "lat": 0.5337331,
    "lng": 121.5707832,
    "color": "#dc3545"
}, {
    "nosamw": "0200830",
    "nama": "Aya Djaidin",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 558300,
    "total_denda": 40000,
    "total_jumlah": 598300,
    "lat": 0.533834,
    "lng": 121.5707696,
    "color": "#dc3545"
}, {
    "nosamw": "0200792",
    "nama": "Azis Laida",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 63500,
    "total_denda": 5000,
    "total_jumlah": 68500,
    "lat": 0.5368431,
    "lng": 121.5731529,
    "color": "#ffc107"
}, {
    "nosamw": "0200308",
    "nama": "Ben Hasan",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2368450,
    "total_denda": 80000,
    "total_jumlah": 2448450,
    "lat": 0.5396439,
    "lng": 121.5715266,
    "color": "#dc3545"
}, {
    "nosamw": "0200826",
    "nama": "Buhari Giasi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 783500,
    "total_denda": 40000,
    "total_jumlah": 823500,
    "lat": 0.5372945,
    "lng": 121.5732633,
    "color": "#dc3545"
}, {
    "nosamw": "0200337",
    "nama": "Buna S. Langke",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 360500,
    "total_denda": 0,
    "total_jumlah": 360500,
    "lat": 0.5335241,
    "lng": 121.5712504,
    "color": "#ffc107"
}, {
    "nosamw": "0200638",
    "nama": "Buting Nyong",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082189483697",
    "total_bulan": 7,
    "total_tagihan": 1681250,
    "total_denda": 30000,
    "total_jumlah": 1711250,
    "lat": 0.5344615,
    "lng": 121.5719258,
    "color": "#dc3545"
}, {
    "nosamw": "0201190",
    "nama": "Cahyani Mega Setya Datau",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 162500,
    "total_denda": 15000,
    "total_jumlah": 177500,
    "lat": 0.5343417,
    "lng": 121.5718595,
    "color": "#fd7e14"
}, {
    "nosamw": "0200665",
    "nama": "Candra Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5442918,
    "lng": 121.5726808,
    "color": "#ffc107"
}, {
    "nosamw": "0200786",
    "nama": "Candra Podungge",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 234000,
    "total_denda": 15000,
    "total_jumlah": 249000,
    "lat": 0.5329147,
    "lng": 121.5707144,
    "color": "#fd7e14"
}, {
    "nosamw": "0200080",
    "nama": "Daeng Bulla",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 935500,
    "total_denda": 110000,
    "total_jumlah": 1045500,
    "lat": 0.5356088,
    "lng": 121.5719341,
    "color": "#dc3545"
}, {
    "nosamw": "0201130",
    "nama": "Dani Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1101800,
    "total_denda": 25000,
    "total_jumlah": 1126800,
    "lat": 0.5389233,
    "lng": 121.57043,
    "color": "#fd7e14"
}, {
    "nosamw": "0200841",
    "nama": "Danial Pangalu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 868400,
    "total_denda": 25000,
    "total_jumlah": 893400,
    "lat": 0.5368588,
    "lng": 121.5729689,
    "color": "#fd7e14"
}, {
    "nosamw": "0200827",
    "nama": "Danial Pangulu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 357500,
    "total_denda": 45000,
    "total_jumlah": 402500,
    "lat": 0.5370584,
    "lng": 121.5736033,
    "color": "#dc3545"
}, {
    "nosamw": "0200125",
    "nama": "Darwin P.",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39750,
    "total_denda": 5000,
    "total_jumlah": 44750,
    "lat": 0.5389033,
    "lng": 121.5726395,
    "color": "#ffc107"
}, {
    "nosamw": "0200148",
    "nama": "Daud Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 36,
    "total_tagihan": 1985000,
    "total_denda": 175000,
    "total_jumlah": 2160000,
    "lat": 0.447564,
    "lng": 121.938694,
    "color": "#dc3545"
}, {
    "nosamw": "0200630",
    "nama": "Dikar Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1125000,
    "total_denda": 155000,
    "total_jumlah": 1280000,
    "lat": 0.535096,
    "lng": 121.5718308,
    "color": "#dc3545"
}, {
    "nosamw": "0200389",
    "nama": "Dinas Perikanan dan Kelautan",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 3235000,
    "total_denda": 35000,
    "total_jumlah": 3270000,
    "lat": 0.5438851,
    "lng": 121.5738339,
    "color": "#fd7e14"
}, {
    "nosamw": "0200032",
    "nama": "Edy Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2127000,
    "total_denda": 75000,
    "total_jumlah": 2202000,
    "lat": 0.5405172,
    "lng": 121.5716221,
    "color": "#dc3545"
}, {
    "nosamw": "0201100",
    "nama": "Elis Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.533534,
    "lng": 121.5712315,
    "color": "#ffc107"
}, {
    "nosamw": "0200597",
    "nama": "Eman Nune",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 754000,
    "total_denda": 110000,
    "total_jumlah": 864000,
    "lat": 0.5392548,
    "lng": 121.5706312,
    "color": "#dc3545"
}, {
    "nosamw": "0201803",
    "nama": "EPI BADARU",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "'082192024351",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5449025,
    "lng": 121.5694618,
    "color": "#ffc107"
}, {
    "nosamw": "0200381",
    "nama": "Erson Hamu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1064250,
    "total_denda": 50000,
    "total_jumlah": 1114250,
    "lat": 0.5401411,
    "lng": 121.5714669,
    "color": "#dc3545"
}, {
    "nosamw": "0201124",
    "nama": "Ervin Rahim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 25000,
    "total_jumlah": 200000,
    "lat": 0.5389244,
    "lng": 121.5705979,
    "color": "#fd7e14"
}, {
    "nosamw": "0200204",
    "nama": "ERWIN BUKOI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 897500,
    "total_denda": 20000,
    "total_jumlah": 917500,
    "lat": 0.5396685,
    "lng": 121.5734332,
    "color": "#fd7e14"
}, {
    "nosamw": "0200330",
    "nama": "FAHIMA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44000,
    "total_denda": 0,
    "total_jumlah": 44000,
    "lat": 0.5340562,
    "lng": 121.5716824,
    "color": "#ffc107"
}, {
    "nosamw": "0200294",
    "nama": "Fangki Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5409672,
    "lng": 121.5714611,
    "color": "#ffc107"
}, {
    "nosamw": "0201105",
    "nama": "Fasman Tane",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.5340881,
    "lng": 121.5716956,
    "color": "#fd7e14"
}, {
    "nosamw": "0200788",
    "nama": "Fatma Rauf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5371974,
    "lng": 121.5736904,
    "color": "#28a745"
}, {
    "nosamw": "0200782",
    "nama": "Fatma Suaib",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5402716,
    "lng": 121.5700987,
    "color": "#ffc107"
}, {
    "nosamw": "0201160",
    "nama": "FIRMANSYAH KABALMAIN",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 118500,
    "total_denda": 0,
    "total_jumlah": 118500,
    "lat": 0.5436001,
    "lng": 121.5738528,
    "color": "#ffc107"
}, {
    "nosamw": "0200304",
    "nama": "Fitrianingsi Bakari",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5388153,
    "lng": 121.5721542,
    "color": "#28a745"
}, {
    "nosamw": "0200189",
    "nama": "Gafar Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5431365,
    "lng": 121.5730835,
    "color": "#ffc107"
}, {
    "nosamw": "0200300",
    "nama": "GAMAR ALHASNI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 241000,
    "total_denda": 5000,
    "total_jumlah": 246000,
    "lat": 0.5422722,
    "lng": 121.5711622,
    "color": "#ffc107"
}, {
    "nosamw": "0200603",
    "nama": "Gunawan Biki",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5396185,
    "lng": 121.5715275,
    "color": "#ffc107"
}, {
    "nosamw": "0201284",
    "nama": "H16 Amin Suleman",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 641850,
    "total_denda": 50000,
    "total_jumlah": 691850,
    "lat": 0.5338387,
    "lng": 121.5715667,
    "color": "#dc3545"
}, {
    "nosamw": "0201358",
    "nama": "H16 Andi Sahir",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 863000,
    "total_denda": 80000,
    "total_jumlah": 943000,
    "lat": 0.534934,
    "lng": 121.5708839,
    "color": "#dc3545"
}, {
    "nosamw": "0201350",
    "nama": "H16 Arman Iyou",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5367587,
    "lng": 121.5733811,
    "color": "#28a745"
}, {
    "nosamw": "0201293",
    "nama": "H16 Badayung Epus",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1435400,
    "total_denda": 70000,
    "total_jumlah": 1505400,
    "lat": 0.534898,
    "lng": 121.5720743,
    "color": "#dc3545"
}, {
    "nosamw": "0201275",
    "nama": "H16 Dodi Lacing",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 132000,
    "total_denda": 15000,
    "total_jumlah": 147000,
    "lat": 0.532923,
    "lng": 121.5707377,
    "color": "#fd7e14"
}, {
    "nosamw": "0201292",
    "nama": "H16 Farlianto",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 254000,
    "total_denda": 15000,
    "total_jumlah": 269000,
    "lat": 0.5353692,
    "lng": 121.5718813,
    "color": "#fd7e14"
}, {
    "nosamw": "0201288",
    "nama": "H16 Femri Mutama",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5330023,
    "lng": 121.5707148,
    "color": "#ffc107"
}, {
    "nosamw": "0201289",
    "nama": "H16 Gadja Laini",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 225000,
    "total_denda": 25000,
    "total_jumlah": 250000,
    "lat": 0.5356189,
    "lng": 121.5710343,
    "color": "#fd7e14"
}, {
    "nosamw": "0201301",
    "nama": "H16 Harun Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5389148,
    "lng": 121.5710483,
    "color": "#28a745"
}, {
    "nosamw": "0201241",
    "nama": "H16 Husen Alhasni",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5423154,
    "lng": 121.5730319,
    "color": "#ffc107"
}, {
    "nosamw": "0201209",
    "nama": "H16 Iko  Sahir",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1091750,
    "total_denda": 40000,
    "total_jumlah": 1131750,
    "lat": 0.5350151,
    "lng": 121.5721518,
    "color": "#dc3545"
}, {
    "nosamw": "0201242",
    "nama": "H16 IRMAWATI. M ABD. WAHAB",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5367284,
    "lng": 121.5726302,
    "color": "#28a745"
}, {
    "nosamw": "0201345",
    "nama": "H16 Jadi Gaho",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 15000,
    "total_jumlah": 120000,
    "lat": 0.5363723,
    "lng": 121.5719314,
    "color": "#fd7e14"
}, {
    "nosamw": "0201196",
    "nama": "H16 Jerre",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.540139,
    "lng": 121.5687884,
    "color": "#ffc107"
}, {
    "nosamw": "0201273",
    "nama": "H16 Kisman Langke",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1161450,
    "total_denda": 60000,
    "total_jumlah": 1221450,
    "lat": 0.5325649,
    "lng": 121.5707387,
    "color": "#dc3545"
}, {
    "nosamw": "0201197",
    "nama": "H16 Marlina Lahiya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 720900,
    "total_denda": 25000,
    "total_jumlah": 745900,
    "lat": 0.5401085,
    "lng": 121.5694416,
    "color": "#fd7e14"
}, {
    "nosamw": "0201321",
    "nama": "H16 Masna Latif",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 637750,
    "total_denda": 60000,
    "total_jumlah": 697750,
    "lat": 0.5468354,
    "lng": 121.5709296,
    "color": "#dc3545"
}, {
    "nosamw": "0201276",
    "nama": "H16 Mikel Rindung",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 423500,
    "total_denda": 35000,
    "total_jumlah": 458500,
    "lat": 0.5352474,
    "lng": 121.571849,
    "color": "#dc3545"
}, {
    "nosamw": "0201356",
    "nama": "H16 Molondo Onte",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 570000,
    "total_denda": 75000,
    "total_jumlah": 645000,
    "lat": 0.5389214,
    "lng": 121.5705883,
    "color": "#dc3545"
}, {
    "nosamw": "0201278",
    "nama": "H16 Ones Sule",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 5000,
    "total_jumlah": 160500,
    "lat": 0.5333101,
    "lng": 121.5708264,
    "color": "#ffc107"
}, {
    "nosamw": "0201291",
    "nama": "H16 Pajar Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5352783,
    "lng": 121.5721833,
    "color": "#ffc107"
}, {
    "nosamw": "0201347",
    "nama": "H16 Rahmad Rivai",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5363659,
    "lng": 121.5719484,
    "color": "#ffc107"
}, {
    "nosamw": "0201281",
    "nama": "H16 Ramli Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5346598,
    "lng": 121.5719383,
    "color": "#fd7e14"
}, {
    "nosamw": "0201283",
    "nama": "H16 Reno Borman",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.534473,
    "lng": 121.5719308,
    "color": "#ffc107"
}, {
    "nosamw": "0201296",
    "nama": "H16 RISNA DJADANI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5329786,
    "lng": 121.5707047,
    "color": "#fd7e14"
}, {
    "nosamw": "0201238",
    "nama": "H16 Risno Bamu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 62000,
    "total_denda": 0,
    "total_jumlah": 62000,
    "lat": 0.540935,
    "lng": 121.5733527,
    "color": "#ffc107"
}, {
    "nosamw": "0201298",
    "nama": "H16 Riswan Laode",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 325000,
    "total_denda": 40000,
    "total_jumlah": 365000,
    "lat": 0.5328376,
    "lng": 121.5706878,
    "color": "#dc3545"
}, {
    "nosamw": "0201287",
    "nama": "H16 Santi Manto",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 75500,
    "total_denda": 0,
    "total_jumlah": 75500,
    "lat": 0.5362292,
    "lng": 121.571101,
    "color": "#ffc107"
}, {
    "nosamw": "0201299",
    "nama": "H16 Saprin Bulongkot",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5349251,
    "lng": 121.5709109,
    "color": "#ffc107"
}, {
    "nosamw": "0201280",
    "nama": "H16 Sili Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 200250,
    "total_denda": 20000,
    "total_jumlah": 220250,
    "lat": 0.5329741,
    "lng": 121.5707325,
    "color": "#fd7e14"
}, {
    "nosamw": "0201346",
    "nama": "H16 Sukrin Mustakim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5363488,
    "lng": 121.5719375,
    "color": "#ffc107"
}, {
    "nosamw": "0201210",
    "nama": "H16 Ulin Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 800450,
    "total_denda": 20000,
    "total_jumlah": 820450,
    "lat": 0.5342229,
    "lng": 121.5717826,
    "color": "#fd7e14"
}, {
    "nosamw": "0201199",
    "nama": "H16 Wiwin Hiola",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 1209100,
    "total_denda": 145000,
    "total_jumlah": 1354100,
    "lat": 0.5399048,
    "lng": 121.569001,
    "color": "#dc3545"
}, {
    "nosamw": "0201343",
    "nama": "H16 YUnus Lopuo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1063100,
    "total_denda": 130000,
    "total_jumlah": 1193100,
    "lat": 0.5361239,
    "lng": 121.5722529,
    "color": "#dc3545"
}, {
    "nosamw": "0201349",
    "nama": "H16 YUNUS MUSA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 167000,
    "total_denda": 20000,
    "total_jumlah": 187000,
    "lat": 0.5338459,
    "lng": 121.5715541,
    "color": "#fd7e14"
}, {
    "nosamw": "0201208",
    "nama": "H16 YUuyun Sahi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 149500,
    "total_denda": 15000,
    "total_jumlah": 164500,
    "lat": 0.5349629,
    "lng": 121.5720603,
    "color": "#fd7e14"
}, {
    "nosamw": "0201432",
    "nama": "H18 FATMAH SUAIB",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 495000,
    "total_denda": 45000,
    "total_jumlah": 540000,
    "lat": 0.5388415,
    "lng": 121.5721601,
    "color": "#dc3545"
}, {
    "nosamw": "0201431",
    "nama": "H18 ILHAM DAUD",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 265600,
    "total_denda": 10000,
    "total_jumlah": 275600,
    "lat": 0.539116,
    "lng": 121.571545,
    "color": "#ffc107"
}, {
    "nosamw": "0201751",
    "nama": "H19 DANIAN PANGULU",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 363000,
    "total_denda": 30000,
    "total_jumlah": 393000,
    "lat": 0.5360963,
    "lng": 121.5723453,
    "color": "#fd7e14"
}, {
    "nosamw": "0201664",
    "nama": "H19 MULYANA PASANDRE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 790150,
    "total_denda": 35000,
    "total_jumlah": 825150,
    "lat": 0.5355069,
    "lng": 121.5715313,
    "color": "#dc3545"
}, {
    "nosamw": "0200059",
    "nama": "Hadijah Ahmad",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 223000,
    "total_denda": 0,
    "total_jumlah": 223000,
    "lat": 0.479636,
    "lng": 121.954213,
    "color": "#ffc107"
}, {
    "nosamw": "0200035",
    "nama": "Hadijah Alhasni",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5398714,
    "lng": 121.5733515,
    "color": "#ffc107"
}, {
    "nosamw": "0200182",
    "nama": "Hafin Buko",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111000,
    "total_denda": 5000,
    "total_jumlah": 116000,
    "lat": 0.5375655,
    "lng": 121.5736333,
    "color": "#ffc107"
}, {
    "nosamw": "0200312",
    "nama": "Haika Darise",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 140250,
    "total_denda": 5000,
    "total_jumlah": 145250,
    "lat": 0.54719,
    "lng": 121.571545,
    "color": "#ffc107"
}, {
    "nosamw": "0200854",
    "nama": "Hairun Saleh",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 362000,
    "total_denda": 40000,
    "total_jumlah": 402000,
    "lat": 0.5386786,
    "lng": 121.5718134,
    "color": "#dc3545"
}, {
    "nosamw": "0200219",
    "nama": "Halima Soga",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5398137,
    "lng": 121.5696257,
    "color": "#ffc107"
}, {
    "nosamw": "0200133",
    "nama": "Hamid Alhadad",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 287800,
    "total_denda": 5000,
    "total_jumlah": 292800,
    "lat": 0.5553504,
    "lng": 121.5712795,
    "color": "#ffc107"
}, {
    "nosamw": "0200008",
    "nama": "Hamid Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 197200,
    "total_denda": 5000,
    "total_jumlah": 202200,
    "lat": 0.537136,
    "lng": 121.5731744,
    "color": "#ffc107"
}, {
    "nosamw": "0200515",
    "nama": "Hamid Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 225000,
    "total_denda": 0,
    "total_jumlah": 225000,
    "lat": 0.5405292,
    "lng": 121.5716845,
    "color": "#ffc107"
}, {
    "nosamw": "0200121",
    "nama": "Hariyanto Baderan",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1054000,
    "total_denda": 115000,
    "total_jumlah": 1169000,
    "lat": 0.5440057,
    "lng": 121.5728326,
    "color": "#dc3545"
}, {
    "nosamw": "0201769",
    "nama": "HARMIN TUE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5360906,
    "lng": 121.571029,
    "color": "#ffc107"
}, {
    "nosamw": "0200174",
    "nama": "Harun Doholio",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.5431405,
    "lng": 121.5710793,
    "color": "#fd7e14"
}, {
    "nosamw": "0200065",
    "nama": "Harun Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 60000,
    "total_jumlah": 725000,
    "lat": 0.5401901,
    "lng": 121.5733938,
    "color": "#dc3545"
}, {
    "nosamw": "0200697",
    "nama": "Harun Sardin",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 698000,
    "total_denda": 100000,
    "total_jumlah": 798000,
    "lat": 0.5471033,
    "lng": 121.5701967,
    "color": "#dc3545"
}, {
    "nosamw": "0200141",
    "nama": "HASANIA DJAKARIA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5418004,
    "lng": 121.5731355,
    "color": "#fd7e14"
}, {
    "nosamw": "0200106",
    "nama": "Hasna Ahmad",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 715400,
    "total_denda": 35000,
    "total_jumlah": 750400,
    "lat": 0.5367254,
    "lng": 121.5733707,
    "color": "#dc3545"
}, {
    "nosamw": "0200120",
    "nama": "Hasna Hulopi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5373726,
    "lng": 121.5737363,
    "color": "#28a745"
}, {
    "nosamw": "0200009",
    "nama": "Hasna T. Olii",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 505500,
    "total_denda": 25000,
    "total_jumlah": 530500,
    "lat": 0.5443371,
    "lng": 121.5727299,
    "color": "#fd7e14"
}, {
    "nosamw": "0200078",
    "nama": "Hati Balide",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082271551811",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5351996,
    "lng": 121.5722529,
    "color": "#ffc107"
}, {
    "nosamw": "0200763",
    "nama": "Hatija Monoarfa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5397953,
    "lng": 121.5701687,
    "color": "#ffc107"
}, {
    "nosamw": "0200596",
    "nama": "HENDRIK KULUPANI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 25000,
    "total_jumlah": 200000,
    "lat": 0.5387573,
    "lng": 121.5718074,
    "color": "#fd7e14"
}, {
    "nosamw": "0200796",
    "nama": "Herlina Jumaha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 465500,
    "total_denda": 40000,
    "total_jumlah": 505500,
    "lat": 0.5372981,
    "lng": 121.5737785,
    "color": "#dc3545"
}, {
    "nosamw": "0200666",
    "nama": "Herlina Soga",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.5472767,
    "lng": 121.57217,
    "color": "#ffc107"
}, {
    "nosamw": "0200774",
    "nama": "Herman",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5400917,
    "lng": 121.5731217,
    "color": "#28a745"
}, {
    "nosamw": "0200283",
    "nama": "Herman Zumaha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 179250,
    "total_denda": 10000,
    "total_jumlah": 189250,
    "lat": 0.5341618,
    "lng": 121.5718012,
    "color": "#ffc107"
}, {
    "nosamw": "0200505",
    "nama": "Herson Lihawa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 491800,
    "total_denda": 45000,
    "total_jumlah": 536800,
    "lat": 0.5430102,
    "lng": 121.5741701,
    "color": "#dc3545"
}, {
    "nosamw": "0201326",
    "nama": "Herson Lihawa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5370634,
    "lng": 121.5714956,
    "color": "#28a745"
}, {
    "nosamw": "0200049",
    "nama": "Hi. Taking",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.5477595,
    "lng": 121.5723909,
    "color": "#fd7e14"
}, {
    "nosamw": "0200399",
    "nama": "Hiko Usman",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 231000,
    "total_denda": 30000,
    "total_jumlah": 261000,
    "lat": 0.5399402,
    "lng": 121.5714599,
    "color": "#dc3545"
}, {
    "nosamw": "0200176",
    "nama": "Hindun Lahay",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5431376,
    "lng": 121.5731009,
    "color": "#ffc107"
}, {
    "nosamw": "0200808",
    "nama": "Hongkong Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5360707,
    "lng": 121.5710984,
    "color": "#ffc107"
}, {
    "nosamw": "0200823",
    "nama": "Husen Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39500,
    "total_denda": 0,
    "total_jumlah": 39500,
    "lat": 0.5339732,
    "lng": 121.5708571,
    "color": "#ffc107"
}, {
    "nosamw": "0200488",
    "nama": "Husin Halid",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 287000,
    "total_denda": 30000,
    "total_jumlah": 317000,
    "lat": 0.5414467,
    "lng": 121.571871,
    "color": "#dc3545"
}, {
    "nosamw": "0200094",
    "nama": "Ibrahim Abdulwahab",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5364962,
    "lng": 121.5728916,
    "color": "#28a745"
}, {
    "nosamw": "0200027",
    "nama": "Ida Alhasni",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5425083,
    "lng": 121.5718818,
    "color": "#ffc107"
}, {
    "nosamw": "0200807",
    "nama": "Idris Badaru",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 504000,
    "total_denda": 55000,
    "total_jumlah": 559000,
    "lat": 0.534279,
    "lng": 121.5718438,
    "color": "#dc3545"
}, {
    "nosamw": "0200322",
    "nama": "Idrus Gusani",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5451704,
    "lng": 121.5709079,
    "color": "#ffc107"
}, {
    "nosamw": "0200191",
    "nama": "Iis Lihawa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 254500,
    "total_denda": 20000,
    "total_jumlah": 274500,
    "lat": 0.5411883,
    "lng": 121.5713518,
    "color": "#fd7e14"
}, {
    "nosamw": "0200005",
    "nama": "IIS ULOLI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 195500,
    "total_denda": 0,
    "total_jumlah": 195500,
    "lat": 0.5368567,
    "lng": 121.57299,
    "color": "#ffc107"
}, {
    "nosamw": "0200326",
    "nama": "Iko Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 527500,
    "total_denda": 30000,
    "total_jumlah": 557500,
    "lat": 0.5453734,
    "lng": 121.5728518,
    "color": "#dc3545"
}, {
    "nosamw": "0200093",
    "nama": "Imran Lolonta",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 191000,
    "total_denda": 25000,
    "total_jumlah": 216000,
    "lat": 0.5362895,
    "lng": 121.5726771,
    "color": "#fd7e14"
}, {
    "nosamw": "0200173",
    "nama": "Imran Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 152400,
    "total_denda": 5000,
    "total_jumlah": 157400,
    "lat": 0.5401622,
    "lng": 121.5733155,
    "color": "#ffc107"
}, {
    "nosamw": "0200550",
    "nama": "Indo Nani",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5365168,
    "lng": 121.5720066,
    "color": "#28a745"
}, {
    "nosamw": "0200099",
    "nama": "Indra Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 806000,
    "total_denda": 45000,
    "total_jumlah": 851000,
    "lat": 0.5459625,
    "lng": 121.5709474,
    "color": "#dc3545"
}, {
    "nosamw": "0200752",
    "nama": "Irpan Akase",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5395454,
    "lng": 121.5715029,
    "color": "#ffc107"
}, {
    "nosamw": "0201787",
    "nama": "IRWAN ADAM",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 12,
    "total_tagihan": 425000,
    "total_denda": 55000,
    "total_jumlah": 480000,
    "lat": 0.5349578,
    "lng": 121.5709277,
    "color": "#dc3545"
}, {
    "nosamw": "0200369",
    "nama": "Ismail Saleh",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5350252,
    "lng": 121.5718534,
    "color": "#dc3545"
}, {
    "nosamw": "0200619",
    "nama": "Iwan Djaidin",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.533693,
    "lng": 121.5708143,
    "color": "#ffc107"
}, {
    "nosamw": "0200527",
    "nama": "Iwan Dundung",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5336619,
    "lng": 121.5714637,
    "color": "#ffc107"
}, {
    "nosamw": "0200338",
    "nama": "Iyam Podungge",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 55000,
    "total_jumlah": 720000,
    "lat": 0.447551,
    "lng": 121.938564,
    "color": "#dc3545"
}, {
    "nosamw": "0200079",
    "nama": "Jafar Bulla",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.5350253,
    "lng": 121.5718365,
    "color": "#ffc107"
}, {
    "nosamw": "0200154",
    "nama": "Juba Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.5389243,
    "lng": 121.5727122,
    "color": "#ffc107"
}, {
    "nosamw": "0200293",
    "nama": "Kamarudin Polumulo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 391750,
    "total_denda": 20000,
    "total_jumlah": 411750,
    "lat": 0.5359392,
    "lng": 121.5725956,
    "color": "#fd7e14"
}, {
    "nosamw": "0200054",
    "nama": "Karamat Katili",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5375006,
    "lng": 121.5732297,
    "color": "#28a745"
}, {
    "nosamw": "0200295",
    "nama": "Karim Bula",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 225250,
    "total_denda": 5000,
    "total_jumlah": 230250,
    "lat": 0.5338493,
    "lng": 121.5715627,
    "color": "#ffc107"
}, {
    "nosamw": "0200815",
    "nama": "Karlina Mahabi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 243250,
    "total_denda": 15000,
    "total_jumlah": 258250,
    "lat": 0.5434495,
    "lng": 121.5716926,
    "color": "#fd7e14"
}, {
    "nosamw": "0200814",
    "nama": "Karsum van Gobel",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 180000,
    "total_denda": 20000,
    "total_jumlah": 200000,
    "lat": 0.5420966,
    "lng": 121.5713191,
    "color": "#fd7e14"
}, {
    "nosamw": "0200064",
    "nama": "KARTIN NOIS",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.534158,
    "lng": 121.5717733,
    "color": "#ffc107"
}, {
    "nosamw": "0200525",
    "nama": "Kasim Totoyi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5343348,
    "lng": 121.5718448,
    "color": "#ffc107"
}, {
    "nosamw": "0201789",
    "nama": "KISA SULEH",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 8,
    "total_tagihan": 1339800,
    "total_denda": 35000,
    "total_jumlah": 1374800,
    "lat": 0.5327727,
    "lng": 121.5706904,
    "color": "#dc3545"
}, {
    "nosamw": "0201114",
    "nama": "Kisman Laini",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5357841,
    "lng": 121.57145,
    "color": "#ffc107"
}, {
    "nosamw": "0200356",
    "nama": "Ktr. Camat Lemito",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 205000,
    "total_denda": 5000,
    "total_jumlah": 210000,
    "lat": 0.5417083,
    "lng": 121.5723033,
    "color": "#ffc107"
}, {
    "nosamw": "0200483",
    "nama": "KUA Lemito",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1197500,
    "total_denda": 65000,
    "total_jumlah": 1262500,
    "lat": 0.5415383,
    "lng": 121.571835,
    "color": "#fd7e14"
}, {
    "nosamw": "0200577",
    "nama": "Lan Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 172500,
    "total_denda": 5000,
    "total_jumlah": 177500,
    "lat": 0.5388447,
    "lng": 121.5725855,
    "color": "#ffc107"
}, {
    "nosamw": "0200046",
    "nama": "Leni Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.540411,
    "lng": 121.5711799,
    "color": "#fd7e14"
}, {
    "nosamw": "0200208",
    "nama": "Lexi Idris",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082292354181",
    "total_bulan": 13,
    "total_tagihan": 3955900,
    "total_denda": 60000,
    "total_jumlah": 4015900,
    "lat": 0.543085,
    "lng": 121.57318,
    "color": "#dc3545"
}, {
    "nosamw": "0200802",
    "nama": "Lilis Rahim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5374665,
    "lng": 121.5737315,
    "color": "#28a745"
}, {
    "nosamw": "0200026",
    "nama": "M. R. Laisa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 546750,
    "total_denda": 25000,
    "total_jumlah": 571750,
    "lat": 0.5374867,
    "lng": 121.573265,
    "color": "#fd7e14"
}, {
    "nosamw": "0200259",
    "nama": "Mahmud Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5388728,
    "lng": 121.5730558,
    "color": "#ffc107"
}, {
    "nosamw": "0201461",
    "nama": "MARYAM AKUBA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 320000,
    "total_denda": 40000,
    "total_jumlah": 360000,
    "lat": 0.55108,
    "lng": 121.57266,
    "color": "#dc3545"
}, {
    "nosamw": "0200514",
    "nama": "Maryam Lolonta",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 269000,
    "total_denda": 35000,
    "total_jumlah": 304000,
    "lat": 0.5402445,
    "lng": 121.5693993,
    "color": "#dc3545"
}, {
    "nosamw": "0200535",
    "nama": "Masdar Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 211250,
    "total_denda": 15000,
    "total_jumlah": 226250,
    "lat": 0.5337222,
    "lng": 121.5714836,
    "color": "#fd7e14"
}, {
    "nosamw": "0200362",
    "nama": "Masing Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5337067,
    "lng": 121.5715026,
    "color": "#ffc107"
}, {
    "nosamw": "0200235",
    "nama": "Masmad Ibrahim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5430731,
    "lng": 121.5731699,
    "color": "#ffc107"
}, {
    "nosamw": "0201773",
    "nama": "MASTINA HALIDO",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 9,
    "total_tagihan": 320000,
    "total_denda": 40000,
    "total_jumlah": 360000,
    "lat": 0.532728,
    "lng": 121.5707014,
    "color": "#dc3545"
}, {
    "nosamw": "0200793",
    "nama": "Maya Talango",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 697700,
    "total_denda": 25000,
    "total_jumlah": 722700,
    "lat": 0.5368032,
    "lng": 121.5736327,
    "color": "#fd7e14"
}, {
    "nosamw": "0200127",
    "nama": "MEI LISA PODUNGGE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155600,
    "total_denda": 5000,
    "total_jumlah": 160600,
    "lat": 0.5424797,
    "lng": 121.5730108,
    "color": "#ffc107"
}, {
    "nosamw": "0201447",
    "nama": "MEMO RAHIM",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 493750,
    "total_denda": 45000,
    "total_jumlah": 538750,
    "lat": 0.5367447,
    "lng": 121.5735142,
    "color": "#dc3545"
}, {
    "nosamw": "0200260",
    "nama": "Meri Abdullah",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5384987,
    "lng": 121.5734795,
    "color": "#ffc107"
}, {
    "nosamw": "0200346",
    "nama": "Mesjid \/ Saharudin Lagohe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 2545000,
    "total_denda": 40000,
    "total_jumlah": 2585000,
    "lat": 0.5333364,
    "lng": 121.5710866,
    "color": "#dc3545"
}, {
    "nosamw": "0200168",
    "nama": "Mesjid Al-Falah",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4000,
    "total_denda": 5000,
    "total_jumlah": 9000,
    "lat": 0.53916,
    "lng": 121.5703233,
    "color": "#ffc107"
}, {
    "nosamw": "0200248",
    "nama": "Mesjid AL-IKHLAS Lemito",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5372734,
    "lng": 121.5732117,
    "color": "#28a745"
}, {
    "nosamw": "0200339",
    "nama": "Mesjid Nur Ilahi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 35,
    "total_tagihan": 627500,
    "total_denda": 170000,
    "total_jumlah": 797500,
    "lat": 0.5347517,
    "lng": 121.5709243,
    "color": "#dc3545"
}, {
    "nosamw": "0200301",
    "nama": "Midun Umar",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5370905,
    "lng": 121.5735745,
    "color": "#28a745"
}, {
    "nosamw": "0200014",
    "nama": "Mohamad Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 432400,
    "total_denda": 5000,
    "total_jumlah": 437400,
    "lat": 0.539197,
    "lng": 121.5734313,
    "color": "#ffc107"
}, {
    "nosamw": "0200289",
    "nama": "Mudin Biki",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 592500,
    "total_denda": 50000,
    "total_jumlah": 642500,
    "lat": 0.5361518,
    "lng": 121.5727646,
    "color": "#dc3545"
}, {
    "nosamw": "0201756",
    "nama": "MUHAMAD SEDI",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5392989,
    "lng": 121.5734096,
    "color": "#ffc107"
}, {
    "nosamw": "0200818",
    "nama": "Muhana Laode",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5332861,
    "lng": 121.5708297,
    "color": "#ffc107"
}, {
    "nosamw": "0200084",
    "nama": "Muhdin Jumaha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.535985,
    "lng": 121.5726202,
    "color": "#ffc107"
}, {
    "nosamw": "0201799",
    "nama": "MUJAKIR DJUMAHA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5388537,
    "lng": 121.5722415,
    "color": "#ffc107"
}, {
    "nosamw": "0200077",
    "nama": "Mus Abdul Wahab",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5357698,
    "lng": 121.5723895,
    "color": "#28a745"
}, {
    "nosamw": "0200811",
    "nama": "Mustapa Pangulu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5386788,
    "lng": 121.5718162,
    "color": "#ffc107"
}, {
    "nosamw": "0200329",
    "nama": "Naba Udin Opy",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 206500,
    "total_denda": 15000,
    "total_jumlah": 221500,
    "lat": 0.533513,
    "lng": 121.5713481,
    "color": "#fd7e14"
}, {
    "nosamw": "0200663",
    "nama": "Nanang Sedi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 560000,
    "total_denda": 80000,
    "total_jumlah": 640000,
    "lat": 0.5376104,
    "lng": 121.5733529,
    "color": "#dc3545"
}, {
    "nosamw": "0200612",
    "nama": "Nasrun Iyako",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 907500,
    "total_denda": 15000,
    "total_jumlah": 922500,
    "lat": 0.5349188,
    "lng": 121.5708802,
    "color": "#fd7e14"
}, {
    "nosamw": "0200760",
    "nama": "Nelci Halid",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 335000,
    "total_denda": 40000,
    "total_jumlah": 375000,
    "lat": 0.5362506,
    "lng": 121.5721079,
    "color": "#dc3545"
}, {
    "nosamw": "0200762",
    "nama": "Neli Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5391904,
    "lng": 121.5733939,
    "color": "#28a745"
}, {
    "nosamw": "0200310",
    "nama": "Neni Halid",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 276000,
    "total_denda": 5000,
    "total_jumlah": 281000,
    "lat": 0.5417123,
    "lng": 121.5720197,
    "color": "#ffc107"
}, {
    "nosamw": "0201112",
    "nama": "Niko Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5337306,
    "lng": 121.5714587,
    "color": "#ffc107"
}, {
    "nosamw": "0200667",
    "nama": "Niko Komendangi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.5333265,
    "lng": 121.5709477,
    "color": "#ffc107"
}, {
    "nosamw": "0200264",
    "nama": "Niko Monoarfa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 717700,
    "total_denda": 20000,
    "total_jumlah": 737700,
    "lat": 0.537921,
    "lng": 121.5735832,
    "color": "#fd7e14"
}, {
    "nosamw": "0200082",
    "nama": "Niko Taib",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.537269,
    "lng": 121.5732463,
    "color": "#28a745"
}, {
    "nosamw": "0200290",
    "nama": "Nikson Harun",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 25000,
    "total_jumlah": 200000,
    "lat": 0.536474,
    "lng": 121.5719896,
    "color": "#fd7e14"
}, {
    "nosamw": "0201103",
    "nama": "Niman Humonggio",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5327161,
    "lng": 121.5707078,
    "color": "#ffc107"
}, {
    "nosamw": "0200801",
    "nama": "Norma Biya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 2553100,
    "total_denda": 80000,
    "total_jumlah": 2633100,
    "lat": 0.5433843,
    "lng": 121.5714552,
    "color": "#dc3545"
}, {
    "nosamw": "0200936",
    "nama": "Nou Ahmad",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5369817,
    "lng": 121.5731201,
    "color": "#28a745"
}, {
    "nosamw": "0201780",
    "nama": "NOVIA HARUN",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082238711790",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 25000,
    "total_jumlah": 200000,
    "lat": 0.5379532,
    "lng": 121.5711474,
    "color": "#fd7e14"
}, {
    "nosamw": "0200316",
    "nama": "Nunung Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 243500,
    "total_denda": 5000,
    "total_jumlah": 248500,
    "lat": 0.5350279,
    "lng": 121.5721421,
    "color": "#ffc107"
}, {
    "nosamw": "0201800",
    "nama": "NUR A. ISMAIL",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5365419,
    "lng": 121.572936,
    "color": "#28a745"
}, {
    "nosamw": "0200474",
    "nama": "Nurja Onte",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 108000,
    "total_denda": 5000,
    "total_jumlah": 113000,
    "lat": 0.5337085,
    "lng": 121.5714872,
    "color": "#ffc107"
}, {
    "nosamw": "0201489",
    "nama": "NURSIA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5399498,
    "lng": 121.5692239,
    "color": "#ffc107"
}, {
    "nosamw": "0200542",
    "nama": "Nurvivi Dano",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1274600,
    "total_denda": 30000,
    "total_jumlah": 1304600,
    "lat": 0.5410681,
    "lng": 121.5714818,
    "color": "#dc3545"
}, {
    "nosamw": "0200708",
    "nama": "Okmin Jailani",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5403764,
    "lng": 121.5731339,
    "color": "#fd7e14"
}, {
    "nosamw": "0200620",
    "nama": "One Sule",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5334855,
    "lng": 121.5711998,
    "color": "#ffc107"
}, {
    "nosamw": "0200060",
    "nama": "PARMAN",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5405915,
    "lng": 121.572055,
    "color": "#ffc107"
}, {
    "nosamw": "0200349",
    "nama": "Patra Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 62000,
    "total_denda": 0,
    "total_jumlah": 62000,
    "lat": 0.5339437,
    "lng": 121.5717142,
    "color": "#ffc107"
}, {
    "nosamw": "0200805",
    "nama": "Pini Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5349275,
    "lng": 121.5708891,
    "color": "#ffc107"
}, {
    "nosamw": "0200418",
    "nama": "Pipin Suko",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 325000,
    "total_denda": 30000,
    "total_jumlah": 355000,
    "lat": 0.5388471,
    "lng": 121.5721546,
    "color": "#dc3545"
}, {
    "nosamw": "0200201",
    "nama": "Raden Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 134750,
    "total_denda": 5000,
    "total_jumlah": 139750,
    "lat": 0.5454362,
    "lng": 121.570979,
    "color": "#ffc107"
}, {
    "nosamw": "0200342",
    "nama": "Rahman Jumaha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5389936,
    "lng": 121.5714717,
    "color": "#ffc107"
}, {
    "nosamw": "0200520",
    "nama": "Raina Towalu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5363091,
    "lng": 121.5727305,
    "color": "#ffc107"
}, {
    "nosamw": "0200296",
    "nama": "Ramdan Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 547500,
    "total_denda": 5000,
    "total_jumlah": 552500,
    "lat": 0.5425353,
    "lng": 121.5713664,
    "color": "#ffc107"
}, {
    "nosamw": "0200481",
    "nama": "Ramli Podungge",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5393172,
    "lng": 121.5701232,
    "color": "#ffc107"
}, {
    "nosamw": "0201362",
    "nama": "Rapika Olii",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 650000,
    "total_denda": 55000,
    "total_jumlah": 705000,
    "lat": 0.5329272,
    "lng": 121.5707371,
    "color": "#dc3545"
}, {
    "nosamw": "0200058",
    "nama": "Rasit Pakaya I",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.535558,
    "lng": 121.5719778,
    "color": "#ffc107"
}, {
    "nosamw": "0201110",
    "nama": "Raskun Andang",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 305000,
    "total_denda": 30000,
    "total_jumlah": 335000,
    "lat": 0.5338072,
    "lng": 121.5714661,
    "color": "#dc3545"
}, {
    "nosamw": "0200580",
    "nama": "Rasuna Abd. Wahab",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 91000,
    "total_denda": 0,
    "total_jumlah": 91000,
    "lat": 0.5349393,
    "lng": 121.5720328,
    "color": "#ffc107"
}, {
    "nosamw": "0200285",
    "nama": "Rasyid Abdjul",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 101500,
    "total_denda": 5000,
    "total_jumlah": 106500,
    "lat": 0.5401892,
    "lng": 121.5731168,
    "color": "#ffc107"
}, {
    "nosamw": "0200063",
    "nama": "RD. Camat 1",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 335000,
    "total_denda": 10000,
    "total_jumlah": 345000,
    "lat": 0.5409767,
    "lng": 121.5734224,
    "color": "#fd7e14"
}, {
    "nosamw": "0200164",
    "nama": "RD. Camat II",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 250500,
    "total_denda": 5000,
    "total_jumlah": 255500,
    "lat": 0.5417861,
    "lng": 121.5726698,
    "color": "#ffc107"
}, {
    "nosamw": "0200669",
    "nama": "Reno Adam",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 285000,
    "total_denda": 35000,
    "total_jumlah": 320000,
    "lat": 0.5342255,
    "lng": 121.5708505,
    "color": "#dc3545"
}, {
    "nosamw": "0200829",
    "nama": "Ridwan Langke",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5324802,
    "lng": 121.5707483,
    "color": "#fd7e14"
}, {
    "nosamw": "0200072",
    "nama": "Riki Tawaa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 146000,
    "total_denda": 5000,
    "total_jumlah": 151000,
    "lat": 0.5432285,
    "lng": 121.5738448,
    "color": "#ffc107"
}, {
    "nosamw": "0200594",
    "nama": "Riko Paduengo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 444250,
    "total_denda": 30000,
    "total_jumlah": 474250,
    "lat": 0.5396499,
    "lng": 121.5715062,
    "color": "#dc3545"
}, {
    "nosamw": "0200199",
    "nama": "Rona Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5408932,
    "lng": 121.5728167,
    "color": "#fd7e14"
}, {
    "nosamw": "0201342",
    "nama": "Roy Mahmud",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 566000,
    "total_denda": 85000,
    "total_jumlah": 651000,
    "lat": 0.5360757,
    "lng": 121.5723908,
    "color": "#dc3545"
}, {
    "nosamw": "0200057",
    "nama": "Rusmin Ahmad",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.540773,
    "lng": 121.5733153,
    "color": "#ffc107"
}, {
    "nosamw": "0200935",
    "nama": "Rustam Niati",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5368349,
    "lng": 121.5730656,
    "color": "#28a745"
}, {
    "nosamw": "0200101",
    "nama": "S. Daiponta",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5374612,
    "lng": 121.5734579,
    "color": "#28a745"
}, {
    "nosamw": "0200067",
    "nama": "S. H. Adjie",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5471244,
    "lng": 121.57248,
    "color": "#ffc107"
}, {
    "nosamw": "0200024",
    "nama": "S. Salawati",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5424579,
    "lng": 121.573005,
    "color": "#fd7e14"
}, {
    "nosamw": "0200108",
    "nama": "S. Usman",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.54058,
    "lng": 121.5713717,
    "color": "#ffc107"
}, {
    "nosamw": "0200017",
    "nama": "S. Waludamba",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1091800,
    "total_denda": 20000,
    "total_jumlah": 1111800,
    "lat": 0.5368367,
    "lng": 121.5730633,
    "color": "#fd7e14"
}, {
    "nosamw": "0200843",
    "nama": "Sadar Sahir",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5340654,
    "lng": 121.5716811,
    "color": "#fd7e14"
}, {
    "nosamw": "0200568",
    "nama": "Safrin Pilomonu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1768150,
    "total_denda": 80000,
    "total_jumlah": 1848150,
    "lat": 0.5392911,
    "lng": 121.5706176,
    "color": "#dc3545"
}, {
    "nosamw": "0201101",
    "nama": "Sahrun Tane",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 1751000,
    "total_denda": 135000,
    "total_jumlah": 1886000,
    "lat": 0.535557,
    "lng": 121.5719729,
    "color": "#dc3545"
}, {
    "nosamw": "0200073",
    "nama": "Said Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 555000,
    "total_denda": 25000,
    "total_jumlah": 580000,
    "lat": 0.5431988,
    "lng": 121.5730454,
    "color": "#fd7e14"
}, {
    "nosamw": "0200327",
    "nama": "Saiful Bula",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5334815,
    "lng": 121.5708262,
    "color": "#ffc107"
}, {
    "nosamw": "0201058",
    "nama": "Saiful Harun",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.5389255,
    "lng": 121.5710338,
    "color": "#fd7e14"
}, {
    "nosamw": "0200303",
    "nama": "Saiful Lahay",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456106,
    "lng": 121.936914,
    "color": "#28a745"
}, {
    "nosamw": "0200781",
    "nama": "Saiful Mambu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5390578,
    "lng": 121.5706079,
    "color": "#ffc107"
}, {
    "nosamw": "0200317",
    "nama": "Sakira Lahia",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1387350,
    "total_denda": 70000,
    "total_jumlah": 1457350,
    "lat": 0.5419316,
    "lng": 121.5713158,
    "color": "#dc3545"
}, {
    "nosamw": "0200390",
    "nama": "Salahudin Taib",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 274700,
    "total_denda": 15000,
    "total_jumlah": 289700,
    "lat": 0.5338998,
    "lng": 121.5708223,
    "color": "#fd7e14"
}, {
    "nosamw": "0200372",
    "nama": "Saleng Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1056500,
    "total_denda": 40000,
    "total_jumlah": 1096500,
    "lat": 0.5338357,
    "lng": 121.571559,
    "color": "#dc3545"
}, {
    "nosamw": "0200794",
    "nama": "Salma Kiba",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111000,
    "total_denda": 5000,
    "total_jumlah": 116000,
    "lat": 0.5376433,
    "lng": 121.5737483,
    "color": "#ffc107"
}, {
    "nosamw": "0200813",
    "nama": "Salma Yahidji",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5417455,
    "lng": 121.5729853,
    "color": "#fd7e14"
}, {
    "nosamw": "0200587",
    "nama": "Samardin Kango",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5457937,
    "lng": 121.57085,
    "color": "#fd7e14"
}, {
    "nosamw": "0200313",
    "nama": "Samsia Enteseo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5426481,
    "lng": 121.5712725,
    "color": "#ffc107"
}, {
    "nosamw": "0200659",
    "nama": "Samsudin Abd. Wahab",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 315000,
    "total_denda": 25000,
    "total_jumlah": 340000,
    "lat": 0.5396501,
    "lng": 121.5711695,
    "color": "#fd7e14"
}, {
    "nosamw": "0200824",
    "nama": "Samsudin Hulopi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5403791,
    "lng": 121.5694055,
    "color": "#ffc107"
}, {
    "nosamw": "0200758",
    "nama": "Samsudin Radjak",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5368637,
    "lng": 121.5735047,
    "color": "#ffc107"
}, {
    "nosamw": "0200299",
    "nama": "Samsudin Zumaha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5370898,
    "lng": 121.5736182,
    "color": "#ffc107"
}, {
    "nosamw": "0200618",
    "nama": "Sanyo Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 185000,
    "total_denda": 20000,
    "total_jumlah": 205000,
    "lat": 0.5334799,
    "lng": 121.5708244,
    "color": "#fd7e14"
}, {
    "nosamw": "0200639",
    "nama": "Sarco Pasandre",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 698350,
    "total_denda": 30000,
    "total_jumlah": 728350,
    "lat": 0.5328333,
    "lng": 121.5706884,
    "color": "#dc3545"
}, {
    "nosamw": "0200784",
    "nama": "Sarifudin Daud",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 199250,
    "total_denda": 25000,
    "total_jumlah": 224250,
    "lat": 0.5368513,
    "lng": 121.5734514,
    "color": "#fd7e14"
}, {
    "nosamw": "0200341",
    "nama": "Sarifudin Rauf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 73000,
    "total_denda": 5000,
    "total_jumlah": 78000,
    "lat": 0.5388741,
    "lng": 121.5726208,
    "color": "#ffc107"
}, {
    "nosamw": "0200640",
    "nama": "Saril Opi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 320000,
    "total_denda": 40000,
    "total_jumlah": 360000,
    "lat": 0.533009,
    "lng": 121.5707106,
    "color": "#dc3545"
}, {
    "nosamw": "0200757",
    "nama": "Sarintan AbdulLah",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 230000,
    "total_denda": 25000,
    "total_jumlah": 255000,
    "lat": 0.546795,
    "lng": 121.5716383,
    "color": "#fd7e14"
}, {
    "nosamw": "0200613",
    "nama": "Sarmin Manto",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 335750,
    "total_denda": 30000,
    "total_jumlah": 365750,
    "lat": 0.5350212,
    "lng": 121.5708875,
    "color": "#dc3545"
}, {
    "nosamw": "0200344",
    "nama": "Sartin Lasalutu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 40000,
    "total_jumlah": 485000,
    "lat": 0.5377317,
    "lng": 121.5734083,
    "color": "#dc3545"
}, {
    "nosamw": "0200010",
    "nama": "Sartono Haras",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085342828214",
    "total_bulan": 15,
    "total_tagihan": 2252150,
    "total_denda": 75000,
    "total_jumlah": 2327150,
    "lat": 0.5375408,
    "lng": 121.5733167,
    "color": "#dc3545"
}, {
    "nosamw": "0200210",
    "nama": "SATIMA ONTE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 193000,
    "total_denda": 5000,
    "total_jumlah": 198000,
    "lat": 0.5333167,
    "lng": 121.5711607,
    "color": "#ffc107"
}, {
    "nosamw": "0200288",
    "nama": "Sazo Opy",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 595000,
    "total_denda": 75000,
    "total_jumlah": 670000,
    "lat": 0.5349415,
    "lng": 121.5720965,
    "color": "#dc3545"
}, {
    "nosamw": "0201328",
    "nama": "SDN 08 LEMITO",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 201500,
    "total_denda": 30000,
    "total_jumlah": 231500,
    "lat": 0.5366089,
    "lng": 121.5712019,
    "color": "#fd7e14"
}, {
    "nosamw": "0200271",
    "nama": "SDN 10 Lemito",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1248100,
    "total_denda": 25000,
    "total_jumlah": 1273100,
    "lat": 0.5670304,
    "lng": 121.567291,
    "color": "#fd7e14"
}, {
    "nosamw": "0200355",
    "nama": "SDN. Lemito",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 329750,
    "total_denda": 10000,
    "total_jumlah": 339750,
    "lat": 0.5417159,
    "lng": 121.5713706,
    "color": "#fd7e14"
}, {
    "nosamw": "0200795",
    "nama": "Sefrin Soga",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 115750,
    "total_denda": 5000,
    "total_jumlah": 120750,
    "lat": 0.5388253,
    "lng": 121.5722239,
    "color": "#ffc107"
}, {
    "nosamw": "0200938",
    "nama": "Serly Ferensi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2610200,
    "total_denda": 70000,
    "total_jumlah": 2680200,
    "lat": 0.5360006,
    "lng": 121.5711102,
    "color": "#dc3545"
}, {
    "nosamw": "0200351",
    "nama": "Simin L",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 133500,
    "total_denda": 10000,
    "total_jumlah": 143500,
    "lat": 0.5455774,
    "lng": 121.5708819,
    "color": "#fd7e14"
}, {
    "nosamw": "0200124",
    "nama": "SONI DJAKATARA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5422478,
    "lng": 121.5711633,
    "color": "#ffc107"
}, {
    "nosamw": "0200819",
    "nama": "Suar Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5357083,
    "lng": 121.5710564,
    "color": "#fd7e14"
}, {
    "nosamw": "0200325",
    "nama": "Suharti Podungge",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 245000,
    "total_denda": 30000,
    "total_jumlah": 275000,
    "lat": 0.5419663,
    "lng": 121.5731211,
    "color": "#dc3545"
}, {
    "nosamw": "0200798",
    "nama": "Suleman Pangulu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5467417,
    "lng": 121.570655,
    "color": "#fd7e14"
}, {
    "nosamw": "0200833",
    "nama": "Sunaini Laode",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 836800,
    "total_denda": 65000,
    "total_jumlah": 901800,
    "lat": 0.532729,
    "lng": 121.5707088,
    "color": "#dc3545"
}, {
    "nosamw": "0201104",
    "nama": "Sunin Prensi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5354861,
    "lng": 121.5715351,
    "color": "#ffc107"
}, {
    "nosamw": "0200228",
    "nama": "Susan Ismail",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 420000,
    "total_denda": 20000,
    "total_jumlah": 440000,
    "lat": 0.5415441,
    "lng": 121.5734115,
    "color": "#fd7e14"
}, {
    "nosamw": "0200119",
    "nama": "Suut Balide",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1804000,
    "total_denda": 65000,
    "total_jumlah": 1869000,
    "lat": 0.5369267,
    "lng": 121.5734933,
    "color": "#dc3545"
}, {
    "nosamw": "0200632",
    "nama": "Syaipul Sahi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 125000,
    "total_denda": 10000,
    "total_jumlah": 135000,
    "lat": 0.5355808,
    "lng": 121.5710238,
    "color": "#fd7e14"
}, {
    "nosamw": "0200789",
    "nama": "Tahir Lolento",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 560500,
    "total_denda": 35000,
    "total_jumlah": 595500,
    "lat": 0.538767,
    "lng": 121.5717508,
    "color": "#dc3545"
}, {
    "nosamw": "0200641",
    "nama": "Talib Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5332235,
    "lng": 121.5707985,
    "color": "#ffc107"
}, {
    "nosamw": "0201108",
    "nama": "Tamrin Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1560200,
    "total_denda": 85000,
    "total_jumlah": 1645200,
    "lat": 0.470252,
    "lng": 121.942647,
    "color": "#dc3545"
}, {
    "nosamw": "0200291",
    "nama": "Tasman Tane 2",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 48500,
    "total_denda": 0,
    "total_jumlah": 48500,
    "lat": 0.5344588,
    "lng": 121.5708942,
    "color": "#ffc107"
}, {
    "nosamw": "0200306",
    "nama": "Taufik Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 125500,
    "total_denda": 5000,
    "total_jumlah": 130500,
    "lat": 0.5427447,
    "lng": 121.5717902,
    "color": "#ffc107"
}, {
    "nosamw": "0200302",
    "nama": "Tekson Harun",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5361853,
    "lng": 121.5726443,
    "color": "#28a745"
}, {
    "nosamw": "0200012",
    "nama": "Teni Haras",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2283750,
    "total_denda": 75000,
    "total_jumlah": 2358750,
    "lat": 0.5365041,
    "lng": 121.5728343,
    "color": "#dc3545"
}, {
    "nosamw": "0200139",
    "nama": "Tino Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5366812,
    "lng": 121.5729584,
    "color": "#28a745"
}, {
    "nosamw": "0200712",
    "nama": "Trisey Balide",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 106250,
    "total_denda": 5000,
    "total_jumlah": 111250,
    "lat": 0.5368091,
    "lng": 121.5724351,
    "color": "#ffc107"
}, {
    "nosamw": "0200806",
    "nama": "Uci Andang",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5339341,
    "lng": 121.5708864,
    "color": "#28a745"
}, {
    "nosamw": "0200616",
    "nama": "Udin Duko",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 539500,
    "total_denda": 30000,
    "total_jumlah": 569500,
    "lat": 0.5355982,
    "lng": 121.571033,
    "color": "#dc3545"
}, {
    "nosamw": "0200846",
    "nama": "Udin Ladiku",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 342000,
    "total_denda": 30000,
    "total_jumlah": 372000,
    "lat": 0.5670666,
    "lng": 121.5683591,
    "color": "#dc3545"
}, {
    "nosamw": "0200034",
    "nama": "Umar Alhasni",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5401051,
    "lng": 121.5731443,
    "color": "#28a745"
}, {
    "nosamw": "0200194",
    "nama": "Umar Kembe",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 130000,
    "total_denda": 5000,
    "total_jumlah": 135000,
    "lat": 0.5435174,
    "lng": 121.5736093,
    "color": "#ffc107"
}, {
    "nosamw": "0200233",
    "nama": "Umar Moodumbi",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 755200,
    "total_denda": 35000,
    "total_jumlah": 790200,
    "lat": 0.5431426,
    "lng": 121.5731209,
    "color": "#dc3545"
}, {
    "nosamw": "0200783",
    "nama": "Undo Rahim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 385000,
    "total_denda": 50000,
    "total_jumlah": 435000,
    "lat": 0.5397346,
    "lng": 121.5696874,
    "color": "#dc3545"
}, {
    "nosamw": "0201007",
    "nama": "USAID Asia Mahabu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 3066700,
    "total_denda": 150000,
    "total_jumlah": 3216700,
    "lat": 0.5402501,
    "lng": 121.570089,
    "color": "#dc3545"
}, {
    "nosamw": "0200958",
    "nama": "USAID Darson Latif",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1656000,
    "total_denda": 120000,
    "total_jumlah": 1776000,
    "lat": 0.546665,
    "lng": 121.5707917,
    "color": "#dc3545"
}, {
    "nosamw": "0200955",
    "nama": "USAID Ghalib Djalim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5360377,
    "lng": 121.5723685,
    "color": "#28a745"
}, {
    "nosamw": "0200961",
    "nama": "USAID Hamid Olii",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5400221,
    "lng": 121.5695008,
    "color": "#ffc107"
}, {
    "nosamw": "0200950",
    "nama": "USAID Hania",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5403033,
    "lng": 121.5691433,
    "color": "#ffc107"
}, {
    "nosamw": "0201027",
    "nama": "USAID Jui Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5434463,
    "lng": 121.5742393,
    "color": "#ffc107"
}, {
    "nosamw": "0201040",
    "nama": "USAID KADIR ABAS",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 445400,
    "total_denda": 65000,
    "total_jumlah": 510400,
    "lat": 0.5389539,
    "lng": 121.5704249,
    "color": "#dc3545"
}, {
    "nosamw": "0201028",
    "nama": "USAID Nanang Niati",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5434183,
    "lng": 121.5742496,
    "color": "#ffc107"
}, {
    "nosamw": "0200956",
    "nama": "USAID Nuke Butolo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5401794,
    "lng": 121.5696892,
    "color": "#ffc107"
}, {
    "nosamw": "0200952",
    "nama": "USAID Olan Tangahu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 71500,
    "total_denda": 0,
    "total_jumlah": 71500,
    "lat": 0.5470217,
    "lng": 121.5702467,
    "color": "#ffc107"
}, {
    "nosamw": "0200964",
    "nama": "USAID Ramli Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.53887,
    "lng": 121.5714048,
    "color": "#ffc107"
}, {
    "nosamw": "0201010",
    "nama": "USAID SANTI WALUDAMBA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5373115,
    "lng": 121.5732732,
    "color": "#28a745"
}, {
    "nosamw": "0200962",
    "nama": "USAID Wati Suko",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44500,
    "total_denda": 5000,
    "total_jumlah": 49500,
    "lat": 0.5380773,
    "lng": 121.5711689,
    "color": "#ffc107"
}, {
    "nosamw": "0200947",
    "nama": "USAID Weni Djalim",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5394716,
    "lng": 121.5701193,
    "color": "#28a745"
}, {
    "nosamw": "0200949",
    "nama": "USAID Yanti Eyato",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2834250,
    "total_denda": 115000,
    "total_jumlah": 2949250,
    "lat": 0.5390927,
    "lng": 121.5702069,
    "color": "#dc3545"
}, {
    "nosamw": "0200983",
    "nama": "USAID.SOFYAN  SARDIN",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 88750,
    "total_denda": 5000,
    "total_jumlah": 93750,
    "lat": 0.5467769,
    "lng": 121.5706519,
    "color": "#ffc107"
}, {
    "nosamw": "0200953",
    "nama": "WAHYUDIN TUIYO",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 180000,
    "total_denda": 20000,
    "total_jumlah": 200000,
    "lat": 0.5397478,
    "lng": 121.5701744,
    "color": "#fd7e14"
}, {
    "nosamw": "0200787",
    "nama": "Wani Waludamba",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49250,
    "total_denda": 5000,
    "total_jumlah": 54250,
    "lat": 0.536855,
    "lng": 121.573678,
    "color": "#ffc107"
}, {
    "nosamw": "0200804",
    "nama": "WINDA LAROTE",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 945700,
    "total_denda": 55000,
    "total_jumlah": 1000700,
    "lat": 0.5340995,
    "lng": 121.5708566,
    "color": "#dc3545"
}, {
    "nosamw": "0200497",
    "nama": "Yamin Lasakowa",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 453000,
    "total_denda": 65000,
    "total_jumlah": 518000,
    "lat": 0.5414725,
    "lng": 121.5802446,
    "color": "#dc3545"
}, {
    "nosamw": "0200693",
    "nama": "Yanti S. Taha",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 167000,
    "total_denda": 20000,
    "total_jumlah": 187000,
    "lat": 0.5418896,
    "lng": 121.5731503,
    "color": "#fd7e14"
}, {
    "nosamw": "0200140",
    "nama": "Yasin Bulla",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 189250,
    "total_denda": 5000,
    "total_jumlah": 194250,
    "lat": 0.5344581,
    "lng": 121.5719207,
    "color": "#ffc107"
}, {
    "nosamw": "0201798",
    "nama": "YENI WALUDAMBA",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.5370617,
    "lng": 121.5714935,
    "color": "#ffc107"
}, {
    "nosamw": "0201772",
    "nama": "YULIN LAMBAKARANG",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5370547,
    "lng": 121.5731894,
    "color": "#28a745"
}, {
    "nosamw": "0200033",
    "nama": "Yunus Batalipu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 653750,
    "total_denda": 35000,
    "total_jumlah": 688750,
    "lat": 0.5431024,
    "lng": 121.5731386,
    "color": "#dc3545"
}, {
    "nosamw": "0200686",
    "nama": "Yunus Lolonto",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5388873,
    "lng": 121.5713716,
    "color": "#ffc107"
}, {
    "nosamw": "0200724",
    "nama": "Yunus Mantu",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 149000,
    "total_denda": 5000,
    "total_jumlah": 154000,
    "lat": 0.5420838,
    "lng": 121.573127,
    "color": "#ffc107"
}, {
    "nosamw": "0200015",
    "nama": "Yunus Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 515000,
    "total_denda": 5000,
    "total_jumlah": 520000,
    "lat": 0.5391559,
    "lng": 121.5732028,
    "color": "#ffc107"
}, {
    "nosamw": "0200305",
    "nama": "Yuri Hutaju",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5426459,
    "lng": 121.5712117,
    "color": "#ffc107"
}, {
    "nosamw": "0200845",
    "nama": "Yusni Manto",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5362632,
    "lng": 121.5711026,
    "color": "#28a745"
}, {
    "nosamw": "0200617",
    "nama": "Yusni Opy",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5334822,
    "lng": 121.5712239,
    "color": "#ffc107"
}, {
    "nosamw": "0200142",
    "nama": "Yusuf Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 370000,
    "total_denda": 30000,
    "total_jumlah": 400000,
    "lat": 0.5451766,
    "lng": 121.5727805,
    "color": "#dc3545"
}, {
    "nosamw": "0200839",
    "nama": "Yusuf Laode",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 80000,
    "total_denda": 0,
    "total_jumlah": 80000,
    "lat": 0.5338531,
    "lng": 121.5716686,
    "color": "#ffc107"
}, {
    "nosamw": "0200463",
    "nama": "Yusuf Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO",
    "desa": "LEMITO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1617750,
    "total_denda": 75000,
    "total_jumlah": 1692750,
    "lat": 0.5417655,
    "lng": 121.5719325,
    "color": "#dc3545"
}, {
    "nosamw": "0200045",
    "nama": "Ajis Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 301750,
    "total_denda": 5000,
    "total_jumlah": 306750,
    "lat": 0.5470248,
    "lng": 121.5728181,
    "color": "#ffc107"
}, {
    "nosamw": "0200767",
    "nama": "ANIS MOHA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 355750,
    "total_denda": 10000,
    "total_jumlah": 365750,
    "lat": 0.5678961,
    "lng": 121.5696013,
    "color": "#fd7e14"
}, {
    "nosamw": "0201794",
    "nama": "ANTONI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 1,
    "total_tagihan": 66500,
    "total_denda": 0,
    "total_jumlah": 66500,
    "lat": 0.5692061,
    "lng": 121.5698267,
    "color": "#ffc107"
}, {
    "nosamw": "0200331",
    "nama": "APIPA ISHAK",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39500,
    "total_denda": 0,
    "total_jumlah": 39500,
    "lat": 0.5462528,
    "lng": 121.5731129,
    "color": "#ffc107"
}, {
    "nosamw": "0200419",
    "nama": "Awaludin Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5452034,
    "lng": 121.5730817,
    "color": "#ffc107"
}, {
    "nosamw": "0200861",
    "nama": "Azis Tawaa",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 368950,
    "total_denda": 10000,
    "total_jumlah": 378950,
    "lat": 0.5691239,
    "lng": 121.5694806,
    "color": "#fd7e14"
}, {
    "nosamw": "0200234",
    "nama": "Beni Botutihe",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5493063,
    "lng": 121.5721992,
    "color": "#ffc107"
}, {
    "nosamw": "0200726",
    "nama": "Cano Latif",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1206750,
    "total_denda": 90000,
    "total_jumlah": 1296750,
    "lat": 0.5670415,
    "lng": 121.5682647,
    "color": "#dc3545"
}, {
    "nosamw": "0201161",
    "nama": "Darmis Suaib",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.550655,
    "lng": 121.57214,
    "color": "#ffc107"
}, {
    "nosamw": "0200455",
    "nama": "Dedi Tambe",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 1904250,
    "total_denda": 150000,
    "total_jumlah": 2054250,
    "lat": 0.5683267,
    "lng": 121.56894,
    "color": "#dc3545"
}, {
    "nosamw": "0201170",
    "nama": "Delyan Bunta",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5652136,
    "lng": 121.5674714,
    "color": "#fd7e14"
}, {
    "nosamw": "0200275",
    "nama": "Edy Monoarfa",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 96500,
    "total_denda": 0,
    "total_jumlah": 96500,
    "lat": 0.5541405,
    "lng": 121.5717154,
    "color": "#ffc107"
}, {
    "nosamw": "0200113",
    "nama": "Empi Tanoa",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5442513,
    "lng": 121.5729024,
    "color": "#ffc107"
}, {
    "nosamw": "0200278",
    "nama": "Erna Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 165000,
    "total_denda": 20000,
    "total_jumlah": 185000,
    "lat": 0.5445347,
    "lng": 121.5728864,
    "color": "#fd7e14"
}, {
    "nosamw": "0200656",
    "nama": "Fatma Doholio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 134800,
    "total_denda": 15000,
    "total_jumlah": 149800,
    "lat": 0.547715,
    "lng": 121.5706533,
    "color": "#fd7e14"
}, {
    "nosamw": "0201788",
    "nama": "FATMA S. HANIU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5682479,
    "lng": 121.5701665,
    "color": "#ffc107"
}, {
    "nosamw": "0200177",
    "nama": "Fresman Tanamati",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085340008781",
    "total_bulan": 12,
    "total_tagihan": 1045500,
    "total_denda": 55000,
    "total_jumlah": 1100500,
    "lat": 0.5472699,
    "lng": 121.5710898,
    "color": "#dc3545"
}, {
    "nosamw": "0200100",
    "nama": "Gani Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 477600,
    "total_denda": 10000,
    "total_jumlah": 487600,
    "lat": 0.54431,
    "lng": 121.5728983,
    "color": "#fd7e14"
}, {
    "nosamw": "0200090",
    "nama": "H. N. Bay",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082196770585",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 45000,
    "total_jumlah": 600000,
    "lat": 0.5471045,
    "lng": 121.572573,
    "color": "#dc3545"
}, {
    "nosamw": "0201235",
    "nama": "H16 ASTIN BAMU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 203500,
    "total_denda": 10000,
    "total_jumlah": 213500,
    "lat": 0.5647439,
    "lng": 121.5674153,
    "color": "#fd7e14"
}, {
    "nosamw": "0201331",
    "nama": "H16 Bernard Mardani",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 154000,
    "total_denda": 5000,
    "total_jumlah": 159000,
    "lat": 0.5479516,
    "lng": 121.5726431,
    "color": "#ffc107"
}, {
    "nosamw": "0201248",
    "nama": "H16 David Komendang",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 295500,
    "total_denda": 30000,
    "total_jumlah": 325500,
    "lat": 0.5506518,
    "lng": 121.5700793,
    "color": "#dc3545"
}, {
    "nosamw": "0201232",
    "nama": "H16 Kaprin Ali",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 375750,
    "total_denda": 30000,
    "total_jumlah": 405750,
    "lat": 0.5605117,
    "lng": 121.57014,
    "color": "#dc3545"
}, {
    "nosamw": "0201255",
    "nama": "H16 Kartin Yunus",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2143900,
    "total_denda": 75000,
    "total_jumlah": 2218900,
    "lat": 0.548698,
    "lng": 121.5726974,
    "color": "#dc3545"
}, {
    "nosamw": "0201352",
    "nama": "H16 Mesta Bamu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5550317,
    "lng": 121.571555,
    "color": "#ffc107"
}, {
    "nosamw": "0201233",
    "nama": "H16 Rasid Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 92500,
    "total_denda": 5000,
    "total_jumlah": 97500,
    "lat": 0.5603008,
    "lng": 121.5699456,
    "color": "#ffc107"
}, {
    "nosamw": "0201234",
    "nama": "H16 Riyanto Al Hasni",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 445250,
    "total_denda": 45000,
    "total_jumlah": 490250,
    "lat": 0.5600391,
    "lng": 121.5694326,
    "color": "#dc3545"
}, {
    "nosamw": "0201240",
    "nama": "H16 Selfi Bumulo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 93000,
    "total_denda": 5000,
    "total_jumlah": 98000,
    "lat": 0.543929,
    "lng": 121.5741814,
    "color": "#ffc107"
}, {
    "nosamw": "0201206",
    "nama": "H16 Sukardi Lasalutu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 20000,
    "total_jumlah": 195000,
    "lat": 0.5595733,
    "lng": 121.5702867,
    "color": "#fd7e14"
}, {
    "nosamw": "0201202",
    "nama": "H16 Wawan Latif",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5681168,
    "lng": 121.5690529,
    "color": "#fd7e14"
}, {
    "nosamw": "0201701",
    "nama": "H19 ANSAR NUNTU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 474350,
    "total_denda": 15000,
    "total_jumlah": 489350,
    "lat": 0.5682554,
    "lng": 121.5701382,
    "color": "#fd7e14"
}, {
    "nosamw": "0201633",
    "nama": "H19 ANTON TUKA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 265000,
    "total_denda": 30000,
    "total_jumlah": 295000,
    "lat": 0.5587117,
    "lng": 121.5704117,
    "color": "#dc3545"
}, {
    "nosamw": "0201697",
    "nama": "H19 ARMAN NOOYO",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5679697,
    "lng": 121.5699203,
    "color": "#ffc107"
}, {
    "nosamw": "0201631",
    "nama": "H19 DJAFAR MONOARFA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 437500,
    "total_denda": 30000,
    "total_jumlah": 467500,
    "lat": 0.5606667,
    "lng": 121.5701267,
    "color": "#dc3545"
}, {
    "nosamw": "0201733",
    "nama": "H19 ERNI SAILANI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 140000,
    "total_denda": 15000,
    "total_jumlah": 155000,
    "lat": 0.5439526,
    "lng": 121.573903,
    "color": "#fd7e14"
}, {
    "nosamw": "0201735",
    "nama": "H19 FATRIANINGSI MAKU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.567306,
    "lng": 121.5692916,
    "color": "#ffc107"
}, {
    "nosamw": "0201720",
    "nama": "H19 HABIBA TANGAHU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 387000,
    "total_denda": 60000,
    "total_jumlah": 447000,
    "lat": 0.5676471,
    "lng": 121.5693441,
    "color": "#dc3545"
}, {
    "nosamw": "0201731",
    "nama": "H19 HADIJAH TAMBE",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1050000,
    "total_denda": 95000,
    "total_jumlah": 1145000,
    "lat": 0.5657768,
    "lng": 121.56754,
    "color": "#dc3545"
}, {
    "nosamw": "0201703",
    "nama": "H19 HERDI PAKAYA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 270000,
    "total_denda": 30000,
    "total_jumlah": 300000,
    "lat": 0.5681967,
    "lng": 121.5701319,
    "color": "#dc3545"
}, {
    "nosamw": "0201705",
    "nama": "H19 IMRAN POPOKA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 10000,
    "total_jumlah": 80000,
    "lat": 0.5682083,
    "lng": 121.570118,
    "color": "#ffc107"
}, {
    "nosamw": "0201710",
    "nama": "H19 ISMAIL BANG",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.5676731,
    "lng": 121.5698154,
    "color": "#ffc107"
}, {
    "nosamw": "0201711",
    "nama": "H19 ISMAIL NUSI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 118000,
    "total_denda": 10000,
    "total_jumlah": 128000,
    "lat": 0.5682282,
    "lng": 121.5701657,
    "color": "#fd7e14"
}, {
    "nosamw": "0201722",
    "nama": "H19 KADIR MANATI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 607000,
    "total_denda": 45000,
    "total_jumlah": 652000,
    "lat": 0.5673903,
    "lng": 121.5693241,
    "color": "#dc3545"
}, {
    "nosamw": "0201744",
    "nama": "H19 KARI MAKU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 616800,
    "total_denda": 35000,
    "total_jumlah": 651800,
    "lat": 0.567299,
    "lng": 121.5692899,
    "color": "#dc3545"
}, {
    "nosamw": "0201676",
    "nama": "H19 KIKIN ABJUL",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 114000,
    "total_denda": 10000,
    "total_jumlah": 124000,
    "lat": 0.5507585,
    "lng": 121.5700983,
    "color": "#fd7e14"
}, {
    "nosamw": "0201630",
    "nama": "H19 MOHAMAT DUNGGIO",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 246250,
    "total_denda": 20000,
    "total_jumlah": 266250,
    "lat": 0.5607467,
    "lng": 121.57007,
    "color": "#fd7e14"
}, {
    "nosamw": "0201692",
    "nama": "H19 MUSU LATIF",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 99600,
    "total_denda": 5000,
    "total_jumlah": 104600,
    "lat": 0.567324,
    "lng": 121.569294,
    "color": "#ffc107"
}, {
    "nosamw": "0201721",
    "nama": "H19 NOU ALBAKIR",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1490800,
    "total_denda": 140000,
    "total_jumlah": 1630800,
    "lat": 0.5679881,
    "lng": 121.5693125,
    "color": "#dc3545"
}, {
    "nosamw": "0201713",
    "nama": "H19 RISKI HULIA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1913500,
    "total_denda": 115000,
    "total_jumlah": 2028500,
    "lat": 0.5673721,
    "lng": 121.56974,
    "color": "#dc3545"
}, {
    "nosamw": "0201737",
    "nama": "H19 SAADIYA LATIF",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 467000,
    "total_denda": 65000,
    "total_jumlah": 532000,
    "lat": 0.5676941,
    "lng": 121.5698127,
    "color": "#dc3545"
}, {
    "nosamw": "0201727",
    "nama": "H19 Sarifa Datau",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 476150,
    "total_denda": 30000,
    "total_jumlah": 506150,
    "lat": 0.5691012,
    "lng": 121.56917,
    "color": "#dc3545"
}, {
    "nosamw": "0201716",
    "nama": "H19 SURYADI HILIMI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5685015,
    "lng": 121.5694271,
    "color": "#ffc107"
}, {
    "nosamw": "0201700",
    "nama": "H19 TAHA POPOKA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 596800,
    "total_denda": 80000,
    "total_jumlah": 676800,
    "lat": 0.5679743,
    "lng": 121.5699188,
    "color": "#dc3545"
}, {
    "nosamw": "0201740",
    "nama": "H19 TK Maranti",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1530000,
    "total_denda": 130000,
    "total_jumlah": 1660000,
    "lat": 0.5656668,
    "lng": 121.5675088,
    "color": "#dc3545"
}, {
    "nosamw": "0201719",
    "nama": "H19 UNE MILE",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 400500,
    "total_denda": 20000,
    "total_jumlah": 420500,
    "lat": 0.5681689,
    "lng": 121.5694644,
    "color": "#fd7e14"
}, {
    "nosamw": "0201753",
    "nama": "H19 YULIN DAIPONTA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 714500,
    "total_denda": 40000,
    "total_jumlah": 754500,
    "lat": 0.5463779,
    "lng": 121.5726934,
    "color": "#dc3545"
}, {
    "nosamw": "0201706",
    "nama": "H19 YUSUF HUTAJU",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1097200,
    "total_denda": 110000,
    "total_jumlah": 1207200,
    "lat": 0.5682646,
    "lng": 121.5701335,
    "color": "#dc3545"
}, {
    "nosamw": "0200716",
    "nama": "Hapsa Dulanmio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.5666012,
    "lng": 121.5678723,
    "color": "#ffc107"
}, {
    "nosamw": "0200437",
    "nama": "Hapsa Olii",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.5624901,
    "lng": 121.5691199,
    "color": "#ffc107"
}, {
    "nosamw": "0200606",
    "nama": "Hawangi Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.560426,
    "lng": 121.5698652,
    "color": "#ffc107"
}, {
    "nosamw": "0200380",
    "nama": "Hestiana Hamu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 536900,
    "total_denda": 30000,
    "total_jumlah": 566900,
    "lat": 0.5674804,
    "lng": 121.568563,
    "color": "#dc3545"
}, {
    "nosamw": "0201732",
    "nama": "INDRAWATI ADAM",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5414762,
    "lng": 121.5714014,
    "color": "#ffc107"
}, {
    "nosamw": "0200246",
    "nama": "Irwan Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5439472,
    "lng": 121.5729319,
    "color": "#ffc107"
}, {
    "nosamw": "0200704",
    "nama": "Ismail Lahay",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 348500,
    "total_denda": 30000,
    "total_jumlah": 378500,
    "lat": 0.5505817,
    "lng": 121.5701133,
    "color": "#dc3545"
}, {
    "nosamw": "0200241",
    "nama": "Ismail Pilobu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 613100,
    "total_denda": 35000,
    "total_jumlah": 648100,
    "lat": 0.5497213,
    "lng": 121.5722268,
    "color": "#dc3545"
}, {
    "nosamw": "0200650",
    "nama": "Iwan Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 428750,
    "total_denda": 25000,
    "total_jumlah": 453750,
    "lat": 0.5697755,
    "lng": 121.5696052,
    "color": "#fd7e14"
}, {
    "nosamw": "0201748",
    "nama": "Jaa Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 202000,
    "total_denda": 5000,
    "total_jumlah": 207000,
    "lat": 0.5436264,
    "lng": 121.5730088,
    "color": "#ffc107"
}, {
    "nosamw": "0200273",
    "nama": "Kamarudin Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5575184,
    "lng": 121.5707847,
    "color": "#28a745"
}, {
    "nosamw": "0200651",
    "nama": "Latifa Datau",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 423800,
    "total_denda": 50000,
    "total_jumlah": 473800,
    "lat": 0.5671124,
    "lng": 121.568228,
    "color": "#dc3545"
}, {
    "nosamw": "0200508",
    "nama": "Mahmud Rauf",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.5524967,
    "lng": 121.5719933,
    "color": "#ffc107"
}, {
    "nosamw": "0200161",
    "nama": "Mastin Ngule",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.54958,
    "lng": 121.5723266,
    "color": "#fd7e14"
}, {
    "nosamw": "0200859",
    "nama": "Meti Poduengo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 260200,
    "total_denda": 5000,
    "total_jumlah": 265200,
    "lat": 0.5673426,
    "lng": 121.5683925,
    "color": "#ffc107"
}, {
    "nosamw": "0200251",
    "nama": "MUHTAR PAKAYA",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 209200,
    "total_denda": 25000,
    "total_jumlah": 234200,
    "lat": 0.5464443,
    "lng": 121.5728988,
    "color": "#fd7e14"
}, {
    "nosamw": "0200258",
    "nama": "MULIYATI",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 80000,
    "total_denda": 0,
    "total_jumlah": 80000,
    "lat": 0.5454406,
    "lng": 121.572841,
    "color": "#ffc107"
}, {
    "nosamw": "0200224",
    "nama": "Nekson Mohungo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5614618,
    "lng": 121.5694292,
    "color": "#ffc107"
}, {
    "nosamw": "0200862",
    "nama": "Nii Maliki",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85500,
    "total_denda": 0,
    "total_jumlah": 85500,
    "lat": 0.5691754,
    "lng": 121.5692648,
    "color": "#ffc107"
}, {
    "nosamw": "0201132",
    "nama": "Niko Maliki",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 324000,
    "total_denda": 10000,
    "total_jumlah": 334000,
    "lat": 0.5686198,
    "lng": 121.5694299,
    "color": "#fd7e14"
}, {
    "nosamw": "0200376",
    "nama": "Nikson Pakaya",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 72000,
    "total_denda": 5000,
    "total_jumlah": 77000,
    "lat": 0.464341,
    "lng": 121.949378,
    "color": "#ffc107"
}, {
    "nosamw": "0200135",
    "nama": "Nizam Guamo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 171500,
    "total_denda": 10000,
    "total_jumlah": 181500,
    "lat": 0.5639221,
    "lng": 121.5676309,
    "color": "#fd7e14"
}, {
    "nosamw": "0200605",
    "nama": "Noho Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 126250,
    "total_denda": 5000,
    "total_jumlah": 131250,
    "lat": 0.5606933,
    "lng": 121.5697267,
    "color": "#ffc107"
}, {
    "nosamw": "0201177",
    "nama": "Noldi Dehi",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 390000,
    "total_denda": 50000,
    "total_jumlah": 440000,
    "lat": 0.5482071,
    "lng": 121.5722564,
    "color": "#dc3545"
}, {
    "nosamw": "0200255",
    "nama": "Non Mato",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 830000,
    "total_denda": 70000,
    "total_jumlah": 900000,
    "lat": 0.5487565,
    "lng": 121.5724033,
    "color": "#dc3545"
}, {
    "nosamw": "0200166",
    "nama": "Nuna Akuba",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 969250,
    "total_denda": 65000,
    "total_jumlah": 1034250,
    "lat": 0.5437325,
    "lng": 121.5735169,
    "color": "#dc3545"
}, {
    "nosamw": "0200852",
    "nama": "Nurlinda Y. Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 117000,
    "total_denda": 0,
    "total_jumlah": 117000,
    "lat": 0.5456282,
    "lng": 121.5728145,
    "color": "#ffc107"
}, {
    "nosamw": "0200755",
    "nama": "Otin Hilimi",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1929000,
    "total_denda": 65000,
    "total_jumlah": 1994000,
    "lat": 0.5685852,
    "lng": 121.568935,
    "color": "#dc3545"
}, {
    "nosamw": "0201157",
    "nama": "RAINA HASAN",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 212250,
    "total_denda": 20000,
    "total_jumlah": 232250,
    "lat": 0.5681472,
    "lng": 121.5700429,
    "color": "#fd7e14"
}, {
    "nosamw": "0201188",
    "nama": "Ridwan Daeng Jubu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 325000,
    "total_denda": 40000,
    "total_jumlah": 365000,
    "lat": 0.5495803,
    "lng": 121.5718951,
    "color": "#dc3545"
}, {
    "nosamw": "0200695",
    "nama": "Saipul Husain",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5441272,
    "lng": 121.5733692,
    "color": "#ffc107"
}, {
    "nosamw": "0200778",
    "nama": "Salma Doholio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5442058,
    "lng": 121.5735017,
    "color": "#ffc107"
}, {
    "nosamw": "0200158",
    "nama": "Salman Dunggio",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 106000,
    "total_denda": 5000,
    "total_jumlah": 111000,
    "lat": 0.561745,
    "lng": 121.5693983,
    "color": "#ffc107"
}, {
    "nosamw": "0200719",
    "nama": "Samsia Maliki",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.5692401,
    "lng": 121.5692044,
    "color": "#ffc107"
}, {
    "nosamw": "0200863",
    "nama": "Selfi Pasau",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 671000,
    "total_denda": 75000,
    "total_jumlah": 746000,
    "lat": 0.5497549,
    "lng": 121.5720442,
    "color": "#dc3545"
}, {
    "nosamw": "0200765",
    "nama": "Simin Hilimi",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 325500,
    "total_denda": 20000,
    "total_jumlah": 345500,
    "lat": 0.5691243,
    "lng": 121.5691831,
    "color": "#fd7e14"
}, {
    "nosamw": "0200705",
    "nama": "Suleman Abdjul",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 88400,
    "total_denda": 5000,
    "total_jumlah": 93400,
    "lat": 0.550632,
    "lng": 121.5719744,
    "color": "#ffc107"
}, {
    "nosamw": "0200851",
    "nama": "Tahir Sabu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 193250,
    "total_denda": 5000,
    "total_jumlah": 198250,
    "lat": 0.5507935,
    "lng": 121.5702601,
    "color": "#ffc107"
}, {
    "nosamw": "0200516",
    "nama": "Tue Moha",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 606250,
    "total_denda": 20000,
    "total_jumlah": 626250,
    "lat": 0.5678423,
    "lng": 121.568857,
    "color": "#fd7e14"
}, {
    "nosamw": "0200853",
    "nama": "Tune Datau",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.5691498,
    "lng": 121.5692244,
    "color": "#ffc107"
}, {
    "nosamw": "0200345",
    "nama": "Umar Alhadad",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5544645,
    "lng": 121.5716112,
    "color": "#ffc107"
}, {
    "nosamw": "0201034",
    "nama": "USAID Apipa Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 448200,
    "total_denda": 40000,
    "total_jumlah": 488200,
    "lat": 0.5439458,
    "lng": 121.5738791,
    "color": "#dc3545"
}, {
    "nosamw": "0200965",
    "nama": "USAID Era Talib",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5685525,
    "lng": 121.5692462,
    "color": "#ffc107"
}, {
    "nosamw": "0200986",
    "nama": "USAID Herlina Maliki",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 112250,
    "total_denda": 5000,
    "total_jumlah": 117250,
    "lat": 0.5693637,
    "lng": 121.5696365,
    "color": "#ffc107"
}, {
    "nosamw": "0201042",
    "nama": "USAID Ibrahim Akuba",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.543715,
    "lng": 121.5735283,
    "color": "#ffc107"
}, {
    "nosamw": "0200960",
    "nama": "USAID Idris Tangahu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 934750,
    "total_denda": 65000,
    "total_jumlah": 999750,
    "lat": 0.549835,
    "lng": 121.5702117,
    "color": "#dc3545"
}, {
    "nosamw": "0201037",
    "nama": "USAID Maryam Manati",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 356000,
    "total_denda": 35000,
    "total_jumlah": 391000,
    "lat": 0.5679547,
    "lng": 121.5698295,
    "color": "#dc3545"
}, {
    "nosamw": "0200973",
    "nama": "USAID Masni Pasau",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5495607,
    "lng": 121.5721534,
    "color": "#ffc107"
}, {
    "nosamw": "0201039",
    "nama": "USAID Masni Yusuf",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 84250,
    "total_denda": 5000,
    "total_jumlah": 89250,
    "lat": 0.5436875,
    "lng": 121.574137,
    "color": "#ffc107"
}, {
    "nosamw": "0201031",
    "nama": "USAID Nyong Tambe",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.567979,
    "lng": 121.5692811,
    "color": "#ffc107"
}, {
    "nosamw": "0200969",
    "nama": "USAID Onu Hilimi",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1240850,
    "total_denda": 80000,
    "total_jumlah": 1320850,
    "lat": 0.5674809,
    "lng": 121.5686724,
    "color": "#dc3545"
}, {
    "nosamw": "0200966",
    "nama": "USAID Pusa Tambe",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 791450,
    "total_denda": 35000,
    "total_jumlah": 826450,
    "lat": 0.56852,
    "lng": 121.5689667,
    "color": "#dc3545"
}, {
    "nosamw": "0200985",
    "nama": "USAID Rasi Hilimi",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 216500,
    "total_denda": 10000,
    "total_jumlah": 226500,
    "lat": 0.5677876,
    "lng": 121.5688537,
    "color": "#fd7e14"
}, {
    "nosamw": "0201032",
    "nama": "USAID Resmi Bumulo",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 121000,
    "total_denda": 5000,
    "total_jumlah": 126000,
    "lat": 0.5436552,
    "lng": 121.5743323,
    "color": "#ffc107"
}, {
    "nosamw": "0201030",
    "nama": "USAID Salha Akuba",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5435539,
    "lng": 121.5736236,
    "color": "#ffc107"
}, {
    "nosamw": "0201008",
    "nama": "USAID Wati Ahmad",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5683422,
    "lng": 121.5690002,
    "color": "#ffc107"
}, {
    "nosamw": "0201059",
    "nama": "Usman Ishak",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 167000,
    "total_denda": 20000,
    "total_jumlah": 187000,
    "lat": 0.5632683,
    "lng": 121.5479483,
    "color": "#fd7e14"
}, {
    "nosamw": "0200471",
    "nama": "Wahab Mahabu",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5440505,
    "lng": 121.5732872,
    "color": "#ffc107"
}, {
    "nosamw": "0200756",
    "nama": "Yul Hasan",
    "kecamatan": "KEC LEMITO DESA LEMITO UTARA",
    "desa": "LEMITO UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1158000,
    "total_denda": 55000,
    "total_jumlah": 1213000,
    "lat": 0.5674355,
    "lng": 121.5685331,
    "color": "#dc3545"
}, {
    "nosamw": "0200183",
    "nama": "ABDULLAH PAKAYA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 3514200,
    "total_denda": 160000,
    "total_jumlah": 3674200,
    "lat": 0.5573708,
    "lng": 121.5527465,
    "color": "#dc3545"
}, {
    "nosamw": "0201530",
    "nama": "ABDULLAH SAHADANI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5574836,
    "lng": 121.5531222,
    "color": "#ffc107"
}, {
    "nosamw": "0200207",
    "nama": "ABUBAKAR HANIU",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 682150,
    "total_denda": 25000,
    "total_jumlah": 707150,
    "lat": 0.5569472,
    "lng": 121.5519446,
    "color": "#fd7e14"
}, {
    "nosamw": "0201512",
    "nama": "AISA SEDI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5574441,
    "lng": 121.553066,
    "color": "#ffc107"
}, {
    "nosamw": "0200292",
    "nama": "ALI HULOPI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 238500,
    "total_denda": 20000,
    "total_jumlah": 258500,
    "lat": 0.5572558,
    "lng": 121.5524987,
    "color": "#fd7e14"
}, {
    "nosamw": "0200206",
    "nama": "ANTON ABDUL WAHAB",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 473250,
    "total_denda": 20000,
    "total_jumlah": 493250,
    "lat": 0.5572274,
    "lng": 121.5524915,
    "color": "#fd7e14"
}, {
    "nosamw": "0201542",
    "nama": "CANI NUSA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1081750,
    "total_denda": 85000,
    "total_jumlah": 1166750,
    "lat": 0.5570164,
    "lng": 121.5529121,
    "color": "#dc3545"
}, {
    "nosamw": "0200115",
    "nama": "DANIAL YS BAMU",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5574952,
    "lng": 121.552956,
    "color": "#ffc107"
}, {
    "nosamw": "0201373",
    "nama": "DAYANG MOHI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1099000,
    "total_denda": 165000,
    "total_jumlah": 1264000,
    "lat": 0.5536136,
    "lng": 121.6380087,
    "color": "#dc3545"
}, {
    "nosamw": "0201061",
    "nama": "Dedi Koni",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.5631433,
    "lng": 121.5487478,
    "color": "#fd7e14"
}, {
    "nosamw": "0200252",
    "nama": "DJAMILA DENJARI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1623600,
    "total_denda": 65000,
    "total_jumlah": 1688600,
    "lat": 0.5568801,
    "lng": 121.5520915,
    "color": "#dc3545"
}, {
    "nosamw": "0201533",
    "nama": "Djamila Dubaili",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 325900,
    "total_denda": 20000,
    "total_jumlah": 345900,
    "lat": 0.5573538,
    "lng": 121.5529182,
    "color": "#fd7e14"
}, {
    "nosamw": "0200256",
    "nama": "ERWIN POWALI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.55684,
    "lng": 121.5519756,
    "color": "#ffc107"
}, {
    "nosamw": "0201338",
    "nama": "H16 Abdul Kadir Abdullah",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 79000,
    "total_denda": 5000,
    "total_jumlah": 84000,
    "lat": 0.5640047,
    "lng": 121.5473179,
    "color": "#ffc107"
}, {
    "nosamw": "0201265",
    "nama": "H16 AJIS IBRAHIM",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082231797113",
    "total_bulan": 7,
    "total_tagihan": 326000,
    "total_denda": 30000,
    "total_jumlah": 356000,
    "lat": 0.5570614,
    "lng": 121.5522603,
    "color": "#dc3545"
}, {
    "nosamw": "0201334",
    "nama": "H16 Alwis Sedi",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1347850,
    "total_denda": 60000,
    "total_jumlah": 1407850,
    "lat": 0.5632666,
    "lng": 121.5488727,
    "color": "#dc3545"
}, {
    "nosamw": "0201339",
    "nama": "H16 Elis Ahmad",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 598600,
    "total_denda": 25000,
    "total_jumlah": 623600,
    "lat": 0.5642665,
    "lng": 121.5473418,
    "color": "#fd7e14"
}, {
    "nosamw": "0201361",
    "nama": "H16 Hendra Tangahu",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082231797113",
    "total_bulan": 3,
    "total_tagihan": 114750,
    "total_denda": 10000,
    "total_jumlah": 124750,
    "lat": 0.5570492,
    "lng": 121.5521882,
    "color": "#fd7e14"
}, {
    "nosamw": "0201340",
    "nama": "H16 Selmi Bau",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 463400,
    "total_denda": 30000,
    "total_jumlah": 493400,
    "lat": 0.564136,
    "lng": 121.5473748,
    "color": "#dc3545"
}, {
    "nosamw": "0201243",
    "nama": "H16 YUDIN KADILI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 321000,
    "total_denda": 5000,
    "total_jumlah": 326000,
    "lat": 0.5567738,
    "lng": 121.5524911,
    "color": "#ffc107"
}, {
    "nosamw": "0201470",
    "nama": "H18 ABD. RAMAN LIHAWA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 245000,
    "total_denda": 30000,
    "total_jumlah": 275000,
    "lat": 0.5571204,
    "lng": 121.5531609,
    "color": "#dc3545"
}, {
    "nosamw": "0201475",
    "nama": "H18 AKIR MONOARFA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110800,
    "total_denda": 5000,
    "total_jumlah": 115800,
    "lat": 0.5571448,
    "lng": 121.5530252,
    "color": "#ffc107"
}, {
    "nosamw": "0201478",
    "nama": "H18 ASMIA DAUTINA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1223450,
    "total_denda": 60000,
    "total_jumlah": 1283450,
    "lat": 0.5618222,
    "lng": 121.5539805,
    "color": "#dc3545"
}, {
    "nosamw": "0201488",
    "nama": "H18 MOHAMAD IDRUS",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 296500,
    "total_denda": 15000,
    "total_jumlah": 311500,
    "lat": 0.5617105,
    "lng": 121.5536014,
    "color": "#fd7e14"
}, {
    "nosamw": "0201491",
    "nama": "H18 RAMLAN SIOLE",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49800,
    "total_denda": 0,
    "total_jumlah": 49800,
    "lat": 0.5620999,
    "lng": 121.5572802,
    "color": "#ffc107"
}, {
    "nosamw": "0201637",
    "nama": "H19 ANTON HIDAYAT",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5575046,
    "lng": 121.552981,
    "color": "#ffc107"
}, {
    "nosamw": "0201549",
    "nama": "HARUN PAKAYA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5569569,
    "lng": 121.5527362,
    "color": "#ffc107"
}, {
    "nosamw": "0200462",
    "nama": "HENDRIK TALAMATI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5571263,
    "lng": 121.5523556,
    "color": "#ffc107"
}, {
    "nosamw": "0200236",
    "nama": "HERLINA DUBAILI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 36,
    "total_tagihan": 1664500,
    "total_denda": 175000,
    "total_jumlah": 1839500,
    "lat": 0.5572773,
    "lng": 121.5525268,
    "color": "#dc3545"
}, {
    "nosamw": "0201586",
    "nama": "HERTI PAKAYA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 98250,
    "total_denda": 5000,
    "total_jumlah": 103250,
    "lat": 0.5574934,
    "lng": 121.5532072,
    "color": "#ffc107"
}, {
    "nosamw": "0200817",
    "nama": "In Umar",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5633567,
    "lng": 121.5479433,
    "color": "#ffc107"
}, {
    "nosamw": "0201516",
    "nama": "JAFAR PAKAYA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5570953,
    "lng": 121.5524335,
    "color": "#fd7e14"
}, {
    "nosamw": "0200940",
    "nama": "KANTOR DESA LOMULI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 10072500,
    "total_denda": 110000,
    "total_jumlah": 10182500,
    "lat": 0.5572717,
    "lng": 121.5537533,
    "color": "#dc3545"
}, {
    "nosamw": "0200261",
    "nama": "KINI DATAU",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2957950,
    "total_denda": 110000,
    "total_jumlah": 3067950,
    "lat": 0.5574227,
    "lng": 121.5529009,
    "color": "#dc3545"
}, {
    "nosamw": "0201524",
    "nama": "LILIS SIOLE",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 66500,
    "total_denda": 0,
    "total_jumlah": 66500,
    "lat": 0.5572476,
    "lng": 121.5531902,
    "color": "#ffc107"
}, {
    "nosamw": "0201453",
    "nama": "LISON KADILI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 222500,
    "total_denda": 5000,
    "total_jumlah": 227500,
    "lat": 0.5571376,
    "lng": 121.552948,
    "color": "#ffc107"
}, {
    "nosamw": "0201060",
    "nama": "MARYAM HULOPI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 565000,
    "total_denda": 50000,
    "total_jumlah": 615000,
    "lat": 0.5633367,
    "lng": 121.5479383,
    "color": "#dc3545"
}, {
    "nosamw": "0201536",
    "nama": "MINARTI PAKAYA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.556876,
    "lng": 121.5526003,
    "color": "#ffc107"
}, {
    "nosamw": "0201513",
    "nama": "MISNAWATI WALUDAMBA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 243000,
    "total_denda": 5000,
    "total_jumlah": 248000,
    "lat": 0.5572811,
    "lng": 121.5533923,
    "color": "#ffc107"
}, {
    "nosamw": "0200592",
    "nama": "Mohamad Monoarfa",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1535000,
    "total_denda": 50000,
    "total_jumlah": 1585000,
    "lat": 0.5642162,
    "lng": 121.5494444,
    "color": "#dc3545"
}, {
    "nosamw": "0201793",
    "nama": "MOHAMAD PONGOLIU",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5568393,
    "lng": 121.5525582,
    "color": "#ffc107"
}, {
    "nosamw": "0200265",
    "nama": "RAFLIN RATALENA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5569277,
    "lng": 121.552282,
    "color": "#ffc107"
}, {
    "nosamw": "0200820",
    "nama": "Rahman Hulopi",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.5621158,
    "lng": 121.5572594,
    "color": "#ffc107"
}, {
    "nosamw": "0201422",
    "nama": "RULI HUSAIN",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 793000,
    "total_denda": 110000,
    "total_jumlah": 903000,
    "lat": 0.5530847,
    "lng": 121.6442295,
    "color": "#dc3545"
}, {
    "nosamw": "0201508",
    "nama": "RUMAH SAKIT  PRATAMA LEMITO",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "RU",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.5599467,
    "lng": 121.55309,
    "color": "#ffc107"
}, {
    "nosamw": "0200556",
    "nama": "SAIFUL LATIF",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 600000,
    "total_denda": 80000,
    "total_jumlah": 680000,
    "lat": 0.5569442,
    "lng": 121.5518559,
    "color": "#dc3545"
}, {
    "nosamw": "0200245",
    "nama": "SALIM SAHABELI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082231797113",
    "total_bulan": 13,
    "total_tagihan": 600600,
    "total_denda": 60000,
    "total_jumlah": 660600,
    "lat": 0.4873727,
    "lng": 121.9353568,
    "color": "#dc3545"
}, {
    "nosamw": "0201554",
    "nama": "SAPIA HANGU",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.556942,
    "lng": 121.5527421,
    "color": "#ffc107"
}, {
    "nosamw": "0201482",
    "nama": "SARTIKA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1480500,
    "total_denda": 55000,
    "total_jumlah": 1535500,
    "lat": 0.5640834,
    "lng": 121.548026,
    "color": "#dc3545"
}, {
    "nosamw": "0200227",
    "nama": "SUAIB SOGA",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085215029534",
    "total_bulan": 8,
    "total_tagihan": 299000,
    "total_denda": 35000,
    "total_jumlah": 334000,
    "lat": 0.5569919,
    "lng": 121.5521318,
    "color": "#dc3545"
}, {
    "nosamw": "0200328",
    "nama": "Suarni Saleh",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5623812,
    "lng": 121.560807,
    "color": "#ffc107"
}, {
    "nosamw": "0201606",
    "nama": "SUSWATI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 208500,
    "total_denda": 20000,
    "total_jumlah": 228500,
    "lat": 0.5574035,
    "lng": 121.5528992,
    "color": "#fd7e14"
}, {
    "nosamw": "0201534",
    "nama": "TRI PURWANTI DJULI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 109750,
    "total_denda": 10000,
    "total_jumlah": 119750,
    "lat": 0.5572216,
    "lng": 121.5526869,
    "color": "#fd7e14"
}, {
    "nosamw": "0200939",
    "nama": "USAID Anis A. Due",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5625853,
    "lng": 121.5611828,
    "color": "#ffc107"
}, {
    "nosamw": "0201041",
    "nama": "USAID Munang Yusuf",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142300,
    "total_denda": 5000,
    "total_jumlah": 147300,
    "lat": 0.56376,
    "lng": 121.5480667,
    "color": "#ffc107"
}, {
    "nosamw": "0201044",
    "nama": "USAID Sartin Usman",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1197500,
    "total_denda": 10000,
    "total_jumlah": 1207500,
    "lat": 0.5417517,
    "lng": 121.5723117,
    "color": "#fd7e14"
}, {
    "nosamw": "0201507",
    "nama": "USMAN HALUSI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1206700,
    "total_denda": 110000,
    "total_jumlah": 1316700,
    "lat": 0.5570732,
    "lng": 121.5529101,
    "color": "#dc3545"
}, {
    "nosamw": "0201523",
    "nama": "YUNI",
    "kecamatan": "KEC LEMITO DESA LOMULI",
    "desa": "LOMULI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5566877,
    "lng": 121.5523241,
    "color": "#ffc107"
}, {
    "nosamw": "0201393",
    "nama": "ABDUL RAHMAN DJURIATI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 255000,
    "total_denda": 35000,
    "total_jumlah": 290000,
    "lat": 0.552925,
    "lng": 121.6442686,
    "color": "#dc3545"
}, {
    "nosamw": "0201371",
    "nama": "ABDULLAH PALAKAI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1033000,
    "total_denda": 155000,
    "total_jumlah": 1188000,
    "lat": 0.5526233,
    "lng": 121.6379343,
    "color": "#dc3545"
}, {
    "nosamw": "0201394",
    "nama": "ABUBAKAR DJURIATI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 740000,
    "total_denda": 100000,
    "total_jumlah": 840000,
    "lat": 0.5528763,
    "lng": 121.6439158,
    "color": "#dc3545"
}, {
    "nosamw": "0201417",
    "nama": "ADAM SARIPIN KADJU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1020000,
    "total_denda": 140000,
    "total_jumlah": 1160000,
    "lat": 0.5560323,
    "lng": 121.6356915,
    "color": "#dc3545"
}, {
    "nosamw": "0201388",
    "nama": "AIN BOTUTIHE",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5522775,
    "lng": 121.6460372,
    "color": "#dc3545"
}, {
    "nosamw": "0200395",
    "nama": "Andi Godang",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 816000,
    "total_denda": 115000,
    "total_jumlah": 931000,
    "lat": 0.5533133,
    "lng": 121.6404683,
    "color": "#dc3545"
}, {
    "nosamw": "0201415",
    "nama": "ANDRIS DJURIATI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 875000,
    "total_denda": 120000,
    "total_jumlah": 995000,
    "lat": 0.552909,
    "lng": 121.64403,
    "color": "#dc3545"
}, {
    "nosamw": "0201594",
    "nama": "Arifin Gai",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 38,
    "total_tagihan": 1297000,
    "total_denda": 185000,
    "total_jumlah": 1482000,
    "lat": 0.55324,
    "lng": 121.637895,
    "color": "#dc3545"
}, {
    "nosamw": "0201389",
    "nama": "ARIFIN GAIB",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 742350,
    "total_denda": 50000,
    "total_jumlah": 792350,
    "lat": 0.5571028,
    "lng": 121.5525489,
    "color": "#dc3545"
}, {
    "nosamw": "0201368",
    "nama": "ASWAN DAMA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 51,
    "total_tagihan": 1665500,
    "total_denda": 250000,
    "total_jumlah": 1915500,
    "lat": 0.5532428,
    "lng": 121.6378926,
    "color": "#dc3545"
}, {
    "nosamw": "0201383",
    "nama": "BADRUN RAJAK",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 425000,
    "total_denda": 55000,
    "total_jumlah": 480000,
    "lat": 0.5562875,
    "lng": 121.6335748,
    "color": "#dc3545"
}, {
    "nosamw": "0200408",
    "nama": "Baygon mahmud",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 763000,
    "total_denda": 105000,
    "total_jumlah": 868000,
    "lat": 0.552903,
    "lng": 121.6448095,
    "color": "#dc3545"
}, {
    "nosamw": "0200775",
    "nama": "Cili Nusa",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 670000,
    "total_denda": 100000,
    "total_jumlah": 770000,
    "lat": 0.55288,
    "lng": 121.64444,
    "color": "#dc3545"
}, {
    "nosamw": "0200409",
    "nama": "Denan Pidar",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 836000,
    "total_denda": 115000,
    "total_jumlah": 951000,
    "lat": 0.5563771,
    "lng": 121.6328805,
    "color": "#dc3545"
}, {
    "nosamw": "0201412",
    "nama": "DJAKARIA MOHI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 35,
    "total_tagihan": 1200000,
    "total_denda": 170000,
    "total_jumlah": 1370000,
    "lat": 0.5539413,
    "lng": 121.638035,
    "color": "#dc3545"
}, {
    "nosamw": "0200731",
    "nama": "Endang Yusuf",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 797000,
    "total_denda": 115000,
    "total_jumlah": 912000,
    "lat": 0.5528194,
    "lng": 121.6445534,
    "color": "#dc3545"
}, {
    "nosamw": "0200524",
    "nama": "Erlin Yusuf",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 929000,
    "total_denda": 135000,
    "total_jumlah": 1064000,
    "lat": 0.5529132,
    "lng": 121.6450135,
    "color": "#dc3545"
}, {
    "nosamw": "0201543",
    "nama": "H18 ABDUL WAHAB DJ. PAKAYA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 415000,
    "total_denda": 60000,
    "total_jumlah": 475000,
    "lat": 0.55354,
    "lng": 121.6395717,
    "color": "#dc3545"
}, {
    "nosamw": "0201571",
    "nama": "H18 AKRIN DEHI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 678000,
    "total_denda": 100000,
    "total_jumlah": 778000,
    "lat": 0.5530307,
    "lng": 121.6438959,
    "color": "#dc3545"
}, {
    "nosamw": "0201535",
    "nama": "H18 ARSAD ASUKE",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 565000,
    "total_denda": 75000,
    "total_jumlah": 640000,
    "lat": 0.556544,
    "lng": 121.6313731,
    "color": "#dc3545"
}, {
    "nosamw": "0201548",
    "nama": "H18 DJAFAR PAKAYA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 237000,
    "total_denda": 30000,
    "total_jumlah": 267000,
    "lat": 0.5535,
    "lng": 121.63971,
    "color": "#dc3545"
}, {
    "nosamw": "0201558",
    "nama": "H18 IRWAN SAMAWATI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1020000,
    "total_denda": 140000,
    "total_jumlah": 1160000,
    "lat": 0.5530439,
    "lng": 121.6452438,
    "color": "#dc3545"
}, {
    "nosamw": "0201560",
    "nama": "H18 NENI MOHI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 35,
    "total_tagihan": 1200000,
    "total_denda": 170000,
    "total_jumlah": 1370000,
    "lat": 0.5519952,
    "lng": 121.6424865,
    "color": "#dc3545"
}, {
    "nosamw": "0201561",
    "nama": "H18 ORIS MONOARFA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1087000,
    "total_denda": 155000,
    "total_jumlah": 1242000,
    "lat": 0.5519779,
    "lng": 121.6422496,
    "color": "#dc3545"
}, {
    "nosamw": "0201540",
    "nama": "H18 RAHMAN TONE",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 41,
    "total_tagihan": 1386000,
    "total_denda": 200000,
    "total_jumlah": 1586000,
    "lat": 0.5512333,
    "lng": 121.6377833,
    "color": "#dc3545"
}, {
    "nosamw": "0200449",
    "nama": "Hadija Kadir",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 627000,
    "total_denda": 90000,
    "total_jumlah": 717000,
    "lat": 0.5542898,
    "lng": 121.6383623,
    "color": "#dc3545"
}, {
    "nosamw": "0200735",
    "nama": "Hadijah Moha",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 929000,
    "total_denda": 135000,
    "total_jumlah": 1064000,
    "lat": 0.5558956,
    "lng": 121.636349,
    "color": "#dc3545"
}, {
    "nosamw": "0200448",
    "nama": "Hamid Palaki",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 353000,
    "total_denda": 50000,
    "total_jumlah": 403000,
    "lat": 0.5547315,
    "lng": 121.637998,
    "color": "#dc3545"
}, {
    "nosamw": "0201398",
    "nama": "HAMSA MOHI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1159250,
    "total_denda": 155000,
    "total_jumlah": 1314250,
    "lat": 0.5540386,
    "lng": 121.6386696,
    "color": "#dc3545"
}, {
    "nosamw": "0201053",
    "nama": "Hamzah Gaib",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1195000,
    "total_denda": 165000,
    "total_jumlah": 1360000,
    "lat": 0.5556828,
    "lng": 121.6369442,
    "color": "#dc3545"
}, {
    "nosamw": "0201785",
    "nama": "HARLIS JURIATI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5566828,
    "lng": 121.6308435,
    "color": "#dc3545"
}, {
    "nosamw": "0201367",
    "nama": "HARSON NDEKI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 45,
    "total_tagihan": 1494000,
    "total_denda": 220000,
    "total_jumlah": 1714000,
    "lat": 0.5533595,
    "lng": 121.6379395,
    "color": "#dc3545"
}, {
    "nosamw": "0200382",
    "nama": "Hartati Zubair",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 810000,
    "total_denda": 110000,
    "total_jumlah": 920000,
    "lat": 0.5529023,
    "lng": 121.6441579,
    "color": "#dc3545"
}, {
    "nosamw": "0201420",
    "nama": "HARTONO MOHA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 757000,
    "total_denda": 90000,
    "total_jumlah": 847000,
    "lat": 0.5540897,
    "lng": 121.6381398,
    "color": "#dc3545"
}, {
    "nosamw": "0200384",
    "nama": "Hasan Juriati",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 1152000,
    "total_denda": 160000,
    "total_jumlah": 1312000,
    "lat": 0.5528384,
    "lng": 121.6440515,
    "color": "#dc3545"
}, {
    "nosamw": "0201365",
    "nama": "HASAN NUSA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 868000,
    "total_denda": 130000,
    "total_jumlah": 998000,
    "lat": 0.5523458,
    "lng": 121.6379559,
    "color": "#dc3545"
}, {
    "nosamw": "0201397",
    "nama": "IBRAHIM KAMBUNGU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1099000,
    "total_denda": 165000,
    "total_jumlah": 1264000,
    "lat": 0.5528966,
    "lng": 121.6436051,
    "color": "#dc3545"
}, {
    "nosamw": "0200734",
    "nama": "Irnaningsih Sidiki",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 565000,
    "total_denda": 75000,
    "total_jumlah": 640000,
    "lat": 0.5558921,
    "lng": 121.6363387,
    "color": "#dc3545"
}, {
    "nosamw": "0201376",
    "nama": "IRPAN BULONGGODU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1099000,
    "total_denda": 165000,
    "total_jumlah": 1264000,
    "lat": 0.5523843,
    "lng": 121.6378571,
    "color": "#dc3545"
}, {
    "nosamw": "0200392",
    "nama": "Ishak B. Majania",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 368000,
    "total_denda": 50000,
    "total_jumlah": 418000,
    "lat": 0.5530072,
    "lng": 121.6439225,
    "color": "#dc3545"
}, {
    "nosamw": "0200385",
    "nama": "Iskandar Soga",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 74500,
    "total_denda": 5000,
    "total_jumlah": 79500,
    "lat": 0.5562666,
    "lng": 121.6334754,
    "color": "#ffc107"
}, {
    "nosamw": "0201598",
    "nama": "ISMAIL ANTULA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1615400,
    "total_denda": 70000,
    "total_jumlah": 1685400,
    "lat": 0.5572361,
    "lng": 121.5527952,
    "color": "#dc3545"
}, {
    "nosamw": "0201392",
    "nama": "ISMAIL BULONGGODU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 172000,
    "total_denda": 25000,
    "total_jumlah": 197000,
    "lat": 0.55288,
    "lng": 121.64444,
    "color": "#fd7e14"
}, {
    "nosamw": "0201386",
    "nama": "KTR. DESA SUKA DAMAI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1145000,
    "total_denda": 110000,
    "total_jumlah": 1255000,
    "lat": 0.5554803,
    "lng": 121.6372833,
    "color": "#dc3545"
}, {
    "nosamw": "0201372",
    "nama": "MARICE MAJANIA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 1000000,
    "total_denda": 150000,
    "total_jumlah": 1150000,
    "lat": 0.56354,
    "lng": 121.5677767,
    "color": "#dc3545"
}, {
    "nosamw": "0200442",
    "nama": "Masni Godang",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 320000,
    "total_denda": 40000,
    "total_jumlah": 360000,
    "lat": 0.5542257,
    "lng": 121.6381508,
    "color": "#dc3545"
}, {
    "nosamw": "0201370",
    "nama": "MASRIN PALAKAI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1099000,
    "total_denda": 165000,
    "total_jumlah": 1264000,
    "lat": 0.5534534,
    "lng": 121.6379617,
    "color": "#dc3545"
}, {
    "nosamw": "0200011",
    "nama": "Nasir Al Hasni",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 775000,
    "total_denda": 105000,
    "total_jumlah": 880000,
    "lat": 0.5531508,
    "lng": 121.6410166,
    "color": "#dc3545"
}, {
    "nosamw": "0200386",
    "nama": "Patrina Majania",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.5530904,
    "lng": 121.6448649,
    "color": "#fd7e14"
}, {
    "nosamw": "0201366",
    "nama": "POGE PALAKAI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 997000,
    "total_denda": 155000,
    "total_jumlah": 1152000,
    "lat": 0.55249,
    "lng": 121.637897,
    "color": "#dc3545"
}, {
    "nosamw": "0201374",
    "nama": "RAHIM DAMA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1099000,
    "total_denda": 165000,
    "total_jumlah": 1264000,
    "lat": 0.5520242,
    "lng": 121.637857,
    "color": "#dc3545"
}, {
    "nosamw": "0201400",
    "nama": "RAHMAT ABDULLAH",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 829000,
    "total_denda": 115000,
    "total_jumlah": 944000,
    "lat": 0.554266,
    "lng": 121.6383773,
    "color": "#dc3545"
}, {
    "nosamw": "0201502",
    "nama": "RAMIN HULAOPI",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 10000,
    "total_jumlah": 305000,
    "lat": 0.5572767,
    "lng": 121.553348,
    "color": "#fd7e14"
}, {
    "nosamw": "0200727",
    "nama": "Ramin Majania",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302000,
    "total_denda": 40000,
    "total_jumlah": 342000,
    "lat": 0.553085,
    "lng": 121.6443895,
    "color": "#dc3545"
}, {
    "nosamw": "0201390",
    "nama": "RAMSA HABIBU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 40,
    "total_tagihan": 1296000,
    "total_denda": 195000,
    "total_jumlah": 1491000,
    "lat": 0.5528446,
    "lng": 121.6450691,
    "color": "#dc3545"
}, {
    "nosamw": "0200729",
    "nama": "Rasna Kambungu",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 896000,
    "total_denda": 130000,
    "total_jumlah": 1026000,
    "lat": 0.552971,
    "lng": 121.6451255,
    "color": "#dc3545"
}, {
    "nosamw": "0200581",
    "nama": "Rauf Samai",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 599000,
    "total_denda": 85000,
    "total_jumlah": 684000,
    "lat": 0.5556776,
    "lng": 121.6368565,
    "color": "#dc3545"
}, {
    "nosamw": "0200364",
    "nama": "Robertus Baharu",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 39,
    "total_tagihan": 2090000,
    "total_denda": 190000,
    "total_jumlah": 2280000,
    "lat": 0.5532177,
    "lng": 121.6406342,
    "color": "#dc3545"
}, {
    "nosamw": "0200771",
    "nama": "Ronal A. Humunggio, S,Pd.",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 20000,
    "total_jumlah": 195000,
    "lat": 0.5529984,
    "lng": 121.6443553,
    "color": "#fd7e14"
}, {
    "nosamw": "0200546",
    "nama": "Roni Mantu",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1171000,
    "total_denda": 165000,
    "total_jumlah": 1336000,
    "lat": 0.554308,
    "lng": 121.6384531,
    "color": "#dc3545"
}, {
    "nosamw": "0201401",
    "nama": "SAHAR RUMPABULU",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 1001000,
    "total_denda": 145000,
    "total_jumlah": 1146000,
    "lat": 0.5563832,
    "lng": 121.6335576,
    "color": "#dc3545"
}, {
    "nosamw": "0200446",
    "nama": "Samsudin Yantoman",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 736000,
    "total_denda": 110000,
    "total_jumlah": 846000,
    "lat": 0.5550637,
    "lng": 121.6376703,
    "color": "#dc3545"
}, {
    "nosamw": "0200417",
    "nama": "SDN Suka Damai",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 921000,
    "total_denda": 135000,
    "total_jumlah": 1056000,
    "lat": 0.5530631,
    "lng": 121.6428767,
    "color": "#dc3545"
}, {
    "nosamw": "0201369",
    "nama": "SIMON DAMA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 1033000,
    "total_denda": 155000,
    "total_jumlah": 1188000,
    "lat": 0.5521227,
    "lng": 121.6378234,
    "color": "#dc3545"
}, {
    "nosamw": "0201385",
    "nama": "USAID JAENAP YUSUF",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 1066000,
    "total_denda": 160000,
    "total_jumlah": 1226000,
    "lat": 0.55399,
    "lng": 121.6387317,
    "color": "#dc3545"
}, {
    "nosamw": "0201402",
    "nama": "YASIN DAMA",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 53,
    "total_tagihan": 1748000,
    "total_denda": 260000,
    "total_jumlah": 2008000,
    "lat": 0.5546017,
    "lng": 121.63803,
    "color": "#dc3545"
}, {
    "nosamw": "0200263",
    "nama": "YENITA LUNGKANG",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 1056000,
    "total_denda": 150000,
    "total_jumlah": 1206000,
    "lat": 0.5565839,
    "lng": 121.6323289,
    "color": "#dc3545"
}, {
    "nosamw": "0200410",
    "nama": "Zainudin Yusuf",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 899000,
    "total_denda": 130000,
    "total_jumlah": 1029000,
    "lat": 0.5565606,
    "lng": 121.6300068,
    "color": "#dc3545"
}, {
    "nosamw": "0200554",
    "nama": "Zuber Manopo",
    "kecamatan": "KEC LEMITO DESA SUKA DAMAI",
    "desa": "SUKA DAMAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 830000,
    "total_denda": 120000,
    "total_jumlah": 950000,
    "lat": 0.5556121,
    "lng": 121.6370748,
    "color": "#dc3545"
}, {
    "nosamw": "0201071",
    "nama": "Abd Azis Kundji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5572708,
    "lng": 121.552859,
    "color": "#ffc107"
}, {
    "nosamw": "0200578",
    "nama": "Abd Rahman Kunji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 680000,
    "total_denda": 80000,
    "total_jumlah": 760000,
    "lat": 0.5416788,
    "lng": 121.5802385,
    "color": "#dc3545"
}, {
    "nosamw": "0200551",
    "nama": "Abd. Rahman Alhasni",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5455675,
    "lng": 121.5777124,
    "color": "#ffc107"
}, {
    "nosamw": "0200576",
    "nama": "Aisa Ismail",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447025,
    "lng": 121.939509,
    "color": "#28a745"
}, {
    "nosamw": "0200694",
    "nama": "AMINA HAMZAH",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 545000,
    "total_denda": 55000,
    "total_jumlah": 600000,
    "lat": 0.5396522,
    "lng": 121.5808895,
    "color": "#dc3545"
}, {
    "nosamw": "0200746",
    "nama": "Arpan Kundji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 495000,
    "total_denda": 65000,
    "total_jumlah": 560000,
    "lat": 0.5402919,
    "lng": 121.5808316,
    "color": "#dc3545"
}, {
    "nosamw": "0200919",
    "nama": "Asna Mabone",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 495000,
    "total_denda": 65000,
    "total_jumlah": 560000,
    "lat": 0.5406957,
    "lng": 121.5804687,
    "color": "#dc3545"
}, {
    "nosamw": "0200160",
    "nama": "Auliya Kunji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2962750,
    "total_denda": 120000,
    "total_jumlah": 3082750,
    "lat": 0.544325,
    "lng": 121.5728617,
    "color": "#dc3545"
}, {
    "nosamw": "0200096",
    "nama": "Fatma Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081242663318",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.5453354,
    "lng": 121.5768556,
    "color": "#ffc107"
}, {
    "nosamw": "0201607",
    "nama": "H18 HAMSAH LAHAY",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 425000,
    "total_denda": 55000,
    "total_jumlah": 480000,
    "lat": 0.5400157,
    "lng": 121.5807999,
    "color": "#dc3545"
}, {
    "nosamw": "0200544",
    "nama": "Hadi Alhasni",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 533000,
    "total_denda": 75000,
    "total_jumlah": 608000,
    "lat": 0.5419644,
    "lng": 121.5799231,
    "color": "#dc3545"
}, {
    "nosamw": "0200644",
    "nama": "Hapasi Sadapu",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5454515,
    "lng": 121.5766106,
    "color": "#ffc107"
}, {
    "nosamw": "0200468",
    "nama": "Harun Kunji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.545595,
    "lng": 121.5771898,
    "color": "#ffc107"
}, {
    "nosamw": "0200013",
    "nama": "Hasim Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 365000,
    "total_denda": 35000,
    "total_jumlah": 400000,
    "lat": 0.54671,
    "lng": 121.5726133,
    "color": "#dc3545"
}, {
    "nosamw": "0200646",
    "nama": "Hasna Dahumu",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5457722,
    "lng": 121.5783922,
    "color": "#ffc107"
}, {
    "nosamw": "0201181",
    "nama": "IMRAN IGRISA",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 96500,
    "total_denda": 0,
    "total_jumlah": 96500,
    "lat": 0.5452479,
    "lng": 121.5750101,
    "color": "#ffc107"
}, {
    "nosamw": "0201796",
    "nama": "JAPAR ADAM",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 8,
    "total_tagihan": 285000,
    "total_denda": 35000,
    "total_jumlah": 320000,
    "lat": 0.5385127,
    "lng": 121.5814899,
    "color": "#dc3545"
}, {
    "nosamw": "0200649",
    "nama": "Jauria Togi.",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 460000,
    "total_denda": 60000,
    "total_jumlah": 520000,
    "lat": 0.5404546,
    "lng": 121.5807486,
    "color": "#dc3545"
}, {
    "nosamw": "0200924",
    "nama": "Kasman dai",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 188000,
    "total_denda": 15000,
    "total_jumlah": 203000,
    "lat": 0.5452681,
    "lng": 121.5756299,
    "color": "#fd7e14"
}, {
    "nosamw": "0201152",
    "nama": "Kuna Palitati",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5470237,
    "lng": 121.5761305,
    "color": "#ffc107"
}, {
    "nosamw": "0200022",
    "nama": "Lison Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 725000,
    "total_denda": 65000,
    "total_jumlah": 790000,
    "lat": 0.54631,
    "lng": 121.572655,
    "color": "#dc3545"
}, {
    "nosamw": "0201081",
    "nama": "Mahyudin Musa",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 600000,
    "total_denda": 80000,
    "total_jumlah": 680000,
    "lat": 0.539857,
    "lng": 121.5807779,
    "color": "#dc3545"
}, {
    "nosamw": "0201067",
    "nama": "Mei Sako",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.5475445,
    "lng": 121.5768284,
    "color": "#ffc107"
}, {
    "nosamw": "0201151",
    "nama": "Min Rumampuk",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 47000,
    "total_denda": 0,
    "total_jumlah": 47000,
    "lat": 0.5474389,
    "lng": 121.5761303,
    "color": "#ffc107"
}, {
    "nosamw": "0200702",
    "nama": "Moh. Kandji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 210000,
    "total_denda": 25000,
    "total_jumlah": 235000,
    "lat": 0.5431682,
    "lng": 121.5794119,
    "color": "#fd7e14"
}, {
    "nosamw": "0200155",
    "nama": "Moh. Karama",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082311922689",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4873642,
    "lng": 121.9353564,
    "color": "#fd7e14"
}, {
    "nosamw": "0201083",
    "nama": "Onu Mobone",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 385000,
    "total_denda": 50000,
    "total_jumlah": 435000,
    "lat": 0.5391367,
    "lng": 121.5810036,
    "color": "#dc3545"
}, {
    "nosamw": "0201790",
    "nama": "OPIN UKE",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 16,
    "total_tagihan": 565000,
    "total_denda": 75000,
    "total_jumlah": 640000,
    "lat": 0.5391402,
    "lng": 121.5812235,
    "color": "#dc3545"
}, {
    "nosamw": "0200040",
    "nama": "Osi Karama",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 671250,
    "total_denda": 55000,
    "total_jumlah": 726250,
    "lat": 0.5460633,
    "lng": 121.5726567,
    "color": "#dc3545"
}, {
    "nosamw": "0201087",
    "nama": "Rahman Biki",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 425000,
    "total_denda": 55000,
    "total_jumlah": 480000,
    "lat": 0.5394887,
    "lng": 121.5809856,
    "color": "#dc3545"
}, {
    "nosamw": "0201776",
    "nama": "RAMLI PAKAYA",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085242303873",
    "total_bulan": 14,
    "total_tagihan": 495000,
    "total_denda": 65000,
    "total_jumlah": 560000,
    "lat": 0.5399871,
    "lng": 121.5808253,
    "color": "#dc3545"
}, {
    "nosamw": "0200523",
    "nama": "Ramlin Daud",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 530000,
    "total_denda": 70000,
    "total_jumlah": 600000,
    "lat": 0.5399716,
    "lng": 121.5807578,
    "color": "#dc3545"
}, {
    "nosamw": "0201074",
    "nama": "Ratna Monoarfa",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2240950,
    "total_denda": 125000,
    "total_jumlah": 2365950,
    "lat": 0.457106,
    "lng": 121.937453,
    "color": "#dc3545"
}, {
    "nosamw": "0200144",
    "nama": "Ridwan M",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.544695,
    "lng": 121.5728117,
    "color": "#ffc107"
}, {
    "nosamw": "0201080",
    "nama": "Rini Lolonto",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 460000,
    "total_denda": 60000,
    "total_jumlah": 520000,
    "lat": 0.5387753,
    "lng": 121.581464,
    "color": "#dc3545"
}, {
    "nosamw": "0200092",
    "nama": "Risna Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 171500,
    "total_denda": 15000,
    "total_jumlah": 186500,
    "lat": 0.5454483,
    "lng": 121.5727567,
    "color": "#fd7e14"
}, {
    "nosamw": "0200591",
    "nama": "Roni Didipu",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5470148,
    "lng": 121.5762504,
    "color": "#ffc107"
}, {
    "nosamw": "0200925",
    "nama": "Rostin Monoarfa",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1073500,
    "total_denda": 90000,
    "total_jumlah": 1163500,
    "lat": 0.5463251,
    "lng": 121.5780995,
    "color": "#dc3545"
}, {
    "nosamw": "0200114",
    "nama": "S. G. Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 2579000,
    "total_denda": 100000,
    "total_jumlah": 2679000,
    "lat": 0.5452217,
    "lng": 121.57278,
    "color": "#dc3545"
}, {
    "nosamw": "0200464",
    "nama": "Safia Kunji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 926800,
    "total_denda": 130000,
    "total_jumlah": 1056800,
    "lat": 0.5455433,
    "lng": 121.5767272,
    "color": "#dc3545"
}, {
    "nosamw": "0200967",
    "nama": "Saida Kundji",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5452935,
    "lng": 121.5772907,
    "color": "#fd7e14"
}, {
    "nosamw": "0201182",
    "nama": "Samsul Pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.545344,
    "lng": 121.5770007,
    "color": "#dc3545"
}, {
    "nosamw": "0200165",
    "nama": "Saraati Ahmad",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 45000,
    "total_jumlah": 600000,
    "lat": 0.544185,
    "lng": 121.5728717,
    "color": "#dc3545"
}, {
    "nosamw": "0200917",
    "nama": "Sarifudin Akolo",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 285000,
    "total_denda": 35000,
    "total_jumlah": 320000,
    "lat": 0.5421011,
    "lng": 121.5802804,
    "color": "#dc3545"
}, {
    "nosamw": "0200698",
    "nama": "SARTIN IBRAHIM",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 663400,
    "total_denda": 95000,
    "total_jumlah": 758400,
    "lat": 0.5443091,
    "lng": 121.5789519,
    "color": "#dc3545"
}, {
    "nosamw": "0200451",
    "nama": "Srimelati Lahuo",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.545426,
    "lng": 121.5761411,
    "color": "#ffc107"
}, {
    "nosamw": "0200691",
    "nama": "Sugiono",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 434000,
    "total_denda": 60000,
    "total_jumlah": 494000,
    "lat": 0.5429628,
    "lng": 121.5796275,
    "color": "#dc3545"
}, {
    "nosamw": "0200490",
    "nama": "SulemaN Marawa",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5408406,
    "lng": 121.5804625,
    "color": "#dc3545"
}, {
    "nosamw": "0200493",
    "nama": "Sunardi Van Gobel",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.5461501,
    "lng": 121.5782183,
    "color": "#ffc107"
}, {
    "nosamw": "0200908",
    "nama": "Udin pakaya",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467084,
    "lng": 121.94953,
    "color": "#28a745"
}, {
    "nosamw": "0201017",
    "nama": "USAID Lun Tuka",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 510250,
    "total_denda": 20000,
    "total_jumlah": 530250,
    "lat": 0.5470586,
    "lng": 121.5759253,
    "color": "#fd7e14"
}, {
    "nosamw": "0201048",
    "nama": "USAID Safrudin Bula",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.5414795,
    "lng": 121.5804212,
    "color": "#fd7e14"
}, {
    "nosamw": "0201049",
    "nama": "USAID SUPARDHI PILOBU",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5404934,
    "lng": 121.580565,
    "color": "#dc3545"
}, {
    "nosamw": "0201019",
    "nama": "USAID Wiwin Adam",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085256126205",
    "total_bulan": 14,
    "total_tagihan": 1185250,
    "total_denda": 65000,
    "total_jumlah": 1250250,
    "lat": 0.5631184,
    "lng": 121.5640682,
    "color": "#dc3545"
}, {
    "nosamw": "0201018",
    "nama": "USAID Yaman Lasalutu",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.5474154,
    "lng": 121.5764212,
    "color": "#ffc107"
}, {
    "nosamw": "0200943",
    "nama": "USAID Yusup Labaco",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 460000,
    "total_denda": 60000,
    "total_jumlah": 520000,
    "lat": 0.5426776,
    "lng": 121.5797292,
    "color": "#dc3545"
}, {
    "nosamw": "0200534",
    "nama": "Usman Abuba",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.5453974,
    "lng": 121.5755996,
    "color": "#ffc107"
}, {
    "nosamw": "0200540",
    "nama": "Wahab Karama",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 575000,
    "total_denda": 50000,
    "total_jumlah": 625000,
    "lat": 0.5635317,
    "lng": 121.567805,
    "color": "#dc3545"
}, {
    "nosamw": "0201084",
    "nama": "Wahid Karama",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 285000,
    "total_denda": 35000,
    "total_jumlah": 320000,
    "lat": 0.5386972,
    "lng": 121.5815323,
    "color": "#dc3545"
}, {
    "nosamw": "0200495",
    "nama": "Yan Husain",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.5454898,
    "lng": 121.5754584,
    "color": "#fd7e14"
}, {
    "nosamw": "0201150",
    "nama": "Yasin Lahay",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 789000,
    "total_denda": 115000,
    "total_jumlah": 904000,
    "lat": 0.5461863,
    "lng": 121.5781382,
    "color": "#dc3545"
}, {
    "nosamw": "0200553",
    "nama": "Yunus Ishak",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 660000,
    "total_denda": 95000,
    "total_jumlah": 755000,
    "lat": 0.5444077,
    "lng": 121.5790428,
    "color": "#dc3545"
}, {
    "nosamw": "0200031",
    "nama": "Yusuf Ibrahim",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47173,
    "lng": 121.945637,
    "color": "#28a745"
}, {
    "nosamw": "0200903",
    "nama": "Yusuf Lahay",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446731,
    "lng": 121.939244,
    "color": "#28a745"
}, {
    "nosamw": "0200521",
    "nama": "Zenab Mantulangi",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 355000,
    "total_denda": 45000,
    "total_jumlah": 400000,
    "lat": 0.5428685,
    "lng": 121.5797252,
    "color": "#dc3545"
}, {
    "nosamw": "0200645",
    "nama": "Zenap Uliani",
    "kecamatan": "KEC LEMITO DESA WONGGARASI BARAT",
    "desa": "WONGGARASI BARAT",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 390000,
    "total_denda": 50000,
    "total_jumlah": 440000,
    "lat": 0.545456,
    "lng": 121.5771964,
    "color": "#dc3545"
}, {
    "nosamw": "0200648",
    "nama": "Abdullah Bumulo",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 320000,
    "total_denda": 45000,
    "total_jumlah": 365000,
    "lat": 0.556722,
    "lng": 121.6303337,
    "color": "#dc3545"
}, {
    "nosamw": "0201055",
    "nama": "Alfian",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 791000,
    "total_denda": 115000,
    "total_jumlah": 906000,
    "lat": 0.5561043,
    "lng": 121.6275445,
    "color": "#dc3545"
}, {
    "nosamw": "0201618",
    "nama": "H18 ARPAN DUNGGIO",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.557241,
    "lng": 121.5526464,
    "color": "#ffc107"
}, {
    "nosamw": "0201518",
    "nama": "HAMIDUN DJURIATI",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 40,
    "total_tagihan": 1417000,
    "total_denda": 195000,
    "total_jumlah": 1612000,
    "lat": 0.5555401,
    "lng": 121.6370752,
    "color": "#dc3545"
}, {
    "nosamw": "0200333",
    "nama": "HERLINA TANGAHU",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 846500,
    "total_denda": 120000,
    "total_jumlah": 966500,
    "lat": 0.5566209,
    "lng": 121.6322056,
    "color": "#dc3545"
}, {
    "nosamw": "0201522",
    "nama": "KASIM KOLI",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 38,
    "total_tagihan": 1302000,
    "total_denda": 185000,
    "total_jumlah": 1487000,
    "lat": 0.5522741,
    "lng": 121.6378357,
    "color": "#dc3545"
}, {
    "nosamw": "0200500",
    "nama": "Mesjid Al-Ikhlas",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458828,
    "lng": 121.936022,
    "color": "#28a745"
}, {
    "nosamw": "0200365",
    "nama": "NINING PAKAYA",
    "kecamatan": "KEC LEMITO DESA WONGGARASI TENGAH",
    "desa": "WONGGARASI TENGAH",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 1025000,
    "total_denda": 145000,
    "total_jumlah": 1170000,
    "lat": 0.5566568,
    "lng": 121.6319072,
    "color": "#dc3545"
}, {
    "nosamw": "0400040",
    "nama": "Abdullah Rahmad",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 585000,
    "total_denda": 15000,
    "total_jumlah": 600000,
    "lat": 0.477152,
    "lng": 121.947715,
    "color": "#fd7e14"
}, {
    "nosamw": "0407352",
    "nama": "ALWIN MAKUTA \/ NO. 24 \/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 581200,
    "total_denda": 70000,
    "total_jumlah": 651200,
    "lat": 0.4775074,
    "lng": 121.9442739,
    "color": "#dc3545"
}, {
    "nosamw": "0401655",
    "nama": "Andris Diange",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 658000,
    "total_denda": 30000,
    "total_jumlah": 688000,
    "lat": 0.476674,
    "lng": 121.947366,
    "color": "#fd7e14"
}, {
    "nosamw": "0401562",
    "nama": "Arwan Dini Karim",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.474782,
    "lng": 121.940275,
    "color": "#ffc107"
}, {
    "nosamw": "0402004",
    "nama": "Asis",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477221,
    "lng": 121.947753,
    "color": "#28a745"
}, {
    "nosamw": "0407539",
    "nama": "AULA PENYULUH KB \/ BOBI TRIANTO MAKU",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "085256740059",
    "total_bulan": 3,
    "total_tagihan": 1207500,
    "total_denda": 20000,
    "total_jumlah": 1227500,
    "lat": 0.4755062,
    "lng": 121.9464281,
    "color": "#fd7e14"
}, {
    "nosamw": "0405880",
    "nama": "BAHRUDIN HUSA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 202500,
    "total_denda": 0,
    "total_jumlah": 202500,
    "lat": 0.4765075,
    "lng": 121.947095,
    "color": "#ffc107"
}, {
    "nosamw": "0405881",
    "nama": "CUN BUKADIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4767964,
    "lng": 121.9473333,
    "color": "#ffc107"
}, {
    "nosamw": "0404170",
    "nama": "Djiro Huladu",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 84200,
    "total_denda": 15000,
    "total_jumlah": 99200,
    "lat": 0.474048,
    "lng": 121.95538,
    "color": "#fd7e14"
}, {
    "nosamw": "0407354",
    "nama": "FATMA YUNUS \/ NO 22 \/ RN .LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 668400,
    "total_denda": 90000,
    "total_jumlah": 758400,
    "lat": 0.4776856,
    "lng": 121.9443924,
    "color": "#dc3545"
}, {
    "nosamw": "0406417",
    "nama": "H18 ASNA SULEMAN",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 508600,
    "total_denda": 15000,
    "total_jumlah": 523600,
    "lat": 0.4748667,
    "lng": 121.9412974,
    "color": "#fd7e14"
}, {
    "nosamw": "0406395",
    "nama": "H18 NURMIN ABJUL",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4743998,
    "lng": 121.9420838,
    "color": "#fd7e14"
}, {
    "nosamw": "0406406",
    "nama": "H18 YENI AKUJE",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 987500,
    "total_denda": 5000,
    "total_jumlah": 992500,
    "lat": 0.4758405,
    "lng": 121.9400539,
    "color": "#ffc107"
}, {
    "nosamw": "0406940",
    "nama": "H19 ARMAN HASAN",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2138500,
    "total_denda": 60000,
    "total_jumlah": 2198500,
    "lat": 0.475494,
    "lng": 121.9467361,
    "color": "#dc3545"
}, {
    "nosamw": "0406964",
    "nama": "H19 RAUF PAKAYA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.4768225,
    "lng": 121.9471537,
    "color": "#ffc107"
}, {
    "nosamw": "0406887",
    "nama": "H19 SURIANTO TOIYO",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4771783,
    "lng": 121.9414682,
    "color": "#ffc107"
}, {
    "nosamw": "0407342",
    "nama": "HABIBA MBUINGA \/ NO. 11\/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1192800,
    "total_denda": 65000,
    "total_jumlah": 1257800,
    "lat": 0.4777271,
    "lng": 121.9444987,
    "color": "#dc3545"
}, {
    "nosamw": "0403171",
    "nama": "Hadija Babunga",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 3711500,
    "total_denda": 85000,
    "total_jumlah": 3796500,
    "lat": 0.473874,
    "lng": 121.944477,
    "color": "#dc3545"
}, {
    "nosamw": "0407343",
    "nama": "HADIJA NENTO \/ NO 14 \/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4777511,
    "lng": 121.9443252,
    "color": "#ffc107"
}, {
    "nosamw": "0407344",
    "nama": "HASANA YUNUS \/ NO 1 \/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4782285,
    "lng": 121.9441955,
    "color": "#ffc107"
}, {
    "nosamw": "0400428",
    "nama": "Hendra Supriyadi",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.480286,
    "lng": 121.944677,
    "color": "#28a745"
}, {
    "nosamw": "0403618",
    "nama": "Herman Tantalama",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.476704,
    "lng": 121.947244,
    "color": "#28a745"
}, {
    "nosamw": "0403422",
    "nama": "Ibrahim Suleman",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 205400,
    "total_denda": 15000,
    "total_jumlah": 220400,
    "lat": 0.473764,
    "lng": 121.944726,
    "color": "#fd7e14"
}, {
    "nosamw": "0400944",
    "nama": "Indrayani Suleman",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4772248,
    "lng": 121.9414719,
    "color": "#28a745"
}, {
    "nosamw": "0404741",
    "nama": "IRFAN POMANTO",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4739201,
    "lng": 121.943489,
    "color": "#fd7e14"
}, {
    "nosamw": "0405886",
    "nama": "ISMAIL PARAJULI",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4764908,
    "lng": 121.9470998,
    "color": "#ffc107"
}, {
    "nosamw": "0402324",
    "nama": "Iwan Karim",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 490000,
    "total_denda": 10000,
    "total_jumlah": 500000,
    "lat": 0.4742919,
    "lng": 121.9434788,
    "color": "#ffc107"
}, {
    "nosamw": "0407388",
    "nama": "JAMILA MOKAWI \/ NO. 13 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 1407350,
    "total_denda": 145000,
    "total_jumlah": 1552350,
    "lat": 0.4777841,
    "lng": 121.944391,
    "color": "#dc3545"
}, {
    "nosamw": "0402618",
    "nama": "Jamila S. Mokaini",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55400,
    "total_denda": 5000,
    "total_jumlah": 60400,
    "lat": 0.4767079,
    "lng": 121.9413293,
    "color": "#ffc107"
}, {
    "nosamw": "0403627",
    "nama": "Jamila Supu",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477057,
    "lng": 121.947168,
    "color": "#28a745"
}, {
    "nosamw": "0402129",
    "nama": "Jhon Gani",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4752994,
    "lng": 121.9405917,
    "color": "#28a745"
}, {
    "nosamw": "0403682",
    "nama": "Juina Humonggio",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.479963,
    "lng": 121.945575,
    "color": "#ffc107"
}, {
    "nosamw": "0402114",
    "nama": "JURI WARTABONE",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 337500,
    "total_denda": 10000,
    "total_jumlah": 347500,
    "lat": 0.4781871,
    "lng": 121.9440872,
    "color": "#ffc107"
}, {
    "nosamw": "0405929",
    "nama": "KARIM BANGGA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 168500,
    "total_denda": 5000,
    "total_jumlah": 173500,
    "lat": 0.4786586,
    "lng": 121.9474083,
    "color": "#ffc107"
}, {
    "nosamw": "0402806",
    "nama": "Karsum Ali",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 632600,
    "total_denda": 25000,
    "total_jumlah": 657600,
    "lat": 0.47706,
    "lng": 121.947659,
    "color": "#fd7e14"
}, {
    "nosamw": "0407356",
    "nama": "KARTIN ZAKARIA \/ NO 19 \/ RN. LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302000,
    "total_denda": 40000,
    "total_jumlah": 342000,
    "lat": 0.4777865,
    "lng": 121.9443221,
    "color": "#dc3545"
}, {
    "nosamw": "0407360",
    "nama": "KASMAN LADIKU \/ NO 16 \/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 515400,
    "total_denda": 35000,
    "total_jumlah": 550400,
    "lat": 0.4778089,
    "lng": 121.9442458,
    "color": "#dc3545"
}, {
    "nosamw": "0407341",
    "nama": "LIAN MBUINGA S.SOS NO. 15\/RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 548700,
    "total_denda": 25000,
    "total_jumlah": 573700,
    "lat": 0.4777799,
    "lng": 121.9442468,
    "color": "#fd7e14"
}, {
    "nosamw": "0403170",
    "nama": "Lin Suleman",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473706,
    "lng": 121.944424,
    "color": "#28a745"
}, {
    "nosamw": "0401813",
    "nama": "Lince Mbuinga",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.475854,
    "lng": 121.945071,
    "color": "#ffc107"
}, {
    "nosamw": "0404780",
    "nama": "Lisda Hippy",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1386500,
    "total_denda": 5000,
    "total_jumlah": 1391500,
    "lat": 0.4732007,
    "lng": 121.9461379,
    "color": "#fd7e14"
}, {
    "nosamw": "0402901",
    "nama": "Lisna Ibrahim",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 246200,
    "total_denda": 25000,
    "total_jumlah": 271200,
    "lat": 0.473757,
    "lng": 121.945052,
    "color": "#fd7e14"
}, {
    "nosamw": "0403190",
    "nama": "Lowan Dunggio",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.474941,
    "lng": 121.940025,
    "color": "#28a745"
}, {
    "nosamw": "0407345",
    "nama": "MARLINA \/ NO.23 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 609200,
    "total_denda": 70000,
    "total_jumlah": 679200,
    "lat": 0.4775787,
    "lng": 121.9444386,
    "color": "#dc3545"
}, {
    "nosamw": "0404415",
    "nama": "Mesjid Al- Hikmah",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 35500,
    "total_denda": 10000,
    "total_jumlah": 45500,
    "lat": 0.475186,
    "lng": 121.939202,
    "color": "#fd7e14"
}, {
    "nosamw": "0401196",
    "nama": "Miden s.d. Gole",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4780343,
    "lng": 121.9481335,
    "color": "#28a745"
}, {
    "nosamw": "0404733",
    "nama": "MOH. ADITYA ABD",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4746921,
    "lng": 121.9435806,
    "color": "#28a745"
}, {
    "nosamw": "0407264",
    "nama": "MOHAMAD AMIN ABUBAKAR",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.479159,
    "lng": 121.9467323,
    "color": "#ffc107"
}, {
    "nosamw": "0407349",
    "nama": "MUDIN SAID \/ NO 7 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 482800,
    "total_denda": 50000,
    "total_jumlah": 532800,
    "lat": 0.4779873,
    "lng": 121.9442729,
    "color": "#dc3545"
}, {
    "nosamw": "0401517",
    "nama": "Muh. Tito Dunggio",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.480033,
    "lng": 121.944218,
    "color": "#fd7e14"
}, {
    "nosamw": "0407440",
    "nama": "MUSHOLAH RUMAH LANSIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "081355575558",
    "total_bulan": 24,
    "total_tagihan": 101000,
    "total_denda": 115000,
    "total_jumlah": 216000,
    "lat": 0.4775587,
    "lng": 121.9443525,
    "color": "#dc3545"
}, {
    "nosamw": "0407355",
    "nama": "MUTIARA SAMADE \/ NO 21",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 479000,
    "total_denda": 35000,
    "total_jumlah": 514000,
    "lat": 0.4777879,
    "lng": 121.9443647,
    "color": "#dc3545"
}, {
    "nosamw": "0402728",
    "nama": "Nita Huala",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.476693,
    "lng": 121.947461,
    "color": "#28a745"
}, {
    "nosamw": "0404498",
    "nama": "Nurdiansyah Panigoro",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1333500,
    "total_denda": 65000,
    "total_jumlah": 1398500,
    "lat": 0.474608,
    "lng": 121.94078,
    "color": "#dc3545"
}, {
    "nosamw": "0400657",
    "nama": "Nurgawati Dama",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1482000,
    "total_denda": 45000,
    "total_jumlah": 1527000,
    "lat": 0.4804924,
    "lng": 121.9424764,
    "color": "#dc3545"
}, {
    "nosamw": "0407390",
    "nama": "RUSDIN HASAN \/ NO. 12 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 278000,
    "total_denda": 30000,
    "total_jumlah": 308000,
    "lat": 0.4777305,
    "lng": 121.9444651,
    "color": "#dc3545"
}, {
    "nosamw": "0407374",
    "nama": "SANDI PURNAMA KIAYI \/ NO. 20 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 62000,
    "total_denda": 0,
    "total_jumlah": 62000,
    "lat": 0.4776831,
    "lng": 121.9442938,
    "color": "#ffc107"
}, {
    "nosamw": "0406888",
    "nama": "SARWEDI",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 195000,
    "total_denda": 0,
    "total_jumlah": 195000,
    "lat": 0.4788736,
    "lng": 121.9469678,
    "color": "#ffc107"
}, {
    "nosamw": "0407398",
    "nama": "SELFI TAMBAYONG,NO 6 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 359000,
    "total_denda": 30000,
    "total_jumlah": 389000,
    "lat": 0.4779621,
    "lng": 121.9442844,
    "color": "#dc3545"
}, {
    "nosamw": "0403432",
    "nama": "SINTIA AKUBA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 477500,
    "total_denda": 40000,
    "total_jumlah": 517500,
    "lat": 0.475332,
    "lng": 121.9451875,
    "color": "#dc3545"
}, {
    "nosamw": "0407391",
    "nama": "SISTA ARI IMASANING",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082290758869",
    "total_bulan": 1,
    "total_tagihan": 195000,
    "total_denda": 0,
    "total_jumlah": 195000,
    "lat": 0.4775138,
    "lng": 121.9415261,
    "color": "#ffc107"
}, {
    "nosamw": "0402811",
    "nama": "Sudin Diange",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 2184500,
    "total_denda": 55000,
    "total_jumlah": 2239500,
    "lat": 0.476927,
    "lng": 121.947301,
    "color": "#dc3545"
}, {
    "nosamw": "0403798",
    "nama": "Suharto Harun",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.474861,
    "lng": 121.947203,
    "color": "#28a745"
}, {
    "nosamw": "0403020",
    "nama": "Sukarman Mohamad",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 4225000,
    "total_denda": 70000,
    "total_jumlah": 4295000,
    "lat": 0.475114,
    "lng": 121.939469,
    "color": "#dc3545"
}, {
    "nosamw": "0407348",
    "nama": "SUMARDI IBRAHIM \/ NO 8 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4779047,
    "lng": 121.9442164,
    "color": "#ffc107"
}, {
    "nosamw": "0405919",
    "nama": "SUNARTI DJOU",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4785796,
    "lng": 121.9475901,
    "color": "#ffc107"
}, {
    "nosamw": "0403199",
    "nama": "Sunu Ali",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.476926,
    "lng": 121.947423,
    "color": "#fd7e14"
}, {
    "nosamw": "0402729",
    "nama": "Tamrin S. Ali",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.476818,
    "lng": 121.947113,
    "color": "#ffc107"
}, {
    "nosamw": "0405492",
    "nama": "TAMSIR LUKUM",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1199500,
    "total_denda": 25000,
    "total_jumlah": 1224500,
    "lat": 0.4753452,
    "lng": 121.9470258,
    "color": "#fd7e14"
}, {
    "nosamw": "0401877",
    "nama": "Thalib Badaria",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1183500,
    "total_denda": 10000,
    "total_jumlah": 1193500,
    "lat": 0.47448,
    "lng": 121.94156,
    "color": "#ffc107"
}, {
    "nosamw": "0407350",
    "nama": "USMAN SALEH \/ NO 18 \/RN .LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 179000,
    "total_denda": 20000,
    "total_jumlah": 199000,
    "lat": 0.477745,
    "lng": 121.944155,
    "color": "#fd7e14"
}, {
    "nosamw": "0402805",
    "nama": "Warda Pasisingi",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4746716,
    "lng": 121.9436673,
    "color": "#28a745"
}, {
    "nosamw": "0403252",
    "nama": "Warni Tantu",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 340000,
    "total_denda": 25000,
    "total_jumlah": 365000,
    "lat": 0.4813292,
    "lng": 121.9424934,
    "color": "#fd7e14"
}, {
    "nosamw": "0405907",
    "nama": "WELI HARUN",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4800207,
    "lng": 121.9435513,
    "color": "#fd7e14"
}, {
    "nosamw": "0407351",
    "nama": "YANSER YUSUF \/ NO 5 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 255200,
    "total_denda": 15000,
    "total_jumlah": 270200,
    "lat": 0.4779903,
    "lng": 121.9441808,
    "color": "#fd7e14"
}, {
    "nosamw": "0401620",
    "nama": "Yolly Motto 4",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47525,
    "lng": 121.9398008,
    "color": "#28a745"
}, {
    "nosamw": "0404287",
    "nama": "YUNUS PULUHULAWA NO.25 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.4775321,
    "lng": 121.9440623,
    "color": "#ffc107"
}, {
    "nosamw": "0407346",
    "nama": "YUSUF H. BUMULO \/ NO. 4 \/ RN LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 316600,
    "total_denda": 35000,
    "total_jumlah": 351600,
    "lat": 0.4780073,
    "lng": 121.9443949,
    "color": "#dc3545"
}, {
    "nosamw": "0405935",
    "nama": "YUSUF IBRAHIM",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47173,
    "lng": 121.945637,
    "color": "#28a745"
}, {
    "nosamw": "0401058",
    "nama": "Yusuf Mbuinga.",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475462,
    "lng": 121.944534,
    "color": "#28a745"
}, {
    "nosamw": "0403556",
    "nama": "Yusuf Melu",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 71600,
    "total_denda": 10000,
    "total_jumlah": 81600,
    "lat": 0.476512,
    "lng": 121.947295,
    "color": "#ffc107"
}, {
    "nosamw": "0403626",
    "nama": "Yusuf Polumuduyo",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 5000,
    "total_jumlah": 73000,
    "lat": 0.476801,
    "lng": 121.947285,
    "color": "#ffc107"
}, {
    "nosamw": "0403111",
    "nama": "Yusuf Tino",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 162000,
    "total_denda": 30000,
    "total_jumlah": 192000,
    "lat": 0.477394,
    "lng": 121.947733,
    "color": "#fd7e14"
}, {
    "nosamw": "0407359",
    "nama": "ZUBAEDAH SUWELEH \/ NO 3 \/ RN.LANZIA",
    "kecamatan": "KEC MARISA DESA BOTUBILOTAHU",
    "desa": "BOTUBILOTAHU",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1739200,
    "total_denda": 80000,
    "total_jumlah": 1819200,
    "lat": 0.478106,
    "lng": 121.9441821,
    "color": "#dc3545"
}, {
    "nosamw": "0402240",
    "nama": "Abd Haris Male",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465843,
    "lng": 121.935086,
    "color": "#28a745"
}, {
    "nosamw": "0403033",
    "nama": "Abd Wahab Ibrahim II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1525000,
    "total_denda": 25000,
    "total_jumlah": 1550000,
    "lat": 0.4599477,
    "lng": 121.940517,
    "color": "#fd7e14"
}, {
    "nosamw": "0400344",
    "nama": "Abd. Kadir Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082396066815",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464144,
    "lng": 121.936871,
    "color": "#28a745"
}, {
    "nosamw": "0400584",
    "nama": "Abd. Kadir Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 6005000,
    "total_denda": 50000,
    "total_jumlah": 6055000,
    "lat": 0.458992,
    "lng": 121.951406,
    "color": "#fd7e14"
}, {
    "nosamw": "0400099",
    "nama": "Abd. Kadir Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 8632600,
    "total_denda": 85000,
    "total_jumlah": 8717600,
    "lat": 0.456257,
    "lng": 121.937108,
    "color": "#dc3545"
}, {
    "nosamw": "0400142",
    "nama": "Abd. Karim Antuli",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460517,
    "lng": 121.936699,
    "color": "#28a745"
}, {
    "nosamw": "0401567",
    "nama": "Abd. Rahman Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466704,
    "lng": 121.949675,
    "color": "#28a745"
}, {
    "nosamw": "0400499",
    "nama": "Abd. Rahman Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466704,
    "lng": 121.949675,
    "color": "#28a745"
}, {
    "nosamw": "0400877",
    "nama": "Abd. Rahman Wartabone",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1835000,
    "total_denda": 20000,
    "total_jumlah": 1855000,
    "lat": 0.459379,
    "lng": 121.953539,
    "color": "#fd7e14"
}, {
    "nosamw": "0403350",
    "nama": "Abdul Hamid Saleh",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#ffc107"
}, {
    "nosamw": "0402062",
    "nama": "Abdulah Yusuf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 327000,
    "total_denda": 30000,
    "total_jumlah": 357000,
    "lat": 0.462825,
    "lng": 121.944435,
    "color": "#fd7e14"
}, {
    "nosamw": "0401082",
    "nama": "Abdullah Bawu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 5452500,
    "total_denda": 80000,
    "total_jumlah": 5532500,
    "lat": 0.45603,
    "lng": 121.937345,
    "color": "#dc3545"
}, {
    "nosamw": "0401550",
    "nama": "Abdullah Nani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467684,
    "lng": 121.953248,
    "color": "#28a745"
}, {
    "nosamw": "0403632",
    "nama": "Adam Rais",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.4614624,
    "lng": 121.9445048,
    "color": "#ffc107"
}, {
    "nosamw": "0403639",
    "nama": "Adi Djafar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45606,
    "lng": 121.935889,
    "color": "#28a745"
}, {
    "nosamw": "0401413",
    "nama": "Adin Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 920000,
    "total_denda": 85000,
    "total_jumlah": 1005000,
    "lat": 0.464425,
    "lng": 121.935307,
    "color": "#dc3545"
}, {
    "nosamw": "0400681",
    "nama": "Adriani Kardiat",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456377,
    "lng": 121.938193,
    "color": "#28a745"
}, {
    "nosamw": "0400532",
    "nama": "Adu Hanapi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082188534500",
    "total_bulan": 24,
    "total_tagihan": 3950000,
    "total_denda": 120000,
    "total_jumlah": 4070000,
    "lat": 0.46251,
    "lng": 121.9442561,
    "color": "#dc3545"
}, {
    "nosamw": "0401626",
    "nama": "Advon Nento II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1330500,
    "total_denda": 50000,
    "total_jumlah": 1380500,
    "lat": 0.459844,
    "lng": 121.936649,
    "color": "#dc3545"
}, {
    "nosamw": "0403373",
    "nama": "Agus Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.459342,
    "lng": 121.936772,
    "color": "#ffc107"
}, {
    "nosamw": "0402998",
    "nama": "Agus Kidam",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.457189,
    "lng": 121.942209,
    "color": "#fd7e14"
}, {
    "nosamw": "0400293",
    "nama": "Agusti M. Goma",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 12324500,
    "total_denda": 75000,
    "total_jumlah": 12399500,
    "lat": 0.466798,
    "lng": 121.938394,
    "color": "#dc3545"
}, {
    "nosamw": "0402440",
    "nama": "Ahmad Afandi S.Sos",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1705000,
    "total_denda": 30000,
    "total_jumlah": 1735000,
    "lat": 0.4607276,
    "lng": 121.9439008,
    "color": "#fd7e14"
}, {
    "nosamw": "0400443",
    "nama": "Ahmad Juuna",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.457234,
    "lng": 121.939797,
    "color": "#ffc107"
}, {
    "nosamw": "0400560",
    "nama": "Ajang Taufik",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 188000,
    "total_denda": 10000,
    "total_jumlah": 198000,
    "lat": 0.456807,
    "lng": 121.937641,
    "color": "#ffc107"
}, {
    "nosamw": "0403901",
    "nama": "Alan Adam\/ Kafe Oma 1",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4585747,
    "lng": 121.9452776,
    "color": "#28a745"
}, {
    "nosamw": "0400029",
    "nama": "Ali Akbar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 550000,
    "total_denda": 50000,
    "total_jumlah": 600000,
    "lat": 0.465997,
    "lng": 121.937657,
    "color": "#dc3545"
}, {
    "nosamw": "0401938",
    "nama": "ALIANSI JURNALIS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "082196729733",
    "total_bulan": 8,
    "total_tagihan": 820000,
    "total_denda": 110000,
    "total_jumlah": 930000,
    "lat": 0.4614652,
    "lng": 121.9458221,
    "color": "#dc3545"
}, {
    "nosamw": "0400671",
    "nama": "Aliyah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1221250,
    "total_denda": 55000,
    "total_jumlah": 1276250,
    "lat": 0.460783,
    "lng": 121.936829,
    "color": "#dc3545"
}, {
    "nosamw": "0402063",
    "nama": "Amin Lopuo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 232000,
    "total_denda": 10000,
    "total_jumlah": 242000,
    "lat": 0.460165,
    "lng": 121.937038,
    "color": "#ffc107"
}, {
    "nosamw": "0400628",
    "nama": "Amir Wadu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.46361,
    "lng": 121.935833,
    "color": "#ffc107"
}, {
    "nosamw": "0402596",
    "nama": "Amirudin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 918500,
    "total_denda": 35000,
    "total_jumlah": 953500,
    "lat": 0.459019,
    "lng": 121.935972,
    "color": "#dc3545"
}, {
    "nosamw": "0402682",
    "nama": "Ana Abdul Azis",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465957,
    "lng": 121.935021,
    "color": "#28a745"
}, {
    "nosamw": "0400492",
    "nama": "Andi Priyasdanto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 12098500,
    "total_denda": 50000,
    "total_jumlah": 12148500,
    "lat": 0.46216,
    "lng": 121.937771,
    "color": "#dc3545"
}, {
    "nosamw": "0402259",
    "nama": "Andi Simpurusiah,Spd",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 698000,
    "total_denda": 45000,
    "total_jumlah": 743000,
    "lat": 0.4560467,
    "lng": 121.9413624,
    "color": "#dc3545"
}, {
    "nosamw": "0402125",
    "nama": "Anhar Hunowu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 157500,
    "total_denda": 0,
    "total_jumlah": 157500,
    "lat": 0.4636233,
    "lng": 121.9448578,
    "color": "#ffc107"
}, {
    "nosamw": "0401581",
    "nama": "Anico Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 63800,
    "total_denda": 5000,
    "total_jumlah": 68800,
    "lat": 0.465787,
    "lng": 121.934924,
    "color": "#ffc107"
}, {
    "nosamw": "0403738",
    "nama": "Anis Rasyid",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 35000,
    "total_jumlah": 420000,
    "lat": 0.467625,
    "lng": 121.953536,
    "color": "#dc3545"
}, {
    "nosamw": "0407469",
    "nama": "ANTON HAIPI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082195677856",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.4545123,
    "lng": 121.9353357,
    "color": "#ffc107"
}, {
    "nosamw": "0401380",
    "nama": "Anwar Dulambuti",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 252500,
    "total_denda": 20000,
    "total_jumlah": 272500,
    "lat": 0.456661,
    "lng": 121.937745,
    "color": "#fd7e14"
}, {
    "nosamw": "0403467",
    "nama": "Ari Puyo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460435,
    "lng": 121.94325,
    "color": "#28a745"
}, {
    "nosamw": "0400334",
    "nama": "Ari Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463913,
    "lng": 121.936874,
    "color": "#28a745"
}, {
    "nosamw": "0400614",
    "nama": "Arifin Samaun",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.457171,
    "lng": 121.937458,
    "color": "#ffc107"
}, {
    "nosamw": "0405300",
    "nama": "ARLIN BUTUO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4625631,
    "lng": 121.9444678,
    "color": "#28a745"
}, {
    "nosamw": "0402193",
    "nama": "Artin Lambeo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457682,
    "lng": 121.936812,
    "color": "#28a745"
}, {
    "nosamw": "0400253",
    "nama": "Aruji Samau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.455731,
    "lng": 121.937081,
    "color": "#ffc107"
}, {
    "nosamw": "0404516",
    "nama": "Asma Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.462185,
    "lng": 121.944554,
    "color": "#ffc107"
}, {
    "nosamw": "0400629",
    "nama": "Asmarahman Sihaloho",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 10000,
    "total_jumlah": 90000,
    "lat": 0.459494,
    "lng": 121.936817,
    "color": "#ffc107"
}, {
    "nosamw": "0401160",
    "nama": "Asmin Lajaru",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.465371,
    "lng": 121.937597,
    "color": "#fd7e14"
}, {
    "nosamw": "0402099",
    "nama": "Asna Ajiji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 5000,
    "total_jumlah": 73000,
    "lat": 0.458073,
    "lng": 121.937315,
    "color": "#ffc107"
}, {
    "nosamw": "0403566",
    "nama": "Asna H. Tutupoho",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 977500,
    "total_denda": 45000,
    "total_jumlah": 1022500,
    "lat": 0.459207,
    "lng": 121.937071,
    "color": "#dc3545"
}, {
    "nosamw": "0402173",
    "nama": "Asni Ishak",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466377,
    "lng": 121.936499,
    "color": "#28a745"
}, {
    "nosamw": "0401046",
    "nama": "Asrapin Botutihe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1898500,
    "total_denda": 40000,
    "total_jumlah": 1938500,
    "lat": 0.459786,
    "lng": 121.960333,
    "color": "#dc3545"
}, {
    "nosamw": "0403437",
    "nama": "Asrin Daud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 2307000,
    "total_denda": 55000,
    "total_jumlah": 2362000,
    "lat": 0.464238,
    "lng": 121.936613,
    "color": "#dc3545"
}, {
    "nosamw": "0401479",
    "nama": "Asrin Laginta",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1207250,
    "total_denda": 55000,
    "total_jumlah": 1262250,
    "lat": 0.455855,
    "lng": 121.937313,
    "color": "#dc3545"
}, {
    "nosamw": "0401012",
    "nama": "Aten Rasid \/ RM. Gaba - G",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2247000,
    "total_denda": 65000,
    "total_jumlah": 2312000,
    "lat": 0.4681476,
    "lng": 121.9622988,
    "color": "#dc3545"
}, {
    "nosamw": "0404163",
    "nama": "Ati Jupri",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.460546,
    "lng": 121.937211,
    "color": "#ffc107"
}, {
    "nosamw": "0400434",
    "nama": "Ati Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46528,
    "lng": 121.946911,
    "color": "#28a745"
}, {
    "nosamw": "0401194",
    "nama": "Ati Nurhayati",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1790000,
    "total_denda": 20000,
    "total_jumlah": 1810000,
    "lat": 0.466298,
    "lng": 121.943026,
    "color": "#fd7e14"
}, {
    "nosamw": "0400607",
    "nama": "Aula ICHSAN Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1801000,
    "total_denda": 65000,
    "total_jumlah": 1866000,
    "lat": 0.466371,
    "lng": 121.946612,
    "color": "#fd7e14"
}, {
    "nosamw": "0401844",
    "nama": "AULA KPU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.4591344,
    "lng": 121.9545814,
    "color": "#ffc107"
}, {
    "nosamw": "0406162",
    "nama": "AULA SERBA GUNA RD. WABUP",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 227500,
    "total_denda": 0,
    "total_jumlah": 227500,
    "lat": 0.4571246,
    "lng": 121.9450763,
    "color": "#ffc107"
}, {
    "nosamw": "0401215",
    "nama": "Aula Serbaguna",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 932500,
    "total_denda": 0,
    "total_jumlah": 932500,
    "lat": 0.457426,
    "lng": 121.94819,
    "color": "#ffc107"
}, {
    "nosamw": "0402255",
    "nama": "Ayu Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.456775,
    "lng": 121.942523,
    "color": "#ffc107"
}, {
    "nosamw": "0400144",
    "nama": "Azis Alo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.467412,
    "lng": 121.934923,
    "color": "#fd7e14"
}, {
    "nosamw": "0406840",
    "nama": "AZIS LIHAWA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4601742,
    "lng": 121.9435409,
    "color": "#ffc107"
}, {
    "nosamw": "0403001",
    "nama": "BAMBANG TRI WAHONO 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.4562863,
    "lng": 121.9415417,
    "color": "#ffc107"
}, {
    "nosamw": "0403482",
    "nama": "Ben A. Kasim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2105000,
    "total_denda": 80000,
    "total_jumlah": 2185000,
    "lat": 0.460355,
    "lng": 121.937026,
    "color": "#dc3545"
}, {
    "nosamw": "0404497",
    "nama": "Bona Laef Simanunkalit",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466202,
    "lng": 121.945763,
    "color": "#28a745"
}, {
    "nosamw": "0400622",
    "nama": "Bpk. Mansur Monoarfa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 7802500,
    "total_denda": 135000,
    "total_jumlah": 7937500,
    "lat": 0.456538,
    "lng": 121.937771,
    "color": "#dc3545"
}, {
    "nosamw": "0400596",
    "nama": "BPKAD Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 2177500,
    "total_denda": 0,
    "total_jumlah": 2177500,
    "lat": 0.458867,
    "lng": 121.94544,
    "color": "#ffc107"
}, {
    "nosamw": "0402414",
    "nama": "Budi Olii 3",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "08134055661",
    "total_bulan": 6,
    "total_tagihan": 497500,
    "total_denda": 30000,
    "total_jumlah": 527500,
    "lat": 0.4621524,
    "lng": 121.9457972,
    "color": "#fd7e14"
}, {
    "nosamw": "0403369",
    "nama": "Budiyono Nihe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 620000,
    "total_denda": 70000,
    "total_jumlah": 690000,
    "lat": 0.466771,
    "lng": 121.936567,
    "color": "#dc3545"
}, {
    "nosamw": "0400591",
    "nama": "Buisang H. Janis",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 592500,
    "total_denda": 0,
    "total_jumlah": 592500,
    "lat": 0.4588658,
    "lng": 121.9520221,
    "color": "#ffc107"
}, {
    "nosamw": "0400470",
    "nama": "Candra Frimalie",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.46193,
    "lng": 121.937594,
    "color": "#ffc107"
}, {
    "nosamw": "0404681",
    "nama": "Chairudin Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 3763900,
    "total_denda": 120000,
    "total_jumlah": 3883900,
    "lat": 0.460442,
    "lng": 121.937003,
    "color": "#dc3545"
}, {
    "nosamw": "0400098",
    "nama": "Cornelis Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 566000,
    "total_denda": 15000,
    "total_jumlah": 581000,
    "lat": 0.45668,
    "lng": 121.936722,
    "color": "#fd7e14"
}, {
    "nosamw": "0400126",
    "nama": "Darna Rubemon",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.466459,
    "lng": 121.936559,
    "color": "#ffc107"
}, {
    "nosamw": "0400383",
    "nama": "Darwin Akase",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.466904,
    "lng": 121.949477,
    "color": "#dc3545"
}, {
    "nosamw": "0406924",
    "nama": "DARWIN AKASE 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4654917,
    "lng": 121.9518736,
    "color": "#ffc107"
}, {
    "nosamw": "0401038",
    "nama": "Darwin Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 440000,
    "total_denda": 40000,
    "total_jumlah": 480000,
    "lat": 0.460442,
    "lng": 121.937003,
    "color": "#dc3545"
}, {
    "nosamw": "0400516",
    "nama": "Daud Moha",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 322500,
    "total_denda": 0,
    "total_jumlah": 322500,
    "lat": 0.4623772,
    "lng": 121.9376439,
    "color": "#ffc107"
}, {
    "nosamw": "0403082",
    "nama": "DEWI HASAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 397000,
    "total_denda": 30000,
    "total_jumlah": 427000,
    "lat": 0.4617221,
    "lng": 121.9448848,
    "color": "#fd7e14"
}, {
    "nosamw": "0402767",
    "nama": "DIAN ABDULLAH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1517500,
    "total_denda": 10000,
    "total_jumlah": 1527500,
    "lat": 0.4599522,
    "lng": 121.9604553,
    "color": "#fd7e14"
}, {
    "nosamw": "0401258",
    "nama": "Dian E. Husain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.466409,
    "lng": 121.946868,
    "color": "#ffc107"
}, {
    "nosamw": "0402421",
    "nama": "Didin Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 320000,
    "total_denda": 20000,
    "total_jumlah": 340000,
    "lat": 0.459772,
    "lng": 121.940623,
    "color": "#fd7e14"
}, {
    "nosamw": "0400907",
    "nama": "DIKES Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 2305000,
    "total_denda": 5000,
    "total_jumlah": 2310000,
    "lat": 0.45946,
    "lng": 121.957152,
    "color": "#ffc107"
}, {
    "nosamw": "0402188",
    "nama": "DImas Adrianto Tahir",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465554,
    "lng": 121.937427,
    "color": "#28a745"
}, {
    "nosamw": "0403051",
    "nama": "Dimas Daniel",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458155,
    "lng": 121.943826,
    "color": "#28a745"
}, {
    "nosamw": "0403205",
    "nama": "Dinas.Perpus Dan keersipan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1652500,
    "total_denda": 0,
    "total_jumlah": 1652500,
    "lat": 0.4576224,
    "lng": 121.9450405,
    "color": "#ffc107"
}, {
    "nosamw": "0402899",
    "nama": "Dino Botutihe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466533,
    "lng": 121.936631,
    "color": "#28a745"
}, {
    "nosamw": "0404941",
    "nama": "DJAFAR HANAPIA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 3903500,
    "total_denda": 110000,
    "total_jumlah": 4013500,
    "lat": 0.4571959,
    "lng": 121.9364214,
    "color": "#dc3545"
}, {
    "nosamw": "0401873",
    "nama": "Djafar Tani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4584299,
    "lng": 121.9594284,
    "color": "#28a745"
}, {
    "nosamw": "0401352",
    "nama": "Djamila Abdjul",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 120000,
    "total_denda": 15000,
    "total_jumlah": 135000,
    "lat": 0.467371,
    "lng": 121.952246,
    "color": "#fd7e14"
}, {
    "nosamw": "0404565",
    "nama": "Djoni Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465051,
    "lng": 121.947102,
    "color": "#28a745"
}, {
    "nosamw": "0403037",
    "nama": "Dr. Pri Wulan Emma Paulie",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462083,
    "lng": 121.937889,
    "color": "#28a745"
}, {
    "nosamw": "0402508",
    "nama": "DRH. Titus Novianto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1583500,
    "total_denda": 65000,
    "total_jumlah": 1648500,
    "lat": 0.45733,
    "lng": 121.94128,
    "color": "#dc3545"
}, {
    "nosamw": "0400060",
    "nama": "Drs. Sartono",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.466178,
    "lng": 121.942935,
    "color": "#ffc107"
}, {
    "nosamw": "0401309",
    "nama": "Drs. Umar Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467192,
    "lng": 121.954998,
    "color": "#28a745"
}, {
    "nosamw": "0401153",
    "nama": "Eli Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 819000,
    "total_denda": 35000,
    "total_jumlah": 854000,
    "lat": 0.457969,
    "lng": 121.936825,
    "color": "#dc3545"
}, {
    "nosamw": "0402028",
    "nama": "Elwin Tahir",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466202,
    "lng": 121.945301,
    "color": "#28a745"
}, {
    "nosamw": "0402679",
    "nama": "Eman Abay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 450500,
    "total_denda": 25000,
    "total_jumlah": 475500,
    "lat": 0.45665,
    "lng": 121.936855,
    "color": "#fd7e14"
}, {
    "nosamw": "0401055",
    "nama": "Endang Butolo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466101,
    "lng": 121.937806,
    "color": "#28a745"
}, {
    "nosamw": "0407534",
    "nama": "EPI TAMUU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "087872149513",
    "total_bulan": 1,
    "total_tagihan": 540000,
    "total_denda": 0,
    "total_jumlah": 540000,
    "lat": 0.4579406,
    "lng": 121.9422671,
    "color": "#ffc107"
}, {
    "nosamw": "0402759",
    "nama": "ERLI HASAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 194500,
    "total_denda": 10000,
    "total_jumlah": 204500,
    "lat": 0.4666247,
    "lng": 121.948594,
    "color": "#ffc107"
}, {
    "nosamw": "0407271",
    "nama": "ERLIN.SAHABU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4630798,
    "lng": 121.9439534,
    "color": "#ffc107"
}, {
    "nosamw": "0403462",
    "nama": "Erna As Sukiran",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456702,
    "lng": 121.938372,
    "color": "#28a745"
}, {
    "nosamw": "0402999",
    "nama": "Erwin Bantahari",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 45000,
    "total_jumlah": 600000,
    "lat": 0.457228,
    "lng": 121.941808,
    "color": "#dc3545"
}, {
    "nosamw": "0403635",
    "nama": "Erwin Mosey",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 516500,
    "total_denda": 15000,
    "total_jumlah": 531500,
    "lat": 0.462282,
    "lng": 121.944593,
    "color": "#fd7e14"
}, {
    "nosamw": "0403107",
    "nama": "Ester Daniel \/ MCK",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 32000,
    "total_denda": 5000,
    "total_jumlah": 37000,
    "lat": 0.456064,
    "lng": 121.936071,
    "color": "#ffc107"
}, {
    "nosamw": "0403564",
    "nama": "Eva Mariana djatnika",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 5476500,
    "total_denda": 215000,
    "total_jumlah": 5691500,
    "lat": 0.456752,
    "lng": 121.938402,
    "color": "#dc3545"
}, {
    "nosamw": "0400455",
    "nama": "Faisal Bahsoan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356554435",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457234,
    "lng": 121.939797,
    "color": "#28a745"
}, {
    "nosamw": "0400165",
    "nama": "Fajal Wasilu I",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 908000,
    "total_denda": 70000,
    "total_jumlah": 978000,
    "lat": 0.455839,
    "lng": 121.937276,
    "color": "#dc3545"
}, {
    "nosamw": "0400345",
    "nama": "Fajal Wasilu II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465037,
    "lng": 121.937538,
    "color": "#28a745"
}, {
    "nosamw": "0400496",
    "nama": "Farid Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 838000,
    "total_denda": 25000,
    "total_jumlah": 863000,
    "lat": 0.456987,
    "lng": 121.942068,
    "color": "#fd7e14"
}, {
    "nosamw": "0404876",
    "nama": "FATMA ABDULLAH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 745000,
    "total_denda": 70000,
    "total_jumlah": 815000,
    "lat": 0.464997,
    "lng": 121.945788,
    "color": "#dc3545"
}, {
    "nosamw": "0401616",
    "nama": "Fatma Bafadhal II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1082500,
    "total_denda": 20000,
    "total_jumlah": 1102500,
    "lat": 0.466396,
    "lng": 121.947157,
    "color": "#fd7e14"
}, {
    "nosamw": "0403067",
    "nama": "Fatma Husain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.461675,
    "lng": 121.938411,
    "color": "#ffc107"
}, {
    "nosamw": "0402370",
    "nama": "Fatma Moputi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46466,
    "lng": 121.934362,
    "color": "#28a745"
}, {
    "nosamw": "0401240",
    "nama": "Fatma Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.465904,
    "lng": 121.963066,
    "color": "#ffc107"
}, {
    "nosamw": "0402676",
    "nama": "Fatma S. Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.456517,
    "lng": 121.938195,
    "color": "#ffc107"
}, {
    "nosamw": "0402282",
    "nama": "Fatmawati Goi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466897,
    "lng": 121.951286,
    "color": "#28a745"
}, {
    "nosamw": "0403030",
    "nama": "Fatmawaty Laraga, SE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4618077,
    "lng": 121.9383877,
    "color": "#ffc107"
}, {
    "nosamw": "0403077",
    "nama": "Fatmawaty Laraga, SE II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 830000,
    "total_denda": 70000,
    "total_jumlah": 900000,
    "lat": 0.4617656,
    "lng": 121.9383716,
    "color": "#dc3545"
}, {
    "nosamw": "0402460",
    "nama": "Fatra Tino",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.460583,
    "lng": 121.942948,
    "color": "#ffc107"
}, {
    "nosamw": "0400632",
    "nama": "Febrianti Djeppu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46191,
    "lng": 121.937904,
    "color": "#28a745"
}, {
    "nosamw": "0400272",
    "nama": "Felix Tomasong",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457726,
    "lng": 121.936553,
    "color": "#28a745"
}, {
    "nosamw": "0400929",
    "nama": "Fengki Katili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463928,
    "lng": 121.936832,
    "color": "#28a745"
}, {
    "nosamw": "0400630",
    "nama": "Ferawati Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456887,
    "lng": 121.937488,
    "color": "#28a745"
}, {
    "nosamw": "0400803",
    "nama": "Ferawaty Majoa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 10000,
    "total_jumlah": 126500,
    "lat": 0.456381,
    "lng": 121.938123,
    "color": "#ffc107"
}, {
    "nosamw": "0400834",
    "nama": "FERIANDI MERTOSONO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.4587645,
    "lng": 121.9520317,
    "color": "#ffc107"
}, {
    "nosamw": "0400922",
    "nama": "Ferry Rengkuan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 10000,
    "total_jumlah": 165500,
    "lat": 0.458229,
    "lng": 121.942864,
    "color": "#ffc107"
}, {
    "nosamw": "0402226",
    "nama": "Fery Irawan Gosal",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 65000,
    "total_denda": 5000,
    "total_jumlah": 70000,
    "lat": 0.466162,
    "lng": 121.945697,
    "color": "#ffc107"
}, {
    "nosamw": "0401516",
    "nama": "Feryal Bahar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448784,
    "lng": 121.944582,
    "color": "#28a745"
}, {
    "nosamw": "0402253",
    "nama": "Fidi Mustafa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.45725,
    "lng": 121.94177,
    "color": "#fd7e14"
}, {
    "nosamw": "0407474",
    "nama": "FIONA GOBEL",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082189072000",
    "total_bulan": 12,
    "total_tagihan": 986500,
    "total_denda": 55000,
    "total_jumlah": 1041500,
    "lat": 0.4565715,
    "lng": 121.9369409,
    "color": "#dc3545"
}, {
    "nosamw": "0400678",
    "nama": "Fiona Malik",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 358000,
    "total_denda": 25000,
    "total_jumlah": 383000,
    "lat": 0.456379,
    "lng": 121.937929,
    "color": "#fd7e14"
}, {
    "nosamw": "0400469",
    "nama": "FIRZALINA LASANTU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4565247,
    "lng": 121.9412269,
    "color": "#ffc107"
}, {
    "nosamw": "0400479",
    "nama": "Fitri Abd. Walid",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 518000,
    "total_denda": 35000,
    "total_jumlah": 553000,
    "lat": 0.457302,
    "lng": 121.941076,
    "color": "#dc3545"
}, {
    "nosamw": "0402367",
    "nama": "Fitrianti Saidi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.457768,
    "lng": 121.937457,
    "color": "#ffc107"
}, {
    "nosamw": "0400206",
    "nama": "Fitser Mohune",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.458083,
    "lng": 121.936482,
    "color": "#ffc107"
}, {
    "nosamw": "0400189",
    "nama": "Fredi Linggat",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462035,
    "lng": 121.937698,
    "color": "#28a745"
}, {
    "nosamw": "0405960",
    "nama": "GABRIELA NOVITA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 3785500,
    "total_denda": 100000,
    "total_jumlah": 3885500,
    "lat": 0.4590364,
    "lng": 121.9358773,
    "color": "#dc3545"
}, {
    "nosamw": "0403816",
    "nama": "Gei Lateka",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462328,
    "lng": 121.9462585,
    "color": "#28a745"
}, {
    "nosamw": "0400650",
    "nama": "Gereja BETHESDA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4646179,
    "lng": 121.9348087,
    "color": "#28a745"
}, {
    "nosamw": "0406582",
    "nama": "GRAND PANUA 1",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 451500,
    "total_denda": 35000,
    "total_jumlah": 486500,
    "lat": 0.4612895,
    "lng": 121.9388617,
    "color": "#dc3545"
}, {
    "nosamw": "0401275",
    "nama": "Grand Permai",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "HT",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100000,
    "total_denda": 0,
    "total_jumlah": 100000,
    "lat": 0.467248,
    "lng": 121.95468,
    "color": "#ffc107"
}, {
    "nosamw": "0400874",
    "nama": "Gudang Farmasi ( Dikes )",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 997500,
    "total_denda": 5000,
    "total_jumlah": 1002500,
    "lat": 0.458743,
    "lng": 121.956874,
    "color": "#ffc107"
}, {
    "nosamw": "0400847",
    "nama": "Gudang Pemda Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460271,
    "lng": 121.9452,
    "color": "#28a745"
}, {
    "nosamw": "0402646",
    "nama": "Gutra Saleh",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466072,
    "lng": 121.934878,
    "color": "#28a745"
}, {
    "nosamw": "0400502",
    "nama": "H. HERMAN DAMIS  4",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 353500,
    "total_denda": 15000,
    "total_jumlah": 368500,
    "lat": 0.459931,
    "lng": 121.935966,
    "color": "#fd7e14"
}, {
    "nosamw": "0406486",
    "nama": "H18 AGUSTIN H. KADIR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 318100,
    "total_denda": 10000,
    "total_jumlah": 328100,
    "lat": 0.4581151,
    "lng": 121.9366502,
    "color": "#fd7e14"
}, {
    "nosamw": "0406459",
    "nama": "H18 ALTON SAUWALI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165000,
    "total_denda": 0,
    "total_jumlah": 165000,
    "lat": 0.4559392,
    "lng": 121.9368637,
    "color": "#ffc107"
}, {
    "nosamw": "0406432",
    "nama": "H18 ARIPIN USMAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 588400,
    "total_denda": 80000,
    "total_jumlah": 668400,
    "lat": 0.4573374,
    "lng": 121.9363271,
    "color": "#dc3545"
}, {
    "nosamw": "0406452",
    "nama": "H18 ARIS POMILI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.4646816,
    "lng": 121.9433399,
    "color": "#dc3545"
}, {
    "nosamw": "0406592",
    "nama": "H18 ASTIN IBRAHIM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 278500,
    "total_denda": 15000,
    "total_jumlah": 293500,
    "lat": 0.4649034,
    "lng": 121.944503,
    "color": "#fd7e14"
}, {
    "nosamw": "0406433",
    "nama": "H18 BAHARUDIN GANI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 710500,
    "total_denda": 40000,
    "total_jumlah": 750500,
    "lat": 0.4543526,
    "lng": 121.9356651,
    "color": "#dc3545"
}, {
    "nosamw": "0406434",
    "nama": "H18 EMAN ABAY",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 141500,
    "total_denda": 0,
    "total_jumlah": 141500,
    "lat": 0.4548735,
    "lng": 121.9355388,
    "color": "#ffc107"
}, {
    "nosamw": "0406410",
    "nama": "H18 FATMA LADIKU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 327000,
    "total_denda": 20000,
    "total_jumlah": 347000,
    "lat": 0.4596638,
    "lng": 121.9363433,
    "color": "#fd7e14"
}, {
    "nosamw": "0406465",
    "nama": "H18 FATMA SAUWALI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 58200,
    "total_denda": 0,
    "total_jumlah": 58200,
    "lat": 0.4559283,
    "lng": 121.936745,
    "color": "#ffc107"
}, {
    "nosamw": "0406454",
    "nama": "H18 HALIM PAKAYA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4647052,
    "lng": 121.9428979,
    "color": "#fd7e14"
}, {
    "nosamw": "0406435",
    "nama": "H18 IKO ISHAK",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 492000,
    "total_denda": 35000,
    "total_jumlah": 527000,
    "lat": 0.4541756,
    "lng": 121.9354194,
    "color": "#dc3545"
}, {
    "nosamw": "0406488",
    "nama": "H18 INTON SAUWALI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 5000,
    "total_jumlah": 170000,
    "lat": 0.4558778,
    "lng": 121.9367153,
    "color": "#fd7e14"
}, {
    "nosamw": "0406596",
    "nama": "H18 KARMAN KACO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.4545041,
    "lng": 121.9353641,
    "color": "#ffc107"
}, {
    "nosamw": "0406436",
    "nama": "H18 KARTIN SAMAUN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 499000,
    "total_denda": 55000,
    "total_jumlah": 554000,
    "lat": 0.4544931,
    "lng": 121.9354464,
    "color": "#dc3545"
}, {
    "nosamw": "0406461",
    "nama": "H18 MEY TIAS PANAKILI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.4559418,
    "lng": 121.9368665,
    "color": "#ffc107"
}, {
    "nosamw": "0406467",
    "nama": "H18 MIRA ILAHUDE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 437500,
    "total_denda": 20000,
    "total_jumlah": 457500,
    "lat": 0.4546658,
    "lng": 121.935232,
    "color": "#fd7e14"
}, {
    "nosamw": "0406438",
    "nama": "H18 NISA ADJIJI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 143200,
    "total_denda": 20000,
    "total_jumlah": 163200,
    "lat": 0.4580835,
    "lng": 121.9375523,
    "color": "#fd7e14"
}, {
    "nosamw": "0406601",
    "nama": "H18 NUN DJAFAR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 508000,
    "total_denda": 40000,
    "total_jumlah": 548000,
    "lat": 0.4561156,
    "lng": 121.9366965,
    "color": "#dc3545"
}, {
    "nosamw": "0406439",
    "nama": "H18 NUNU DALANGGO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.4543652,
    "lng": 121.935516,
    "color": "#dc3545"
}, {
    "nosamw": "0406440",
    "nama": "H18 NURMILA KADIR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 264200,
    "total_denda": 15000,
    "total_jumlah": 279200,
    "lat": 0.4579685,
    "lng": 121.9372092,
    "color": "#fd7e14"
}, {
    "nosamw": "0406591",
    "nama": "H18 OLIVIANA KODONGAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4649135,
    "lng": 121.9446392,
    "color": "#ffc107"
}, {
    "nosamw": "0406441",
    "nama": "H18 PATMAWATY HANAPI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1974000,
    "total_denda": 75000,
    "total_jumlah": 2049000,
    "lat": 0.4581983,
    "lng": 121.936428,
    "color": "#dc3545"
}, {
    "nosamw": "0406442",
    "nama": "H18 RAMIDA ABDULLAH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 653600,
    "total_denda": 50000,
    "total_jumlah": 703600,
    "lat": 0.4548524,
    "lng": 121.9355348,
    "color": "#dc3545"
}, {
    "nosamw": "0406520",
    "nama": "H18 RIAN DJAFAR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 463500,
    "total_denda": 20000,
    "total_jumlah": 483500,
    "lat": 0.4559788,
    "lng": 121.9367313,
    "color": "#fd7e14"
}, {
    "nosamw": "0406444",
    "nama": "H18 SURI NIHE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 453900,
    "total_denda": 10000,
    "total_jumlah": 463900,
    "lat": 0.4555063,
    "lng": 121.9361641,
    "color": "#fd7e14"
}, {
    "nosamw": "0406445",
    "nama": "H18 SUWITO RAHIM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4561148,
    "lng": 121.9368688,
    "color": "#ffc107"
}, {
    "nosamw": "0406447",
    "nama": "H18 YULIN AKE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 80000,
    "total_denda": 0,
    "total_jumlah": 80000,
    "lat": 0.4548977,
    "lng": 121.9356405,
    "color": "#ffc107"
}, {
    "nosamw": "0406825",
    "nama": "H19 ABDUL R. ISMAIL",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.46415,
    "lng": 121.9439421,
    "color": "#fd7e14"
}, {
    "nosamw": "0406891",
    "nama": "H19 AMIR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 936750,
    "total_denda": 70000,
    "total_jumlah": 1006750,
    "lat": 0.4554068,
    "lng": 121.9360771,
    "color": "#dc3545"
}, {
    "nosamw": "0406938",
    "nama": "H19 ARTEMIS AAMBONG",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 2002000,
    "total_denda": 55000,
    "total_jumlah": 2057000,
    "lat": 0.4561122,
    "lng": 121.9372043,
    "color": "#dc3545"
}, {
    "nosamw": "0406869",
    "nama": "H19 ASMIN Y. MAKU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 202500,
    "total_denda": 0,
    "total_jumlah": 202500,
    "lat": 0.463677,
    "lng": 121.9447497,
    "color": "#ffc107"
}, {
    "nosamw": "0406988",
    "nama": "H19 CUN ABAS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 812000,
    "total_denda": 40000,
    "total_jumlah": 852000,
    "lat": 0.454503,
    "lng": 121.9353592,
    "color": "#dc3545"
}, {
    "nosamw": "0406828",
    "nama": "H19 DAHLAN ADJIJI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 298000,
    "total_denda": 15000,
    "total_jumlah": 313000,
    "lat": 0.454946,
    "lng": 121.9357367,
    "color": "#fd7e14"
}, {
    "nosamw": "0406992",
    "nama": "H19 ELA YUSUP",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4611308,
    "lng": 121.9442731,
    "color": "#fd7e14"
}, {
    "nosamw": "0406829",
    "nama": "H19 HAMZAH BAU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.4553576,
    "lng": 121.9356534,
    "color": "#dc3545"
}, {
    "nosamw": "0406833",
    "nama": "H19 HARUN HANAPIA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 226500,
    "total_denda": 15000,
    "total_jumlah": 241500,
    "lat": 0.4553678,
    "lng": 121.9356646,
    "color": "#fd7e14"
}, {
    "nosamw": "0406984",
    "nama": "H19 MARYAM JUFRI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.4555488,
    "lng": 121.9364836,
    "color": "#ffc107"
}, {
    "nosamw": "0406823",
    "nama": "H19 MARYAM PAKAYA \/ KADIR HUNOWU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4469276,
    "lng": 121.9389658,
    "color": "#ffc107"
}, {
    "nosamw": "0406653",
    "nama": "H19 RUKMIN HARUN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4573514,
    "lng": 121.9360624,
    "color": "#ffc107"
}, {
    "nosamw": "0406993",
    "nama": "H19 SELPI LAHAY",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4628123,
    "lng": 121.9439678,
    "color": "#fd7e14"
}, {
    "nosamw": "0406868",
    "nama": "H19 Sesni Kadjalia",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085166260515",
    "total_bulan": 4,
    "total_tagihan": 204800,
    "total_denda": 20000,
    "total_jumlah": 224800,
    "lat": 0.4609455,
    "lng": 121.9443157,
    "color": "#fd7e14"
}, {
    "nosamw": "0406826",
    "nama": "H19 SUKARDI PAKAYA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1699000,
    "total_denda": 75000,
    "total_jumlah": 1774000,
    "lat": 0.4527867,
    "lng": 121.9364983,
    "color": "#dc3545"
}, {
    "nosamw": "0406830",
    "nama": "H19 SUPRIANTI MATANTU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4553608,
    "lng": 121.9356534,
    "color": "#28a745"
}, {
    "nosamw": "0406836",
    "nama": "H19 YUSNI HASAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 10000,
    "total_jumlah": 126500,
    "lat": 0.4586377,
    "lng": 121.9450236,
    "color": "#ffc107"
}, {
    "nosamw": "0403523",
    "nama": "Hadija Gani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 421500,
    "total_denda": 15000,
    "total_jumlah": 436500,
    "lat": 0.466984,
    "lng": 121.949544,
    "color": "#fd7e14"
}, {
    "nosamw": "0407484",
    "nama": "HADIJAH IDRUS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081255995989",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4650515,
    "lng": 121.9445865,
    "color": "#ffc107"
}, {
    "nosamw": "0400744",
    "nama": "Hadijah Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463483,
    "lng": 121.935777,
    "color": "#28a745"
}, {
    "nosamw": "0406329",
    "nama": "HAFIS QUR AN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 6004500,
    "total_denda": 80000,
    "total_jumlah": 6084500,
    "lat": 0.461444,
    "lng": 121.9462085,
    "color": "#dc3545"
}, {
    "nosamw": "0402997",
    "nama": "Hairun Suleman Bumulo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 270000,
    "total_denda": 0,
    "total_jumlah": 270000,
    "lat": 0.457015,
    "lng": 121.942337,
    "color": "#ffc107"
}, {
    "nosamw": "0402658",
    "nama": "Hajara Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 27000,
    "total_denda": 5000,
    "total_jumlah": 32000,
    "lat": 0.45928,
    "lng": 121.936906,
    "color": "#ffc107"
}, {
    "nosamw": "0401943",
    "nama": "Halima Umar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463483,
    "lng": 121.935777,
    "color": "#28a745"
}, {
    "nosamw": "0401304",
    "nama": "Halym Laparaga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082259031206",
    "total_bulan": 1,
    "total_tagihan": 222500,
    "total_denda": 5000,
    "total_jumlah": 227500,
    "lat": 0.460616,
    "lng": 121.9368227,
    "color": "#ffc107"
}, {
    "nosamw": "0400490",
    "nama": "Haman Kunding",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 197500,
    "total_denda": 15000,
    "total_jumlah": 212500,
    "lat": 0.461884,
    "lng": 121.937897,
    "color": "#fd7e14"
}, {
    "nosamw": "0403917",
    "nama": "Hamid Malik",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.454893,
    "lng": 121.937833,
    "color": "#ffc107"
}, {
    "nosamw": "0400535",
    "nama": "Hamira Harun",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4644791,
    "lng": 121.9367954,
    "color": "#28a745"
}, {
    "nosamw": "0403592",
    "nama": "Hamka Inombi  II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460785,
    "lng": 121.936831,
    "color": "#28a745"
}, {
    "nosamw": "0400445",
    "nama": "Hamka Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46551,
    "lng": 121.937719,
    "color": "#28a745"
}, {
    "nosamw": "0401052",
    "nama": "Hamran Danial",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 181500,
    "total_denda": 10000,
    "total_jumlah": 191500,
    "lat": 0.459631,
    "lng": 121.936346,
    "color": "#ffc107"
}, {
    "nosamw": "0401583",
    "nama": "Hamsa Ismail",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 243600,
    "total_denda": 20000,
    "total_jumlah": 263600,
    "lat": 0.459365,
    "lng": 121.936685,
    "color": "#fd7e14"
}, {
    "nosamw": "0400424",
    "nama": "HAMZAH PIPII",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082194357894",
    "total_bulan": 5,
    "total_tagihan": 509000,
    "total_denda": 25000,
    "total_jumlah": 534000,
    "lat": 0.4609067,
    "lng": 121.9430609,
    "color": "#fd7e14"
}, {
    "nosamw": "0402163",
    "nama": "Hanum Habibie",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 343000,
    "total_denda": 25000,
    "total_jumlah": 368000,
    "lat": 0.457316,
    "lng": 121.941628,
    "color": "#fd7e14"
}, {
    "nosamw": "0400308",
    "nama": "Hariji Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.466924,
    "lng": 121.951673,
    "color": "#dc3545"
}, {
    "nosamw": "0401782",
    "nama": "Harton Tamola",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456524,
    "lng": 121.938033,
    "color": "#28a745"
}, {
    "nosamw": "0400468",
    "nama": "Haryanto Malik",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 867000,
    "total_denda": 45000,
    "total_jumlah": 912000,
    "lat": 0.45681,
    "lng": 121.942335,
    "color": "#dc3545"
}, {
    "nosamw": "0401319",
    "nama": "Hasan Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 15000,
    "total_jumlah": 310000,
    "lat": 0.459667,
    "lng": 121.936856,
    "color": "#fd7e14"
}, {
    "nosamw": "0403481",
    "nama": "Hasan Inombi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.459278,
    "lng": 121.936733,
    "color": "#ffc107"
}, {
    "nosamw": "0401227",
    "nama": "Hasan Kadir",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458111,
    "lng": 121.936368,
    "color": "#28a745"
}, {
    "nosamw": "0400188",
    "nama": "Hasan Saleh",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3194250,
    "total_denda": 40000,
    "total_jumlah": 3234250,
    "lat": 0.456868,
    "lng": 121.936777,
    "color": "#dc3545"
}, {
    "nosamw": "0401442",
    "nama": "Hasan Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 2043500,
    "total_denda": 50000,
    "total_jumlah": 2093500,
    "lat": 0.455855,
    "lng": 121.937313,
    "color": "#dc3545"
}, {
    "nosamw": "0405186",
    "nama": "HASANUDIN ABDULLAH \/ KTR KUA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4605908,
    "lng": 121.943421,
    "color": "#28a745"
}, {
    "nosamw": "0401300",
    "nama": "Hasna Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085298970313",
    "total_bulan": 11,
    "total_tagihan": 1088500,
    "total_denda": 55000,
    "total_jumlah": 1143500,
    "lat": 0.4597565,
    "lng": 121.9408675,
    "color": "#dc3545"
}, {
    "nosamw": "0402896",
    "nama": "HASNA ALBAKIR",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082293343482",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4565236,
    "lng": 121.9383384,
    "color": "#ffc107"
}, {
    "nosamw": "0401867",
    "nama": "Hasna Bumulo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1837000,
    "total_denda": 95000,
    "total_jumlah": 1932000,
    "lat": 0.4648917,
    "lng": 121.9453364,
    "color": "#dc3545"
}, {
    "nosamw": "0404504",
    "nama": "Hasna Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 469800,
    "total_denda": 70000,
    "total_jumlah": 539800,
    "lat": 0.459843,
    "lng": 121.935778,
    "color": "#dc3545"
}, {
    "nosamw": "0402280",
    "nama": "Hasni Polamolo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458768,
    "lng": 121.936033,
    "color": "#28a745"
}, {
    "nosamw": "0400809",
    "nama": "Hein Katili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 830000,
    "total_denda": 85000,
    "total_jumlah": 915000,
    "lat": 0.447244,
    "lng": 121.939645,
    "color": "#dc3545"
}, {
    "nosamw": "0400627",
    "nama": "Helen J. Manopo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 783000,
    "total_denda": 35000,
    "total_jumlah": 818000,
    "lat": 0.458629,
    "lng": 121.95177,
    "color": "#dc3545"
}, {
    "nosamw": "0400232",
    "nama": "Hely Katili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.455839,
    "lng": 121.937276,
    "color": "#ffc107"
}, {
    "nosamw": "0400518",
    "nama": "Hendra A. Baderan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.462098,
    "lng": 121.937472,
    "color": "#ffc107"
}, {
    "nosamw": "0405967",
    "nama": "HENDRIK IBRAHIM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 842000,
    "total_denda": 35000,
    "total_jumlah": 877000,
    "lat": 0.4651559,
    "lng": 121.9445124,
    "color": "#dc3545"
}, {
    "nosamw": "0401348",
    "nama": "Heni Panakili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1854500,
    "total_denda": 60000,
    "total_jumlah": 1914500,
    "lat": 0.456944,
    "lng": 121.937527,
    "color": "#dc3545"
}, {
    "nosamw": "0402039",
    "nama": "Herdi Poha SE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1197000,
    "total_denda": 35000,
    "total_jumlah": 1232000,
    "lat": 0.4623907,
    "lng": 121.9376176,
    "color": "#fd7e14"
}, {
    "nosamw": "0401838",
    "nama": "HERLINA MECE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.459718,
    "lng": 121.935969,
    "color": "#ffc107"
}, {
    "nosamw": "0406998",
    "nama": "Herlina Yasin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 657000,
    "total_denda": 55000,
    "total_jumlah": 712000,
    "lat": 0.464396,
    "lng": 121.951784,
    "color": "#dc3545"
}, {
    "nosamw": "0400656",
    "nama": "Herni Yunus",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 453500,
    "total_denda": 30000,
    "total_jumlah": 483500,
    "lat": 0.459557,
    "lng": 121.936915,
    "color": "#fd7e14"
}, {
    "nosamw": "0402257",
    "nama": "Herti Abdul",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 980000,
    "total_denda": 90000,
    "total_jumlah": 1070000,
    "lat": 0.456061,
    "lng": 121.936447,
    "color": "#dc3545"
}, {
    "nosamw": "0401246",
    "nama": "Hi. Andi Tawakkal",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461981,
    "lng": 121.937926,
    "color": "#28a745"
}, {
    "nosamw": "0400442",
    "nama": "Hikman Katohidar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461072,
    "lng": 121.944613,
    "color": "#28a745"
}, {
    "nosamw": "0401520",
    "nama": "Hj Mardiana",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 10000,
    "total_jumlah": 126500,
    "lat": 0.4591236,
    "lng": 121.9571567,
    "color": "#ffc107"
}, {
    "nosamw": "0400389",
    "nama": "Hj. Sri Fatmi Sanoebar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85000,
    "total_denda": 0,
    "total_jumlah": 85000,
    "lat": 0.460554,
    "lng": 121.947772,
    "color": "#ffc107"
}, {
    "nosamw": "0402995",
    "nama": "Hudin Hunowu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.457278,
    "lng": 121.942139,
    "color": "#ffc107"
}, {
    "nosamw": "0407502",
    "nama": "HUSAIN KARIM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085340228463",
    "total_bulan": 2,
    "total_tagihan": 492500,
    "total_denda": 5000,
    "total_jumlah": 497500,
    "lat": 0.4592265,
    "lng": 121.9363075,
    "color": "#ffc107"
}, {
    "nosamw": "0401220",
    "nama": "Husin Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 143500,
    "total_denda": 5000,
    "total_jumlah": 148500,
    "lat": 0.459252,
    "lng": 121.959495,
    "color": "#ffc107"
}, {
    "nosamw": "0402074",
    "nama": "Husni A. Inombi I",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2477000,
    "total_denda": 75000,
    "total_jumlah": 2552000,
    "lat": 0.460442,
    "lng": 121.937003,
    "color": "#dc3545"
}, {
    "nosamw": "0402078",
    "nama": "Husni A. Inombi II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.460355,
    "lng": 121.937026,
    "color": "#fd7e14"
}, {
    "nosamw": "0400581",
    "nama": "I Wayan Redana",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457991,
    "lng": 121.937445,
    "color": "#28a745"
}, {
    "nosamw": "0400303",
    "nama": "Ibrahim Asabi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 295000,
    "total_denda": 35000,
    "total_jumlah": 330000,
    "lat": 0.466554,
    "lng": 121.949149,
    "color": "#dc3545"
}, {
    "nosamw": "0400679",
    "nama": "Ibrahim Bouti",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "081381541636",
    "total_bulan": 3,
    "total_tagihan": 3897500,
    "total_denda": 15000,
    "total_jumlah": 3912500,
    "lat": 0.458153,
    "lng": 121.942074,
    "color": "#fd7e14"
}, {
    "nosamw": "0402515",
    "nama": "Ibrahim Bouty II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456435,
    "lng": 121.937917,
    "color": "#28a745"
}, {
    "nosamw": "0401741",
    "nama": "Ibrahim Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45672,
    "lng": 121.937705,
    "color": "#28a745"
}, {
    "nosamw": "0401498",
    "nama": "Ibrahim Rupu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100200,
    "total_denda": 5000,
    "total_jumlah": 105200,
    "lat": 0.45786,
    "lng": 121.937417,
    "color": "#ffc107"
}, {
    "nosamw": "0400079",
    "nama": "Ico Liputo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 942000,
    "total_denda": 10000,
    "total_jumlah": 952000,
    "lat": 0.458989,
    "lng": 121.935989,
    "color": "#ffc107"
}, {
    "nosamw": "0400209",
    "nama": "Idan Dunggio",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 871500,
    "total_denda": 55000,
    "total_jumlah": 926500,
    "lat": 0.46608,
    "lng": 121.945385,
    "color": "#dc3545"
}, {
    "nosamw": "0401043",
    "nama": "Idham Khalid",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 379500,
    "total_denda": 15000,
    "total_jumlah": 394500,
    "lat": 0.4562,
    "lng": 121.937082,
    "color": "#fd7e14"
}, {
    "nosamw": "0403435",
    "nama": "Idris Ahmad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 825000,
    "total_denda": 69990,
    "total_jumlah": 894990,
    "lat": 0.464082,
    "lng": 121.93665,
    "color": "#dc3545"
}, {
    "nosamw": "0400414",
    "nama": "Idris Haras",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460506,
    "lng": 121.936241,
    "color": "#28a745"
}, {
    "nosamw": "0400071",
    "nama": "Idris Kadji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 5000,
    "total_jumlah": 99000,
    "lat": 0.464428,
    "lng": 121.936887,
    "color": "#ffc107"
}, {
    "nosamw": "0404165",
    "nama": "Idris Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 662000,
    "total_denda": 60000,
    "total_jumlah": 722000,
    "lat": 0.460492,
    "lng": 121.937017,
    "color": "#dc3545"
}, {
    "nosamw": "0400745",
    "nama": "Idris Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356381575",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.465426,
    "lng": 121.937734,
    "color": "#ffc107"
}, {
    "nosamw": "0401074",
    "nama": "Idris Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.456869,
    "lng": 121.936811,
    "color": "#ffc107"
}, {
    "nosamw": "0403665",
    "nama": "Ikram D. Djiu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081241219216",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4608541,
    "lng": 121.9433194,
    "color": "#28a745"
}, {
    "nosamw": "0404225",
    "nama": "IKRAM MUSA",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4628925,
    "lng": 121.9439599,
    "color": "#ffc107"
}, {
    "nosamw": "0401452",
    "nama": "Iku Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 457000,
    "total_denda": 25000,
    "total_jumlah": 482000,
    "lat": 0.456992,
    "lng": 121.937308,
    "color": "#fd7e14"
}, {
    "nosamw": "0401377",
    "nama": "Ilham Alwi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459505,
    "lng": 121.935898,
    "color": "#28a745"
}, {
    "nosamw": "0403651",
    "nama": "Imran Laraga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1308500,
    "total_denda": 60000,
    "total_jumlah": 1368500,
    "lat": 0.4600814,
    "lng": 121.9433813,
    "color": "#dc3545"
}, {
    "nosamw": "0402659",
    "nama": "Indi Nurbani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 405000,
    "total_denda": 45000,
    "total_jumlah": 450000,
    "lat": 0.466106,
    "lng": 121.933896,
    "color": "#dc3545"
}, {
    "nosamw": "0402993",
    "nama": "Indra Harun",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1105000,
    "total_denda": 45000,
    "total_jumlah": 1150000,
    "lat": 0.456853,
    "lng": 121.942443,
    "color": "#dc3545"
}, {
    "nosamw": "0400160",
    "nama": "Indri Pertiwi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 2305500,
    "total_denda": 135000,
    "total_jumlah": 2440500,
    "lat": 0.456867,
    "lng": 121.936961,
    "color": "#dc3545"
}, {
    "nosamw": "0400191",
    "nama": "INDRI STEVANI TOMASONG",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1487500,
    "total_denda": 10000,
    "total_jumlah": 1497500,
    "lat": 0.457943,
    "lng": 121.9366623,
    "color": "#fd7e14"
}, {
    "nosamw": "0400473",
    "nama": "Ir. Hairudin Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4571627,
    "lng": 121.941314,
    "color": "#fd7e14"
}, {
    "nosamw": "0400642",
    "nama": "Ir. Masali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4757852,
    "lng": 121.9320621,
    "color": "#28a745"
}, {
    "nosamw": "0400448",
    "nama": "Ir. Yusuf Giasi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 126500,
    "total_denda": 5000,
    "total_jumlah": 131500,
    "lat": 0.4580789,
    "lng": 121.9369507,
    "color": "#ffc107"
}, {
    "nosamw": "0400970",
    "nama": "Iram Duawulu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466237,
    "lng": 121.945969,
    "color": "#28a745"
}, {
    "nosamw": "0401775",
    "nama": "Irfan Saleh",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456153,
    "lng": 121.93674,
    "color": "#28a745"
}, {
    "nosamw": "0400533",
    "nama": "Irina , Sp",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4561076,
    "lng": 121.9372237,
    "color": "#28a745"
}, {
    "nosamw": "0401027",
    "nama": "Irmawati Tantu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 473500,
    "total_denda": 20000,
    "total_jumlah": 493500,
    "lat": 0.466497,
    "lng": 121.949465,
    "color": "#fd7e14"
}, {
    "nosamw": "0404349",
    "nama": "Ishak Radjak",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 275000,
    "total_denda": 5000,
    "total_jumlah": 280000,
    "lat": 0.456751,
    "lng": 121.936961,
    "color": "#ffc107"
}, {
    "nosamw": "0400869",
    "nama": "Ismail Abdul Rahman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.4631166,
    "lng": 121.9462446,
    "color": "#ffc107"
}, {
    "nosamw": "0403079",
    "nama": "Ismail H. Umar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.462694,
    "lng": 121.944731,
    "color": "#ffc107"
}, {
    "nosamw": "0400483",
    "nama": "Isman Nurdin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 425000,
    "total_denda": 75000,
    "total_jumlah": 500000,
    "lat": 0.458091,
    "lng": 121.942122,
    "color": "#fd7e14"
}, {
    "nosamw": "0400680",
    "nama": "Isna Saripi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.481276,
    "lng": 121.954519,
    "color": "#28a745"
}, {
    "nosamw": "0400920",
    "nama": "Iswan Gau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 240000,
    "total_denda": 0,
    "total_jumlah": 240000,
    "lat": 0.4568074,
    "lng": 121.9475123,
    "color": "#ffc107"
}, {
    "nosamw": "0404301",
    "nama": "Iswan Gau \/ Sanggar Pramu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 6516400,
    "total_denda": 110000,
    "total_jumlah": 6626400,
    "lat": 0.462006,
    "lng": 121.944767,
    "color": "#dc3545"
}, {
    "nosamw": "0406980",
    "nama": "ISWAN GAU 3",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 236500,
    "total_denda": 10000,
    "total_jumlah": 246500,
    "lat": 0.4564609,
    "lng": 121.950361,
    "color": "#fd7e14"
}, {
    "nosamw": "0407531",
    "nama": "ISWAN HUSAIN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "082196769435",
    "total_bulan": 1,
    "total_tagihan": 2361000,
    "total_denda": 0,
    "total_jumlah": 2361000,
    "lat": 0.4635474,
    "lng": 121.9471447,
    "color": "#ffc107"
}, {
    "nosamw": "0402249",
    "nama": "Iswan Ntau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 5000,
    "total_jumlah": 147500,
    "lat": 0.456705,
    "lng": 121.942322,
    "color": "#ffc107"
}, {
    "nosamw": "0400905",
    "nama": "Iwan Adam",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1127500,
    "total_denda": 10000,
    "total_jumlah": 1137500,
    "lat": 0.456284,
    "lng": 121.947069,
    "color": "#fd7e14"
}, {
    "nosamw": "0401353",
    "nama": "Iyam Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 497000,
    "total_denda": 45000,
    "total_jumlah": 542000,
    "lat": 0.460056,
    "lng": 121.94072,
    "color": "#dc3545"
}, {
    "nosamw": "0403064",
    "nama": "Jafar Hanapi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 60000,
    "total_jumlah": 725000,
    "lat": 0.4592547,
    "lng": 121.9387443,
    "color": "#dc3545"
}, {
    "nosamw": "0405184",
    "nama": "JEAN L. TULANGOW",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 50000,
    "total_jumlah": 605000,
    "lat": 0.4627,
    "lng": 121.9421432,
    "color": "#dc3545"
}, {
    "nosamw": "0404737",
    "nama": "JEANETTE PUSPA KILAPONG 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085314991354",
    "total_bulan": 14,
    "total_tagihan": 6809000,
    "total_denda": 70000,
    "total_jumlah": 6879000,
    "lat": 0.459934,
    "lng": 121.9407111,
    "color": "#dc3545"
}, {
    "nosamw": "0400675",
    "nama": "Jemi Waroka",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.466621,
    "lng": 121.949209,
    "color": "#ffc107"
}, {
    "nosamw": "0407512",
    "nama": "JEMMY A BERAHIM 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "085256843596",
    "total_bulan": 1,
    "total_tagihan": 136000,
    "total_denda": 0,
    "total_jumlah": 136000,
    "lat": 0.4571955,
    "lng": 121.9391519,
    "color": "#ffc107"
}, {
    "nosamw": "0402424",
    "nama": "Jemmy A. Berahim SE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 702500,
    "total_denda": 5000,
    "total_jumlah": 707500,
    "lat": 0.461072,
    "lng": 121.944613,
    "color": "#ffc107"
}, {
    "nosamw": "0400255",
    "nama": "Jhono J. Sau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1045000,
    "total_denda": 95000,
    "total_jumlah": 1140000,
    "lat": 0.464447,
    "lng": 121.937633,
    "color": "#dc3545"
}, {
    "nosamw": "0402197",
    "nama": "John Ibrahim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 148000,
    "total_denda": 10000,
    "total_jumlah": 158000,
    "lat": 0.459949,
    "lng": 121.936205,
    "color": "#ffc107"
}, {
    "nosamw": "0400602",
    "nama": "Joko",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 300000,
    "total_denda": 0,
    "total_jumlah": 300000,
    "lat": 0.458566,
    "lng": 121.951904,
    "color": "#ffc107"
}, {
    "nosamw": "0400529",
    "nama": "Jufri Mokodongan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 702000,
    "total_denda": 45000,
    "total_jumlah": 747000,
    "lat": 0.459417,
    "lng": 121.935967,
    "color": "#dc3545"
}, {
    "nosamw": "0400476",
    "nama": "Juli S. Kai",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.456858,
    "lng": 121.942074,
    "color": "#ffc107"
}, {
    "nosamw": "0400925",
    "nama": "Jumliadi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457347,
    "lng": 121.937296,
    "color": "#28a745"
}, {
    "nosamw": "0401399",
    "nama": "Jurnalis Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 111400,
    "total_denda": 5000,
    "total_jumlah": 116400,
    "lat": 0.457609,
    "lng": 121.937443,
    "color": "#ffc107"
}, {
    "nosamw": "0401331",
    "nama": "Kadri Hulinggi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 5000,
    "total_jumlah": 86000,
    "lat": 0.459303,
    "lng": 121.936869,
    "color": "#ffc107"
}, {
    "nosamw": "0400194",
    "nama": "Kani Bulonggodu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459876,
    "lng": 121.935998,
    "color": "#28a745"
}, {
    "nosamw": "0400503",
    "nama": "Karmila Malik",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082293343482",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4566194,
    "lng": 121.9384036,
    "color": "#ffc107"
}, {
    "nosamw": "0401219",
    "nama": "Kartin Taib",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456801,
    "lng": 121.936882,
    "color": "#28a745"
}, {
    "nosamw": "0407401",
    "nama": "KARTIN WALANDA SALELE, S.Pd.K",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082193540585",
    "total_bulan": 3,
    "total_tagihan": 484500,
    "total_denda": 10000,
    "total_jumlah": 494500,
    "lat": 0.4568215,
    "lng": 121.939002,
    "color": "#fd7e14"
}, {
    "nosamw": "0401272",
    "nama": "Kasim Silone",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.458528,
    "lng": 121.943079,
    "color": "#ffc107"
}, {
    "nosamw": "0401282",
    "nama": "Kisman Lasantu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2989500,
    "total_denda": 110000,
    "total_jumlah": 3099500,
    "lat": 0.46558,
    "lng": 121.934524,
    "color": "#dc3545"
}, {
    "nosamw": "0400153",
    "nama": "Koramil Marisa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 205000,
    "total_denda": 0,
    "total_jumlah": 205000,
    "lat": 0.46399,
    "lng": 121.935338,
    "color": "#ffc107"
}, {
    "nosamw": "0404371",
    "nama": "KOS J&J",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085314991354",
    "total_bulan": 11,
    "total_tagihan": 27682500,
    "total_denda": 55000,
    "total_jumlah": 27737500,
    "lat": 0.4598192,
    "lng": 121.941053,
    "color": "#dc3545"
}, {
    "nosamw": "0401526",
    "nama": "Koyo Dunggio",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465672,
    "lng": 121.934818,
    "color": "#28a745"
}, {
    "nosamw": "0403023",
    "nama": "Ktr BNK Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1262500,
    "total_denda": 0,
    "total_jumlah": 1262500,
    "lat": 0.458464,
    "lng": 121.935908,
    "color": "#ffc107"
}, {
    "nosamw": "0401419",
    "nama": "Ktr Departement Sosial 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.457151,
    "lng": 121.945103,
    "color": "#ffc107"
}, {
    "nosamw": "0403038",
    "nama": "Ktr Dinas Pendidikan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 962500,
    "total_denda": 0,
    "total_jumlah": 962500,
    "lat": 0.456972,
    "lng": 121.948172,
    "color": "#ffc107"
}, {
    "nosamw": "0406029",
    "nama": "KTR IMIGRASI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 612500,
    "total_denda": 50000,
    "total_jumlah": 662500,
    "lat": 0.4581483,
    "lng": 121.9363077,
    "color": "#fd7e14"
}, {
    "nosamw": "0404660",
    "nama": "Ktr Pengadilan Agama Marisa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 2102500,
    "total_denda": 0,
    "total_jumlah": 2102500,
    "lat": 0.458437,
    "lng": 121.944245,
    "color": "#ffc107"
}, {
    "nosamw": "0400010",
    "nama": "KTR. BAZNAS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 5000,
    "total_jumlah": 107500,
    "lat": 0.4615858,
    "lng": 121.9449264,
    "color": "#ffc107"
}, {
    "nosamw": "0400946",
    "nama": "Ktr. BKPPD",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1487500,
    "total_denda": 20000,
    "total_jumlah": 1507500,
    "lat": 0.457869,
    "lng": 121.947585,
    "color": "#fd7e14"
}, {
    "nosamw": "0400196",
    "nama": "Ktr. BPS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458071,
    "lng": 121.943474,
    "color": "#28a745"
}, {
    "nosamw": "0400889",
    "nama": "Ktr. BUMD",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "BN",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 19452000,
    "total_denda": 105000,
    "total_jumlah": 19557000,
    "lat": 0.45611,
    "lng": 121.946896,
    "color": "#dc3545"
}, {
    "nosamw": "0400862",
    "nama": "Ktr. Bupati",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457436,
    "lng": 121.948385,
    "color": "#28a745"
}, {
    "nosamw": "0400600",
    "nama": "Ktr. Depag Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 602500,
    "total_denda": 0,
    "total_jumlah": 602500,
    "lat": 0.461112,
    "lng": 121.947553,
    "color": "#ffc107"
}, {
    "nosamw": "0403115",
    "nama": "Ktr. Dinas Kesehatan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45862,
    "lng": 121.956881,
    "color": "#28a745"
}, {
    "nosamw": "0400980",
    "nama": "Ktr. DISHUB PERBUD",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1525000,
    "total_denda": 5000,
    "total_jumlah": 1530000,
    "lat": 0.4620061,
    "lng": 121.9475424,
    "color": "#ffc107"
}, {
    "nosamw": "0401239",
    "nama": "Ktr. DPR II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 34557500,
    "total_denda": 50000,
    "total_jumlah": 34607500,
    "lat": 0.460583,
    "lng": 121.947826,
    "color": "#fd7e14"
}, {
    "nosamw": "0400454",
    "nama": "Ktr. Gor Pemda",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1377500,
    "total_denda": 105000,
    "total_jumlah": 1482500,
    "lat": 0.462035,
    "lng": 121.937296,
    "color": "#dc3545"
}, {
    "nosamw": "0400976",
    "nama": "Ktr. Inspektorat",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 522500,
    "total_denda": 5000,
    "total_jumlah": 527500,
    "lat": 0.457574,
    "lng": 121.94752,
    "color": "#ffc107"
}, {
    "nosamw": "0400573",
    "nama": "Ktr. Kejaksaan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 782500,
    "total_denda": 0,
    "total_jumlah": 782500,
    "lat": 0.457266,
    "lng": 121.948707,
    "color": "#ffc107"
}, {
    "nosamw": "0400982",
    "nama": "Ktr. Kelautan &amp;Perikanan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1517500,
    "total_denda": 20000,
    "total_jumlah": 1537500,
    "lat": 0.4610143,
    "lng": 121.9477697,
    "color": "#fd7e14"
}, {
    "nosamw": "0401106",
    "nama": "Ktr. KesbangPol",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1265000,
    "total_denda": 20000,
    "total_jumlah": 1285000,
    "lat": 0.4618231,
    "lng": 121.9492798,
    "color": "#fd7e14"
}, {
    "nosamw": "0400981",
    "nama": "Ktr. Kimpraswil \/ PU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 3167500,
    "total_denda": 0,
    "total_jumlah": 3167500,
    "lat": 0.456169,
    "lng": 121.948866,
    "color": "#ffc107"
}, {
    "nosamw": "0401009",
    "nama": "Ktr. KopPerindag &amp;Invest",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 782500,
    "total_denda": 0,
    "total_jumlah": 782500,
    "lat": 0.4599897,
    "lng": 121.9493129,
    "color": "#ffc107"
}, {
    "nosamw": "0401232",
    "nama": "Ktr. KPPN 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460369,
    "lng": 121.93579,
    "color": "#28a745"
}, {
    "nosamw": "0400239",
    "nama": "Ktr. KPU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1412500,
    "total_denda": 0,
    "total_jumlah": 1412500,
    "lat": 0.4589759,
    "lng": 121.9547545,
    "color": "#ffc107"
}, {
    "nosamw": "0400954",
    "nama": "Ktr. Pertanian",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460479,
    "lng": 121.945321,
    "color": "#28a745"
}, {
    "nosamw": "0401006",
    "nama": "Ktr. Peternakan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 287500,
    "total_denda": 0,
    "total_jumlah": 287500,
    "lat": 0.4606458,
    "lng": 121.9492827,
    "color": "#ffc107"
}, {
    "nosamw": "0401008",
    "nama": "Ktr. SKCPM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "082349689990",
    "total_bulan": 1,
    "total_tagihan": 1382500,
    "total_denda": 0,
    "total_jumlah": 1382500,
    "lat": 0.4613209,
    "lng": 121.9493187,
    "color": "#ffc107"
}, {
    "nosamw": "0400234",
    "nama": "Kurucop Tomasong",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457458,
    "lng": 121.9366,
    "color": "#28a745"
}, {
    "nosamw": "0401418",
    "nama": "Kuswaji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1054500,
    "total_denda": 70000,
    "total_jumlah": 1124500,
    "lat": 0.465733,
    "lng": 121.935055,
    "color": "#dc3545"
}, {
    "nosamw": "0402992",
    "nama": "Lapangan Tenis Pemda",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 752500,
    "total_denda": 0,
    "total_jumlah": 752500,
    "lat": 0.457613,
    "lng": 121.949205,
    "color": "#ffc107"
}, {
    "nosamw": "0404314",
    "nama": "Leni Katili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461498,
    "lng": 121.938477,
    "color": "#28a745"
}, {
    "nosamw": "0400306",
    "nama": "Lensi Doda",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466554,
    "lng": 121.949149,
    "color": "#28a745"
}, {
    "nosamw": "0400458",
    "nama": "Leny Sunardi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1444500,
    "total_denda": 70000,
    "total_jumlah": 1514500,
    "lat": 0.466665,
    "lng": 121.936978,
    "color": "#dc3545"
}, {
    "nosamw": "0400768",
    "nama": "Lian Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1045250,
    "total_denda": 60000,
    "total_jumlah": 1105250,
    "lat": 0.463395,
    "lng": 121.935762,
    "color": "#dc3545"
}, {
    "nosamw": "0403046",
    "nama": "Lian Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 4417250,
    "total_denda": 120000,
    "total_jumlah": 4537250,
    "lat": 0.463395,
    "lng": 121.935762,
    "color": "#dc3545"
}, {
    "nosamw": "0402804",
    "nama": "Lian Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 96000,
    "total_denda": 10000,
    "total_jumlah": 106000,
    "lat": 0.465933,
    "lng": 121.934899,
    "color": "#ffc107"
}, {
    "nosamw": "0403609",
    "nama": "Lian Rupu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.466031,
    "lng": 121.935032,
    "color": "#dc3545"
}, {
    "nosamw": "0400947",
    "nama": "Lili Kadji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464931,
    "lng": 121.93757,
    "color": "#28a745"
}, {
    "nosamw": "0402638",
    "nama": "Lili Yahya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1082000,
    "total_denda": 85000,
    "total_jumlah": 1167000,
    "lat": 0.466224,
    "lng": 121.935206,
    "color": "#dc3545"
}, {
    "nosamw": "0400948",
    "nama": "Lilis Due",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.465232,
    "lng": 121.945833,
    "color": "#ffc107"
}, {
    "nosamw": "0400298",
    "nama": "Lily Gani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 217500,
    "total_denda": 0,
    "total_jumlah": 217500,
    "lat": 0.466949,
    "lng": 121.949639,
    "color": "#ffc107"
}, {
    "nosamw": "0403372",
    "nama": "Lini Lasampe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1852500,
    "total_denda": 135000,
    "total_jumlah": 1987500,
    "lat": 0.46614,
    "lng": 121.937532,
    "color": "#dc3545"
}, {
    "nosamw": "0402732",
    "nama": "Lisanti Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.458467,
    "lng": 121.94378,
    "color": "#ffc107"
}, {
    "nosamw": "0400617",
    "nama": "Lisda Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 767000,
    "total_denda": 70000,
    "total_jumlah": 837000,
    "lat": 0.466035,
    "lng": 121.935253,
    "color": "#dc3545"
}, {
    "nosamw": "0403466",
    "nama": "Lisna Adjidji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 308000,
    "total_denda": 15000,
    "total_jumlah": 323000,
    "lat": 0.458024,
    "lng": 121.93736,
    "color": "#fd7e14"
}, {
    "nosamw": "0403192",
    "nama": "Lukman Lasake",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 245000,
    "total_denda": 5000,
    "total_jumlah": 250000,
    "lat": 0.46057,
    "lng": 121.943037,
    "color": "#ffc107"
}, {
    "nosamw": "0400480",
    "nama": "M. Damis",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1333500,
    "total_denda": 50000,
    "total_jumlah": 1383500,
    "lat": 0.457314,
    "lng": 121.942414,
    "color": "#dc3545"
}, {
    "nosamw": "0400801",
    "nama": "Madrasah Al-Mubaraq",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462006,
    "lng": 121.945721,
    "color": "#28a745"
}, {
    "nosamw": "0401025",
    "nama": "Man Abdul",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1025000,
    "total_denda": 55000,
    "total_jumlah": 1080000,
    "lat": 0.46627,
    "lng": 121.96267,
    "color": "#dc3545"
}, {
    "nosamw": "0402049",
    "nama": "Mandra Rabiasa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 560200,
    "total_denda": 40000,
    "total_jumlah": 600200,
    "lat": 0.457335,
    "lng": 121.93747,
    "color": "#dc3545"
}, {
    "nosamw": "0400307",
    "nama": "Mansur Tanani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 597500,
    "total_denda": 10000,
    "total_jumlah": 607500,
    "lat": 0.466479,
    "lng": 121.946772,
    "color": "#fd7e14"
}, {
    "nosamw": "0403766",
    "nama": "Marini U. Malik 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "08114390750",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4566261,
    "lng": 121.93818,
    "color": "#28a745"
}, {
    "nosamw": "0400619",
    "nama": "Marjuda Ismail",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458658,
    "lng": 121.951443,
    "color": "#28a745"
}, {
    "nosamw": "0401223",
    "nama": "Markas Satpol",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 5170000,
    "total_denda": 5000,
    "total_jumlah": 5175000,
    "lat": 0.460913,
    "lng": 121.947708,
    "color": "#ffc107"
}, {
    "nosamw": "0400579",
    "nama": "Maryam Ahmad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 521000,
    "total_denda": 45000,
    "total_jumlah": 566000,
    "lat": 0.465122,
    "lng": 121.937488,
    "color": "#dc3545"
}, {
    "nosamw": "0407485",
    "nama": "MARYAM GANI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082293929848",
    "total_bulan": 1,
    "total_tagihan": 255000,
    "total_denda": 0,
    "total_jumlah": 255000,
    "lat": 0.4637995,
    "lng": 121.9471192,
    "color": "#ffc107"
}, {
    "nosamw": "0403724",
    "nama": "Maryam Tanaiyo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462819,
    "lng": 121.944424,
    "color": "#28a745"
}, {
    "nosamw": "0401400",
    "nama": "Marzuki Hionu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464003,
    "lng": 121.935655,
    "color": "#28a745"
}, {
    "nosamw": "0400784",
    "nama": "Mega Tadang",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460442,
    "lng": 121.937003,
    "color": "#28a745"
}, {
    "nosamw": "0404496",
    "nama": "Meiske Amirullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458471,
    "lng": 121.944156,
    "color": "#28a745"
}, {
    "nosamw": "0403028",
    "nama": "Melinda Bouty",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4676,
    "lng": 121.934874,
    "color": "#28a745"
}, {
    "nosamw": "0400049",
    "nama": "Melly Metti II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467115,
    "lng": 121.935231,
    "color": "#28a745"
}, {
    "nosamw": "0403751",
    "nama": "Meriwaty Maku",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 3338250,
    "total_denda": 110000,
    "total_jumlah": 3448250,
    "lat": 0.459193,
    "lng": 121.936967,
    "color": "#dc3545"
}, {
    "nosamw": "0401302",
    "nama": "Merywati Maku",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 7554000,
    "total_denda": 75000,
    "total_jumlah": 7629000,
    "lat": 0.459233,
    "lng": 121.936902,
    "color": "#dc3545"
}, {
    "nosamw": "0401324",
    "nama": "MES KAWASAKI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 995000,
    "total_denda": 100000,
    "total_jumlah": 1095000,
    "lat": 0.459638,
    "lng": 121.93917,
    "color": "#dc3545"
}, {
    "nosamw": "0401269",
    "nama": "Mesjid Agung Baitulrahim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4618378,
    "lng": 121.9460691,
    "color": "#28a745"
}, {
    "nosamw": "0400310",
    "nama": "Mesjid Al-Ikhlas",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 287900,
    "total_denda": 35000,
    "total_jumlah": 322900,
    "lat": 0.458828,
    "lng": 121.936022,
    "color": "#dc3545"
}, {
    "nosamw": "0405181",
    "nama": "Mesjid Al-Ikhlas 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 2563500,
    "total_denda": 35000,
    "total_jumlah": 2598500,
    "lat": 0.4575764,
    "lng": 121.9374324,
    "color": "#dc3545"
}, {
    "nosamw": "0403093",
    "nama": "Mesjid An-Nur",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466997,
    "lng": 121.937337,
    "color": "#28a745"
}, {
    "nosamw": "0402800",
    "nama": "Mesjid Babulfat\/Rusni Dja",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 223500,
    "total_denda": 60000,
    "total_jumlah": 283500,
    "lat": 0.46602,
    "lng": 121.934539,
    "color": "#dc3545"
}, {
    "nosamw": "0407328",
    "nama": "MESS GSM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "085242424693",
    "total_bulan": 1,
    "total_tagihan": 1448000,
    "total_denda": 0,
    "total_jumlah": 1448000,
    "lat": 0.4570108,
    "lng": 121.9404382,
    "color": "#ffc107"
}, {
    "nosamw": "0400481",
    "nama": "Minarsih \/ KARA USMAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4570241,
    "lng": 121.9367245,
    "color": "#ffc107"
}, {
    "nosamw": "0400736",
    "nama": "Minarsih 1",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4576128,
    "lng": 121.9365999,
    "color": "#28a745"
}, {
    "nosamw": "0401627",
    "nama": "Minarsih 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4670322,
    "lng": 121.951062,
    "color": "#28a745"
}, {
    "nosamw": "0401170",
    "nama": "Minggus. A. Ma, SH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 50000,
    "total_jumlah": 605000,
    "lat": 0.4563566,
    "lng": 121.9371596,
    "color": "#dc3545"
}, {
    "nosamw": "0401081",
    "nama": "Mini Bawu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 238000,
    "total_denda": 15000,
    "total_jumlah": 253000,
    "lat": 0.457307,
    "lng": 121.937042,
    "color": "#fd7e14"
}, {
    "nosamw": "0401558",
    "nama": "Mirwansyah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 172000,
    "total_denda": 10000,
    "total_jumlah": 182000,
    "lat": 0.462359,
    "lng": 121.945757,
    "color": "#ffc107"
}, {
    "nosamw": "0402678",
    "nama": "Moh. Adjiji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 883500,
    "total_denda": 15000,
    "total_jumlah": 898500,
    "lat": 0.456579,
    "lng": 121.936827,
    "color": "#fd7e14"
}, {
    "nosamw": "0402022",
    "nama": "Moh. Igrisa II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 200000,
    "total_denda": 25000,
    "total_jumlah": 225000,
    "lat": 0.465855,
    "lng": 121.944756,
    "color": "#fd7e14"
}, {
    "nosamw": "0400537",
    "nama": "Moh. Inaku Moputi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465248,
    "lng": 121.945979,
    "color": "#28a745"
}, {
    "nosamw": "0401014",
    "nama": "Moh. Jakpar Harahap",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 305000,
    "total_denda": 10000,
    "total_jumlah": 315000,
    "lat": 0.4569777,
    "lng": 121.9376821,
    "color": "#ffc107"
}, {
    "nosamw": "0400054",
    "nama": "Moh. Noldi Datau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461488,
    "lng": 121.938529,
    "color": "#28a745"
}, {
    "nosamw": "0400583",
    "nama": "Moh. Resa Valefi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 345500,
    "total_denda": 5000,
    "total_jumlah": 350500,
    "lat": 0.457726,
    "lng": 121.941313,
    "color": "#ffc107"
}, {
    "nosamw": "0401190",
    "nama": "MRKS. PMI Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.46194,
    "lng": 121.944851,
    "color": "#ffc107"
}, {
    "nosamw": "0401570",
    "nama": "Muchsin H. L. Pasi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.458522,
    "lng": 121.951681,
    "color": "#fd7e14"
}, {
    "nosamw": "0406323",
    "nama": "MUHAMAD S. HALID",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4646062,
    "lng": 121.9446868,
    "color": "#ffc107"
}, {
    "nosamw": "0402657",
    "nama": "Mun Lasese",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.460731,
    "lng": 121.936923,
    "color": "#ffc107"
}, {
    "nosamw": "0401355",
    "nama": "Munzia N. Djula",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4653066,
    "lng": 121.9461464,
    "color": "#28a745"
}, {
    "nosamw": "0400370",
    "nama": "Munzia Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1320000,
    "total_denda": 50000,
    "total_jumlah": 1370000,
    "lat": 0.466189,
    "lng": 121.943482,
    "color": "#dc3545"
}, {
    "nosamw": "0402322",
    "nama": "Murniati Giasi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 266000,
    "total_denda": 10000,
    "total_jumlah": 276000,
    "lat": 0.45831,
    "lng": 121.942891,
    "color": "#ffc107"
}, {
    "nosamw": "0404764",
    "nama": "MUSKINA ABDULLAH 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 787500,
    "total_denda": 0,
    "total_jumlah": 787500,
    "lat": 0.4525324,
    "lng": 121.9489108,
    "color": "#ffc107"
}, {
    "nosamw": "0401093",
    "nama": "Muslim Haras",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 692150,
    "total_denda": 40000,
    "total_jumlah": 732150,
    "lat": 0.461122,
    "lng": 121.935686,
    "color": "#dc3545"
}, {
    "nosamw": "0400616",
    "nama": "Muslimin Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459889,
    "lng": 121.937041,
    "color": "#28a745"
}, {
    "nosamw": "0401199",
    "nama": "Nadjabudin M.M.T",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "085147244477",
    "total_bulan": 1,
    "total_tagihan": 368000,
    "total_denda": 0,
    "total_jumlah": 368000,
    "lat": 0.460426,
    "lng": 121.960755,
    "color": "#ffc107"
}, {
    "nosamw": "0401855",
    "nama": "Nadjabudin MM. Thaib",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 3403000,
    "total_denda": 15000,
    "total_jumlah": 3418000,
    "lat": 0.460199,
    "lng": 121.960659,
    "color": "#fd7e14"
}, {
    "nosamw": "0403527",
    "nama": "Nain Hunowu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.454885,
    "lng": 121.937826,
    "color": "#28a745"
}, {
    "nosamw": "0400942",
    "nama": "Nani Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1030000,
    "total_denda": 95000,
    "total_jumlah": 1125000,
    "lat": 0.466932,
    "lng": 121.934608,
    "color": "#dc3545"
}, {
    "nosamw": "0402108",
    "nama": "Napra Mahmud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465744,
    "lng": 121.937638,
    "color": "#28a745"
}, {
    "nosamw": "0400004",
    "nama": "Nasar A",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461104,
    "lng": 121.935575,
    "color": "#28a745"
}, {
    "nosamw": "0400738",
    "nama": "Nasir Punuh",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464514,
    "lng": 121.934627,
    "color": "#28a745"
}, {
    "nosamw": "0403480",
    "nama": "Nasra Husain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460355,
    "lng": 121.937026,
    "color": "#28a745"
}, {
    "nosamw": "0400466",
    "nama": "Nasrun Husain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466199,
    "lng": 121.937561,
    "color": "#28a745"
}, {
    "nosamw": "0400316",
    "nama": "Nero Duawulu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082291188155",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466759,
    "lng": 121.949556,
    "color": "#28a745"
}, {
    "nosamw": "0400419",
    "nama": "Nesrawaty Abdjul",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4564686,
    "lng": 121.9369208,
    "color": "#28a745"
}, {
    "nosamw": "0404182",
    "nama": "Nijam Nei",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4609845,
    "lng": 121.9613194,
    "color": "#fd7e14"
}, {
    "nosamw": "0404792",
    "nama": "NILAWATI SALEH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 5000,
    "total_jumlah": 118500,
    "lat": 0.4578623,
    "lng": 121.9372498,
    "color": "#ffc107"
}, {
    "nosamw": "0402647",
    "nama": "Nini Harun",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 134800,
    "total_denda": 20000,
    "total_jumlah": 154800,
    "lat": 0.459756,
    "lng": 121.935976,
    "color": "#fd7e14"
}, {
    "nosamw": "0403450",
    "nama": "Nini Karim 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 5000,
    "total_jumlah": 66500,
    "lat": 0.456837,
    "lng": 121.937524,
    "color": "#ffc107"
}, {
    "nosamw": "0401306",
    "nama": "Nini Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081241311993",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457985,
    "lng": 121.9436116,
    "color": "#28a745"
}, {
    "nosamw": "0400805",
    "nama": "Nining Haluta",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.467014,
    "lng": 121.951486,
    "color": "#fd7e14"
}, {
    "nosamw": "0401391",
    "nama": "Nining Rabiasa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1334200,
    "total_denda": 100000,
    "total_jumlah": 1434200,
    "lat": 0.457447,
    "lng": 121.937439,
    "color": "#dc3545"
}, {
    "nosamw": "0404548",
    "nama": "Nirmala Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460698,
    "lng": 121.943178,
    "color": "#28a745"
}, {
    "nosamw": "0400227",
    "nama": "Niu Rahim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 233000,
    "total_denda": 20000,
    "total_jumlah": 253000,
    "lat": 0.4561045,
    "lng": 121.9371738,
    "color": "#fd7e14"
}, {
    "nosamw": "0402631",
    "nama": "Nohran Gani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457106,
    "lng": 121.936962,
    "color": "#28a745"
}, {
    "nosamw": "0401069",
    "nama": "Non Daud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466314,
    "lng": 121.946116,
    "color": "#28a745"
}, {
    "nosamw": "0403937",
    "nama": "Non Djafar - Ko Ciong",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4554525,
    "lng": 121.9372253,
    "color": "#28a745"
}, {
    "nosamw": "0403000",
    "nama": "Nova D. Ntuiyo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.457039,
    "lng": 121.942141,
    "color": "#ffc107"
}, {
    "nosamw": "0401255",
    "nama": "Nova Debora Gerungan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462279,
    "lng": 121.937788,
    "color": "#28a745"
}, {
    "nosamw": "0404936",
    "nama": "NUR AIN BOBIHU",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 532000,
    "total_denda": 50000,
    "total_jumlah": 582000,
    "lat": 0.4574572,
    "lng": 121.9372499,
    "color": "#dc3545"
}, {
    "nosamw": "0401940",
    "nama": "Nur Alam",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 5054000,
    "total_denda": 150000,
    "total_jumlah": 5204000,
    "lat": 0.466566,
    "lng": 121.947718,
    "color": "#dc3545"
}, {
    "nosamw": "0404390",
    "nama": "NURAIN MAHMUD",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.4628354,
    "lng": 121.9447923,
    "color": "#ffc107"
}, {
    "nosamw": "0402392",
    "nama": "Nurhayati Khalid, S.Hi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4608062,
    "lng": 121.9436755,
    "color": "#28a745"
}, {
    "nosamw": "0407334",
    "nama": "NURLELA ISMAIL",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081244540961",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462524,
    "lng": 121.9464147,
    "color": "#28a745"
}, {
    "nosamw": "0402834",
    "nama": "Nurmawi Almas",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459936,
    "lng": 121.935705,
    "color": "#28a745"
}, {
    "nosamw": "0402254",
    "nama": "Nursyam Rauf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 440000,
    "total_denda": 40000,
    "total_jumlah": 480000,
    "lat": 0.456556,
    "lng": 121.942372,
    "color": "#dc3545"
}, {
    "nosamw": "0404270",
    "nama": "Nuryadin Dako",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 799000,
    "total_denda": 20000,
    "total_jumlah": 819000,
    "lat": 0.4624969,
    "lng": 121.9447208,
    "color": "#fd7e14"
}, {
    "nosamw": "0400305",
    "nama": "Oktaviana Mahmud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4663617,
    "lng": 121.9437446,
    "color": "#ffc107"
}, {
    "nosamw": "0402251",
    "nama": "Olha Jasin,Amg",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4562343,
    "lng": 121.9413897,
    "color": "#ffc107"
}, {
    "nosamw": "0400410",
    "nama": "Olis Dulman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466368,
    "lng": 121.946421,
    "color": "#28a745"
}, {
    "nosamw": "0401394",
    "nama": "Olis Hanapi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.465286,
    "lng": 121.937584,
    "color": "#fd7e14"
}, {
    "nosamw": "0400767",
    "nama": "Olis Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.466643,
    "lng": 121.936702,
    "color": "#fd7e14"
}, {
    "nosamw": "0400776",
    "nama": "Omba Bau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457066,
    "lng": 121.936789,
    "color": "#28a745"
}, {
    "nosamw": "0400223",
    "nama": "Ontho Akib",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466479,
    "lng": 121.937031,
    "color": "#28a745"
}, {
    "nosamw": "0403641",
    "nama": "Pandi Pinggu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.458455,
    "lng": 121.944028,
    "color": "#ffc107"
}, {
    "nosamw": "0402384",
    "nama": "Parman Kasim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 770000,
    "total_denda": 135000,
    "total_jumlah": 905000,
    "lat": 0.460099,
    "lng": 121.940253,
    "color": "#dc3545"
}, {
    "nosamw": "0404717",
    "nama": "Paud Terpadu Harapan Kita",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 229000,
    "total_denda": 30000,
    "total_jumlah": 259000,
    "lat": 0.460655,
    "lng": 121.945014,
    "color": "#fd7e14"
}, {
    "nosamw": "0401551",
    "nama": "Pengadilan Neg. Marisa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1202500,
    "total_denda": 0,
    "total_jumlah": 1202500,
    "lat": 0.460239,
    "lng": 121.945314,
    "color": "#ffc107"
}, {
    "nosamw": "0407331",
    "nama": "Perum Galaxy \/ Blok F17",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.4590091,
    "lng": 121.9444046,
    "color": "#ffc107"
}, {
    "nosamw": "0407332",
    "nama": "Perum Galaxy \/ Blok F18",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 3,
    "total_tagihan": 405500,
    "total_denda": 15000,
    "total_jumlah": 420500,
    "lat": 0.4590398,
    "lng": 121.9443843,
    "color": "#fd7e14"
}, {
    "nosamw": "0407397",
    "nama": "PERUM GALAXY \/ BLOK F23",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 716500,
    "total_denda": 30000,
    "total_jumlah": 746500,
    "lat": 0.4588782,
    "lng": 121.9440241,
    "color": "#dc3545"
}, {
    "nosamw": "0407330",
    "nama": "Perum Galaxy \/ Blok G1",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 7,
    "total_tagihan": 500500,
    "total_denda": 35000,
    "total_jumlah": 535500,
    "lat": 0.4590512,
    "lng": 121.9444576,
    "color": "#dc3545"
}, {
    "nosamw": "0407333",
    "nama": "PERUM GALAXY BLOK F19 \/ MONALISA HINTALO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.458989,
    "lng": 121.9441427,
    "color": "#ffc107"
}, {
    "nosamw": "0407431",
    "nama": "Perum Galaxy Blok G.12",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4588528,
    "lng": 121.9439396,
    "color": "#ffc107"
}, {
    "nosamw": "0407432",
    "nama": "Perum Galaxy Blok G.13",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 4,
    "total_tagihan": 427500,
    "total_denda": 15000,
    "total_jumlah": 442500,
    "lat": 0.4588867,
    "lng": 121.9439239,
    "color": "#fd7e14"
}, {
    "nosamw": "0407433",
    "nama": "Perum Galaxy Blok G.14",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 5,
    "total_tagihan": 340000,
    "total_denda": 20000,
    "total_jumlah": 360000,
    "lat": 0.4588951,
    "lng": 121.9439646,
    "color": "#fd7e14"
}, {
    "nosamw": "0407368",
    "nama": "PERUM GALAXY BLOK G.9",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4589449,
    "lng": 121.9441246,
    "color": "#ffc107"
}, {
    "nosamw": "0407396",
    "nama": "PERUM GALAXY BLOK G10",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 253000,
    "total_denda": 10000,
    "total_jumlah": 263000,
    "lat": 0.4588964,
    "lng": 121.9439835,
    "color": "#ffc107"
}, {
    "nosamw": "0407366",
    "nama": "PERUM GALAXY BLOK G2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4590459,
    "lng": 121.9444397,
    "color": "#fd7e14"
}, {
    "nosamw": "0403733",
    "nama": "Pitro Lamatowa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 442750,
    "total_denda": 30000,
    "total_jumlah": 472750,
    "lat": 0.4579816,
    "lng": 121.9371877,
    "color": "#fd7e14"
}, {
    "nosamw": "0402206",
    "nama": "Polsek Marisa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4670743,
    "lng": 121.93703247,
    "color": "#28a745"
}, {
    "nosamw": "0400329",
    "nama": "Ponpes Hidayatullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.455984,
    "lng": 121.938182,
    "color": "#28a745"
}, {
    "nosamw": "0400674",
    "nama": "Poppy Podiyongo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465866,
    "lng": 121.935023,
    "color": "#28a745"
}, {
    "nosamw": "0400314",
    "nama": "PT. Hasjrat Abadi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4663709,
    "lng": 121.9448587,
    "color": "#28a745"
}, {
    "nosamw": "0400186",
    "nama": "Puang Tomelo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.467189,
    "lng": 121.954496,
    "color": "#ffc107"
}, {
    "nosamw": "0402788",
    "nama": "RACHMAWATI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4552758,
    "lng": 121.9380481,
    "color": "#28a745"
}, {
    "nosamw": "0400317",
    "nama": "Raden Anwar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46717,
    "lng": 121.951257,
    "color": "#28a745"
}, {
    "nosamw": "0407385",
    "nama": "RAFLI SANGADI \/ PERUM GALAXY BLOK G.8",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4589632,
    "lng": 121.9441416,
    "color": "#28a745"
}, {
    "nosamw": "0400689",
    "nama": "Rahim Rajak",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 622500,
    "total_denda": 15000,
    "total_jumlah": 637500,
    "lat": 0.457028,
    "lng": 121.937432,
    "color": "#fd7e14"
}, {
    "nosamw": "0401241",
    "nama": "Rahima Abubakar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1249000,
    "total_denda": 45000,
    "total_jumlah": 1294000,
    "lat": 0.462154,
    "lng": 121.945908,
    "color": "#fd7e14"
}, {
    "nosamw": "0401496",
    "nama": "Rahmat H.K. Ismail",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 227000,
    "total_denda": 5000,
    "total_jumlah": 232000,
    "lat": 0.466529,
    "lng": 121.949198,
    "color": "#ffc107"
}, {
    "nosamw": "0403790",
    "nama": "Rahmat Utina",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460303,
    "lng": 121.937228,
    "color": "#28a745"
}, {
    "nosamw": "0401505",
    "nama": "Rahmawati Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464634,
    "lng": 121.94715,
    "color": "#28a745"
}, {
    "nosamw": "0401251",
    "nama": "RAHMAWATI PULUKADANG",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.4583531,
    "lng": 121.9524021,
    "color": "#ffc107"
}, {
    "nosamw": "0401102",
    "nama": "Rahmawaty Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1969000,
    "total_denda": 70000,
    "total_jumlah": 2039000,
    "lat": 0.462483,
    "lng": 121.944361,
    "color": "#dc3545"
}, {
    "nosamw": "0401398",
    "nama": "Raina Sune",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1284000,
    "total_denda": 25000,
    "total_jumlah": 1309000,
    "lat": 0.460239,
    "lng": 121.936952,
    "color": "#fd7e14"
}, {
    "nosamw": "0401296",
    "nama": "Ram Ahmad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 935000,
    "total_denda": 85000,
    "total_jumlah": 1020000,
    "lat": 0.461092,
    "lng": 121.937537,
    "color": "#dc3545"
}, {
    "nosamw": "0400730",
    "nama": "Raman Podungge",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1542500,
    "total_denda": 60000,
    "total_jumlah": 1602500,
    "lat": 0.456358,
    "lng": 121.949649,
    "color": "#dc3545"
}, {
    "nosamw": "0400335",
    "nama": "Ramey M. Rarung",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 2642500,
    "total_denda": 45000,
    "total_jumlah": 2687500,
    "lat": 0.457931,
    "lng": 121.936324,
    "color": "#dc3545"
}, {
    "nosamw": "0400965",
    "nama": "Ramin Daud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.45865,
    "lng": 121.9525523,
    "color": "#ffc107"
}, {
    "nosamw": "0403002",
    "nama": "Ramlin Amrain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 311000,
    "total_denda": 15000,
    "total_jumlah": 326000,
    "lat": 0.456917,
    "lng": 121.942326,
    "color": "#fd7e14"
}, {
    "nosamw": "0400352",
    "nama": "Ramon Poha",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1321000,
    "total_denda": 105000,
    "total_jumlah": 1426000,
    "lat": 0.459192,
    "lng": 121.935919,
    "color": "#dc3545"
}, {
    "nosamw": "0402686",
    "nama": "Rapin N. Upu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 27000,
    "total_denda": 5000,
    "total_jumlah": 32000,
    "lat": 0.46582,
    "lng": 121.937643,
    "color": "#ffc107"
}, {
    "nosamw": "0401773",
    "nama": "RD 02 Ketua Pengadilan Ne",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467179,
    "lng": 121.937186,
    "color": "#28a745"
}, {
    "nosamw": "0404492",
    "nama": "RD Wakil Ketua Pengadilan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466941,
    "lng": 121.938804,
    "color": "#28a745"
}, {
    "nosamw": "0401252",
    "nama": "RD. BPS",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458242,
    "lng": 121.9436,
    "color": "#28a745"
}, {
    "nosamw": "0400585",
    "nama": "RD. Bupati II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 3707500,
    "total_denda": 0,
    "total_jumlah": 3707500,
    "lat": 0.458533,
    "lng": 121.950107,
    "color": "#ffc107"
}, {
    "nosamw": "0401007",
    "nama": "RD. Depag",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.456265,
    "lng": 121.948255,
    "color": "#ffc107"
}, {
    "nosamw": "0401233",
    "nama": "RD. Dokter Puskesmas",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464721,
    "lng": 121.935906,
    "color": "#28a745"
}, {
    "nosamw": "0400661",
    "nama": "RD. KAJARI Tipe C",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 3970000,
    "total_denda": 145000,
    "total_jumlah": 4115000,
    "lat": 0.4571746,
    "lng": 121.9483446,
    "color": "#dc3545"
}, {
    "nosamw": "0401016",
    "nama": "RD. Kejaksaan 1 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2289500,
    "total_denda": 105000,
    "total_jumlah": 2394500,
    "lat": 0.457187,
    "lng": 121.948454,
    "color": "#dc3545"
}, {
    "nosamw": "0401017",
    "nama": "RD. Kejaksaan 2 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 411000,
    "total_denda": 30000,
    "total_jumlah": 441000,
    "lat": 0.457147,
    "lng": 121.948589,
    "color": "#dc3545"
}, {
    "nosamw": "0401018",
    "nama": "RD. Kejaksaan 3 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45719,
    "lng": 121.94878,
    "color": "#28a745"
}, {
    "nosamw": "0401019",
    "nama": "RD. Kejaksaan 4 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1578500,
    "total_denda": 60000,
    "total_jumlah": 1638500,
    "lat": 0.457189,
    "lng": 121.948982,
    "color": "#dc3545"
}, {
    "nosamw": "0401020",
    "nama": "RD. Kejaksaan 5 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1872750,
    "total_denda": 110000,
    "total_jumlah": 1982750,
    "lat": 0.457276,
    "lng": 121.948867,
    "color": "#dc3545"
}, {
    "nosamw": "0401021",
    "nama": "RD. Kejaksaan 6 Tipe D",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1477500,
    "total_denda": 115000,
    "total_jumlah": 1592500,
    "lat": 0.457321,
    "lng": 121.949138,
    "color": "#dc3545"
}, {
    "nosamw": "0400415",
    "nama": "RD. Kejaksaan No.7",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 149000,
    "total_denda": 5000,
    "total_jumlah": 154000,
    "lat": 0.457293,
    "lng": 121.949197,
    "color": "#ffc107"
}, {
    "nosamw": "0400463",
    "nama": "RD. Kejaksaan No.8",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1691500,
    "total_denda": 85000,
    "total_jumlah": 1776500,
    "lat": 0.457251,
    "lng": 121.949075,
    "color": "#dc3545"
}, {
    "nosamw": "0400934",
    "nama": "RD. Ketua Dewan 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 89295000,
    "total_denda": 185000,
    "total_jumlah": 89480000,
    "lat": 0.456271,
    "lng": 121.946782,
    "color": "#dc3545"
}, {
    "nosamw": "0402991",
    "nama": "RD. Ketua PN Marisa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.456809,
    "lng": 121.945649,
    "color": "#ffc107"
}, {
    "nosamw": "0401278",
    "nama": "RD. KPPN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460211,
    "lng": 121.936047,
    "color": "#28a745"
}, {
    "nosamw": "0401666",
    "nama": "RD. KPPN\/ TAJO PRAKOSO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460153,
    "lng": 121.936418,
    "color": "#28a745"
}, {
    "nosamw": "0401669",
    "nama": "RD. KPPN\/Farida Uno",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460134,
    "lng": 121.93624,
    "color": "#28a745"
}, {
    "nosamw": "0401668",
    "nama": "RD. KPPN\/Misra Rauf,SE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4601232,
    "lng": 121.9362527,
    "color": "#28a745"
}, {
    "nosamw": "0401667",
    "nama": "RD. KPPN\/Nurwedi Djahyono",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.460112,
    "lng": 121.936094,
    "color": "#ffc107"
}, {
    "nosamw": "0405922",
    "nama": "RD. POSAL POHUWATO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1816500,
    "total_denda": 75000,
    "total_jumlah": 1891500,
    "lat": 0.4582745,
    "lng": 121.9361855,
    "color": "#dc3545"
}, {
    "nosamw": "0401050",
    "nama": "RD. Sekda",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 662500,
    "total_denda": 0,
    "total_jumlah": 662500,
    "lat": 0.456327,
    "lng": 121.945256,
    "color": "#ffc107"
}, {
    "nosamw": "0400983",
    "nama": "RD. Wakil Bupati",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 4367500,
    "total_denda": 0,
    "total_jumlah": 4367500,
    "lat": 0.458076,
    "lng": 121.945009,
    "color": "#ffc107"
}, {
    "nosamw": "0401169",
    "nama": "Reskiyanty",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 500000,
    "total_denda": 55000,
    "total_jumlah": 555000,
    "lat": 0.461719,
    "lng": 121.938043,
    "color": "#dc3545"
}, {
    "nosamw": "0407524",
    "nama": "RIA DENGO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082296983706",
    "total_bulan": 7,
    "total_tagihan": 619000,
    "total_denda": 30000,
    "total_jumlah": 649000,
    "lat": 0.45858,
    "lng": 121.94528,
    "color": "#dc3545"
}, {
    "nosamw": "0403924",
    "nama": "Rianto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 705000,
    "total_denda": 65000,
    "total_jumlah": 770000,
    "lat": 0.461787,
    "lng": 121.938136,
    "color": "#dc3545"
}, {
    "nosamw": "0400609",
    "nama": "RIDO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466219,
    "lng": 121.945024,
    "color": "#28a745"
}, {
    "nosamw": "0400474",
    "nama": "RIDWAN MADI HURUJI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 157500,
    "total_denda": 0,
    "total_jumlah": 157500,
    "lat": 0.456603,
    "lng": 121.9412103,
    "color": "#ffc107"
}, {
    "nosamw": "0404164",
    "nama": "Ridwan Pulubuhu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46053,
    "lng": 121.93713,
    "color": "#28a745"
}, {
    "nosamw": "0401910",
    "nama": "Ridwan Puyo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460636,
    "lng": 121.942956,
    "color": "#28a745"
}, {
    "nosamw": "0400349",
    "nama": "RIFAT SUWELEH 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4646327,
    "lng": 121.944667,
    "color": "#28a745"
}, {
    "nosamw": "0402035",
    "nama": "Rifka Pua\/Hotel Enjelina",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "082196853131",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4575223,
    "lng": 121.9398381,
    "color": "#28a745"
}, {
    "nosamw": "0401354",
    "nama": "Riko Auko",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467103,
    "lng": 121.955465,
    "color": "#28a745"
}, {
    "nosamw": "0403406",
    "nama": "Rion Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1232000,
    "total_denda": 95000,
    "total_jumlah": 1327000,
    "lat": 0.455925,
    "lng": 121.936649,
    "color": "#dc3545"
}, {
    "nosamw": "0406813",
    "nama": "RISMA RASYID",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45734,
    "lng": 121.958175,
    "color": "#28a745"
}, {
    "nosamw": "0400570",
    "nama": "Risman Priyatma",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 797000,
    "total_denda": 35000,
    "total_jumlah": 832000,
    "lat": 0.465031,
    "lng": 121.934301,
    "color": "#dc3545"
}, {
    "nosamw": "0401383",
    "nama": "Rita Podionggo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457672,
    "lng": 121.937352,
    "color": "#28a745"
}, {
    "nosamw": "0403407",
    "nama": "Rival S. A. Habu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465244,
    "lng": 121.937464,
    "color": "#28a745"
}, {
    "nosamw": "0403771",
    "nama": "Riyanto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 432500,
    "total_denda": 10000,
    "total_jumlah": 442500,
    "lat": 0.466345,
    "lng": 121.948902,
    "color": "#fd7e14"
}, {
    "nosamw": "0400484",
    "nama": "Roi Mopai",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 940000,
    "total_denda": 85000,
    "total_jumlah": 1025000,
    "lat": 0.457881,
    "lng": 121.936527,
    "color": "#dc3545"
}, {
    "nosamw": "0403555",
    "nama": "Roni Lateka",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 191000,
    "total_denda": 10000,
    "total_jumlah": 201000,
    "lat": 0.464888,
    "lng": 121.944815,
    "color": "#fd7e14"
}, {
    "nosamw": "0403310",
    "nama": "Rosnawati B. Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4603239,
    "lng": 121.9496054,
    "color": "#ffc107"
}, {
    "nosamw": "0400751",
    "nama": "Rosnawati Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 662500,
    "total_denda": 25000,
    "total_jumlah": 687500,
    "lat": 0.460698,
    "lng": 121.937071,
    "color": "#fd7e14"
}, {
    "nosamw": "0400618",
    "nama": "Rostin Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 4794500,
    "total_denda": 105000,
    "total_jumlah": 4899500,
    "lat": 0.4586288,
    "lng": 121.952645,
    "color": "#dc3545"
}, {
    "nosamw": "0403710",
    "nama": "Royke Pua",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458397,
    "lng": 121.943873,
    "color": "#28a745"
}, {
    "nosamw": "0401204",
    "nama": "Royke Sindim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4654916,
    "lng": 121.947237,
    "color": "#28a745"
}, {
    "nosamw": "0403486",
    "nama": "Ruko 1 \/ Moh.Noval Asegaf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4655719,
    "lng": 121.9473162,
    "color": "#28a745"
}, {
    "nosamw": "0403487",
    "nama": "RUKO 2\/MOH. NOVAL ASSEGAF",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4655284,
    "lng": 121.9473019,
    "color": "#28a745"
}, {
    "nosamw": "0403488",
    "nama": "Ruko 3 \/ Moh. Noval Asega",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465403,
    "lng": 121.9462,
    "color": "#28a745"
}, {
    "nosamw": "0403711",
    "nama": "Ruko 4 \/ Moh. Noval Asaga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465338,
    "lng": 121.946302,
    "color": "#28a745"
}, {
    "nosamw": "0403712",
    "nama": "Ruko 5 \/ BPJS tenaga kerja",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 921000,
    "total_denda": 5000,
    "total_jumlah": 926000,
    "lat": 0.46541,
    "lng": 121.946441,
    "color": "#ffc107"
}, {
    "nosamw": "0403713",
    "nama": "Ruko 6 \/ Moh. Noval Asaga",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1135500,
    "total_denda": 195000,
    "total_jumlah": 1330500,
    "lat": 0.46541,
    "lng": 121.946441,
    "color": "#dc3545"
}, {
    "nosamw": "0403716",
    "nama": "Ruko 9 \/ BANK BRI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "BN",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 5312500,
    "total_denda": 5000,
    "total_jumlah": 5317500,
    "lat": 0.465347,
    "lng": 121.946392,
    "color": "#ffc107"
}, {
    "nosamw": "0400387",
    "nama": "Rusdin Suleman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 566000,
    "total_denda": 50000,
    "total_jumlah": 616000,
    "lat": 0.460784,
    "lng": 121.937016,
    "color": "#dc3545"
}, {
    "nosamw": "0400615",
    "nama": "Rusman Poha",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 284000,
    "total_denda": 35000,
    "total_jumlah": 319000,
    "lat": 0.465795,
    "lng": 121.934808,
    "color": "#dc3545"
}, {
    "nosamw": "0402509",
    "nama": "Rusmawati Hamid",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.457349,
    "lng": 121.941452,
    "color": "#ffc107"
}, {
    "nosamw": "0402756",
    "nama": "Rusmin Noho",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.449785,
    "lng": 121.938095,
    "color": "#ffc107"
}, {
    "nosamw": "0401364",
    "nama": "Rustam Safari",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 236500,
    "total_denda": 10000,
    "total_jumlah": 246500,
    "lat": 0.466976,
    "lng": 121.955708,
    "color": "#fd7e14"
}, {
    "nosamw": "0400662",
    "nama": "Rusu Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1115500,
    "total_denda": 85000,
    "total_jumlah": 1200500,
    "lat": 0.455904,
    "lng": 121.936854,
    "color": "#dc3545"
}, {
    "nosamw": "0400853",
    "nama": "Sadianawati",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.457263,
    "lng": 121.937528,
    "color": "#fd7e14"
}, {
    "nosamw": "0401362",
    "nama": "Sadik Basrewan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 120000,
    "total_denda": 15000,
    "total_jumlah": 135000,
    "lat": 0.464919,
    "lng": 121.934484,
    "color": "#fd7e14"
}, {
    "nosamw": "0400646",
    "nama": "Safrudin Hanapi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39800,
    "total_denda": 5000,
    "total_jumlah": 44800,
    "lat": 0.460355,
    "lng": 121.937026,
    "color": "#ffc107"
}, {
    "nosamw": "0400467",
    "nama": "Safrudin Katohidar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.456794,
    "lng": 121.942095,
    "color": "#fd7e14"
}, {
    "nosamw": "0400876",
    "nama": "SAHRIA KARIM",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 694000,
    "total_denda": 30000,
    "total_jumlah": 724000,
    "lat": 0.456823,
    "lng": 121.9393573,
    "color": "#fd7e14"
}, {
    "nosamw": "0402014",
    "nama": "Sahrin Lasiama",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461007,
    "lng": 121.935739,
    "color": "#28a745"
}, {
    "nosamw": "0400048",
    "nama": "Saidi Tangahu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459145,
    "lng": 121.936033,
    "color": "#28a745"
}, {
    "nosamw": "0400365",
    "nama": "Saidi Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466941,
    "lng": 121.951415,
    "color": "#28a745"
}, {
    "nosamw": "0400285",
    "nama": "Saiful Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 916000,
    "total_denda": 20000,
    "total_jumlah": 936000,
    "lat": 0.456106,
    "lng": 121.936914,
    "color": "#fd7e14"
}, {
    "nosamw": "0401500",
    "nama": "Saipul Kasim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 664500,
    "total_denda": 30000,
    "total_jumlah": 694500,
    "lat": 0.459337,
    "lng": 121.935809,
    "color": "#fd7e14"
}, {
    "nosamw": "0404321",
    "nama": "Salami J. Rauf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.456092,
    "lng": 121.937027,
    "color": "#ffc107"
}, {
    "nosamw": "0400486",
    "nama": "Salma Husa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.456771,
    "lng": 121.942272,
    "color": "#ffc107"
}, {
    "nosamw": "0401518",
    "nama": "Salma Rahman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.466597,
    "lng": 121.947982,
    "color": "#ffc107"
}, {
    "nosamw": "0402814",
    "nama": "Sam Manopo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 240000,
    "total_denda": 30000,
    "total_jumlah": 270000,
    "lat": 0.466567,
    "lng": 121.951359,
    "color": "#fd7e14"
}, {
    "nosamw": "0400475",
    "nama": "Saman Lasalutu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 175000,
    "total_denda": 5000,
    "total_jumlah": 180000,
    "lat": 0.456902,
    "lng": 121.942439,
    "color": "#ffc107"
}, {
    "nosamw": "0401416",
    "nama": "Samrin Kaune",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461599,
    "lng": 121.938443,
    "color": "#28a745"
}, {
    "nosamw": "0402707",
    "nama": "Samsudin Lawani",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460783,
    "lng": 121.936829,
    "color": "#28a745"
}, {
    "nosamw": "0400648",
    "nama": "Samsudin Mamonto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1573500,
    "total_denda": 100000,
    "total_jumlah": 1673500,
    "lat": 0.458623,
    "lng": 121.951821,
    "color": "#dc3545"
}, {
    "nosamw": "0400653",
    "nama": "Samuel Koraag",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.458363,
    "lng": 121.942986,
    "color": "#ffc107"
}, {
    "nosamw": "0402203",
    "nama": "Samuel Koraag\/Toni",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 8038250,
    "total_denda": 65000,
    "total_jumlah": 8103250,
    "lat": 0.460659,
    "lng": 121.943097,
    "color": "#dc3545"
}, {
    "nosamw": "0403742",
    "nama": "Santi Marhaba",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458948,
    "lng": 121.935969,
    "color": "#28a745"
}, {
    "nosamw": "0400113",
    "nama": "SANTO NAEWO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4670646,
    "lng": 121.9505474,
    "color": "#ffc107"
}, {
    "nosamw": "0402076",
    "nama": "Santri Hidayatullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456297,
    "lng": 121.938571,
    "color": "#28a745"
}, {
    "nosamw": "0402136",
    "nama": "Sarah Yuliana Rotu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.460865,
    "lng": 121.935633,
    "color": "#ffc107"
}, {
    "nosamw": "0403376",
    "nama": "Saripudin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460592,
    "lng": 121.943019,
    "color": "#28a745"
}, {
    "nosamw": "0400489",
    "nama": "Sarman J. Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 360000,
    "total_denda": 15000,
    "total_jumlah": 375000,
    "lat": 0.46209,
    "lng": 121.937798,
    "color": "#fd7e14"
}, {
    "nosamw": "0401401",
    "nama": "Sartin Goi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4610369,
    "lng": 121.9445103,
    "color": "#28a745"
}, {
    "nosamw": "0402797",
    "nama": "Sartin Hamzah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 923750,
    "total_denda": 40000,
    "total_jumlah": 963750,
    "lat": 0.463483,
    "lng": 121.935777,
    "color": "#dc3545"
}, {
    "nosamw": "0403469",
    "nama": "Sartin Husain",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459108,
    "lng": 121.935986,
    "color": "#28a745"
}, {
    "nosamw": "0400624",
    "nama": "Sartin Laju",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467385,
    "lng": 121.954033,
    "color": "#28a745"
}, {
    "nosamw": "0401709",
    "nama": "Satrio Pako",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.456583,
    "lng": 121.937678,
    "color": "#ffc107"
}, {
    "nosamw": "0402795",
    "nama": "Saurin Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 425000,
    "total_denda": 40000,
    "total_jumlah": 465000,
    "lat": 0.463483,
    "lng": 121.935777,
    "color": "#dc3545"
}, {
    "nosamw": "0400939",
    "nama": "Sekretariat PKK",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 395000,
    "total_denda": 20000,
    "total_jumlah": 415000,
    "lat": 0.456507,
    "lng": 121.946557,
    "color": "#fd7e14"
}, {
    "nosamw": "0404290",
    "nama": "Simson Gau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 5265000,
    "total_denda": 25000,
    "total_jumlah": 5290000,
    "lat": 0.45831,
    "lng": 121.942891,
    "color": "#fd7e14"
}, {
    "nosamw": "0401976",
    "nama": "Sin Sauwali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 597500,
    "total_denda": 5000,
    "total_jumlah": 602500,
    "lat": 0.466177,
    "lng": 121.945402,
    "color": "#ffc107"
}, {
    "nosamw": "0400505",
    "nama": "Since Kadji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464679,
    "lng": 121.937684,
    "color": "#28a745"
}, {
    "nosamw": "0401385",
    "nama": "Since Kaune",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460718,
    "lng": 121.937187,
    "color": "#28a745"
}, {
    "nosamw": "0403548",
    "nama": "Since Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.465213,
    "lng": 121.945593,
    "color": "#ffc107"
}, {
    "nosamw": "0403637",
    "nama": "Sindi Rahayu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.465187,
    "lng": 121.937722,
    "color": "#ffc107"
}, {
    "nosamw": "0401381",
    "nama": "Sintia Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1997250,
    "total_denda": 90000,
    "total_jumlah": 2087250,
    "lat": 0.462764,
    "lng": 121.944753,
    "color": "#dc3545"
}, {
    "nosamw": "0400460",
    "nama": "Sinyo Rubemon",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457126,
    "lng": 121.94,
    "color": "#28a745"
}, {
    "nosamw": "0404653",
    "nama": "Sirvon Lakoro",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Cabut Meter",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 27000,
    "total_denda": 5000,
    "total_jumlah": 32000,
    "lat": 0.46522,
    "lng": 121.945998,
    "color": "#ffc107"
}, {
    "nosamw": "0407499",
    "nama": "SITTI MUTIA RADJAK",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082253900348",
    "total_bulan": 2,
    "total_tagihan": 296000,
    "total_denda": 5000,
    "total_jumlah": 301000,
    "lat": 0.4597563,
    "lng": 121.9386474,
    "color": "#ffc107"
}, {
    "nosamw": "0403663",
    "nama": "SMP ISLAM NURUL QUR AN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 809150,
    "total_denda": 30000,
    "total_jumlah": 839150,
    "lat": 0.4593667,
    "lng": 121.9540515,
    "color": "#dc3545"
}, {
    "nosamw": "0401532",
    "nama": "Sofya Pilomonu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4554353,
    "lng": 121.9375587,
    "color": "#ffc107"
}, {
    "nosamw": "0403470",
    "nama": "Sofyan Duano",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 958000,
    "total_denda": 50000,
    "total_jumlah": 1008000,
    "lat": 0.457928,
    "lng": 121.937401,
    "color": "#dc3545"
}, {
    "nosamw": "0402284",
    "nama": "Sopyan Haras",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1713500,
    "total_denda": 80000,
    "total_jumlah": 1793500,
    "lat": 0.459316,
    "lng": 121.935765,
    "color": "#dc3545"
}, {
    "nosamw": "0403765",
    "nama": "Sri Dewi Akili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 789500,
    "total_denda": 70000,
    "total_jumlah": 859500,
    "lat": 0.466778,
    "lng": 121.939071,
    "color": "#dc3545"
}, {
    "nosamw": "0403031",
    "nama": "Sri Endang Asabi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461851,
    "lng": 121.938177,
    "color": "#28a745"
}, {
    "nosamw": "0407400",
    "nama": "SRI FATMI SANOEBAR 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356586461",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4645375,
    "lng": 121.9470786,
    "color": "#ffc107"
}, {
    "nosamw": "0403045",
    "nama": "Sri Meylani Kiayi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461966,
    "lng": 121.938166,
    "color": "#28a745"
}, {
    "nosamw": "0400171",
    "nama": "Sri Nihe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466571,
    "lng": 121.936779,
    "color": "#28a745"
}, {
    "nosamw": "0403385",
    "nama": "Stevanus Thomasong",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.45736,
    "lng": 121.936847,
    "color": "#ffc107"
}, {
    "nosamw": "0401003",
    "nama": "STIE Ichsan Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 679100,
    "total_denda": 30000,
    "total_jumlah": 709100,
    "lat": 0.464152,
    "lng": 121.948745,
    "color": "#fd7e14"
}, {
    "nosamw": "0402994",
    "nama": "Suci Juliandari Akuba",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 247500,
    "total_denda": 5000,
    "total_jumlah": 252500,
    "lat": 0.457146,
    "lng": 121.94224,
    "color": "#ffc107"
}, {
    "nosamw": "0407386",
    "nama": "SUCI NURUL LAXMI, S.KEP \/ PERUM GALAXY BLOK G7",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4590526,
    "lng": 121.9441498,
    "color": "#28a745"
}, {
    "nosamw": "0402490",
    "nama": "Sufran H. Djaini",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 146000,
    "total_denda": 5000,
    "total_jumlah": 151000,
    "lat": 0.462251,
    "lng": 121.945676,
    "color": "#ffc107"
}, {
    "nosamw": "0404738",
    "nama": "SUGIANTORO",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082255609888",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 15000,
    "total_jumlah": 310000,
    "lat": 0.4582871,
    "lng": 121.9437095,
    "color": "#fd7e14"
}, {
    "nosamw": "0400297",
    "nama": "SUGINAH",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4757858,
    "lng": 121.9320603,
    "color": "#28a745"
}, {
    "nosamw": "0401373",
    "nama": "Suharto M. Darise",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467261,
    "lng": 121.954309,
    "color": "#28a745"
}, {
    "nosamw": "0402151",
    "nama": "Suharto Moha",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458712,
    "lng": 121.957176,
    "color": "#28a745"
}, {
    "nosamw": "0401858",
    "nama": "Sulviana Katili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 10000,
    "total_jumlah": 250000,
    "lat": 0.4580072,
    "lng": 121.9373215,
    "color": "#ffc107"
}, {
    "nosamw": "0401116",
    "nama": "Sumiati Adjidji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 220500,
    "total_denda": 10000,
    "total_jumlah": 230500,
    "lat": 0.455922,
    "lng": 121.936687,
    "color": "#ffc107"
}, {
    "nosamw": "0400534",
    "nama": "Sunaryo Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 320000,
    "total_denda": 40000,
    "total_jumlah": 360000,
    "lat": 0.466477,
    "lng": 121.947339,
    "color": "#dc3545"
}, {
    "nosamw": "0400500",
    "nama": "Sunaryo Djohar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460464,
    "lng": 121.936931,
    "color": "#28a745"
}, {
    "nosamw": "0400626",
    "nama": "Supratman Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.456463,
    "lng": 121.937885,
    "color": "#28a745"
}, {
    "nosamw": "0401285",
    "nama": "Suratman Mahmud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 600000,
    "total_denda": 60000,
    "total_jumlah": 660000,
    "lat": 0.467033,
    "lng": 121.951205,
    "color": "#dc3545"
}, {
    "nosamw": "0400873",
    "nama": "Suratman Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4560093,
    "lng": 121.9381165,
    "color": "#28a745"
}, {
    "nosamw": "0400159",
    "nama": "Surino",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172000,
    "total_denda": 5000,
    "total_jumlah": 177000,
    "lat": 0.466763,
    "lng": 121.949709,
    "color": "#ffc107"
}, {
    "nosamw": "0400714",
    "nama": "Surono",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 660000,
    "total_denda": 60000,
    "total_jumlah": 720000,
    "lat": 0.457143,
    "lng": 121.937059,
    "color": "#dc3545"
}, {
    "nosamw": "0400743",
    "nama": "Suryani Botutihe",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465559,
    "lng": 121.937727,
    "color": "#28a745"
}, {
    "nosamw": "0403078",
    "nama": "Suryanti",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 320500,
    "total_denda": 20000,
    "total_jumlah": 340500,
    "lat": 0.462209,
    "lng": 121.937922,
    "color": "#fd7e14"
}, {
    "nosamw": "0403841",
    "nama": "Susilo Siswanto",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 2594000,
    "total_denda": 90000,
    "total_jumlah": 2684000,
    "lat": 0.461586,
    "lng": 121.938406,
    "color": "#dc3545"
}, {
    "nosamw": "0400558",
    "nama": "Sutarjo Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464286,
    "lng": 121.937489,
    "color": "#28a745"
}, {
    "nosamw": "0400495",
    "nama": "Syahrul",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466762,
    "lng": 121.938826,
    "color": "#28a745"
}, {
    "nosamw": "0401234",
    "nama": "Syarif Idrus",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 25000,
    "total_jumlah": 300000,
    "lat": 0.462173,
    "lng": 121.937879,
    "color": "#fd7e14"
}, {
    "nosamw": "0400830",
    "nama": "Ta Awu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46454,
    "lng": 121.937653,
    "color": "#28a745"
}, {
    "nosamw": "0403680",
    "nama": "Tahir Usman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 597000,
    "total_denda": 20000,
    "total_jumlah": 617000,
    "lat": 0.4574041,
    "lng": 121.9373579,
    "color": "#fd7e14"
}, {
    "nosamw": "0403022",
    "nama": "Taman Bappeda",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1565000,
    "total_denda": 240000,
    "total_jumlah": 1805000,
    "lat": 0.4586,
    "lng": 121.944652,
    "color": "#dc3545"
}, {
    "nosamw": "0404477",
    "nama": "Taman Pemda Pohuwato",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 15000,
    "total_jumlah": 117500,
    "lat": 0.457432,
    "lng": 121.94762,
    "color": "#ffc107"
}, {
    "nosamw": "0401073",
    "nama": "Tamin Paja",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 4230000,
    "total_denda": 70000,
    "total_jumlah": 4300000,
    "lat": 0.460996,
    "lng": 121.935564,
    "color": "#dc3545"
}, {
    "nosamw": "0401096",
    "nama": "Tamrin Abdul Azis",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 88000,
    "total_denda": 10000,
    "total_jumlah": 98000,
    "lat": 0.466311,
    "lng": 121.934959,
    "color": "#ffc107"
}, {
    "nosamw": "0400362",
    "nama": "Tardy Lahay",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.466866,
    "lng": 121.950079,
    "color": "#ffc107"
}, {
    "nosamw": "0401601",
    "nama": "Tin Bulonggodu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 465200,
    "total_denda": 60000,
    "total_jumlah": 525200,
    "lat": 0.459805,
    "lng": 121.936519,
    "color": "#dc3545"
}, {
    "nosamw": "0401587",
    "nama": "Tirta Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082343008033",
    "total_bulan": 8,
    "total_tagihan": 1671000,
    "total_denda": 35000,
    "total_jumlah": 1706000,
    "lat": 0.4535729,
    "lng": 121.947749,
    "color": "#dc3545"
}, {
    "nosamw": "0400959",
    "nama": "Tiwi Bunena",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4555164,
    "lng": 121.9361862,
    "color": "#28a745"
}, {
    "nosamw": "0400597",
    "nama": "TK Pembina",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1665600,
    "total_denda": 10000,
    "total_jumlah": 1675600,
    "lat": 0.458151,
    "lng": 121.947512,
    "color": "#fd7e14"
}, {
    "nosamw": "0407301",
    "nama": "TOGU P .G  MALAU 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085394609333",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.45858,
    "lng": 121.94528,
    "color": "#ffc107"
}, {
    "nosamw": "0404766",
    "nama": "Togu P. G. Malau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458587,
    "lng": 121.94493,
    "color": "#28a745"
}, {
    "nosamw": "0400919",
    "nama": "Tomis Yasin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459381,
    "lng": 121.935913,
    "color": "#28a745"
}, {
    "nosamw": "0402537",
    "nama": "Tommy S. Kalangi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1542000,
    "total_denda": 15000,
    "total_jumlah": 1557000,
    "lat": 0.456476,
    "lng": 121.938289,
    "color": "#ffc107"
}, {
    "nosamw": "0400565",
    "nama": "Tomy Dj. Lendo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 615000,
    "total_denda": 10000,
    "total_jumlah": 625000,
    "lat": 0.459194,
    "lng": 121.937444,
    "color": "#ffc107"
}, {
    "nosamw": "0401268",
    "nama": "Toni Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1722500,
    "total_denda": 20000,
    "total_jumlah": 1742500,
    "lat": 0.4600448,
    "lng": 121.939532,
    "color": "#fd7e14"
}, {
    "nosamw": "0403468",
    "nama": "Toni Lamusu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460845,
    "lng": 121.935567,
    "color": "#28a745"
}, {
    "nosamw": "0402604",
    "nama": "Tuni Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 405000,
    "total_denda": 0,
    "total_jumlah": 405000,
    "lat": 0.4661,
    "lng": 121.945376,
    "color": "#ffc107"
}, {
    "nosamw": "0402268",
    "nama": "Udin Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467084,
    "lng": 121.94953,
    "color": "#28a745"
}, {
    "nosamw": "0402385",
    "nama": "Udin Tobuhu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 525500,
    "total_denda": 20000,
    "total_jumlah": 545500,
    "lat": 0.4621897,
    "lng": 121.9629729,
    "color": "#fd7e14"
}, {
    "nosamw": "0402250",
    "nama": "Ulfa Hunowu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.456583,
    "lng": 121.942468,
    "color": "#ffc107"
}, {
    "nosamw": "0401387",
    "nama": "Ulpan Banggoi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463799,
    "lng": 121.935843,
    "color": "#28a745"
}, {
    "nosamw": "0402122",
    "nama": "Umar Abdulah",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085349661817",
    "total_bulan": 2,
    "total_tagihan": 298500,
    "total_denda": 10000,
    "total_jumlah": 308500,
    "lat": 0.4563798,
    "lng": 121.9380403,
    "color": "#ffc107"
}, {
    "nosamw": "0402688",
    "nama": "Umar Bantahari",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 96500,
    "total_denda": 0,
    "total_jumlah": 96500,
    "lat": 0.459403,
    "lng": 121.953921,
    "color": "#ffc107"
}, {
    "nosamw": "0401297",
    "nama": "Umar Imran",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082186755296",
    "total_bulan": 3,
    "total_tagihan": 449500,
    "total_denda": 15000,
    "total_jumlah": 464500,
    "lat": 0.456582,
    "lng": 121.9379441,
    "color": "#fd7e14"
}, {
    "nosamw": "0403081",
    "nama": "Umar Kasim Eyato, S.Ag",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4608088,
    "lng": 121.9433566,
    "color": "#28a745"
}, {
    "nosamw": "0401226",
    "nama": "Umar Lahiya 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1401750,
    "total_denda": 80000,
    "total_jumlah": 1481750,
    "lat": 0.462491,
    "lng": 121.944447,
    "color": "#dc3545"
}, {
    "nosamw": "0402048",
    "nama": "Une Panakili",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 82500,
    "total_denda": 5000,
    "total_jumlah": 87500,
    "lat": 0.457738,
    "lng": 121.937454,
    "color": "#ffc107"
}, {
    "nosamw": "0401280",
    "nama": "Unggu Sarce M",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082259031901",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458709,
    "lng": 121.951588,
    "color": "#28a745"
}, {
    "nosamw": "0404229",
    "nama": "USAID Halima Kunau",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 396400,
    "total_denda": 10000,
    "total_jumlah": 406400,
    "lat": 0.460828,
    "lng": 121.936915,
    "color": "#ffc107"
}, {
    "nosamw": "0403898",
    "nama": "USAID Maryam Tangahu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1026500,
    "total_denda": 90000,
    "total_jumlah": 1116500,
    "lat": 0.459394,
    "lng": 121.935732,
    "color": "#dc3545"
}, {
    "nosamw": "0403887",
    "nama": "USAID Norma Rupu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457735,
    "lng": 121.936933,
    "color": "#28a745"
}, {
    "nosamw": "0403820",
    "nama": "USAID Udin Inombi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458478,
    "lng": 121.93614,
    "color": "#28a745"
}, {
    "nosamw": "0401640",
    "nama": "Usman Lopuo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460546,
    "lng": 121.936977,
    "color": "#28a745"
}, {
    "nosamw": "0401671",
    "nama": "Usman Rupu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 210500,
    "total_denda": 10000,
    "total_jumlah": 220500,
    "lat": 0.466989,
    "lng": 121.951534,
    "color": "#fd7e14"
}, {
    "nosamw": "0403410",
    "nama": "Uswatun Hasanah 2",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 642000,
    "total_denda": 30000,
    "total_jumlah": 672000,
    "lat": 0.460446,
    "lng": 121.942902,
    "color": "#fd7e14"
}, {
    "nosamw": "0403047",
    "nama": "Vera Kasegar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1362000,
    "total_denda": 50000,
    "total_jumlah": 1412000,
    "lat": 0.461986,
    "lng": 121.938797,
    "color": "#dc3545"
}, {
    "nosamw": "0404373",
    "nama": "VONNY TENGES",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462436,
    "lng": 121.9370157,
    "color": "#28a745"
}, {
    "nosamw": "0400795",
    "nama": "Wahid Lopuo",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46414,
    "lng": 121.937589,
    "color": "#28a745"
}, {
    "nosamw": "0400339",
    "nama": "Wahidin Darjan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.467024,
    "lng": 121.951562,
    "color": "#fd7e14"
}, {
    "nosamw": "0400342",
    "nama": "Wan Adjidji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 463500,
    "total_denda": 25000,
    "total_jumlah": 488500,
    "lat": 0.455855,
    "lng": 121.937313,
    "color": "#fd7e14"
}, {
    "nosamw": "0402069",
    "nama": "Wani Langgila",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1005800,
    "total_denda": 60000,
    "total_jumlah": 1065800,
    "lat": 0.457476,
    "lng": 121.937484,
    "color": "#dc3545"
}, {
    "nosamw": "0402717",
    "nama": "Warjito Mahmud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460441,
    "lng": 121.936864,
    "color": "#28a745"
}, {
    "nosamw": "0404680",
    "nama": "Warni Sayedi",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.461137,
    "lng": 121.935698,
    "color": "#ffc107"
}, {
    "nosamw": "0400185",
    "nama": "Welly Mantu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4568,
    "lng": 121.936874,
    "color": "#28a745"
}, {
    "nosamw": "0402761",
    "nama": "Weni A. Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.459891,
    "lng": 121.93576,
    "color": "#ffc107"
}, {
    "nosamw": "0400841",
    "nama": "Wisno Umar",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462426,
    "lng": 121.944534,
    "color": "#28a745"
}, {
    "nosamw": "0402252",
    "nama": "Wiwin Tamungu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 910000,
    "total_denda": 15000,
    "total_jumlah": 925000,
    "lat": 0.456968,
    "lng": 121.942582,
    "color": "#fd7e14"
}, {
    "nosamw": "0400465",
    "nama": "Yakob Haluta",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464368,
    "lng": 121.937627,
    "color": "#28a745"
}, {
    "nosamw": "0406848",
    "nama": "YAKOP TANANI",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 777500,
    "total_denda": 80000,
    "total_jumlah": 857500,
    "lat": 0.4645654,
    "lng": 121.9429682,
    "color": "#dc3545"
}, {
    "nosamw": "0400427",
    "nama": "Yan Ismail Unjila",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460486,
    "lng": 121.936899,
    "color": "#28a745"
}, {
    "nosamw": "0400835",
    "nama": "Yan Ismail Unjila II",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 546000,
    "total_denda": 15000,
    "total_jumlah": 561000,
    "lat": 0.457126,
    "lng": 121.94,
    "color": "#fd7e14"
}, {
    "nosamw": "0401509",
    "nama": "Yandri Taha",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1104000,
    "total_denda": 50000,
    "total_jumlah": 1154000,
    "lat": 0.466011,
    "lng": 121.962793,
    "color": "#dc3545"
}, {
    "nosamw": "0402248",
    "nama": "Yanti Dj Ishak,SE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4561455,
    "lng": 121.9414154,
    "color": "#fd7e14"
}, {
    "nosamw": "0400956",
    "nama": "Yasmin Yusuf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1387000,
    "total_denda": 85000,
    "total_jumlah": 1472000,
    "lat": 0.4659824,
    "lng": 121.9451581,
    "color": "#dc3545"
}, {
    "nosamw": "0402155",
    "nama": "Yaspin Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 251250,
    "total_denda": 5000,
    "total_jumlah": 256250,
    "lat": 0.459384,
    "lng": 121.953827,
    "color": "#ffc107"
}, {
    "nosamw": "0401724",
    "nama": "YOLANDA MOHUNE",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 2280500,
    "total_denda": 50000,
    "total_jumlah": 2330500,
    "lat": 0.4587675,
    "lng": 121.9521108,
    "color": "#dc3545"
}, {
    "nosamw": "0403788",
    "nama": "Yolly Motto 3",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2557250,
    "total_denda": 80000,
    "total_jumlah": 2637250,
    "lat": 0.466219,
    "lng": 121.942612,
    "color": "#dc3545"
}, {
    "nosamw": "0401041",
    "nama": "Yonarti Pikoli",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1821000,
    "total_denda": 5000,
    "total_jumlah": 1826000,
    "lat": 0.457126,
    "lng": 121.94,
    "color": "#ffc107"
}, {
    "nosamw": "0401376",
    "nama": "Yulan Monoarfa",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.465805,
    "lng": 121.934911,
    "color": "#ffc107"
}, {
    "nosamw": "0400645",
    "nama": "Yulisman Pulukadang",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2023500,
    "total_denda": 70000,
    "total_jumlah": 2093500,
    "lat": 0.458439,
    "lng": 121.951831,
    "color": "#dc3545"
}, {
    "nosamw": "0401895",
    "nama": "Yunita Dulman",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465279,
    "lng": 121.946131,
    "color": "#28a745"
}, {
    "nosamw": "0400574",
    "nama": "Yunita Metti",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461803,
    "lng": 121.93784,
    "color": "#28a745"
}, {
    "nosamw": "0400501",
    "nama": "Yunus Adjidji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 368000,
    "total_denda": 55000,
    "total_jumlah": 423000,
    "lat": 0.456666,
    "lng": 121.936821,
    "color": "#dc3545"
}, {
    "nosamw": "0400251",
    "nama": "Yunus Cono",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4598715,
    "lng": 121.935826,
    "color": "#28a745"
}, {
    "nosamw": "0403636",
    "nama": "Yunus Hasan",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46078,
    "lng": 121.943225,
    "color": "#28a745"
}, {
    "nosamw": "0402457",
    "nama": "Yunus Huluji",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461137,
    "lng": 121.935698,
    "color": "#28a745"
}, {
    "nosamw": "0404291",
    "nama": "Yunus Matuka",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1095000,
    "total_denda": 105000,
    "total_jumlah": 1200000,
    "lat": 0.464507,
    "lng": 121.934129,
    "color": "#dc3545"
}, {
    "nosamw": "0403073",
    "nama": "Yusran Rauf",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 136600,
    "total_denda": 5000,
    "total_jumlah": 141600,
    "lat": 0.455925,
    "lng": 121.936649,
    "color": "#ffc107"
}, {
    "nosamw": "0400899",
    "nama": "Yusuf Ali",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.460731,
    "lng": 121.936923,
    "color": "#fd7e14"
}, {
    "nosamw": "0401284",
    "nama": "Yusuf Duawulu",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466566,
    "lng": 121.951603,
    "color": "#28a745"
}, {
    "nosamw": "0405529",
    "nama": "Yusuf Kadir",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.4649109,
    "lng": 121.9445316,
    "color": "#ffc107"
}, {
    "nosamw": "0400190",
    "nama": "Yusuf Karim",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459605,
    "lng": 121.935964,
    "color": "#28a745"
}, {
    "nosamw": "0402338",
    "nama": "Yusuf Nusi S.Kom",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 422500,
    "total_denda": 10000,
    "total_jumlah": 432500,
    "lat": 0.457499,
    "lng": 121.937413,
    "color": "#ffc107"
}, {
    "nosamw": "0400721",
    "nama": "Yusup Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "0000",
    "total_bulan": 27,
    "total_tagihan": 1490000,
    "total_denda": 135000,
    "total_jumlah": 1625000,
    "lat": 0.465478,
    "lng": 121.937657,
    "color": "#dc3545"
}, {
    "nosamw": "0401417",
    "nama": "Yuyun Potale",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 288500,
    "total_denda": 15000,
    "total_jumlah": 303500,
    "lat": 0.466608,
    "lng": 121.949421,
    "color": "#fd7e14"
}, {
    "nosamw": "0401875",
    "nama": "Zaenab Inaku",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465316,
    "lng": 121.946129,
    "color": "#28a745"
}, {
    "nosamw": "0403102",
    "nama": "Zaenal Arifin",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459174,
    "lng": 121.937234,
    "color": "#28a745"
}, {
    "nosamw": "0400510",
    "nama": "Zainudin Nento",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 495000,
    "total_denda": 45000,
    "total_jumlah": 540000,
    "lat": 0.465362,
    "lng": 121.937643,
    "color": "#dc3545"
}, {
    "nosamw": "0403043",
    "nama": "Zein Yunus S.Kom",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.459662,
    "lng": 121.939228,
    "color": "#28a745"
}, {
    "nosamw": "0402119",
    "nama": "Zubedi Daud",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 188000,
    "total_denda": 10000,
    "total_jumlah": 198000,
    "lat": 0.460063,
    "lng": 121.940848,
    "color": "#ffc107"
}, {
    "nosamw": "0403551",
    "nama": "ZULKIFLI RAHMAN",
    "kecamatan": "KEC MARISA DESA MARISA SELATAN",
    "desa": "MARISA SELATAN",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4652528,
    "lng": 121.9450562,
    "color": "#ffc107"
}, {
    "nosamw": "0400727",
    "nama": "Abd. L. Puhi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 294500,
    "total_denda": 25000,
    "total_jumlah": 319500,
    "lat": 0.469524,
    "lng": 121.946271,
    "color": "#fd7e14"
}, {
    "nosamw": "0402195",
    "nama": "ABD. RAHMAN PAKAYA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466704,
    "lng": 121.949675,
    "color": "#28a745"
}, {
    "nosamw": "0401245",
    "nama": "Abd. Rahman Tilameo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468961,
    "lng": 121.946779,
    "color": "#28a745"
}, {
    "nosamw": "0403251",
    "nama": "Abd. Rasid",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473714,
    "lng": 121.944774,
    "color": "#28a745"
}, {
    "nosamw": "0401743",
    "nama": "Abdul Fadli Tino",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 668000,
    "total_denda": 25000,
    "total_jumlah": 693000,
    "lat": 0.467382,
    "lng": 121.937926,
    "color": "#fd7e14"
}, {
    "nosamw": "0407549",
    "nama": "ABDUL RAHMAN BALADRAF",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085161145303",
    "total_bulan": 3,
    "total_tagihan": 670000,
    "total_denda": 10000,
    "total_jumlah": 680000,
    "lat": 0.4671806,
    "lng": 121.9382391,
    "color": "#fd7e14"
}, {
    "nosamw": "0403976",
    "nama": "AFIF \/ ABIL",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.473076,
    "lng": 121.9464718,
    "color": "#ffc107"
}, {
    "nosamw": "0401942",
    "nama": "Agus Tri Winarko, Se",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4750548,
    "lng": 121.9474052,
    "color": "#28a745"
}, {
    "nosamw": "0401869",
    "nama": "Ajarahmat Amrain",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 3512750,
    "total_denda": 90000,
    "total_jumlah": 3602750,
    "lat": 0.470793,
    "lng": 121.940237,
    "color": "#dc3545"
}, {
    "nosamw": "0402016",
    "nama": "Alfrets Surentu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47023,
    "lng": 121.940125,
    "color": "#28a745"
}, {
    "nosamw": "0401459",
    "nama": "Amrin Umar",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472074,
    "lng": 121.939895,
    "color": "#28a745"
}, {
    "nosamw": "0402433",
    "nama": "Ana Laude (bni)",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "BN",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467603,
    "lng": 121.935622,
    "color": "#28a745"
}, {
    "nosamw": "0403782",
    "nama": "Ana Laude 2",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 315000,
    "total_denda": 30000,
    "total_jumlah": 345000,
    "lat": 0.467563,
    "lng": 121.935506,
    "color": "#fd7e14"
}, {
    "nosamw": "0402831",
    "nama": "Anita Tantu II",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.476998,
    "lng": 121.947376,
    "color": "#28a745"
}, {
    "nosamw": "0403688",
    "nama": "Antonio Sudarsono",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.473785,
    "lng": 121.938613,
    "color": "#ffc107"
}, {
    "nosamw": "0401595",
    "nama": "Antonius Yilim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85000,
    "total_denda": 5000,
    "total_jumlah": 90000,
    "lat": 0.467633,
    "lng": 121.93536,
    "color": "#ffc107"
}, {
    "nosamw": "0402439",
    "nama": "Anwar Kumasi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 172000,
    "total_denda": 20000,
    "total_jumlah": 192000,
    "lat": 0.470698,
    "lng": 121.939814,
    "color": "#fd7e14"
}, {
    "nosamw": "0402088",
    "nama": "Ardiansyah Arifin",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470436,
    "lng": 121.940916,
    "color": "#28a745"
}, {
    "nosamw": "0401975",
    "nama": "Arfan Tangoy",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469654,
    "lng": 121.942583,
    "color": "#28a745"
}, {
    "nosamw": "0401624",
    "nama": "Ariyanto Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467049,
    "lng": 121.944232,
    "color": "#28a745"
}, {
    "nosamw": "0400167",
    "nama": "Asda Yunus",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 2001500,
    "total_denda": 315000,
    "total_jumlah": 2316500,
    "lat": 0.467443,
    "lng": 121.937648,
    "color": "#dc3545"
}, {
    "nosamw": "0401980",
    "nama": "Aslam Mohamad II",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471413,
    "lng": 121.940074,
    "color": "#28a745"
}, {
    "nosamw": "0404400",
    "nama": "Asnawi Ismail",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467191,
    "lng": 121.943952,
    "color": "#28a745"
}, {
    "nosamw": "0400969",
    "nama": "Aswin Diange",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.477198,
    "lng": 121.947759,
    "color": "#ffc107"
}, {
    "nosamw": "0400582",
    "nama": "Aswin Lahay",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1275500,
    "total_denda": 115000,
    "total_jumlah": 1390500,
    "lat": 0.466195,
    "lng": 121.944563,
    "color": "#dc3545"
}, {
    "nosamw": "0401154",
    "nama": "Aswin Lahay II",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466543,
    "lng": 121.944429,
    "color": "#28a745"
}, {
    "nosamw": "0400651",
    "nama": "Bahari Gobel",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 127500,
    "total_denda": 15000,
    "total_jumlah": 142500,
    "lat": 0.470612,
    "lng": 121.939436,
    "color": "#fd7e14"
}, {
    "nosamw": "0404506",
    "nama": "Baharuddin",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.467214,
    "lng": 121.939178,
    "color": "#ffc107"
}, {
    "nosamw": "0402052",
    "nama": "Bonny Gosal",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 60000,
    "total_jumlah": 725000,
    "lat": 0.467422,
    "lng": 121.93516,
    "color": "#dc3545"
}, {
    "nosamw": "0400634",
    "nama": "Bpk. Darsono Rivai",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1314000,
    "total_denda": 60000,
    "total_jumlah": 1374000,
    "lat": 0.471943,
    "lng": 121.941365,
    "color": "#dc3545"
}, {
    "nosamw": "0400208",
    "nama": "BRI. Cabang Marisa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467526,
    "lng": 121.935672,
    "color": "#28a745"
}, {
    "nosamw": "0400816",
    "nama": "Budi Olii",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 546000,
    "total_denda": 10000,
    "total_jumlah": 556000,
    "lat": 0.466558,
    "lng": 121.946368,
    "color": "#ffc107"
}, {
    "nosamw": "0402290",
    "nama": "Bumbu Daeng Caya",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.473153,
    "lng": 121.938196,
    "color": "#fd7e14"
}, {
    "nosamw": "0407447",
    "nama": "dr. DIAN IKAGUSTINA TAMBUNAN",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "08126311143",
    "total_bulan": 4,
    "total_tagihan": 298000,
    "total_denda": 15000,
    "total_jumlah": 313000,
    "lat": 0.4687653,
    "lng": 121.9399493,
    "color": "#fd7e14"
}, {
    "nosamw": "0404684",
    "nama": "Eli Hasan",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 255000,
    "total_denda": 45000,
    "total_jumlah": 300000,
    "lat": 0.471387,
    "lng": 121.945729,
    "color": "#dc3545"
}, {
    "nosamw": "0402770",
    "nama": "Elian Podungge",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470804,
    "lng": 121.94021,
    "color": "#28a745"
}, {
    "nosamw": "0401542",
    "nama": "Ellen I. Umar",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 201000,
    "total_denda": 10000,
    "total_jumlah": 211000,
    "lat": 0.468131,
    "lng": 121.945944,
    "color": "#ffc107"
}, {
    "nosamw": "0404731",
    "nama": "ELVI BULUATI",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 978000,
    "total_denda": 45000,
    "total_jumlah": 1023000,
    "lat": 0.467901,
    "lng": 121.94671,
    "color": "#fd7e14"
}, {
    "nosamw": "0400966",
    "nama": "Erlan Yasin",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47711,
    "lng": 121.94765,
    "color": "#28a745"
}, {
    "nosamw": "0401121",
    "nama": "Erna Tino",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 3570500,
    "total_denda": 80000,
    "total_jumlah": 3650500,
    "lat": 0.467263,
    "lng": 121.93853,
    "color": "#dc3545"
}, {
    "nosamw": "0401125",
    "nama": "FATMA AHMAD",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449338,
    "lng": 121.940457,
    "color": "#28a745"
}, {
    "nosamw": "0406877",
    "nama": "FAZRIAH LAMADUPA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4744103,
    "lng": 121.9420831,
    "color": "#ffc107"
}, {
    "nosamw": "0407560",
    "nama": "FEMI MOPUTI",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085166365622",
    "total_bulan": 4,
    "total_tagihan": 730000,
    "total_denda": 15000,
    "total_jumlah": 745000,
    "lat": 0.4575758,
    "lng": 121.9497065,
    "color": "#fd7e14"
}, {
    "nosamw": "0404749",
    "nama": "FERAWATI BABUNGA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469913,
    "lng": 121.946816,
    "color": "#28a745"
}, {
    "nosamw": "0404573",
    "nama": "Fitriyanti Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471926,
    "lng": 121.940088,
    "color": "#28a745"
}, {
    "nosamw": "0401036",
    "nama": "Goefron Ibrahim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 399500,
    "total_denda": 20000,
    "total_jumlah": 419500,
    "lat": 0.466364,
    "lng": 121.944408,
    "color": "#ffc107"
}, {
    "nosamw": "0406598",
    "nama": "H18 ERSE DRANANG PERTIWI",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4674903,
    "lng": 121.9422691,
    "color": "#ffc107"
}, {
    "nosamw": "0406479",
    "nama": "H18 MIEN TOBUHU",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4669445,
    "lng": 121.9393421,
    "color": "#ffc107"
}, {
    "nosamw": "0406856",
    "nama": "H19 Martin Rabiasa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 688500,
    "total_denda": 40000,
    "total_jumlah": 728500,
    "lat": 0.469015,
    "lng": 121.9415396,
    "color": "#dc3545"
}, {
    "nosamw": "0406858",
    "nama": "H19 NETI MAKU",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 606000,
    "total_denda": 30000,
    "total_jumlah": 636000,
    "lat": 0.4744405,
    "lng": 121.9552041,
    "color": "#dc3545"
}, {
    "nosamw": "0402486",
    "nama": "Hadija S. Towali",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468991,
    "lng": 121.945335,
    "color": "#28a745"
}, {
    "nosamw": "0401590",
    "nama": "Hamdun Pasisingi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473695,
    "lng": 121.94445,
    "color": "#28a745"
}, {
    "nosamw": "0402445",
    "nama": "Hariono Asiku",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 125000,
    "total_denda": 15000,
    "total_jumlah": 140000,
    "lat": 0.467649,
    "lng": 121.935458,
    "color": "#fd7e14"
}, {
    "nosamw": "0402802",
    "nama": "Hariyanto Syarief",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472988,
    "lng": 121.951372,
    "color": "#28a745"
}, {
    "nosamw": "0400355",
    "nama": "Hartin Malae",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470135,
    "lng": 121.943659,
    "color": "#28a745"
}, {
    "nosamw": "0403778",
    "nama": "Haryono Asabi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47125,
    "lng": 121.940022,
    "color": "#28a745"
}, {
    "nosamw": "0403698",
    "nama": "Hasan Oka",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 4798750,
    "total_denda": 50000,
    "total_jumlah": 4848750,
    "lat": 0.467437,
    "lng": 121.943309,
    "color": "#dc3545"
}, {
    "nosamw": "0400356",
    "nama": "Hatimah Bumulo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 40000,
    "total_jumlah": 485000,
    "lat": 0.480528,
    "lng": 121.94233,
    "color": "#dc3545"
}, {
    "nosamw": "0404425",
    "nama": "Herman Asabi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.479509,
    "lng": 121.951445,
    "color": "#28a745"
}, {
    "nosamw": "0400887",
    "nama": "Husain Lasimpala",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1031500,
    "total_denda": 45000,
    "total_jumlah": 1076500,
    "lat": 0.4667952,
    "lng": 121.9608316,
    "color": "#dc3545"
}, {
    "nosamw": "0401457",
    "nama": "Husain Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 869000,
    "total_denda": 25000,
    "total_jumlah": 894000,
    "lat": 0.467046,
    "lng": 121.944019,
    "color": "#fd7e14"
}, {
    "nosamw": "0400870",
    "nama": "I Kadek Armawan",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473068,
    "lng": 121.951694,
    "color": "#28a745"
}, {
    "nosamw": "0401688",
    "nama": "Ibrahim Moito",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475639,
    "lng": 121.938158,
    "color": "#28a745"
}, {
    "nosamw": "0400974",
    "nama": "Idrus A. Moputi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467137,
    "lng": 121.938386,
    "color": "#28a745"
}, {
    "nosamw": "0401534",
    "nama": "Ilham Pobi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4689331,
    "lng": 121.9409239,
    "color": "#28a745"
}, {
    "nosamw": "0403659",
    "nama": "Imran Yusuf",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475094,
    "lng": 121.93976,
    "color": "#28a745"
}, {
    "nosamw": "0404742",
    "nama": "INDRA LARAGA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467382,
    "lng": 121.943577,
    "color": "#28a745"
}, {
    "nosamw": "0407382",
    "nama": "INDRA SAKTI POIYO",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.46892,
    "lng": 121.9409349,
    "color": "#ffc107"
}, {
    "nosamw": "0404378",
    "nama": "Irfan Halilu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1970450,
    "total_denda": 120000,
    "total_jumlah": 2090450,
    "lat": 0.467249,
    "lng": 121.943851,
    "color": "#dc3545"
}, {
    "nosamw": "0401094",
    "nama": "Irfan Saud",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.467412,
    "lng": 121.936098,
    "color": "#fd7e14"
}, {
    "nosamw": "0404507",
    "nama": "Irpan Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Cabut Meter",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 259000,
    "total_denda": 25000,
    "total_jumlah": 284000,
    "lat": 0.466487,
    "lng": 121.945069,
    "color": "#fd7e14"
}, {
    "nosamw": "0401837",
    "nama": "ISMON SAHI",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.480492,
    "lng": 121.9448023,
    "color": "#fd7e14"
}, {
    "nosamw": "0402238",
    "nama": "Iswan Gau II",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.472042,
    "lng": 121.942872,
    "color": "#fd7e14"
}, {
    "nosamw": "0400608",
    "nama": "Iwan K. Idrus",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4692,
    "lng": 121.945213,
    "color": "#28a745"
}, {
    "nosamw": "0407523",
    "nama": "JALALUDIN NAPU",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085398602002",
    "total_bulan": 5,
    "total_tagihan": 962500,
    "total_denda": 20000,
    "total_jumlah": 982500,
    "lat": 0.4670232,
    "lng": 121.9389419,
    "color": "#fd7e14"
}, {
    "nosamw": "0404568",
    "nama": "Jamal Max Kaluku",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47192,
    "lng": 121.940672,
    "color": "#28a745"
}, {
    "nosamw": "0404423",
    "nama": "Jefri Junyar Saehu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.47171,
    "lng": 121.9456,
    "color": "#dc3545"
}, {
    "nosamw": "0401593",
    "nama": "Jimi Yilim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 284750,
    "total_denda": 45000,
    "total_jumlah": 329750,
    "lat": 0.467461,
    "lng": 121.934942,
    "color": "#fd7e14"
}, {
    "nosamw": "0403743",
    "nama": "Juhaeni",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.474899,
    "lng": 121.9470756,
    "color": "#28a745"
}, {
    "nosamw": "0404509",
    "nama": "Kadir Hasan",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466151,
    "lng": 121.943723,
    "color": "#28a745"
}, {
    "nosamw": "0401685",
    "nama": "Kamarudin Oka",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.474739,
    "lng": 121.940531,
    "color": "#28a745"
}, {
    "nosamw": "0403631",
    "nama": "Kasri Shara AlLo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 655000,
    "total_denda": 50000,
    "total_jumlah": 705000,
    "lat": 0.470473,
    "lng": 121.942365,
    "color": "#dc3545"
}, {
    "nosamw": "0402308",
    "nama": "Ktr Desa M. Utara",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47234,
    "lng": 121.941252,
    "color": "#28a745"
}, {
    "nosamw": "0400811",
    "nama": "LIN MALAE",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469965,
    "lng": 121.943224,
    "color": "#28a745"
}, {
    "nosamw": "0401812",
    "nama": "Lius Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472017,
    "lng": 121.940258,
    "color": "#28a745"
}, {
    "nosamw": "0401229",
    "nama": "Lusiana Bouty",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470109,
    "lng": 121.951845,
    "color": "#28a745"
}, {
    "nosamw": "0403384",
    "nama": "Madhi Alhasni",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47085,
    "lng": 121.942367,
    "color": "#28a745"
}, {
    "nosamw": "0402133",
    "nama": "Marni Tuna",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470104,
    "lng": 121.941759,
    "color": "#28a745"
}, {
    "nosamw": "0404683",
    "nama": "Marwan Tilameo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 463000,
    "total_denda": 75000,
    "total_jumlah": 538000,
    "lat": 0.46919,
    "lng": 121.945911,
    "color": "#dc3545"
}, {
    "nosamw": "0404202",
    "nama": "Maryam Ibrahim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470512,
    "lng": 121.942606,
    "color": "#28a745"
}, {
    "nosamw": "0404260",
    "nama": "Maryam Saripi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 832500,
    "total_denda": 15000,
    "total_jumlah": 847500,
    "lat": 0.473567,
    "lng": 121.944842,
    "color": "#fd7e14"
}, {
    "nosamw": "0401742",
    "nama": "Mashudi Bulango",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466467,
    "lng": 121.944354,
    "color": "#28a745"
}, {
    "nosamw": "0400961",
    "nama": "Masjid Nur Tauhid",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 76000,
    "total_denda": 5000,
    "total_jumlah": 81000,
    "lat": 0.476833,
    "lng": 121.947248,
    "color": "#ffc107"
}, {
    "nosamw": "0405278",
    "nama": "MCK.TERMINAL MARISA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 81800,
    "total_denda": 5000,
    "total_jumlah": 86800,
    "lat": 0.4708953,
    "lng": 121.9398695,
    "color": "#ffc107"
}, {
    "nosamw": "0400824",
    "nama": "Melis R. Hunowu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470096,
    "lng": 121.940784,
    "color": "#28a745"
}, {
    "nosamw": "0400225",
    "nama": "Melly Metty IV",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467894,
    "lng": 121.937466,
    "color": "#28a745"
}, {
    "nosamw": "0403948",
    "nama": "MERNA MBUINGA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4685341,
    "lng": 121.9407609,
    "color": "#ffc107"
}, {
    "nosamw": "0402503",
    "nama": "Mesjid Nur Rudin",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 31,
    "total_tagihan": 130000,
    "total_denda": 155000,
    "total_jumlah": 285000,
    "lat": 0.466273,
    "lng": 121.943315,
    "color": "#dc3545"
}, {
    "nosamw": "0402713",
    "nama": "Midun Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468443,
    "lng": 121.946729,
    "color": "#28a745"
}, {
    "nosamw": "0401264",
    "nama": "Moh. Zainal Kono",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475338,
    "lng": 121.939098,
    "color": "#28a745"
}, {
    "nosamw": "0400804",
    "nama": "Muskina Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.470619,
    "lng": 121.942453,
    "color": "#fd7e14"
}, {
    "nosamw": "0404432",
    "nama": "Nangsi Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 614000,
    "total_denda": 65000,
    "total_jumlah": 679000,
    "lat": 0.470731,
    "lng": 121.940439,
    "color": "#dc3545"
}, {
    "nosamw": "0402507",
    "nama": "Nasrudin Herlambang",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4678,
    "lng": 121.946854,
    "color": "#28a745"
}, {
    "nosamw": "0402010",
    "nama": "Nikson Pakaya",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1054000,
    "total_denda": 25000,
    "total_jumlah": 1079000,
    "lat": 0.464341,
    "lng": 121.949378,
    "color": "#fd7e14"
}, {
    "nosamw": "0402966",
    "nama": "Nina Asabi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1990500,
    "total_denda": 70000,
    "total_jumlah": 2060500,
    "lat": 0.467306,
    "lng": 121.957852,
    "color": "#dc3545"
}, {
    "nosamw": "0404359",
    "nama": "Nonce Sadapu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472185,
    "lng": 121.943105,
    "color": "#28a745"
}, {
    "nosamw": "0402846",
    "nama": "Nurdin Botutihe",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467493,
    "lng": 121.938578,
    "color": "#28a745"
}, {
    "nosamw": "0403201",
    "nama": "Nurhayati Daud",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 830000,
    "total_denda": 75000,
    "total_jumlah": 905000,
    "lat": 0.467126,
    "lng": 121.939385,
    "color": "#dc3545"
}, {
    "nosamw": "0404569",
    "nama": "Nurlela Kaluku",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471963,
    "lng": 121.940517,
    "color": "#28a745"
}, {
    "nosamw": "0401323",
    "nama": "Nurlena Idji",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470508,
    "lng": 121.939623,
    "color": "#28a745"
}, {
    "nosamw": "0401967",
    "nama": "Nurna Ningsi Uno",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467499,
    "lng": 121.935772,
    "color": "#28a745"
}, {
    "nosamw": "0401874",
    "nama": "Nuryawati Dunggi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469743,
    "lng": 121.94456,
    "color": "#28a745"
}, {
    "nosamw": "0402849",
    "nama": "Ono Kumasi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1110000,
    "total_denda": 20000,
    "total_jumlah": 1130000,
    "lat": 0.467314,
    "lng": 121.938788,
    "color": "#fd7e14"
}, {
    "nosamw": "0401594",
    "nama": "Optapianus Yilim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 277500,
    "total_denda": 45000,
    "total_jumlah": 322500,
    "lat": 0.467981,
    "lng": 121.935124,
    "color": "#fd7e14"
}, {
    "nosamw": "0401722",
    "nama": "Pakaya Suleman",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473577,
    "lng": 121.945111,
    "color": "#28a745"
}, {
    "nosamw": "0403068",
    "nama": "Palangka Muktiwijaya, SE",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4717655,
    "lng": 121.9468429,
    "color": "#ffc107"
}, {
    "nosamw": "0404572",
    "nama": "Pemi Sabu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471922,
    "lng": 121.942833,
    "color": "#28a745"
}, {
    "nosamw": "0403708",
    "nama": "Puji",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.474552,
    "lng": 121.94104,
    "color": "#28a745"
}, {
    "nosamw": "0402965",
    "nama": "Rafles Takahegesang",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 726000,
    "total_denda": 75000,
    "total_jumlah": 801000,
    "lat": 0.470519,
    "lng": 121.939384,
    "color": "#dc3545"
}, {
    "nosamw": "0400477",
    "nama": "Rahman Daud",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 990000,
    "total_denda": 90000,
    "total_jumlah": 1080000,
    "lat": 0.469039,
    "lng": 121.947604,
    "color": "#dc3545"
}, {
    "nosamw": "0401817",
    "nama": "Rahman Ibrahim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 138250,
    "total_denda": 15000,
    "total_jumlah": 153250,
    "lat": 0.466182,
    "lng": 121.94465,
    "color": "#fd7e14"
}, {
    "nosamw": "0402233",
    "nama": "Rahmat Mayulu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 458000,
    "total_denda": 40000,
    "total_jumlah": 498000,
    "lat": 0.4739401,
    "lng": 121.9483906,
    "color": "#dc3545"
}, {
    "nosamw": "0400844",
    "nama": "Ramayani Nento",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467486,
    "lng": 121.93595,
    "color": "#28a745"
}, {
    "nosamw": "0400588",
    "nama": "Ramly  Abd. Radjak",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.469452,
    "lng": 121.945939,
    "color": "#dc3545"
}, {
    "nosamw": "0407535",
    "nama": "REZKY MESRA",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085242568759",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4666307,
    "lng": 121.9462566,
    "color": "#ffc107"
}, {
    "nosamw": "0402019",
    "nama": "RISWAN IBRAHIM \/ SINTA HASAN",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1190600,
    "total_denda": 130000,
    "total_jumlah": 1320600,
    "lat": 0.4701918,
    "lng": 121.9401688,
    "color": "#dc3545"
}, {
    "nosamw": "0401206",
    "nama": "Rizal Moniaga 2",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468687,
    "lng": 121.946623,
    "color": "#28a745"
}, {
    "nosamw": "0401461",
    "nama": "Roslin A. Ishak",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466161,
    "lng": 121.945475,
    "color": "#28a745"
}, {
    "nosamw": "0401631",
    "nama": "Roswati Monoarfa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467663,
    "lng": 121.937261,
    "color": "#28a745"
}, {
    "nosamw": "0402017",
    "nama": "Rusmin Pasisingi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470179,
    "lng": 121.9405,
    "color": "#28a745"
}, {
    "nosamw": "0400156",
    "nama": "Rustam Dunggio",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467266,
    "lng": 121.93767,
    "color": "#28a745"
}, {
    "nosamw": "0402639",
    "nama": "Saida Hulionu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47526,
    "lng": 121.938591,
    "color": "#28a745"
}, {
    "nosamw": "0403248",
    "nama": "Salam Monoarfa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 847500,
    "total_denda": 125000,
    "total_jumlah": 972500,
    "lat": 0.470241,
    "lng": 121.941648,
    "color": "#dc3545"
}, {
    "nosamw": "0400731",
    "nama": "Salma Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1738200,
    "total_denda": 35000,
    "total_jumlah": 1773200,
    "lat": 0.468518,
    "lng": 121.946731,
    "color": "#dc3545"
}, {
    "nosamw": "0401897",
    "nama": "Samsudin Noor",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467313,
    "lng": 121.938912,
    "color": "#28a745"
}, {
    "nosamw": "0401466",
    "nama": "Sarce Abd. Azis",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469898,
    "lng": 121.947096,
    "color": "#28a745"
}, {
    "nosamw": "0402038",
    "nama": "Sarjon Palinga S.Sos",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 610000,
    "total_denda": 65000,
    "total_jumlah": 675000,
    "lat": 0.47021,
    "lng": 121.940538,
    "color": "#dc3545"
}, {
    "nosamw": "0400150",
    "nama": "Sarni Bumulo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468189,
    "lng": 121.937048,
    "color": "#28a745"
}, {
    "nosamw": "0403250",
    "nama": "Satria Potutu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 633600,
    "total_denda": 80000,
    "total_jumlah": 713600,
    "lat": 0.470083,
    "lng": 121.943727,
    "color": "#dc3545"
}, {
    "nosamw": "0401536",
    "nama": "Sili Abd. Azis",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 571600,
    "total_denda": 85000,
    "total_jumlah": 656600,
    "lat": 0.470852,
    "lng": 121.940299,
    "color": "#dc3545"
}, {
    "nosamw": "0404396",
    "nama": "Sofyan Hajarati",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469515,
    "lng": 121.945942,
    "color": "#28a745"
}, {
    "nosamw": "0401287",
    "nama": "Sofyan Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470351,
    "lng": 121.941429,
    "color": "#28a745"
}, {
    "nosamw": "0400598",
    "nama": "Sofyan Otoluwa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470172,
    "lng": 121.942444,
    "color": "#28a745"
}, {
    "nosamw": "0402374",
    "nama": "Sri Anita Tantu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.477717,
    "lng": 121.950184,
    "color": "#dc3545"
}, {
    "nosamw": "0402209",
    "nama": "Sri Maryati Ahmad",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1828750,
    "total_denda": 145000,
    "total_jumlah": 1973750,
    "lat": 0.472002,
    "lng": 121.943014,
    "color": "#dc3545"
}, {
    "nosamw": "0402353",
    "nama": "Sri Nining Nipi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469815,
    "lng": 121.943297,
    "color": "#28a745"
}, {
    "nosamw": "0406163",
    "nama": "SRI WAHYUNI, S.FARM 1",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 214000,
    "total_denda": 5000,
    "total_jumlah": 219000,
    "lat": 0.4670862,
    "lng": 121.9388937,
    "color": "#ffc107"
}, {
    "nosamw": "0403921",
    "nama": "Sri Wiwin Biga",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 5000,
    "total_jumlah": 86000,
    "lat": 0.469825,
    "lng": 121.957236,
    "color": "#ffc107"
}, {
    "nosamw": "0403752",
    "nama": "Srinildawaty Badu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468787,
    "lng": 121.946644,
    "color": "#28a745"
}, {
    "nosamw": "0402106",
    "nama": "Stela Frida Malik",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470005,
    "lng": 121.942259,
    "color": "#28a745"
}, {
    "nosamw": "0402422",
    "nama": "Sudirto Binding",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47339,
    "lng": 121.944893,
    "color": "#28a745"
}, {
    "nosamw": "0403773",
    "nama": "Sukasih",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4670303,
    "lng": 121.9388066,
    "color": "#28a745"
}, {
    "nosamw": "0401863",
    "nama": "Sulastrika Mohamad",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 55000,
    "total_jumlah": 665000,
    "lat": 0.4699548,
    "lng": 121.9443554,
    "color": "#dc3545"
}, {
    "nosamw": "0404431",
    "nama": "Sumarlin",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1778250,
    "total_denda": 45000,
    "total_jumlah": 1823250,
    "lat": 0.467847,
    "lng": 121.946821,
    "color": "#fd7e14"
}, {
    "nosamw": "0401451",
    "nama": "Sunaryo Ali",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466477,
    "lng": 121.947339,
    "color": "#28a745"
}, {
    "nosamw": "0403249",
    "nama": "Suriyati Rivai",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.472155,
    "lng": 121.941412,
    "color": "#28a745"
}, {
    "nosamw": "0401100",
    "nama": "SYAMSU R. NOER",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.473591,
    "lng": 121.945246,
    "color": "#28a745"
}, {
    "nosamw": "0400058",
    "nama": "Tety Alamri, SE",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4677241,
    "lng": 121.9469327,
    "color": "#28a745"
}, {
    "nosamw": "0402380",
    "nama": "Thaib Babuta",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47054,
    "lng": 121.940765,
    "color": "#28a745"
}, {
    "nosamw": "0404682",
    "nama": "Titi Lapagulu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 413000,
    "total_denda": 75000,
    "total_jumlah": 488000,
    "lat": 0.470012,
    "lng": 121.943224,
    "color": "#dc3545"
}, {
    "nosamw": "0401819",
    "nama": "Trisintia Dewi Panigoro",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47047,
    "lng": 121.942728,
    "color": "#28a745"
}, {
    "nosamw": "0400605",
    "nama": "Tune Monoarfa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 440000,
    "total_denda": 40000,
    "total_jumlah": 480000,
    "lat": 0.470527,
    "lng": 121.940187,
    "color": "#dc3545"
}, {
    "nosamw": "0404087",
    "nama": "USAID Baha Apajulu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46703,
    "lng": 121.944136,
    "color": "#28a745"
}, {
    "nosamw": "0404051",
    "nama": "USAID Berdi Bulango",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467036,
    "lng": 121.944272,
    "color": "#28a745"
}, {
    "nosamw": "0404127",
    "nama": "USAID Darson Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466861,
    "lng": 121.944126,
    "color": "#28a745"
}, {
    "nosamw": "0404141",
    "nama": "USAID Dolly Mbuinga",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469994,
    "lng": 121.943215,
    "color": "#28a745"
}, {
    "nosamw": "0404099",
    "nama": "USAID Ikis doda",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.467053,
    "lng": 121.944208,
    "color": "#fd7e14"
}, {
    "nosamw": "0404047",
    "nama": "USAID Indra Ota",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467278,
    "lng": 121.943977,
    "color": "#28a745"
}, {
    "nosamw": "0404052",
    "nama": "USAID Johan Ayuba",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467518,
    "lng": 121.943872,
    "color": "#28a745"
}, {
    "nosamw": "0404049",
    "nama": "USAID Kuji Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 599750,
    "total_denda": 85000,
    "total_jumlah": 684750,
    "lat": 0.466974,
    "lng": 121.944001,
    "color": "#dc3545"
}, {
    "nosamw": "0404129",
    "nama": "USAID Ono Ota",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467306,
    "lng": 121.943687,
    "color": "#28a745"
}, {
    "nosamw": "0404105",
    "nama": "USAID Oten Bumulo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467074,
    "lng": 121.943841,
    "color": "#28a745"
}, {
    "nosamw": "0404089",
    "nama": "USAID Salim Ladiku",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.467121,
    "lng": 121.944118,
    "color": "#ffc107"
}, {
    "nosamw": "0404228",
    "nama": "USAID Subroto Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 176200,
    "total_denda": 15000,
    "total_jumlah": 191200,
    "lat": 0.466623,
    "lng": 121.945386,
    "color": "#fd7e14"
}, {
    "nosamw": "0404050",
    "nama": "USAID Suni Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.46662,
    "lng": 121.944457,
    "color": "#ffc107"
}, {
    "nosamw": "0404063",
    "nama": "USAID Usman Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 555000,
    "total_denda": 85000,
    "total_jumlah": 640000,
    "lat": 0.471808,
    "lng": 121.945345,
    "color": "#dc3545"
}, {
    "nosamw": "0404098",
    "nama": "USAID Wani Moohulalo",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466592,
    "lng": 121.944062,
    "color": "#28a745"
}, {
    "nosamw": "0404053",
    "nama": "USAID Yuman Lapagula",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 526000,
    "total_denda": 90000,
    "total_jumlah": 616000,
    "lat": 0.467278,
    "lng": 121.943766,
    "color": "#dc3545"
}, {
    "nosamw": "0403507",
    "nama": "Usman",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 773500,
    "total_denda": 65000,
    "total_jumlah": 838500,
    "lat": 0.470575,
    "lng": 121.940154,
    "color": "#dc3545"
}, {
    "nosamw": "0404369",
    "nama": "Usman Pantu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 846500,
    "total_denda": 65000,
    "total_jumlah": 911500,
    "lat": 0.470687,
    "lng": 121.940605,
    "color": "#dc3545"
}, {
    "nosamw": "0401759",
    "nama": "Usman Rupu",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 121000,
    "total_denda": 15000,
    "total_jumlah": 136000,
    "lat": 0.466989,
    "lng": 121.951534,
    "color": "#fd7e14"
}, {
    "nosamw": "0401820",
    "nama": "Vivin Latif",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1487000,
    "total_denda": 70000,
    "total_jumlah": 1557000,
    "lat": 0.467411,
    "lng": 121.938611,
    "color": "#dc3545"
}, {
    "nosamw": "0402510",
    "nama": "Wahab Gani",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 200000,
    "total_denda": 25000,
    "total_jumlah": 225000,
    "lat": 0.467447,
    "lng": 121.938492,
    "color": "#fd7e14"
}, {
    "nosamw": "0401053",
    "nama": "Wahyuningsih, S.Pd.I",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 661500,
    "total_denda": 30000,
    "total_jumlah": 691500,
    "lat": 0.4665307,
    "lng": 121.9447986,
    "color": "#fd7e14"
}, {
    "nosamw": "0401480",
    "nama": "Walasri Husain",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1536500,
    "total_denda": 50000,
    "total_jumlah": 1586500,
    "lat": 0.473726,
    "lng": 121.947263,
    "color": "#dc3545"
}, {
    "nosamw": "0403699",
    "nama": "Wardin Saidi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471567,
    "lng": 121.940218,
    "color": "#28a745"
}, {
    "nosamw": "0401271",
    "nama": "Warni Lawani",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 550000,
    "total_denda": 50000,
    "total_jumlah": 600000,
    "lat": 0.469354,
    "lng": 121.942415,
    "color": "#dc3545"
}, {
    "nosamw": "0400052",
    "nama": "Welly Katili",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172000,
    "total_denda": 5000,
    "total_jumlah": 177000,
    "lat": 0.46763,
    "lng": 121.935264,
    "color": "#ffc107"
}, {
    "nosamw": "0400274",
    "nama": "Winarni Tino",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 3206250,
    "total_denda": 80000,
    "total_jumlah": 3286250,
    "lat": 0.467367,
    "lng": 121.938329,
    "color": "#dc3545"
}, {
    "nosamw": "0400748",
    "nama": "Wiranto Husain",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 940000,
    "total_denda": 85000,
    "total_jumlah": 1025000,
    "lat": 0.4668356,
    "lng": 121.9489204,
    "color": "#dc3545"
}, {
    "nosamw": "0400865",
    "nama": "Yamin Lahay",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466327,
    "lng": 121.943636,
    "color": "#28a745"
}, {
    "nosamw": "0400796",
    "nama": "Yamin Lihawa",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 825000,
    "total_denda": 75000,
    "total_jumlah": 900000,
    "lat": 0.470021,
    "lng": 121.939571,
    "color": "#dc3545"
}, {
    "nosamw": "0402199",
    "nama": "Yanti Datuage",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.471973,
    "lng": 121.942899,
    "color": "#28a745"
}, {
    "nosamw": "0404446",
    "nama": "Yunus Abdullah",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.479519,
    "lng": 121.951647,
    "color": "#28a745"
}, {
    "nosamw": "0402827",
    "nama": "Yunus Potale",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 872000,
    "total_denda": 125000,
    "total_jumlah": 997000,
    "lat": 0.4706303,
    "lng": 121.9410363,
    "color": "#dc3545"
}, {
    "nosamw": "0401044",
    "nama": "Yusni Adam",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.470326,
    "lng": 121.942627,
    "color": "#28a745"
}, {
    "nosamw": "0402330",
    "nama": "Yusri Doda",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1336000,
    "total_denda": 30000,
    "total_jumlah": 1366000,
    "lat": 0.465996,
    "lng": 121.944006,
    "color": "#fd7e14"
}, {
    "nosamw": "0400027",
    "nama": "Yusuf Alhabsi",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467188,
    "lng": 121.93839,
    "color": "#28a745"
}, {
    "nosamw": "0401687",
    "nama": "Yusuf Ibrahim",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47173,
    "lng": 121.945637,
    "color": "#28a745"
}, {
    "nosamw": "0403508",
    "nama": "Yusup Pakaya \/ Laila",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47013,
    "lng": 121.940871,
    "color": "#28a745"
}, {
    "nosamw": "0406857",
    "nama": "ZAINUDIN BOUTY",
    "kecamatan": "KEC MARISA DESA MARISA UTARA",
    "desa": "MARISA UTARA",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4690222,
    "lng": 121.9414124,
    "color": "#ffc107"
}, {
    "nosamw": "0400343",
    "nama": "A. Samir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.4644778,
    "lng": 121.9504017,
    "color": "#ffc107"
}, {
    "nosamw": "0404652",
    "nama": "Abd Wahab Bantahari",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46507,
    "lng": 121.945929,
    "color": "#28a745"
}, {
    "nosamw": "0402293",
    "nama": "Abd. Samad Botutihe",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2738000,
    "total_denda": 100000,
    "total_jumlah": 2838000,
    "lat": 0.462257,
    "lng": 121.951538,
    "color": "#dc3545"
}, {
    "nosamw": "0400586",
    "nama": "Abdul Maskhur Saleh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 771500,
    "total_denda": 15000,
    "total_jumlah": 786500,
    "lat": 0.4645374,
    "lng": 121.9507321,
    "color": "#fd7e14"
}, {
    "nosamw": "0403578",
    "nama": "Abdul Mukmin Suaib",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4638185,
    "lng": 121.9517698,
    "color": "#fd7e14"
}, {
    "nosamw": "0404325",
    "nama": "Abdullah Sabunge",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.459369,
    "lng": 121.953897,
    "color": "#ffc107"
}, {
    "nosamw": "0403097",
    "nama": "Abdurrahman Anggen",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.463261,
    "lng": 121.951732,
    "color": "#ffc107"
}, {
    "nosamw": "0404719",
    "nama": "Abu Bakar Muhamad",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4629668,
    "lng": 121.9461183,
    "color": "#28a745"
}, {
    "nosamw": "0404720",
    "nama": "Adam Saidi Daud",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2457000,
    "total_denda": 75000,
    "total_jumlah": 2532000,
    "lat": 0.462443,
    "lng": 121.950401,
    "color": "#dc3545"
}, {
    "nosamw": "0401338",
    "nama": "Ade Fitriyatna H",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 646500,
    "total_denda": 35000,
    "total_jumlah": 681500,
    "lat": 0.4648102,
    "lng": 121.9481535,
    "color": "#dc3545"
}, {
    "nosamw": "0403537",
    "nama": "Adnan Nasir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 234500,
    "total_denda": 5000,
    "total_jumlah": 239500,
    "lat": 0.4623851,
    "lng": 121.962743,
    "color": "#ffc107"
}, {
    "nosamw": "0403263",
    "nama": "ADRIANUS PANANDA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 304500,
    "total_denda": 15000,
    "total_jumlah": 319500,
    "lat": 0.463993,
    "lng": 121.9502418,
    "color": "#fd7e14"
}, {
    "nosamw": "0402277",
    "nama": "Adrianzah Lihawa II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1080000,
    "total_denda": 10000,
    "total_jumlah": 1090000,
    "lat": 0.462002,
    "lng": 121.951377,
    "color": "#fd7e14"
}, {
    "nosamw": "0402748",
    "nama": "AGNES PUJI ASTUTI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1216500,
    "total_denda": 20000,
    "total_jumlah": 1236500,
    "lat": 0.4619212,
    "lng": 121.9504127,
    "color": "#fd7e14"
}, {
    "nosamw": "0407270",
    "nama": "AGUNG SETIABUDI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.456044,
    "lng": 121.9485553,
    "color": "#ffc107"
}, {
    "nosamw": "0404187",
    "nama": "Agus Hertanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Cabut Meter",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.452613,
    "lng": 121.957347,
    "color": "#28a745"
}, {
    "nosamw": "0407542",
    "nama": "AGUS HULUBANGGA S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082393025235",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4705679,
    "lng": 121.9618013,
    "color": "#fd7e14"
}, {
    "nosamw": "0401478",
    "nama": "Agus Pakaya. SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2959750,
    "total_denda": 110000,
    "total_jumlah": 3069750,
    "lat": 0.467123,
    "lng": 121.955231,
    "color": "#dc3545"
}, {
    "nosamw": "0403128",
    "nama": "AGUS PALAHUATA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 489000,
    "total_denda": 30000,
    "total_jumlah": 519000,
    "lat": 0.4664561,
    "lng": 121.9519202,
    "color": "#dc3545"
}, {
    "nosamw": "0405524",
    "nama": "Agus Sutrisno, S.Ik, MH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 682500,
    "total_denda": 0,
    "total_jumlah": 682500,
    "lat": 0.4668167,
    "lng": 121.9615885,
    "color": "#ffc107"
}, {
    "nosamw": "0401242",
    "nama": "Agussalim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1057500,
    "total_denda": 35000,
    "total_jumlah": 1092500,
    "lat": 0.463913,
    "lng": 121.948695,
    "color": "#dc3545"
}, {
    "nosamw": "0402278",
    "nama": "Ahmad Agusalim S.pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 750000,
    "total_denda": 75000,
    "total_jumlah": 825000,
    "lat": 0.462111,
    "lng": 121.950767,
    "color": "#dc3545"
}, {
    "nosamw": "0405995",
    "nama": "AHMAD PATAMANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 784500,
    "total_denda": 50000,
    "total_jumlah": 834500,
    "lat": 0.466265,
    "lng": 121.9567517,
    "color": "#dc3545"
}, {
    "nosamw": "0404480",
    "nama": "Ahmad Patila",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1130500,
    "total_denda": 75000,
    "total_jumlah": 1205500,
    "lat": 0.466401,
    "lng": 121.9607092,
    "color": "#dc3545"
}, {
    "nosamw": "0404721",
    "nama": "Ahmad Setiadi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 223500,
    "total_denda": 10000,
    "total_jumlah": 233500,
    "lat": 0.462391,
    "lng": 121.950405,
    "color": "#fd7e14"
}, {
    "nosamw": "0402171",
    "nama": "Ainun S.Farm, Apt.",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4617501,
    "lng": 121.9514487,
    "color": "#ffc107"
}, {
    "nosamw": "0403801",
    "nama": "Akram",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.464216,
    "lng": 121.951805,
    "color": "#ffc107"
}, {
    "nosamw": "0403809",
    "nama": "Alan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 185000,
    "total_denda": 5000,
    "total_jumlah": 190000,
    "lat": 0.455852,
    "lng": 121.956511,
    "color": "#ffc107"
}, {
    "nosamw": "0402342",
    "nama": "Albert Pede SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 542500,
    "total_denda": 35000,
    "total_jumlah": 577500,
    "lat": 0.4618679,
    "lng": 121.9508602,
    "color": "#dc3545"
}, {
    "nosamw": "0402202",
    "nama": "Alce",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 230000,
    "total_denda": 10000,
    "total_jumlah": 240000,
    "lat": 0.465929,
    "lng": 121.963072,
    "color": "#fd7e14"
}, {
    "nosamw": "0400319",
    "nama": "Alda Lamondo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.46402,
    "lng": 121.95145,
    "color": "#ffc107"
}, {
    "nosamw": "0403784",
    "nama": "Alfiah, Spi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.4631925,
    "lng": 121.9516896,
    "color": "#ffc107"
}, {
    "nosamw": "0400553",
    "nama": "ALING HAMANG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 421000,
    "total_denda": 25000,
    "total_jumlah": 446000,
    "lat": 0.4638172,
    "lng": 121.9507684,
    "color": "#fd7e14"
}, {
    "nosamw": "0403620",
    "nama": "Altriana Karim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462546,
    "lng": 121.950613,
    "color": "#28a745"
}, {
    "nosamw": "0404173",
    "nama": "Ambrin Kaco",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465113,
    "lng": 121.945224,
    "color": "#28a745"
}, {
    "nosamw": "0404184",
    "nama": "AMBRIN ZAKARIA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465066,
    "lng": 121.946345,
    "color": "#28a745"
}, {
    "nosamw": "0401957",
    "nama": "Amin Daud",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1229500,
    "total_denda": 70000,
    "total_jumlah": 1299500,
    "lat": 0.46357,
    "lng": 121.949239,
    "color": "#dc3545"
}, {
    "nosamw": "0401676",
    "nama": "Amzai",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.464434,
    "lng": 121.949074,
    "color": "#ffc107"
}, {
    "nosamw": "0400504",
    "nama": "Anas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4644674,
    "lng": 121.9506333,
    "color": "#ffc107"
}, {
    "nosamw": "0401937",
    "nama": "Andi Edy",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 210500,
    "total_denda": 10000,
    "total_jumlah": 220500,
    "lat": 0.462059,
    "lng": 121.95061,
    "color": "#fd7e14"
}, {
    "nosamw": "0400374",
    "nama": "Andi Faisal Irwan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 275500,
    "total_denda": 10000,
    "total_jumlah": 285500,
    "lat": 0.462092,
    "lng": 121.951457,
    "color": "#fd7e14"
}, {
    "nosamw": "0407483",
    "nama": "ANDI FITRIANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085240462221",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4534516,
    "lng": 121.9570468,
    "color": "#ffc107"
}, {
    "nosamw": "0400462",
    "nama": "Andi S. Hippi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 449500,
    "total_denda": 10000,
    "total_jumlah": 459500,
    "lat": 0.4644749,
    "lng": 121.9506047,
    "color": "#fd7e14"
}, {
    "nosamw": "0400035",
    "nama": "Andi Sapto Haryoko",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 210500,
    "total_denda": 10000,
    "total_jumlah": 220500,
    "lat": 0.462996,
    "lng": 121.951461,
    "color": "#fd7e14"
}, {
    "nosamw": "0404470",
    "nama": "Andi Ulfa Sari",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 947500,
    "total_denda": 60000,
    "total_jumlah": 1007500,
    "lat": 0.464319,
    "lng": 121.951544,
    "color": "#dc3545"
}, {
    "nosamw": "0401657",
    "nama": "Andika Inaku",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.464593,
    "lng": 121.951751,
    "color": "#ffc107"
}, {
    "nosamw": "0401854",
    "nama": "Andris Dunggio",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 767500,
    "total_denda": 10000,
    "total_jumlah": 777500,
    "lat": 0.462904,
    "lng": 121.950527,
    "color": "#fd7e14"
}, {
    "nosamw": "0401641",
    "nama": "ANDRIYANSYAH PULUBUHU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 391500,
    "total_denda": 30000,
    "total_jumlah": 421500,
    "lat": 0.4660479,
    "lng": 121.9632055,
    "color": "#dc3545"
}, {
    "nosamw": "0401900",
    "nama": "Andy Romandani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 289500,
    "total_denda": 5000,
    "total_jumlah": 294500,
    "lat": 0.463012,
    "lng": 121.950576,
    "color": "#ffc107"
}, {
    "nosamw": "0407551",
    "nama": "ANIS ABAS",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082196852884",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4624517,
    "lng": 121.96317,
    "color": "#ffc107"
}, {
    "nosamw": "0402726",
    "nama": "Anis Gou",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466924,
    "lng": 121.951673,
    "color": "#28a745"
}, {
    "nosamw": "0402369",
    "nama": "Anita Chaidir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1000000,
    "total_denda": 25000,
    "total_jumlah": 1025000,
    "lat": 0.462244,
    "lng": 121.950494,
    "color": "#fd7e14"
}, {
    "nosamw": "0405992",
    "nama": "ANITA RAMADHANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 3892000,
    "total_denda": 25000,
    "total_jumlah": 3917000,
    "lat": 0.4596359,
    "lng": 121.9603754,
    "color": "#fd7e14"
}, {
    "nosamw": "0401060",
    "nama": "Annur",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4631088,
    "lng": 121.9512004,
    "color": "#ffc107"
}, {
    "nosamw": "0402640",
    "nama": "Anton D. Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 324450,
    "total_denda": 15000,
    "total_jumlah": 339450,
    "lat": 0.466312,
    "lng": 121.946256,
    "color": "#fd7e14"
}, {
    "nosamw": "0404137",
    "nama": "ANTONIO SUDARSONO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.473785,
    "lng": 121.938613,
    "color": "#ffc107"
}, {
    "nosamw": "0401990",
    "nama": "Apri Y. Sapan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.46427,
    "lng": 121.951257,
    "color": "#ffc107"
}, {
    "nosamw": "0402502",
    "nama": "Arbaia Dunggio",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 2395500,
    "total_denda": 45000,
    "total_jumlah": 2440500,
    "lat": 0.463198,
    "lng": 121.950584,
    "color": "#dc3545"
}, {
    "nosamw": "0405827",
    "nama": "ARDI ZIKIRI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085779246813",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4638724,
    "lng": 121.9503654,
    "color": "#ffc107"
}, {
    "nosamw": "0401656",
    "nama": "ARIFIN MADJOWA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 207500,
    "total_denda": 5000,
    "total_jumlah": 212500,
    "lat": 0.4623934,
    "lng": 121.9626795,
    "color": "#ffc107"
}, {
    "nosamw": "0403399",
    "nama": "ARIFIN YUSUF",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4638592,
    "lng": 121.9506995,
    "color": "#fd7e14"
}, {
    "nosamw": "0404434",
    "nama": "Arifudin Pikoli",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.464682,
    "lng": 121.951432,
    "color": "#ffc107"
}, {
    "nosamw": "0401639",
    "nama": "Arin Abd. Albakir,SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4641692,
    "lng": 121.950511,
    "color": "#ffc107"
}, {
    "nosamw": "0402213",
    "nama": "Ariyanto Abdullah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 3151250,
    "total_denda": 95000,
    "total_jumlah": 3246250,
    "lat": 0.465183,
    "lng": 121.945419,
    "color": "#dc3545"
}, {
    "nosamw": "0400376",
    "nama": "Arlan Kadir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 840500,
    "total_denda": 15000,
    "total_jumlah": 855500,
    "lat": 0.4644934,
    "lng": 121.9503673,
    "color": "#dc3545"
}, {
    "nosamw": "0404254",
    "nama": "Arman S.sos",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.463637,
    "lng": 121.951361,
    "color": "#fd7e14"
}, {
    "nosamw": "0401987",
    "nama": "ASMARAMAN ABING TUAH SIHALOHO 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 944000,
    "total_denda": 0,
    "total_jumlah": 944000,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#ffc107"
}, {
    "nosamw": "0401408",
    "nama": "ASMARAMAN ABING TUAH SIHALOHO. I",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1448000,
    "total_denda": 0,
    "total_jumlah": 1448000,
    "lat": 0.4870548,
    "lng": 121.9342983,
    "color": "#ffc107"
}, {
    "nosamw": "0405989",
    "nama": "ASNA ISMAIL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4668806,
    "lng": 121.95376,
    "color": "#ffc107"
}, {
    "nosamw": "0401059",
    "nama": "Asnawati Hasan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4642682,
    "lng": 121.9518016,
    "color": "#fd7e14"
}, {
    "nosamw": "0400857",
    "nama": "Asni Karim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465924,
    "lng": 121.963007,
    "color": "#28a745"
}, {
    "nosamw": "0402410",
    "nama": "Asriadi Amd.Tem",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.461836,
    "lng": 121.951513,
    "color": "#ffc107"
}, {
    "nosamw": "0407268",
    "nama": "ASRIYADI, AMD.TEM 1 ",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 152500,
    "total_denda": 5000,
    "total_jumlah": 157500,
    "lat": 0.4605502,
    "lng": 121.9439384,
    "color": "#ffc107"
}, {
    "nosamw": "0403649",
    "nama": "Badria Alamri",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45939,
    "lng": 121.954029,
    "color": "#28a745"
}, {
    "nosamw": "0401831",
    "nama": "Bambang Susanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 668500,
    "total_denda": 30000,
    "total_jumlah": 698500,
    "lat": 0.462327,
    "lng": 121.950552,
    "color": "#dc3545"
}, {
    "nosamw": "0405158",
    "nama": "BAMBANG YUDI HARIYANTO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2239500,
    "total_denda": 75000,
    "total_jumlah": 2314500,
    "lat": 0.4641982,
    "lng": 121.950444,
    "color": "#dc3545"
}, {
    "nosamw": "0400086",
    "nama": "BASRIATI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4641537,
    "lng": 121.9471743,
    "color": "#fd7e14"
}, {
    "nosamw": "0406380",
    "nama": "BAWASLU POHUWATO\/MAHMUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.4580693,
    "lng": 121.9446446,
    "color": "#ffc107"
}, {
    "nosamw": "0402165",
    "nama": "Bayu Adi Nugroho",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.462208,
    "lng": 121.950661,
    "color": "#ffc107"
}, {
    "nosamw": "0406633",
    "nama": "BAYU ARSAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 828500,
    "total_denda": 35000,
    "total_jumlah": 863500,
    "lat": 0.4661859,
    "lng": 121.9636396,
    "color": "#dc3545"
}, {
    "nosamw": "0403003",
    "nama": "Bayu Setiawan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.462099,
    "lng": 121.95088,
    "color": "#fd7e14"
}, {
    "nosamw": "0403026",
    "nama": "Bejo Supriono II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4654916,
    "lng": 121.947237,
    "color": "#28a745"
}, {
    "nosamw": "0401188",
    "nama": "Belly Tomasong",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 784000,
    "total_denda": 10000,
    "total_jumlah": 794000,
    "lat": 0.461305,
    "lng": 121.961906,
    "color": "#ffc107"
}, {
    "nosamw": "0402607",
    "nama": "Beni Yusuf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 77200,
    "total_denda": 5000,
    "total_jumlah": 82200,
    "lat": 0.465978,
    "lng": 121.945033,
    "color": "#ffc107"
}, {
    "nosamw": "0404323",
    "nama": "Binti Tilameo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 340500,
    "total_denda": 10000,
    "total_jumlah": 350500,
    "lat": 0.4630901,
    "lng": 121.9516473,
    "color": "#fd7e14"
}, {
    "nosamw": "0401334",
    "nama": "Boki Bahmid, SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 750000,
    "total_denda": 20000,
    "total_jumlah": 770000,
    "lat": 0.4641412,
    "lng": 121.9482359,
    "color": "#fd7e14"
}, {
    "nosamw": "0402600",
    "nama": "Boni Yusuf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4648277,
    "lng": 121.9446013,
    "color": "#28a745"
}, {
    "nosamw": "0401961",
    "nama": "BPPKP Pohuwato",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1262500,
    "total_denda": 0,
    "total_jumlah": 1262500,
    "lat": 0.456246,
    "lng": 121.948857,
    "color": "#ffc107"
}, {
    "nosamw": "0407547",
    "nama": "BUMDES PALOPO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082393025235",
    "total_bulan": 7,
    "total_tagihan": 1513000,
    "total_denda": 30000,
    "total_jumlah": 1543000,
    "lat": 0.4634143,
    "lng": 121.9616743,
    "color": "#dc3545"
}, {
    "nosamw": "0400267",
    "nama": "Buyung H. Ismail",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4641786,
    "lng": 121.9504463,
    "color": "#ffc107"
}, {
    "nosamw": "0400696",
    "nama": "CAHYADI PUTRA JAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 432500,
    "total_denda": 10000,
    "total_jumlah": 442500,
    "lat": 0.4638483,
    "lng": 121.9516771,
    "color": "#fd7e14"
}, {
    "nosamw": "0402473",
    "nama": "Cintamidiniyati Utiah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462667,
    "lng": 121.9506507,
    "color": "#28a745"
}, {
    "nosamw": "0407565",
    "nama": "DAHLAN HAPULU, SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085215570117",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4636436,
    "lng": 121.950277,
    "color": "#ffc107"
}, {
    "nosamw": "0402211",
    "nama": "Danny Davincy,ST",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 977000,
    "total_denda": 25000,
    "total_jumlah": 1002000,
    "lat": 0.4631135,
    "lng": 121.9507067,
    "color": "#fd7e14"
}, {
    "nosamw": "0402220",
    "nama": "Dariyatmo Dulman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 629000,
    "total_denda": 20000,
    "total_jumlah": 649000,
    "lat": 0.461859,
    "lng": 121.950539,
    "color": "#fd7e14"
}, {
    "nosamw": "0404541",
    "nama": "Darmiaty Dahar, SP",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4633562,
    "lng": 121.9518013,
    "color": "#ffc107"
}, {
    "nosamw": "0403094",
    "nama": "Darminanty Olii",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466049,
    "lng": 121.945301,
    "color": "#28a745"
}, {
    "nosamw": "0400886",
    "nama": "Darna Tobuhu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4620104,
    "lng": 121.9536665,
    "color": "#ffc107"
}, {
    "nosamw": "0403112",
    "nama": "Dealer Suzuki",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 93500,
    "total_denda": 0,
    "total_jumlah": 93500,
    "lat": 0.466962,
    "lng": 121.956268,
    "color": "#ffc107"
}, {
    "nosamw": "0403270",
    "nama": "Decky Hendrawanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 381000,
    "total_denda": 5000,
    "total_jumlah": 386000,
    "lat": 0.4639035,
    "lng": 121.9507117,
    "color": "#ffc107"
}, {
    "nosamw": "0402059",
    "nama": "Dede Musa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 649500,
    "total_denda": 40000,
    "total_jumlah": 689500,
    "lat": 0.465033,
    "lng": 121.945639,
    "color": "#dc3545"
}, {
    "nosamw": "0403549",
    "nama": "Dewa Ayu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.464242,
    "lng": 121.951491,
    "color": "#fd7e14"
}, {
    "nosamw": "0401664",
    "nama": "Dewi Maryanti Biki",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 307500,
    "total_denda": 0,
    "total_jumlah": 307500,
    "lat": 0.464061,
    "lng": 121.948507,
    "color": "#ffc107"
}, {
    "nosamw": "0400110",
    "nama": "Dewi Patimah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 692000,
    "total_denda": 20000,
    "total_jumlah": 712000,
    "lat": 0.4638524,
    "lng": 121.9517802,
    "color": "#fd7e14"
}, {
    "nosamw": "0404761",
    "nama": "Dewi s. rubai.",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 580000,
    "total_denda": 30000,
    "total_jumlah": 610000,
    "lat": 0.4630542,
    "lng": 121.9517521,
    "color": "#dc3545"
}, {
    "nosamw": "0405113",
    "nama": "DEWI WONG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4645113,
    "lng": 121.9513276,
    "color": "#ffc107"
}, {
    "nosamw": "0403692",
    "nama": "Dian Abdjul, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 3795500,
    "total_denda": 115000,
    "total_jumlah": 3910500,
    "lat": 0.4641151,
    "lng": 121.9513629,
    "color": "#dc3545"
}, {
    "nosamw": "0401397",
    "nama": "Dian Abdullah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4643391,
    "lng": 121.9510267,
    "color": "#ffc107"
}, {
    "nosamw": "0402525",
    "nama": "Dian Bastiar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 327500,
    "total_denda": 10000,
    "total_jumlah": 337500,
    "lat": 0.462774,
    "lng": 121.950504,
    "color": "#fd7e14"
}, {
    "nosamw": "0401066",
    "nama": "DIAN ERVINA PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4641784,
    "lng": 121.9509279,
    "color": "#ffc107"
}, {
    "nosamw": "0405979",
    "nama": "DIAN HALAA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1308000,
    "total_denda": 30000,
    "total_jumlah": 1338000,
    "lat": 0.4596998,
    "lng": 121.9599965,
    "color": "#dc3545"
}, {
    "nosamw": "0401303",
    "nama": "Dinas Kehutanan \/ Lingk.H",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 17960000,
    "total_denda": 320000,
    "total_jumlah": 18280000,
    "lat": 0.461106,
    "lng": 121.945068,
    "color": "#dc3545"
}, {
    "nosamw": "0402448",
    "nama": "Diong Sitompul, SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1756000,
    "total_denda": 35000,
    "total_jumlah": 1791000,
    "lat": 0.4616058,
    "lng": 121.9517754,
    "color": "#dc3545"
}, {
    "nosamw": "0401552",
    "nama": "Djafar Nusupu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 101800,
    "total_denda": 10000,
    "total_jumlah": 111800,
    "lat": 0.459106,
    "lng": 121.959624,
    "color": "#fd7e14"
}, {
    "nosamw": "0401661",
    "nama": "Djafar Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.467205,
    "lng": 121.954823,
    "color": "#ffc107"
}, {
    "nosamw": "0400528",
    "nama": "DJAFAR YASIN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4642,
    "lng": 121.9505207,
    "color": "#ffc107"
}, {
    "nosamw": "0403281",
    "nama": "Djemy Poha",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 425000,
    "total_denda": 5000,
    "total_jumlah": 430000,
    "lat": 0.462319,
    "lng": 121.963074,
    "color": "#ffc107"
}, {
    "nosamw": "0402040",
    "nama": "Djoni Abjul \/ Merlian P.G",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.463381,
    "lng": 121.951593,
    "color": "#fd7e14"
}, {
    "nosamw": "0403114",
    "nama": "Drh. Nasir Efendi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.463077,
    "lng": 121.951713,
    "color": "#ffc107"
}, {
    "nosamw": "0402512",
    "nama": "DRH. Yani Susilo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.463194,
    "lng": 121.94906,
    "color": "#fd7e14"
}, {
    "nosamw": "0401751",
    "nama": "Drs, Idris Djafar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4660715,
    "lng": 121.962955,
    "color": "#fd7e14"
}, {
    "nosamw": "0401335",
    "nama": "Drs. M Mustafa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1391000,
    "total_denda": 65000,
    "total_jumlah": 1456000,
    "lat": 0.463861,
    "lng": 121.948614,
    "color": "#dc3545"
}, {
    "nosamw": "0400567",
    "nama": "Drs. Mohamad Mustafa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463875,
    "lng": 121.947607,
    "color": "#28a745"
}, {
    "nosamw": "0400391",
    "nama": "Drs. Ramon Abjul",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 262500,
    "total_denda": 5000,
    "total_jumlah": 267500,
    "lat": 0.463698,
    "lng": 121.949332,
    "color": "#ffc107"
}, {
    "nosamw": "0401501",
    "nama": "Drs. Zairin Td.m",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 623000,
    "total_denda": 50000,
    "total_jumlah": 673000,
    "lat": 0.464647,
    "lng": 121.948549,
    "color": "#dc3545"
}, {
    "nosamw": "0401752",
    "nama": "Dwiyanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 217500,
    "total_denda": 0,
    "total_jumlah": 217500,
    "lat": 0.463999,
    "lng": 121.949439,
    "color": "#ffc107"
}, {
    "nosamw": "0402483",
    "nama": "Ebit Desei, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 173500,
    "total_denda": 5000,
    "total_jumlah": 178500,
    "lat": 0.4615749,
    "lng": 121.9512876,
    "color": "#ffc107"
}, {
    "nosamw": "0406367",
    "nama": "EFENDY",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 3768000,
    "total_denda": 160000,
    "total_jumlah": 3928000,
    "lat": 0.4638413,
    "lng": 121.9507784,
    "color": "#dc3545"
}, {
    "nosamw": "0402465",
    "nama": "Efy Marfiany Luma",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 440000,
    "total_denda": 40000,
    "total_jumlah": 480000,
    "lat": 0.462099,
    "lng": 121.951377,
    "color": "#dc3545"
}, {
    "nosamw": "0403768",
    "nama": "Eka Setiawan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464177,
    "lng": 121.951798,
    "color": "#28a745"
}, {
    "nosamw": "0403018",
    "nama": "Eko Kristanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 550000,
    "total_denda": 50000,
    "total_jumlah": 600000,
    "lat": 0.461913,
    "lng": 121.951476,
    "color": "#dc3545"
}, {
    "nosamw": "0404449",
    "nama": "Eko Widodo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 157500,
    "total_denda": 0,
    "total_jumlah": 157500,
    "lat": 0.4639065,
    "lng": 121.9504629,
    "color": "#ffc107"
}, {
    "nosamw": "0407527",
    "nama": "ELFIANTI (KOTEX)",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085214377839",
    "total_bulan": 7,
    "total_tagihan": 3332500,
    "total_denda": 30000,
    "total_jumlah": 3362500,
    "lat": 0.4592808,
    "lng": 121.9600836,
    "color": "#dc3545"
}, {
    "nosamw": "0402451",
    "nama": "Eli Rumampuk",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 270000,
    "total_denda": 0,
    "total_jumlah": 270000,
    "lat": 0.462053,
    "lng": 121.951291,
    "color": "#ffc107"
}, {
    "nosamw": "0401978",
    "nama": "ELIS MBUINGA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356243562",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4644814,
    "lng": 121.9512505,
    "color": "#ffc107"
}, {
    "nosamw": "0402528",
    "nama": "Elis Suaiba",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.46192,
    "lng": 121.950427,
    "color": "#ffc107"
}, {
    "nosamw": "0407519",
    "nama": "ELISABETH D. LOSSO 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085213723359",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4576029,
    "lng": 121.9585462,
    "color": "#ffc107"
}, {
    "nosamw": "0401974",
    "nama": "Endang Suyati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 580500,
    "total_denda": 20000,
    "total_jumlah": 600500,
    "lat": 0.46195,
    "lng": 121.950291,
    "color": "#fd7e14"
}, {
    "nosamw": "0402500",
    "nama": "ENDRAWATY YUSUF",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 304500,
    "total_denda": 20000,
    "total_jumlah": 324500,
    "lat": 0.4646191,
    "lng": 121.9445035,
    "color": "#fd7e14"
}, {
    "nosamw": "0407421",
    "nama": "ERLIS NOHO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085396317156",
    "total_bulan": 6,
    "total_tagihan": 1460500,
    "total_denda": 25000,
    "total_jumlah": 1485500,
    "lat": 0.4565218,
    "lng": 121.9508192,
    "color": "#fd7e14"
}, {
    "nosamw": "0402068",
    "nama": "Erni Djakaria",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.465106,
    "lng": 121.946162,
    "color": "#fd7e14"
}, {
    "nosamw": "0403534",
    "nama": "Erse Drawana Pertiwi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.463847,
    "lng": 121.951749,
    "color": "#ffc107"
}, {
    "nosamw": "0404145",
    "nama": "Ervana Gosal",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.46422,
    "lng": 121.951514,
    "color": "#ffc107"
}, {
    "nosamw": "0405908",
    "nama": "ERVINA AKILI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4638147,
    "lng": 121.9509503,
    "color": "#ffc107"
}, {
    "nosamw": "0404215",
    "nama": "Erwin Gaib",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165000,
    "total_denda": 0,
    "total_jumlah": 165000,
    "lat": 0.463909,
    "lng": 121.951786,
    "color": "#ffc107"
}, {
    "nosamw": "0401911",
    "nama": "Esa Emmalya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463454,
    "lng": 121.949488,
    "color": "#ffc107"
}, {
    "nosamw": "0401899",
    "nama": "Eton Bawu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 303500,
    "total_denda": 5000,
    "total_jumlah": 308500,
    "lat": 0.462869,
    "lng": 121.951057,
    "color": "#ffc107"
}, {
    "nosamw": "0400787",
    "nama": "EWIN PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 249500,
    "total_denda": 10000,
    "total_jumlah": 259500,
    "lat": 0.4645238,
    "lng": 121.9509582,
    "color": "#fd7e14"
}, {
    "nosamw": "0407297",
    "nama": "EWIN PAKAYA 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082227341988",
    "total_bulan": 5,
    "total_tagihan": 1715000,
    "total_denda": 20000,
    "total_jumlah": 1735000,
    "lat": 0.4607432,
    "lng": 121.949758,
    "color": "#fd7e14"
}, {
    "nosamw": "0405159",
    "nama": "FAHMI SULEMAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4641667,
    "lng": 121.9502634,
    "color": "#ffc107"
}, {
    "nosamw": "0404495",
    "nama": "Faidil",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 789000,
    "total_denda": 35000,
    "total_jumlah": 824000,
    "lat": 0.46411,
    "lng": 121.951781,
    "color": "#dc3545"
}, {
    "nosamw": "0401295",
    "nama": "Faisal Poli",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1114500,
    "total_denda": 75000,
    "total_jumlah": 1189500,
    "lat": 0.463925,
    "lng": 121.948848,
    "color": "#dc3545"
}, {
    "nosamw": "0402670",
    "nama": "Famawati Pongoliu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 697800,
    "total_denda": 60000,
    "total_jumlah": 757800,
    "lat": 0.4679144,
    "lng": 121.9480152,
    "color": "#dc3545"
}, {
    "nosamw": "0401149",
    "nama": "FARID ABD. GANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 5000,
    "total_jumlah": 147500,
    "lat": 0.4645371,
    "lng": 121.950688,
    "color": "#ffc107"
}, {
    "nosamw": "0406611",
    "nama": "FARID HIDIYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 529500,
    "total_denda": 35000,
    "total_jumlah": 564500,
    "lat": 0.466051,
    "lng": 121.9633074,
    "color": "#dc3545"
}, {
    "nosamw": "0403129",
    "nama": "Farida Polapa\/Perum G.M.I",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 336500,
    "total_denda": 25000,
    "total_jumlah": 361500,
    "lat": 0.46424,
    "lng": 121.951859,
    "color": "#fd7e14"
}, {
    "nosamw": "0403387",
    "nama": "FATIMAH SARJONO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 187500,
    "total_denda": 0,
    "total_jumlah": 187500,
    "lat": 0.448708,
    "lng": 121.941591,
    "color": "#ffc107"
}, {
    "nosamw": "0404685",
    "nama": "Fatma Abdullah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1518000,
    "total_denda": 75000,
    "total_jumlah": 1593000,
    "lat": 0.464997,
    "lng": 121.945788,
    "color": "#dc3545"
}, {
    "nosamw": "0402018",
    "nama": "Fatma Hamid",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 453500,
    "total_denda": 25000,
    "total_jumlah": 478500,
    "lat": 0.4605,
    "lng": 121.960843,
    "color": "#fd7e14"
}, {
    "nosamw": "0402859",
    "nama": "FATMA ISA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4568559,
    "lng": 121.9518757,
    "color": "#ffc107"
}, {
    "nosamw": "0402231",
    "nama": "Fatma Juita Datau",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 3585000,
    "total_denda": 25000,
    "total_jumlah": 3610000,
    "lat": 0.4621275,
    "lng": 121.9500687,
    "color": "#fd7e14"
}, {
    "nosamw": "0405490",
    "nama": "FATMA NURUL HUDA ABAS",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4641585,
    "lng": 121.9501743,
    "color": "#ffc107"
}, {
    "nosamw": "0400638",
    "nama": "Fatmah Bafadhal ( 1 )",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 720000,
    "total_denda": 60000,
    "total_jumlah": 780000,
    "lat": 0.463924,
    "lng": 121.948415,
    "color": "#dc3545"
}, {
    "nosamw": "0401791",
    "nama": "Fd. Tohoro",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 820000,
    "total_denda": 70000,
    "total_jumlah": 890000,
    "lat": 0.464482,
    "lng": 121.9492217,
    "color": "#dc3545"
}, {
    "nosamw": "0404763",
    "nama": "Febriyanto Detu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085396885391",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4649101,
    "lng": 121.9445325,
    "color": "#28a745"
}, {
    "nosamw": "0401677",
    "nama": "Fendy Billy H. Pangkey",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 717000,
    "total_denda": 20000,
    "total_jumlah": 737000,
    "lat": 0.464265,
    "lng": 121.949336,
    "color": "#fd7e14"
}, {
    "nosamw": "0401703",
    "nama": "Ferawati Umar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.46424,
    "lng": 121.9508343,
    "color": "#fd7e14"
}, {
    "nosamw": "0401850",
    "nama": "Ferawaty Mbuinga II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 390500,
    "total_denda": 35000,
    "total_jumlah": 425500,
    "lat": 0.464669,
    "lng": 121.949747,
    "color": "#dc3545"
}, {
    "nosamw": "0402057",
    "nama": "Feri Ma ruf A.Ma.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4873855,
    "lng": 121.9354316,
    "color": "#28a745"
}, {
    "nosamw": "0403039",
    "nama": "Firman Ikhwan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1340000,
    "total_denda": 20000,
    "total_jumlah": 1360000,
    "lat": 0.464168,
    "lng": 121.949621,
    "color": "#fd7e14"
}, {
    "nosamw": "0403815",
    "nama": "Firmansyah Mile",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.464183,
    "lng": 121.951748,
    "color": "#ffc107"
}, {
    "nosamw": "0404540",
    "nama": "Firza Ingka Mewoh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 308000,
    "total_denda": 10000,
    "total_jumlah": 318000,
    "lat": 0.458404,
    "lng": 121.954664,
    "color": "#fd7e14"
}, {
    "nosamw": "0402208",
    "nama": "Fitria N. Tahir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461764,
    "lng": 121.95064,
    "color": "#28a745"
}, {
    "nosamw": "0402258",
    "nama": "Fitriya Abdurahman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1342000,
    "total_denda": 100000,
    "total_jumlah": 1442000,
    "lat": 0.462434,
    "lng": 121.951293,
    "color": "#dc3545"
}, {
    "nosamw": "0401845",
    "nama": "Fitriyani Abdussamad",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464893,
    "lng": 121.949192,
    "color": "#28a745"
}, {
    "nosamw": "0407326",
    "nama": "Fitriyanti Hiola",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.4615573,
    "lng": 121.9509128,
    "color": "#ffc107"
}, {
    "nosamw": "0401404",
    "nama": "FREDOLIN YUNUS ALFIAN NURDIN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4599795,
    "lng": 121.9551055,
    "color": "#fd7e14"
}, {
    "nosamw": "0401171",
    "nama": "FRENGKY KIRIMANG( KANTIN KODIM )",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085298327140",
    "total_bulan": 4,
    "total_tagihan": 622500,
    "total_denda": 15000,
    "total_jumlah": 637500,
    "lat": 0.4564464,
    "lng": 121.9506752,
    "color": "#fd7e14"
}, {
    "nosamw": "0407461",
    "nama": "FRISKA LIZA MAHDA RONDONUWU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085223115000",
    "total_bulan": 1,
    "total_tagihan": 1747500,
    "total_denda": 0,
    "total_jumlah": 1747500,
    "lat": 0.4576696,
    "lng": 121.9401378,
    "color": "#ffc107"
}, {
    "nosamw": "0406374",
    "nama": "Gayus Rambiko",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 561000,
    "total_denda": 20000,
    "total_jumlah": 581000,
    "lat": 0.4638967,
    "lng": 121.9504394,
    "color": "#fd7e14"
}, {
    "nosamw": "0401949",
    "nama": "Gias Taha, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 450000,
    "total_denda": 30000,
    "total_jumlah": 480000,
    "lat": 0.4658587,
    "lng": 121.9627191,
    "color": "#dc3545"
}, {
    "nosamw": "0407566",
    "nama": "GITA FEBRIANITA ARMAN MOHI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085215570117",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4637153,
    "lng": 121.9502449,
    "color": "#ffc107"
}, {
    "nosamw": "0402480",
    "nama": "Goan A. Dako, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 237500,
    "total_denda": 5000,
    "total_jumlah": 242500,
    "lat": 0.4628432,
    "lng": 121.95044,
    "color": "#ffc107"
}, {
    "nosamw": "0401108",
    "nama": "Griya M. Indah I\/1 \/ Ilya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463969,
    "lng": 121.9484,
    "color": "#ffc107"
}, {
    "nosamw": "0401109",
    "nama": "Griya M. Indah I\/2 \/ Mahy",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.46407,
    "lng": 121.948222,
    "color": "#ffc107"
}, {
    "nosamw": "0401110",
    "nama": "Griya M. Indah I\/3 \/ Novi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 2217500,
    "total_denda": 155000,
    "total_jumlah": 2372500,
    "lat": 0.463959,
    "lng": 121.948305,
    "color": "#dc3545"
}, {
    "nosamw": "0401166",
    "nama": "Griya M. Indah I\/4 \/ Elfi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 605000,
    "total_denda": 55000,
    "total_jumlah": 660000,
    "lat": 0.4641,
    "lng": 121.948003,
    "color": "#dc3545"
}, {
    "nosamw": "0401111",
    "nama": "Griya M. Indah I\/5 \/ Suwa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1214000,
    "total_denda": 100000,
    "total_jumlah": 1314000,
    "lat": 0.463736,
    "lng": 121.948278,
    "color": "#dc3545"
}, {
    "nosamw": "0401162",
    "nama": "Griya M. Indah I\/6 \/ Budi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463795,
    "lng": 121.948248,
    "color": "#ffc107"
}, {
    "nosamw": "0401165",
    "nama": "Griya M. Indah K\/4 \/ Nely",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 542500,
    "total_denda": 35000,
    "total_jumlah": 577500,
    "lat": 0.463828,
    "lng": 121.948648,
    "color": "#dc3545"
}, {
    "nosamw": "0401168",
    "nama": "Griya M. Indah K\/5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2672500,
    "total_denda": 110000,
    "total_jumlah": 2782500,
    "lat": 0.4639427,
    "lng": 121.9485188,
    "color": "#dc3545"
}, {
    "nosamw": "0401221",
    "nama": "Griya M. Indah K\/6",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 616000,
    "total_denda": 20000,
    "total_jumlah": 636000,
    "lat": 0.463854,
    "lng": 121.948395,
    "color": "#fd7e14"
}, {
    "nosamw": "0407256",
    "nama": "GUFRON IBRAHIM, SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 356000,
    "total_denda": 25000,
    "total_jumlah": 381000,
    "lat": 0.4594072,
    "lng": 121.9543383,
    "color": "#fd7e14"
}, {
    "nosamw": "0407379",
    "nama": "H. MUHAMMAD 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.4637242,
    "lng": 121.9471345,
    "color": "#ffc107"
}, {
    "nosamw": "0407380",
    "nama": "H. MUHAMMAD 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463717,
    "lng": 121.9471395,
    "color": "#ffc107"
}, {
    "nosamw": "0407381",
    "nama": "H. MUHAMMAD 3",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.4637339,
    "lng": 121.9471413,
    "color": "#dc3545"
}, {
    "nosamw": "0407418",
    "nama": "H. MUHAMMAD 4",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081355575558",
    "total_bulan": 7,
    "total_tagihan": 991500,
    "total_denda": 30000,
    "total_jumlah": 1021500,
    "lat": 0.4638105,
    "lng": 121.9471313,
    "color": "#dc3545"
}, {
    "nosamw": "0407417",
    "nama": "H. MUHAMMAD 5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082190074737",
    "total_bulan": 5,
    "total_tagihan": 288000,
    "total_denda": 25000,
    "total_jumlah": 313000,
    "lat": 0.4639535,
    "lng": 121.947117,
    "color": "#fd7e14"
}, {
    "nosamw": "0406509",
    "nama": "H18 ABDUL KARIM KAMBUNGU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 2429500,
    "total_denda": 120000,
    "total_jumlah": 2549500,
    "lat": 0.466369,
    "lng": 121.9513865,
    "color": "#dc3545"
}, {
    "nosamw": "0406448",
    "nama": "H18 ABDULLAH DAMA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 341500,
    "total_denda": 10000,
    "total_jumlah": 351500,
    "lat": 0.4644683,
    "lng": 121.9445605,
    "color": "#fd7e14"
}, {
    "nosamw": "0406525",
    "nama": "H18 ADAM NASUPU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4612952,
    "lng": 121.9513994,
    "color": "#fd7e14"
}, {
    "nosamw": "0406493",
    "nama": "H18 ADLIN GANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4571043,
    "lng": 121.9517824,
    "color": "#ffc107"
}, {
    "nosamw": "0406492",
    "nama": "H18 AGUS BAGU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 617000,
    "total_denda": 45000,
    "total_jumlah": 662000,
    "lat": 0.4656037,
    "lng": 121.9453875,
    "color": "#dc3545"
}, {
    "nosamw": "0406427",
    "nama": "H18 AGUSTIN USMAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 514000,
    "total_denda": 70000,
    "total_jumlah": 584000,
    "lat": 0.4571853,
    "lng": 121.9514218,
    "color": "#dc3545"
}, {
    "nosamw": "0406559",
    "nama": "H18 AJIS HUDODO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 778800,
    "total_denda": 80000,
    "total_jumlah": 858800,
    "lat": 0.4569041,
    "lng": 121.9514324,
    "color": "#dc3545"
}, {
    "nosamw": "0406510",
    "nama": "H18 ALI SALEH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4670887,
    "lng": 121.9505302,
    "color": "#ffc107"
}, {
    "nosamw": "0406386",
    "nama": "H18 ANCA ABUDI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 58200,
    "total_denda": 0,
    "total_jumlah": 58200,
    "lat": 0.4574443,
    "lng": 121.9512378,
    "color": "#ffc107"
}, {
    "nosamw": "0406511",
    "nama": "H18 ANTON D. PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 260000,
    "total_denda": 20000,
    "total_jumlah": 280000,
    "lat": 0.464216,
    "lng": 121.9502184,
    "color": "#fd7e14"
}, {
    "nosamw": "0406489",
    "nama": "H18 ANTON LIBUNELO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 38600,
    "total_denda": 0,
    "total_jumlah": 38600,
    "lat": 0.4572456,
    "lng": 121.9511855,
    "color": "#ffc107"
}, {
    "nosamw": "0406490",
    "nama": "H18 APRIYULAN ABDULAH S.TP",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 105000,
    "total_denda": 10000,
    "total_jumlah": 115000,
    "lat": 0.4572323,
    "lng": 121.95123,
    "color": "#fd7e14"
}, {
    "nosamw": "0406494",
    "nama": "H18 ARIPIN LAMAPA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 948500,
    "total_denda": 30000,
    "total_jumlah": 978500,
    "lat": 0.4653288,
    "lng": 121.9448871,
    "color": "#dc3545"
}, {
    "nosamw": "0406541",
    "nama": "H18 B1 \/ 11",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4664742,
    "lng": 121.9639577,
    "color": "#ffc107"
}, {
    "nosamw": "0406543",
    "nama": "H18 B1 \/ 13",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 252500,
    "total_denda": 15000,
    "total_jumlah": 267500,
    "lat": 0.4665166,
    "lng": 121.9641038,
    "color": "#fd7e14"
}, {
    "nosamw": "0406544",
    "nama": "H18 B1 \/ 14",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1322500,
    "total_denda": 65000,
    "total_jumlah": 1387500,
    "lat": 0.4665162,
    "lng": 121.9640853,
    "color": "#dc3545"
}, {
    "nosamw": "0406608",
    "nama": "H18 B1 \/ 27",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 479500,
    "total_denda": 15000,
    "total_jumlah": 494500,
    "lat": 0.4661186,
    "lng": 121.9634568,
    "color": "#fd7e14"
}, {
    "nosamw": "0406631",
    "nama": "H18 B1 \/ 28",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.466052,
    "lng": 121.9633306,
    "color": "#fd7e14"
}, {
    "nosamw": "0406491",
    "nama": "H18 BAHLIN MASULILI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 344000,
    "total_denda": 40000,
    "total_jumlah": 384000,
    "lat": 0.4572135,
    "lng": 121.9513941,
    "color": "#dc3545"
}, {
    "nosamw": "0406623",
    "nama": "H18 C1 \/ 28",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 847000,
    "total_denda": 75000,
    "total_jumlah": 922000,
    "lat": 0.4657441,
    "lng": 121.9633463,
    "color": "#dc3545"
}, {
    "nosamw": "0406612",
    "nama": "H18 C1 \/ 4",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 239500,
    "total_denda": 15000,
    "total_jumlah": 254500,
    "lat": 0.4660976,
    "lng": 121.9634249,
    "color": "#fd7e14"
}, {
    "nosamw": "0406613",
    "nama": "H18 C1 \/ 5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 859500,
    "total_denda": 65000,
    "total_jumlah": 924500,
    "lat": 0.4661275,
    "lng": 121.9635858,
    "color": "#dc3545"
}, {
    "nosamw": "0406614",
    "nama": "H18 C1 \/ 6",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1090000,
    "total_denda": 70000,
    "total_jumlah": 1160000,
    "lat": 0.4661053,
    "lng": 121.9635857,
    "color": "#dc3545"
}, {
    "nosamw": "0406615",
    "nama": "H18 C1 \/ 7",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 541000,
    "total_denda": 30000,
    "total_jumlah": 571000,
    "lat": 0.4661445,
    "lng": 121.9636497,
    "color": "#dc3545"
}, {
    "nosamw": "0406616",
    "nama": "H18 C1 \/ 9",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4662578,
    "lng": 121.9638533,
    "color": "#ffc107"
}, {
    "nosamw": "0406513",
    "nama": "H18 DARMIN TOBUHU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4668695,
    "lng": 121.9505785,
    "color": "#28a745"
}, {
    "nosamw": "0406369",
    "nama": "H18 Endang Rianti Supu C1 \/ 26",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.4658664,
    "lng": 121.9634901,
    "color": "#ffc107"
}, {
    "nosamw": "0406496",
    "nama": "H18 ERLAN BAGU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.464467,
    "lng": 121.944038,
    "color": "#ffc107"
}, {
    "nosamw": "0406551",
    "nama": "H18 FATMA BALIDE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 168400,
    "total_denda": 20000,
    "total_jumlah": 188400,
    "lat": 0.4450209,
    "lng": 121.939186,
    "color": "#fd7e14"
}, {
    "nosamw": "0406498",
    "nama": "H18 FITRI TOONAWU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 179750,
    "total_denda": 20000,
    "total_jumlah": 199750,
    "lat": 0.4660702,
    "lng": 121.945377,
    "color": "#fd7e14"
}, {
    "nosamw": "0406605",
    "nama": "H18 FITRIYANTI TAMLY",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85500,
    "total_denda": 0,
    "total_jumlah": 85500,
    "lat": 0.4618684,
    "lng": 121.9496791,
    "color": "#ffc107"
}, {
    "nosamw": "0406641",
    "nama": "H18 HADIJAH KADIR",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4625391,
    "lng": 121.9498643,
    "color": "#ffc107"
}, {
    "nosamw": "0406514",
    "nama": "H18 HAMID TOBUHU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 38600,
    "total_denda": 0,
    "total_jumlah": 38600,
    "lat": 0.4663529,
    "lng": 121.9512942,
    "color": "#ffc107"
}, {
    "nosamw": "0406499",
    "nama": "H18 HAMU TOONAWU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 395000,
    "total_denda": 25000,
    "total_jumlah": 420000,
    "lat": 0.4656472,
    "lng": 121.9453494,
    "color": "#fd7e14"
}, {
    "nosamw": "0406500",
    "nama": "H18 HAPNI USMAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4660781,
    "lng": 121.9453255,
    "color": "#fd7e14"
}, {
    "nosamw": "0406421",
    "nama": "H18 HERMAN ARU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 15000,
    "total_jumlah": 114000,
    "lat": 0.4574102,
    "lng": 121.9517,
    "color": "#fd7e14"
}, {
    "nosamw": "0406538",
    "nama": "H18 HERMAN YUNUS \/ B1 \/ 8",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 643500,
    "total_denda": 55000,
    "total_jumlah": 698500,
    "lat": 0.4663098,
    "lng": 121.9630479,
    "color": "#dc3545"
}, {
    "nosamw": "0406634",
    "nama": "H18 IDA IRAWATI, S.Sos \/ B1 \/ 23",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 906000,
    "total_denda": 45000,
    "total_jumlah": 951000,
    "lat": 0.4661732,
    "lng": 121.9637177,
    "color": "#dc3545"
}, {
    "nosamw": "0406640",
    "nama": "H18 IMAM MUSTOPA \/ B1 \/ 17",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4663094,
    "lng": 121.9641431,
    "color": "#ffc107"
}, {
    "nosamw": "0406518",
    "nama": "H18 IRFAN KUE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.465816,
    "lng": 121.9520855,
    "color": "#ffc107"
}, {
    "nosamw": "0406534",
    "nama": "H18 ISBAR PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4640715,
    "lng": 121.9511943,
    "color": "#28a745"
}, {
    "nosamw": "0406557",
    "nama": "H18 KARMAN DALUTA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 451000,
    "total_denda": 35000,
    "total_jumlah": 486000,
    "lat": 0.4569671,
    "lng": 121.9514868,
    "color": "#dc3545"
}, {
    "nosamw": "0406503",
    "nama": "H18 LATIFA NOVA DOTULONG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 3609000,
    "total_denda": 55000,
    "total_jumlah": 3664000,
    "lat": 0.4652839,
    "lng": 121.9447128,
    "color": "#dc3545"
}, {
    "nosamw": "0406574",
    "nama": "H18 LUKMAN SULEMAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 502600,
    "total_denda": 30000,
    "total_jumlah": 532600,
    "lat": 0.4574927,
    "lng": 121.9513216,
    "color": "#dc3545"
}, {
    "nosamw": "0406526",
    "nama": "H18 MARIA ULFA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 10000,
    "total_jumlah": 305000,
    "lat": 0.4605123,
    "lng": 121.9607665,
    "color": "#fd7e14"
}, {
    "nosamw": "0406516",
    "nama": "H18 MOHAMAD TANGAHU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 953200,
    "total_denda": 20000,
    "total_jumlah": 973200,
    "lat": 0.4592829,
    "lng": 121.9594177,
    "color": "#fd7e14"
}, {
    "nosamw": "0406548",
    "nama": "H18 MUSTAFA ABDULLAH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 236000,
    "total_denda": 35000,
    "total_jumlah": 271000,
    "lat": 0.4569367,
    "lng": 121.9513543,
    "color": "#dc3545"
}, {
    "nosamw": "0406384",
    "nama": "H18 NASRUN MALEO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 365700,
    "total_denda": 10000,
    "total_jumlah": 375700,
    "lat": 0.4572049,
    "lng": 121.9515678,
    "color": "#fd7e14"
}, {
    "nosamw": "0406630",
    "nama": "H18 NINING HALUTA \/ B1 \/ 29",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 555500,
    "total_denda": 35000,
    "total_jumlah": 590500,
    "lat": 0.4660483,
    "lng": 121.9632101,
    "color": "#dc3545"
}, {
    "nosamw": "0406527",
    "nama": "H18 PINDI SOLAT",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 484500,
    "total_denda": 10000,
    "total_jumlah": 494500,
    "lat": 0.4623241,
    "lng": 121.9635865,
    "color": "#fd7e14"
}, {
    "nosamw": "0406521",
    "nama": "H18 RAM DAUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 37,
    "total_tagihan": 3208000,
    "total_denda": 180000,
    "total_jumlah": 3388000,
    "lat": 0.4668171,
    "lng": 121.9521502,
    "color": "#dc3545"
}, {
    "nosamw": "0406522",
    "nama": "H18 RAMAN SUPU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 354500,
    "total_denda": 10000,
    "total_jumlah": 364500,
    "lat": 0.4661735,
    "lng": 121.9517982,
    "color": "#fd7e14"
}, {
    "nosamw": "0406523",
    "nama": "H18 RAMSIA PONUWAO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107500,
    "total_denda": 0,
    "total_jumlah": 107500,
    "lat": 0.4591746,
    "lng": 121.9526315,
    "color": "#ffc107"
}, {
    "nosamw": "0406472",
    "nama": "H18 RIDWAN PASOO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1030200,
    "total_denda": 50000,
    "total_jumlah": 1080200,
    "lat": 0.457109,
    "lng": 121.9513656,
    "color": "#dc3545"
}, {
    "nosamw": "0406637",
    "nama": "H18 RIZKIYANTO PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 350000,
    "total_denda": 15000,
    "total_jumlah": 365000,
    "lat": 0.4662817,
    "lng": 121.9639212,
    "color": "#fd7e14"
}, {
    "nosamw": "0406528",
    "nama": "H18 RUSMIN DJAKARIA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 178000,
    "total_denda": 10000,
    "total_jumlah": 188000,
    "lat": 0.4667848,
    "lng": 121.9584327,
    "color": "#fd7e14"
}, {
    "nosamw": "0406529",
    "nama": "H18 SALEH ISMAIL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.4755183,
    "lng": 121.9640961,
    "color": "#ffc107"
}, {
    "nosamw": "0406558",
    "nama": "H18 SALIM K. DUNGGIO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 75000,
    "total_denda": 0,
    "total_jumlah": 75000,
    "lat": 0.4568956,
    "lng": 121.9516182,
    "color": "#ffc107"
}, {
    "nosamw": "0406506",
    "nama": "H18 SANTO BUTOLO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 640000,
    "total_denda": 20000,
    "total_jumlah": 660000,
    "lat": 0.4649376,
    "lng": 121.9451946,
    "color": "#fd7e14"
}, {
    "nosamw": "0406639",
    "nama": "H18 SAPTAWATI \/ B1 \/ 18",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4663273,
    "lng": 121.9641874,
    "color": "#ffc107"
}, {
    "nosamw": "0406422",
    "nama": "H18 SONI YASIN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 44200,
    "total_denda": 0,
    "total_jumlah": 44200,
    "lat": 0.4574796,
    "lng": 121.9515415,
    "color": "#ffc107"
}, {
    "nosamw": "0406635",
    "nama": "H18 TRIA SUSANTI \/ C1 \/ 8",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.4662171,
    "lng": 121.9636857,
    "color": "#fd7e14"
}, {
    "nosamw": "0406473",
    "nama": "H18 ULIN ASABI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 410200,
    "total_denda": 5000,
    "total_jumlah": 415200,
    "lat": 0.4572418,
    "lng": 121.9513733,
    "color": "#ffc107"
}, {
    "nosamw": "0406426",
    "nama": "H18 WAHID LOPUO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 74400,
    "total_denda": 5000,
    "total_jumlah": 79400,
    "lat": 0.4571283,
    "lng": 121.9515219,
    "color": "#ffc107"
}, {
    "nosamw": "0406546",
    "nama": "H18 WELI DEILOLO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085398290397",
    "total_bulan": 11,
    "total_tagihan": 739700,
    "total_denda": 50000,
    "total_jumlah": 789700,
    "lat": 0.4569208,
    "lng": 121.9513016,
    "color": "#dc3545"
}, {
    "nosamw": "0406508",
    "nama": "H18 YUSNA NAWAI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 39500,
    "total_denda": 0,
    "total_jumlah": 39500,
    "lat": 0.475636,
    "lng": 121.9637705,
    "color": "#ffc107"
}, {
    "nosamw": "0406606",
    "nama": "H18 YUSNI DJAKATARA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 180500,
    "total_denda": 5000,
    "total_jumlah": 185500,
    "lat": 0.4614173,
    "lng": 121.9496652,
    "color": "#ffc107"
}, {
    "nosamw": "0406643",
    "nama": "H18 YUSUF AHMAD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082296292293",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4638108,
    "lng": 121.9508181,
    "color": "#ffc107"
}, {
    "nosamw": "0406471",
    "nama": "H18 YUSUF LASIMPALA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142300,
    "total_denda": 5000,
    "total_jumlah": 147300,
    "lat": 0.4572511,
    "lng": 121.9512455,
    "color": "#ffc107"
}, {
    "nosamw": "0406533",
    "nama": "H18 ZARIA ABAS",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.466659,
    "lng": 121.9619909,
    "color": "#ffc107"
}, {
    "nosamw": "0406899",
    "nama": "H19 ABDULLAH RAUF",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302000,
    "total_denda": 40000,
    "total_jumlah": 342000,
    "lat": 0.4572132,
    "lng": 121.9520745,
    "color": "#dc3545"
}, {
    "nosamw": "0406894",
    "nama": "H19 ALIMELU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 665000,
    "total_denda": 95000,
    "total_jumlah": 760000,
    "lat": 0.464178,
    "lng": 121.9631402,
    "color": "#dc3545"
}, {
    "nosamw": "0406914",
    "nama": "H19 ARIF SALIKO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 432750,
    "total_denda": 50000,
    "total_jumlah": 482750,
    "lat": 0.4574224,
    "lng": 121.9516301,
    "color": "#dc3545"
}, {
    "nosamw": "0406966",
    "nama": "H19 ARMAN SULEMAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 434000,
    "total_denda": 60000,
    "total_jumlah": 494000,
    "lat": 0.4572349,
    "lng": 121.9518542,
    "color": "#dc3545"
}, {
    "nosamw": "0406875",
    "nama": "H19 ARSAD MASAWALI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.4574556,
    "lng": 121.9519095,
    "color": "#ffc107"
}, {
    "nosamw": "0406862",
    "nama": "H19 ASRI KATILI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085398287581",
    "total_bulan": 5,
    "total_tagihan": 193000,
    "total_denda": 20000,
    "total_jumlah": 213000,
    "lat": 0.457126,
    "lng": 121.9519714,
    "color": "#fd7e14"
}, {
    "nosamw": "0406995",
    "nama": "H19 ERNI PAMALO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 272000,
    "total_denda": 15000,
    "total_jumlah": 287000,
    "lat": 0.4571064,
    "lng": 121.9521267,
    "color": "#fd7e14"
}, {
    "nosamw": "0406895",
    "nama": "H19 HADI KADIR",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.4568883,
    "lng": 121.9519539,
    "color": "#ffc107"
}, {
    "nosamw": "0406824",
    "nama": "H19 HASAN PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 96800,
    "total_denda": 5000,
    "total_jumlah": 101800,
    "lat": 0.4571617,
    "lng": 121.951945,
    "color": "#ffc107"
}, {
    "nosamw": "0406867",
    "nama": "H19 KASIM HAMID",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 246000,
    "total_denda": 10000,
    "total_jumlah": 256000,
    "lat": 0.4569518,
    "lng": 121.9517448,
    "color": "#fd7e14"
}, {
    "nosamw": "0406922",
    "nama": "H19 MAMAN MARDAIN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 255900,
    "total_denda": 5000,
    "total_jumlah": 260900,
    "lat": 0.4568755,
    "lng": 121.9519136,
    "color": "#ffc107"
}, {
    "nosamw": "0406873",
    "nama": "H19 MARYAM HULOPI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 393800,
    "total_denda": 45000,
    "total_jumlah": 438800,
    "lat": 0.4574382,
    "lng": 121.9519655,
    "color": "#dc3545"
}, {
    "nosamw": "0406880",
    "nama": "H19 Nani Tawaa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "085343611480",
    "total_bulan": 3,
    "total_tagihan": 278900,
    "total_denda": 10000,
    "total_jumlah": 288900,
    "lat": 0.4568886,
    "lng": 121.951938,
    "color": "#fd7e14"
}, {
    "nosamw": "0406865",
    "nama": "H19 OUNO H. MOPUTI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4630314,
    "lng": 121.944858,
    "color": "#ffc107"
}, {
    "nosamw": "0406898",
    "nama": "H19 POPPI S. NTIU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 163250,
    "total_denda": 5000,
    "total_jumlah": 168250,
    "lat": 0.4570898,
    "lng": 121.9520908,
    "color": "#ffc107"
}, {
    "nosamw": "0406981",
    "nama": "H19 RADEN SAMAU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49800,
    "total_denda": 0,
    "total_jumlah": 49800,
    "lat": 0.4568836,
    "lng": 121.9518251,
    "color": "#ffc107"
}, {
    "nosamw": "0406876",
    "nama": "H19 RAFIKA ABJUL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 77200,
    "total_denda": 5000,
    "total_jumlah": 82200,
    "lat": 0.4569072,
    "lng": 121.9518109,
    "color": "#ffc107"
}, {
    "nosamw": "0406881",
    "nama": "H19 RAHMAN DUNGGIO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4569141,
    "lng": 121.9521318,
    "color": "#ffc107"
}, {
    "nosamw": "0406969",
    "nama": "H19 RAHMAN OLII",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 49800,
    "total_denda": 0,
    "total_jumlah": 49800,
    "lat": 0.4571307,
    "lng": 121.9520018,
    "color": "#ffc107"
}, {
    "nosamw": "0406703",
    "nama": "H19 RATNA NENTO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 240000,
    "total_denda": 20000,
    "total_jumlah": 260000,
    "lat": 0.4647,
    "lng": 121.9438276,
    "color": "#fd7e14"
}, {
    "nosamw": "0406991",
    "nama": "H19 RISAL TANANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 607600,
    "total_denda": 35000,
    "total_jumlah": 642600,
    "lat": 0.4571635,
    "lng": 121.952132,
    "color": "#dc3545"
}, {
    "nosamw": "0406874",
    "nama": "H19 SALEH IBRAHIM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 102400,
    "total_denda": 5000,
    "total_jumlah": 107400,
    "lat": 0.4574394,
    "lng": 121.9518192,
    "color": "#ffc107"
}, {
    "nosamw": "0406897",
    "nama": "H19 SAMSUDIN GIASI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "085211781530",
    "total_bulan": 10,
    "total_tagihan": 613250,
    "total_denda": 45000,
    "total_jumlah": 658250,
    "lat": 0.4569931,
    "lng": 121.9520148,
    "color": "#dc3545"
}, {
    "nosamw": "0406811",
    "nama": "H19 SERLYN MAUDE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4648402,
    "lng": 121.9448024,
    "color": "#ffc107"
}, {
    "nosamw": "0406971",
    "nama": "H19 SYARIF HUSUNA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1135000,
    "total_denda": 20000,
    "total_jumlah": 1155000,
    "lat": 0.4615064,
    "lng": 121.9616349,
    "color": "#fd7e14"
}, {
    "nosamw": "0406970",
    "nama": "H19 TALIB BULIIDE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 70000,
    "total_denda": 5000,
    "total_jumlah": 75000,
    "lat": 0.4650922,
    "lng": 121.9660978,
    "color": "#ffc107"
}, {
    "nosamw": "0406866",
    "nama": "H19 TARDI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4633204,
    "lng": 121.9446687,
    "color": "#ffc107"
}, {
    "nosamw": "0405990",
    "nama": "HABIBA DARJAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 1405000,
    "total_denda": 135000,
    "total_jumlah": 1540000,
    "lat": 0.4672153,
    "lng": 121.9540026,
    "color": "#dc3545"
}, {
    "nosamw": "0402296",
    "nama": "Hadija Potabuga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 357500,
    "total_denda": 5000,
    "total_jumlah": 362500,
    "lat": 0.4619476,
    "lng": 121.9515099,
    "color": "#ffc107"
}, {
    "nosamw": "0402064",
    "nama": "Hadija Rigawe",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 269000,
    "total_denda": 10000,
    "total_jumlah": 279000,
    "lat": 0.465156,
    "lng": 121.9464,
    "color": "#fd7e14"
}, {
    "nosamw": "0404456",
    "nama": "Hadrianto, S.Pi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 552000,
    "total_denda": 40000,
    "total_jumlah": 592000,
    "lat": 0.4634457,
    "lng": 121.9512875,
    "color": "#dc3545"
}, {
    "nosamw": "0405899",
    "nama": "HAJRIA TOONAWU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085240049241",
    "total_bulan": 7,
    "total_tagihan": 1849500,
    "total_denda": 30000,
    "total_jumlah": 1879500,
    "lat": 0.4568668,
    "lng": 121.9519296,
    "color": "#dc3545"
}, {
    "nosamw": "0401959",
    "nama": "Hamid Abas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.462255,
    "lng": 121.950813,
    "color": "#ffc107"
}, {
    "nosamw": "0404402",
    "nama": "Hamid Padang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1000000,
    "total_denda": 110000,
    "total_jumlah": 1110000,
    "lat": 0.464143,
    "lng": 121.951765,
    "color": "#dc3545"
}, {
    "nosamw": "0401341",
    "nama": "Hamida Anuli",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464038,
    "lng": 121.948635,
    "color": "#28a745"
}, {
    "nosamw": "0405075",
    "nama": "Hamzah Rahman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 273750,
    "total_denda": 35000,
    "total_jumlah": 308750,
    "lat": 0.4596297,
    "lng": 121.9561894,
    "color": "#dc3545"
}, {
    "nosamw": "0401730",
    "nama": "Haris Nusi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.466042,
    "lng": 121.962812,
    "color": "#ffc107"
}, {
    "nosamw": "0402061",
    "nama": "Hasan Abas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.465284,
    "lng": 121.946309,
    "color": "#ffc107"
}, {
    "nosamw": "0407500",
    "nama": "HASAN KIJAI BADERAN 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356586461",
    "total_bulan": 1,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4642641,
    "lng": 121.9470953,
    "color": "#ffc107"
}, {
    "nosamw": "0406967",
    "nama": "HASAN TANGAHU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1209500,
    "total_denda": 115000,
    "total_jumlah": 1324500,
    "lat": 0.4572378,
    "lng": 121.9520344,
    "color": "#dc3545"
}, {
    "nosamw": "0400747",
    "nama": "Hasmiaty Labaco",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458244,
    "lng": 121.9438,
    "color": "#28a745"
}, {
    "nosamw": "0405991",
    "nama": "HASMIYATI MAHMUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.4667382,
    "lng": 121.9512824,
    "color": "#ffc107"
}, {
    "nosamw": "0403371",
    "nama": "Hasna Hionu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466852,
    "lng": 121.951428,
    "color": "#28a745"
}, {
    "nosamw": "0405489",
    "nama": "HAWA DATAU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4623755,
    "lng": 121.9631432,
    "color": "#fd7e14"
}, {
    "nosamw": "0402066",
    "nama": "Hayun Mayang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1360000,
    "total_denda": 25000,
    "total_jumlah": 1385000,
    "lat": 0.465075,
    "lng": 121.946699,
    "color": "#fd7e14"
}, {
    "nosamw": "0407526",
    "nama": "HELDI BAU S.H",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085340109114",
    "total_bulan": 2,
    "total_tagihan": 391500,
    "total_denda": 5000,
    "total_jumlah": 396500,
    "lat": 0.4633019,
    "lng": 121.9441204,
    "color": "#ffc107"
}, {
    "nosamw": "0403460",
    "nama": "Hendra Napu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.463876,
    "lng": 121.951741,
    "color": "#fd7e14"
}, {
    "nosamw": "0400050",
    "nama": "HENDRIK DARISE II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1228500,
    "total_denda": 55000,
    "total_jumlah": 1283500,
    "lat": 0.4644672,
    "lng": 121.9506603,
    "color": "#dc3545"
}, {
    "nosamw": "0403092",
    "nama": "Hendrita Sulila",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463161,
    "lng": 121.951495,
    "color": "#28a745"
}, {
    "nosamw": "0405957",
    "nama": "HENDRIYANTO MAHMUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 741500,
    "total_denda": 50000,
    "total_jumlah": 791500,
    "lat": 0.463709,
    "lng": 121.9512318,
    "color": "#dc3545"
}, {
    "nosamw": "0404474",
    "nama": "Hendry Tuliabu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 688500,
    "total_denda": 40000,
    "total_jumlah": 728500,
    "lat": 0.464409,
    "lng": 121.951676,
    "color": "#dc3545"
}, {
    "nosamw": "0403811",
    "nama": "Heni Tone",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.464169,
    "lng": 121.951712,
    "color": "#ffc107"
}, {
    "nosamw": "0403069",
    "nama": "Herda. A.Ma",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.462146,
    "lng": 121.9507,
    "color": "#ffc107"
}, {
    "nosamw": "0402535",
    "nama": "Heriyanto Dalanggo M.Pdi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 431000,
    "total_denda": 20000,
    "total_jumlah": 451000,
    "lat": 0.461971,
    "lng": 121.950287,
    "color": "#fd7e14"
}, {
    "nosamw": "0400848",
    "nama": "Heriyanto uwete",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 230000,
    "total_denda": 10000,
    "total_jumlah": 240000,
    "lat": 0.462032,
    "lng": 121.951221,
    "color": "#fd7e14"
}, {
    "nosamw": "0401259",
    "nama": "Herlina Suleman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 366000,
    "total_denda": 20000,
    "total_jumlah": 386000,
    "lat": 0.4645202,
    "lng": 121.9504181,
    "color": "#fd7e14"
}, {
    "nosamw": "0404443",
    "nama": "Herlina Yasin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 295000,
    "total_denda": 10000,
    "total_jumlah": 305000,
    "lat": 0.464396,
    "lng": 121.951784,
    "color": "#fd7e14"
}, {
    "nosamw": "0402138",
    "nama": "Herlinawati Ibrahim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 329500,
    "total_denda": 5000,
    "total_jumlah": 334500,
    "lat": 0.462764,
    "lng": 121.9508,
    "color": "#ffc107"
}, {
    "nosamw": "0404435",
    "nama": "Herlindah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 944500,
    "total_denda": 55000,
    "total_jumlah": 999500,
    "lat": 0.464184,
    "lng": 121.951707,
    "color": "#dc3545"
}, {
    "nosamw": "0404324",
    "nama": "Herman Dama",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.464589,
    "lng": 121.951571,
    "color": "#ffc107"
}, {
    "nosamw": "0404280",
    "nama": "Herman Luawo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 314000,
    "total_denda": 20000,
    "total_jumlah": 334000,
    "lat": 0.463989,
    "lng": 121.951714,
    "color": "#fd7e14"
}, {
    "nosamw": "0402287",
    "nama": "HERMANSYAH ADIKAJI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1058500,
    "total_denda": 80000,
    "total_jumlah": 1138500,
    "lat": 0.4646129,
    "lng": 121.9502345,
    "color": "#dc3545"
}, {
    "nosamw": "0401665",
    "nama": "Hervin Samoe",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464061,
    "lng": 121.948507,
    "color": "#28a745"
}, {
    "nosamw": "0403318",
    "nama": "Hery Hunowu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 965500,
    "total_denda": 70000,
    "total_jumlah": 1035500,
    "lat": 0.466101,
    "lng": 121.962764,
    "color": "#dc3545"
}, {
    "nosamw": "0403010",
    "nama": "Heski EN. TewaL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 393500,
    "total_denda": 10000,
    "total_jumlah": 403500,
    "lat": 0.462299,
    "lng": 121.950408,
    "color": "#fd7e14"
}, {
    "nosamw": "0401780",
    "nama": "Hesty G. Manurung",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 288000,
    "total_denda": 20000,
    "total_jumlah": 308000,
    "lat": 0.4630771,
    "lng": 121.9489633,
    "color": "#fd7e14"
}, {
    "nosamw": "0403424",
    "nama": "Himawan T. Wijaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 181500,
    "total_denda": 5000,
    "total_jumlah": 186500,
    "lat": 0.463414,
    "lng": 121.951274,
    "color": "#ffc107"
}, {
    "nosamw": "0405175",
    "nama": "HIN ISMAIL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4556047,
    "lng": 121.955702,
    "color": "#ffc107"
}, {
    "nosamw": "0402484",
    "nama": "Hiskia J. Manggopo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1656500,
    "total_denda": 70000,
    "total_jumlah": 1726500,
    "lat": 0.46616,
    "lng": 121.962798,
    "color": "#dc3545"
}, {
    "nosamw": "0404549",
    "nama": "Hj Aminah Olii",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.460662,
    "lng": 121.943163,
    "color": "#28a745"
}, {
    "nosamw": "0402388",
    "nama": "Hj. Asia SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082290271140",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462158,
    "lng": 121.950415,
    "color": "#ffc107"
}, {
    "nosamw": "0405305",
    "nama": "HJ. HAJERAH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 722000,
    "total_denda": 5000,
    "total_jumlah": 727000,
    "lat": 0.4640305,
    "lng": 121.9471525,
    "color": "#ffc107"
}, {
    "nosamw": "0403108",
    "nama": "Hj. Ida Rosida",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.462256,
    "lng": 121.951401,
    "color": "#ffc107"
}, {
    "nosamw": "0403928",
    "nama": "Husain Abdul",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 249500,
    "total_denda": 10000,
    "total_jumlah": 259500,
    "lat": 0.4637858,
    "lng": 121.9514651,
    "color": "#fd7e14"
}, {
    "nosamw": "0401814",
    "nama": "HUSAIN TAMRIN LAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 580000,
    "total_denda": 30000,
    "total_jumlah": 610000,
    "lat": 0.4644263,
    "lng": 121.9510813,
    "color": "#dc3545"
}, {
    "nosamw": "0404185",
    "nama": "Husin Djakaria",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 469000,
    "total_denda": 75000,
    "total_jumlah": 544000,
    "lat": 0.465101,
    "lng": 121.946225,
    "color": "#dc3545"
}, {
    "nosamw": "0400318",
    "nama": "Husnul Hamka",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1438500,
    "total_denda": 45000,
    "total_jumlah": 1483500,
    "lat": 0.4670898,
    "lng": 121.9508617,
    "color": "#dc3545"
}, {
    "nosamw": "0402471",
    "nama": "Hutri Merdekawati Mosii",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 500000,
    "total_denda": 40000,
    "total_jumlah": 540000,
    "lat": 0.462928,
    "lng": 121.950401,
    "color": "#dc3545"
}, {
    "nosamw": "0402464",
    "nama": "I Ketut Sadia",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.462075,
    "lng": 121.951119,
    "color": "#ffc107"
}, {
    "nosamw": "0401761",
    "nama": "I ketut Suwardika",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 441000,
    "total_denda": 15000,
    "total_jumlah": 456000,
    "lat": 0.4644841,
    "lng": 121.9503624,
    "color": "#fd7e14"
}, {
    "nosamw": "0403629",
    "nama": "I Nyoman Adiputra",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.464157,
    "lng": 121.951522,
    "color": "#ffc107"
}, {
    "nosamw": "0403414",
    "nama": "I Nyoman Master",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 885000,
    "total_denda": 75000,
    "total_jumlah": 960000,
    "lat": 0.463418,
    "lng": 121.951696,
    "color": "#dc3545"
}, {
    "nosamw": "0403652",
    "nama": "Ibrahim Ismail",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 5000,
    "total_jumlah": 128000,
    "lat": 0.463176,
    "lng": 121.9606199,
    "color": "#ffc107"
}, {
    "nosamw": "0401749",
    "nama": "Ibrahim Razak",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462797,
    "lng": 121.963318,
    "color": "#28a745"
}, {
    "nosamw": "0404732",
    "nama": "Ican Marfika Yusuf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1360500,
    "total_denda": 45000,
    "total_jumlah": 1405500,
    "lat": 0.464703,
    "lng": 121.951338,
    "color": "#dc3545"
}, {
    "nosamw": "0400514",
    "nama": "Icu S. Monoarfa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082187522405",
    "total_bulan": 2,
    "total_tagihan": 288500,
    "total_denda": 5000,
    "total_jumlah": 293500,
    "lat": 0.4873658,
    "lng": 121.9353182,
    "color": "#ffc107"
}, {
    "nosamw": "0401951",
    "nama": "Idris Man Abdul",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.466001,
    "lng": 121.962838,
    "color": "#fd7e14"
}, {
    "nosamw": "0404757",
    "nama": "IDRUS A. MOPUTI 3",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.462801,
    "lng": 121.951888,
    "color": "#ffc107"
}, {
    "nosamw": "0403109",
    "nama": "Idrus Moputi 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.463256,
    "lng": 121.951553,
    "color": "#ffc107"
}, {
    "nosamw": "0405998",
    "nama": "IDRUS MUSA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4599444,
    "lng": 121.960229,
    "color": "#28a745"
}, {
    "nosamw": "0401674",
    "nama": "Iis Rahayu Alatas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 3006000,
    "total_denda": 65000,
    "total_jumlah": 3071000,
    "lat": 0.464029,
    "lng": 121.949321,
    "color": "#dc3545"
}, {
    "nosamw": "0401673",
    "nama": "Ikhlas Mangkau",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.464324,
    "lng": 121.949257,
    "color": "#ffc107"
}, {
    "nosamw": "0402315",
    "nama": "Ilham Gelamona",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2181000,
    "total_denda": 65000,
    "total_jumlah": 2246000,
    "lat": 0.4644603,
    "lng": 121.9511483,
    "color": "#dc3545"
}, {
    "nosamw": "0403563",
    "nama": "Ilham Lawendatu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.457793,
    "lng": 121.949615,
    "color": "#ffc107"
}, {
    "nosamw": "0401347",
    "nama": "Ilyas Kumali",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.463914,
    "lng": 121.948281,
    "color": "#dc3545"
}, {
    "nosamw": "0405128",
    "nama": "ILYAS MUSA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 291500,
    "total_denda": 15000,
    "total_jumlah": 306500,
    "lat": 0.4641418,
    "lng": 121.9505294,
    "color": "#fd7e14"
}, {
    "nosamw": "0401502",
    "nama": "Imran Biki",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464647,
    "lng": 121.948549,
    "color": "#ffc107"
}, {
    "nosamw": "0405980",
    "nama": "IMRAN DJAKARIA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 287800,
    "total_denda": 15000,
    "total_jumlah": 302800,
    "lat": 0.4650284,
    "lng": 121.9651636,
    "color": "#fd7e14"
}, {
    "nosamw": "0400117",
    "nama": "INDAH ARIEF PAUDIE, ST",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4627591,
    "lng": 121.9488569,
    "color": "#28a745"
}, {
    "nosamw": "0402299",
    "nama": "Indah Ika Puspita",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 157500,
    "total_denda": 0,
    "total_jumlah": 157500,
    "lat": 0.461838,
    "lng": 121.951553,
    "color": "#ffc107"
}, {
    "nosamw": "0402056",
    "nama": "Indah N. Tobuhu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 639000,
    "total_denda": 25000,
    "total_jumlah": 664000,
    "lat": 0.4654185,
    "lng": 121.9450427,
    "color": "#fd7e14"
}, {
    "nosamw": "0405962",
    "nama": "INDAH PARAMITA MUSTAFA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 4473500,
    "total_denda": 105000,
    "total_jumlah": 4578500,
    "lat": 0.4628122,
    "lng": 121.9511106,
    "color": "#dc3545"
}, {
    "nosamw": "0402389",
    "nama": "Indra Migdad Hilipito",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 468500,
    "total_denda": 5000,
    "total_jumlah": 473500,
    "lat": 0.462272,
    "lng": 121.951284,
    "color": "#ffc107"
}, {
    "nosamw": "0403439",
    "nama": "Indrawaty djama II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 343000,
    "total_denda": 25000,
    "total_jumlah": 368000,
    "lat": 0.464067,
    "lng": 121.951518,
    "color": "#fd7e14"
}, {
    "nosamw": "0404412",
    "nama": "Indrawaty Hamid",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 723500,
    "total_denda": 55000,
    "total_jumlah": 778500,
    "lat": 0.463037,
    "lng": 121.950414,
    "color": "#dc3545"
}, {
    "nosamw": "0403576",
    "nama": "Indrawaty Yusuf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 518500,
    "total_denda": 20000,
    "total_jumlah": 538500,
    "lat": 0.464316,
    "lng": 121.951727,
    "color": "#fd7e14"
}, {
    "nosamw": "0404327",
    "nama": "Ipin Djuma Lalu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 235500,
    "total_denda": 5000,
    "total_jumlah": 240500,
    "lat": 0.463789,
    "lng": 121.951438,
    "color": "#ffc107"
}, {
    "nosamw": "0402336",
    "nama": "Irfan Mangantar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.461846,
    "lng": 121.951474,
    "color": "#ffc107"
}, {
    "nosamw": "0401662",
    "nama": "IRHAM YASIR",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.464437,
    "lng": 121.9493696,
    "color": "#ffc107"
}, {
    "nosamw": "0401886",
    "nama": "Irmawati Lasimpala",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1398950,
    "total_denda": 70000,
    "total_jumlah": 1468950,
    "lat": 0.466425,
    "lng": 121.94678,
    "color": "#dc3545"
}, {
    "nosamw": "0407287",
    "nama": "IRMAWATI LASIMPALA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.466425,
    "lng": 121.94678,
    "color": "#ffc107"
}, {
    "nosamw": "0400515",
    "nama": "Irnawati Masia,ST",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 989500,
    "total_denda": 65000,
    "total_jumlah": 1054500,
    "lat": 0.4636847,
    "lng": 121.9489337,
    "color": "#dc3545"
}, {
    "nosamw": "0401589",
    "nama": "Irvan Muzakir S.Kom",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463488,
    "lng": 121.951577,
    "color": "#28a745"
}, {
    "nosamw": "0400207",
    "nama": "Irwan Ibrahim Hamzah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4645341,
    "lng": 121.9504327,
    "color": "#ffc107"
}, {
    "nosamw": "0402157",
    "nama": "Irwan Lahay",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466394,
    "lng": 121.946993,
    "color": "#28a745"
}, {
    "nosamw": "0403186",
    "nama": "Irwan Lasimpala",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 201000,
    "total_denda": 5000,
    "total_jumlah": 206000,
    "lat": 0.459387,
    "lng": 121.953781,
    "color": "#ffc107"
}, {
    "nosamw": "0402378",
    "nama": "Irwanto Husnan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 187500,
    "total_denda": 0,
    "total_jumlah": 187500,
    "lat": 0.462326,
    "lng": 121.951329,
    "color": "#ffc107"
}, {
    "nosamw": "0402224",
    "nama": "Is Rahmola",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462624,
    "lng": 121.950453,
    "color": "#ffc107"
}, {
    "nosamw": "0401201",
    "nama": "Isa Darjan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 493750,
    "total_denda": 40000,
    "total_jumlah": 533750,
    "lat": 0.465862,
    "lng": 121.96285,
    "color": "#dc3545"
}, {
    "nosamw": "0402477",
    "nama": "Ishak DG. Matenga Sp",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462751,
    "lng": 121.95072,
    "color": "#ffc107"
}, {
    "nosamw": "0402848",
    "nama": "Ishak Tayabu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 768500,
    "total_denda": 40000,
    "total_jumlah": 808500,
    "lat": 0.4594932,
    "lng": 121.9563977,
    "color": "#dc3545"
}, {
    "nosamw": "0400639",
    "nama": "Iskandar Datau",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 597500,
    "total_denda": 5000,
    "total_jumlah": 602500,
    "lat": 0.4641356,
    "lng": 121.9476698,
    "color": "#ffc107"
}, {
    "nosamw": "0407522",
    "nama": "ISKANDAR MASILI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085147244477",
    "total_bulan": 1,
    "total_tagihan": 1035000,
    "total_denda": 0,
    "total_jumlah": 1035000,
    "lat": 0.4603553,
    "lng": 121.9609439,
    "color": "#ffc107"
}, {
    "nosamw": "0405170",
    "nama": "ISMAIL ABAS, S.HI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 51,
    "total_tagihan": 2731000,
    "total_denda": 250000,
    "total_jumlah": 2981000,
    "lat": 0.4641606,
    "lng": 121.9505339,
    "color": "#dc3545"
}, {
    "nosamw": "0406632",
    "nama": "ISMAIL BULOTO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 792500,
    "total_denda": 40000,
    "total_jumlah": 832500,
    "lat": 0.4661895,
    "lng": 121.9636179,
    "color": "#dc3545"
}, {
    "nosamw": "0404483",
    "nama": "Ismail Ibrahim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 272000,
    "total_denda": 15000,
    "total_jumlah": 287000,
    "lat": 0.46326,
    "lng": 121.951486,
    "color": "#fd7e14"
}, {
    "nosamw": "0402060",
    "nama": "Ismail Musa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.46507,
    "lng": 121.945534,
    "color": "#ffc107"
}, {
    "nosamw": "0406350",
    "nama": "ISMAIL SABU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 190000,
    "total_denda": 10000,
    "total_jumlah": 200000,
    "lat": 0.471933,
    "lng": 121.94033,
    "color": "#fd7e14"
}, {
    "nosamw": "0403671",
    "nama": "Isman Nurdin II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.458961,
    "lng": 121.954876,
    "color": "#ffc107"
}, {
    "nosamw": "0403696",
    "nama": "Iswandi Sangkala",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 387500,
    "total_denda": 5000,
    "total_jumlah": 392500,
    "lat": 0.463931,
    "lng": 121.951359,
    "color": "#ffc107"
}, {
    "nosamw": "0407283",
    "nama": "Iswanto Lamusu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 302500,
    "total_denda": 5000,
    "total_jumlah": 307500,
    "lat": 0.4638097,
    "lng": 121.9505563,
    "color": "#ffc107"
}, {
    "nosamw": "0405621",
    "nama": "Iwan DG. Mile",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085117771489",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.456164,
    "lng": 121.950803,
    "color": "#ffc107"
}, {
    "nosamw": "0402482",
    "nama": "Izhar Zaitulah Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1761000,
    "total_denda": 145000,
    "total_jumlah": 1906000,
    "lat": 0.462057,
    "lng": 121.950683,
    "color": "#dc3545"
}, {
    "nosamw": "0400061",
    "nama": "Jamer R. Seba",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 560000,
    "total_denda": 5000,
    "total_jumlah": 565000,
    "lat": 0.464467,
    "lng": 121.951586,
    "color": "#dc3545"
}, {
    "nosamw": "0401363",
    "nama": "Janette E. Ishak Kiu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 404500,
    "total_denda": 30000,
    "total_jumlah": 434500,
    "lat": 0.4644929,
    "lng": 121.9503799,
    "color": "#dc3545"
}, {
    "nosamw": "0402519",
    "nama": "Jasmiatun",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 203000,
    "total_denda": 10000,
    "total_jumlah": 213000,
    "lat": 0.461262,
    "lng": 121.96168,
    "color": "#fd7e14"
}, {
    "nosamw": "0401905",
    "nama": "JEFRI KARIM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4620675,
    "lng": 121.9507781,
    "color": "#ffc107"
}, {
    "nosamw": "0401754",
    "nama": "Jhon Moh. Harmain",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 506500,
    "total_denda": 40000,
    "total_jumlah": 546500,
    "lat": 0.463594,
    "lng": 121.949443,
    "color": "#dc3545"
}, {
    "nosamw": "0400181",
    "nama": "Johanis R. Sampe",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1207500,
    "total_denda": 60000,
    "total_jumlah": 1267500,
    "lat": 0.487275,
    "lng": 121.93477,
    "color": "#dc3545"
}, {
    "nosamw": "0401675",
    "nama": "Juli Rahmat E. A",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.464522,
    "lng": 121.948799,
    "color": "#ffc107"
}, {
    "nosamw": "0401039",
    "nama": "Julia Citra Risky",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 539500,
    "total_denda": 15000,
    "total_jumlah": 554500,
    "lat": 0.4645479,
    "lng": 121.9504701,
    "color": "#fd7e14"
}, {
    "nosamw": "0406342",
    "nama": "JUMARNI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082188935994",
    "total_bulan": 1,
    "total_tagihan": 270000,
    "total_denda": 0,
    "total_jumlah": 270000,
    "lat": 0.4625742,
    "lng": 121.9484896,
    "color": "#ffc107"
}, {
    "nosamw": "0400292",
    "nama": "Jumiati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 344500,
    "total_denda": 5000,
    "total_jumlah": 349500,
    "lat": 0.4644839,
    "lng": 121.9504048,
    "color": "#ffc107"
}, {
    "nosamw": "0407293",
    "nama": "KABAR MULTIMEDIA GROUP",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.4625477,
    "lng": 121.9498504,
    "color": "#dc3545"
}, {
    "nosamw": "0405617",
    "nama": "Kader Bone Putra 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 513000,
    "total_denda": 10000,
    "total_jumlah": 523000,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#fd7e14"
}, {
    "nosamw": "0400168",
    "nama": "Kadir Aini 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.463826,
    "lng": 121.951599,
    "color": "#ffc107"
}, {
    "nosamw": "0407420",
    "nama": "KAMPOENG KULINER\/RATNA RUBEMON",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085299743730",
    "total_bulan": 6,
    "total_tagihan": 395000,
    "total_denda": 25000,
    "total_jumlah": 420000,
    "lat": 0.4669915,
    "lng": 121.956483,
    "color": "#fd7e14"
}, {
    "nosamw": "0406062",
    "nama": "KAMPUS UNISAN POHUWATO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 821550,
    "total_denda": 30000,
    "total_jumlah": 851550,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#dc3545"
}, {
    "nosamw": "0401508",
    "nama": "Kamto Taha",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1067800,
    "total_denda": 75000,
    "total_jumlah": 1142800,
    "lat": 0.466187,
    "lng": 121.963327,
    "color": "#dc3545"
}, {
    "nosamw": "0401930",
    "nama": "Karim Domili",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1177500,
    "total_denda": 45000,
    "total_jumlah": 1222500,
    "lat": 0.462426,
    "lng": 121.950818,
    "color": "#dc3545"
}, {
    "nosamw": "0402373",
    "nama": "Karman Bakari",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.461977,
    "lng": 121.951339,
    "color": "#fd7e14"
}, {
    "nosamw": "0406164",
    "nama": "KARTINI MUSLIMIN, SE. M.AK",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#ffc107"
}, {
    "nosamw": "0407338",
    "nama": "KTR KEMENAG POHUWATO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 370000,
    "total_denda": 20000,
    "total_jumlah": 390000,
    "lat": 0.4607889,
    "lng": 121.9477353,
    "color": "#fd7e14"
}, {
    "nosamw": "0404489",
    "nama": "Ktr ULP Kab. Pohuwato",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 902500,
    "total_denda": 0,
    "total_jumlah": 902500,
    "lat": 0.457361,
    "lng": 121.947905,
    "color": "#ffc107"
}, {
    "nosamw": "0400453",
    "nama": "Ktr. BAPEDA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 3835000,
    "total_denda": 5000,
    "total_jumlah": 3840000,
    "lat": 0.458831,
    "lng": 121.945168,
    "color": "#ffc107"
}, {
    "nosamw": "0407289",
    "nama": "KTR. BAWASLU (PEMDA)",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1997500,
    "total_denda": 0,
    "total_jumlah": 1997500,
    "lat": 0.4599776,
    "lng": 121.9501816,
    "color": "#ffc107"
}, {
    "nosamw": "0402366",
    "nama": "Ktr. BLK E\/ Jefri Lanti",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458805,
    "lng": 121.957071,
    "color": "#28a745"
}, {
    "nosamw": "0402365",
    "nama": "Ktr. BLKD\/Jefri Lanti",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 467500,
    "total_denda": 0,
    "total_jumlah": 467500,
    "lat": 0.458752,
    "lng": 121.956736,
    "color": "#ffc107"
}, {
    "nosamw": "0400896",
    "nama": "Ktr. BPBD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.4589508,
    "lng": 121.9462315,
    "color": "#ffc107"
}, {
    "nosamw": "0405299",
    "nama": "KTR. BPMP TSP",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 11745000,
    "total_denda": 95000,
    "total_jumlah": 11840000,
    "lat": 0.4760214,
    "lng": 121.9428758,
    "color": "#dc3545"
}, {
    "nosamw": "0404779",
    "nama": "KTR. DESA PALOPO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2135000,
    "total_denda": 200000,
    "total_jumlah": 2335000,
    "lat": 0.4666415,
    "lng": 121.9581772,
    "color": "#dc3545"
}, {
    "nosamw": "0400978",
    "nama": "Ktr. Dinas Perum&Permukiman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1772500,
    "total_denda": 20000,
    "total_jumlah": 1792500,
    "lat": 0.459274,
    "lng": 121.9493583,
    "color": "#fd7e14"
}, {
    "nosamw": "0405487",
    "nama": "KTR. KODIM POHUWATO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 21422500,
    "total_denda": 5000,
    "total_jumlah": 21427500,
    "lat": 0.4558234,
    "lng": 121.9503126,
    "color": "#dc3545"
}, {
    "nosamw": "0400973",
    "nama": "Ktr. PDK",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457213,
    "lng": 121.948217,
    "color": "#28a745"
}, {
    "nosamw": "0403525",
    "nama": "KTR. PEMBERDAYAAN PEREMPUAN \/ KB",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1900000,
    "total_denda": 95000,
    "total_jumlah": 1995000,
    "lat": 0.4566508,
    "lng": 121.9460284,
    "color": "#dc3545"
}, {
    "nosamw": "0400057",
    "nama": "Ktr. PMD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 4397500,
    "total_denda": 20000,
    "total_jumlah": 4417500,
    "lat": 0.456876,
    "lng": 121.945609,
    "color": "#fd7e14"
}, {
    "nosamw": "0405485",
    "nama": "KTR. UPTD KPH UNIT III POHUWATO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 382500,
    "total_denda": 20000,
    "total_jumlah": 402500,
    "lat": 0.4593941,
    "lng": 121.9493124,
    "color": "#fd7e14"
}, {
    "nosamw": "0404528",
    "nama": "LAJUARDI ARIDI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1102500,
    "total_denda": 0,
    "total_jumlah": 1102500,
    "lat": 0.46108,
    "lng": 121.9554954,
    "color": "#ffc107"
}, {
    "nosamw": "0407557",
    "nama": "LAJUARDI ARIDI 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356576200",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4595378,
    "lng": 121.9557946,
    "color": "#28a745"
}, {
    "nosamw": "0401503",
    "nama": "LAKSMIN LANGAGO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4629821,
    "lng": 121.9509021,
    "color": "#ffc107"
}, {
    "nosamw": "0402067",
    "nama": "Lance Due",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.465397,
    "lng": 121.945111,
    "color": "#ffc107"
}, {
    "nosamw": "0407478",
    "nama": "LELY FITRIANY MAIGY",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085256843596",
    "total_bulan": 8,
    "total_tagihan": 497000,
    "total_denda": 35000,
    "total_jumlah": 532000,
    "lat": 0.4586763,
    "lng": 121.9450651,
    "color": "#dc3545"
}, {
    "nosamw": "0401273",
    "nama": "Leo Tandirano \/ Perum G.M",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463121,
    "lng": 121.951485,
    "color": "#ffc107"
}, {
    "nosamw": "0401679",
    "nama": "Liffi Mamesa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.464225,
    "lng": 121.949398,
    "color": "#ffc107"
}, {
    "nosamw": "0403697",
    "nama": "Lila Pamuji",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.46354,
    "lng": 121.951295,
    "color": "#ffc107"
}, {
    "nosamw": "0402054",
    "nama": "LILI METTY",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 204000,
    "total_denda": 10000,
    "total_jumlah": 214000,
    "lat": 0.4629945,
    "lng": 121.9504032,
    "color": "#fd7e14"
}, {
    "nosamw": "0401786",
    "nama": "Liliyanti Pikoli",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.463648,
    "lng": 121.94948,
    "color": "#ffc107"
}, {
    "nosamw": "0404246",
    "nama": "Linda Beleneti",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 344500,
    "total_denda": 15000,
    "total_jumlah": 359500,
    "lat": 0.463797,
    "lng": 121.95182,
    "color": "#fd7e14"
}, {
    "nosamw": "0404782",
    "nama": "LISNA LESTARI A.R.",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 178000,
    "total_denda": 10000,
    "total_jumlah": 188000,
    "lat": 0.4644679,
    "lng": 121.951079,
    "color": "#fd7e14"
}, {
    "nosamw": "0402382",
    "nama": "Lukman Pither",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 646500,
    "total_denda": 35000,
    "total_jumlah": 681500,
    "lat": 0.461998,
    "lng": 121.950339,
    "color": "#dc3545"
}, {
    "nosamw": "0402065",
    "nama": "Lukman Tou",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 414500,
    "total_denda": 25000,
    "total_jumlah": 439500,
    "lat": 0.464983,
    "lng": 121.9457,
    "color": "#fd7e14"
}, {
    "nosamw": "0400294",
    "nama": "M. Ferari D. Susilo, SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 453500,
    "total_denda": 25000,
    "total_jumlah": 478500,
    "lat": 0.4642117,
    "lng": 121.9507536,
    "color": "#fd7e14"
}, {
    "nosamw": "0400921",
    "nama": "M. Indah Blok F No. 5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.463945,
    "lng": 121.948247,
    "color": "#ffc107"
}, {
    "nosamw": "0404484",
    "nama": "Madrasah Aliyah Al-Mubara",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "082291398359",
    "total_bulan": 15,
    "total_tagihan": 1187900,
    "total_denda": 75000,
    "total_jumlah": 1262900,
    "lat": 0.4621713,
    "lng": 121.9448636,
    "color": "#dc3545"
}, {
    "nosamw": "0401731",
    "nama": "Mahlar Poaloi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.466259,
    "lng": 121.963252,
    "color": "#28a745"
}, {
    "nosamw": "0400923",
    "nama": "Maimuna Hunta",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 671200,
    "total_denda": 30000,
    "total_jumlah": 701200,
    "lat": 0.456282,
    "lng": 121.956531,
    "color": "#fd7e14"
}, {
    "nosamw": "0402158",
    "nama": "Mardia Lontolo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 505000,
    "total_denda": 10000,
    "total_jumlah": 515000,
    "lat": 0.456727,
    "lng": 121.949702,
    "color": "#ffc107"
}, {
    "nosamw": "0407329",
    "nama": "MARDIANA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082211130559",
    "total_bulan": 14,
    "total_tagihan": 2543000,
    "total_denda": 70000,
    "total_jumlah": 2613000,
    "lat": 0.4595817,
    "lng": 121.9571733,
    "color": "#dc3545"
}, {
    "nosamw": "0401357",
    "nama": "Margiet Tien Tatara",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 516500,
    "total_denda": 35000,
    "total_jumlah": 551500,
    "lat": 0.463022,
    "lng": 121.951495,
    "color": "#dc3545"
}, {
    "nosamw": "0402371",
    "nama": "Mariam Ibrahim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1379000,
    "total_denda": 75000,
    "total_jumlah": 1454000,
    "lat": 0.462374,
    "lng": 121.951324,
    "color": "#dc3545"
}, {
    "nosamw": "0407257",
    "nama": "MARJAN RASID",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4608847,
    "lng": 121.949734,
    "color": "#ffc107"
}, {
    "nosamw": "0406376",
    "nama": "MARKAS DAMKAR POHUWATO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 790000,
    "total_denda": 5000,
    "total_jumlah": 795000,
    "lat": 0.4580371,
    "lng": 121.9448731,
    "color": "#ffc107"
}, {
    "nosamw": "0401890",
    "nama": "Marlen Lasantu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.466094,
    "lng": 121.962726,
    "color": "#ffc107"
}, {
    "nosamw": "0405981",
    "nama": "MARYAM ALI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4628546,
    "lng": 121.9640987,
    "color": "#ffc107"
}, {
    "nosamw": "0404376",
    "nama": "Maryam Busura",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 665500,
    "total_denda": 45000,
    "total_jumlah": 710500,
    "lat": 0.458808,
    "lng": 121.957428,
    "color": "#dc3545"
}, {
    "nosamw": "0402352",
    "nama": "Maryam Kiayi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.459337,
    "lng": 121.959565,
    "color": "#fd7e14"
}, {
    "nosamw": "0401659",
    "nama": "Maryam Tanaiyo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462819,
    "lng": 121.944424,
    "color": "#28a745"
}, {
    "nosamw": "0402200",
    "nama": "MARYANTO C.B.R",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 55000,
    "total_jumlah": 720000,
    "lat": 0.4637759,
    "lng": 121.9513295,
    "color": "#dc3545"
}, {
    "nosamw": "0404736",
    "nama": "MAS UD DJAMA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4593928,
    "lng": 121.9568586,
    "color": "#fd7e14"
}, {
    "nosamw": "0400822",
    "nama": "MASFIN UMAR",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 640000,
    "total_denda": 10000,
    "total_jumlah": 650000,
    "lat": 0.467479,
    "lng": 121.9544767,
    "color": "#fd7e14"
}, {
    "nosamw": "0407507",
    "nama": "MASJID AL-KAHFI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "082186080658",
    "total_bulan": 5,
    "total_tagihan": 292000,
    "total_denda": 20000,
    "total_jumlah": 312000,
    "lat": 0.460538,
    "lng": 121.9552375,
    "color": "#fd7e14"
}, {
    "nosamw": "0406107",
    "nama": "Masni Ibrahim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1063500,
    "total_denda": 25000,
    "total_jumlah": 1088500,
    "lat": 0.4619309,
    "lng": 121.9504082,
    "color": "#fd7e14"
}, {
    "nosamw": "0406177",
    "nama": "MASRITA J. DJ. MOHI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4641832,
    "lng": 121.9509185,
    "color": "#ffc107"
}, {
    "nosamw": "0402351",
    "nama": "Mega Anjili",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#28a745"
}, {
    "nosamw": "0402485",
    "nama": "Meilan Hengki Radjak",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 647500,
    "total_denda": 10000,
    "total_jumlah": 657500,
    "lat": 0.462037,
    "lng": 121.951151,
    "color": "#fd7e14"
}, {
    "nosamw": "0404269",
    "nama": "Meilan Sumuri",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4644263,
    "lng": 121.9518854,
    "color": "#ffc107"
}, {
    "nosamw": "0407479",
    "nama": "MEILANI SUKHARTI WAWORUNTU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "089535972290",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.4499206,
    "lng": 121.939326,
    "color": "#ffc107"
}, {
    "nosamw": "0405286",
    "nama": "MELDI SAM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 213200,
    "total_denda": 15000,
    "total_jumlah": 228200,
    "lat": 0.4649496,
    "lng": 121.9456551,
    "color": "#fd7e14"
}, {
    "nosamw": "0404318",
    "nama": "Melsia Thomasong",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 889000,
    "total_denda": 60000,
    "total_jumlah": 949000,
    "lat": 0.464561,
    "lng": 121.951963,
    "color": "#dc3545"
}, {
    "nosamw": "0401753",
    "nama": "Mercy Tichel Ahmad",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 812000,
    "total_denda": 20000,
    "total_jumlah": 832000,
    "lat": 0.4630575,
    "lng": 121.9489739,
    "color": "#fd7e14"
}, {
    "nosamw": "0402395",
    "nama": "Meri Salim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.461991,
    "lng": 121.950874,
    "color": "#fd7e14"
}, {
    "nosamw": "0401825",
    "nama": "Merlin Mbuinga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 281500,
    "total_denda": 20000,
    "total_jumlah": 301500,
    "lat": 0.4644798,
    "lng": 121.9492136,
    "color": "#fd7e14"
}, {
    "nosamw": "0404514",
    "nama": "Mes STIE ICHSAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464692,
    "lng": 121.948698,
    "color": "#28a745"
}, {
    "nosamw": "0401823",
    "nama": "Mesiyanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 6027500,
    "total_denda": 90000,
    "total_jumlah": 6117500,
    "lat": 0.4621197,
    "lng": 121.9500454,
    "color": "#dc3545"
}, {
    "nosamw": "0407393",
    "nama": "Mesjid Al-Falah Komunal Marisa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "082393832277",
    "total_bulan": 2,
    "total_tagihan": 9000,
    "total_denda": 5000,
    "total_jumlah": 14000,
    "lat": 0.4566782,
    "lng": 121.951485,
    "color": "#ffc107"
}, {
    "nosamw": "0407265",
    "nama": "MESVI LABARA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1169000,
    "total_denda": 30000,
    "total_jumlah": 1199000,
    "lat": 0.4638202,
    "lng": 121.9505104,
    "color": "#dc3545"
}, {
    "nosamw": "0401064",
    "nama": "Meyko Malik",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.46413,
    "lng": 121.948055,
    "color": "#ffc107"
}, {
    "nosamw": "0407408",
    "nama": "MIDUN MOHAMAD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085392125243",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4605142,
    "lng": 121.9495842,
    "color": "#ffc107"
}, {
    "nosamw": "0401992",
    "nama": "Mirawati Lukum",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.46252,
    "lng": 121.950947,
    "color": "#ffc107"
}, {
    "nosamw": "0407275",
    "nama": "Mirna Djafar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4631648,
    "lng": 121.9618602,
    "color": "#fd7e14"
}, {
    "nosamw": "0403619",
    "nama": "MIRWAN INAKU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 435000,
    "total_denda": 20000,
    "total_jumlah": 455000,
    "lat": 0.462326,
    "lng": 121.950574,
    "color": "#fd7e14"
}, {
    "nosamw": "0402196",
    "nama": "Misba",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.464256,
    "lng": 121.949607,
    "color": "#ffc107"
}, {
    "nosamw": "0401834",
    "nama": "Misdi Suji",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.463873,
    "lng": 121.949166,
    "color": "#fd7e14"
}, {
    "nosamw": "0401950",
    "nama": "Misnawati Butolo, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 246000,
    "total_denda": 15000,
    "total_jumlah": 261000,
    "lat": 0.4658873,
    "lng": 121.962848,
    "color": "#fd7e14"
}, {
    "nosamw": "0403577",
    "nama": "Misrah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.46333,
    "lng": 121.951627,
    "color": "#28a745"
}, {
    "nosamw": "0407412",
    "nama": "MOH FAHRI A. TUDA PERUM GALAXY BLOK F.21",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4589398,
    "lng": 121.9441414,
    "color": "#ffc107"
}, {
    "nosamw": "0401432",
    "nama": "Moh Hamka Tahang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 521000,
    "total_denda": 15000,
    "total_jumlah": 536000,
    "lat": 0.463403,
    "lng": 121.951857,
    "color": "#fd7e14"
}, {
    "nosamw": "0403012",
    "nama": "MOH. ALGIFARI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 927500,
    "total_denda": 75000,
    "total_jumlah": 1002500,
    "lat": 0.4559449,
    "lng": 121.9583346,
    "color": "#dc3545"
}, {
    "nosamw": "0402910",
    "nama": "Moh. Husen",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 905250,
    "total_denda": 25000,
    "total_jumlah": 930250,
    "lat": 0.464365,
    "lng": 121.951698,
    "color": "#fd7e14"
}, {
    "nosamw": "0400798",
    "nama": "Moh. R. Eka Putra",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.4641717,
    "lng": 121.9505444,
    "color": "#ffc107"
}, {
    "nosamw": "0402034",
    "nama": "MOH. RIYADI PANIGORO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.4638716,
    "lng": 121.9505957,
    "color": "#ffc107"
}, {
    "nosamw": "0406328",
    "nama": "MOH.TANG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 330500,
    "total_denda": 15000,
    "total_jumlah": 345500,
    "lat": 0.4638742,
    "lng": 121.9510595,
    "color": "#fd7e14"
}, {
    "nosamw": "0406810",
    "nama": "Mohamad Ali",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 274500,
    "total_denda": 5000,
    "total_jumlah": 279500,
    "lat": 0.4619602,
    "lng": 121.9514607,
    "color": "#ffc107"
}, {
    "nosamw": "0404438",
    "nama": "Mohamad Ntoi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1305000,
    "total_denda": 25000,
    "total_jumlah": 1330000,
    "lat": 0.463774,
    "lng": 121.951907,
    "color": "#fd7e14"
}, {
    "nosamw": "0405309",
    "nama": "MOHAMAD RIZAL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081295996479",
    "total_bulan": 4,
    "total_tagihan": 1395000,
    "total_denda": 15000,
    "total_jumlah": 1410000,
    "lat": 0.4873635,
    "lng": 121.9353136,
    "color": "#fd7e14"
}, {
    "nosamw": "0401954",
    "nama": "Mohamad Rizal 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1357500,
    "total_denda": 25000,
    "total_jumlah": 1382500,
    "lat": 0.465901,
    "lng": 121.9630947,
    "color": "#fd7e14"
}, {
    "nosamw": "0401871",
    "nama": "Mohamad Sukriady",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 344000,
    "total_denda": 20000,
    "total_jumlah": 364000,
    "lat": 0.4628026,
    "lng": 121.9507411,
    "color": "#fd7e14"
}, {
    "nosamw": "0402244",
    "nama": "Mohamad Tangahu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 35000,
    "total_jumlah": 420000,
    "lat": 0.462161,
    "lng": 121.95151,
    "color": "#dc3545"
}, {
    "nosamw": "0402487",
    "nama": "Moudy Yanny Gosal",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 244000,
    "total_denda": 5000,
    "total_jumlah": 249000,
    "lat": 0.46215,
    "lng": 121.951658,
    "color": "#ffc107"
}, {
    "nosamw": "0402162",
    "nama": "Muchlis Kai",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1705000,
    "total_denda": 75000,
    "total_jumlah": 1780000,
    "lat": 0.4640751,
    "lng": 121.947776,
    "color": "#dc3545"
}, {
    "nosamw": "0407278",
    "nama": "Muh. Arisnandar H",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081293729157",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4638961,
    "lng": 121.9503895,
    "color": "#ffc107"
}, {
    "nosamw": "0402501",
    "nama": "Muh. Hasyim Said",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 911500,
    "total_denda": 65000,
    "total_jumlah": 976500,
    "lat": 0.463447,
    "lng": 121.949212,
    "color": "#dc3545"
}, {
    "nosamw": "0403813",
    "nama": "Muhamad Sani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.463513,
    "lng": 121.951332,
    "color": "#ffc107"
}, {
    "nosamw": "0404640",
    "nama": "MUHAMMAD YUSUF",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1527500,
    "total_denda": 120000,
    "total_jumlah": 1647500,
    "lat": 0.4623946,
    "lng": 121.9507289,
    "color": "#dc3545"
}, {
    "nosamw": "0401146",
    "nama": "MUHARAM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4654916,
    "lng": 121.947237,
    "color": "#28a745"
}, {
    "nosamw": "0401628",
    "nama": "Muhklas Abror Tahir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 162000,
    "total_denda": 5000,
    "total_jumlah": 167000,
    "lat": 0.4643753,
    "lng": 121.9502614,
    "color": "#ffc107"
}, {
    "nosamw": "0401369",
    "nama": "Muhlis Abdul",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081241238063",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.4625353,
    "lng": 121.9473858,
    "color": "#ffc107"
}, {
    "nosamw": "0401958",
    "nama": "Muhlis D. Ambosaba",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 243000,
    "total_denda": 10000,
    "total_jumlah": 253000,
    "lat": 0.463309,
    "lng": 121.949129,
    "color": "#fd7e14"
}, {
    "nosamw": "0404347",
    "nama": "Muhtar Nusupu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 284400,
    "total_denda": 5000,
    "total_jumlah": 289400,
    "lat": 0.459083,
    "lng": 121.958919,
    "color": "#ffc107"
}, {
    "nosamw": "0402234",
    "nama": "Muksin A. Hanggi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 792500,
    "total_denda": 40000,
    "total_jumlah": 832500,
    "lat": 0.466024,
    "lng": 121.962859,
    "color": "#dc3545"
}, {
    "nosamw": "0401939",
    "nama": "Mukti Tapulu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 961500,
    "total_denda": 40000,
    "total_jumlah": 1001500,
    "lat": 0.466022,
    "lng": 121.9626395,
    "color": "#dc3545"
}, {
    "nosamw": "0402675",
    "nama": "Multiyana Arifyanti",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.462924,
    "lng": 121.950459,
    "color": "#ffc107"
}, {
    "nosamw": "0401333",
    "nama": "Mulyani Pulukadang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 698500,
    "total_denda": 35000,
    "total_jumlah": 733500,
    "lat": 0.464221,
    "lng": 121.948502,
    "color": "#dc3545"
}, {
    "nosamw": "0402316",
    "nama": "Mushola Ktr. Kejaksaan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.457469,
    "lng": 121.948575,
    "color": "#28a745"
}, {
    "nosamw": "0403579",
    "nama": "Muslimah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463133,
    "lng": 121.951873,
    "color": "#ffc107"
}, {
    "nosamw": "0401140",
    "nama": "Muslimin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082195027997",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.464202,
    "lng": 121.9506861,
    "color": "#ffc107"
}, {
    "nosamw": "0400610",
    "nama": "MUSTAFA YASIN.S.Pd.i",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "082152910851",
    "total_bulan": 8,
    "total_tagihan": 575000,
    "total_denda": 35000,
    "total_jumlah": 610000,
    "lat": 0.4587515,
    "lng": 121.9496869,
    "color": "#dc3545"
}, {
    "nosamw": "0403416",
    "nama": "Nanang Wijayanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1262500,
    "total_denda": 120000,
    "total_jumlah": 1382500,
    "lat": 0.46199,
    "lng": 121.950449,
    "color": "#dc3545"
}, {
    "nosamw": "0407540",
    "nama": "NANGSI NAPU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081347718362",
    "total_bulan": 3,
    "total_tagihan": 197500,
    "total_denda": 10000,
    "total_jumlah": 207500,
    "lat": 0.4567614,
    "lng": 121.9519895,
    "color": "#fd7e14"
}, {
    "nosamw": "0403041",
    "nama": "Nani Hulopi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.4662575,
    "lng": 121.959026,
    "color": "#ffc107"
}, {
    "nosamw": "0401672",
    "nama": "Nani Olii",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 622500,
    "total_denda": 0,
    "total_jumlah": 622500,
    "lat": 0.464477,
    "lng": 121.948876,
    "color": "#fd7e14"
}, {
    "nosamw": "0400211",
    "nama": "Naning Abubakar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462317,
    "lng": 121.963134,
    "color": "#28a745"
}, {
    "nosamw": "0402495",
    "nama": "Narty Olii",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 188000,
    "total_denda": 5000,
    "total_jumlah": 193000,
    "lat": 0.466219,
    "lng": 121.943715,
    "color": "#ffc107"
}, {
    "nosamw": "0401822",
    "nama": "Nasrudin Herlambang, S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.463145,
    "lng": 121.9486751,
    "color": "#ffc107"
}, {
    "nosamw": "0405982",
    "nama": "NEHEMIA RUSEL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 352500,
    "total_denda": 0,
    "total_jumlah": 352500,
    "lat": 0.457505,
    "lng": 121.9586622,
    "color": "#ffc107"
}, {
    "nosamw": "0402396",
    "nama": "Neno Djakaria",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 73200,
    "total_denda": 10000,
    "total_jumlah": 83200,
    "lat": 0.462473,
    "lng": 121.963277,
    "color": "#ffc107"
}, {
    "nosamw": "0403628",
    "nama": "Ni Kadek Adriani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 230000,
    "total_denda": 10000,
    "total_jumlah": 240000,
    "lat": 0.463988,
    "lng": 121.951762,
    "color": "#fd7e14"
}, {
    "nosamw": "0401924",
    "nama": "Ni Kadek Ernawati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.461991,
    "lng": 121.950803,
    "color": "#fd7e14"
}, {
    "nosamw": "0400338",
    "nama": "NI NYOMAN SURIYATI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.4625831,
    "lng": 121.947095,
    "color": "#ffc107"
}, {
    "nosamw": "0401843",
    "nama": "Nikson Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 692500,
    "total_denda": 25000,
    "total_jumlah": 717500,
    "lat": 0.464341,
    "lng": 121.949378,
    "color": "#fd7e14"
}, {
    "nosamw": "0402072",
    "nama": "Nining Lasena",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 5000,
    "total_jumlah": 128000,
    "lat": 0.465116,
    "lng": 121.946081,
    "color": "#ffc107"
}, {
    "nosamw": "0402020",
    "nama": "Ninsi D. J. Saleh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.461839,
    "lng": 121.950236,
    "color": "#ffc107"
}, {
    "nosamw": "0406181",
    "nama": "NOLDI BADU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4635683,
    "lng": 121.9487564,
    "color": "#ffc107"
}, {
    "nosamw": "0401919",
    "nama": "Noldi Gosal",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.463079,
    "lng": 121.950358,
    "color": "#ffc107"
}, {
    "nosamw": "0406233",
    "nama": "NOLDI MORSAL PATODO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1153000,
    "total_denda": 45000,
    "total_jumlah": 1198000,
    "lat": 0.4639306,
    "lng": 121.9504757,
    "color": "#dc3545"
}, {
    "nosamw": "0402319",
    "nama": "Noldi Weling",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 711500,
    "total_denda": 20000,
    "total_jumlah": 731500,
    "lat": 0.4645403,
    "lng": 121.9501929,
    "color": "#fd7e14"
}, {
    "nosamw": "0405168",
    "nama": "Noor Asief",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1324000,
    "total_denda": 25000,
    "total_jumlah": 1349000,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#dc3545"
}, {
    "nosamw": "0401898",
    "nama": "Novi Lahay",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 457500,
    "total_denda": 0,
    "total_jumlah": 457500,
    "lat": 0.463495,
    "lng": 121.94935,
    "color": "#ffc107"
}, {
    "nosamw": "0403366",
    "nama": "Nur Afiah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 12338250,
    "total_denda": 40000,
    "total_jumlah": 12378250,
    "lat": 0.460443,
    "lng": 121.961014,
    "color": "#dc3545"
}, {
    "nosamw": "0400263",
    "nama": "Nur Afni Katili",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 498000,
    "total_denda": 20000,
    "total_jumlah": 518000,
    "lat": 0.4645494,
    "lng": 121.9504502,
    "color": "#fd7e14"
}, {
    "nosamw": "0402416",
    "nama": "NUR ISMI RAMADHANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.4641472,
    "lng": 121.9514381,
    "color": "#ffc107"
}, {
    "nosamw": "0401337",
    "nama": "Nur Rafiah Hidayat",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 55000,
    "total_jumlah": 720000,
    "lat": 0.464451,
    "lng": 121.948602,
    "color": "#dc3545"
}, {
    "nosamw": "0403210",
    "nama": "Nur Rahman Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 217000,
    "total_denda": 10000,
    "total_jumlah": 227000,
    "lat": 0.463579,
    "lng": 121.951711,
    "color": "#fd7e14"
}, {
    "nosamw": "0402489",
    "nama": "Nurain Yahya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 484000,
    "total_denda": 35000,
    "total_jumlah": 519000,
    "lat": 0.463108,
    "lng": 121.9511799,
    "color": "#dc3545"
}, {
    "nosamw": "0402350",
    "nama": "Nurhaedah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 395000,
    "total_denda": 5000,
    "total_jumlah": 400000,
    "lat": 0.467028,
    "lng": 121.951618,
    "color": "#ffc107"
}, {
    "nosamw": "0402247",
    "nama": "Nurhayati,S.Si",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 665000,
    "total_denda": 55000,
    "total_jumlah": 720000,
    "lat": 0.4619658,
    "lng": 121.9514622,
    "color": "#dc3545"
}, {
    "nosamw": "0401192",
    "nama": "Nurinayah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 444000,
    "total_denda": 10000,
    "total_jumlah": 454000,
    "lat": 0.463577,
    "lng": 121.951752,
    "color": "#fd7e14"
}, {
    "nosamw": "0401757",
    "nama": "Nurlaila Abdurrahman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.463699,
    "lng": 121.949483,
    "color": "#ffc107"
}, {
    "nosamw": "0401758",
    "nama": "Nurleni Ihsan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 3752500,
    "total_denda": 95000,
    "total_jumlah": 3847500,
    "lat": 0.466025,
    "lng": 121.962945,
    "color": "#dc3545"
}, {
    "nosamw": "0401557",
    "nama": "Nurmala Nyoma",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1469000,
    "total_denda": 20000,
    "total_jumlah": 1489000,
    "lat": 0.464647,
    "lng": 121.948549,
    "color": "#fd7e14"
}, {
    "nosamw": "0402363",
    "nama": "Nurul Khairia Hulawa S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 396500,
    "total_denda": 15000,
    "total_jumlah": 411500,
    "lat": 0.465733,
    "lng": 121.962952,
    "color": "#fd7e14"
}, {
    "nosamw": "0402311",
    "nama": "Okky Farid Febrianto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.465816,
    "lng": 121.963135,
    "color": "#ffc107"
}, {
    "nosamw": "0401829",
    "nama": "Owen Sumendang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.464129,
    "lng": 121.94972,
    "color": "#ffc107"
}, {
    "nosamw": "0400073",
    "nama": "Owin S. Mohi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 4783000,
    "total_denda": 155000,
    "total_jumlah": 4938000,
    "lat": 0.4644932,
    "lng": 121.9502421,
    "color": "#dc3545"
}, {
    "nosamw": "0407411",
    "nama": "PARAMITA TINO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082196851118",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461835,
    "lng": 121.9448434,
    "color": "#28a745"
}, {
    "nosamw": "0400386",
    "nama": "Parman Pambi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 692000,
    "total_denda": 0,
    "total_jumlah": 692000,
    "lat": 0.4610801,
    "lng": 121.9617957,
    "color": "#ffc107"
}, {
    "nosamw": "0407548",
    "nama": "PAUD PEMBINA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "085342697830",
    "total_bulan": 3,
    "total_tagihan": 226000,
    "total_denda": 10000,
    "total_jumlah": 236000,
    "lat": 0.4605852,
    "lng": 121.9469988,
    "color": "#fd7e14"
}, {
    "nosamw": "0403961",
    "nama": "PENGINAPAN RITZ COLTON",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1142000,
    "total_denda": 0,
    "total_jumlah": 1142000,
    "lat": 0.4673309,
    "lng": 121.9552125,
    "color": "#ffc107"
}, {
    "nosamw": "0403735",
    "nama": "Perdi Tantu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3777500,
    "total_denda": 35000,
    "total_jumlah": 3812500,
    "lat": 0.457325,
    "lng": 121.949572,
    "color": "#dc3545"
}, {
    "nosamw": "0407369",
    "nama": "PERDI UMURI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1532000,
    "total_denda": 35000,
    "total_jumlah": 1567000,
    "lat": 0.4629357,
    "lng": 121.9634819,
    "color": "#dc3545"
}, {
    "nosamw": "0400090",
    "nama": "PERUM AL-FIRA BLOK A NO. 6",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 2315000,
    "total_denda": 115000,
    "total_jumlah": 2430000,
    "lat": 0.459801,
    "lng": 121.9551148,
    "color": "#dc3545"
}, {
    "nosamw": "0407543",
    "nama": "PERUM GALAXY \/ BLOK F.20",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081318512467",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4589465,
    "lng": 121.9442218,
    "color": "#ffc107"
}, {
    "nosamw": "0407544",
    "nama": "PERUM GALAXY \/ BLOK F.27",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.4588928,
    "lng": 121.9439744,
    "color": "#dc3545"
}, {
    "nosamw": "0407451",
    "nama": "PERUM GALAXY BLOK A. 4",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081355575558",
    "total_bulan": 5,
    "total_tagihan": 372500,
    "total_denda": 20000,
    "total_jumlah": 392500,
    "lat": 0.4592804,
    "lng": 121.9452928,
    "color": "#fd7e14"
}, {
    "nosamw": "0407425",
    "nama": "PERUM GALAXY BLOK F 24",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 7,
    "total_tagihan": 430500,
    "total_denda": 30000,
    "total_jumlah": 460500,
    "lat": 0.4588736,
    "lng": 121.943955,
    "color": "#dc3545"
}, {
    "nosamw": "0407426",
    "nama": "PERUM GALAXY BLOK F 25",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.458881,
    "lng": 121.9439254,
    "color": "#ffc107"
}, {
    "nosamw": "0407476",
    "nama": "PERUM GALAXY BLOK F. 26",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.4588962,
    "lng": 121.9439399,
    "color": "#ffc107"
}, {
    "nosamw": "0407413",
    "nama": "PERUM GALAXY BLOK F.22",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.459027,
    "lng": 121.9441452,
    "color": "#ffc107"
}, {
    "nosamw": "0407415",
    "nama": "PERUM GALAXY BLOK G.11",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 22,
    "total_tagihan": 1267000,
    "total_denda": 105000,
    "total_jumlah": 1372000,
    "lat": 0.4588408,
    "lng": 121.9439597,
    "color": "#dc3545"
}, {
    "nosamw": "0407414",
    "nama": "PERUM GALAXY BLOK G.5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 9,
    "total_tagihan": 513000,
    "total_denda": 40000,
    "total_jumlah": 553000,
    "lat": 0.4589898,
    "lng": 121.9443482,
    "color": "#dc3545"
}, {
    "nosamw": "0403883",
    "nama": "PERUM GALAXY BLOK G4",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4590072,
    "lng": 121.9443926,
    "color": "#ffc107"
}, {
    "nosamw": "0407475",
    "nama": "PERUM GALAXY BLOK G6",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356643421",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 5000,
    "total_jumlah": 118500,
    "lat": 0.4590361,
    "lng": 121.944314,
    "color": "#ffc107"
}, {
    "nosamw": "0404618",
    "nama": "Perum Griya Al-Fira Blok B No 6",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 605000,
    "total_denda": 50000,
    "total_jumlah": 655000,
    "lat": 0.4598724,
    "lng": 121.9551816,
    "color": "#dc3545"
}, {
    "nosamw": "0407497",
    "nama": "PERUM MEGA ZANUR \/ BLOK A.20",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4665326,
    "lng": 121.9641409,
    "color": "#ffc107"
}, {
    "nosamw": "0407457",
    "nama": "PERUM MEGA ZANUR \/ BLOK A.21",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 18,
    "total_tagihan": 1395500,
    "total_denda": 85000,
    "total_jumlah": 1480500,
    "lat": 0.4665205,
    "lng": 121.9641203,
    "color": "#dc3545"
}, {
    "nosamw": "0407454",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.01",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 17,
    "total_tagihan": 940000,
    "total_denda": 80000,
    "total_jumlah": 1020000,
    "lat": 0.4657013,
    "lng": 121.9632854,
    "color": "#dc3545"
}, {
    "nosamw": "0407455",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.03",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 5,
    "total_tagihan": 411500,
    "total_denda": 20000,
    "total_jumlah": 431500,
    "lat": 0.4658347,
    "lng": 121.9634723,
    "color": "#fd7e14"
}, {
    "nosamw": "0407467",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.04",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 16,
    "total_tagihan": 1247500,
    "total_denda": 75000,
    "total_jumlah": 1322500,
    "lat": 0.4658456,
    "lng": 121.9634685,
    "color": "#dc3545"
}, {
    "nosamw": "0407486",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.05",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 16,
    "total_tagihan": 885000,
    "total_denda": 75000,
    "total_jumlah": 960000,
    "lat": 0.4658784,
    "lng": 121.9638138,
    "color": "#dc3545"
}, {
    "nosamw": "0407487",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.06",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 16,
    "total_tagihan": 1149000,
    "total_denda": 75000,
    "total_jumlah": 1224000,
    "lat": 0.4658538,
    "lng": 121.963483,
    "color": "#dc3545"
}, {
    "nosamw": "0407472",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.29",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 10,
    "total_tagihan": 1064000,
    "total_denda": 45000,
    "total_jumlah": 1109000,
    "lat": 0.4655653,
    "lng": 121.9632315,
    "color": "#dc3545"
}, {
    "nosamw": "0407456",
    "nama": "PERUM MEGA ZANUR \/ BLOK D.30",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.4655492,
    "lng": 121.9633014,
    "color": "#fd7e14"
}, {
    "nosamw": "0407448",
    "nama": "perum YAHYA LAMONDA, SH 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081340801966",
    "total_bulan": 5,
    "total_tagihan": 307500,
    "total_denda": 20000,
    "total_jumlah": 327500,
    "lat": 0.4601486,
    "lng": 121.9560071,
    "color": "#fd7e14"
}, {
    "nosamw": "0407562",
    "nama": "PERUM ZANUR PARK \/ BLOK A.19",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 3,
    "total_tagihan": 236500,
    "total_denda": 10000,
    "total_jumlah": 246500,
    "lat": 0.4665081,
    "lng": 121.9640656,
    "color": "#fd7e14"
}, {
    "nosamw": "0407554",
    "nama": "PERUM ZANUR PARK \/ BLOK B1.06",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.4662136,
    "lng": 121.9635589,
    "color": "#fd7e14"
}, {
    "nosamw": "0407471",
    "nama": "PERUM ZANUR PARK B1.26 \/ FANDRI HAMZAH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.466135,
    "lng": 121.9634687,
    "color": "#dc3545"
}, {
    "nosamw": "0400637",
    "nama": "Petrus Timang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 20000,
    "total_jumlah": 295000,
    "lat": 0.464069,
    "lng": 121.947795,
    "color": "#fd7e14"
}, {
    "nosamw": "0401750",
    "nama": "PGMI jl.Anggrek Lia Fadilla",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.4644734,
    "lng": 121.9512304,
    "color": "#dc3545"
}, {
    "nosamw": "0405952",
    "nama": "POS JAGA KODIM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 5597500,
    "total_denda": 5000,
    "total_jumlah": 5602500,
    "lat": 0.4559497,
    "lng": 121.9506728,
    "color": "#dc3545"
}, {
    "nosamw": "0400336",
    "nama": "PURNAMA SARI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4638831,
    "lng": 121.9510504,
    "color": "#ffc107"
}, {
    "nosamw": "0403228",
    "nama": "PUSKESMAS MARISA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "PP",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1392000,
    "total_denda": 5000,
    "total_jumlah": 1397000,
    "lat": 0.463252,
    "lng": 121.9637873,
    "color": "#ffc107"
}, {
    "nosamw": "0403104",
    "nama": "R. Mulyanto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.462054,
    "lng": 121.950589,
    "color": "#ffc107"
}, {
    "nosamw": "0403021",
    "nama": "R.T.H. 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458708,
    "lng": 121.944925,
    "color": "#28a745"
}, {
    "nosamw": "0404563",
    "nama": "Rachmawati \/ Thalib",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1192500,
    "total_denda": 65000,
    "total_jumlah": 1257500,
    "lat": 0.46447,
    "lng": 121.951324,
    "color": "#dc3545"
}, {
    "nosamw": "0406360",
    "nama": "RACHMAWATI 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4644869,
    "lng": 121.9512593,
    "color": "#ffc107"
}, {
    "nosamw": "0401342",
    "nama": "Rafid M. Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 432500,
    "total_denda": 5000,
    "total_jumlah": 437500,
    "lat": 0.464647,
    "lng": 121.948549,
    "color": "#ffc107"
}, {
    "nosamw": "0401746",
    "nama": "RAFLIN HARAS",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4636945,
    "lng": 121.9489815,
    "color": "#ffc107"
}, {
    "nosamw": "0401826",
    "nama": "Rahmat Ma ruf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 288000,
    "total_denda": 20000,
    "total_jumlah": 308000,
    "lat": 0.4632523,
    "lng": 121.9489481,
    "color": "#fd7e14"
}, {
    "nosamw": "0400299",
    "nama": "Rahmat Mbuinga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 619000,
    "total_denda": 35000,
    "total_jumlah": 654000,
    "lat": 0.464469,
    "lng": 121.951851,
    "color": "#dc3545"
}, {
    "nosamw": "0402024",
    "nama": "Rahmawaty",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.461841,
    "lng": 121.950613,
    "color": "#ffc107"
}, {
    "nosamw": "0401728",
    "nama": "Rahmawaty Abd. Gani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 214000,
    "total_denda": 5000,
    "total_jumlah": 219000,
    "lat": 0.464148,
    "lng": 121.949633,
    "color": "#ffc107"
}, {
    "nosamw": "0401325",
    "nama": "Rahmawaty S",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1788000,
    "total_denda": 110000,
    "total_jumlah": 1898000,
    "lat": 0.458682,
    "lng": 121.951858,
    "color": "#dc3545"
}, {
    "nosamw": "0401783",
    "nama": "Rahmiyati Tangahu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 283000,
    "total_denda": 5000,
    "total_jumlah": 288000,
    "lat": 0.46411,
    "lng": 121.949501,
    "color": "#ffc107"
}, {
    "nosamw": "0403254",
    "nama": "Raimun Eraku",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 671000,
    "total_denda": 30000,
    "total_jumlah": 701000,
    "lat": 0.463146,
    "lng": 121.951703,
    "color": "#dc3545"
}, {
    "nosamw": "0405155",
    "nama": "RAMADAN ASE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1379000,
    "total_denda": 40000,
    "total_jumlah": 1419000,
    "lat": 0.4639522,
    "lng": 121.950127,
    "color": "#dc3545"
}, {
    "nosamw": "0401663",
    "nama": "Raman Saleh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 624000,
    "total_denda": 45000,
    "total_jumlah": 669000,
    "lat": 0.464353,
    "lng": 121.949132,
    "color": "#dc3545"
}, {
    "nosamw": "0406176",
    "nama": "RAMSES CHRESTERIO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 353000,
    "total_denda": 20000,
    "total_jumlah": 373000,
    "lat": 0.4620679,
    "lng": 121.9500967,
    "color": "#fd7e14"
}, {
    "nosamw": "0401908",
    "nama": "Ramyana Musra Nusa, S.Pt",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4631014,
    "lng": 121.9507412,
    "color": "#ffc107"
}, {
    "nosamw": "0404404",
    "nama": "Randy Alam Mamu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464007,
    "lng": 121.951745,
    "color": "#28a745"
}, {
    "nosamw": "0400358",
    "nama": "Rauf Guamo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.46326,
    "lng": 121.951486,
    "color": "#fd7e14"
}, {
    "nosamw": "0401756",
    "nama": "RAWINS SOGI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 287500,
    "total_denda": 5000,
    "total_jumlah": 292500,
    "lat": 0.463034,
    "lng": 121.9489,
    "color": "#ffc107"
}, {
    "nosamw": "0401839",
    "nama": "Raymon Polapa, SH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.4620822,
    "lng": 121.9508284,
    "color": "#dc3545"
}, {
    "nosamw": "0403580",
    "nama": "RD KEJAKSAAN NO. 17",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 136000,
    "total_denda": 5000,
    "total_jumlah": 141000,
    "lat": 0.4579628,
    "lng": 121.9493286,
    "color": "#ffc107"
}, {
    "nosamw": "0404899",
    "nama": "RD KEJAKSAAN NO. 18",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 375500,
    "total_denda": 25000,
    "total_jumlah": 400500,
    "lat": 0.4578572,
    "lng": 121.949241,
    "color": "#fd7e14"
}, {
    "nosamw": "0400164",
    "nama": "RD KEJAKSAAN NO. 19",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 50000,
    "total_jumlah": 660000,
    "lat": 0.4580253,
    "lng": 121.9491396,
    "color": "#dc3545"
}, {
    "nosamw": "0403059",
    "nama": "RD KEJAKSAAN NO. 20",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.457866,
    "lng": 121.9492118,
    "color": "#ffc107"
}, {
    "nosamw": "0402223",
    "nama": "RD Perwira Penghubung",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 3455000,
    "total_denda": 55000,
    "total_jumlah": 3510000,
    "lat": 0.458879,
    "lng": 121.945711,
    "color": "#dc3545"
}, {
    "nosamw": "0402304",
    "nama": "RD. Kejaksaan No 10",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2923500,
    "total_denda": 95000,
    "total_jumlah": 3018500,
    "lat": 0.457295,
    "lng": 121.949045,
    "color": "#dc3545"
}, {
    "nosamw": "0402303",
    "nama": "RD. Kejaksaan No 15",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 3148250,
    "total_denda": 105000,
    "total_jumlah": 3253250,
    "lat": 0.457515,
    "lng": 121.949186,
    "color": "#dc3545"
}, {
    "nosamw": "0402301",
    "nama": "RD. Kejaksaan No. 11",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 487500,
    "total_denda": 15000,
    "total_jumlah": 502500,
    "lat": 0.457438,
    "lng": 121.948775,
    "color": "#fd7e14"
}, {
    "nosamw": "0402300",
    "nama": "RD. Kejaksaan No. 12",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.457338,
    "lng": 121.949086,
    "color": "#ffc107"
}, {
    "nosamw": "0402307",
    "nama": "RD. Kejaksaan No. 13",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.457404,
    "lng": 121.949113,
    "color": "#fd7e14"
}, {
    "nosamw": "0402306",
    "nama": "RD. Kejaksaan No. 14",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.457432,
    "lng": 121.949175,
    "color": "#ffc107"
}, {
    "nosamw": "0402305",
    "nama": "RD. Kejaksaan No. 16",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 25000,
    "total_jumlah": 300000,
    "lat": 0.457563,
    "lng": 121.949205,
    "color": "#fd7e14"
}, {
    "nosamw": "0402302",
    "nama": "RD. Kejaksaan No. 9",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2170000,
    "total_denda": 95000,
    "total_jumlah": 2265000,
    "lat": 0.457422,
    "lng": 121.949153,
    "color": "#dc3545"
}, {
    "nosamw": "0405940",
    "nama": "RD. KODIM 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 2673000,
    "total_denda": 45000,
    "total_jumlah": 2718000,
    "lat": 0.4559314,
    "lng": 121.9506571,
    "color": "#dc3545"
}, {
    "nosamw": "0402711",
    "nama": "RD. KODIM 11",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 269000,
    "total_denda": 5000,
    "total_jumlah": 274000,
    "lat": 0.4556001,
    "lng": 121.9500587,
    "color": "#ffc107"
}, {
    "nosamw": "0400321",
    "nama": "RD. KODIM 12",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4556057,
    "lng": 121.9500629,
    "color": "#ffc107"
}, {
    "nosamw": "0400348",
    "nama": "RD. KODIM 13",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 343500,
    "total_denda": 15000,
    "total_jumlah": 358500,
    "lat": 0.4550928,
    "lng": 121.9498814,
    "color": "#fd7e14"
}, {
    "nosamw": "0403153",
    "nama": "RD. KODIM 14",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 56,
    "total_tagihan": 12596000,
    "total_denda": 275000,
    "total_jumlah": 12871000,
    "lat": 0.4551606,
    "lng": 121.9499725,
    "color": "#dc3545"
}, {
    "nosamw": "0405941",
    "nama": "RD. KODIM 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 15597500,
    "total_denda": 105000,
    "total_jumlah": 15702500,
    "lat": 0.4582018,
    "lng": 121.9495507,
    "color": "#dc3545"
}, {
    "nosamw": "0405945",
    "nama": "RD. KODIM 5",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 411500,
    "total_denda": 5000,
    "total_jumlah": 416500,
    "lat": 0.4555222,
    "lng": 121.9507337,
    "color": "#fd7e14"
}, {
    "nosamw": "0400240",
    "nama": "RD. PARAMEDIS 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 4583500,
    "total_denda": 30000,
    "total_jumlah": 4613500,
    "lat": 0.4633783,
    "lng": 121.9641767,
    "color": "#dc3545"
}, {
    "nosamw": "0403745",
    "nama": "RD. PARAMEDIS 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 720500,
    "total_denda": 20000,
    "total_jumlah": 740500,
    "lat": 0.4633676,
    "lng": 121.9642027,
    "color": "#fd7e14"
}, {
    "nosamw": "0401914",
    "nama": "Recky Pangalila",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 755000,
    "total_denda": 5000,
    "total_jumlah": 760000,
    "lat": 0.462867,
    "lng": 121.950676,
    "color": "#ffc107"
}, {
    "nosamw": "0407490",
    "nama": "REIN SUNGE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081240027186",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4623305,
    "lng": 121.962709,
    "color": "#ffc107"
}, {
    "nosamw": "0401896",
    "nama": "Reinold Agustinus Gandu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 522500,
    "total_denda": 5000,
    "total_jumlah": 527500,
    "lat": 0.462927,
    "lng": 121.950614,
    "color": "#ffc107"
}, {
    "nosamw": "0401339",
    "nama": "Retni Gani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 667500,
    "total_denda": 50000,
    "total_jumlah": 717500,
    "lat": 0.4648089,
    "lng": 121.9481554,
    "color": "#dc3545"
}, {
    "nosamw": "0401686",
    "nama": "Revina Sari",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 5000,
    "total_jumlah": 245000,
    "lat": 0.46228,
    "lng": 121.950197,
    "color": "#ffc107"
}, {
    "nosamw": "0404559",
    "nama": "Rifat Suweleh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4622043,
    "lng": 121.9464661,
    "color": "#ffc107"
}, {
    "nosamw": "0407404",
    "nama": "RIKA LAPUNCU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082393832277",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#28a745"
}, {
    "nosamw": "0407422",
    "nama": "RIKI M. BUMULO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "085242092983",
    "total_bulan": 3,
    "total_tagihan": 255000,
    "total_denda": 20000,
    "total_jumlah": 275000,
    "lat": 0.4625892,
    "lng": 121.9634209,
    "color": "#fd7e14"
}, {
    "nosamw": "0400852",
    "nama": "Rikmendi Yasin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.4641695,
    "lng": 121.9505232,
    "color": "#ffc107"
}, {
    "nosamw": "0400536",
    "nama": "Rini Pembengo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 675500,
    "total_denda": 25000,
    "total_jumlah": 700500,
    "lat": 0.463481,
    "lng": 121.949584,
    "color": "#fd7e14"
}, {
    "nosamw": "0402295",
    "nama": "Rini Tantu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 327000,
    "total_denda": 20000,
    "total_jumlah": 347000,
    "lat": 0.462114,
    "lng": 121.951721,
    "color": "#fd7e14"
}, {
    "nosamw": "0402749",
    "nama": "RISKI HUNOWU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 723000,
    "total_denda": 30000,
    "total_jumlah": 753000,
    "lat": 0.4631031,
    "lng": 121.9511766,
    "color": "#dc3545"
}, {
    "nosamw": "0400984",
    "nama": "Risman Muslim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.467084,
    "lng": 121.94953,
    "color": "#fd7e14"
}, {
    "nosamw": "0401827",
    "nama": "Risman Paulutu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.46248,
    "lng": 121.950842,
    "color": "#ffc107"
}, {
    "nosamw": "0402346",
    "nama": "Risna H. Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.461947,
    "lng": 121.950282,
    "color": "#fd7e14"
}, {
    "nosamw": "0402230",
    "nama": "Risno Latjengke",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 300000,
    "total_denda": 0,
    "total_jumlah": 300000,
    "lat": 0.463272,
    "lng": 121.950664,
    "color": "#ffc107"
}, {
    "nosamw": "0404395",
    "nama": "Riswan Lasimpala",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 555000,
    "total_denda": 45000,
    "total_jumlah": 600000,
    "lat": 0.464054,
    "lng": 121.952081,
    "color": "#dc3545"
}, {
    "nosamw": "0406617",
    "nama": "Riswanto Fitser G. Bokings",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4662094,
    "lng": 121.9639475,
    "color": "#ffc107"
}, {
    "nosamw": "0402518",
    "nama": "Rita Djakatara",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 125250,
    "total_denda": 5000,
    "total_jumlah": 130250,
    "lat": 0.4610542,
    "lng": 121.949819,
    "color": "#ffc107"
}, {
    "nosamw": "0401727",
    "nama": "Rizal Moniaga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.4643313,
    "lng": 121.9492405,
    "color": "#fd7e14"
}, {
    "nosamw": "0404261",
    "nama": "Rizan Mahadjani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 240000,
    "total_denda": 5000,
    "total_jumlah": 245000,
    "lat": 0.463401,
    "lng": 121.951775,
    "color": "#ffc107"
}, {
    "nosamw": "0406180",
    "nama": "RIZKA DAUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4641721,
    "lng": 121.9505246,
    "color": "#ffc107"
}, {
    "nosamw": "0401865",
    "nama": "Roihan S. Husain",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.463084,
    "lng": 121.951835,
    "color": "#ffc107"
}, {
    "nosamw": "0401560",
    "nama": "ROMAN ISMAIL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 411500,
    "total_denda": 20000,
    "total_jumlah": 431500,
    "lat": 0.4604456,
    "lng": 121.9551322,
    "color": "#fd7e14"
}, {
    "nosamw": "0400640",
    "nama": "Romi Hadju",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 547500,
    "total_denda": 30000,
    "total_jumlah": 577500,
    "lat": 0.4644155,
    "lng": 121.9475995,
    "color": "#dc3545"
}, {
    "nosamw": "0404356",
    "nama": "Ronal Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1218000,
    "total_denda": 40000,
    "total_jumlah": 1258000,
    "lat": 0.463593,
    "lng": 121.951824,
    "color": "#dc3545"
}, {
    "nosamw": "0402402",
    "nama": "Ronald Otolua S.Pi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 330500,
    "total_denda": 5000,
    "total_jumlah": 335500,
    "lat": 0.4630443,
    "lng": 121.9511624,
    "color": "#ffc107"
}, {
    "nosamw": "0405101",
    "nama": "RONALDI LANTI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 0,
    "total_jumlah": 120000,
    "lat": 0.464175,
    "lng": 121.9506062,
    "color": "#ffc107"
}, {
    "nosamw": "0406542",
    "nama": "RONI PANYILE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 604000,
    "total_denda": 40000,
    "total_jumlah": 644000,
    "lat": 0.4664583,
    "lng": 121.9638994,
    "color": "#dc3545"
}, {
    "nosamw": "0403584",
    "nama": "Rony Dumbi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 773000,
    "total_denda": 40000,
    "total_jumlah": 813000,
    "lat": 0.46363,
    "lng": 121.951292,
    "color": "#dc3545"
}, {
    "nosamw": "0401971",
    "nama": "Roshayat Zaenudin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 190000,
    "total_denda": 15000,
    "total_jumlah": 205000,
    "lat": 0.462853,
    "lng": 121.950754,
    "color": "#fd7e14"
}, {
    "nosamw": "0401075",
    "nama": "Roslina Mantu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 262500,
    "total_denda": 10000,
    "total_jumlah": 272500,
    "lat": 0.4641922,
    "lng": 121.9501878,
    "color": "#fd7e14"
}, {
    "nosamw": "0401103",
    "nama": "Rosni Kamumu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 831900,
    "total_denda": 10000,
    "total_jumlah": 841900,
    "lat": 0.466173,
    "lng": 121.945574,
    "color": "#ffc107"
}, {
    "nosamw": "0406344",
    "nama": "Rostin Biki",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085255566309",
    "total_bulan": 2,
    "total_tagihan": 253000,
    "total_denda": 5000,
    "total_jumlah": 258000,
    "lat": 0.4615409,
    "lng": 121.9443909,
    "color": "#ffc107"
}, {
    "nosamw": "0400074",
    "nama": "Roy Bakari \/ Perum G.M.I",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1165000,
    "total_denda": 25000,
    "total_jumlah": 1190000,
    "lat": 0.4631168,
    "lng": 121.9518498,
    "color": "#fd7e14"
}, {
    "nosamw": "0407375",
    "nama": "RS MULTAZAM",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "RU",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 12421000,
    "total_denda": 20000,
    "total_jumlah": 12441000,
    "lat": 0.4645898,
    "lng": 121.9634169,
    "color": "#fd7e14"
}, {
    "nosamw": "0401953",
    "nama": "Rudin Dawanggi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 458000,
    "total_denda": 35000,
    "total_jumlah": 493000,
    "lat": 0.466284,
    "lng": 121.962753,
    "color": "#dc3545"
}, {
    "nosamw": "0400723",
    "nama": "Ruhmi Sulaehani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 412500,
    "total_denda": 0,
    "total_jumlah": 412500,
    "lat": 0.4644652,
    "lng": 121.9506812,
    "color": "#ffc107"
}, {
    "nosamw": "0401493",
    "nama": "Ruko Mawar Sharon 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4654916,
    "lng": 121.947237,
    "color": "#28a745"
}, {
    "nosamw": "0407285",
    "nama": "RUKO Mawar Sharon 3",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 631500,
    "total_denda": 75000,
    "total_jumlah": 706500,
    "lat": 0.4642279,
    "lng": 121.9474118,
    "color": "#fd7e14"
}, {
    "nosamw": "0401554",
    "nama": "RULLI HUNTA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 503500,
    "total_denda": 35000,
    "total_jumlah": 538500,
    "lat": 0.4645749,
    "lng": 121.9474887,
    "color": "#dc3545"
}, {
    "nosamw": "0401785",
    "nama": "Rusdin Rahman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 178000,
    "total_denda": 10000,
    "total_jumlah": 188000,
    "lat": 0.46436,
    "lng": 121.949469,
    "color": "#fd7e14"
}, {
    "nosamw": "0401678",
    "nama": "Rusdiyanto B",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 469500,
    "total_denda": 30000,
    "total_jumlah": 499500,
    "lat": 0.464265,
    "lng": 121.949336,
    "color": "#dc3545"
}, {
    "nosamw": "0407377",
    "nama": "RUSLAN HASAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082343457472",
    "total_bulan": 4,
    "total_tagihan": 408500,
    "total_denda": 15000,
    "total_jumlah": 423500,
    "lat": 0.4602665,
    "lng": 121.9605255,
    "color": "#fd7e14"
}, {
    "nosamw": "0401968",
    "nama": "Rusli Kandang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 411000,
    "total_denda": 30000,
    "total_jumlah": 441000,
    "lat": 0.463047,
    "lng": 121.950739,
    "color": "#dc3545"
}, {
    "nosamw": "0406338",
    "nama": "Rusmulyadi, MH",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 197500,
    "total_denda": 10000,
    "total_jumlah": 207500,
    "lat": 0.4659178,
    "lng": 121.9516112,
    "color": "#fd7e14"
}, {
    "nosamw": "0402478",
    "nama": "Rusni Soleman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 243000,
    "total_denda": 10000,
    "total_jumlah": 253000,
    "lat": 0.461802,
    "lng": 121.951482,
    "color": "#fd7e14"
}, {
    "nosamw": "0401846",
    "nama": "S. Putu Rauh",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 701500,
    "total_denda": 40000,
    "total_jumlah": 741500,
    "lat": 0.462662,
    "lng": 121.950791,
    "color": "#dc3545"
}, {
    "nosamw": "0401625",
    "nama": "Safriati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1560500,
    "total_denda": 85000,
    "total_jumlah": 1645500,
    "lat": 0.46412,
    "lng": 121.95159,
    "color": "#dc3545"
}, {
    "nosamw": "0405161",
    "nama": "SAHRIL BAGU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 5000,
    "total_jumlah": 128000,
    "lat": 0.4644809,
    "lng": 121.9512407,
    "color": "#ffc107"
}, {
    "nosamw": "0401344",
    "nama": "Saiful Anam",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 243000,
    "total_denda": 10000,
    "total_jumlah": 253000,
    "lat": 0.464002,
    "lng": 121.948864,
    "color": "#fd7e14"
}, {
    "nosamw": "0402096",
    "nama": "Saiful Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.466635,
    "lng": 121.949521,
    "color": "#fd7e14"
}, {
    "nosamw": "0404308",
    "nama": "Saleh Ahmad Bumulo 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "082292111859",
    "total_bulan": 1,
    "total_tagihan": 2604000,
    "total_denda": 5000,
    "total_jumlah": 2609000,
    "lat": 0.4630898,
    "lng": 121.9636072,
    "color": "#ffc107"
}, {
    "nosamw": "0403616",
    "nama": "Saleh Kani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 384000,
    "total_denda": 20000,
    "total_jumlah": 404000,
    "lat": 0.460066,
    "lng": 121.960442,
    "color": "#fd7e14"
}, {
    "nosamw": "0404240",
    "nama": "Salma Abdullah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 11838250,
    "total_denda": 90000,
    "total_jumlah": 11928250,
    "lat": 0.463645,
    "lng": 121.951812,
    "color": "#dc3545"
}, {
    "nosamw": "0402536",
    "nama": "Salma Ibrahim",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462035,
    "lng": 121.950579,
    "color": "#ffc107"
}, {
    "nosamw": "0400663",
    "nama": "Salma Nento",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 208000,
    "total_denda": 20000,
    "total_jumlah": 228000,
    "lat": 0.466258,
    "lng": 121.94606,
    "color": "#fd7e14"
}, {
    "nosamw": "0402521",
    "nama": "Salman Abjul",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4617905,
    "lng": 121.9517719,
    "color": "#ffc107"
}, {
    "nosamw": "0405983",
    "nama": "SALMAWATI MOHA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 661500,
    "total_denda": 30000,
    "total_jumlah": 691500,
    "lat": 0.4580302,
    "lng": 121.9591148,
    "color": "#fd7e14"
}, {
    "nosamw": "0405173",
    "nama": "Samsul Bachri",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.464202,
    "lng": 121.9507283,
    "color": "#fd7e14"
}, {
    "nosamw": "0405189",
    "nama": "SAMUEL SITUMORANG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 868000,
    "total_denda": 30000,
    "total_jumlah": 898000,
    "lat": 0.4673236,
    "lng": 121.9551178,
    "color": "#dc3545"
}, {
    "nosamw": "0404467",
    "nama": "Sandil Sabanari",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 356500,
    "total_denda": 15000,
    "total_jumlah": 371500,
    "lat": 0.463829,
    "lng": 121.951822,
    "color": "#fd7e14"
}, {
    "nosamw": "0403585",
    "nama": "Sappeani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 711000,
    "total_denda": 30000,
    "total_jumlah": 741000,
    "lat": 0.46225,
    "lng": 121.950475,
    "color": "#dc3545"
}, {
    "nosamw": "0406178",
    "nama": "Saraswaty HAnapi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 288000,
    "total_denda": 20000,
    "total_jumlah": 308000,
    "lat": 0.4641766,
    "lng": 121.9510837,
    "color": "#fd7e14"
}, {
    "nosamw": "0406644",
    "nama": "SARMAN MAKAHINDA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 398000,
    "total_denda": 30000,
    "total_jumlah": 428000,
    "lat": 0.4639372,
    "lng": 121.9505001,
    "color": "#dc3545"
}, {
    "nosamw": "0404448",
    "nama": "Sarmin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464265,
    "lng": 121.951657,
    "color": "#ffc107"
}, {
    "nosamw": "0404709",
    "nama": "Sartin Ismail",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 247800,
    "total_denda": 30000,
    "total_jumlah": 277800,
    "lat": 0.4662838,
    "lng": 121.9589655,
    "color": "#dc3545"
}, {
    "nosamw": "0402836",
    "nama": "Satria Bahsoan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 4240000,
    "total_denda": 60000,
    "total_jumlah": 4300000,
    "lat": 0.459295,
    "lng": 121.955197,
    "color": "#dc3545"
}, {
    "nosamw": "0406078",
    "nama": "SAYUF MOHUNE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 366000,
    "total_denda": 20000,
    "total_jumlah": 386000,
    "lat": 0.4578093,
    "lng": 121.9587573,
    "color": "#fd7e14"
}, {
    "nosamw": "0401179",
    "nama": "Selvi Lukum",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 333500,
    "total_denda": 5000,
    "total_jumlah": 338500,
    "lat": 0.463667,
    "lng": 121.951855,
    "color": "#ffc107"
}, {
    "nosamw": "0400302",
    "nama": "SERLI KATILI, SE ( ADIRA )",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 224000,
    "total_denda": 0,
    "total_jumlah": 224000,
    "lat": 0.4639512,
    "lng": 121.9471653,
    "color": "#ffc107"
}, {
    "nosamw": "0406179",
    "nama": "SHODIKIN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4641755,
    "lng": 121.950826,
    "color": "#fd7e14"
}, {
    "nosamw": "0403622",
    "nama": "Si Buyung Pauweni",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464164,
    "lng": 121.949442,
    "color": "#28a745"
}, {
    "nosamw": "0404094",
    "nama": "SILCENANG APADJULU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.4619196,
    "lng": 121.9504071,
    "color": "#fd7e14"
}, {
    "nosamw": "0407441",
    "nama": "SILVANA PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081252521619",
    "total_bulan": 11,
    "total_tagihan": 818000,
    "total_denda": 50000,
    "total_jumlah": 868000,
    "lat": 0.46573,
    "lng": 121.9633321,
    "color": "#dc3545"
}, {
    "nosamw": "0407267",
    "nama": "SILVERA GANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4625529,
    "lng": 121.9511779,
    "color": "#ffc107"
}, {
    "nosamw": "0402368",
    "nama": "Silvera S. Gani",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.46295,
    "lng": 121.950786,
    "color": "#ffc107"
}, {
    "nosamw": "0400217",
    "nama": "Sipora Ester Rorong",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4645358,
    "lng": 121.9508433,
    "color": "#ffc107"
}, {
    "nosamw": "0404360",
    "nama": "Siti AD. Puriyana",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464301,
    "lng": 121.951771,
    "color": "#ffc107"
}, {
    "nosamw": "0400357",
    "nama": "Siti Diana",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.463628,
    "lng": 121.951817,
    "color": "#ffc107"
}, {
    "nosamw": "0400658",
    "nama": "Sofyan Niati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.464256,
    "lng": 121.949607,
    "color": "#ffc107"
}, {
    "nosamw": "0405280",
    "nama": "Sofyan Siswanto E. Dama",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1023000,
    "total_denda": 45000,
    "total_jumlah": 1068000,
    "lat": 0.4640591,
    "lng": 121.9517323,
    "color": "#dc3545"
}, {
    "nosamw": "0407561",
    "nama": "SONNI  SAMOE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356243562",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.4638735,
    "lng": 121.9510495,
    "color": "#ffc107"
}, {
    "nosamw": "0403009",
    "nama": "Spencer H. Mandang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 483000,
    "total_denda": 20000,
    "total_jumlah": 503000,
    "lat": 0.462257,
    "lng": 121.950362,
    "color": "#fd7e14"
}, {
    "nosamw": "0400218",
    "nama": "Sri Darma T. Hunowu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1263500,
    "total_denda": 20000,
    "total_jumlah": 1283500,
    "lat": 0.4644998,
    "lng": 121.9507657,
    "color": "#fd7e14"
}, {
    "nosamw": "0402185",
    "nama": "SRI DAYANI ISMAIL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1001500,
    "total_denda": 85000,
    "total_jumlah": 1086500,
    "lat": 0.4870552,
    "lng": 121.9342961,
    "color": "#dc3545"
}, {
    "nosamw": "0404406",
    "nama": "Sri Endang Maku",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 4140000,
    "total_denda": 30000,
    "total_jumlah": 4170000,
    "lat": 0.4629,
    "lng": 121.95046,
    "color": "#dc3545"
}, {
    "nosamw": "0404756",
    "nama": "SRI MARTHALIA MOHAMAD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 171500,
    "total_denda": 10000,
    "total_jumlah": 181500,
    "lat": 0.462839,
    "lng": 121.950438,
    "color": "#fd7e14"
}, {
    "nosamw": "0402379",
    "nama": "Sri Ningsih Mbuinga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1005500,
    "total_denda": 30000,
    "total_jumlah": 1035500,
    "lat": 0.462457,
    "lng": 121.950462,
    "color": "#dc3545"
}, {
    "nosamw": "0400337",
    "nama": "Sri Rama Makunta",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 343000,
    "total_denda": 25000,
    "total_jumlah": 368000,
    "lat": 0.46388,
    "lng": 121.951784,
    "color": "#fd7e14"
}, {
    "nosamw": "0407466",
    "nama": "SRI SUSANTI HULOPI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085394602880",
    "total_bulan": 10,
    "total_tagihan": 1303500,
    "total_denda": 45000,
    "total_jumlah": 1348500,
    "lat": 0.4645905,
    "lng": 121.9634068,
    "color": "#dc3545"
}, {
    "nosamw": "0401853",
    "nama": "SRI WAHYUNI SAID",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4636937,
    "lng": 121.9486891,
    "color": "#fd7e14"
}, {
    "nosamw": "0402030",
    "nama": "Sriwahyuni Pilomonu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1399000,
    "total_denda": 50000,
    "total_jumlah": 1449000,
    "lat": 0.463012,
    "lng": 121.950771,
    "color": "#dc3545"
}, {
    "nosamw": "0402036",
    "nama": "Sriwahyuni S.Farm. Apt",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081357889270",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462179,
    "lng": 121.950753,
    "color": "#ffc107"
}, {
    "nosamw": "0402186",
    "nama": "Sriyolan Abas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4643529,
    "lng": 121.9492499,
    "color": "#fd7e14"
}, {
    "nosamw": "0401835",
    "nama": "SRY MIRANTY POTABUGA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 301000,
    "total_denda": 20000,
    "total_jumlah": 321000,
    "lat": 0.4633136,
    "lng": 121.9490234,
    "color": "#fd7e14"
}, {
    "nosamw": "0403803",
    "nama": "St Aisyah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.461929,
    "lng": 121.950504,
    "color": "#ffc107"
}, {
    "nosamw": "0402479",
    "nama": "St Aisyah II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.461977,
    "lng": 121.951339,
    "color": "#28a745"
}, {
    "nosamw": "0404715",
    "nama": "Stevanus Tomasong",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 658000,
    "total_denda": 30000,
    "total_jumlah": 688000,
    "lat": 0.464278,
    "lng": 121.951837,
    "color": "#dc3545"
}, {
    "nosamw": "0404521",
    "nama": "Suci Megawati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 236500,
    "total_denda": 10000,
    "total_jumlah": 246500,
    "lat": 0.464719,
    "lng": 121.951502,
    "color": "#fd7e14"
}, {
    "nosamw": "0404303",
    "nama": "Sudarmin",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2037500,
    "total_denda": 20000,
    "total_jumlah": 2057500,
    "lat": 0.463033,
    "lng": 121.951758,
    "color": "#fd7e14"
}, {
    "nosamw": "0404517",
    "nama": "Sudirman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 294500,
    "total_denda": 20000,
    "total_jumlah": 314500,
    "lat": 0.4630898,
    "lng": 121.9516441,
    "color": "#fd7e14"
}, {
    "nosamw": "0400494",
    "nama": "SUGIANTO SUDJARNO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4757852,
    "lng": 121.9320621,
    "color": "#ffc107"
}, {
    "nosamw": "0400814",
    "nama": "Sugito",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.4645364,
    "lng": 121.950734,
    "color": "#ffc107"
}, {
    "nosamw": "0401903",
    "nama": "Suharmi Hamid",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 262500,
    "total_denda": 0,
    "total_jumlah": 262500,
    "lat": 0.462576,
    "lng": 121.950822,
    "color": "#ffc107"
}, {
    "nosamw": "0402260",
    "nama": "Suharpina N.Talib",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 195000,
    "total_denda": 0,
    "total_jumlah": 195000,
    "lat": 0.460552,
    "lng": 121.960741,
    "color": "#ffc107"
}, {
    "nosamw": "0402348",
    "nama": "Suhartin Mahanggi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.462034,
    "lng": 121.951247,
    "color": "#ffc107"
}, {
    "nosamw": "0404070",
    "nama": "SUKARMAN SUYITNO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 500000,
    "total_denda": 40000,
    "total_jumlah": 540000,
    "lat": 0.4630829,
    "lng": 121.9516279,
    "color": "#dc3545"
}, {
    "nosamw": "0403212",
    "nama": "Sukawati",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 116500,
    "total_denda": 5000,
    "total_jumlah": 121500,
    "lat": 0.464061,
    "lng": 121.951813,
    "color": "#ffc107"
}, {
    "nosamw": "0400459",
    "nama": "Suleman Lone",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.458658,
    "lng": 121.95164,
    "color": "#28a745"
}, {
    "nosamw": "0405986",
    "nama": "SULEMAN SABANI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4630171,
    "lng": 121.9462079,
    "color": "#28a745"
}, {
    "nosamw": "0406370",
    "nama": "Suleman Yusuf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.4639335,
    "lng": 121.9506871,
    "color": "#fd7e14"
}, {
    "nosamw": "0400429",
    "nama": "Suleman,SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1782500,
    "total_denda": 40000,
    "total_jumlah": 1822500,
    "lat": 0.4639127,
    "lng": 121.9484979,
    "color": "#dc3545"
}, {
    "nosamw": "0400799",
    "nama": "Sulfianty",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4638736,
    "lng": 121.9510159,
    "color": "#ffc107"
}, {
    "nosamw": "0401969",
    "nama": "Sulianti Igrisa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.463109,
    "lng": 121.950632,
    "color": "#fd7e14"
}, {
    "nosamw": "0403096",
    "nama": "Sumarno Kaiman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1151000,
    "total_denda": 80000,
    "total_jumlah": 1231000,
    "lat": 0.462337,
    "lng": 121.950648,
    "color": "#dc3545"
}, {
    "nosamw": "0404659",
    "nama": "Sumiaty",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.464131,
    "lng": 121.95145,
    "color": "#28a745"
}, {
    "nosamw": "0403805",
    "nama": "Sumitro Jimmi Harun",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1176000,
    "total_denda": 40000,
    "total_jumlah": 1216000,
    "lat": 0.463149,
    "lng": 121.951681,
    "color": "#dc3545"
}, {
    "nosamw": "0401962",
    "nama": "SUPARMIN POU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1355500,
    "total_denda": 45000,
    "total_jumlah": 1400500,
    "lat": 0.4615821,
    "lng": 121.9510952,
    "color": "#dc3545"
}, {
    "nosamw": "0407553",
    "nama": "SUPARMIN POU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085240728882",
    "total_bulan": 6,
    "total_tagihan": 593500,
    "total_denda": 25000,
    "total_jumlah": 618500,
    "lat": 0.4625338,
    "lng": 121.9490469,
    "color": "#fd7e14"
}, {
    "nosamw": "0402262",
    "nama": "Supriadi Kaiha",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1395000,
    "total_denda": 40000,
    "total_jumlah": 1435000,
    "lat": 0.462221,
    "lng": 121.950801,
    "color": "#dc3545"
}, {
    "nosamw": "0406085",
    "nama": "SUPRIN LAHAY",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 205000,
    "total_denda": 15000,
    "total_jumlah": 220000,
    "lat": 0.4662477,
    "lng": 121.957484,
    "color": "#fd7e14"
}, {
    "nosamw": "0406477",
    "nama": "SUPRIYANTO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4631829,
    "lng": 121.9447348,
    "color": "#ffc107"
}, {
    "nosamw": "0403734",
    "nama": "Supriyanto Tou",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464982,
    "lng": 121.946926,
    "color": "#ffc107"
}, {
    "nosamw": "0401266",
    "nama": "Surahman",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 492500,
    "total_denda": 10000,
    "total_jumlah": 502500,
    "lat": 0.4638969,
    "lng": 121.9504231,
    "color": "#fd7e14"
}, {
    "nosamw": "0401148",
    "nama": "Suriyati Kadir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.4641034,
    "lng": 121.9513872,
    "color": "#ffc107"
}, {
    "nosamw": "0402349",
    "nama": "Susilo S.Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 150000,
    "total_denda": 0,
    "total_jumlah": 150000,
    "lat": 0.462424,
    "lng": 121.95122,
    "color": "#ffc107"
}, {
    "nosamw": "0401286",
    "nama": "Sutami Nusu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 254000,
    "total_denda": 5000,
    "total_jumlah": 259000,
    "lat": 0.4645135,
    "lng": 121.950288,
    "color": "#ffc107"
}, {
    "nosamw": "0401912",
    "nama": "Sutisna Modanggu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 623500,
    "total_denda": 40000,
    "total_jumlah": 663500,
    "lat": 0.462558,
    "lng": 121.950308,
    "color": "#dc3545"
}, {
    "nosamw": "0401167",
    "nama": "Sutrisni Idji, S. Pd",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 451500,
    "total_denda": 35000,
    "total_jumlah": 486500,
    "lat": 0.4641508,
    "lng": 121.9482213,
    "color": "#dc3545"
}, {
    "nosamw": "0400754",
    "nama": "Sutrisno Luma",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1375000,
    "total_denda": 125000,
    "total_jumlah": 1500000,
    "lat": 0.46347,
    "lng": 121.951456,
    "color": "#dc3545"
}, {
    "nosamw": "0404275",
    "nama": "Sutrisno Puluhulawa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1020000,
    "total_denda": 100000,
    "total_jumlah": 1120000,
    "lat": 0.463648,
    "lng": 121.951729,
    "color": "#dc3545"
}, {
    "nosamw": "0402455",
    "nama": "Syam Rasa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.46216,
    "lng": 121.950787,
    "color": "#ffc107"
}, {
    "nosamw": "0401619",
    "nama": "Syamsiah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.463849,
    "lng": 121.9510072,
    "color": "#ffc107"
}, {
    "nosamw": "0402449",
    "nama": "Syamsidar SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 282000,
    "total_denda": 10000,
    "total_jumlah": 292000,
    "lat": 0.462254,
    "lng": 121.950789,
    "color": "#fd7e14"
}, {
    "nosamw": "0400420",
    "nama": "Syamsu Rizal Naer",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 558500,
    "total_denda": 40000,
    "total_jumlah": 598500,
    "lat": 0.462203,
    "lng": 121.950511,
    "color": "#dc3545"
}, {
    "nosamw": "0402357",
    "nama": "Syamsuar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 50000,
    "total_jumlah": 660000,
    "lat": 0.461981,
    "lng": 121.951209,
    "color": "#dc3545"
}, {
    "nosamw": "0403621",
    "nama": "Syamsul Bahri Lasabang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 941000,
    "total_denda": 50000,
    "total_jumlah": 991000,
    "lat": 0.4651702,
    "lng": 121.9486137,
    "color": "#dc3545"
}, {
    "nosamw": "0403042",
    "nama": "Syane Roring",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465294,
    "lng": 121.945314,
    "color": "#28a745"
}, {
    "nosamw": "0402520",
    "nama": "Syansudin Ayuwa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1402000,
    "total_denda": 30000,
    "total_jumlah": 1432000,
    "lat": 0.4665798,
    "lng": 121.9590594,
    "color": "#dc3545"
}, {
    "nosamw": "0404473",
    "nama": "Syarviardi Sukardeni",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 285000,
    "total_denda": 15000,
    "total_jumlah": 300000,
    "lat": 0.463901,
    "lng": 121.951814,
    "color": "#fd7e14"
}, {
    "nosamw": "0401301",
    "nama": "T. Daeng Ngabeng",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 207500,
    "total_denda": 5000,
    "total_jumlah": 212500,
    "lat": 0.463537,
    "lng": 121.951341,
    "color": "#ffc107"
}, {
    "nosamw": "0405009",
    "nama": "TAMAN MESJID AGUNG",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4626226,
    "lng": 121.9471538,
    "color": "#28a745"
}, {
    "nosamw": "0400684",
    "nama": "TAMAN PEMUDA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 121000,
    "total_denda": 5000,
    "total_jumlah": 126000,
    "lat": 0.4586199,
    "lng": 121.9485513,
    "color": "#ffc107"
}, {
    "nosamw": "0400578",
    "nama": "Tamsil Palahuata",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1278000,
    "total_denda": 45000,
    "total_jumlah": 1323000,
    "lat": 0.466909,
    "lng": 121.950191,
    "color": "#dc3545"
}, {
    "nosamw": "0403083",
    "nama": "Tamsir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 5000,
    "total_jumlah": 147500,
    "lat": 0.463269,
    "lng": 121.949061,
    "color": "#ffc107"
}, {
    "nosamw": "0405994",
    "nama": "TANIS DALANGGO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 240400,
    "total_denda": 10000,
    "total_jumlah": 250400,
    "lat": 0.4596825,
    "lng": 121.9540399,
    "color": "#fd7e14"
}, {
    "nosamw": "0405183",
    "nama": "TASNI DUNGGIO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 317500,
    "total_denda": 15000,
    "total_jumlah": 332500,
    "lat": 0.464868,
    "lng": 121.9448568,
    "color": "#fd7e14"
}, {
    "nosamw": "0401544",
    "nama": "Tati Ferawati Noor",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 247500,
    "total_denda": 0,
    "total_jumlah": 247500,
    "lat": 0.4642156,
    "lng": 121.9507528,
    "color": "#ffc107"
}, {
    "nosamw": "0407405",
    "nama": "TAUPIK RIZKI MUSTAPA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356325588",
    "total_bulan": 17,
    "total_tagihan": 966000,
    "total_denda": 80000,
    "total_jumlah": 1046000,
    "lat": 0.4637088,
    "lng": 121.9502363,
    "color": "#dc3545"
}, {
    "nosamw": "0402655",
    "nama": "Tedi Hunowu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.465143,
    "lng": 121.945183,
    "color": "#28a745"
}, {
    "nosamw": "0404512",
    "nama": "Tejo Mudini",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2641500,
    "total_denda": 65000,
    "total_jumlah": 2706500,
    "lat": 0.463341,
    "lng": 121.951974,
    "color": "#dc3545"
}, {
    "nosamw": "0402725",
    "nama": "Teti Gau",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462787,
    "lng": 121.950683,
    "color": "#28a745"
}, {
    "nosamw": "0406733",
    "nama": "Tety Tanggomo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 283000,
    "total_denda": 5000,
    "total_jumlah": 288000,
    "lat": 0.4627144,
    "lng": 121.9511587,
    "color": "#ffc107"
}, {
    "nosamw": "0401963",
    "nama": "Threice L. Tungkangnaung",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 511000,
    "total_denda": 10000,
    "total_jumlah": 521000,
    "lat": 0.462031,
    "lng": 121.950529,
    "color": "#fd7e14"
}, {
    "nosamw": "0404727",
    "nama": "TPS BLH Pohuwato",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 630600,
    "total_denda": 70000,
    "total_jumlah": 700600,
    "lat": 0.462028,
    "lng": 121.951292,
    "color": "#dc3545"
}, {
    "nosamw": "0406818",
    "nama": "TPS BLH POHUWATO 2",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 485000,
    "total_denda": 70000,
    "total_jumlah": 555000,
    "lat": 0.4627098,
    "lng": 121.95014,
    "color": "#dc3545"
}, {
    "nosamw": "0401913",
    "nama": "Tris Ma ruf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4628143,
    "lng": 121.951121,
    "color": "#ffc107"
}, {
    "nosamw": "0400749",
    "nama": "Trisye D. Rumopa",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 480500,
    "total_denda": 10000,
    "total_jumlah": 490500,
    "lat": 0.464563,
    "lng": 121.95021,
    "color": "#fd7e14"
}, {
    "nosamw": "0401320",
    "nama": "Tugu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 15000,
    "total_jumlah": 117500,
    "lat": 0.458559,
    "lng": 121.944367,
    "color": "#ffc107"
}, {
    "nosamw": "0404481",
    "nama": "Tuti Abdullah",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4637856,
    "lng": 121.9514228,
    "color": "#ffc107"
}, {
    "nosamw": "0402467",
    "nama": "Udin Djafar",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.462052,
    "lng": 121.950975,
    "color": "#dc3545"
}, {
    "nosamw": "0407324",
    "nama": "Ulan Surentu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081347915860",
    "total_bulan": 4,
    "total_tagihan": 1192500,
    "total_denda": 15000,
    "total_jumlah": 1207500,
    "lat": 0.4608761,
    "lng": 121.9610388,
    "color": "#fd7e14"
}, {
    "nosamw": "0403423",
    "nama": "Ulfa 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081241854161",
    "total_bulan": 17,
    "total_tagihan": 1044000,
    "total_denda": 80000,
    "total_jumlah": 1124000,
    "lat": 0.463617,
    "lng": 121.951389,
    "color": "#dc3545"
}, {
    "nosamw": "0401732",
    "nama": "Umar Abas",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.466117,
    "lng": 121.963102,
    "color": "#ffc107"
}, {
    "nosamw": "0400488",
    "nama": "Umar Eri Antu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4631076,
    "lng": 121.9511892,
    "color": "#ffc107"
}, {
    "nosamw": "0400236",
    "nama": "Umar K",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.4644854,
    "lng": 121.9503696,
    "color": "#ffc107"
}, {
    "nosamw": "0405977",
    "nama": "UNE HULOPI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61000,
    "total_denda": 0,
    "total_jumlah": 61000,
    "lat": 0.4663042,
    "lng": 121.9520512,
    "color": "#ffc107"
}, {
    "nosamw": "0405987",
    "nama": "URI NIHE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 395000,
    "total_denda": 25000,
    "total_jumlah": 420000,
    "lat": 0.4651099,
    "lng": 121.9462477,
    "color": "#fd7e14"
}, {
    "nosamw": "0400945",
    "nama": "Usman As. Ali",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4645357,
    "lng": 121.9507199,
    "color": "#ffc107"
}, {
    "nosamw": "0406821",
    "nama": "Usman Kadir",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1036500,
    "total_denda": 40000,
    "total_jumlah": 1076500,
    "lat": 0.4575033,
    "lng": 121.958425,
    "color": "#dc3545"
}, {
    "nosamw": "0406337",
    "nama": "USMAN PAJA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082343056298",
    "total_bulan": 10,
    "total_tagihan": 716000,
    "total_denda": 50000,
    "total_jumlah": 766000,
    "lat": 0.4568701,
    "lng": 121.9518841,
    "color": "#dc3545"
}, {
    "nosamw": "0401973",
    "nama": "Veradiantie Kaluku",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.462126,
    "lng": 121.950563,
    "color": "#dc3545"
}, {
    "nosamw": "0402007",
    "nama": "VERASISKA.RIBUNU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4638788,
    "lng": 121.9503371,
    "color": "#ffc107"
}, {
    "nosamw": "0400228",
    "nama": "Vicky M. Lahamutu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 0,
    "total_jumlah": 68000,
    "lat": 0.464173,
    "lng": 121.94955,
    "color": "#ffc107"
}, {
    "nosamw": "0401995",
    "nama": "Vidia A. Wullur",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464187,
    "lng": 121.951916,
    "color": "#ffc107"
}, {
    "nosamw": "0406827",
    "nama": "VISRAN AHMAD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 753000,
    "total_denda": 50000,
    "total_jumlah": 803000,
    "lat": 0.4659001,
    "lng": 121.9628607,
    "color": "#dc3545"
}, {
    "nosamw": "0402360",
    "nama": "Wahid",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 247500,
    "total_denda": 0,
    "total_jumlah": 247500,
    "lat": 0.462189,
    "lng": 121.951452,
    "color": "#ffc107"
}, {
    "nosamw": "0400636",
    "nama": "Wahida Syarif",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 276500,
    "total_denda": 10000,
    "total_jumlah": 286500,
    "lat": 0.464143,
    "lng": 121.947952,
    "color": "#fd7e14"
}, {
    "nosamw": "0402137",
    "nama": "Waode Hamdini SE",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.464256,
    "lng": 121.949607,
    "color": "#ffc107"
}, {
    "nosamw": "0401189",
    "nama": "Warni Ma ruf",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4630956,
    "lng": 121.9518841,
    "color": "#ffc107"
}, {
    "nosamw": "0403611",
    "nama": "WATI SUKO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 177400,
    "total_denda": 10000,
    "total_jumlah": 187400,
    "lat": 0.4573064,
    "lng": 121.9497144,
    "color": "#fd7e14"
}, {
    "nosamw": "0400641",
    "nama": "Wella Makawimbang",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1218750,
    "total_denda": 120000,
    "total_jumlah": 1338750,
    "lat": 0.463875,
    "lng": 121.947607,
    "color": "#dc3545"
}, {
    "nosamw": "0402272",
    "nama": "Widyastuti Mbuinga",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.463438,
    "lng": 121.949078,
    "color": "#ffc107"
}, {
    "nosamw": "0405954",
    "nama": "WILSON DALUTA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1929500,
    "total_denda": 100000,
    "total_jumlah": 2029500,
    "lat": 0.449598,
    "lng": 121.940647,
    "color": "#dc3545"
}, {
    "nosamw": "0401931",
    "nama": "Wirnaningsih Hubu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 35000,
    "total_jumlah": 480000,
    "lat": 0.463059,
    "lng": 121.950489,
    "color": "#dc3545"
}, {
    "nosamw": "0407372",
    "nama": "WISANTO PAKAYA",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4638298,
    "lng": 121.95029,
    "color": "#ffc107"
}, {
    "nosamw": "0402023",
    "nama": "Wisda II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 210000,
    "total_denda": 0,
    "total_jumlah": 210000,
    "lat": 0.463331,
    "lng": 121.95072,
    "color": "#ffc107"
}, {
    "nosamw": "0407510",
    "nama": "WISDA MALIK",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085340109114",
    "total_bulan": 4,
    "total_tagihan": 996500,
    "total_denda": 20000,
    "total_jumlah": 1016500,
    "lat": 0.466415,
    "lng": 121.949015,
    "color": "#fd7e14"
}, {
    "nosamw": "0401792",
    "nama": "Worang H. Daud,S.Pd II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 779500,
    "total_denda": 25000,
    "total_jumlah": 804500,
    "lat": 0.463943,
    "lng": 121.9486548,
    "color": "#fd7e14"
}, {
    "nosamw": "0401726",
    "nama": "Yakop Ishak",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1454500,
    "total_denda": 45000,
    "total_jumlah": 1499500,
    "lat": 0.4634988,
    "lng": 121.9489757,
    "color": "#dc3545"
}, {
    "nosamw": "0407508",
    "nama": "YASIN DAUD",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082346322373",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.4592503,
    "lng": 121.9598608,
    "color": "#ffc107"
}, {
    "nosamw": "0403753",
    "nama": "Yasin Polumulo",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.459301,
    "lng": 121.953958,
    "color": "#ffc107"
}, {
    "nosamw": "0401490",
    "nama": "YASRI",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 94000,
    "total_denda": 0,
    "total_jumlah": 94000,
    "lat": 0.4643853,
    "lng": 121.9502413,
    "color": "#ffc107"
}, {
    "nosamw": "0400726",
    "nama": "Yatik Kalil",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 545500,
    "total_denda": 10000,
    "total_jumlah": 555500,
    "lat": 0.4643847,
    "lng": 121.9492764,
    "color": "#fd7e14"
}, {
    "nosamw": "0404493",
    "nama": "Yelly Laruba",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4618883,
    "lng": 121.9504253,
    "color": "#ffc107"
}, {
    "nosamw": "0402177",
    "nama": "Yeni Ahmad",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 3271500,
    "total_denda": 50000,
    "total_jumlah": 3321500,
    "lat": 0.463873,
    "lng": 121.949166,
    "color": "#dc3545"
}, {
    "nosamw": "0403685",
    "nama": "YESIKA ADHISDEA BADERAN",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85000,
    "total_denda": 0,
    "total_jumlah": 85000,
    "lat": 0.4645623,
    "lng": 121.9470693,
    "color": "#ffc107"
}, {
    "nosamw": "0400882",
    "nama": "Yessy Anggraini",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1586500,
    "total_denda": 45000,
    "total_jumlah": 1631500,
    "lat": 0.4642017,
    "lng": 121.9508705,
    "color": "#dc3545"
}, {
    "nosamw": "0402362",
    "nama": "Yetti Paputungan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.46505,
    "lng": 121.945868,
    "color": "#ffc107"
}, {
    "nosamw": "0404350",
    "nama": "Yockke Mega Pratama",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082397084969",
    "total_bulan": 7,
    "total_tagihan": 638500,
    "total_denda": 30000,
    "total_jumlah": 668500,
    "lat": 0.463818,
    "lng": 121.95173,
    "color": "#dc3545"
}, {
    "nosamw": "0401916",
    "nama": "Yolanda Alulu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1965000,
    "total_denda": 15000,
    "total_jumlah": 1980000,
    "lat": 0.462324,
    "lng": 121.950822,
    "color": "#fd7e14"
}, {
    "nosamw": "0401035",
    "nama": "YOLANDA ALULU 1",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 825000,
    "total_denda": 0,
    "total_jumlah": 825000,
    "lat": 0.4627275,
    "lng": 121.9471893,
    "color": "#ffc107"
}, {
    "nosamw": "0401892",
    "nama": "Yondi K. Natili",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 184500,
    "total_denda": 10000,
    "total_jumlah": 194500,
    "lat": 0.464141,
    "lng": 121.949442,
    "color": "#fd7e14"
}, {
    "nosamw": "0402828",
    "nama": "Yono Goi",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.4667601,
    "lng": 121.9538785,
    "color": "#ffc107"
}, {
    "nosamw": "0405308",
    "nama": "YULAN K. LANTU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1059500,
    "total_denda": 75000,
    "total_jumlah": 1134500,
    "lat": 0.4619809,
    "lng": 121.9507206,
    "color": "#dc3545"
}, {
    "nosamw": "0400493",
    "nama": "Yuningsi Pakaya",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 2798000,
    "total_denda": 100000,
    "total_jumlah": 2898000,
    "lat": 0.4645412,
    "lng": 121.9507598,
    "color": "#dc3545"
}, {
    "nosamw": "0402494",
    "nama": "Yunus Riyadi II",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 385000,
    "total_denda": 30000,
    "total_jumlah": 415000,
    "lat": 0.46202,
    "lng": 121.950528,
    "color": "#dc3545"
}, {
    "nosamw": "0405972",
    "nama": "YUSNA POLUMULO",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4659007,
    "lng": 121.9454494,
    "color": "#28a745"
}, {
    "nosamw": "0405650",
    "nama": "YUSNA TAIB",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 187500,
    "total_denda": 0,
    "total_jumlah": 187500,
    "lat": 0.463842,
    "lng": 121.9508847,
    "color": "#ffc107"
}, {
    "nosamw": "0401878",
    "nama": "Yusran. S",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.464386,
    "lng": 121.94953,
    "color": "#ffc107"
}, {
    "nosamw": "0403575",
    "nama": "Yusri Datau",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.464495,
    "lng": 121.951768,
    "color": "#ffc107"
}, {
    "nosamw": "0401862",
    "nama": "Yusri M. Hionu",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1642500,
    "total_denda": 35000,
    "total_jumlah": 1677500,
    "lat": 0.466852,
    "lng": 121.951428,
    "color": "#dc3545"
}, {
    "nosamw": "0406595",
    "nama": "YUSUF ABDUL",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2457500,
    "total_denda": 20000,
    "total_jumlah": 2477500,
    "lat": 0.4625604,
    "lng": 121.9498827,
    "color": "#fd7e14"
}, {
    "nosamw": "0402493",
    "nama": "Yuyun Masangka",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.462179,
    "lng": 121.951098,
    "color": "#28a745"
}, {
    "nosamw": "0400388",
    "nama": "Yuyun S. Mooduto",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 747000,
    "total_denda": 40000,
    "total_jumlah": 787000,
    "lat": 0.464043,
    "lng": 121.952015,
    "color": "#dc3545"
}, {
    "nosamw": "0401734",
    "nama": "Zainal Abdi Radjak",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 278500,
    "total_denda": 15000,
    "total_jumlah": 293500,
    "lat": 0.4640129,
    "lng": 121.949143,
    "color": "#fd7e14"
}, {
    "nosamw": "0401164",
    "nama": "ZIKRI NASARU",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4640576,
    "lng": 121.9484043,
    "color": "#ffc107"
}, {
    "nosamw": "0404174",
    "nama": "Zulkifli Murawan",
    "kecamatan": "KEC MARISA DESA PALOPO",
    "desa": "PALOPO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 25000,
    "total_jumlah": 355000,
    "lat": 0.46514,
    "lng": 121.945523,
    "color": "#fd7e14"
}, {
    "nosamw": "0400224",
    "nama": "Abd Rahman Lasaka",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 157500,
    "total_denda": 0,
    "total_jumlah": 157500,
    "lat": 0.451548,
    "lng": 121.938424,
    "color": "#ffc107"
}, {
    "nosamw": "0402090",
    "nama": "Abd. Kadir Mahmud",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446043,
    "lng": 121.938726,
    "color": "#28a745"
}, {
    "nosamw": "0401653",
    "nama": "Abd. Qadir Jailani",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.455303,
    "lng": 121.938343,
    "color": "#28a745"
}, {
    "nosamw": "0401327",
    "nama": "Abd. W ( Pesantren )",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 96500,
    "total_denda": 0,
    "total_jumlah": 96500,
    "lat": 0.455291,
    "lng": 121.937549,
    "color": "#ffc107"
}, {
    "nosamw": "0400140",
    "nama": "Abd. Wahab Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1252000,
    "total_denda": 100000,
    "total_jumlah": 1352000,
    "lat": 0.453737,
    "lng": 121.938508,
    "color": "#dc3545"
}, {
    "nosamw": "0402081",
    "nama": "ABDUL KADIR PODUNGGE",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4476747,
    "lng": 121.937975,
    "color": "#28a745"
}, {
    "nosamw": "0401049",
    "nama": "Abdulah Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 3823500,
    "total_denda": 105000,
    "total_jumlah": 3928500,
    "lat": 0.449453,
    "lng": 121.941678,
    "color": "#dc3545"
}, {
    "nosamw": "0400229",
    "nama": "Abdullah Bouty",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45021,
    "lng": 121.939786,
    "color": "#28a745"
}, {
    "nosamw": "0400013",
    "nama": "Abdullah Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.449873,
    "lng": 121.939068,
    "color": "#ffc107"
}, {
    "nosamw": "0402180",
    "nama": "Abdulrahman Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 965000,
    "total_denda": 40000,
    "total_jumlah": 1005000,
    "lat": 0.449786,
    "lng": 121.938386,
    "color": "#dc3545"
}, {
    "nosamw": "0402924",
    "nama": "Ade Piola",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449758,
    "lng": 121.942445,
    "color": "#28a745"
}, {
    "nosamw": "0403390",
    "nama": "Ade Yanjo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 250000,
    "total_denda": 35000,
    "total_jumlah": 285000,
    "lat": 0.445586,
    "lng": 121.937946,
    "color": "#dc3545"
}, {
    "nosamw": "0400245",
    "nama": "Adi Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 548000,
    "total_denda": 50000,
    "total_jumlah": 598000,
    "lat": 0.447475,
    "lng": 121.941059,
    "color": "#dc3545"
}, {
    "nosamw": "0400902",
    "nama": "Adi Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 639000,
    "total_denda": 45000,
    "total_jumlah": 684000,
    "lat": 0.448981,
    "lng": 121.939533,
    "color": "#dc3545"
}, {
    "nosamw": "0401598",
    "nama": "Ado Kasim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 919000,
    "total_denda": 80000,
    "total_jumlah": 999000,
    "lat": 0.447282,
    "lng": 121.93793,
    "color": "#dc3545"
}, {
    "nosamw": "0407274",
    "nama": "ADO KASIM",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 5000,
    "total_jumlah": 118500,
    "lat": 0.447282,
    "lng": 121.93793,
    "color": "#ffc107"
}, {
    "nosamw": "0402889",
    "nama": "Adriyanto Harun",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.447978,
    "lng": 121.938832,
    "color": "#fd7e14"
}, {
    "nosamw": "0400398",
    "nama": "Agus Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2120750,
    "total_denda": 65000,
    "total_jumlah": 2185750,
    "lat": 0.447631,
    "lng": 121.941101,
    "color": "#dc3545"
}, {
    "nosamw": "0402476",
    "nama": "Agus Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 217500,
    "total_denda": 0,
    "total_jumlah": 217500,
    "lat": 0.449025,
    "lng": 121.943754,
    "color": "#ffc107"
}, {
    "nosamw": "0404959",
    "nama": "AGUS MADO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 2312500,
    "total_denda": 50000,
    "total_jumlah": 2362500,
    "lat": 0.4458866,
    "lng": 121.9393168,
    "color": "#dc3545"
}, {
    "nosamw": "0403452",
    "nama": "Agustin Polutu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448824,
    "lng": 121.943994,
    "color": "#28a745"
}, {
    "nosamw": "0402547",
    "nama": "Agustina Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446126,
    "lng": 121.937801,
    "color": "#28a745"
}, {
    "nosamw": "0401037",
    "nama": "Ahir Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.450047,
    "lng": 121.941714,
    "color": "#28a745"
}, {
    "nosamw": "0403227",
    "nama": "AHMAD ADJIJI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280800,
    "total_denda": 35000,
    "total_jumlah": 315800,
    "lat": 0.4451393,
    "lng": 121.9390883,
    "color": "#dc3545"
}, {
    "nosamw": "0400202",
    "nama": "Ahmad Giasi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 886000,
    "total_denda": 60000,
    "total_jumlah": 946000,
    "lat": 0.447303,
    "lng": 121.939036,
    "color": "#dc3545"
}, {
    "nosamw": "0402397",
    "nama": "Ahmad Zaitun Naue",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 262500,
    "total_denda": 10000,
    "total_jumlah": 272500,
    "lat": 0.455172,
    "lng": 121.938004,
    "color": "#fd7e14"
}, {
    "nosamw": "0400246",
    "nama": "Aisa Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447025,
    "lng": 121.939509,
    "color": "#28a745"
}, {
    "nosamw": "0400123",
    "nama": "Ajis Lamapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446784,
    "lng": 121.938742,
    "color": "#28a745"
}, {
    "nosamw": "0400850",
    "nama": "Ajis Mantu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 2027000,
    "total_denda": 125000,
    "total_jumlah": 2152000,
    "lat": 0.453177,
    "lng": 121.938658,
    "color": "#dc3545"
}, {
    "nosamw": "0400430",
    "nama": "Ali Bulonggodu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451973,
    "lng": 121.939027,
    "color": "#28a745"
}, {
    "nosamw": "0401313",
    "nama": "Alimin Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44705,
    "lng": 121.939097,
    "color": "#28a745"
}, {
    "nosamw": "0404960",
    "nama": "ALMA IBRAHIM",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 915500,
    "total_denda": 50000,
    "total_jumlah": 965500,
    "lat": 0.4511561,
    "lng": 121.9422344,
    "color": "#dc3545"
}, {
    "nosamw": "0405028",
    "nama": "ALPIAN HARUN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 678500,
    "total_denda": 50000,
    "total_jumlah": 728500,
    "lat": 0.4465614,
    "lng": 121.9376142,
    "color": "#dc3545"
}, {
    "nosamw": "0403461",
    "nama": "Amin Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45185,
    "lng": 121.93631,
    "color": "#28a745"
}, {
    "nosamw": "0400327",
    "nama": "Amir Usman",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 6467750,
    "total_denda": 75000,
    "total_jumlah": 6542750,
    "lat": 0.447847,
    "lng": 121.941518,
    "color": "#dc3545"
}, {
    "nosamw": "0402568",
    "nama": "Amrin M. Adam",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 2460500,
    "total_denda": 155000,
    "total_jumlah": 2615500,
    "lat": 0.446498,
    "lng": 121.940184,
    "color": "#dc3545"
}, {
    "nosamw": "0402891",
    "nama": "Amrin Nihe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1682000,
    "total_denda": 95000,
    "total_jumlah": 1777000,
    "lat": 0.449844,
    "lng": 121.941519,
    "color": "#dc3545"
}, {
    "nosamw": "0400102",
    "nama": "Ana Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 380000,
    "total_denda": 5000,
    "total_jumlah": 385000,
    "lat": 0.4499069,
    "lng": 121.9394331,
    "color": "#ffc107"
}, {
    "nosamw": "0402540",
    "nama": "Andi Lasurulah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 564500,
    "total_denda": 45000,
    "total_jumlah": 609500,
    "lat": 0.447828,
    "lng": 121.939192,
    "color": "#dc3545"
}, {
    "nosamw": "0404751",
    "nama": "ANDRIKA POPOY",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446598,
    "lng": 121.93913,
    "color": "#28a745"
}, {
    "nosamw": "0403356",
    "nama": "Aninta Saini",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 525000,
    "total_denda": 30000,
    "total_jumlah": 555000,
    "lat": 0.445782,
    "lng": 121.9383,
    "color": "#fd7e14"
}, {
    "nosamw": "0400291",
    "nama": "Anis Taliki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 322500,
    "total_denda": 0,
    "total_jumlah": 322500,
    "lat": 0.45216,
    "lng": 121.938917,
    "color": "#ffc107"
}, {
    "nosamw": "0407541",
    "nama": "ANISHA WISDA DEWANTI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082291560404",
    "total_bulan": 3,
    "total_tagihan": 700000,
    "total_denda": 15000,
    "total_jumlah": 715000,
    "lat": 0.4511792,
    "lng": 121.9525412,
    "color": "#fd7e14"
}, {
    "nosamw": "0404846",
    "nama": "ANO MASANI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4529961,
    "lng": 121.9369749,
    "color": "#28a745"
}, {
    "nosamw": "0400257",
    "nama": "Anton Bumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 5000,
    "total_jumlah": 112000,
    "lat": 0.448579,
    "lng": 121.943351,
    "color": "#ffc107"
}, {
    "nosamw": "0402194",
    "nama": "Anwar Bulonggodu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 492000,
    "total_denda": 50000,
    "total_jumlah": 542000,
    "lat": 0.451603,
    "lng": 121.937219,
    "color": "#dc3545"
}, {
    "nosamw": "0404530",
    "nama": "ARA DJIBU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 523500,
    "total_denda": 30000,
    "total_jumlah": 553500,
    "lat": 0.4454973,
    "lng": 121.938071,
    "color": "#fd7e14"
}, {
    "nosamw": "0400858",
    "nama": "Arabi Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 588000,
    "total_denda": 35000,
    "total_jumlah": 623000,
    "lat": 0.447275,
    "lng": 121.937812,
    "color": "#dc3545"
}, {
    "nosamw": "0401901",
    "nama": "Arfan Monoarfa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.455102,
    "lng": 121.937974,
    "color": "#ffc107"
}, {
    "nosamw": "0401208",
    "nama": "Arifin Harun",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1215000,
    "total_denda": 110000,
    "total_jumlah": 1325000,
    "lat": 0.44593,
    "lng": 121.938022,
    "color": "#dc3545"
}, {
    "nosamw": "0402601",
    "nama": "Aripin Alim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 5417500,
    "total_denda": 110000,
    "total_jumlah": 5527500,
    "lat": 0.448025,
    "lng": 121.938028,
    "color": "#dc3545"
}, {
    "nosamw": "0401230",
    "nama": "Arlan Yunus Mohamad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 118500,
    "total_denda": 0,
    "total_jumlah": 118500,
    "lat": 0.4481076,
    "lng": 121.9383624,
    "color": "#ffc107"
}, {
    "nosamw": "0402599",
    "nama": "Arsyad Taha",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447927,
    "lng": 121.937999,
    "color": "#28a745"
}, {
    "nosamw": "0402838",
    "nama": "Asin Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449706,
    "lng": 121.941687,
    "color": "#28a745"
}, {
    "nosamw": "0402554",
    "nama": "Asma Bilatula",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446803,
    "lng": 121.940692,
    "color": "#28a745"
}, {
    "nosamw": "0402887",
    "nama": "Asna Wameto",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449479,
    "lng": 121.941141,
    "color": "#28a745"
}, {
    "nosamw": "0400312",
    "nama": "Asna Yasin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448742,
    "lng": 121.942951,
    "color": "#28a745"
}, {
    "nosamw": "0400706",
    "nama": "Asnawi Kaluku",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448171,
    "lng": 121.940903,
    "color": "#28a745"
}, {
    "nosamw": "0401307",
    "nama": "Asni Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 3988500,
    "total_denda": 75000,
    "total_jumlah": 4063500,
    "lat": 0.449504,
    "lng": 121.942445,
    "color": "#dc3545"
}, {
    "nosamw": "0400382",
    "nama": "Asni Saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1237500,
    "total_denda": 25000,
    "total_jumlah": 1262500,
    "lat": 0.447811,
    "lng": 121.938891,
    "color": "#fd7e14"
}, {
    "nosamw": "0400544",
    "nama": "Aswin Bantahari",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 842500,
    "total_denda": 25000,
    "total_jumlah": 867500,
    "lat": 0.448311,
    "lng": 121.940679,
    "color": "#fd7e14"
}, {
    "nosamw": "0401994",
    "nama": "Aswin Labedi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448795,
    "lng": 121.943798,
    "color": "#28a745"
}, {
    "nosamw": "0402444",
    "nama": "Aswin Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449403,
    "lng": 121.942188,
    "color": "#28a745"
}, {
    "nosamw": "0402386",
    "nama": "Atni Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448723,
    "lng": 121.942164,
    "color": "#28a745"
}, {
    "nosamw": "0401716",
    "nama": "Awas Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 1548500,
    "total_denda": 135000,
    "total_jumlah": 1683500,
    "lat": 0.446048,
    "lng": 121.939516,
    "color": "#dc3545"
}, {
    "nosamw": "0401450",
    "nama": "Azis Jalil",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 853000,
    "total_denda": 70000,
    "total_jumlah": 923000,
    "lat": 0.446653,
    "lng": 121.938026,
    "color": "#dc3545"
}, {
    "nosamw": "0400077",
    "nama": "Beng Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 972000,
    "total_denda": 50000,
    "total_jumlah": 1022000,
    "lat": 0.450763,
    "lng": 121.93924,
    "color": "#dc3545"
}, {
    "nosamw": "0400104",
    "nama": "Beny Laungan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447933,
    "lng": 121.939694,
    "color": "#28a745"
}, {
    "nosamw": "0400837",
    "nama": "Budi Sastra Sabihi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1185000,
    "total_denda": 65000,
    "total_jumlah": 1250000,
    "lat": 0.446199,
    "lng": 121.9381,
    "color": "#dc3545"
}, {
    "nosamw": "0401435",
    "nama": "Burhan Gani",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 310000,
    "total_denda": 5000,
    "total_jumlah": 315000,
    "lat": 0.445693,
    "lng": 121.938265,
    "color": "#ffc107"
}, {
    "nosamw": "0404295",
    "nama": "Burhan Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1184500,
    "total_denda": 40000,
    "total_jumlah": 1224500,
    "lat": 0.447536,
    "lng": 121.93861,
    "color": "#dc3545"
}, {
    "nosamw": "0400284",
    "nama": "Burhanudin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.453365,
    "lng": 121.93868,
    "color": "#28a745"
}, {
    "nosamw": "0402922",
    "nama": "Cani Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449626,
    "lng": 121.938676,
    "color": "#28a745"
}, {
    "nosamw": "0401249",
    "nama": "Cena Husain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1215000,
    "total_denda": 110000,
    "total_jumlah": 1325000,
    "lat": 0.449167,
    "lng": 121.940636,
    "color": "#dc3545"
}, {
    "nosamw": "0401254",
    "nama": "Ceni Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449417,
    "lng": 121.940529,
    "color": "#28a745"
}, {
    "nosamw": "0401430",
    "nama": "CENI ZALIM",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4536568,
    "lng": 121.9376902,
    "color": "#ffc107"
}, {
    "nosamw": "0400116",
    "nama": "Cin Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4516336,
    "lng": 121.9378312,
    "color": "#ffc107"
}, {
    "nosamw": "0400735",
    "nama": "Coni Djafar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 540000,
    "total_denda": 15000,
    "total_jumlah": 555000,
    "lat": 0.450201,
    "lng": 121.939706,
    "color": "#fd7e14"
}, {
    "nosamw": "0404166",
    "nama": "Cun Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 1572000,
    "total_denda": 120000,
    "total_jumlah": 1692000,
    "lat": 0.450019,
    "lng": 121.942028,
    "color": "#dc3545"
}, {
    "nosamw": "0400193",
    "nama": "Daeng Anto",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 605000,
    "total_denda": 55000,
    "total_jumlah": 660000,
    "lat": 0.453459,
    "lng": 121.938334,
    "color": "#dc3545"
}, {
    "nosamw": "0400482",
    "nama": "Daiman Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1066500,
    "total_denda": 10000,
    "total_jumlah": 1076500,
    "lat": 0.451438,
    "lng": 121.937848,
    "color": "#fd7e14"
}, {
    "nosamw": "0402110",
    "nama": "Daiman Maiji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447576,
    "lng": 121.938604,
    "color": "#28a745"
}, {
    "nosamw": "0403348",
    "nama": "DANDI AKUBA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 301000,
    "total_denda": 25000,
    "total_jumlah": 326000,
    "lat": 0.4495046,
    "lng": 121.9455815,
    "color": "#fd7e14"
}, {
    "nosamw": "0401090",
    "nama": "Dariana Saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 593000,
    "total_denda": 50000,
    "total_jumlah": 643000,
    "lat": 0.447767,
    "lng": 121.939351,
    "color": "#dc3545"
}, {
    "nosamw": "0401281",
    "nama": "Darliana Koro",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 677000,
    "total_denda": 45000,
    "total_jumlah": 722000,
    "lat": 0.447839,
    "lng": 121.939433,
    "color": "#dc3545"
}, {
    "nosamw": "0401880",
    "nama": "Darlin Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.450135,
    "lng": 121.940721,
    "color": "#28a745"
}, {
    "nosamw": "0402623",
    "nama": "Darmajid Lakoro",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1355000,
    "total_denda": 80000,
    "total_jumlah": 1435000,
    "lat": 0.44775,
    "lng": 121.939277,
    "color": "#dc3545"
}, {
    "nosamw": "0400108",
    "nama": "Darmin Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 1782500,
    "total_denda": 125000,
    "total_jumlah": 1907500,
    "lat": 0.447055,
    "lng": 121.93992,
    "color": "#dc3545"
}, {
    "nosamw": "0400346",
    "nama": "Daud Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447564,
    "lng": 121.938694,
    "color": "#28a745"
}, {
    "nosamw": "0403363",
    "nama": "Dian Samade",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 197500,
    "total_denda": 15000,
    "total_jumlah": 212500,
    "lat": 0.447335,
    "lng": 121.937913,
    "color": "#fd7e14"
}, {
    "nosamw": "0402437",
    "nama": "Didin Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 5000,
    "total_jumlah": 86000,
    "lat": 0.4454771,
    "lng": 121.9390477,
    "color": "#ffc107"
}, {
    "nosamw": "0400131",
    "nama": "Diman Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446695,
    "lng": 121.938628,
    "color": "#28a745"
}, {
    "nosamw": "0404249",
    "nama": "Dini Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.450214,
    "lng": 121.939505,
    "color": "#ffc107"
}, {
    "nosamw": "0400546",
    "nama": "Dino Abubakar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449602,
    "lng": 121.939988,
    "color": "#28a745"
}, {
    "nosamw": "0401133",
    "nama": "Dirwan Sarahu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 146000,
    "total_denda": 10000,
    "total_jumlah": 156000,
    "lat": 0.4545339,
    "lng": 121.9376651,
    "color": "#ffc107"
}, {
    "nosamw": "0403727",
    "nama": "Djamaludin Dalanggo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 217000,
    "total_denda": 15000,
    "total_jumlah": 232000,
    "lat": 0.447843,
    "lng": 121.938341,
    "color": "#fd7e14"
}, {
    "nosamw": "0401247",
    "nama": "Djaura Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 480000,
    "total_denda": 10000,
    "total_jumlah": 490000,
    "lat": 0.449813,
    "lng": 121.948645,
    "color": "#ffc107"
}, {
    "nosamw": "0400222",
    "nama": "Djida Lapata",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 685500,
    "total_denda": 35000,
    "total_jumlah": 720500,
    "lat": 0.447399,
    "lng": 121.938149,
    "color": "#dc3545"
}, {
    "nosamw": "0400197",
    "nama": "Djidan Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447568,
    "lng": 121.938936,
    "color": "#28a745"
}, {
    "nosamw": "0402415",
    "nama": "Djuhuria Hamid",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448584,
    "lng": 121.94131,
    "color": "#28a745"
}, {
    "nosamw": "0403451",
    "nama": "Doyo Husain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 2213500,
    "total_denda": 130000,
    "total_jumlah": 2343500,
    "lat": 0.451887,
    "lng": 121.956886,
    "color": "#dc3545"
}, {
    "nosamw": "0401575",
    "nama": "Eca Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446037,
    "lng": 121.938027,
    "color": "#28a745"
}, {
    "nosamw": "0400134",
    "nama": "EDA LASAMPE",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 275000,
    "total_denda": 25000,
    "total_jumlah": 300000,
    "lat": 0.4473332,
    "lng": 121.9394797,
    "color": "#fd7e14"
}, {
    "nosamw": "0401539",
    "nama": "Ekman Sompa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447274,
    "lng": 121.940822,
    "color": "#28a745"
}, {
    "nosamw": "0402542",
    "nama": "Elan Taiki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448851,
    "lng": 121.943163,
    "color": "#28a745"
}, {
    "nosamw": "0401351",
    "nama": "Elis Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 2849000,
    "total_denda": 85000,
    "total_jumlah": 2934000,
    "lat": 0.445788,
    "lng": 121.938706,
    "color": "#dc3545"
}, {
    "nosamw": "0401569",
    "nama": "Ena Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 987200,
    "total_denda": 75000,
    "total_jumlah": 1062200,
    "lat": 0.446106,
    "lng": 121.938373,
    "color": "#dc3545"
}, {
    "nosamw": "0402156",
    "nama": "Erna Mato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 440000,
    "total_denda": 20000,
    "total_jumlah": 460000,
    "lat": 0.4515,
    "lng": 121.937564,
    "color": "#fd7e14"
}, {
    "nosamw": "0404271",
    "nama": "Erni Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445413,
    "lng": 121.939182,
    "color": "#28a745"
}, {
    "nosamw": "0400241",
    "nama": "Erpan Sahabu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448644,
    "lng": 121.94134,
    "color": "#28a745"
}, {
    "nosamw": "0400130",
    "nama": "Faisal Nihe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448932,
    "lng": 121.942738,
    "color": "#28a745"
}, {
    "nosamw": "0400885",
    "nama": "Farida Tangahu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 480000,
    "total_denda": 20000,
    "total_jumlah": 500000,
    "lat": 0.4457998,
    "lng": 121.9383031,
    "color": "#fd7e14"
}, {
    "nosamw": "0404244",
    "nama": "Fatma Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 727000,
    "total_denda": 40000,
    "total_jumlah": 767000,
    "lat": 0.449338,
    "lng": 121.940457,
    "color": "#dc3545"
}, {
    "nosamw": "0401576",
    "nama": "Fatma Apadjulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446703,
    "lng": 121.937922,
    "color": "#28a745"
}, {
    "nosamw": "0406005",
    "nama": "FATMA DALANGGO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2692000,
    "total_denda": 65000,
    "total_jumlah": 2757000,
    "lat": 0.4480782,
    "lng": 121.9382911,
    "color": "#dc3545"
}, {
    "nosamw": "0400927",
    "nama": "Fatma Madu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 801000,
    "total_denda": 30000,
    "total_jumlah": 831000,
    "lat": 0.4495083,
    "lng": 121.9411267,
    "color": "#dc3545"
}, {
    "nosamw": "0402391",
    "nama": "Fatma Monoarfa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4515821,
    "lng": 121.9385124,
    "color": "#ffc107"
}, {
    "nosamw": "0402573",
    "nama": "Fatma Radjak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2514500,
    "total_denda": 95000,
    "total_jumlah": 2609500,
    "lat": 0.453177,
    "lng": 121.938658,
    "color": "#dc3545"
}, {
    "nosamw": "0400794",
    "nama": "FATMAWATI ALAM",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 730000,
    "total_denda": 55000,
    "total_jumlah": 785000,
    "lat": 0.449327,
    "lng": 121.940373,
    "color": "#dc3545"
}, {
    "nosamw": "0406332",
    "nama": "FATMAWATI GOBEL",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 2501500,
    "total_denda": 40000,
    "total_jumlah": 2541500,
    "lat": 0.4529828,
    "lng": 121.9384501,
    "color": "#dc3545"
}, {
    "nosamw": "0403945",
    "nama": "felix katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1241700,
    "total_denda": 70000,
    "total_jumlah": 1311700,
    "lat": 0.446017,
    "lng": 121.939597,
    "color": "#dc3545"
}, {
    "nosamw": "0404284",
    "nama": "Felmi Haras",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44533,
    "lng": 121.939134,
    "color": "#28a745"
}, {
    "nosamw": "0400933",
    "nama": "Fendi Biki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1895000,
    "total_denda": 70000,
    "total_jumlah": 1965000,
    "lat": 0.449091,
    "lng": 121.942503,
    "color": "#dc3545"
}, {
    "nosamw": "0400711",
    "nama": "Feni Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 3184500,
    "total_denda": 105000,
    "total_jumlah": 3289500,
    "lat": 0.450278,
    "lng": 121.940131,
    "color": "#dc3545"
}, {
    "nosamw": "0401591",
    "nama": "Ferdi Jalil",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 476000,
    "total_denda": 35000,
    "total_jumlah": 511000,
    "lat": 0.447355,
    "lng": 121.937991,
    "color": "#dc3545"
}, {
    "nosamw": "0402083",
    "nama": "Ferdi Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446154,
    "lng": 121.937944,
    "color": "#28a745"
}, {
    "nosamw": "0401360",
    "nama": "Ferdi Worotican",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 450500,
    "total_denda": 5000,
    "total_jumlah": 455500,
    "lat": 0.448913,
    "lng": 121.939362,
    "color": "#ffc107"
}, {
    "nosamw": "0404947",
    "nama": "FIDYA ASTUTI AHMAD",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 275500,
    "total_denda": 15000,
    "total_jumlah": 290500,
    "lat": 0.4452701,
    "lng": 121.9385581,
    "color": "#fd7e14"
}, {
    "nosamw": "0406025",
    "nama": "FIRA RADJAK",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 214000,
    "total_denda": 5000,
    "total_jumlah": 219000,
    "lat": 0.4539185,
    "lng": 121.9382562,
    "color": "#ffc107"
}, {
    "nosamw": "0400282",
    "nama": "FITRAH SALLEH",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4479083,
    "lng": 121.9387797,
    "color": "#28a745"
}, {
    "nosamw": "0400401",
    "nama": "GEREJA SIDANG JEMAAT ALAH",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.463153,
    "lng": 121.9359381,
    "color": "#28a745"
}, {
    "nosamw": "0402882",
    "nama": "Gomo Radjak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 455000,
    "total_denda": 35000,
    "total_jumlah": 490000,
    "lat": 0.448681,
    "lng": 121.944472,
    "color": "#dc3545"
}, {
    "nosamw": "0400114",
    "nama": "GPDI Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 4080500,
    "total_denda": 30000,
    "total_jumlah": 4110500,
    "lat": 0.4512608,
    "lng": 121.9390705,
    "color": "#dc3545"
}, {
    "nosamw": "0400101",
    "nama": "GPIG Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 131000,
    "total_denda": 0,
    "total_jumlah": 131000,
    "lat": 0.449938,
    "lng": 121.938699,
    "color": "#ffc107"
}, {
    "nosamw": "0400849",
    "nama": "H. Herman Damis",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.455221,
    "lng": 121.938074,
    "color": "#fd7e14"
}, {
    "nosamw": "0406552",
    "nama": "H18 SUHARTO LAHAY",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4454532,
    "lng": 121.9393628,
    "color": "#28a745"
}, {
    "nosamw": "0406553",
    "nama": "H18 SURYAN EFENDI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4454699,
    "lng": 121.9392706,
    "color": "#28a745"
}, {
    "nosamw": "0406555",
    "nama": "H18 YASMIN M. DAI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 311600,
    "total_denda": 35000,
    "total_jumlah": 346600,
    "lat": 0.4465283,
    "lng": 121.9376683,
    "color": "#dc3545"
}, {
    "nosamw": "0406886",
    "nama": "H19 FATMA MELANGI, S.Pd",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 262500,
    "total_denda": 15000,
    "total_jumlah": 277500,
    "lat": 0.4464831,
    "lng": 121.9380242,
    "color": "#fd7e14"
}, {
    "nosamw": "0406855",
    "nama": "H19 RIYANTI ISHAK",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 470500,
    "total_denda": 40000,
    "total_jumlah": 510500,
    "lat": 0.4465623,
    "lng": 121.9386494,
    "color": "#dc3545"
}, {
    "nosamw": "0402522",
    "nama": "Hadidja Kasim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 489500,
    "total_denda": 15000,
    "total_jumlah": 504500,
    "lat": 0.44534,
    "lng": 121.937963,
    "color": "#fd7e14"
}, {
    "nosamw": "0400313",
    "nama": "Hadijah Taliki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449092,
    "lng": 121.943129,
    "color": "#28a745"
}, {
    "nosamw": "0402150",
    "nama": "Haiko N. Diko",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 360000,
    "total_denda": 45000,
    "total_jumlah": 405000,
    "lat": 0.447193,
    "lng": 121.938115,
    "color": "#dc3545"
}, {
    "nosamw": "0402741",
    "nama": "Hairia Saini",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 312000,
    "total_denda": 30000,
    "total_jumlah": 342000,
    "lat": 0.448522,
    "lng": 121.941286,
    "color": "#fd7e14"
}, {
    "nosamw": "0400863",
    "nama": "Hais Pasandre",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448693,
    "lng": 121.944096,
    "color": "#28a745"
}, {
    "nosamw": "0403781",
    "nama": "Hano AbdulLah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 141600,
    "total_denda": 10000,
    "total_jumlah": 151600,
    "lat": 0.448865,
    "lng": 121.93948,
    "color": "#ffc107"
}, {
    "nosamw": "0400972",
    "nama": "Haris Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 350000,
    "total_denda": 15000,
    "total_jumlah": 365000,
    "lat": 0.446026,
    "lng": 121.938559,
    "color": "#fd7e14"
}, {
    "nosamw": "0407288",
    "nama": "Hartati",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1407000,
    "total_denda": 55000,
    "total_jumlah": 1462000,
    "lat": 0.4465544,
    "lng": 121.940346,
    "color": "#dc3545"
}, {
    "nosamw": "0400087",
    "nama": "Hartin Antukai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.448641,
    "lng": 121.941402,
    "color": "#ffc107"
}, {
    "nosamw": "0406041",
    "nama": "HARUN DUE",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165000,
    "total_denda": 0,
    "total_jumlah": 165000,
    "lat": 0.4539065,
    "lng": 121.9380242,
    "color": "#ffc107"
}, {
    "nosamw": "0404686",
    "nama": "Harun Hasan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 54000,
    "total_denda": 10000,
    "total_jumlah": 64000,
    "lat": 0.445467,
    "lng": 121.938743,
    "color": "#ffc107"
}, {
    "nosamw": "0400280",
    "nama": "Hasan Antukai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448235,
    "lng": 121.941019,
    "color": "#28a745"
}, {
    "nosamw": "0400138",
    "nama": "Hasan Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 0,
    "total_jumlah": 100500,
    "lat": 0.447409,
    "lng": 121.938708,
    "color": "#ffc107"
}, {
    "nosamw": "0400183",
    "nama": "Hasan Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446826,
    "lng": 121.939202,
    "color": "#28a745"
}, {
    "nosamw": "0401124",
    "nama": "Hasan Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451451,
    "lng": 121.93845,
    "color": "#28a745"
}, {
    "nosamw": "0405182",
    "nama": "HASAN PAKAYA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 120000,
    "total_denda": 15000,
    "total_jumlah": 135000,
    "lat": 0.451451,
    "lng": 121.93845,
    "color": "#fd7e14"
}, {
    "nosamw": "0400115",
    "nama": "Hasan Pombode",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 26,
    "total_tagihan": 1329000,
    "total_denda": 130000,
    "total_jumlah": 1459000,
    "lat": 0.446573,
    "lng": 121.939069,
    "color": "#dc3545"
}, {
    "nosamw": "0401453",
    "nama": "Hasi \/ Tuu Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447313,
    "lng": 121.937956,
    "color": "#28a745"
}, {
    "nosamw": "0400557",
    "nama": "Hasim Abdulah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.44864,
    "lng": 121.941596,
    "color": "#ffc107"
}, {
    "nosamw": "0403070",
    "nama": "Hasmiati M. Noor",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45172,
    "lng": 121.936414,
    "color": "#28a745"
}, {
    "nosamw": "0400883",
    "nama": "Hasni Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3567500,
    "total_denda": 40000,
    "total_jumlah": 3607500,
    "lat": 0.446858,
    "lng": 121.937863,
    "color": "#dc3545"
}, {
    "nosamw": "0402852",
    "nama": "Hasni Due",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 779250,
    "total_denda": 95000,
    "total_jumlah": 874250,
    "lat": 0.450028,
    "lng": 121.941869,
    "color": "#dc3545"
}, {
    "nosamw": "0403453",
    "nama": "Haspa Becelebo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 324000,
    "total_denda": 60000,
    "total_jumlah": 384000,
    "lat": 0.446121,
    "lng": 121.939581,
    "color": "#dc3545"
}, {
    "nosamw": "0402130",
    "nama": "Hawaria Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 440400,
    "total_denda": 35000,
    "total_jumlah": 475400,
    "lat": 0.447098,
    "lng": 121.937941,
    "color": "#dc3545"
}, {
    "nosamw": "0401787",
    "nama": "Hayani Sisa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 184500,
    "total_denda": 0,
    "total_jumlah": 184500,
    "lat": 0.449786,
    "lng": 121.940092,
    "color": "#ffc107"
}, {
    "nosamw": "0401580",
    "nama": "Hayati Sahabu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448666,
    "lng": 121.941205,
    "color": "#28a745"
}, {
    "nosamw": "0400078",
    "nama": "Hein Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 359000,
    "total_denda": 5000,
    "total_jumlah": 364000,
    "lat": 0.447244,
    "lng": 121.939645,
    "color": "#ffc107"
}, {
    "nosamw": "0400085",
    "nama": "Helda Katili I",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 225000,
    "total_denda": 0,
    "total_jumlah": 225000,
    "lat": 0.4512877,
    "lng": 121.9392659,
    "color": "#ffc107"
}, {
    "nosamw": "0404247",
    "nama": "Helmi A. Harun",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1577500,
    "total_denda": 25000,
    "total_jumlah": 1602500,
    "lat": 0.448727,
    "lng": 121.944667,
    "color": "#fd7e14"
}, {
    "nosamw": "0406751",
    "nama": "HELMI ULOLI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445867,
    "lng": 121.9393276,
    "color": "#28a745"
}, {
    "nosamw": "0402857",
    "nama": "Hely Katili II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 221500,
    "total_denda": 5000,
    "total_jumlah": 226500,
    "lat": 0.4535646,
    "lng": 121.937129,
    "color": "#ffc107"
}, {
    "nosamw": "0402584",
    "nama": "HENDRA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 657150,
    "total_denda": 35000,
    "total_jumlah": 692150,
    "lat": 0.4530801,
    "lng": 121.9369905,
    "color": "#dc3545"
}, {
    "nosamw": "0400261",
    "nama": "HENDRIK KATILI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1007000,
    "total_denda": 5000,
    "total_jumlah": 1012000,
    "lat": 0.4511831,
    "lng": 121.9379872,
    "color": "#ffc107"
}, {
    "nosamw": "0402850",
    "nama": "Heni Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 461000,
    "total_denda": 35000,
    "total_jumlah": 496000,
    "lat": 0.449442,
    "lng": 121.941727,
    "color": "#dc3545"
}, {
    "nosamw": "0403359",
    "nama": "Heni Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2237500,
    "total_denda": 75000,
    "total_jumlah": 2312500,
    "lat": 0.446014,
    "lng": 121.938469,
    "color": "#dc3545"
}, {
    "nosamw": "0401715",
    "nama": "Heri Abdjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1100000,
    "total_denda": 70000,
    "total_jumlah": 1170000,
    "lat": 0.446101,
    "lng": 121.939621,
    "color": "#dc3545"
}, {
    "nosamw": "0401023",
    "nama": "Herlina Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 496000,
    "total_denda": 40000,
    "total_jumlah": 536000,
    "lat": 0.448748,
    "lng": 121.941251,
    "color": "#dc3545"
}, {
    "nosamw": "0402000",
    "nama": "Herlina Ahmad II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448465,
    "lng": 121.943725,
    "color": "#28a745"
}, {
    "nosamw": "0401748",
    "nama": "HERLINA TANGAHU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445277,
    "lng": 121.938619,
    "color": "#28a745"
}, {
    "nosamw": "0401713",
    "nama": "Herman Poapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 931000,
    "total_denda": 75000,
    "total_jumlah": 1006000,
    "lat": 0.445638,
    "lng": 121.939862,
    "color": "#dc3545"
}, {
    "nosamw": "0403152",
    "nama": "HERMANTO S. BAMBANG",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 528500,
    "total_denda": 10000,
    "total_jumlah": 538500,
    "lat": 0.454494,
    "lng": 121.9558136,
    "color": "#fd7e14"
}, {
    "nosamw": "0401630",
    "nama": "Herni Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447539,
    "lng": 121.939763,
    "color": "#28a745"
}, {
    "nosamw": "0400177",
    "nama": "Hi. Sidin Potale",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1272500,
    "total_denda": 20000,
    "total_jumlah": 1292500,
    "lat": 0.44702,
    "lng": 121.938682,
    "color": "#fd7e14"
}, {
    "nosamw": "0402551",
    "nama": "Hilen Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446195,
    "lng": 121.938777,
    "color": "#28a745"
}, {
    "nosamw": "0400276",
    "nama": "Hola Tomasong",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 396500,
    "total_denda": 10000,
    "total_jumlah": 406500,
    "lat": 0.4478455,
    "lng": 121.9398963,
    "color": "#ffc107"
}, {
    "nosamw": "0400105",
    "nama": "Hong Meti",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 876500,
    "total_denda": 50000,
    "total_jumlah": 926500,
    "lat": 0.449132,
    "lng": 121.943642,
    "color": "#dc3545"
}, {
    "nosamw": "0400178",
    "nama": "Husain Alam",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 222500,
    "total_denda": 5000,
    "total_jumlah": 227500,
    "lat": 0.446251,
    "lng": 121.939416,
    "color": "#ffc107"
}, {
    "nosamw": "0401579",
    "nama": "Husain Hadudu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 2841500,
    "total_denda": 55000,
    "total_jumlah": 2896500,
    "lat": 0.445881,
    "lng": 121.938427,
    "color": "#dc3545"
}, {
    "nosamw": "0402577",
    "nama": "Husain Kaluku",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1098250,
    "total_denda": 60000,
    "total_jumlah": 1158250,
    "lat": 0.448267,
    "lng": 121.94268,
    "color": "#dc3545"
}, {
    "nosamw": "0402906",
    "nama": "HUSAIN PAKAYA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 415000,
    "total_denda": 15000,
    "total_jumlah": 430000,
    "lat": 0.4494403,
    "lng": 121.9455092,
    "color": "#fd7e14"
}, {
    "nosamw": "0406006",
    "nama": "HUSAIN RAJAK",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.4482392,
    "lng": 121.9385113,
    "color": "#ffc107"
}, {
    "nosamw": "0400174",
    "nama": "Husin Muda",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.447432,
    "lng": 121.9384,
    "color": "#fd7e14"
}, {
    "nosamw": "0400132",
    "nama": "Husuna Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446406,
    "lng": 121.938336,
    "color": "#28a745"
}, {
    "nosamw": "0404961",
    "nama": "IBRAHIM TANGAHU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4570217,
    "lng": 121.9585183,
    "color": "#28a745"
}, {
    "nosamw": "0400233",
    "nama": "Ibrahim Tune",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 3087500,
    "total_denda": 55000,
    "total_jumlah": 3142500,
    "lat": 0.452549,
    "lng": 121.938376,
    "color": "#dc3545"
}, {
    "nosamw": "0400330",
    "nama": "Ice Monoarfa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 272000,
    "total_denda": 20000,
    "total_jumlah": 292000,
    "lat": 0.446126,
    "lng": 121.938132,
    "color": "#fd7e14"
}, {
    "nosamw": "0401566",
    "nama": "Idris Bouti",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 259500,
    "total_denda": 10000,
    "total_jumlah": 269500,
    "lat": 0.447049,
    "lng": 121.937957,
    "color": "#ffc107"
}, {
    "nosamw": "0400214",
    "nama": "Iko Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 584000,
    "total_denda": 20000,
    "total_jumlah": 604000,
    "lat": 0.447182,
    "lng": 121.937808,
    "color": "#fd7e14"
}, {
    "nosamw": "0402669",
    "nama": "Imanu Ito",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1714400,
    "total_denda": 105000,
    "total_jumlah": 1819400,
    "lat": 0.445996,
    "lng": 121.939751,
    "color": "#dc3545"
}, {
    "nosamw": "0402874",
    "nama": "Ina Taiki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 544450,
    "total_denda": 65000,
    "total_jumlah": 609450,
    "lat": 0.448779,
    "lng": 121.94283,
    "color": "#dc3545"
}, {
    "nosamw": "0403101",
    "nama": "Ince Teno",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4491,
    "lng": 121.943338,
    "color": "#28a745"
}, {
    "nosamw": "0402784",
    "nama": "Indri Sawaku",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 2120000,
    "total_denda": 60000,
    "total_jumlah": 2180000,
    "lat": 0.448954,
    "lng": 121.94025,
    "color": "#dc3545"
}, {
    "nosamw": "0402894",
    "nama": "Intan Samade",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 40000,
    "total_denda": 5000,
    "total_jumlah": 45000,
    "lat": 0.449432,
    "lng": 121.942171,
    "color": "#ffc107"
}, {
    "nosamw": "0400096",
    "nama": "Inton Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 4147000,
    "total_denda": 110000,
    "total_jumlah": 4257000,
    "lat": 0.445357,
    "lng": 121.939002,
    "color": "#dc3545"
}, {
    "nosamw": "0400088",
    "nama": "Inton Dunggio",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448633,
    "lng": 121.941731,
    "color": "#28a745"
}, {
    "nosamw": "0401573",
    "nama": "Ir Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446183,
    "lng": 121.938546,
    "color": "#28a745"
}, {
    "nosamw": "0406001",
    "nama": "Irawati Auke",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 165500,
    "total_denda": 5000,
    "total_jumlah": 170500,
    "lat": 0.4471811,
    "lng": 121.9379153,
    "color": "#ffc107"
}, {
    "nosamw": "0401717",
    "nama": "Irfan Dukalang",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445552,
    "lng": 121.939901,
    "color": "#28a745"
}, {
    "nosamw": "0400347",
    "nama": "Irham Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.452451,
    "lng": 121.938768,
    "color": "#ffc107"
}, {
    "nosamw": "0402053",
    "nama": "Irma Kaluku",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 940000,
    "total_denda": 60000,
    "total_jumlah": 1000000,
    "lat": 0.44814,
    "lng": 121.942047,
    "color": "#dc3545"
}, {
    "nosamw": "0401420",
    "nama": "Iron Polutu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.448872,
    "lng": 121.943267,
    "color": "#ffc107"
}, {
    "nosamw": "0401429",
    "nama": "Isa Uloli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 392000,
    "total_denda": 30000,
    "total_jumlah": 422000,
    "lat": 0.451621,
    "lng": 121.937991,
    "color": "#fd7e14"
}, {
    "nosamw": "0400669",
    "nama": "Ishak Djafar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.44653,
    "lng": 121.940523,
    "color": "#fd7e14"
}, {
    "nosamw": "0400323",
    "nama": "Ishak Halid",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449398,
    "lng": 121.940218,
    "color": "#28a745"
}, {
    "nosamw": "0402148",
    "nama": "Ishak Rajak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 324500,
    "total_denda": 10000,
    "total_jumlah": 334500,
    "lat": 0.447227,
    "lng": 121.93927,
    "color": "#ffc107"
}, {
    "nosamw": "0406007",
    "nama": "ISMAIL LAMAPA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4483445,
    "lng": 121.9387086,
    "color": "#28a745"
}, {
    "nosamw": "0402117",
    "nama": "Ismiati Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449669,
    "lng": 121.940012,
    "color": "#28a745"
}, {
    "nosamw": "0401448",
    "nama": "Isna Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1239000,
    "total_denda": 40000,
    "total_jumlah": 1279000,
    "lat": 0.447137,
    "lng": 121.939484,
    "color": "#dc3545"
}, {
    "nosamw": "0404420",
    "nama": "Isnanto Radjak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449779,
    "lng": 121.943135,
    "color": "#28a745"
}, {
    "nosamw": "0400385",
    "nama": "Isno Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448686,
    "lng": 121.942973,
    "color": "#28a745"
}, {
    "nosamw": "0401441",
    "nama": "Isran Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44877,
    "lng": 121.943139,
    "color": "#28a745"
}, {
    "nosamw": "0401277",
    "nama": "Iswan Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 300000,
    "total_denda": 0,
    "total_jumlah": 300000,
    "lat": 0.447854,
    "lng": 121.938606,
    "color": "#ffc107"
}, {
    "nosamw": "0400278",
    "nama": "Itin Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 3515000,
    "total_denda": 80000,
    "total_jumlah": 3595000,
    "lat": 0.44768,
    "lng": 121.938356,
    "color": "#dc3545"
}, {
    "nosamw": "0404414",
    "nama": "Itin Yanjo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446931,
    "lng": 121.938965,
    "color": "#28a745"
}, {
    "nosamw": "0402183",
    "nama": "Iwan Moha",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 168500,
    "total_denda": 5000,
    "total_jumlah": 173500,
    "lat": 0.449834,
    "lng": 121.938886,
    "color": "#ffc107"
}, {
    "nosamw": "0400725",
    "nama": "Iyam Lapata",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 466500,
    "total_denda": 30000,
    "total_jumlah": 496500,
    "lat": 0.446887,
    "lng": 121.939253,
    "color": "#fd7e14"
}, {
    "nosamw": "0401599",
    "nama": "Iyam Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 4885500,
    "total_denda": 95000,
    "total_jumlah": 4980500,
    "lat": 0.447551,
    "lng": 121.938564,
    "color": "#dc3545"
}, {
    "nosamw": "0400100",
    "nama": "Iyan Saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 619000,
    "total_denda": 30000,
    "total_jumlah": 649000,
    "lat": 0.4559297,
    "lng": 121.9369173,
    "color": "#dc3545"
}, {
    "nosamw": "0400179",
    "nama": "Iyong Antukai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449077,
    "lng": 121.942356,
    "color": "#28a745"
}, {
    "nosamw": "0404191",
    "nama": "JAMALUDIN RUPU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4480433,
    "lng": 121.938172,
    "color": "#28a745"
}, {
    "nosamw": "0400900",
    "nama": "JEMMI RARUNG",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4493342,
    "lng": 121.9408869,
    "color": "#28a745"
}, {
    "nosamw": "0400924",
    "nama": "Jhon Abdul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447784,
    "lng": 121.939163,
    "color": "#28a745"
}, {
    "nosamw": "0400854",
    "nama": "Jhon Rajak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 308000,
    "total_denda": 15000,
    "total_jumlah": 323000,
    "lat": 0.451572,
    "lng": 121.937922,
    "color": "#fd7e14"
}, {
    "nosamw": "0400094",
    "nama": "Jhoni Katili I",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1089000,
    "total_denda": 50000,
    "total_jumlah": 1139000,
    "lat": 0.4508955,
    "lng": 121.9391121,
    "color": "#dc3545"
}, {
    "nosamw": "0403789",
    "nama": "Jhoni Mahmud",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45622,
    "lng": 121.956534,
    "color": "#28a745"
}, {
    "nosamw": "0402475",
    "nama": "Jois Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1907500,
    "total_denda": 55000,
    "total_jumlah": 1962500,
    "lat": 0.454315,
    "lng": 121.9381567,
    "color": "#dc3545"
}, {
    "nosamw": "0400395",
    "nama": "JUDIN SULEMAN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4457015,
    "lng": 121.9395407,
    "color": "#28a745"
}, {
    "nosamw": "0401216",
    "nama": "Juriyati Taniyo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447848,
    "lng": 121.941327,
    "color": "#28a745"
}, {
    "nosamw": "0400112",
    "nama": "Kadir Aljufri",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446768,
    "lng": 121.938813,
    "color": "#28a745"
}, {
    "nosamw": "0406010",
    "nama": "KADIR LASIAMA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4520497,
    "lng": 121.9378753,
    "color": "#28a745"
}, {
    "nosamw": "0404401",
    "nama": "Kadir Matlub",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2117100,
    "total_denda": 75000,
    "total_jumlah": 2192100,
    "lat": 0.445601,
    "lng": 121.937866,
    "color": "#dc3545"
}, {
    "nosamw": "0400295",
    "nama": "Kadir S. Une",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 164000,
    "total_denda": 20000,
    "total_jumlah": 184000,
    "lat": 0.447509,
    "lng": 121.938609,
    "color": "#fd7e14"
}, {
    "nosamw": "0401600",
    "nama": "KADRIN LASANTU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 252500,
    "total_denda": 20000,
    "total_jumlah": 272500,
    "lat": 0.449269,
    "lng": 121.94077,
    "color": "#fd7e14"
}, {
    "nosamw": "0400065",
    "nama": "Kahar Razak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.452487,
    "lng": 121.939178,
    "color": "#28a745"
}, {
    "nosamw": "0403806",
    "nama": "Kahardi Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 139500,
    "total_denda": 5000,
    "total_jumlah": 144500,
    "lat": 0.445276,
    "lng": 121.938969,
    "color": "#ffc107"
}, {
    "nosamw": "0402192",
    "nama": "KAI ADJIJI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.4450342,
    "lng": 121.9391837,
    "color": "#ffc107"
}, {
    "nosamw": "0400175",
    "nama": "Kamran Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 799000,
    "total_denda": 65000,
    "total_jumlah": 864000,
    "lat": 0.44653,
    "lng": 121.940523,
    "color": "#dc3545"
}, {
    "nosamw": "0400703",
    "nama": "KARMILA ARIS",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.445305,
    "lng": 121.9386509,
    "color": "#ffc107"
}, {
    "nosamw": "0405191",
    "nama": "KARMILA M. DIKO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 139500,
    "total_denda": 5000,
    "total_jumlah": 144500,
    "lat": 0.44648,
    "lng": 121.9376233,
    "color": "#ffc107"
}, {
    "nosamw": "0404948",
    "nama": "KARTIN IDRUS",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 484000,
    "total_denda": 40000,
    "total_jumlah": 524000,
    "lat": 0.4454604,
    "lng": 121.9384717,
    "color": "#dc3545"
}, {
    "nosamw": "0400286",
    "nama": "Kasim Balide",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1503500,
    "total_denda": 90000,
    "total_jumlah": 1593500,
    "lat": 0.446861,
    "lng": 121.939096,
    "color": "#dc3545"
}, {
    "nosamw": "0406026",
    "nama": "KASMA LABUGA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4477088,
    "lng": 121.9381136,
    "color": "#ffc107"
}, {
    "nosamw": "0401876",
    "nama": "Kastori Perikanan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446794,
    "lng": 121.94046,
    "color": "#28a745"
}, {
    "nosamw": "0402867",
    "nama": "Kiam Dunggio",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.447726,
    "lng": 121.941263,
    "color": "#ffc107"
}, {
    "nosamw": "0400979",
    "nama": "Kine Lasantu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 647500,
    "total_denda": 5000,
    "total_jumlah": 652500,
    "lat": 0.449797,
    "lng": 121.940833,
    "color": "#ffc107"
}, {
    "nosamw": "0401200",
    "nama": "Kisman Nusi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 447500,
    "total_denda": 15000,
    "total_jumlah": 462500,
    "lat": 0.450259,
    "lng": 121.940637,
    "color": "#fd7e14"
}, {
    "nosamw": "0401431",
    "nama": "Kisman Panggi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451562,
    "lng": 121.937168,
    "color": "#28a745"
}, {
    "nosamw": "0404418",
    "nama": "KKSS Pohuwato \/ Ambo Tang",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.453543,
    "lng": 121.938486,
    "color": "#dc3545"
}, {
    "nosamw": "0400163",
    "nama": "Kodu Tadulako",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1702500,
    "total_denda": 115000,
    "total_jumlah": 1817500,
    "lat": 0.447738,
    "lng": 121.939172,
    "color": "#dc3545"
}, {
    "nosamw": "0401623",
    "nama": "Ktr.Desa Phwt \/ Suwardi K",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 615000,
    "total_denda": 65000,
    "total_jumlah": 680000,
    "lat": 0.4475495,
    "lng": 121.9399312,
    "color": "#fd7e14"
}, {
    "nosamw": "0400718",
    "nama": "Kumentar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449141,
    "lng": 121.94255,
    "color": "#28a745"
}, {
    "nosamw": "0401484",
    "nama": "Laila Dunggio",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 3946000,
    "total_denda": 90000,
    "total_jumlah": 4036000,
    "lat": 0.445697,
    "lng": 121.937333,
    "color": "#dc3545"
}, {
    "nosamw": "0402006",
    "nama": "LANA HUNOWU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 10000,
    "total_jumlah": 133000,
    "lat": 0.4493372,
    "lng": 121.945417,
    "color": "#ffc107"
}, {
    "nosamw": "0400682",
    "nama": "Lana Lasiama",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1931250,
    "total_denda": 75000,
    "total_jumlah": 2006250,
    "lat": 0.446638,
    "lng": 121.9409,
    "color": "#dc3545"
}, {
    "nosamw": "0406012",
    "nama": "LATIF KADIR",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451494,
    "lng": 121.937586,
    "color": "#28a745"
}, {
    "nosamw": "0402571",
    "nama": "Lena Panggi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 843000,
    "total_denda": 75000,
    "total_jumlah": 918000,
    "lat": 0.451484,
    "lng": 121.937396,
    "color": "#dc3545"
}, {
    "nosamw": "0401424",
    "nama": "Lena Saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.45222,
    "lng": 121.938561,
    "color": "#ffc107"
}, {
    "nosamw": "0401034",
    "nama": "Leni Lasiama",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.451451,
    "lng": 121.93845,
    "color": "#ffc107"
}, {
    "nosamw": "0400107",
    "nama": "Lexi Roring",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448035,
    "lng": 121.939936,
    "color": "#28a745"
}, {
    "nosamw": "0402219",
    "nama": "Lian Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1167500,
    "total_denda": 15000,
    "total_jumlah": 1182500,
    "lat": 0.454475,
    "lng": 121.938174,
    "color": "#fd7e14"
}, {
    "nosamw": "0403605",
    "nama": "Lima Yusuf",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2777000,
    "total_denda": 95000,
    "total_jumlah": 2872000,
    "lat": 0.446576,
    "lng": 121.939846,
    "color": "#dc3545"
}, {
    "nosamw": "0402011",
    "nama": "Limi Latif",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 472000,
    "total_denda": 35000,
    "total_jumlah": 507000,
    "lat": 0.449682,
    "lng": 121.942631,
    "color": "#dc3545"
}, {
    "nosamw": "0401888",
    "nama": "Lina Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445459,
    "lng": 121.937578,
    "color": "#28a745"
}, {
    "nosamw": "0406013",
    "nama": "LINA YUSUF",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4477371,
    "lng": 121.9381485,
    "color": "#ffc107"
}, {
    "nosamw": "0402481",
    "nama": "Linda Thalib",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449256,
    "lng": 121.939981,
    "color": "#28a745"
}, {
    "nosamw": "0403725",
    "nama": "Lisna Yusuf",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447886,
    "lng": 121.937939,
    "color": "#28a745"
}, {
    "nosamw": "0400664",
    "nama": "Lisno Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 919000,
    "total_denda": 50000,
    "total_jumlah": 969000,
    "lat": 0.447544,
    "lng": 121.941096,
    "color": "#dc3545"
}, {
    "nosamw": "0401711",
    "nama": "Madi Danial",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 524000,
    "total_denda": 45000,
    "total_jumlah": 569000,
    "lat": 0.446497,
    "lng": 121.940156,
    "color": "#dc3545"
}, {
    "nosamw": "0400766",
    "nama": "Madi Sahabu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448699,
    "lng": 121.943875,
    "color": "#28a745"
}, {
    "nosamw": "0400769",
    "nama": "Mahmud Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 420000,
    "total_denda": 10000,
    "total_jumlah": 430000,
    "lat": 0.44741,
    "lng": 121.939562,
    "color": "#ffc107"
}, {
    "nosamw": "0404393",
    "nama": "Mahmud Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1050000,
    "total_denda": 95000,
    "total_jumlah": 1145000,
    "lat": 0.450117,
    "lng": 121.93928,
    "color": "#dc3545"
}, {
    "nosamw": "0406016",
    "nama": "MAHYUDIN BADU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 433000,
    "total_denda": 5000,
    "total_jumlah": 438000,
    "lat": 0.4480739,
    "lng": 121.9382452,
    "color": "#ffc107"
}, {
    "nosamw": "0400296",
    "nama": "Mani Tama",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44719,
    "lng": 121.939423,
    "color": "#28a745"
}, {
    "nosamw": "0400122",
    "nama": "Mapera Tadang",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447473,
    "lng": 121.939475,
    "color": "#28a745"
}, {
    "nosamw": "0401205",
    "nama": "Mariam Bau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449654,
    "lng": 121.941829,
    "color": "#28a745"
}, {
    "nosamw": "0402326",
    "nama": "Marni Lapata",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445995,
    "lng": 121.938412,
    "color": "#28a745"
}, {
    "nosamw": "0401349",
    "nama": "Marten Yusuf",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1060000,
    "total_denda": 15000,
    "total_jumlah": 1075000,
    "lat": 0.447392,
    "lng": 121.937898,
    "color": "#fd7e14"
}, {
    "nosamw": "0400230",
    "nama": "Marwan Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 4070000,
    "total_denda": 60000,
    "total_jumlah": 4130000,
    "lat": 0.449845,
    "lng": 121.939908,
    "color": "#dc3545"
}, {
    "nosamw": "0401472",
    "nama": "Maryam Kadir",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451493,
    "lng": 121.937886,
    "color": "#28a745"
}, {
    "nosamw": "0400254",
    "nama": "Maryam Polumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2744000,
    "total_denda": 95000,
    "total_jumlah": 2839000,
    "lat": 0.446202,
    "lng": 121.938523,
    "color": "#dc3545"
}, {
    "nosamw": "0400880",
    "nama": "Masiya Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445632,
    "lng": 121.938897,
    "color": "#28a745"
}, {
    "nosamw": "0403386",
    "nama": "Masjid Al-Fajri",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4465868,
    "lng": 121.9386192,
    "color": "#28a745"
}, {
    "nosamw": "0402041",
    "nama": "Mawi Husain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448152,
    "lng": 121.940664,
    "color": "#28a745"
}, {
    "nosamw": "0404503",
    "nama": "MCK Kelapa Dua Marisa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.450056,
    "lng": 121.948841,
    "color": "#28a745"
}, {
    "nosamw": "0402419",
    "nama": "Melda Baino",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44694,
    "lng": 121.94063,
    "color": "#28a745"
}, {
    "nosamw": "0401028",
    "nama": "MELIS LAMANI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 362000,
    "total_denda": 25000,
    "total_jumlah": 387000,
    "lat": 0.447969,
    "lng": 121.941722,
    "color": "#fd7e14"
}, {
    "nosamw": "0402178",
    "nama": "Melisa Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466411,
    "lng": 121.9395851,
    "color": "#28a745"
}, {
    "nosamw": "0400081",
    "nama": "Melly Metti III",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449716,
    "lng": 121.938565,
    "color": "#28a745"
}, {
    "nosamw": "0401283",
    "nama": "MESJID AL - FAZRI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 2126500,
    "total_denda": 20000,
    "total_jumlah": 2146500,
    "lat": 0.44664,
    "lng": 121.938678,
    "color": "#fd7e14"
}, {
    "nosamw": "0402387",
    "nama": "Mesjid Al-Ikhwan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 16400,
    "total_denda": 10000,
    "total_jumlah": 26400,
    "lat": 0.448815,
    "lng": 121.941431,
    "color": "#ffc107"
}, {
    "nosamw": "0402890",
    "nama": "Mesjid Ar- Ridho\/Narjo Al",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451362,
    "lng": 121.938434,
    "color": "#28a745"
}, {
    "nosamw": "0407463",
    "nama": "MESJID JABAL RAHMAH",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "085242849146",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4464017,
    "lng": 121.9378717,
    "color": "#28a745"
}, {
    "nosamw": "0400128",
    "nama": "Mesjid Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 3131500,
    "total_denda": 50000,
    "total_jumlah": 3181500,
    "lat": 0.449031,
    "lng": 121.939363,
    "color": "#dc3545"
}, {
    "nosamw": "0401274",
    "nama": "Min Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1282500,
    "total_denda": 15000,
    "total_jumlah": 1297500,
    "lat": 0.451457,
    "lng": 121.93861,
    "color": "#fd7e14"
}, {
    "nosamw": "0404253",
    "nama": "Miska Tuloli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 10000,
    "total_jumlah": 165500,
    "lat": 0.44708,
    "lng": 121.937862,
    "color": "#ffc107"
}, {
    "nosamw": "0400093",
    "nama": "Moh. Hata Mustafa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172000,
    "total_denda": 5000,
    "total_jumlah": 177000,
    "lat": 0.446662,
    "lng": 121.939769,
    "color": "#ffc107"
}, {
    "nosamw": "0402320",
    "nama": "Moh. Sugianto Todawi II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45342,
    "lng": 121.938538,
    "color": "#28a745"
}, {
    "nosamw": "0402574",
    "nama": "MOH. ZULAIKA ZAKARIA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 311000,
    "total_denda": 20000,
    "total_jumlah": 331000,
    "lat": 0.4515901,
    "lng": 121.9384894,
    "color": "#fd7e14"
}, {
    "nosamw": "0400005",
    "nama": "Mohamad Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447292,
    "lng": 121.939122,
    "color": "#28a745"
}, {
    "nosamw": "0400741",
    "nama": "Mudin Gani",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445924,
    "lng": 121.938072,
    "color": "#28a745"
}, {
    "nosamw": "0404439",
    "nama": "Muhamad Akram Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1152500,
    "total_denda": 15000,
    "total_jumlah": 1167500,
    "lat": 0.448971,
    "lng": 121.938621,
    "color": "#fd7e14"
}, {
    "nosamw": "0404372",
    "nama": "Muhtar Almas II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 647000,
    "total_denda": 15000,
    "total_jumlah": 662000,
    "lat": 0.4462835,
    "lng": 121.9396942,
    "color": "#fd7e14"
}, {
    "nosamw": "0400125",
    "nama": "Muhtar Lamapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 768000,
    "total_denda": 60000,
    "total_jumlah": 828000,
    "lat": 0.446375,
    "lng": 121.938417,
    "color": "#dc3545"
}, {
    "nosamw": "0400195",
    "nama": "Mukhtar Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 10000,
    "total_jumlah": 90000,
    "lat": 0.446973,
    "lng": 121.93942,
    "color": "#ffc107"
}, {
    "nosamw": "0402179",
    "nama": "Mus Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44961,
    "lng": 121.938484,
    "color": "#28a745"
}, {
    "nosamw": "0402013",
    "nama": "MUSHOLAH SABITUL MUTTAQIN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 2201500,
    "total_denda": 5000,
    "total_jumlah": 2206500,
    "lat": 0.4537976,
    "lng": 121.9376821,
    "color": "#ffc107"
}, {
    "nosamw": "0401004",
    "nama": "Mushollah SDN Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 5049000,
    "total_denda": 45000,
    "total_jumlah": 5094000,
    "lat": 0.455291,
    "lng": 121.937571,
    "color": "#dc3545"
}, {
    "nosamw": "0402948",
    "nama": "Musnawati Saridi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 2225000,
    "total_denda": 85000,
    "total_jumlah": 2310000,
    "lat": 0.448816,
    "lng": 121.943291,
    "color": "#dc3545"
}, {
    "nosamw": "0400884",
    "nama": "Nana Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 330000,
    "total_denda": 30000,
    "total_jumlah": 360000,
    "lat": 0.445741,
    "lng": 121.93827,
    "color": "#fd7e14"
}, {
    "nosamw": "0403638",
    "nama": "Nanang Apadjulu  II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449726,
    "lng": 121.948737,
    "color": "#28a745"
}, {
    "nosamw": "0402920",
    "nama": "Nanang saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 139500,
    "total_denda": 5000,
    "total_jumlah": 144500,
    "lat": 0.449502,
    "lng": 121.938726,
    "color": "#ffc107"
}, {
    "nosamw": "0404121",
    "nama": "Nandi Suleman S.Ag",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4543222,
    "lng": 121.9355591,
    "color": "#28a745"
}, {
    "nosamw": "0401263",
    "nama": "Nangsi Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1427000,
    "total_denda": 40000,
    "total_jumlah": 1467000,
    "lat": 0.449805,
    "lng": 121.938425,
    "color": "#dc3545"
}, {
    "nosamw": "0402634",
    "nama": "Nani Balide",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 445000,
    "total_denda": 40000,
    "total_jumlah": 485000,
    "lat": 0.446268,
    "lng": 121.939468,
    "color": "#dc3545"
}, {
    "nosamw": "0402550",
    "nama": "Nano Husain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.447334,
    "lng": 121.940878,
    "color": "#ffc107"
}, {
    "nosamw": "0407533",
    "nama": "NARCO ALI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082261387659",
    "total_bulan": 2,
    "total_tagihan": 123000,
    "total_denda": 5000,
    "total_jumlah": 128000,
    "lat": 0.4522606,
    "lng": 121.9377876,
    "color": "#ffc107"
}, {
    "nosamw": "0401605",
    "nama": "Naser Lapata",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 412000,
    "total_denda": 55000,
    "total_jumlah": 467000,
    "lat": 0.447508,
    "lng": 121.938568,
    "color": "#dc3545"
}, {
    "nosamw": "0400519",
    "nama": "Nasim Puyo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 402000,
    "total_denda": 15000,
    "total_jumlah": 417000,
    "lat": 0.4537235,
    "lng": 121.9383124,
    "color": "#fd7e14"
}, {
    "nosamw": "0400668",
    "nama": "Neis Kiu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 178000,
    "total_denda": 15000,
    "total_jumlah": 193000,
    "lat": 0.448913,
    "lng": 121.939362,
    "color": "#fd7e14"
}, {
    "nosamw": "0400719",
    "nama": "Neis Marjin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451408,
    "lng": 121.937218,
    "color": "#28a745"
}, {
    "nosamw": "0400943",
    "nama": "Neliko Manto",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 995000,
    "total_denda": 90000,
    "total_jumlah": 1085000,
    "lat": 0.448782,
    "lng": 121.943888,
    "color": "#dc3545"
}, {
    "nosamw": "0401588",
    "nama": "Nenti Rahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44558,
    "lng": 121.93826,
    "color": "#28a745"
}, {
    "nosamw": "0402919",
    "nama": "Nenti Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 629000,
    "total_denda": 35000,
    "total_jumlah": 664000,
    "lat": 0.449721,
    "lng": 121.938721,
    "color": "#dc3545"
}, {
    "nosamw": "0401622",
    "nama": "Nila Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302000,
    "total_denda": 45000,
    "total_jumlah": 347000,
    "lat": 0.445772,
    "lng": 121.937586,
    "color": "#dc3545"
}, {
    "nosamw": "0403362",
    "nama": "Ningsi Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 733000,
    "total_denda": 30000,
    "total_jumlah": 763000,
    "lat": 0.452022,
    "lng": 121.938394,
    "color": "#fd7e14"
}, {
    "nosamw": "0402790",
    "nama": "Nini Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.446075,
    "lng": 121.937862,
    "color": "#ffc107"
}, {
    "nosamw": "0404307",
    "nama": "Nining Goi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 236500,
    "total_denda": 15000,
    "total_jumlah": 251500,
    "lat": 0.448913,
    "lng": 121.939362,
    "color": "#fd7e14"
}, {
    "nosamw": "0400935",
    "nama": "Nisa Muksin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.446973,
    "lng": 121.937804,
    "color": "#ffc107"
}, {
    "nosamw": "0400216",
    "nama": "Noldi Bakri",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.45472,
    "lng": 121.93788,
    "color": "#ffc107"
}, {
    "nosamw": "0401721",
    "nama": "Non Lasurullah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 188000,
    "total_denda": 20000,
    "total_jumlah": 208000,
    "lat": 0.446045,
    "lng": 121.939936,
    "color": "#fd7e14"
}, {
    "nosamw": "0400002",
    "nama": "Non Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 333500,
    "total_denda": 20000,
    "total_jumlah": 353500,
    "lat": 0.449958,
    "lng": 121.938742,
    "color": "#fd7e14"
}, {
    "nosamw": "0400143",
    "nama": "NONCE DUNGGIO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4477475,
    "lng": 121.9392764,
    "color": "#28a745"
}, {
    "nosamw": "0402590",
    "nama": "Nonu Taraba",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451535,
    "lng": 121.937079,
    "color": "#28a745"
}, {
    "nosamw": "0402563",
    "nama": "Norma Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2705000,
    "total_denda": 70000,
    "total_jumlah": 2775000,
    "lat": 0.446105,
    "lng": 121.938794,
    "color": "#dc3545"
}, {
    "nosamw": "0402543",
    "nama": "Nou Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 429500,
    "total_denda": 40000,
    "total_jumlah": 469500,
    "lat": 0.448828,
    "lng": 121.943355,
    "color": "#dc3545"
}, {
    "nosamw": "0401024",
    "nama": "Nova Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1040000,
    "total_denda": 35000,
    "total_jumlah": 1075000,
    "lat": 0.4485,
    "lng": 121.941158,
    "color": "#dc3545"
}, {
    "nosamw": "0402147",
    "nama": "Nova Husain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448697,
    "lng": 121.941656,
    "color": "#28a745"
}, {
    "nosamw": "0406883",
    "nama": "NOVAL AL-HADDAR",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 256000,
    "total_denda": 0,
    "total_jumlah": 256000,
    "lat": 0.4495513,
    "lng": 121.9461186,
    "color": "#ffc107"
}, {
    "nosamw": "0401427",
    "nama": "Nune Due",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.452451,
    "lng": 121.938768,
    "color": "#ffc107"
}, {
    "nosamw": "0402517",
    "nama": "Nunu Polumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445734,
    "lng": 121.937924,
    "color": "#28a745"
}, {
    "nosamw": "0402837",
    "nama": "Nur Baiti",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.450055,
    "lng": 121.941242,
    "color": "#fd7e14"
}, {
    "nosamw": "0400084",
    "nama": "NURAIN HUNOWU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1290000,
    "total_denda": 15000,
    "total_jumlah": 1305000,
    "lat": 0.448253,
    "lng": 121.9406662,
    "color": "#fd7e14"
}, {
    "nosamw": "0400226",
    "nama": "Nurdin Abjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 5000,
    "total_jumlah": 73000,
    "lat": 0.44651,
    "lng": 121.939075,
    "color": "#ffc107"
}, {
    "nosamw": "0400127",
    "nama": "Nurdin M.Diko",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446508,
    "lng": 121.938068,
    "color": "#28a745"
}, {
    "nosamw": "0400256",
    "nama": "Nurdin Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 577000,
    "total_denda": 5000,
    "total_jumlah": 582000,
    "lat": 0.448805,
    "lng": 121.943356,
    "color": "#ffc107"
}, {
    "nosamw": "0401609",
    "nama": "Nurlela Abdjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 100500,
    "total_denda": 5000,
    "total_jumlah": 105500,
    "lat": 0.446888,
    "lng": 121.93792,
    "color": "#ffc107"
}, {
    "nosamw": "0401993",
    "nama": "Nurlela Biki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1426500,
    "total_denda": 75000,
    "total_jumlah": 1501500,
    "lat": 0.448788,
    "lng": 121.943952,
    "color": "#dc3545"
}, {
    "nosamw": "0400667",
    "nama": "Ois Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445737,
    "lng": 121.939689,
    "color": "#28a745"
}, {
    "nosamw": "0402764",
    "nama": "Olha Rambing",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449606,
    "lng": 121.939019,
    "color": "#28a745"
}, {
    "nosamw": "0402189",
    "nama": "Olis Dalanggo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 587500,
    "total_denda": 50000,
    "total_jumlah": 637500,
    "lat": 0.447544,
    "lng": 121.941096,
    "color": "#dc3545"
}, {
    "nosamw": "0400129",
    "nama": "Ompa Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447082,
    "lng": 121.939631,
    "color": "#28a745"
}, {
    "nosamw": "0400903",
    "nama": "One Husa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449199,
    "lng": 121.939357,
    "color": "#28a745"
}, {
    "nosamw": "0406023",
    "nama": "OTAN HARUN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.447906,
    "lng": 121.9386994,
    "color": "#ffc107"
}, {
    "nosamw": "0401372",
    "nama": "Oyis Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447348,
    "lng": 121.939898,
    "color": "#28a745"
}, {
    "nosamw": "0407446",
    "nama": "PANDI KIU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085255313756",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4464491,
    "lng": 121.9376274,
    "color": "#fd7e14"
}, {
    "nosamw": "0404292",
    "nama": "PATI HUDODO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 432500,
    "total_denda": 55000,
    "total_jumlah": 487500,
    "lat": 0.450259,
    "lng": 121.941874,
    "color": "#dc3545"
}, {
    "nosamw": "0402572",
    "nama": "Perli Uloli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2092500,
    "total_denda": 70000,
    "total_jumlah": 2162500,
    "lat": 0.451448,
    "lng": 121.937356,
    "color": "#dc3545"
}, {
    "nosamw": "0400161",
    "nama": "PONPES UMMAHAATUL MUKMININ WALMUTTAQIN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 65000,
    "total_denda": 5000,
    "total_jumlah": 70000,
    "lat": 0.4490592,
    "lng": 121.9395363,
    "color": "#ffc107"
}, {
    "nosamw": "0404942",
    "nama": "POPI PAERA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4543393,
    "lng": 121.9378182,
    "color": "#28a745"
}, {
    "nosamw": "0400331",
    "nama": "Rahima Daud",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 47000,
    "total_denda": 5000,
    "total_jumlah": 52000,
    "lat": 0.4462199,
    "lng": 121.9381633,
    "color": "#ffc107"
}, {
    "nosamw": "0400691",
    "nama": "Rahma Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 2183500,
    "total_denda": 60000,
    "total_jumlah": 2243500,
    "lat": 0.448599,
    "lng": 121.941468,
    "color": "#dc3545"
}, {
    "nosamw": "0402921",
    "nama": "Rahma Niar Bouty",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449444,
    "lng": 121.938445,
    "color": "#28a745"
}, {
    "nosamw": "0403731",
    "nama": "Rahmat Polutu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 54000,
    "total_denda": 5000,
    "total_jumlah": 59000,
    "lat": 0.447975,
    "lng": 121.939585,
    "color": "#ffc107"
}, {
    "nosamw": "0401654",
    "nama": "Rahmat. S, ST",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1428500,
    "total_denda": 65000,
    "total_jumlah": 1493500,
    "lat": 0.4472271,
    "lng": 121.9398981,
    "color": "#dc3545"
}, {
    "nosamw": "0402986",
    "nama": "Rahmi Endang",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 2482000,
    "total_denda": 120000,
    "total_jumlah": 2602000,
    "lat": 0.449183,
    "lng": 121.943233,
    "color": "#dc3545"
}, {
    "nosamw": "0402544",
    "nama": "Rahmi Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448645,
    "lng": 121.943071,
    "color": "#28a745"
}, {
    "nosamw": "0400135",
    "nama": "Rais Uloli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 369500,
    "total_denda": 20000,
    "total_jumlah": 389500,
    "lat": 0.446379,
    "lng": 121.938847,
    "color": "#fd7e14"
}, {
    "nosamw": "0400729",
    "nama": "Rais Uloli II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447186,
    "lng": 121.938366,
    "color": "#28a745"
}, {
    "nosamw": "0400271",
    "nama": "Ram Pasandre",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1181000,
    "total_denda": 45000,
    "total_jumlah": 1226000,
    "lat": 0.449086,
    "lng": 121.943039,
    "color": "#dc3545"
}, {
    "nosamw": "0402883",
    "nama": "Ramlah Hasan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448735,
    "lng": 121.942937,
    "color": "#28a745"
}, {
    "nosamw": "0402144",
    "nama": "RAMLAN KAJIM",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 415000,
    "total_denda": 20000,
    "total_jumlah": 435000,
    "lat": 0.4537404,
    "lng": 121.9382935,
    "color": "#fd7e14"
}, {
    "nosamw": "0400324",
    "nama": "Ramli Antukai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2742500,
    "total_denda": 105000,
    "total_jumlah": 2847500,
    "lat": 0.446498,
    "lng": 121.940184,
    "color": "#dc3545"
}, {
    "nosamw": "0402552",
    "nama": "Rapi Djakatara",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.447256,
    "lng": 121.940832,
    "color": "#ffc107"
}, {
    "nosamw": "0400775",
    "nama": "Rasna Tune",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 1097250,
    "total_denda": 25000,
    "total_jumlah": 1122250,
    "lat": 0.448888,
    "lng": 121.943897,
    "color": "#fd7e14"
}, {
    "nosamw": "0400136",
    "nama": "Rasyid Harmain",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1460000,
    "total_denda": 40000,
    "total_jumlah": 1500000,
    "lat": 0.446428,
    "lng": 121.940034,
    "color": "#dc3545"
}, {
    "nosamw": "0402333",
    "nama": "Ratna Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449666,
    "lng": 121.941923,
    "color": "#28a745"
}, {
    "nosamw": "0400397",
    "nama": "Ratna Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1056000,
    "total_denda": 20000,
    "total_jumlah": 1076000,
    "lat": 0.449954,
    "lng": 121.940792,
    "color": "#fd7e14"
}, {
    "nosamw": "0402553",
    "nama": "Ratna Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.453476,
    "lng": 121.938359,
    "color": "#28a745"
}, {
    "nosamw": "0400242",
    "nama": "Ratni Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448898,
    "lng": 121.941462,
    "color": "#28a745"
}, {
    "nosamw": "0400789",
    "nama": "RD POS AL II POHUWATO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1896500,
    "total_denda": 145000,
    "total_jumlah": 2041500,
    "lat": 0.4489999,
    "lng": 121.9454625,
    "color": "#dc3545"
}, {
    "nosamw": "0402560",
    "nama": "Reni Salim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 928000,
    "total_denda": 35000,
    "total_jumlah": 963000,
    "lat": 0.451599,
    "lng": 121.936845,
    "color": "#dc3545"
}, {
    "nosamw": "0402079",
    "nama": "Ridwan Husin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44771,
    "lng": 121.93856,
    "color": "#28a745"
}, {
    "nosamw": "0402881",
    "nama": "Ridwan Suleman",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1631000,
    "total_denda": 40000,
    "total_jumlah": 1671000,
    "lat": 0.448015,
    "lng": 121.938953,
    "color": "#dc3545"
}, {
    "nosamw": "0402782",
    "nama": "Rini Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1856500,
    "total_denda": 100000,
    "total_jumlah": 1956500,
    "lat": 0.44842,
    "lng": 121.941106,
    "color": "#dc3545"
}, {
    "nosamw": "0402539",
    "nama": "Ripin Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448658,
    "lng": 121.941772,
    "color": "#28a745"
}, {
    "nosamw": "0400897",
    "nama": "Riska Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44925,
    "lng": 121.941366,
    "color": "#28a745"
}, {
    "nosamw": "0402587",
    "nama": "Risno Daiponta",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2594500,
    "total_denda": 70000,
    "total_jumlah": 2664500,
    "lat": 0.454229,
    "lng": 121.937903,
    "color": "#dc3545"
}, {
    "nosamw": "0400212",
    "nama": "Rison Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082216967091",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447133,
    "lng": 121.938865,
    "color": "#28a745"
}, {
    "nosamw": "0403709",
    "nama": "Roin M. Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 160000,
    "total_denda": 10000,
    "total_jumlah": 170000,
    "lat": 0.451736,
    "lng": 121.936111,
    "color": "#ffc107"
}, {
    "nosamw": "0400926",
    "nama": "ROLAN BOKINGO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 301000,
    "total_denda": 20000,
    "total_jumlah": 321000,
    "lat": 0.4479636,
    "lng": 121.9384047,
    "color": "#fd7e14"
}, {
    "nosamw": "0401329",
    "nama": "Rolan Manono",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 149000,
    "total_denda": 10000,
    "total_jumlah": 159000,
    "lat": 0.4457655,
    "lng": 121.9383204,
    "color": "#ffc107"
}, {
    "nosamw": "0406015",
    "nama": "ROMIN SUPU",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 135000,
    "total_denda": 0,
    "total_jumlah": 135000,
    "lat": 0.4481008,
    "lng": 121.9383642,
    "color": "#ffc107"
}, {
    "nosamw": "0402005",
    "nama": "Ros Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 4567500,
    "total_denda": 115000,
    "total_jumlah": 4682500,
    "lat": 0.445671,
    "lng": 121.939782,
    "color": "#dc3545"
}, {
    "nosamw": "0400540",
    "nama": "Rosdiana Paneo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1452500,
    "total_denda": 105000,
    "total_jumlah": 1557500,
    "lat": 0.447738,
    "lng": 121.939413,
    "color": "#dc3545"
}, {
    "nosamw": "0401996",
    "nama": "Rosmiati G. Bula",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1020000,
    "total_denda": 45000,
    "total_jumlah": 1065000,
    "lat": 0.449386,
    "lng": 121.943482,
    "color": "#dc3545"
}, {
    "nosamw": "0402566",
    "nama": "Rosna Djafar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 292250,
    "total_denda": 10000,
    "total_jumlah": 302250,
    "lat": 0.4545487,
    "lng": 121.9376823,
    "color": "#fd7e14"
}, {
    "nosamw": "0400244",
    "nama": "Rosna Mahanggi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1647500,
    "total_denda": 70000,
    "total_jumlah": 1717500,
    "lat": 0.450524,
    "lng": 121.939543,
    "color": "#dc3545"
}, {
    "nosamw": "0402570",
    "nama": "Rostin Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 820500,
    "total_denda": 30000,
    "total_jumlah": 850500,
    "lat": 0.447525,
    "lng": 121.938353,
    "color": "#dc3545"
}, {
    "nosamw": "0402886",
    "nama": "Rostin Lapata",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449275,
    "lng": 121.941519,
    "color": "#28a745"
}, {
    "nosamw": "0403449",
    "nama": "Rostin Tino",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 15000,
    "total_jumlah": 180000,
    "lat": 0.4490017,
    "lng": 121.94199,
    "color": "#fd7e14"
}, {
    "nosamw": "0404430",
    "nama": "Roy Tangahu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 463500,
    "total_denda": 25000,
    "total_jumlah": 488500,
    "lat": 0.4454642,
    "lng": 121.9381007,
    "color": "#fd7e14"
}, {
    "nosamw": "0405023",
    "nama": "RUDI LAMELO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 359500,
    "total_denda": 25000,
    "total_jumlah": 384500,
    "lat": 0.4465645,
    "lng": 121.93913,
    "color": "#fd7e14"
}, {
    "nosamw": "0401719",
    "nama": "Rudin Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 3197000,
    "total_denda": 170000,
    "total_jumlah": 3367000,
    "lat": 0.445615,
    "lng": 121.9398,
    "color": "#dc3545"
}, {
    "nosamw": "0402015",
    "nama": "Rudin K. Olii",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2680750,
    "total_denda": 110000,
    "total_jumlah": 2790750,
    "lat": 0.445971,
    "lng": 121.940048,
    "color": "#dc3545"
}, {
    "nosamw": "0402585",
    "nama": "Rukmin Paera",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1962500,
    "total_denda": 50000,
    "total_jumlah": 2012500,
    "lat": 0.454513,
    "lng": 121.938029,
    "color": "#dc3545"
}, {
    "nosamw": "0400707",
    "nama": "Ruslan Bouty",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 548500,
    "total_denda": 15000,
    "total_jumlah": 563500,
    "lat": 0.450292,
    "lng": 121.939987,
    "color": "#fd7e14"
}, {
    "nosamw": "0401615",
    "nama": "Ruslia Biki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 2084500,
    "total_denda": 85000,
    "total_jumlah": 2169500,
    "lat": 0.447782,
    "lng": 121.941308,
    "color": "#dc3545"
}, {
    "nosamw": "0400055",
    "nama": "Rustam Layuhibu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451553,
    "lng": 121.938811,
    "color": "#28a745"
}, {
    "nosamw": "0400109",
    "nama": "Rusu Almas I",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 560000,
    "total_denda": 80000,
    "total_jumlah": 640000,
    "lat": 0.447129,
    "lng": 121.939461,
    "color": "#dc3545"
}, {
    "nosamw": "0401540",
    "nama": "Saboha Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.447386,
    "lng": 121.939652,
    "color": "#ffc107"
}, {
    "nosamw": "0400953",
    "nama": "Sadik Giasi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 912500,
    "total_denda": 45000,
    "total_jumlah": 957500,
    "lat": 0.447857,
    "lng": 121.941501,
    "color": "#dc3545"
}, {
    "nosamw": "0400009",
    "nama": "Safrudin Abdullah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 262500,
    "total_denda": 0,
    "total_jumlah": 262500,
    "lat": 0.452064,
    "lng": 121.938048,
    "color": "#ffc107"
}, {
    "nosamw": "0400686",
    "nama": "Sahriyanto Lamapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1313500,
    "total_denda": 30000,
    "total_jumlah": 1343500,
    "lat": 0.445891,
    "lng": 121.938489,
    "color": "#fd7e14"
}, {
    "nosamw": "0401288",
    "nama": "Said Nusa II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 487500,
    "total_denda": 35000,
    "total_jumlah": 522500,
    "lat": 0.449297,
    "lng": 121.943446,
    "color": "#dc3545"
}, {
    "nosamw": "0400542",
    "nama": "Saiful Alam",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 843500,
    "total_denda": 65000,
    "total_jumlah": 908500,
    "lat": 0.447026,
    "lng": 121.939361,
    "color": "#dc3545"
}, {
    "nosamw": "0401423",
    "nama": "Saiful Djauhari",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 767000,
    "total_denda": 50000,
    "total_jumlah": 817000,
    "lat": 0.4516,
    "lng": 121.937649,
    "color": "#dc3545"
}, {
    "nosamw": "0406002",
    "nama": "SAIPUL AMANA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 214000,
    "total_denda": 10000,
    "total_jumlah": 224000,
    "lat": 0.4477936,
    "lng": 121.9393434,
    "color": "#ffc107"
}, {
    "nosamw": "0402097",
    "nama": "Saipul Rasid",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 2535500,
    "total_denda": 95000,
    "total_jumlah": 2630500,
    "lat": 0.448814,
    "lng": 121.944323,
    "color": "#dc3545"
}, {
    "nosamw": "0400089",
    "nama": "Salami Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448341,
    "lng": 121.940943,
    "color": "#28a745"
}, {
    "nosamw": "0402153",
    "nama": "Salani Dalango",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445645,
    "lng": 121.937584,
    "color": "#28a745"
}, {
    "nosamw": "0402649",
    "nama": "Saleh Dalanggo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447312,
    "lng": 121.937705,
    "color": "#28a745"
}, {
    "nosamw": "0401425",
    "nama": "Salju Marhaba",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 454000,
    "total_denda": 15000,
    "total_jumlah": 469000,
    "lat": 0.454513,
    "lng": 121.938029,
    "color": "#fd7e14"
}, {
    "nosamw": "0401945",
    "nama": "Salma Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 1043000,
    "total_denda": 165000,
    "total_jumlah": 1208000,
    "lat": 0.446632,
    "lng": 121.938162,
    "color": "#dc3545"
}, {
    "nosamw": "0401610",
    "nama": "Salma Habubu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446237,
    "lng": 121.938208,
    "color": "#28a745"
}, {
    "nosamw": "0400103",
    "nama": "Salma Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 450500,
    "total_denda": 25000,
    "total_jumlah": 475500,
    "lat": 0.446651,
    "lng": 121.939161,
    "color": "#fd7e14"
}, {
    "nosamw": "0400309",
    "nama": "Salma Lamapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447657,
    "lng": 121.938461,
    "color": "#28a745"
}, {
    "nosamw": "0403603",
    "nama": "Salmin Rasyid",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 54000,
    "total_denda": 10000,
    "total_jumlah": 64000,
    "lat": 0.449463,
    "lng": 121.938562,
    "color": "#ffc107"
}, {
    "nosamw": "0401405",
    "nama": "Sam Djafar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 63500,
    "total_denda": 5000,
    "total_jumlah": 68500,
    "lat": 0.45498,
    "lng": 121.937873,
    "color": "#ffc107"
}, {
    "nosamw": "0403388",
    "nama": "Sam Lasampe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 354000,
    "total_denda": 40000,
    "total_jumlah": 394000,
    "lat": 0.445707,
    "lng": 121.937636,
    "color": "#dc3545"
}, {
    "nosamw": "0402184",
    "nama": "Samin Umar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44989,
    "lng": 121.939347,
    "color": "#28a745"
}, {
    "nosamw": "0400716",
    "nama": "Samsudin Mohamad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 474500,
    "total_denda": 35000,
    "total_jumlah": 509500,
    "lat": 0.44762,
    "lng": 121.938574,
    "color": "#dc3545"
}, {
    "nosamw": "0401270",
    "nama": "SAMSUDIN PAKAYA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.4484045,
    "lng": 121.9426074,
    "color": "#ffc107"
}, {
    "nosamw": "0402436",
    "nama": "Sance Panggi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45152,
    "lng": 121.937651,
    "color": "#28a745"
}, {
    "nosamw": "0401330",
    "nama": "Sango Kadir",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 159000,
    "total_denda": 15000,
    "total_jumlah": 174000,
    "lat": 0.446019,
    "lng": 121.938681,
    "color": "#fd7e14"
}, {
    "nosamw": "0402104",
    "nama": "SARCE PAUNE",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 1061000,
    "total_denda": 35000,
    "total_jumlah": 1096000,
    "lat": 0.448785,
    "lng": 121.944189,
    "color": "#dc3545"
}, {
    "nosamw": "0402002",
    "nama": "Sarco Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 232000,
    "total_denda": 20000,
    "total_jumlah": 252000,
    "lat": 0.448667,
    "lng": 121.943997,
    "color": "#fd7e14"
}, {
    "nosamw": "0401578",
    "nama": "Sarco Rahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 102400,
    "total_denda": 10000,
    "total_jumlah": 112400,
    "lat": 0.445236,
    "lng": 121.938226,
    "color": "#ffc107"
}, {
    "nosamw": "0405891",
    "nama": "Sarifudin Omintadu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 5000,
    "total_jumlah": 71000,
    "lat": 0.4478982,
    "lng": 121.9390297,
    "color": "#ffc107"
}, {
    "nosamw": "0401445",
    "nama": "Sarini Alim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447225,
    "lng": 121.939556,
    "color": "#28a745"
}, {
    "nosamw": "0404302",
    "nama": "Sarintan Abdjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 526000,
    "total_denda": 45000,
    "total_jumlah": 571000,
    "lat": 0.4458027,
    "lng": 121.9395767,
    "color": "#dc3545"
}, {
    "nosamw": "0401358",
    "nama": "Sarlin Dunggio",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 692000,
    "total_denda": 40000,
    "total_jumlah": 732000,
    "lat": 0.448753,
    "lng": 121.944395,
    "color": "#dc3545"
}, {
    "nosamw": "0400894",
    "nama": "Sartika Samade",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1011500,
    "total_denda": 85000,
    "total_jumlah": 1096500,
    "lat": 0.445692,
    "lng": 121.937875,
    "color": "#dc3545"
}, {
    "nosamw": "0404252",
    "nama": "Sartin Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 8693250,
    "total_denda": 95000,
    "total_jumlah": 8788250,
    "lat": 0.44727,
    "lng": 121.937865,
    "color": "#dc3545"
}, {
    "nosamw": "0402031",
    "nama": "Sartin Djakatara",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 2217750,
    "total_denda": 90000,
    "total_jumlah": 2307750,
    "lat": 0.449682,
    "lng": 121.942888,
    "color": "#dc3545"
}, {
    "nosamw": "0400231",
    "nama": "Sarton Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 47,
    "total_tagihan": 9477500,
    "total_denda": 235000,
    "total_jumlah": 9712500,
    "lat": 0.450093,
    "lng": 121.939903,
    "color": "#dc3545"
}, {
    "nosamw": "0400378",
    "nama": "SDN Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 800500,
    "total_denda": 0,
    "total_jumlah": 800500,
    "lat": 0.454965,
    "lng": 121.936026,
    "color": "#ffc107"
}, {
    "nosamw": "0402556",
    "nama": "Selpi Daluta",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449074,
    "lng": 121.944088,
    "color": "#28a745"
}, {
    "nosamw": "0401921",
    "nama": "Selpi Sahabu II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 770000,
    "total_denda": 70000,
    "total_jumlah": 840000,
    "lat": 0.448775,
    "lng": 121.943872,
    "color": "#dc3545"
}, {
    "nosamw": "0402549",
    "nama": "Selpi Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 924000,
    "total_denda": 30000,
    "total_jumlah": 954000,
    "lat": 0.445784,
    "lng": 121.938632,
    "color": "#fd7e14"
}, {
    "nosamw": "0402538",
    "nama": "SELPIN PAKAYA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 734500,
    "total_denda": 35000,
    "total_jumlah": 769500,
    "lat": 0.4527,
    "lng": 121.939383,
    "color": "#dc3545"
}, {
    "nosamw": "0402614",
    "nama": "Selvi Pomusu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449431,
    "lng": 121.941957,
    "color": "#28a745"
}, {
    "nosamw": "0400878",
    "nama": "Selvi Sahabu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 2606000,
    "total_denda": 75000,
    "total_jumlah": 2681000,
    "lat": 0.448698,
    "lng": 121.943476,
    "color": "#dc3545"
}, {
    "nosamw": "0402435",
    "nama": "Serlin Kopoli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447032,
    "lng": 121.940686,
    "color": "#28a745"
}, {
    "nosamw": "0401720",
    "nama": "Sey Lopuo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446804,
    "lng": 121.939226,
    "color": "#28a745"
}, {
    "nosamw": "0400268",
    "nama": "Sien Polumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446662,
    "lng": 121.939769,
    "color": "#28a745"
}, {
    "nosamw": "0403610",
    "nama": "Sifoni Antukai II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 390000,
    "total_denda": 35000,
    "total_jumlah": 425000,
    "lat": 0.449453,
    "lng": 121.940676,
    "color": "#dc3545"
}, {
    "nosamw": "0400955",
    "nama": "Siko Lapunco",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 577500,
    "total_denda": 15000,
    "total_jumlah": 592500,
    "lat": 0.4492602,
    "lng": 121.9455645,
    "color": "#fd7e14"
}, {
    "nosamw": "0400957",
    "nama": "Silfoni Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.445318,
    "lng": 121.937875,
    "color": "#ffc107"
}, {
    "nosamw": "0406024",
    "nama": "SILVANA MUSA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 368000,
    "total_denda": 50000,
    "total_jumlah": 418000,
    "lat": 0.4479855,
    "lng": 121.9379123,
    "color": "#dc3545"
}, {
    "nosamw": "0401456",
    "nama": "Silvoni Nihe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.448029,
    "lng": 121.942005,
    "color": "#ffc107"
}, {
    "nosamw": "0403596",
    "nama": "Sin Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 371000,
    "total_denda": 10000,
    "total_jumlah": 381000,
    "lat": 0.447484,
    "lng": 121.938448,
    "color": "#ffc107"
}, {
    "nosamw": "0400709",
    "nama": "Sindy Bouty",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 120000,
    "total_denda": 5000,
    "total_jumlah": 125000,
    "lat": 0.449972,
    "lng": 121.939997,
    "color": "#ffc107"
}, {
    "nosamw": "0401507",
    "nama": "Sintia Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449752,
    "lng": 121.941024,
    "color": "#28a745"
}, {
    "nosamw": "0401356",
    "nama": "Siti Nikmatul Ma wa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.4525827,
    "lng": 121.937013,
    "color": "#fd7e14"
}, {
    "nosamw": "0401365",
    "nama": "SMP 4 Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "SN",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 553000,
    "total_denda": 15000,
    "total_jumlah": 568000,
    "lat": 0.449716,
    "lng": 121.938605,
    "color": "#fd7e14"
}, {
    "nosamw": "0403607",
    "nama": "Sofyan Dama",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1645250,
    "total_denda": 70000,
    "total_jumlah": 1715250,
    "lat": 0.445712,
    "lng": 121.93997,
    "color": "#dc3545"
}, {
    "nosamw": "0400904",
    "nama": "Sofyan Imale",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.447159,
    "lng": 121.939636,
    "color": "#ffc107"
}, {
    "nosamw": "0400710",
    "nama": "Sopyan Supu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 476500,
    "total_denda": 15000,
    "total_jumlah": 491500,
    "lat": 0.449766,
    "lng": 121.9403259,
    "color": "#fd7e14"
}, {
    "nosamw": "0403595",
    "nama": "Sri Endang M. Noer",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1305000,
    "total_denda": 70000,
    "total_jumlah": 1375000,
    "lat": 0.447602,
    "lng": 121.938683,
    "color": "#dc3545"
}, {
    "nosamw": "0402504",
    "nama": "Sri Wati Iji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 346500,
    "total_denda": 25000,
    "total_jumlah": 371500,
    "lat": 0.449128,
    "lng": 121.943794,
    "color": "#fd7e14"
}, {
    "nosamw": "0406812",
    "nama": "SRI YANI ASTUTIK",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 2502500,
    "total_denda": 20000,
    "total_jumlah": 2522500,
    "lat": 0.4539723,
    "lng": 121.9567619,
    "color": "#fd7e14"
}, {
    "nosamw": "0400106",
    "nama": "Sriyulan M. Ishak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 642500,
    "total_denda": 5000,
    "total_jumlah": 647500,
    "lat": 0.448354,
    "lng": 121.940778,
    "color": "#ffc107"
}, {
    "nosamw": "0402923",
    "nama": "Sugeng Wahyudi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 344500,
    "total_denda": 5000,
    "total_jumlah": 349500,
    "lat": 0.4493383,
    "lng": 121.9385633,
    "color": "#ffc107"
}, {
    "nosamw": "0402586",
    "nama": "SUHARTO DAUD",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 257500,
    "total_denda": 30000,
    "total_jumlah": 287500,
    "lat": 0.453749,
    "lng": 121.937923,
    "color": "#fd7e14"
}, {
    "nosamw": "0406017",
    "nama": "SUHELMI POHA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44988,
    "lng": 121.938214,
    "color": "#28a745"
}, {
    "nosamw": "0402742",
    "nama": "Suhelmi Poha",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 712000,
    "total_denda": 45000,
    "total_jumlah": 757000,
    "lat": 0.44988,
    "lng": 121.938214,
    "color": "#dc3545"
}, {
    "nosamw": "0400097",
    "nama": "Sukardi Saleh",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447122,
    "lng": 121.939655,
    "color": "#28a745"
}, {
    "nosamw": "0401276",
    "nama": "Sukardi Saleh II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 297500,
    "total_denda": 5000,
    "total_jumlah": 302500,
    "lat": 0.448388,
    "lng": 121.938772,
    "color": "#ffc107"
}, {
    "nosamw": "0400879",
    "nama": "Sukiman Madu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 940500,
    "total_denda": 60000,
    "total_jumlah": 1000500,
    "lat": 0.451451,
    "lng": 121.93845,
    "color": "#dc3545"
}, {
    "nosamw": "0400694",
    "nama": "Sulce Imran",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.447308,
    "lng": 121.93943,
    "color": "#fd7e14"
}, {
    "nosamw": "0401446",
    "nama": "Suleman Abd. Azis",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446804,
    "lng": 121.939226,
    "color": "#28a745"
}, {
    "nosamw": "0402526",
    "nama": "Suleman Anwar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 55000,
    "total_jumlah": 665000,
    "lat": 0.453177,
    "lng": 121.938658,
    "color": "#dc3545"
}, {
    "nosamw": "0404289",
    "nama": "Suleman Dai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 564000,
    "total_denda": 35000,
    "total_jumlah": 599000,
    "lat": 0.451849,
    "lng": 121.936316,
    "color": "#dc3545"
}, {
    "nosamw": "0402821",
    "nama": "Suleman Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.449065,
    "lng": 121.93925,
    "color": "#ffc107"
}, {
    "nosamw": "0404357",
    "nama": "Suleman Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.454566,
    "lng": 121.955676,
    "color": "#28a745"
}, {
    "nosamw": "0402116",
    "nama": "Suleman Walahe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 10000,
    "total_jumlah": 90000,
    "lat": 0.447843,
    "lng": 121.94143,
    "color": "#ffc107"
}, {
    "nosamw": "0402569",
    "nama": "Sulfi Ibrahim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449187,
    "lng": 121.941963,
    "color": "#28a745"
}, {
    "nosamw": "0400247",
    "nama": "Suma Abjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446333,
    "lng": 121.938225,
    "color": "#28a745"
}, {
    "nosamw": "0400771",
    "nama": "Sumarni Panggi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1702000,
    "total_denda": 85000,
    "total_jumlah": 1787000,
    "lat": 0.451526,
    "lng": 121.937907,
    "color": "#dc3545"
}, {
    "nosamw": "0402564",
    "nama": "Sumiati Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 280200,
    "total_denda": 40000,
    "total_jumlah": 320200,
    "lat": 0.446236,
    "lng": 121.938348,
    "color": "#dc3545"
}, {
    "nosamw": "0401015",
    "nama": "Sumiati Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 2149000,
    "total_denda": 50000,
    "total_jumlah": 2199000,
    "lat": 0.447181,
    "lng": 121.939501,
    "color": "#dc3545"
}, {
    "nosamw": "0401718",
    "nama": "Sumiyati Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 24,
    "total_tagihan": 797000,
    "total_denda": 120000,
    "total_jumlah": 917000,
    "lat": 0.445779,
    "lng": 121.940131,
    "color": "#dc3545"
}, {
    "nosamw": "0400141",
    "nama": "Sun Bulonggodu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448,
    "lng": 121.93974,
    "color": "#28a745"
}, {
    "nosamw": "0400328",
    "nama": "Sunandar Buluati",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 12560550,
    "total_denda": 160000,
    "total_jumlah": 12720550,
    "lat": 0.447162,
    "lng": 121.937847,
    "color": "#dc3545"
}, {
    "nosamw": "0407429",
    "nama": "SUPRATMAN",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082271080664",
    "total_bulan": 1,
    "total_tagihan": 253200,
    "total_denda": 5000,
    "total_jumlah": 258200,
    "lat": 0.4460883,
    "lng": 121.9395648,
    "color": "#ffc107"
}, {
    "nosamw": "0401410",
    "nama": "Suratmin Nento",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 2204000,
    "total_denda": 35000,
    "total_jumlah": 2239000,
    "lat": 0.446434,
    "lng": 121.940124,
    "color": "#dc3545"
}, {
    "nosamw": "0402983",
    "nama": "Suriani Danupoyo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 390000,
    "total_denda": 45000,
    "total_jumlah": 435000,
    "lat": 0.449141,
    "lng": 121.943058,
    "color": "#dc3545"
}, {
    "nosamw": "0404560",
    "nama": "Suryance Mbuinga 2",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445798,
    "lng": 121.940034,
    "color": "#28a745"
}, {
    "nosamw": "0404309",
    "nama": "Suta Daniel",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445164,
    "lng": 121.938641,
    "color": "#28a745"
}, {
    "nosamw": "0404429",
    "nama": "Syamsia Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 280000,
    "total_denda": 35000,
    "total_jumlah": 315000,
    "lat": 0.44999,
    "lng": 121.94075,
    "color": "#dc3545"
}, {
    "nosamw": "0400351",
    "nama": "Syamsuri",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 2807000,
    "total_denda": 60000,
    "total_jumlah": 2867000,
    "lat": 0.45326,
    "lng": 121.938355,
    "color": "#dc3545"
}, {
    "nosamw": "0403365",
    "nama": "Tahir Matlup",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 20000,
    "total_jumlah": 240000,
    "lat": 0.445683,
    "lng": 121.937985,
    "color": "#fd7e14"
}, {
    "nosamw": "0406018",
    "nama": "TAMRIN NOHO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 2648750,
    "total_denda": 135000,
    "total_jumlah": 2783750,
    "lat": 0.45368,
    "lng": 121.937802,
    "color": "#dc3545"
}, {
    "nosamw": "0400777",
    "nama": "Tana Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 3872500,
    "total_denda": 65000,
    "total_jumlah": 3937500,
    "lat": 0.450057,
    "lng": 121.939944,
    "color": "#dc3545"
}, {
    "nosamw": "0402926",
    "nama": "Tarno Daluta",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 624000,
    "total_denda": 30000,
    "total_jumlah": 654000,
    "lat": 0.44967,
    "lng": 121.942908,
    "color": "#fd7e14"
}, {
    "nosamw": "0400133",
    "nama": "Tasmin Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 381000,
    "total_denda": 10000,
    "total_jumlah": 391000,
    "lat": 0.446322,
    "lng": 121.938871,
    "color": "#ffc107"
}, {
    "nosamw": "0400807",
    "nama": "Tati Tadang",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 830000,
    "total_denda": 75000,
    "total_jumlah": 905000,
    "lat": 0.453982,
    "lng": 121.938365,
    "color": "#dc3545"
}, {
    "nosamw": "0403357",
    "nama": "Tayun Sompa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 539000,
    "total_denda": 45000,
    "total_jumlah": 584000,
    "lat": 0.449478,
    "lng": 121.940389,
    "color": "#dc3545"
}, {
    "nosamw": "0402565",
    "nama": "Teni Adipu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.4463424,
    "lng": 121.9383778,
    "color": "#ffc107"
}, {
    "nosamw": "0402990",
    "nama": "Teni Olii",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1758000,
    "total_denda": 55000,
    "total_jumlah": 1813000,
    "lat": 0.4491993,
    "lng": 121.9441019,
    "color": "#dc3545"
}, {
    "nosamw": "0404946",
    "nama": "THALIB YUSUF",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1619500,
    "total_denda": 50000,
    "total_jumlah": 1669500,
    "lat": 0.4457367,
    "lng": 121.9379133,
    "color": "#dc3545"
}, {
    "nosamw": "0401447",
    "nama": "Tima Yusuf",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 825000,
    "total_denda": 75000,
    "total_jumlah": 900000,
    "lat": 0.445871,
    "lng": 121.937622,
    "color": "#dc3545"
}, {
    "nosamw": "0402514",
    "nama": "Tommi Silas II",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R4",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.452272,
    "lng": 121.957259,
    "color": "#28a745"
}, {
    "nosamw": "0403174",
    "nama": "Toni Abubakar",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 3635000,
    "total_denda": 95000,
    "total_jumlah": 3730000,
    "lat": 0.449487,
    "lng": 121.939995,
    "color": "#dc3545"
}, {
    "nosamw": "0400157",
    "nama": "Tou Balide",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.447532,
    "lng": 121.938843,
    "color": "#ffc107"
}, {
    "nosamw": "0403358",
    "nama": "Tue Harun",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446426,
    "lng": 121.938252,
    "color": "#28a745"
}, {
    "nosamw": "0400139",
    "nama": "Tue Podungge",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44633,
    "lng": 121.938829,
    "color": "#28a745"
}, {
    "nosamw": "0400201",
    "nama": "Tue Polumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 575000,
    "total_denda": 40000,
    "total_jumlah": 615000,
    "lat": 0.44933,
    "lng": 121.940157,
    "color": "#dc3545"
}, {
    "nosamw": "0404849",
    "nama": "TUTUN PASISINGI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1344000,
    "total_denda": 30000,
    "total_jumlah": 1374000,
    "lat": 0.4537402,
    "lng": 121.9378725,
    "color": "#dc3545"
}, {
    "nosamw": "0402650",
    "nama": "Tuu Due",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 529500,
    "total_denda": 40000,
    "total_jumlah": 569500,
    "lat": 0.4460634,
    "lng": 121.9385975,
    "color": "#dc3545"
}, {
    "nosamw": "0400918",
    "nama": "Ucen Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2344000,
    "total_denda": 95000,
    "total_jumlah": 2439000,
    "lat": 0.449044,
    "lng": 121.942879,
    "color": "#dc3545"
}, {
    "nosamw": "0401592",
    "nama": "Udin Gani",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 402000,
    "total_denda": 20000,
    "total_jumlah": 422000,
    "lat": 0.447081,
    "lng": 121.937905,
    "color": "#fd7e14"
}, {
    "nosamw": "0400200",
    "nama": "Udin Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 838500,
    "total_denda": 35000,
    "total_jumlah": 873500,
    "lat": 0.446481,
    "lng": 121.939891,
    "color": "#dc3545"
}, {
    "nosamw": "0400559",
    "nama": "Udin Poha",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 1065000,
    "total_denda": 60000,
    "total_jumlah": 1125000,
    "lat": 0.449877,
    "lng": 121.93909,
    "color": "#dc3545"
}, {
    "nosamw": "0402559",
    "nama": "Uken Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1500000,
    "total_denda": 115000,
    "total_jumlah": 1615000,
    "lat": 0.450191,
    "lng": 121.941437,
    "color": "#dc3545"
}, {
    "nosamw": "0402613",
    "nama": "Ulfa Biki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 488000,
    "total_denda": 35000,
    "total_jumlah": 523000,
    "lat": 0.446744,
    "lng": 121.941144,
    "color": "#dc3545"
}, {
    "nosamw": "0402401",
    "nama": "Ulin Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 584000,
    "total_denda": 40000,
    "total_jumlah": 624000,
    "lat": 0.449581,
    "lng": 121.941978,
    "color": "#dc3545"
}, {
    "nosamw": "0403404",
    "nama": "Umar Abdullah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.448674,
    "lng": 121.941695,
    "color": "#ffc107"
}, {
    "nosamw": "0404994",
    "nama": "UMAR DJAFAR",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4458581,
    "lng": 121.9386514,
    "color": "#28a745"
}, {
    "nosamw": "0406019",
    "nama": "UMAR NUSI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 28,
    "total_tagihan": 3288500,
    "total_denda": 140000,
    "total_jumlah": 3428500,
    "lat": 0.4477151,
    "lng": 121.9378607,
    "color": "#dc3545"
}, {
    "nosamw": "0401440",
    "nama": "Umar Suleman",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447241,
    "lng": 121.939394,
    "color": "#28a745"
}, {
    "nosamw": "0400538",
    "nama": "Un Metti",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449164,
    "lng": 121.939902,
    "color": "#28a745"
}, {
    "nosamw": "0406003",
    "nama": "UNA RASYID",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 176800,
    "total_denda": 15000,
    "total_jumlah": 191800,
    "lat": 0.4480578,
    "lng": 121.9383109,
    "color": "#fd7e14"
}, {
    "nosamw": "0401040",
    "nama": "Une Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1194500,
    "total_denda": 95000,
    "total_jumlah": 1289500,
    "lat": 0.449211,
    "lng": 121.943886,
    "color": "#dc3545"
}, {
    "nosamw": "0404226",
    "nama": "USAID Aisa Kasim",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 691500,
    "total_denda": 50000,
    "total_jumlah": 741500,
    "lat": 0.445919,
    "lng": 121.938681,
    "color": "#dc3545"
}, {
    "nosamw": "0404134",
    "nama": "USAID Alex Abdjul",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 5000,
    "total_jumlah": 40000,
    "lat": 0.445289,
    "lng": 121.939034,
    "color": "#ffc107"
}, {
    "nosamw": "0404116",
    "nama": "USAID AMNA RUJUA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 5000,
    "total_jumlah": 92500,
    "lat": 0.4671141,
    "lng": 121.9508947,
    "color": "#ffc107"
}, {
    "nosamw": "0403870",
    "nama": "USAID Anton S.",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.445271,
    "lng": 121.938905,
    "color": "#ffc107"
}, {
    "nosamw": "0404124",
    "nama": "USAID Iyong Botutihe",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451469,
    "lng": 121.93626,
    "color": "#28a745"
}, {
    "nosamw": "0404126",
    "nama": "USAID Mitra Balide",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 655500,
    "total_denda": 55000,
    "total_jumlah": 710500,
    "lat": 0.445403,
    "lng": 121.939223,
    "color": "#dc3545"
}, {
    "nosamw": "0404139",
    "nama": "USAID RAHIM A. TOOLI",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 999500,
    "total_denda": 25000,
    "total_jumlah": 1024500,
    "lat": 0.445295,
    "lng": 121.939021,
    "color": "#fd7e14"
}, {
    "nosamw": "0404138",
    "nama": "USAID Suleman Rajak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451424,
    "lng": 121.936129,
    "color": "#28a745"
}, {
    "nosamw": "0404136",
    "nama": "USAID Suleman Talib",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.451619,
    "lng": 121.936668,
    "color": "#ffc107"
}, {
    "nosamw": "0404106",
    "nama": "USAID Uti Due",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449803,
    "lng": 121.942082,
    "color": "#28a745"
}, {
    "nosamw": "0404117",
    "nama": "USAID Wardin Taraba",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 3200250,
    "total_denda": 75000,
    "total_jumlah": 3275250,
    "lat": 0.452448,
    "lng": 121.936215,
    "color": "#dc3545"
}, {
    "nosamw": "0404133",
    "nama": "USAID Weni Mantu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 91200,
    "total_denda": 10000,
    "total_jumlah": 101200,
    "lat": 0.445528,
    "lng": 121.939289,
    "color": "#ffc107"
}, {
    "nosamw": "0404101",
    "nama": "USAID Wini",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449924,
    "lng": 121.942153,
    "color": "#28a745"
}, {
    "nosamw": "0404123",
    "nama": "USAID Wirna Saman",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.445995,
    "lng": 121.938723,
    "color": "#28a745"
}, {
    "nosamw": "0404131",
    "nama": "USAID Yakob Imran",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4466,
    "lng": 121.939076,
    "color": "#28a745"
}, {
    "nosamw": "0404118",
    "nama": "USAID Yerik Apadjulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 278600,
    "total_denda": 35000,
    "total_jumlah": 313600,
    "lat": 0.444979,
    "lng": 121.938977,
    "color": "#dc3545"
}, {
    "nosamw": "0404128",
    "nama": "USAID Yoni Abay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302000,
    "total_denda": 45000,
    "total_jumlah": 347000,
    "lat": 0.452927,
    "lng": 121.936041,
    "color": "#dc3545"
}, {
    "nosamw": "0404135",
    "nama": "USAID Yulis Lamapa",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.44552,
    "lng": 121.939294,
    "color": "#28a745"
}, {
    "nosamw": "0400080",
    "nama": "Usman Haras",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 4808250,
    "total_denda": 25000,
    "total_jumlah": 4833250,
    "lat": 0.450663,
    "lng": 121.939349,
    "color": "#fd7e14"
}, {
    "nosamw": "0400252",
    "nama": "Usman Karbaini",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 1128000,
    "total_denda": 95000,
    "total_jumlah": 1223000,
    "lat": 0.453495,
    "lng": 121.938416,
    "color": "#dc3545"
}, {
    "nosamw": "0400761",
    "nama": "Victor Djatmika",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.451578,
    "lng": 121.938055,
    "color": "#ffc107"
}, {
    "nosamw": "0401841",
    "nama": "Wahab Tuloli",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 1035000,
    "total_denda": 15000,
    "total_jumlah": 1050000,
    "lat": 0.447883,
    "lng": 121.938178,
    "color": "#fd7e14"
}, {
    "nosamw": "0400092",
    "nama": "Wahe Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 228000,
    "total_denda": 25000,
    "total_jumlah": 253000,
    "lat": 0.446999,
    "lng": 121.939791,
    "color": "#fd7e14"
}, {
    "nosamw": "0400279",
    "nama": "Wahid M. Nur",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447705,
    "lng": 121.938757,
    "color": "#28a745"
}, {
    "nosamw": "0400871",
    "nama": "Wani Almas",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 1304500,
    "total_denda": 75000,
    "total_jumlah": 1379500,
    "lat": 0.446456,
    "lng": 121.938153,
    "color": "#dc3545"
}, {
    "nosamw": "0404951",
    "nama": "WAPI LOPUO",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4458258,
    "lng": 121.9386993,
    "color": "#28a745"
}, {
    "nosamw": "0400137",
    "nama": "Wardin Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 133000,
    "total_denda": 5000,
    "total_jumlah": 138000,
    "lat": 0.44727,
    "lng": 121.939305,
    "color": "#ffc107"
}, {
    "nosamw": "0400740",
    "nama": "Warman Imale",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 525000,
    "total_denda": 30000,
    "total_jumlah": 555000,
    "lat": 0.44797,
    "lng": 121.940515,
    "color": "#fd7e14"
}, {
    "nosamw": "0403594",
    "nama": "Warus Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1064000,
    "total_denda": 100000,
    "total_jumlah": 1164000,
    "lat": 0.447706,
    "lng": 121.93845,
    "color": "#dc3545"
}, {
    "nosamw": "0401156",
    "nama": "Weda Polumulo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 2439000,
    "total_denda": 35000,
    "total_jumlah": 2474000,
    "lat": 0.453544,
    "lng": 121.938642,
    "color": "#dc3545"
}, {
    "nosamw": "0403567",
    "nama": "Werlinawati Usman",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.452161,
    "lng": 121.938911,
    "color": "#28a745"
}, {
    "nosamw": "0400180",
    "nama": "Wilson Daluta",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 643000,
    "total_denda": 40000,
    "total_jumlah": 683000,
    "lat": 0.449598,
    "lng": 121.940647,
    "color": "#dc3545"
}, {
    "nosamw": "0402870",
    "nama": "Win Abay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.451997,
    "lng": 121.938268,
    "color": "#ffc107"
}, {
    "nosamw": "0401321",
    "nama": "Wirna Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 1319500,
    "total_denda": 10000,
    "total_jumlah": 1329500,
    "lat": 0.449103,
    "lng": 121.943145,
    "color": "#fd7e14"
}, {
    "nosamw": "0402562",
    "nama": "Wisi Hasan",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 1340000,
    "total_denda": 50000,
    "total_jumlah": 1390000,
    "lat": 0.447256,
    "lng": 121.940832,
    "color": "#dc3545"
}, {
    "nosamw": "0406020",
    "nama": "WIWIN PAKAYA",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 2286500,
    "total_denda": 95000,
    "total_jumlah": 2381500,
    "lat": 0.4516038,
    "lng": 121.9377569,
    "color": "#dc3545"
}, {
    "nosamw": "0400248",
    "nama": "Yaman Apajulu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446875,
    "lng": 121.939577,
    "color": "#28a745"
}, {
    "nosamw": "0400091",
    "nama": "Yanis Samau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 648500,
    "total_denda": 25000,
    "total_jumlah": 673500,
    "lat": 0.447782,
    "lng": 121.941308,
    "color": "#fd7e14"
}, {
    "nosamw": "0401488",
    "nama": "Yanti Ismail",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446096,
    "lng": 121.939391,
    "color": "#28a745"
}, {
    "nosamw": "0401788",
    "nama": "Yanto Latif",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Cabut Meter",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448041,
    "lng": 121.941713,
    "color": "#28a745"
}, {
    "nosamw": "0400325",
    "nama": "Yasin Kadir",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 403000,
    "total_denda": 35000,
    "total_jumlah": 438000,
    "lat": 0.44991,
    "lng": 121.939857,
    "color": "#dc3545"
}, {
    "nosamw": "0400866",
    "nama": "Yepi Razak",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1816000,
    "total_denda": 80000,
    "total_jumlah": 1896000,
    "lat": 0.445277,
    "lng": 121.938502,
    "color": "#dc3545"
}, {
    "nosamw": "0402839",
    "nama": "Yeri Abdullah",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449521,
    "lng": 121.941316,
    "color": "#28a745"
}, {
    "nosamw": "0407538",
    "nama": "YETI ABDULLAH",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085246747318",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4465743,
    "lng": 121.9403727,
    "color": "#28a745"
}, {
    "nosamw": "0400158",
    "nama": "Yohana Sumakud",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 497000,
    "total_denda": 35000,
    "total_jumlah": 532000,
    "lat": 0.4461161,
    "lng": 121.9380339,
    "color": "#dc3545"
}, {
    "nosamw": "0400043",
    "nama": "Yoli Moto",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 567500,
    "total_denda": 20000,
    "total_jumlah": 587500,
    "lat": 0.44834,
    "lng": 121.94007,
    "color": "#fd7e14"
}, {
    "nosamw": "0401267",
    "nama": "Yoni Baunaka Antukai",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1900500,
    "total_denda": 80000,
    "total_jumlah": 1980500,
    "lat": 0.448471,
    "lng": 121.941543,
    "color": "#dc3545"
}, {
    "nosamw": "0402190",
    "nama": "Yopi Bau",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 298000,
    "total_denda": 20000,
    "total_jumlah": 318000,
    "lat": 0.449212,
    "lng": 121.940013,
    "color": "#fd7e14"
}, {
    "nosamw": "0404687",
    "nama": "Yordan Lopuo",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 212000,
    "total_denda": 30000,
    "total_jumlah": 242000,
    "lat": 0.445266,
    "lng": 121.938774,
    "color": "#fd7e14"
}, {
    "nosamw": "0402611",
    "nama": "Yuliana Thalib",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 66000,
    "total_denda": 10000,
    "total_jumlah": 76000,
    "lat": 0.449982,
    "lng": 121.939968,
    "color": "#ffc107"
}, {
    "nosamw": "0401005",
    "nama": "Yulin Polutu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.448816,
    "lng": 121.94289,
    "color": "#ffc107"
}, {
    "nosamw": "0400281",
    "nama": "Yunus Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447626,
    "lng": 121.939348,
    "color": "#28a745"
}, {
    "nosamw": "0403532",
    "nama": "Yusni Daniel",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 393500,
    "total_denda": 30000,
    "total_jumlah": 423500,
    "lat": 0.445857,
    "lng": 121.938349,
    "color": "#fd7e14"
}, {
    "nosamw": "0400541",
    "nama": "Yusri Dama",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 314000,
    "total_denda": 25000,
    "total_jumlah": 339000,
    "lat": 0.448355,
    "lng": 121.938765,
    "color": "#fd7e14"
}, {
    "nosamw": "0402115",
    "nama": "Yusuf Jasin",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 120000,
    "total_denda": 15000,
    "total_jumlah": 135000,
    "lat": 0.447961,
    "lng": 121.941716,
    "color": "#fd7e14"
}, {
    "nosamw": "0402181",
    "nama": "Yusuf Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2128500,
    "total_denda": 70000,
    "total_jumlah": 2198500,
    "lat": 0.449786,
    "lng": 121.938386,
    "color": "#dc3545"
}, {
    "nosamw": "0400121",
    "nama": "Yusuf Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446731,
    "lng": 121.939244,
    "color": "#28a745"
}, {
    "nosamw": "0402123",
    "nama": "Yusuf Mohamad",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449242,
    "lng": 121.941399,
    "color": "#28a745"
}, {
    "nosamw": "0401714",
    "nama": "Yusuf Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 5000,
    "total_jumlah": 38000,
    "lat": 0.446048,
    "lng": 121.939516,
    "color": "#ffc107"
}, {
    "nosamw": "0400250",
    "nama": "Yusuf Samsu",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.448134,
    "lng": 121.940648,
    "color": "#28a745"
}, {
    "nosamw": "0402182",
    "nama": "Yusuf Tamalangi",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 3577400,
    "total_denda": 160000,
    "total_jumlah": 3737400,
    "lat": 0.449891,
    "lng": 121.937951,
    "color": "#dc3545"
}, {
    "nosamw": "0402781",
    "nama": "Yuyun Ibura",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449539,
    "lng": 121.940916,
    "color": "#28a745"
}, {
    "nosamw": "0401492",
    "nama": "Yuyun Naki",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 867500,
    "total_denda": 70000,
    "total_jumlah": 937500,
    "lat": 0.448251,
    "lng": 121.942023,
    "color": "#dc3545"
}, {
    "nosamw": "0400390",
    "nama": "Zabir Saini",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449688,
    "lng": 121.940938,
    "color": "#28a745"
}, {
    "nosamw": "0402591",
    "nama": "Zaenab Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO",
    "desa": "POHUWATO",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 608000,
    "total_denda": 95000,
    "total_jumlah": 703000,
    "lat": 0.451434,
    "lng": 121.937508,
    "color": "#dc3545"
}, {
    "nosamw": "0403272",
    "nama": "ABD QODIR DJAELANI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4564925,
    "lng": 121.9371693,
    "color": "#ffc107"
}, {
    "nosamw": "0407241",
    "nama": "ABDUL MANAN BY SANDI S. USMAN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1936500,
    "total_denda": 65000,
    "total_jumlah": 2001500,
    "lat": 0.4535333,
    "lng": 121.9569533,
    "color": "#dc3545"
}, {
    "nosamw": "0406027",
    "nama": "ABDULLAH MUSA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 175000,
    "total_denda": 20000,
    "total_jumlah": 195000,
    "lat": 0.477652,
    "lng": 121.949556,
    "color": "#fd7e14"
}, {
    "nosamw": "0407452",
    "nama": "AGUS NENTO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082196758728",
    "total_bulan": 6,
    "total_tagihan": 2560000,
    "total_denda": 25000,
    "total_jumlah": 2585000,
    "lat": 0.4517217,
    "lng": 121.955565,
    "color": "#fd7e14"
}, {
    "nosamw": "0404969",
    "nama": "AHMAD KUE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 962400,
    "total_denda": 90000,
    "total_jumlah": 1052400,
    "lat": 0.4502354,
    "lng": 121.941962,
    "color": "#dc3545"
}, {
    "nosamw": "0405872",
    "nama": "AHMAD LASIMPALA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3707500,
    "total_denda": 40000,
    "total_jumlah": 3747500,
    "lat": 0.4562441,
    "lng": 121.9565724,
    "color": "#dc3545"
}, {
    "nosamw": "0403463",
    "nama": "AISA AKUBA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 210000,
    "total_denda": 30000,
    "total_jumlah": 240000,
    "lat": 0.4506315,
    "lng": 121.9424592,
    "color": "#fd7e14"
}, {
    "nosamw": "0406933",
    "nama": "ALAN ADAM ( KAFE OMA 2 )",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 10000,
    "total_jumlah": 120000,
    "lat": 0.450532,
    "lng": 121.9512814,
    "color": "#ffc107"
}, {
    "nosamw": "0404419",
    "nama": "Albert D. Wenzen",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 172500,
    "total_denda": 0,
    "total_jumlah": 172500,
    "lat": 0.4505838,
    "lng": 121.9394355,
    "color": "#ffc107"
}, {
    "nosamw": "0406028",
    "nama": "ALIA IDJI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4496779,
    "lng": 121.9440001,
    "color": "#ffc107"
}, {
    "nosamw": "0404871",
    "nama": "AMINA MOHA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.449527,
    "lng": 121.9401969,
    "color": "#ffc107"
}, {
    "nosamw": "0402145",
    "nama": "Amir Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1994000,
    "total_denda": 65000,
    "total_jumlah": 2059000,
    "lat": 0.449567,
    "lng": 121.941936,
    "color": "#dc3545"
}, {
    "nosamw": "0407465",
    "nama": "ANDREW BENHARD  RATTU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081244529696",
    "total_bulan": 3,
    "total_tagihan": 282000,
    "total_denda": 15000,
    "total_jumlah": 297000,
    "lat": 0.4508669,
    "lng": 121.9516392,
    "color": "#fd7e14"
}, {
    "nosamw": "0407273",
    "nama": "ANTONI BUHARI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 466500,
    "total_denda": 10000,
    "total_jumlah": 476500,
    "lat": 0.4498996,
    "lng": 121.9492415,
    "color": "#ffc107"
}, {
    "nosamw": "0407438",
    "nama": "ARDIYANSA LASARUDIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085392125243",
    "total_bulan": 4,
    "total_tagihan": 1172500,
    "total_denda": 15000,
    "total_jumlah": 1187500,
    "lat": 0.4542587,
    "lng": 121.9569302,
    "color": "#fd7e14"
}, {
    "nosamw": "0406030",
    "nama": "ARMAN WAMETO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1674000,
    "total_denda": 60000,
    "total_jumlah": 1734000,
    "lat": 0.4488764,
    "lng": 121.9450587,
    "color": "#dc3545"
}, {
    "nosamw": "0402070",
    "nama": "Arsad Hunowu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449684,
    "lng": 121.940718,
    "color": "#28a745"
}, {
    "nosamw": "0406165",
    "nama": "ASEP S",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4525324,
    "lng": 121.9489108,
    "color": "#28a745"
}, {
    "nosamw": "0407445",
    "nama": "ASNA S. POTALE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082360124046",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4500887,
    "lng": 121.9497404,
    "color": "#28a745"
}, {
    "nosamw": "0402561",
    "nama": "Asni Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 3884500,
    "total_denda": 140000,
    "total_jumlah": 4024500,
    "lat": 0.449851,
    "lng": 121.940826,
    "color": "#dc3545"
}, {
    "nosamw": "0405274",
    "nama": "ASRAMA HIDAYATULLAH",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4546453,
    "lng": 121.9386874,
    "color": "#28a745"
}, {
    "nosamw": "0404688",
    "nama": "Asura Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 595200,
    "total_denda": 80000,
    "total_jumlah": 675200,
    "lat": 0.44653,
    "lng": 121.940523,
    "color": "#dc3545"
}, {
    "nosamw": "0404865",
    "nama": "ATIN WALAHE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 162000,
    "total_denda": 5000,
    "total_jumlah": 167000,
    "lat": 0.4490921,
    "lng": 121.9417879,
    "color": "#ffc107"
}, {
    "nosamw": "0404475",
    "nama": "Barudin Samade",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 8113000,
    "total_denda": 85000,
    "total_jumlah": 8198000,
    "lat": 0.455776,
    "lng": 121.95645,
    "color": "#dc3545"
}, {
    "nosamw": "0404718",
    "nama": "Bebi Sahi",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.452262,
    "lng": 121.95748,
    "color": "#28a745"
}, {
    "nosamw": "0402856",
    "nama": "Beng Lasantu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4489676,
    "lng": 121.9408542,
    "color": "#ffc107"
}, {
    "nosamw": "0402169",
    "nama": "Bine Kidam",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 2777500,
    "total_denda": 35000,
    "total_jumlah": 2812500,
    "lat": 0.454961,
    "lng": 121.938345,
    "color": "#dc3545"
}, {
    "nosamw": "0407564",
    "nama": "BUDIARNI MOKODOMPIT",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085240765088",
    "total_bulan": 1,
    "total_tagihan": 81000,
    "total_denda": 0,
    "total_jumlah": 81000,
    "lat": 0.4481768,
    "lng": 121.9396893,
    "color": "#ffc107"
}, {
    "nosamw": "0406052",
    "nama": "DEBBY IDJI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1003000,
    "total_denda": 40000,
    "total_jumlah": 1043000,
    "lat": 0.4496995,
    "lng": 121.9434909,
    "color": "#dc3545"
}, {
    "nosamw": "0404575",
    "nama": "Deka Tantu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 169500,
    "total_denda": 5000,
    "total_jumlah": 174500,
    "lat": 0.449794,
    "lng": 121.940506,
    "color": "#ffc107"
}, {
    "nosamw": "0402472",
    "nama": "Delpan Yanjo",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.446796,
    "lng": 121.93926,
    "color": "#28a745"
}, {
    "nosamw": "0405458",
    "nama": "DERSI AKIM",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 2810000,
    "total_denda": 85000,
    "total_jumlah": 2895000,
    "lat": 0.4517883,
    "lng": 121.9559567,
    "color": "#dc3545"
}, {
    "nosamw": "0403287",
    "nama": "DIMAN POLUTU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 552000,
    "total_denda": 10000,
    "total_jumlah": 562000,
    "lat": 0.4495117,
    "lng": 121.9413475,
    "color": "#fd7e14"
}, {
    "nosamw": "0407428",
    "nama": "DJAFAR KUKE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "082271080664",
    "total_bulan": 1,
    "total_tagihan": 113000,
    "total_denda": 0,
    "total_jumlah": 113000,
    "lat": 0.4497446,
    "lng": 121.945223,
    "color": "#ffc107"
}, {
    "nosamw": "0406031",
    "nama": "Dodi Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.4495316,
    "lng": 121.9436707,
    "color": "#ffc107"
}, {
    "nosamw": "0405082",
    "nama": "Dumais Hais Doda",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 29,
    "total_tagihan": 1740000,
    "total_denda": 145000,
    "total_jumlah": 1885000,
    "lat": 0.4506034,
    "lng": 121.9512117,
    "color": "#dc3545"
}, {
    "nosamw": "0407504",
    "nama": "ELAN POLUTU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085298441092",
    "total_bulan": 1,
    "total_tagihan": 142500,
    "total_denda": 0,
    "total_jumlah": 142500,
    "lat": 0.4491057,
    "lng": 121.9464015,
    "color": "#ffc107"
}, {
    "nosamw": "0404348",
    "nama": "Elisabet D. Losso",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 107000,
    "total_denda": 0,
    "total_jumlah": 107000,
    "lat": 0.454589,
    "lng": 121.956119,
    "color": "#ffc107"
}, {
    "nosamw": "0407552",
    "nama": "ELISABETH D. LOSSO 3",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082217462697",
    "total_bulan": 1,
    "total_tagihan": 225000,
    "total_denda": 0,
    "total_jumlah": 225000,
    "lat": 0.4574797,
    "lng": 121.9587529,
    "color": "#ffc107"
}, {
    "nosamw": "0400604",
    "nama": "ELVIANTI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 3163500,
    "total_denda": 35000,
    "total_jumlah": 3198500,
    "lat": 0.456044,
    "lng": 121.9485553,
    "color": "#dc3545"
}, {
    "nosamw": "0406034",
    "nama": "Elvin Katili",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 995000,
    "total_denda": 85000,
    "total_jumlah": 1080000,
    "lat": 0.4498783,
    "lng": 121.941015,
    "color": "#dc3545"
}, {
    "nosamw": "0404220",
    "nama": "Empi Tuna",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 488400,
    "total_denda": 50000,
    "total_jumlah": 538400,
    "lat": 0.45013,
    "lng": 121.941831,
    "color": "#dc3545"
}, {
    "nosamw": "0404857",
    "nama": "ERLIAN TUMBEL",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 1045000,
    "total_denda": 60000,
    "total_jumlah": 1105000,
    "lat": 0.4495872,
    "lng": 121.9400543,
    "color": "#dc3545"
}, {
    "nosamw": "0402548",
    "nama": "Farida Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1478600,
    "total_denda": 85000,
    "total_jumlah": 1563600,
    "lat": 0.447895,
    "lng": 121.941583,
    "color": "#dc3545"
}, {
    "nosamw": "0402592",
    "nama": "Fatma Pakaya",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 2394000,
    "total_denda": 60000,
    "total_jumlah": 2454000,
    "lat": 0.4505408,
    "lng": 121.9512791,
    "color": "#dc3545"
}, {
    "nosamw": "0404167",
    "nama": "FATMA TAHIR",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4497729,
    "lng": 121.9489268,
    "color": "#28a745"
}, {
    "nosamw": "0405089",
    "nama": "Ferawati Panai",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4491451,
    "lng": 121.9454553,
    "color": "#28a745"
}, {
    "nosamw": "0402331",
    "nama": "GUSTIRANDA LAMUSU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 20,
    "total_tagihan": 1400050,
    "total_denda": 95000,
    "total_jumlah": 1495050,
    "lat": 0.4513102,
    "lng": 121.9418879,
    "color": "#dc3545"
}, {
    "nosamw": "0406565",
    "nama": "H18 APIYA LAKORO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 5000,
    "total_jumlah": 60000,
    "lat": 0.4475633,
    "lng": 121.9398009,
    "color": "#ffc107"
}, {
    "nosamw": "0406575",
    "nama": "H18 HARUN MOIGO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 122000,
    "total_denda": 5000,
    "total_jumlah": 127000,
    "lat": 0.4575448,
    "lng": 121.9512391,
    "color": "#ffc107"
}, {
    "nosamw": "0406561",
    "nama": "H18 JHONI MOMUAT",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4493633,
    "lng": 121.93959,
    "color": "#ffc107"
}, {
    "nosamw": "0406562",
    "nama": "H18 MARLIN SAMAKO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 538000,
    "total_denda": 25000,
    "total_jumlah": 563000,
    "lat": 0.4491404,
    "lng": 121.9464265,
    "color": "#fd7e14"
}, {
    "nosamw": "0406568",
    "nama": "H18 MAS 'UD SAMAKO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4497349,
    "lng": 121.9434894,
    "color": "#ffc107"
}, {
    "nosamw": "0406569",
    "nama": "H18 MELKI HUSAIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 561500,
    "total_denda": 45000,
    "total_jumlah": 606500,
    "lat": 0.449496,
    "lng": 121.945609,
    "color": "#dc3545"
}, {
    "nosamw": "0406573",
    "nama": "H18 TITIN AHMAD",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4511615,
    "lng": 121.9423836,
    "color": "#ffc107"
}, {
    "nosamw": "0406560",
    "nama": "H18 TUNE DJAFAR",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 465000,
    "total_denda": 45000,
    "total_jumlah": 510000,
    "lat": 0.4873767,
    "lng": 121.93526,
    "color": "#dc3545"
}, {
    "nosamw": "0406958",
    "nama": "H19 FADLUN MAHMUD",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 950500,
    "total_denda": 65000,
    "total_jumlah": 1015500,
    "lat": 0.452531,
    "lng": 121.9393026,
    "color": "#dc3545"
}, {
    "nosamw": "0406955",
    "nama": "H19 ISHAK KIU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 772500,
    "total_denda": 30000,
    "total_jumlah": 802500,
    "lat": 0.4478989,
    "lng": 121.9408767,
    "color": "#dc3545"
}, {
    "nosamw": "0406982",
    "nama": "H19 MARYAM MORIDU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 830000,
    "total_denda": 70000,
    "total_jumlah": 900000,
    "lat": 0.4502965,
    "lng": 121.9408749,
    "color": "#dc3545"
}, {
    "nosamw": "0406950",
    "nama": "H19 MUSTAFA HUNOWU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1296500,
    "total_denda": 100000,
    "total_jumlah": 1396500,
    "lat": 0.451228,
    "lng": 121.9418535,
    "color": "#dc3545"
}, {
    "nosamw": "0406974",
    "nama": "H19 RATNA RADJAK",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 584000,
    "total_denda": 35000,
    "total_jumlah": 619000,
    "lat": 0.4524989,
    "lng": 121.9392246,
    "color": "#dc3545"
}, {
    "nosamw": "0406977",
    "nama": "H19 SAHRIR",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 191000,
    "total_denda": 10000,
    "total_jumlah": 201000,
    "lat": 0.4530613,
    "lng": 121.9387284,
    "color": "#fd7e14"
}, {
    "nosamw": "0406975",
    "nama": "H19 SAUBIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 972400,
    "total_denda": 100000,
    "total_jumlah": 1072400,
    "lat": 0.4502933,
    "lng": 121.941384,
    "color": "#dc3545"
}, {
    "nosamw": "0406957",
    "nama": "H19 UMAR TANGAHU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 10,
    "total_tagihan": 633000,
    "total_denda": 45000,
    "total_jumlah": 678000,
    "lat": 0.4494982,
    "lng": 121.9409913,
    "color": "#dc3545"
}, {
    "nosamw": "0406986",
    "nama": "H19 UYUN MONOARFA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 944000,
    "total_denda": 40000,
    "total_jumlah": 984000,
    "lat": 0.4543579,
    "lng": 121.9373056,
    "color": "#dc3545"
}, {
    "nosamw": "0403574",
    "nama": "Hadija Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 54000,
    "total_denda": 10000,
    "total_jumlah": 64000,
    "lat": 0.456612,
    "lng": 121.945476,
    "color": "#ffc107"
}, {
    "nosamw": "0401944",
    "nama": "Hamid Tuna",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4485216,
    "lng": 121.941495,
    "color": "#ffc107"
}, {
    "nosamw": "0402166",
    "nama": "Hardi Ali",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.447053,
    "lng": 121.940805,
    "color": "#28a745"
}, {
    "nosamw": "0402745",
    "nama": "Hartono Rahman",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45269,
    "lng": 121.957324,
    "color": "#28a745"
}, {
    "nosamw": "0404574",
    "nama": "Hasim N. Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 872000,
    "total_denda": 0,
    "total_jumlah": 872000,
    "lat": 0.45015,
    "lng": 121.940658,
    "color": "#ffc107"
}, {
    "nosamw": "0405005",
    "nama": "HASNA BUMULO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 820500,
    "total_denda": 70000,
    "total_jumlah": 890500,
    "lat": 0.4486629,
    "lng": 121.9415914,
    "color": "#dc3545"
}, {
    "nosamw": "0407509",
    "nama": "HELMI, SE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082293982693",
    "total_bulan": 1,
    "total_tagihan": 74500,
    "total_denda": 0,
    "total_jumlah": 74500,
    "lat": 0.4515167,
    "lng": 121.95434,
    "color": "#ffc107"
}, {
    "nosamw": "0402027",
    "nama": "HERMAN NOHO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 3727500,
    "total_denda": 15000,
    "total_jumlah": 3742500,
    "lat": 0.456044,
    "lng": 121.9485553,
    "color": "#ffc107"
}, {
    "nosamw": "0406036",
    "nama": "Hesti Biki",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 705000,
    "total_denda": 40000,
    "total_jumlah": 745000,
    "lat": 0.4481564,
    "lng": 121.9385017,
    "color": "#dc3545"
}, {
    "nosamw": "0406358",
    "nama": "INGKA MOPUTI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 647500,
    "total_denda": 10000,
    "total_jumlah": 657500,
    "lat": 0.4515426,
    "lng": 121.9479516,
    "color": "#fd7e14"
}, {
    "nosamw": "0404169",
    "nama": "Irfan Gani",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 643400,
    "total_denda": 35000,
    "total_jumlah": 678400,
    "lat": 0.45006,
    "lng": 121.941519,
    "color": "#dc3545"
}, {
    "nosamw": "0407266",
    "nama": "IRFAN MOPUTI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 526500,
    "total_denda": 15000,
    "total_jumlah": 541500,
    "lat": 0.4495705,
    "lng": 121.9420561,
    "color": "#fd7e14"
}, {
    "nosamw": "0400149",
    "nama": "Iron Rahim",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4498927,
    "lng": 121.9492832,
    "color": "#28a745"
}, {
    "nosamw": "0404863",
    "nama": "ISHAK HUSAIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4484833,
    "lng": 121.9418437,
    "color": "#ffc107"
}, {
    "nosamw": "0404245",
    "nama": "Ismail Pasisingi",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 986400,
    "total_denda": 100000,
    "total_jumlah": 1086400,
    "lat": 0.450147,
    "lng": 121.941702,
    "color": "#dc3545"
}, {
    "nosamw": "0407559",
    "nama": "JEANE MIRANTI MUSTAFA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082291490171",
    "total_bulan": 1,
    "total_tagihan": 262500,
    "total_denda": 0,
    "total_jumlah": 262500,
    "lat": 0.4539061,
    "lng": 121.9567155,
    "color": "#ffc107"
}, {
    "nosamw": "0407556",
    "nama": "JESIKA TAROREH",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356900144",
    "total_bulan": 2,
    "total_tagihan": 142500,
    "total_denda": 5000,
    "total_jumlah": 147500,
    "lat": 0.4492428,
    "lng": 121.9467068,
    "color": "#ffc107"
}, {
    "nosamw": "0404216",
    "nama": "Jois ilonu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 763800,
    "total_denda": 65000,
    "total_jumlah": 828800,
    "lat": 0.450169,
    "lng": 121.941311,
    "color": "#dc3545"
}, {
    "nosamw": "0402105",
    "nama": "Jon Katelu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.453653,
    "lng": 121.937942,
    "color": "#ffc107"
}, {
    "nosamw": "0402128",
    "nama": "Karlin Rahim S.Ag",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 634000,
    "total_denda": 10000,
    "total_jumlah": 644000,
    "lat": 0.455069,
    "lng": 121.938204,
    "color": "#fd7e14"
}, {
    "nosamw": "0404723",
    "nama": "KSM Pohuwato \/ Mahmud Pag",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "HU",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 266600,
    "total_denda": 35000,
    "total_jumlah": 301600,
    "lat": 0.456041,
    "lng": 121.938362,
    "color": "#dc3545"
}, {
    "nosamw": "0404781",
    "nama": "KTR BP4K MARISA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 102500,
    "total_denda": 0,
    "total_jumlah": 102500,
    "lat": 0.4580835,
    "lng": 121.9418003,
    "color": "#ffc107"
}, {
    "nosamw": "0407262",
    "nama": "KTR. BASARNAS POHUWATO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 3512500,
    "total_denda": 20000,
    "total_jumlah": 3532500,
    "lat": 0.4556097,
    "lng": 121.9480297,
    "color": "#fd7e14"
}, {
    "nosamw": "0402462",
    "nama": "Ktr. Desa Pohuwato Timur",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 294000,
    "total_denda": 45000,
    "total_jumlah": 339000,
    "lat": 0.449664,
    "lng": 121.940176,
    "color": "#fd7e14"
}, {
    "nosamw": "0404868",
    "nama": "LATIF HULOPI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 94000,
    "total_denda": 5000,
    "total_jumlah": 99000,
    "lat": 0.4502039,
    "lng": 121.940365,
    "color": "#ffc107"
}, {
    "nosamw": "0407529",
    "nama": "LEKSI HUSAIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082195057102",
    "total_bulan": 5,
    "total_tagihan": 815000,
    "total_denda": 20000,
    "total_jumlah": 835000,
    "lat": 0.4536633,
    "lng": 121.9568183,
    "color": "#fd7e14"
}, {
    "nosamw": "0402851",
    "nama": "Lena Akuba",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1059500,
    "total_denda": 115000,
    "total_jumlah": 1174500,
    "lat": 0.450035,
    "lng": 121.94173,
    "color": "#dc3545"
}, {
    "nosamw": "0406037",
    "nama": "LENA PASANDRE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 2336000,
    "total_denda": 110000,
    "total_jumlah": 2446000,
    "lat": 0.4495356,
    "lng": 121.9437796,
    "color": "#dc3545"
}, {
    "nosamw": "0406056",
    "nama": "LENA PASANDRE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 4276500,
    "total_denda": 130000,
    "total_jumlah": 4406500,
    "lat": 0.4496624,
    "lng": 121.9439943,
    "color": "#dc3545"
}, {
    "nosamw": "0404854",
    "nama": "LIAN SAMAU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 41400,
    "total_denda": 0,
    "total_jumlah": 41400,
    "lat": 0.4484567,
    "lng": 121.9415817,
    "color": "#ffc107"
}, {
    "nosamw": "0406038",
    "nama": "LIAN SAMAU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 171500,
    "total_denda": 10000,
    "total_jumlah": 181500,
    "lat": 0.4495261,
    "lng": 121.9410112,
    "color": "#fd7e14"
}, {
    "nosamw": "0401535",
    "nama": "Mahmud Pagga\/Panti Asuhan",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "YS",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 65000,
    "total_denda": 5000,
    "total_jumlah": 70000,
    "lat": 0.455226,
    "lng": 121.938305,
    "color": "#ffc107"
}, {
    "nosamw": "0404869",
    "nama": "MASITO HASAN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4502074,
    "lng": 121.9404065,
    "color": "#ffc107"
}, {
    "nosamw": "0404864",
    "nama": "MELO HUSAIN",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4489365,
    "lng": 121.9419795,
    "color": "#28a745"
}, {
    "nosamw": "0405866",
    "nama": "MESJID HIDAYATULLAH MARISA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4548886,
    "lng": 121.9389241,
    "color": "#28a745"
}, {
    "nosamw": "0407002",
    "nama": "Mesjid Nurul Iman",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 126600,
    "total_denda": 15000,
    "total_jumlah": 141600,
    "lat": 0.449495,
    "lng": 121.9413783,
    "color": "#fd7e14"
}, {
    "nosamw": "0407252",
    "nama": "MESJID SUJUD",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "TI",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 4565500,
    "total_denda": 150000,
    "total_jumlah": 4715500,
    "lat": 0.4509304,
    "lng": 121.9526132,
    "color": "#dc3545"
}, {
    "nosamw": "0400394",
    "nama": "Moh.Hamdi Pontoh",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 1139500,
    "total_denda": 50000,
    "total_jumlah": 1189500,
    "lat": 0.4510872,
    "lng": 121.9424171,
    "color": "#dc3545"
}, {
    "nosamw": "0401210",
    "nama": "Moni Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.447656,
    "lng": 121.941073,
    "color": "#fd7e14"
}, {
    "nosamw": "0407261",
    "nama": "MULYATY",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 32,
    "total_tagihan": 2917500,
    "total_denda": 160000,
    "total_jumlah": 3077500,
    "lat": 0.4654916,
    "lng": 121.947237,
    "color": "#dc3545"
}, {
    "nosamw": "0404970",
    "nama": "MUSTIKAWATI MUSA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 227200,
    "total_denda": 20000,
    "total_jumlah": 247200,
    "lat": 0.4502968,
    "lng": 121.9418967,
    "color": "#fd7e14"
}, {
    "nosamw": "0404861",
    "nama": "MUTAR MBUINGA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 465000,
    "total_denda": 10000,
    "total_jumlah": 475000,
    "lat": 0.4514917,
    "lng": 121.9545633,
    "color": "#fd7e14"
}, {
    "nosamw": "0400379",
    "nama": "Nei Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 835600,
    "total_denda": 125000,
    "total_jumlah": 960600,
    "lat": 0.449199,
    "lng": 121.940682,
    "color": "#dc3545"
}, {
    "nosamw": "0404576",
    "nama": "Niyo Lasiama",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 691000,
    "total_denda": 60000,
    "total_jumlah": 751000,
    "lat": 0.449915,
    "lng": 121.940801,
    "color": "#dc3545"
}, {
    "nosamw": "0405153",
    "nama": "NON ABUBAKAR",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 781000,
    "total_denda": 45000,
    "total_jumlah": 826000,
    "lat": 0.4498288,
    "lng": 121.9491217,
    "color": "#dc3545"
}, {
    "nosamw": "0402558",
    "nama": "Nona Pasandre",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449271,
    "lng": 121.943297,
    "color": "#28a745"
}, {
    "nosamw": "0404973",
    "nama": "NONI ANUNTE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 565000,
    "total_denda": 70000,
    "total_jumlah": 635000,
    "lat": 0.4508111,
    "lng": 121.9417003,
    "color": "#dc3545"
}, {
    "nosamw": "0402393",
    "nama": "Nurain Khalid",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 301500,
    "total_denda": 15000,
    "total_jumlah": 316500,
    "lat": 0.449378,
    "lng": 121.940188,
    "color": "#fd7e14"
}, {
    "nosamw": "0402001",
    "nama": "NURAIN SAIDI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 253750,
    "total_denda": 5000,
    "total_jumlah": 258750,
    "lat": 0.4573135,
    "lng": 121.9453556,
    "color": "#ffc107"
}, {
    "nosamw": "0402337",
    "nama": "Nurdin Karim",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 334000,
    "total_denda": 10000,
    "total_jumlah": 344000,
    "lat": 0.450023,
    "lng": 121.940866,
    "color": "#fd7e14"
}, {
    "nosamw": "0401702",
    "nama": "Nurmasita Condra",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451702,
    "lng": 121.956244,
    "color": "#28a745"
}, {
    "nosamw": "0404968",
    "nama": "ODI ALIMO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 25,
    "total_tagihan": 844000,
    "total_denda": 120000,
    "total_jumlah": 964000,
    "lat": 0.4501902,
    "lng": 121.9420435,
    "color": "#dc3545"
}, {
    "nosamw": "0404977",
    "nama": "OMAN AKUBA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 648700,
    "total_denda": 20000,
    "total_jumlah": 668700,
    "lat": 0.4503172,
    "lng": 121.941576,
    "color": "#dc3545"
}, {
    "nosamw": "0406042",
    "nama": "OMI AKUBA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1395700,
    "total_denda": 30000,
    "total_jumlah": 1425700,
    "lat": 0.4497485,
    "lng": 121.9435106,
    "color": "#dc3545"
}, {
    "nosamw": "0400371",
    "nama": "Pos Jaga Wabub",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 257500,
    "total_denda": 0,
    "total_jumlah": 257500,
    "lat": 0.4572013,
    "lng": 121.9451182,
    "color": "#ffc107"
}, {
    "nosamw": "0406059",
    "nama": "RAMAN ANUNTE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1191000,
    "total_denda": 65000,
    "total_jumlah": 1256000,
    "lat": 0.4493476,
    "lng": 121.9435519,
    "color": "#dc3545"
}, {
    "nosamw": "0402275",
    "nama": "Raman Lahay",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.449076,
    "lng": 121.943045,
    "color": "#28a745"
}, {
    "nosamw": "0404851",
    "nama": "RAMANG PODUNGGE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61500,
    "total_denda": 0,
    "total_jumlah": 61500,
    "lat": 0.4481633,
    "lng": 121.9419183,
    "color": "#ffc107"
}, {
    "nosamw": "0401386",
    "nama": "Rapia Hionu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 113500,
    "total_denda": 0,
    "total_jumlah": 113500,
    "lat": 0.449568,
    "lng": 121.941867,
    "color": "#ffc107"
}, {
    "nosamw": "0404243",
    "nama": "Rapika Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 396000,
    "total_denda": 50000,
    "total_jumlah": 446000,
    "lat": 0.449761,
    "lng": 121.940394,
    "color": "#dc3545"
}, {
    "nosamw": "0404972",
    "nama": "RATNA AHMAD",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 2235500,
    "total_denda": 110000,
    "total_jumlah": 2345500,
    "lat": 0.449666,
    "lng": 121.941923,
    "color": "#dc3545"
}, {
    "nosamw": "0405953",
    "nama": "RD. KODIM NO. 10",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 1881500,
    "total_denda": 165000,
    "total_jumlah": 2046500,
    "lat": 0.4558117,
    "lng": 121.9498267,
    "color": "#dc3545"
}, {
    "nosamw": "0405604",
    "nama": "RD. KODIM NO. 7",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 36,
    "total_tagihan": 2160500,
    "total_denda": 180000,
    "total_jumlah": 2340500,
    "lat": 0.455459,
    "lng": 121.9505616,
    "color": "#dc3545"
}, {
    "nosamw": "0405605",
    "nama": "RD. KODIM NO. 8",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 36,
    "total_tagihan": 2017500,
    "total_denda": 175000,
    "total_jumlah": 2192500,
    "lat": 0.4554203,
    "lng": 121.9502622,
    "color": "#dc3545"
}, {
    "nosamw": "0405607",
    "nama": "RD. KODIM NO. 9",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 2050500,
    "total_denda": 145000,
    "total_jumlah": 2195500,
    "lat": 0.455397,
    "lng": 121.9502052,
    "color": "#dc3545"
}, {
    "nosamw": "0407443",
    "nama": "REGITHA MAKARAMA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081356968170",
    "total_bulan": 10,
    "total_tagihan": 2788000,
    "total_denda": 45000,
    "total_jumlah": 2833000,
    "lat": 0.4527865,
    "lng": 121.9479269,
    "color": "#dc3545"
}, {
    "nosamw": "0405282",
    "nama": "REIDEL NADING",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 582500,
    "total_denda": 5000,
    "total_jumlah": 587500,
    "lat": 0.4567493,
    "lng": 121.9494872,
    "color": "#ffc107"
}, {
    "nosamw": "0403029",
    "nama": "RENI ABAY",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 214750,
    "total_denda": 25000,
    "total_jumlah": 239750,
    "lat": 0.4507488,
    "lng": 121.9421659,
    "color": "#fd7e14"
}, {
    "nosamw": "0404995",
    "nama": "RINTO IDJI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 1986500,
    "total_denda": 85000,
    "total_jumlah": 2071500,
    "lat": 0.4495161,
    "lng": 121.9437796,
    "color": "#dc3545"
}, {
    "nosamw": "0401236",
    "nama": "Rmh.  Adat  Pohuwato",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 5380000,
    "total_denda": 150000,
    "total_jumlah": 5530000,
    "lat": 0.455674,
    "lng": 121.947226,
    "color": "#dc3545"
}, {
    "nosamw": "0407430",
    "nama": "RONALD IDRUS",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "085242303873",
    "total_bulan": 22,
    "total_tagihan": 5763000,
    "total_denda": 105000,
    "total_jumlah": 5868000,
    "lat": 0.4601091,
    "lng": 121.9604554,
    "color": "#dc3545"
}, {
    "nosamw": "0401982",
    "nama": "Rusman Daluta",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 17,
    "total_tagihan": 4211000,
    "total_denda": 85000,
    "total_jumlah": 4296000,
    "lat": 0.4509032,
    "lng": 121.9514894,
    "color": "#dc3545"
}, {
    "nosamw": "0400722",
    "nama": "Saiful Bau",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 610000,
    "total_denda": 50000,
    "total_jumlah": 660000,
    "lat": 0.4494246,
    "lng": 121.940784,
    "color": "#dc3545"
}, {
    "nosamw": "0404248",
    "nama": "Saleh Ahmad",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 304200,
    "total_denda": 35000,
    "total_jumlah": 339200,
    "lat": 0.449726,
    "lng": 121.940788,
    "color": "#dc3545"
}, {
    "nosamw": "0402541",
    "nama": "Saleh Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 1180300,
    "total_denda": 30000,
    "total_jumlah": 1210300,
    "lat": 0.448901,
    "lng": 121.943847,
    "color": "#dc3545"
}, {
    "nosamw": "0406046",
    "nama": "SALMA ADAM",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 506500,
    "total_denda": 40000,
    "total_jumlah": 546500,
    "lat": 0.4493233,
    "lng": 121.944,
    "color": "#dc3545"
}, {
    "nosamw": "0407258",
    "nama": "SALMA MUJARAHA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 68000,
    "total_denda": 5000,
    "total_jumlah": 73000,
    "lat": 0.4495616,
    "lng": 121.9415738,
    "color": "#ffc107"
}, {
    "nosamw": "0403864",
    "nama": "Sander Dahlan",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 363000,
    "total_denda": 10000,
    "total_jumlah": 373000,
    "lat": 0.456435,
    "lng": 121.956733,
    "color": "#ffc107"
}, {
    "nosamw": "0404999",
    "nama": "SARIPPA TAIKI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 18,
    "total_tagihan": 1333000,
    "total_denda": 90000,
    "total_jumlah": 1423000,
    "lat": 0.4495402,
    "lng": 121.943497,
    "color": "#dc3545"
}, {
    "nosamw": "0405659",
    "nama": "SARTIKA TANI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 244500,
    "total_denda": 20000,
    "total_jumlah": 264500,
    "lat": 0.4507112,
    "lng": 121.9424176,
    "color": "#fd7e14"
}, {
    "nosamw": "0404939",
    "nama": "SATIMA LOPUO",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 891500,
    "total_denda": 75000,
    "total_jumlah": 966500,
    "lat": 0.4477749,
    "lng": 121.9409424,
    "color": "#dc3545"
}, {
    "nosamw": "0403560",
    "nama": "Seha Alhasni",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 722500,
    "total_denda": 80000,
    "total_jumlah": 802500,
    "lat": 0.452482,
    "lng": 121.95737,
    "color": "#fd7e14"
}, {
    "nosamw": "0403345",
    "nama": "SOLEMAN LONE 2",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 706500,
    "total_denda": 15000,
    "total_jumlah": 721500,
    "lat": 0.4545794,
    "lng": 121.9557392,
    "color": "#fd7e14"
}, {
    "nosamw": "0400249",
    "nama": "SRI FATMI SANOEBAR 3",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.451257,
    "lng": 121.9522609,
    "color": "#28a745"
}, {
    "nosamw": "0407305",
    "nama": "SRI FATMI SANOEBAR 4",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4511108,
    "lng": 121.9521693,
    "color": "#28a745"
}, {
    "nosamw": "0407573",
    "nama": "SUDEN PASANDRE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082291353696",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4671189,
    "lng": 121.9510673,
    "color": "#28a745"
}, {
    "nosamw": "0402087",
    "nama": "Suleman Moputi",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 562200,
    "total_denda": 75000,
    "total_jumlah": 637200,
    "lat": 0.454566,
    "lng": 121.955676,
    "color": "#dc3545"
}, {
    "nosamw": "0401444",
    "nama": "Suryance Mbuinga",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 467100,
    "total_denda": 35000,
    "total_jumlah": 502100,
    "lat": 0.449581,
    "lng": 121.939974,
    "color": "#dc3545"
}, {
    "nosamw": "0404866",
    "nama": "SUUD MUSA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 535400,
    "total_denda": 65000,
    "total_jumlah": 600400,
    "lat": 0.450508,
    "lng": 121.9408014,
    "color": "#dc3545"
}, {
    "nosamw": "0400697",
    "nama": "Tahir Dama",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.4497096,
    "lng": 121.9403902,
    "color": "#ffc107"
}, {
    "nosamw": "0402167",
    "nama": "Tahir Tuna",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 1215000,
    "total_denda": 110000,
    "total_jumlah": 1325000,
    "lat": 0.450126,
    "lng": 121.942099,
    "color": "#dc3545"
}, {
    "nosamw": "0406050",
    "nama": "TAUFIK IDJI",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 1229500,
    "total_denda": 40000,
    "total_jumlah": 1269500,
    "lat": 0.4496497,
    "lng": 121.9433233,
    "color": "#dc3545"
}, {
    "nosamw": "0406060",
    "nama": "TINI LATIF",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 23,
    "total_tagihan": 1043600,
    "total_denda": 110000,
    "total_jumlah": 1153600,
    "lat": 0.4493383,
    "lng": 121.9439298,
    "color": "#dc3545"
}, {
    "nosamw": "0404285",
    "nama": "Tomi Bouty",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4482063,
    "lng": 121.9411717,
    "color": "#ffc107"
}, {
    "nosamw": "0402808",
    "nama": "Ucun Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 27,
    "total_tagihan": 896000,
    "total_denda": 135000,
    "total_jumlah": 1031000,
    "lat": 0.449876,
    "lng": 121.941487,
    "color": "#dc3545"
}, {
    "nosamw": "0404230",
    "nama": "UDIN SUNGE",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4517733,
    "lng": 121.95592,
    "color": "#28a745"
}, {
    "nosamw": "0404944",
    "nama": "ULIN MUTIARA",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 2510500,
    "total_denda": 70000,
    "total_jumlah": 2580500,
    "lat": 0.4487293,
    "lng": 121.9452149,
    "color": "#dc3545"
}, {
    "nosamw": "0404140",
    "nama": "USAID Alwin Abdullah",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 15,
    "total_tagihan": 786000,
    "total_denda": 75000,
    "total_jumlah": 861000,
    "lat": 0.450176,
    "lng": 121.941889,
    "color": "#dc3545"
}, {
    "nosamw": "0404158",
    "nama": "USAID Ambo Kamang",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 21,
    "total_tagihan": 1299500,
    "total_denda": 100000,
    "total_jumlah": 1399500,
    "lat": 0.450041,
    "lng": 121.941426,
    "color": "#dc3545"
}, {
    "nosamw": "0404091",
    "nama": "USAID Deli Musa",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 22,
    "total_tagihan": 798200,
    "total_denda": 105000,
    "total_jumlah": 903200,
    "lat": 0.44978,
    "lng": 121.941462,
    "color": "#dc3545"
}, {
    "nosamw": "0404157",
    "nama": "USAID Heyan Akuba",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.450155,
    "lng": 121.94152,
    "color": "#28a745"
}, {
    "nosamw": "0404122",
    "nama": "USAID Moh. Pasisingi",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 46,
    "total_tagihan": 1613250,
    "total_denda": 225000,
    "total_jumlah": 1838250,
    "lat": 0.449415,
    "lng": 121.94181,
    "color": "#dc3545"
}, {
    "nosamw": "0404119",
    "nama": "USAID Mudi Akuba",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.450079,
    "lng": 121.941851,
    "color": "#28a745"
}, {
    "nosamw": "0404156",
    "nama": "USAID Nou Tuna",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 138200,
    "total_denda": 10000,
    "total_jumlah": 148200,
    "lat": 0.450192,
    "lng": 121.941469,
    "color": "#fd7e14"
}, {
    "nosamw": "0404155",
    "nama": "USAID Obi idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 268000,
    "total_denda": 25000,
    "total_jumlah": 293000,
    "lat": 0.449986,
    "lng": 121.941471,
    "color": "#fd7e14"
}, {
    "nosamw": "0404120",
    "nama": "USAID Salma Anunte",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.45009,
    "lng": 121.941674,
    "color": "#28a745"
}, {
    "nosamw": "0404159",
    "nama": "USAID Udin Lasantu",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 16,
    "total_tagihan": 1127900,
    "total_denda": 80000,
    "total_jumlah": 1207900,
    "lat": 0.450053,
    "lng": 121.941505,
    "color": "#dc3545"
}, {
    "nosamw": "0404130",
    "nama": "USAID Umar Idji",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 33000,
    "total_denda": 0,
    "total_jumlah": 33000,
    "lat": 0.449851,
    "lng": 121.942016,
    "color": "#ffc107"
}, {
    "nosamw": "0407277",
    "nama": "Usman Poha 2",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 714000,
    "total_denda": 55000,
    "total_jumlah": 769000,
    "lat": 0.4498898,
    "lng": 121.9492685,
    "color": "#dc3545"
}, {
    "nosamw": "0405092",
    "nama": "Wiwin Harun",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4499672,
    "lng": 121.9493869,
    "color": "#28a745"
}, {
    "nosamw": "0407489",
    "nama": "YOLANDA WATI SIANU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "081342405898",
    "total_bulan": 1,
    "total_tagihan": 247500,
    "total_denda": 0,
    "total_jumlah": 247500,
    "lat": 0.4492955,
    "lng": 121.9456125,
    "color": "#ffc107"
}, {
    "nosamw": "0403691",
    "nama": "Yolly Motto II",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 85000,
    "total_denda": 5000,
    "total_jumlah": 90000,
    "lat": 0.451985,
    "lng": 121.957021,
    "color": "#ffc107"
}, {
    "nosamw": "0405001",
    "nama": "YOYO KALUKU",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4494463,
    "lng": 121.9434287,
    "color": "#28a745"
}, {
    "nosamw": "0400354",
    "nama": "Yusuf A. Muda",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 30,
    "total_tagihan": 2107000,
    "total_denda": 150000,
    "total_jumlah": 2257000,
    "lat": 0.449246,
    "lng": 121.939953,
    "color": "#dc3545"
}, {
    "nosamw": "0402780",
    "nama": "Yusuf Latif",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 33,
    "total_tagihan": 5174000,
    "total_denda": 165000,
    "total_jumlah": 5339000,
    "lat": 0.449135,
    "lng": 121.943433,
    "color": "#dc3545"
}, {
    "nosamw": "0403796",
    "nama": "YUYUN NAKI 2",
    "kecamatan": "KEC MARISA DESA POHUWATO TIMUR",
    "desa": "POHUWATO TIMUR",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 347000,
    "total_denda": 10000,
    "total_jumlah": 357000,
    "lat": 0.4580693,
    "lng": 121.9446446,
    "color": "#fd7e14"
}, {
    "nosamw": "0407402",
    "nama": " ASWIN USMAN, S.Pd",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082293227176",
    "total_bulan": 2,
    "total_tagihan": 181500,
    "total_denda": 5000,
    "total_jumlah": 186500,
    "lat": 0.4735867,
    "lng": 121.949077,
    "color": "#ffc107"
}, {
    "nosamw": "0403260",
    "nama": "Abd. R. Sakiran",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477869,
    "lng": 121.952985,
    "color": "#28a745"
}, {
    "nosamw": "0401395",
    "nama": "Abd. Wahid Hasan",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 952500,
    "total_denda": 0,
    "total_jumlah": 952500,
    "lat": 0.475061,
    "lng": 121.955193,
    "color": "#ffc107"
}, {
    "nosamw": "0400659",
    "nama": "ABDUL MASKUR SALEH .2",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 1031500,
    "total_denda": 25000,
    "total_jumlah": 1056500,
    "lat": 0.4705608,
    "lng": 121.947033,
    "color": "#fd7e14"
}, {
    "nosamw": "0403544",
    "nama": "Abdulah Husain",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47595,
    "lng": 121.954975,
    "color": "#28a745"
}, {
    "nosamw": "0404793",
    "nama": "ABDULLAH M. BAHALULU",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 179500,
    "total_denda": 20000,
    "total_jumlah": 199500,
    "lat": 0.4804507,
    "lng": 121.9542059,
    "color": "#fd7e14"
}, {
    "nosamw": "0400910",
    "nama": "Abdullah Mile",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468042,
    "lng": 121.94999,
    "color": "#28a745"
}, {
    "nosamw": "0403172",
    "nama": "Abdullah Musa",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 302600,
    "total_denda": 45000,
    "total_jumlah": 347600,
    "lat": 0.477652,
    "lng": 121.949556,
    "color": "#dc3545"
}, {
    "nosamw": "0400893",
    "nama": "Abubakar Mahabu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 1126000,
    "total_denda": 70000,
    "total_jumlah": 1196000,
    "lat": 0.466905,
    "lng": 121.958991,
    "color": "#dc3545"
}, {
    "nosamw": "0405154",
    "nama": "ABUBAKAR T. HENTUMA",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 87500,
    "total_denda": 0,
    "total_jumlah": 87500,
    "lat": 0.4745225,
    "lng": 121.9549987,
    "color": "#ffc107"
}, {
    "nosamw": "0400148",
    "nama": "Adam Tangahu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467706,
    "lng": 121.955554,
    "color": "#28a745"
}, {
    "nosamw": "0401010",
    "nama": "Adrian Adam \/ RM. Alinda",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467103,
    "lng": 121.961594,
    "color": "#28a745"
}, {
    "nosamw": "0406064",
    "nama": "ADRIYUNAN SALEH",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4740586,
    "lng": 121.9547725,
    "color": "#ffc107"
}, {
    "nosamw": "0400833",
    "nama": "Agus Pramono",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 14,
    "total_tagihan": 2585000,
    "total_denda": 70000,
    "total_jumlah": 2655000,
    "lat": 0.473767,
    "lng": 121.947376,
    "color": "#dc3545"
}, {
    "nosamw": "0401095",
    "nama": "Agusnawi Palay",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 291500,
    "total_denda": 20000,
    "total_jumlah": 311500,
    "lat": 0.46896,
    "lng": 121.947592,
    "color": "#fd7e14"
}, {
    "nosamw": "0405031",
    "nama": "AHMAD LASIMPALA",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 622500,
    "total_denda": 25000,
    "total_jumlah": 647500,
    "lat": 0.4670615,
    "lng": 121.9608303,
    "color": "#fd7e14"
}, {
    "nosamw": "0403925",
    "nama": "Aisa Islaku",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469573,
    "lng": 121.948948,
    "color": "#28a745"
}, {
    "nosamw": "0404800",
    "nama": "AISA MUSA",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 19,
    "total_tagihan": 814000,
    "total_denda": 90000,
    "total_jumlah": 904000,
    "lat": 0.4623907,
    "lng": 121.9376176,
    "color": "#dc3545"
}, {
    "nosamw": "0403280",
    "nama": "Ajis Umuri",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.478203,
    "lng": 121.952904,
    "color": "#28a745"
}, {
    "nosamw": "0404387",
    "nama": "Alwin Ismail",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 38600,
    "total_denda": 0,
    "total_jumlah": 38600,
    "lat": 0.476104,
    "lng": 121.954954,
    "color": "#ffc107"
}, {
    "nosamw": "0401608",
    "nama": "Andris Miolo",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.478062,
    "lng": 121.95305,
    "color": "#28a745"
}, {
    "nosamw": "0406070",
    "nama": "ANIS MOIGO",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 616900,
    "total_denda": 35000,
    "total_jumlah": 651900,
    "lat": 0.4753936,
    "lng": 121.9552132,
    "color": "#dc3545"
}, {
    "nosamw": "0406067",
    "nama": "ARDIN HASAN",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 13,
    "total_tagihan": 753000,
    "total_denda": 60000,
    "total_jumlah": 813000,
    "lat": 0.4623907,
    "lng": 121.9376176,
    "color": "#dc3545"
}, {
    "nosamw": "0402946",
    "nama": "Arfan Inaku",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 568000,
    "total_denda": 20000,
    "total_jumlah": 588000,
    "lat": 0.474384,
    "lng": 121.955858,
    "color": "#fd7e14"
}, {
    "nosamw": "0405574",
    "nama": "ARIF",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4670855,
    "lng": 121.9619892,
    "color": "#ffc107"
}, {
    "nosamw": "0402246",
    "nama": "Arifin Balu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 185000,
    "total_denda": 5000,
    "total_jumlah": 190000,
    "lat": 0.47852,
    "lng": 121.948548,
    "color": "#ffc107"
}, {
    "nosamw": "0403165",
    "nama": "Ariyanto H. Diko",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475109,
    "lng": 121.962061,
    "color": "#28a745"
}, {
    "nosamw": "0401555",
    "nama": "Arlin Pakaya",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 539600,
    "total_denda": 30000,
    "total_jumlah": 569600,
    "lat": 0.473554,
    "lng": 121.945793,
    "color": "#fd7e14"
}, {
    "nosamw": "0404577",
    "nama": "Arman Hasan",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 8,
    "total_tagihan": 283600,
    "total_denda": 40000,
    "total_jumlah": 323600,
    "lat": 0.474663,
    "lng": 121.956475,
    "color": "#dc3545"
}, {
    "nosamw": "0404379",
    "nama": "Arman Israfil",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.479621,
    "lng": 121.954335,
    "color": "#ffc107"
}, {
    "nosamw": "0400512",
    "nama": "Armin Duawulu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.468239,
    "lng": 121.946853,
    "color": "#28a745"
}, {
    "nosamw": "0402952",
    "nama": "Armin Dunggio",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.47711,
    "lng": 121.953906,
    "color": "#28a745"
}, {
    "nosamw": "0402534",
    "nama": "Armin Nasibu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 604000,
    "total_denda": 60000,
    "total_jumlah": 664000,
    "lat": 0.467746,
    "lng": 121.947987,
    "color": "#dc3545"
}, {
    "nosamw": "0401515",
    "nama": "Arwan Lasimpala",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 155500,
    "total_denda": 5000,
    "total_jumlah": 160500,
    "lat": 0.4671026,
    "lng": 121.9608807,
    "color": "#ffc107"
}, {
    "nosamw": "0404806",
    "nama": "ARWIYA ALIWU",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4785759,
    "lng": 121.9538533,
    "color": "#ffc107"
}, {
    "nosamw": "0406105",
    "nama": "ASDIN DEYALA",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 99000,
    "total_denda": 10000,
    "total_jumlah": 109000,
    "lat": 0.467688,
    "lng": 121.9483906,
    "color": "#fd7e14"
}, {
    "nosamw": "0404656",
    "nama": "Asmin Samako",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 61000,
    "total_denda": 0,
    "total_jumlah": 61000,
    "lat": 0.468025,
    "lng": 121.948359,
    "color": "#ffc107"
}, {
    "nosamw": "0401547",
    "nama": "Asmin Y. Maku",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.4779,
    "lng": 121.94897,
    "color": "#28a745"
}, {
    "nosamw": "0406096",
    "nama": "Asni Rupu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 180000,
    "total_denda": 0,
    "total_jumlah": 180000,
    "lat": 0.4708431,
    "lng": 121.9563865,
    "color": "#ffc107"
}, {
    "nosamw": "0400832",
    "nama": "Aspol No. 13 \/ Very L",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 34,
    "total_tagihan": 11713000,
    "total_denda": 170000,
    "total_jumlah": 11883000,
    "lat": 0.469017,
    "lng": 121.95011,
    "color": "#dc3545"
}, {
    "nosamw": "0407337",
    "nama": "ASRAMA SLB",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082348727724",
    "total_bulan": 3,
    "total_tagihan": 455500,
    "total_denda": 10000,
    "total_jumlah": 465500,
    "lat": 0.4704002,
    "lng": 121.9525626,
    "color": "#fd7e14"
}, {
    "nosamw": "0404413",
    "nama": "Asri Masiga Yusuf",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 249500,
    "total_denda": 10000,
    "total_jumlah": 259500,
    "lat": 0.477658,
    "lng": 121.950668,
    "color": "#fd7e14"
}, {
    "nosamw": "0404578",
    "nama": "Aswin Abdullah",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 80000,
    "total_denda": 10000,
    "total_jumlah": 90000,
    "lat": 0.474188,
    "lng": 121.956598,
    "color": "#ffc107"
}, {
    "nosamw": "0401062",
    "nama": "Aten Rasid 2",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 7112500,
    "total_denda": 50000,
    "total_jumlah": 7162500,
    "lat": 0.468952,
    "lng": 121.961895,
    "color": "#dc3545"
}, {
    "nosamw": "0405007",
    "nama": "ATO HARAS",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 561000,
    "total_denda": 20000,
    "total_jumlah": 581000,
    "lat": 0.4777545,
    "lng": 121.9482087,
    "color": "#fd7e14"
}, {
    "nosamw": "0407532",
    "nama": "AULIA USMAN 2",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082296222622",
    "total_bulan": 8,
    "total_tagihan": 497000,
    "total_denda": 35000,
    "total_jumlah": 532000,
    "lat": 0.4698555,
    "lng": 121.9515864,
    "color": "#dc3545"
}, {
    "nosamw": "0404726",
    "nama": "Ayub A. Lie",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469716,
    "lng": 121.946735,
    "color": "#28a745"
}, {
    "nosamw": "0404580",
    "nama": "Ayuba Moigo",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 35000,
    "total_denda": 0,
    "total_jumlah": 35000,
    "lat": 0.475586,
    "lng": 121.95526,
    "color": "#ffc107"
}, {
    "nosamw": "0400593",
    "nama": "Barak (Aspol)",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 455000,
    "total_denda": 5000,
    "total_jumlah": 460000,
    "lat": 0.467895,
    "lng": 121.950249,
    "color": "#ffc107"
}, {
    "nosamw": "0401332",
    "nama": "Barak Bujang",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "HK",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 307500,
    "total_denda": 5000,
    "total_jumlah": 312500,
    "lat": 0.469148,
    "lng": 121.95038,
    "color": "#fd7e14"
}, {
    "nosamw": "0401586",
    "nama": "Bdn. Pertanahan ( Abd. Ka",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "IP",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 1157500,
    "total_denda": 0,
    "total_jumlah": 1157500,
    "lat": 0.467893,
    "lng": 121.952263,
    "color": "#ffc107"
}, {
    "nosamw": "0404476",
    "nama": "Bengkel SLB \/ Nikma B. Is",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.469354,
    "lng": 121.949023,
    "color": "#28a745"
}, {
    "nosamw": "0403004",
    "nama": "Beni Rupu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 119200,
    "total_denda": 10000,
    "total_jumlah": 129200,
    "lat": 0.46765,
    "lng": 121.9555,
    "color": "#ffc107"
}, {
    "nosamw": "0401056",
    "nama": "Beny Nento",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 220000,
    "total_denda": 15000,
    "total_jumlah": 235000,
    "lat": 0.474138,
    "lng": 121.947057,
    "color": "#fd7e14"
}, {
    "nosamw": "0401904",
    "nama": "Buraira",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 3,
    "total_tagihan": 165000,
    "total_denda": 10000,
    "total_jumlah": 175000,
    "lat": 0.479738,
    "lng": 121.945525,
    "color": "#fd7e14"
}, {
    "nosamw": "0403193",
    "nama": "Burhan Saleh",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 12,
    "total_tagihan": 480000,
    "total_denda": 60000,
    "total_jumlah": 540000,
    "lat": 0.477721,
    "lng": 121.953887,
    "color": "#dc3545"
}, {
    "nosamw": "0404934",
    "nama": "CANDRA ANULI",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 411500,
    "total_denda": 20000,
    "total_jumlah": 431500,
    "lat": 0.4785981,
    "lng": 121.9488688,
    "color": "#fd7e14"
}, {
    "nosamw": "0400205",
    "nama": "Danial Herman",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 129500,
    "total_denda": 5000,
    "total_jumlah": 134500,
    "lat": 0.467899,
    "lng": 121.946824,
    "color": "#ffc107"
}, {
    "nosamw": "0403008",
    "nama": "Darwis Hasan",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.477483,
    "lng": 121.951251,
    "color": "#28a745"
}, {
    "nosamw": "0402792",
    "nama": "Dasmin Rupu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467624,
    "lng": 121.955448,
    "color": "#28a745"
}, {
    "nosamw": "0402724",
    "nama": "Daud Hionu",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 89000,
    "total_denda": 0,
    "total_jumlah": 89000,
    "lat": 0.467384,
    "lng": 121.955312,
    "color": "#ffc107"
}, {
    "nosamw": "0407280",
    "nama": "David Mole",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 561000,
    "total_denda": 20000,
    "total_jumlah": 581000,
    "lat": 0.4705597,
    "lng": 121.9561839,
    "color": "#fd7e14"
}, {
    "nosamw": "0403013",
    "nama": "Delly Mulyani A. Pakaya",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.467706,
    "lng": 121.955554,
    "color": "#28a745"
}, {
    "nosamw": "0403197",
    "nama": "Didin Tontowa",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 620500,
    "total_denda": 35000,
    "total_jumlah": 655500,
    "lat": 0.477781,
    "lng": 121.950766,
    "color": "#dc3545"
}, {
    "nosamw": "0400901",
    "nama": "Djafar Harun",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 247500,
    "total_denda": 0,
    "total_jumlah": 247500,
    "lat": 0.466681,
    "lng": 121.95855,
    "color": "#ffc107"
}, {
    "nosamw": "0403524",
    "nama": "Djuanti Diange",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 888000,
    "total_denda": 25000,
    "total_jumlah": 913000,
    "lat": 0.479762,
    "lng": 121.954027,
    "color": "#fd7e14"
}, {
    "nosamw": "0402132",
    "nama": "Don Umuri",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.475609,
    "lng": 121.954986,
    "color": "#28a745"
}, {
    "nosamw": "0401068",
    "nama": "Dr. Berny Mamitoho",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 4,
    "total_tagihan": 226500,
    "total_denda": 15000,
    "total_jumlah": 241500,
    "lat": 0.466931,
    "lng": 121.947816,
    "color": "#fd7e14"
}, {
    "nosamw": "0404486",
    "nama": "Dra. Fardan Karim",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 7,
    "total_tagihan": 522500,
    "total_denda": 35000,
    "total_jumlah": 557500,
    "lat": 0.477981,
    "lng": 121.94851,
    "color": "#dc3545"
}, {
    "nosamw": "0401883",
    "nama": "Drs. Umar Pakaja",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 1795000,
    "total_denda": 10000,
    "total_jumlah": 1805000,
    "lat": 0.47375,
    "lng": 121.944925,
    "color": "#ffc107"
}, {
    "nosamw": "0402660",
    "nama": "EKA PUTRA MANTULANGI",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4826605,
    "lng": 121.9552773,
    "color": "#ffc107"
}, {
    "nosamw": "0401047",
    "nama": "Eman Dj. Towadi",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 127500,
    "total_denda": 0,
    "total_jumlah": 127500,
    "lat": 0.476054,
    "lng": 121.954348,
    "color": "#ffc107"
}, {
    "nosamw": "0401022",
    "nama": "Eman Mohi",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 11,
    "total_tagihan": 4390000,
    "total_denda": 55000,
    "total_jumlah": 4445000,
    "lat": 0.470761,
    "lng": 121.957964,
    "color": "#dc3545"
}, {
    "nosamw": "0402727",
    "nama": "Eman Thalib",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 9,
    "total_tagihan": 708000,
    "total_denda": 40000,
    "total_jumlah": 748000,
    "lat": 0.4678681,
    "lng": 121.9556721,
    "color": "#dc3545"
}, {
    "nosamw": "0402430",
    "nama": "Empi Diange S.Ag",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 0,
    "total_tagihan": 0,
    "total_denda": 0,
    "total_jumlah": 0,
    "lat": 0.476634,
    "lng": 121.947538,
    "color": "#28a745"
}, {
    "nosamw": "0401556",
    "nama": "Erni Sidiki",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "R1",
    "nomorhp": "",
    "total_bulan": 6,
    "total_tagihan": 198000,
    "total_denda": 30000,
    "total_jumlah": 228000,
    "lat": 0.469398,
    "lng": 121.947407,
    "color": "#fd7e14"
}, {
    "nosamw": "0405494",
    "nama": "EWIN LASIMPALA",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "",
    "total_bulan": 1,
    "total_tagihan": 55000,
    "total_denda": 0,
    "total_jumlah": 55000,
    "lat": 0.4742107,
    "lng": 121.9549326,
    "color": "#ffc107"
}, {
    "nosamw": "0407427",
    "nama": "External Affairs ( PT Mentari Alam Persada)",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "NB",
    "nomorhp": "085756633197",
    "total_bulan": 1,
    "total_tagihan": 105000,
    "total_denda": 0,
    "total_jumlah": 105000,
    "lat": 0.4765917,
    "lng": 121.9661282,
    "color": "#ffc107"
}, {
    "nosamw": "0402347",
    "nama": "Fadli Alhasni",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Segel",
    "klasifikasi": "NK",
    "nomorhp": "",
    "total_bulan": 2,
    "total_tagihan": 946250,
    "total_denda": 30000,
    "total_jumlah": 976250,
    "lat": 0.466689,
    "lng": 121.947637,
    "color": "#ffc107"
}, {
    "nosamw": "0407520",
    "nama": "FAJRINDA DAHLAN S.AP",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R3",
    "nomorhp": "082194690504",
    "total_bulan": 2,
    "total_tagihan": 110000,
    "total_denda": 5000,
    "total_jumlah": 115000,
    "lat": 0.4708105,
    "lng": 121.952044,
    "color": "#ffc107"
}, {
    "nosamw": "0401032",
    "nama": "FATMA HARUN",
    "kecamatan": "KEC MARISA DESA TERATAI",
    "desa": "TERATAI",
    "status": "Aktif",
    "klasifikasi": "R2",
    "nomorhp": "",
    "total_bulan": 5,
    "total_tagihan": 496000,
    "total_denda": 20000,
    "total_jumlah": 516000,
    "lat": 0.4685257,
    "lng": 121.9620161,
    "color": "#fd7e14"
}]